import cloudWord from "@assets/images/cloud_word.png";
import cloudExcel from "@assets/images/cloud_excel.png";
import cloudPPT from "@assets/images/cloud_ppt.png";
import cloudZip from "@assets/images/cloud_zip.png";
import cloudText from "@assets/images/cloud_text.png";
import cloudPDF from "@assets/images/cloud_pdf.png";
import cloudCAD from "@assets/images/cloud_cad.png";
import cloudSKP from "@assets/images/cloud_skp.svg";
import cloudImage from "@assets/images/cloud_image.png";
import cloudAudio from "@assets/images/cloud_audio.png";
import cloudVideo from "@assets/images/cloud_video.png";
import cloudUnknow from "@assets/images/cloud_unknow.png";
import cloudDmax from "@assets/images/cloud_3dmax.png";
import cloudRevit from "@assets/images/cloud_revit.png";
import cloudAi from "@assets/images/cloud_ai.png";


export const ART_MATERIAL_STATUS = {
  1: "未发布",
  2: " 审核中",
  3: "已驳回",
  4: "已上架",
  5: "已下架",
};

export const ART_MATERIAL_VALUE = {
  '基础信息': "#header",
  '概述': '#desc',
  '特性': '#features',
  '经验': '#experience',
  '规格': '#sizes',
  '检验证书': '#certificate',
  '使用场景': '#usage_scenarios',
  '搭配建议': '#collocation',
  '节点': '#node',
  '包装信息': '#package_info',
  '配件': '#parts'
};


export const MATERIAL_SERVICE = {
  1: "代施工",
  2: "代加工",
  3: "代安装",
  5: "代深化设计",
  4: "其他"
};

export const MATERIAL_CLIENTTYPE = {
  1: "普通客户",
  2: "供应商",
  3: "官方",
};

export const MATERIAL_SUPPLUY_CYCLE = {
  7: '一周内',
  30: '一个月内',
  90: '三个月内',
  180: '半年内',
  // 365: '一年内',
  // 366: '一年以上'
};

export const SPACE_ENUM = [
  // '不限',
  '室内',
  '室外',
  '灰空间',
  '地下室',
  '屋顶',
  '外墙',
  '庭院',
  '机场',
  '火车站',
  '购物中心/超市',
  '广场',
  '酒店',
  '博物馆/展览馆',
  '剧院/KTV',
  '写字楼',
  '学校',
  '医院',
  '餐厅',
  '住宅/别墅',
  '泳池',
  '操场',
]

export const PRODUCT_STATUS = {
  0: '草稿',
  1: '草稿',
  2: '发布审核中',
  3: '敏感词',
  4: '完整性',
  5: '驳回'
}

export const PRODUCT_ONSALE = {
  1: '未上架',
  2: '上架'
}

export const PRODUCT_BEST = {
  1: '未严选',
  2: '上架'
}

export const MATERIAL_STATUS = {
  1: "草稿",
  2: "审核中",
  3: "敏感审核",
  4: "完整性",
  5: "未过审"
}

export const ADMIN_MATERIAL_STATUS = {
  1: "草稿",
  2: "审核中",
  3: "敏感审核通过",
  4: "完整性审核通过",
  5: "敏感词审核未通过",
  6: "完整性审核未通过"
}
export const SALE_MATERIAL_STATUS = {
  1: "未上架",
  2: "已上架",
  3: "已驳回",
  4: "待审核",
}

export const MATERIAL_SALE_STATUS = {
  // "未上架",
  NOT_ON_SALE: 1,
  // 已上架
  ON_SALE: 2,
}
export const ANCHOR_NAV = [
  {
    anchor: 'cover',
    title: '主图'
  },
  {
    anchor: 'productParam',
    title: '产品参数'
  },
  {
    anchor: 'experience',
    title: '经验'
  },
  {
    anchor: 'Introduction',
    title: '产品介绍'
  },
  {
    anchor: 'relateWork',
    title: '相关作品'
  },
  {
    anchor: 'certificate',
    title: '检验证书'
  },
  {
    anchor: 'packageInfo',
    title: '包装信息'
  },
  {
    anchor: 'parts',
    title: '配件'
  }
]

export const PRODUCT_ALIAS = {
  MATERIAL: "材料",
  FACILITY: "设备",
  PRODUCT: "成品"
}

export const PRODUCT_FILTER_STATUS = {
  1: '草稿',
  2: '审核中',
  5: '未过审',
}

export const PRODUCT_LIST_NAME = {
  'MATERIAL': '材料库',
  'FACILITY': '设备库',
  'PRODUCT': '成品库'
}

export const PRODUCT_LIST_ICON = {
  'MATERIAL': 'icon-a-zu950',
  'FACILITY': 'icon-a-zu9491',
  'PRODUCT': 'icon-a-zu9481'
}

export const PRODUCT_LIST_ROUTE = {
  'MATERIAL': 'teamMaterial',
  'FACILITY': 'teamFacility',
  'PRODUCT': 'teamProduct'
}

export const PRODUCT_GROUP = [
  {
    title: '材料',
    icon: 'icon-daohangxiala-cailiao',
    type: 'MATERIAL'
  },
  {
    title: '成品',
    icon: 'icon-daohangxiala-chengpin',
    type: 'PRODUCT'
  },
  {
    title: '设备',
    icon: 'icon-daohangxiala-shebei',
    type: 'FACILITY'
  }
]

export const CONSTRACT_SUPPLY_STATUS = {
  1: '正常',
  10: '已终止'
}

export const TEAM_ROLE_PRODUCT = {
  'lobbyPage': '介绍页',
  'product': '产品库',
  'works': '作品库',
  'contractedSupplier': '团队供应商',
  'person': '合作',
  'materialBoard': '物料板',
  'cloud': '不觉云'
}

export const VISITOR_ROLE_PRODUCT = {
  'lobbyPage': '介绍页',
  'works': '作品库',
  'person': '合作',
  'product': "产品库"
}

export const CHECKBOX_LIST = {
  lobbyPage: {
    'view': '查看',
    'share': '分享',
  },
  contractedSupplier: {
    'view': '查看供应商',
    'VC_information': '查看联系方式',
    'VT_contract': '查看合同',
    // 'CT_attachment': '查看附件',
    'V_remarks': '查看备注',
    // 'D_productsQrCode': '导出产品二维码'
  },
  works: {
    'view': '查看',
    // 'VC_information': '查看客户信息',
    // 'VC_information': '隐藏客户信息',
    // 'CT_attachment': '查看作品文件',
    // 'D_attachment': '下载作品文件',
    'edit': '编辑',
    'share': '分享',
    'pic_download': '下载',
  },
  product: {
    'view': '查看',
    'share': '分享',
    'download': '下载',
    'D_productsQrCode': '导出产品二维码'
  },
  materialBoard: {
    'operate': '操作',
  },
  person: {
    'view': '查看',
    // 'share': '分享',
  },
  cloud: {
    'view': '查看',
    'view_sys': '隐藏系统文件夹',
    'manage': '管理',
    'download': '下载',
  },
}

export const VISITORBOX_LIST = {
  lobbyPage: {
    'view': '查看',
    'share': '分享',
  },
  works: {
    'view': '查看',
    'pic_download': '下载',
    'share': '分享',
  },
  person: {
    'view': '查看',
    // 'share': '分享',
  },
  product: {
    'view': '查看',
    'collect': '入库',
    'download': '下载',
    'price_visible': "价格显示"
  },
}

export const PRODUCT_LIST_SHOW = {
  'MATERIAL': 'material',
  'FACILITY': 'equipment',
  'PRODUCT': 'product',
  'PERSON': 'person'
}

export const TEAM_ROLE_LIST = [
  'lobbyPage',
  'product',
  'works',
  'contractedSupplier',
  'materialBoard',
  'person',
  'cloud'
];

export const VISITOR_ROLE_LIST = [
  'lobbyPage',
  'product',
  'works',
  'person',
];

export const TEAM_VIP_ROLE_LIST = [
  'lobbyPage',
  'product',
  'works',
  'materialBoard',
  'person',
];

export const def_avator = 'https://oss-panzi-app-test.panzitech.com/1741678886527_9243byte_400x400_panzi_1741678886387.jpg';

export const def_product = 'https://app-test.zjhzoyad.com/zip-9e50aae3-1b8a-4212-833d-a8ca2210c9efad1d4e10-0e46-43df-b519-9bc5b515e5bcdefault_bg.png';

export const def_vr = 'https://oss-panzi-app-test.panzitech.com/1701184123107_315744byte_5849_1679545147026_315744_works_bg.png';

export const def_works = 'https://oss-panzi-app-test.panzitech.com/1701184123107_315744byte_5849_1679545147026_315744_works_bg.png';

export const def_upload_error = 'https://oss-panzi-app-test.panzitech.com/zip-1711029327482_3916byte_395x232_组_2540__1_.png'

export const def_team_logo = "https://oss-panzi-app-test.panzitech.com/1741678967958_10555byte_400x400_panzi_1741678967774.jpg";

export const product_icon = {
  '材料': 'icon-daohangxiala-cailiao',
  '成品': 'icon-daohangxiala-chengpin',
  '设备': 'icon-daohangxiala-shebei',
}

export const user_product_icon = {
  '材料': 'icon-a-zu950',
  '成品': 'icon-a-zu9481',
  '设备': 'icon-a-zu9491',
}

export const hw_image_size_limite = 25000000;

export const SUPPLY_STATUS = {
  1: '未签约',
  2: '签约',
  3: '合作到期'
}

export const PriceUnits = [
  "件",
  "个",
  "台",
  "张",
  "片",
  "瓶",
  "箱",
  "盒",
  "捆",
  "包",
  "桶",
  "托",
  "卷",
  "米",
  "平方米",
  "升",
  "千克",
  "吨",
  "扇",
  "套"
];

export const works_type_Key = {
  'designTime': 1,
  'worksType': 2,
  'designStyle': 3,
}


export const protocol = { // 团队服务\隐私\用户\儿童\付费
  teamservice: "https://oss-panzi-app-test.panzitech.com/1740118200543_29873byte_0x0_不觉私域服务协议.docx",// 不觉团队服务协议
  privacy: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/zh-CN/BUJUE_隐私权保护政策_ZH.docx", // 不觉隐私政策
  user: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/zh-CN/BUJUE_用户协议_ZH.docx", // 不觉用户协议
  child: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/zh-CN/BUJUE_儿童个人信息保护规则_ZH.docx", //儿童
  price: 'https://oss-panzi-app-test.panzitech.com/1740118198511_25128byte_0x0_不觉付费协议.docx', //付费
  teamCertification: "https://oss-panzi-app-test.panzitech.com/1726736001427_16405byte_0x0_%E4%B8%8D%E8%A7%89%E7%A9%BA%E9%97%B4%E8%89%BA%E6%9C%AF%E9%A6%86%E4%B8%BB%E4%BD%93%E8%AE%A4%E8%AF%81%E9%A1%BB%E7%9F%A5.docx", // 不觉主体认证协议

}

export const protocolByLanguage = {
  zh: {
    teamservice: protocol.teamservice,
    privacy: protocol.privacy,
    user: protocol.user,
    child: protocol.child,
    price: protocol.price,
    teamCertification: protocol.teamCertification,
  },
  en: {
    teamservice: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Private_Domain_Service_Agreement_EN.docx",
    privacy: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Privacy_Policy_EN.docx",
    user: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Terms_of_Service_EN.docx",
    child: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Childrens_Personal_Information_Rules_EN.docx",
    price: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Paid_Services_Agreement_EN.docx",
    teamCertification: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Entity_Verification_Notice_EN.docx",
  },
  ja: {
    teamservice: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Private_Domain_Service_Agreement_JA.docx",
    privacy: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Privacy_Policy_JA.docx",
    user: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Terms_of_Service_JA.docx",
    child: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Childrens_Personal_Information_Rules_JA.docx",
    price: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Paid_Services_Agreement_JA.docx",
    teamCertification: "https://bujue-static-cdn.bujue.art/platform-privacy-policy/other-languages/BUJUE_Entity_Verification_Notice_JA.docx",
  },
};

const normalizeProtocolLanguage = (language) =>
  String(language || "zh").toLowerCase().split(/[-_,]/)[0] || "zh";

export const getProtocolUrl = (protocolKey, language) => {
  const languageCode = normalizeProtocolLanguage(language);
  const localizedProtocol = protocolByLanguage[languageCode];
  if (
    localizedProtocol &&
    Object.prototype.hasOwnProperty.call(localizedProtocol, protocolKey)
  ) {
    return localizedProtocol[protocolKey];
  }
  return protocol[protocolKey] || "";
};
export const teamRoute = [
  'team_home.html',
  'teamMember.html',
  'team_info.html',
  'team_security.html',
  'team_permiss.html',
  'team_language_settings.html',
  'team_con.html',
  'team_join_list.html',
  'team.html',
  'product_detail.html',
  'team_cloud.html',
  'create_product.html',
  'team_member.html',
  'team_private_member.html',
  'team_open.html',
  'share_manage.html',
  'team_certification.html',
  'product_classify.html',
  'team_brand.html',
  'team_supplier.html',
  'team_shop.html'
]

export const mouseCursorStyle = {
  disable: 'https://oss-panzi-app-test.panzitech.com/zip-1706746451603_598byte_30x30_disable.png',
  add: 'https://oss-panzi-app-test.panzitech.com/1706703710443_501byte_30x30_mouse_pointer.png',
  colResizeDark: 'https://oss-panzi-app-test.panzitech.com/1712027040472_347byte_23x23_%E7%BB%84_2711.png',
  colResizeLight: 'https://oss-panzi-app-test.panzitech.com/1712027009717_328byte_23x23_%E7%BB%84_2710.png',
}

export const hwObsConfigInfo = {
  'bucket_name': 'app-test',
  'domain_name': 'https://oss-panzi-app-test.panzitech.com',
  'end_point': 'https://obs.cn-east-2.myhuaweicloud.com',
}

export const aliOssConfigInfo = {
  // Region填写Bucket所在地域。以华东1（杭州）为例，yourRegion填写为oss-cn-hangzhou。
  'region': 'oss-cn-hangzhou',
  'bucket_name': 'panzi-app-test',
  'end_point': 'https://oss-panzi-app-test.panzitech.com',
  'videos_compression_end_point': 'https://oss-panzi-app-test.panzitech.com/videos/compression',
}

// Values are i18n keys; consumers must translate them at display time.
export const unsavedTip = {
  'tip_one': '更改未保存，确定离开？',
  'tip_two': '文件上传未完成，确定离开？',
  'tip_three': '文件上传未完成，稍后再试'
}

export const bujueDecryptKey = 'MATERIAL_WEB_KEY'

export const maxUploadLimit = 99999999

export const uploadImageWidthAndHeightLimit = {
  width: 15000,
  height: 15000
}

export const uploadTip = {
  'tip_one': '一次最多上传' + maxUploadLimit + '个文件',
  'tip_two': '尺寸超过限制（宽/高不超过15000像素）'
}

export const xdoc = 'https://view.xdocin.com/xdoc?_xdoc='

export const cloudDiskFileTypeIdentification = {
  'word': cloudWord,
  'excel': cloudExcel,
  'ppt': cloudPPT,
  'zip': cloudZip,
  'text': cloudText,
  'pdf': cloudPDF,
  'cad': cloudCAD,
  'skp': cloudSKP,
  'unknow': cloudUnknow,
  'image': cloudImage,
  'video': cloudVideo,
  'audio': cloudAudio,
  'dmax': cloudDmax,
  'revit': cloudRevit,
  'ai': cloudAi
}

export const defaultHostname = ['dev.panzitech.com', 'material-test.bujue.art', 'material-pre.bujue.art', 'bujue.art', 'www.bujue.art', 'temporary.bujue.art']
export const smallFileSize = 1048576
export const defTeamShopBg = [
  {
    "name": "6.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589087689_525033byte_2298x1380_6.png",
    "size": 525033
  },
  {
    "name": "1.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589087825_1480731byte_2298x1380_1.png",
    "size": 1480731
  },
  {
    "name": "3.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589087761_1215980byte_2298x1380_3.png",
    "size": 1215980
  },
  {
    "name": "2.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589087798_1357777byte_2298x1380_2.png",
    "size": 1357777
  },
  {
    "name": "4.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589087840_1167738byte_2298x1380_4.png",
    "size": 1167738
  },
  {
    "name": "5.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589087867_1646722byte_2298x1380_5.png",
    "size": 1646722
  },
  {
    "name": "8.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589088607_714173byte_2298x1380_8.png",
    "size": 714173
  },
  {
    "name": "7.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589088755_2216607byte_2298x1380_7.png",
    "size": 2216607
  },
  {
    "name": "11.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589088780_1041856byte_2298x1380_11.png",
    "size": 1041856
  },
  {
    "name": "13.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589088873_1272005byte_2298x1380_13.png",
    "size": 1272005
  },
  {
    "name": "10.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589088821_1351165byte_2298x1380_10.png",
    "size": 1351165
  },
  {
    "name": "9.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589088936_621017byte_2298x1380_9.png",
    "size": 621017
  },
  {
    "name": "17.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589089624_1182320byte_2298x1380_17.png",
    "size": 1182320
  },
  {
    "name": "12.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589089100_1720923byte_2298x1380_12.png",
    "size": 1720923
  },
  {
    "name": "20.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589090020_677476byte_2298x1380_20.png",
    "size": 677476
  },
  {
    "name": "16.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589089948_1389655byte_2298x1380_16.png",
    "size": 1389655
  },
  {
    "name": "19.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589090090_1311214byte_2298x1380_19.png",
    "size": 1311214
  },
  {
    "name": "18.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589090218_1028685byte_2298x1380_18.png",
    "size": 1028685
  },
  {
    "name": "14.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589090385_680230byte_2298x1380_14.png",
    "size": 680230
  },
  {
    "name": "15.png",
    "url": "https://oss-panzi-app-test.panzitech.com/1718589089557_721161byte_2298x1380_15.png",
    "size": 721161
  }
]
// 团队认证状态
export const team_certification_status = {
  SAVE: "保存",
  PASS: "审核通过",
  PENDING: "待审核",
  REJECT: "审核不通过"
}
// 存量团队认证失效时间
export const team_timeout = 1727712000000;
// 0访客 1成员 2管理员 3二级管理员
export const roleValueList = [0, 1, 2, 3];

export const ym_url = {
  test: 'material-test.bujue.art',
  pre: 'material-pre.bujue.art',
  prod: 'bujue.art',
  ls: 'temporary.bujue.art' // 临时域名
}

export const py_province = {
  "Beijing": "北京",
  "Tianjin": "天津",
  "Shanghai": "上海",
  "Chongqing": "重庆",
  "Hebei": "河北",
  "Shanxi": "山西",
  "Liaoning": "辽宁",
  "Jilin": "吉林",
  "Heilongjiang": "黑龙江",
  "Jiangsu": "江苏",
  "Zhejiang": "浙江",
  "Anhui": "安徽",
  "Fujian": "福建",
  "Jiangxi": "江西",
  "Shandong": "山东",
  "Henan": "河南",
  "Hubei": "湖北",
  "Hunan": "湖南",
  "Guangdong": "广东",
  "Guangxi": "广西",
  "Hainan": "海南",
  "Sichuan": "四川",
  "Guizhou": "贵州",
  "Yunnan": "云南",
  "Tibet": "西藏",
  "Shaanxi": "陕西",
  "Gansu": "甘肃",
  "Qinghai": "青海",
  "Ningxia": "宁夏",
  "Neimenggu": "内蒙古",
  "Neimeng": "内蒙",
  "Xinjiang": "新疆",
  "Taiwan": "台湾",
  "Hong Kong": "香港",
  "Macau": "澳门"
}

export const py_city = {
  "aba": "阿坝",
  "akesu": "阿克苏",
  "aletai": "阿勒泰",
  "ali": "阿里",
  "anqing": "安庆",
  "anshan": "鞍山",
  "anshun": "安顺",
  "anyang": "安阳",
  "aomen": "澳门",
  "baicheng": "白城",
  "baise": "百色",
  "baishan": "白山",
  "baiyin": "白银",
  "bangbu": "蚌埠",
  "baoding": "保定",
  "baoji": "宝鸡",
  "baoshan": "保山",
  "baotou": "包头",
  "bayannaoer": "巴彦淖尔",
  "bayinguoleng": "巴音郭楞",
  "beijing": "北京",
  "benxi": "本溪",
  "bijie": "毕节",
  "binzhou": "滨州",
  "boertala": "博尔塔拉",
  "bozhou": "亳州",
  "cangzhou": "沧州",
  "changchun": "长春",
  "changde": "常德",
  "changji": "昌吉",
  "changsha": "长沙",
  "changzhou": "常州",
  "chaohu": "巢湖",
  "chaoyang": "朝阳",
  "chaozhou": "潮州",
  "chengde": "承德",
  "chengdu": "成都",
  "chenzhou": "郴州",
  "chifeng": "赤峰",
  "chizhou": "池州",
  "chongqing": "重庆",
  "chongzuo": "崇左",
  "chuzhou": "滁州",
  "dali": "大理",
  "dalian": "大连",
  "dandong": "丹东",
  "daqing": "大庆",
  "datong": "大同",
  "daxinganling": "大兴安岭",
  "dazhou": "达州",
  "dehong": "德宏",
  "deyang": "德阳",
  "dezhou": "德州",
  "dingxi": "定西",
  "dongguan": "东莞",
  "dongying": "东营",
  "ezhou": "鄂州",
  "enshi": "恩施",
  "erdos": "鄂尔多斯",
  "foshan": "佛山",
  "fushun": "抚顺",
  "fuxin": "阜新",
  "fuyang": "阜阳",
  "fuzhou": "福州",
  "gannan": "甘南",
  "ganzhou": "赣州",
  "guangan": "广安",
  "guangyuan": "广元",
  "guangzhou": "广州",
  "guigang": "贵港",
  "guilin": "桂林",
  "guiyang": "贵阳",
  "guyuan": "固原",
  "haerbin": "哈尔滨",
  "haibei": "海北",
  "haidong": "海东",
  "haikou": "海口",
  "hainan": "海南",
  "haixi": "海西",
  "hami": "哈密",
  "handan": "邯郸",
  "hangzhou": "杭州",
  "hanzhong": "汉中",
  "hebi": "鹤壁",
  "hechi": "河池",
  "hefei": "合肥",
  "hegang": "鹤岗",
  "heihe": "黑河",
  "hengshui": "衡水",
  "hengyang": "衡阳",
  "hetian": "和田",
  "heyuan": "河源",
  "heze": "菏泽",
  "hezhou": "贺州",
  "honghe": "红河",
  "huaian": "淮安",
  "huaibei": "淮北",
  "huaihua": "怀化",
  "huainan": "淮南",
  "huanggang": "黄冈",
  "huangnan": "黄南",
  "huangshan": "黄山",
  "huangshi": "黄石",
  "huhehaote": "呼和浩特",
  "huizhou": "惠州",
  "hulunbeier": "呼伦贝尔",
  "huzhou": "湖州",
  "jiamusi": "佳木斯",
  "jian": "吉安",
  "jiangmen": "江门",
  "jiaozuo": "焦作",
  "jiaxing": "嘉兴",
  "jiayuguan": "嘉峪关",
  "jieyang": "揭阳",
  "jilin": "吉林",
  "jinan": "济南",
  "jinchang": "金昌",
  "jincheng": "晋城",
  "jingdezhen": "景德镇",
  "jingmen": "荆门",
  "jingzhou": "荆州",
  "jinhua": "金华",
  "jining": "济宁",
  "jinzhong": "晋中",
  "jinzhou": "锦州",
  "jiujiang": "九江",
  "jiuquan": "酒泉",
  "jixi": "鸡西",
  "kaifeng": "开封",
  "kashgar": "喀什",
  "kelamayi": "克拉玛依",
  "kezilesu": "克孜勒苏",
  "kunming": "昆明",
  "laibin": "来宾",
  "laiwu": "莱芜",
  "langfang": "廊坊",
  "lanzhou": "兰州",
  "lasa": "拉萨",
  "leshan": "乐山",
  "liangshan": "凉山",
  "lianyungang": "连云港",
  "liaocheng": "聊城",
  "liaoyang": "辽阳",
  "liaoyuan": "辽源",
  "lijiang": "丽江",
  "lincang": "临沧",
  "linfen": "临汾",
  "linxia": "临夏",
  "linyi": "临沂",
  "linzhi": "林芝",
  "lishui": "丽水",
  "liuzhou": "柳州",
  "longnan": "陇南",
  "longyan": "龙岩",
  "loudi": "娄底",
  "luohe": "漯河",
  "luoyang": "洛阳",
  "luzhou": "泸州",
  "lvliang": "吕梁",
  "maanshan": "马鞍山",
  "maoming": "茂名",
  "meishan": "眉山",
  "meizhou": "梅州",
  "mianyang": "绵阳",
  "mudanjiang": "牡丹江",
  "nanchang": "南昌",
  "nanchong": "南充",
  "nanjing": "南京",
  "nanning": "南宁",
  "nanping": "南平",
  "nanyang": "南阳",
  "naqu": "那曲",
  "neijiang": "内江",
  "ningbo": "宁波",
  "ningde": "宁德",
  "nujiang": "怒江",
  "panjin": "盘锦",
  "panzhihua": "攀枝花",
  "pingdingshan": "平顶山",
  "pingliang": "平凉",
  "pingxiang": "萍乡",
  "putian": "莆田",
  "puyang": "濮阳",
  "qiandongnan": "黔东南",
  "qiannan": "黔南",
  "qianxinan": "黔西南",
  "qingdao": "青岛",
  "qingyang": "庆阳",
  "qingyuan": "清远",
  "qinhuangdao": "秦皇岛",
  "qinzhou": "钦州",
  "qiqihaer": "齐齐哈尔",
  "qitaihe": "七台河",
  "quanzhou": "泉州",
  "qujing": "曲靖",
  "quzhou": "衢州",
  "rikaze": "日喀则",
  "rizhao": "日照",
  "sanmenxia": "三门峡",
  "sanming": "三明",
  "sanya": "三亚",
  "shangluo": "商洛",
  "shangqiu": "商丘",
  "shangrao": "上饶",
  "shanghai": "上海",
  "shannan": "山南",
  "shantou": "汕头",
  "shanwei": "汕尾",
  "shaoguan": "韶关",
  "shaoxing": "绍兴",
  "shaoyang": "邵阳",
  "shennongjia": "神农架",
  "shenyang": "沈阳",
  "shenzhen": "深圳",
  "shijiazhuang": "石家庄",
  "shiyan": "十堰",
  "shizuishan": "石嘴山",
  "shuangyashan": "双鸭山",
  "shuozhou": "朔州",
  "siping": "四平",
  "songyuan": "松原",
  "suihua": "绥化",
  "suining": "遂宁",
  "suizhou": "随州",
  "suqian": "宿迁",
  "suzhou": "苏州",
  "tacheng": "塔城",
  "taian": "泰安",
  "taiwan": "台湾",
  "taiyuan": "太原",
  "taizhou": "泰州",
  "tangshan": "唐山",
  "tianjin": "天津",
  "tianshui": "天水",
  "tieling": "铁岭",
  "tongchuan": "铜川",
  "tonghua": "通化",
  "tongliao": "通辽",
  "tongling": "铜陵",
  "tongrendiqu": "铜仁",
  "tulufan": "吐鲁番",
  "weifang": "潍坊",
  "weihai": "威海",
  "weinan": "渭南",
  "wenshan": "文山",
  "wenzhou": "温州",
  "wuhai": "乌海",
  "wuhan": "武汉",
  "wuhu": "芜湖",
  "wulanchabu": "乌兰察布",
  "wulumuqi": "乌鲁木齐",
  "wuwei": "武威",
  "wuxi": "无锡",
  "wuzhong": "吴忠",
  "wuzhou": "梧州",
  "xiamen": "厦门",
  "xian": "西安",
  "xianggang": "香港",
  "xiangtan": "湘潭",
  "xiangxi": "湘西",
  "xianning": "咸宁",
  "xianyang": "咸阳",
  "xiaogan": "孝感",
  "xilinguole": "锡林郭勒",
  "xingan": "兴安",
  "xingtai": "邢台",
  "xining": "西宁",
  "xinjiang": "新疆",
  "xinxiang": "新乡",
  "xinyang": "信阳",
  "xinyu": "新余",
  "xinzhou": "忻州",
  "xishuangbanna": "西双版纳",
  "xuancheng": "宣城",
  "xuchang": "许昌",
  "xuzhou": "徐州",
  "yaan": "雅安",
  "yanan": "延安",
  "yanbian": "延边",
  "yancheng": "盐城",
  "yangjiang": "阳江",
  "yangquan": "阳泉",
  "yangzhou": "扬州",
  "yantai": "烟台",
  "yibin": "宜宾",
  "yichang": "宜昌",
  "yichun": "宜春",
  "yilihasake": "伊犁哈萨克",
  "yinchuan": "银川",
  "yingkou": "营口",
  "yingtan": "鹰潭",
  "yiyang": "益阳",
  "yongzhou": "永州",
  "yueyang": "岳阳",
  "yulin": "玉林",
  "yulin1": "榆林",
  "yuncheng": "运城",
  "yunfu": "云浮",
  "yunlin": "云林",
  "yuxi": "玉溪",
  "zaozhuang": "枣庄",
  "zhangjiajie": "张家界",
  "zhangjiakou": "张家口",
  "zhangye": "张掖",
  "zhangzhou": "漳州",
  "zhanjiang": "湛江",
  "zhaoqing": "肇庆",
  "zhaotong": "昭通",
  "zhengzhou": "郑州",
  "zhenjiang": "镇江",
  "zhongshan": "中山",
  "zhongwei": "中卫",
  "zhoukou": "周口",
  "zhoushan": "舟山",
  "zhuhai": "珠海",
  "zhuzhou": "株洲",
  "zibo": "淄博",
  "zigong": "自贡",
  "ziyang": "资阳",
  "zunyi": "遵义",

}

// [2026-10-26] 设计中心下拉「项目管理工具」入口（盘八斗）：仅这些团队展示
export const PROJECT_TOOL_TEAM_IDS = [
  '6ab090f2320ac61f31ce6dc0', // 此乃线上新加坡团队 不要改
  '6a8e9db09221d0059797ee6a',
  '64462569a93c0227d2cdc5f0',
  '6a86cdbab39cd7239d174c8e' // 预发
];
export const PROJECT_TOOL_URL = 'http://team.panzitech.com/';

/** [2026-10-26] 当前团队是否在「项目管理工具 / 私域工作台」白名单内 */
export const isProjectToolTeam = (teamId) =>
  PROJECT_TOOL_TEAM_IDS.includes(String(teamId || ''));

export const PolyglotEnJson = {
  // User center dropdown and dialogs
  "最多只能关联 {{maxCount}} 张图片": "You can link up to {{maxCount}} images",
  "个人信息": "Personal information",
  "名片信息": "Business card details",
  "账号管理": "Account management",
  "个性签名": "Bio",
  "个性签名：": "Bio:",
  "添加个性签名..": "Add a personalized signature..",
  "当前账号暂无私域": "The current account does not have a space yet.",
  "请先创建私域，开启产品管理新体验": "Create a space first to unlock a new product management experience.",
  "我管理的私域": "Spaces I manage",
  "我加入的私域": "Spaces I've joined",
  "已停用": "Disabled",
  "删除私域": "Delete Space",
  "删除私域之后，私域在平台上的数据将被清除，且不可恢复。": "Once the Private Space is deleted, its data on the platform will be cleared and cannot be recovered.",
  "移交私域": "Transfer Space",
  "会员": "Member",
  "查看原因": "View reason",
  "第三方账号": "Third-party accounts",
  "微信": "WeChat",
  "解绑": "Unlink",
  "未绑定": "Not linked",
  "解绑成功": "Unlinked successfully",
  "确认要解除绑定吗？": "Are you sure you want to unlink?",
  "身份验证": "Identity verification",
  "验证": "Verify",
  "为了你的账户安全,请验证身份,验证成功后进行下一步操作.": "To keep your account secure, verify your identity. You can continue after verification.",
  "使用手机号": "Use phone number",
  "使用邮箱": "Use email",
  "请输入验证码": "Enter verification code",
  "请获取验证码": "Get the verification code",
  "绑定成功": "Linked successfully",
  "绑定邮箱": "Link email",
  "请输入您要绑定的邮箱地址": "Enter the email address you want to link",
  "请输入有效邮箱地址": "Enter a valid email address",
  "绑定手机号": "Link phone number",
  "请输入您要绑定的手机号码": "Enter the phone number you want to link",
  "请输入用户名或密码": "Enter username or password",
  "请输入确认密码": "Enter confirmation password",
  "请输入密码": "Enter password",
  "请输入用户名": "Enter username",
  "请确认密码": "Confirm your password",
  "确认密码": "Confirm password",
  "两次密码不一致": "Passwords do not match",
  "请再次输入密码": "Enter password again",
  "确认新密码": "Confirm new password",
  "新密码": "New password",
  "密码绑定": "Password setup",
  "设置登录密码": "Set login password",
  "绑定微信": "Link WeChat",
  "请扫二维码绑定微信": "Scan the QR code to link WeChat",
  "当前用户未登录！": "You are not logged in",
  "暂无权限！": "You don't have permission",
  "该手机号/邮箱账号已被占用，请更换其他手机号/邮箱账号再试。": "This phone number/email address is already in use. Use a different one and try again.",
  "请输入新手机号": "Enter new phone number",
  "请输入新邮箱": "Enter new email",
  "新手机号与旧手机号相同": "The new phone number is the same as the old phone number",
  "获取验证码失败,请重新获取": "Failed to get verification code. Try again.",
  "未设置": "Not set",
  "姓名不能超过20个字": "Name cannot exceed 20 characters",
  "职位不能超过20个字": "Position cannot exceed 20 characters",
  "电话不能超过50个字": "Phone number cannot exceed 50 characters",
  "邮箱不能超过100个字": "Email cannot exceed 100 characters",
  "备注不能超过100个字": "Remarks cannot exceed 100 characters",
  "我的空间": "My Space",
  "入驻成为供应商": "Become a Supplier",
  "切换为设计师": "Switch to Designer",
  "账户设置": "Account Settings",
  "帮助中心": "Help Center",
  "您的浏览器暂时不支持添加快捷方式，推荐使用chrome或safari浏览器": "Your browser does not support adding shortcuts. We recommend using Chrome or Safari.",
  "安装快捷方式": "Install Shortcut",
  "退出登录": "Log Out",
  "供应商终止合作": "Supplier Partnership Terminated",
  "咨询电话：{{phone}}": "Contact: {{phone}}",
  "恭喜您领取成功": "Claim successful",
  "平台已免费赠送您三个月会员": "The platform has given you a <gift>free</gift> <membership>three-month membership</membership>.",
  "有效期至：{{date}}": "Valid Until: {{date}}",
  "开心收下": "Accept",
  "您有<count>{{count}}条</count>新的询价需要处理": "New inquiries to process: <count>{{count}}</count>",
  "共计{{count}}个产品": "{{count}} products in total",
  // —— 二元文案 t() 化新增（2026-07-17）——
  "{{name}}字段已存在！": "{{name}} field already exists",
  "您的数据我们将为您保留至{{time}}。为保证数据安全，请及时续费。": "Your data will be retained until {{time}}. To ensure data security, please renew your subscription.",
  "一次最多只能导入{{n}}张模版": "Only up to {{n}} templates can be imported at a time",
  "共{{n}}页": "{{n}} pages in total",
  "已选{{n}}页": "Selected {{n}} pages",
  "第{{n}}页": "Page {{n}}",
  "新增标记": "New",
  "输入手机号或邮箱": "Enter phone number or email",
  "委托添加{{name}}数据": "Share link to add {{name}}",
  "{{team}}委托您添加私域库数据，点击链接开始操作：{{url}}": "{{team}} has invited you to add data to the Private Space library. Click the link to get started: {{url}}",
  "确认将该{{name}}下架吗？": "Are you sure you want to unpublish this {{name}}?",
  "确认导出{{count}}个已入库产品的二维码？": "Export QR codes for {{count}} products in your library?",
  "你没有{{name}}的管理权限，继续操作将退出管理模式，是否继续？": "You do not have administrative permissions for the {{name}}. Continuing will exit the management mode. Do you wish to continue?",
  "暂无可{{type}}私域": "No Private Space available for {{type}}",
  "已解除{{name}}，确认是否删除，确认后消失。": "The {{name}} has been terminated. Please confirm whether to delete it. Once confirmed, it will disappear.",
  "取消{{name}}": "Cancel {{name}}",
  "这里还没有{{name}}方的介绍": "There is no introduction of the {{name}} party here yet",
  // —— 入库数据完整性校验（2026-07-28）——
  "数据完整性校验未通过": "Data integrity check not passed",
  "入库失败{{count}}条": "{{count}} items failed storage",
  "入库成功{{count}}条": "{{count}} items successfully stored",
  "入库成功{{successCount}}条": "{{successCount}} items successfully stored",
  "入库成功{{successCount}}条,失败{{failCount}}条": "{{successCount}} items stored, {{failCount}} items failed",
  "入库成功{{successCount}}条，失败{{failCount}}条": "{{successCount}} items stored, {{failCount}} items failed",
  "入库成功{{successCount}}条，未处理{{unprocessedCount}}条": "{{successCount}} items stored, {{unprocessedCount}} unprocessed",
  "入库成功{{successCount}}条，失败{{failCount}}条，未处理{{unprocessedCount}}条": "{{successCount}} items stored, {{failCount}} items failed, {{unprocessedCount}} unprocessed",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失": "{{successCount}} items stored, {{failCount}} failed, {{requiredCount}} missing required fields",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，未处理{{unprocessedCount}}条": "{{successCount}} items stored, {{failCount}} failed, {{requiredCount}} missing required fields, {{unprocessedCount}} unprocessed",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词": "{{successCount}} items stored, {{failCount}} failed, {{sensitiveCount}} containing restricted terms",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "{{successCount}} items stored, {{failCount}} failed, {{sensitiveCount}} containing restricted terms, {{unprocessedCount}} unprocessed",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词": "{{successCount}} items stored, {{failCount}} failed, {{requiredCount}} missing required fields, {{sensitiveCount}} containing restricted terms",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "{{successCount}} items stored, {{failCount}} failed, {{requiredCount}} missing required fields, {{sensitiveCount}} containing restricted terms, {{unprocessedCount}} unprocessed",
  "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词": "Stock-in failed, {{requiredCount}} missing required fields, {{sensitiveCount}} containing restricted terms",
  "入库失败,{{requiredCount}}个产品必填项缺失": "Stock-in failed, {{requiredCount}} missing required fields",
  "入库失败,{{sensitiveCount}}条产品存在敏感词": "Stock-in failed, {{sensitiveCount}} containing restricted terms",
  "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "Stock-in failed, {{requiredCount}} missing required fields, {{sensitiveCount}} containing restricted terms, {{unprocessedCount}} unprocessed",
  "入库失败,{{requiredCount}}个产品必填项缺失，未处理{{unprocessedCount}}条": "Stock-in failed, {{requiredCount}} missing required fields, {{unprocessedCount}} unprocessed",
  "入库失败,{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "Stock-in failed, {{sensitiveCount}} containing restricted terms, {{unprocessedCount}} unprocessed",
  "当前选中产品不支持入库操作": "Selected products cannot be stocked in",
  "当前选中产品不支持上架操作": "Selected products cannot be listed",
  "当前选中产品不支持下架操作": "Selected products cannot be delisted",
  "提交审核{{submitCount}}条": "{{submitCount}} items submitted for review",
  "已提交审核{{submitCount}}条": "{{submitCount}} items submitted for review",
  "已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条": "{{submitCount}} items submitted for review, {{unprocessedCount}} unprocessed",
  "上架成功{{successCount}}条": "{{successCount}} items listed",
  "上架成功{{successCount}}条，未处理{{unprocessedCount}}条": "{{successCount}} items listed, {{unprocessedCount}} unprocessed",
  "上架成功{{successCount}}条，已提交审核{{submitCount}}条": "{{successCount}} items listed, {{submitCount}} submitted for review",
  "上架成功{{successCount}}条，已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条": "{{successCount}} items listed, {{submitCount}} submitted for review, {{unprocessedCount}} unprocessed",
  "上架失败{{failCount}}条": "{{failCount}} items failed to list",
  "下架成功{{successCount}}条": "{{successCount}} items delisted successfully",
  "已下架{{successCount}}条": "{{successCount}} items delisted",
  "已下架{{successCount}}条，未处理{{unprocessedCount}}条": "{{successCount}} items delisted, {{unprocessedCount}} unprocessed",
  "下架失败{{failCount}}条": "{{failCount}} items failed to delist",
  "状态不支持{{unsupportedCount}}条": "{{unsupportedCount}} items have unsupported status",
  "未处理{{unprocessedCount}}条": "{{unprocessedCount}} items unprocessed",
  "上架成功{{successCount}}条,失败{{failCount}}条": "{{successCount}} items listed, {{failCount}} items failed",
  "句号": ". ",
  "逗号": ", ",
  "时间": "Time",
  "风格": "Style",
  "类型": "Type",
  "内容展示": "Content",
  "基本信息": "Information",
  "获奖证书": "Awards",
  "媒体宣传": "Media",
  // "选品列表": "List Of Selected Products",
  "无": "None",
  "暂无数据": "No data yet",
  "没有更多了": "No more items",
  "上架时间": "Listing Time",
  "上市时间": "Launch Date",
  "入库时间": "Date added",
  "名称排序": "Name Order",
  "默认排序": "Default Sort",
  "正序": "Asc",
  "倒序": "Desc",
  "分类": "Type",
  "分类N": "Type",
  "全部": "All",
  "所有产品": "All Products",
  "全部{{name}}": "All {{name}}",
  "现场勘测": "Site Survey",
  "深化设计": "Detailed Design",
  "代安装": "Installation service",
  "代施工": "Construction service",
  "代加工": "Processing service",
  "送货上门": "Home Delivery",
  "其他": "Others",
  "保养": "Maintenance",
  "一周内": "Within a week",
  "一个月内": "Within a month",
  "三个月内": "Within three months",
  "半年内": "Within six months",
  "重置": "Reset",
  "确认内容": "Confirm",
  "效果": "Final Look",
  "效果N": "Final Look",
  "素材": "Texture",
  "款式": "Style",
  "款式N": "Style",
  "产品参数": "Product Parameters",
  "品牌": "Brand",
  "品牌N": "Brand",
  "合资": "Joint Venture",
  "进口": "Imported",
  "国产": "Domestic",
  "原创": "Original",
  "产品类型": "Type",
  "选择产品类型": "Select product type",
  "供货周期": "Lead time",
  "配套服务": "Service",
  "附件": "File",
  "名片": "Card",
  "价格:": "Price:",
  "案例": "Case",
  "联系方式": "Contact Information",
  "姓名": "Name",
  "手机号": "phone",
  "邮箱": "Email",
  "已选内容": "Selected Products",
  "提交询价": "Submit",
  "返回": "Back",
  "提交成功": "Submitted successfully",
  "您的询价正在处理中": "Your inquiry is currently being processed",
  "您的询价正在处理中，前往不觉app查看询价记录": "Your inquiry is currently being processed. Open the Bujue app to view your inquiry history.",
  "您的询价正在处理中，前往不觉官网-我的询价查看": "Your inquiry is currently being processed. Go to My inquiries on the Bujue official site to view it.",
  "新手引导": "Quick guide",
  "知道了": "OK",
  "无附件数据": "No Attachments",
  "供应商信息": "Supplier information",
  "品牌信息": "Brand information",
  "分类信息": "Category information",
  "产品": "Products",
  "介绍": "Introduction",
  "作品": "Works",
  "筛选": "Filter",
  "滑动查看": "Swipe",
  "点击进入": "Enter",
  "点击开始": "Enter",
  "￥": "¥",
  "品牌类型": "Brand type",
  "安全防护": "Safety Protection",
  "厨房电器": "Kitchen Appliances",
  "电气设备": "Electrical Equipment",
  "儿童家具": "Children's Furniture",
  "辅材配件": "Auxiliary Materials And Accessories",
  "户外园艺": "Outdoor Gardening",
  "基础结构": "Infrastructure",
  "家居纺织品": "Home Textiles",
  "建筑节能": "Building Energy Efficiency",
  "建筑围护": "Building Enclosure",
  "洁具卫浴": "Sanitary Ware",
  "楼梯与扶手": "Stairs And Handrails",
  "门窗类": "Doors And Windows",
  "面层材料": "Surface Materials",
  "全屋定制": "Whole House Customization",
  "软装家居": "Soft Furnishings For Home",
  "施工工具": "Construction Tools",
  "水电暖通": "Plumbing, Electrical, Heating And Ventilation",
  "照明灯具": "Lighting Fixtures",
  "智能家居": "Smart Home",
  "装饰线条": "Decorative Mouldings",
  "件": "Piece",
  "/件": "/piece",
  "张": "Sheet",
  "个": "Unit",
  "台": "Set",
  "片": "Slice",
  "瓶": "Bottle",
  "箱": "Case",
  "盒": "Box",
  "捆": "Bundle",
  "包": "Package",
  "桶": "Barrel",
  "托": "Pallet",
  "卷": "Roll",
  "米": "m",
  "平方米": "m²",
  "升": "L",
  "千克": "Kg",
  "吨": "t",
  "扇": "Panel",
  "套": "Set",
  "跳过": "Skip",
  "暂无价格": "No Price",
  "¥ {{price}} 起": "From ¥ {{price}}",
  "¥ {{price}} 起": "From ¥ {{price}}",
  "产品列表固定价格": "¥ {{price}}",
  "产品列表区间价格": "<unit>From </unit>¥ {{price}}",
  "请输入名称": "Please Enter Your Name",
  "请输入手机号": "Please Enter Your Phone Number",
  "请输入邮箱": "Please Enter Your Email Address",
  "请输地区": "Please Enter Your Region",
  "请输其他联系方式": "Please Enter Other Contact Information",
  "提交": "Confirm",
  "至少保留一项": "Keep at least one item",
  "品牌：": "Brand:",
  "展开": "More",
  "折叠": "Hide",
  "品牌:": "Brand:",
  "类型:": "Type:",
  "周期:": "Cycle:",
  "上市时间:": "Launch Date:",
  "服务:": "Service:",
  "供货周期:": "Delivery Time:",
  "备注:": "Remark:",
  "贴图": "Texture",
  "贴图N": "Texture",
  "平铺": "Tiling",
  "平铺N": "Tiling",
  "列表": "List",
  "批量下载": "Batch Download",
  "共": "Total",
  "个文件": "files",
  "张贴图": " textures",
  "个模型": " models",
  "材质": "Material",
  "规格:": "Spec:",
  "规格": "Spec",
  "作品信息": "Information",
  "时间：": "Design Time:",
  "类型：": "Type:",
  "查看作品": "View Works",
  "材质:": "Material:",
  "图库": "Gallery",
  "简介": "About",
  "当前锚点": "Current Hotspots",
  "所有锚点": "All Hotspots",
  "选择资材类型": "Select material type",
  "资材类型": "Material type",
  "服务范围": "Service scope",
  "选择服务范围": "Select service scope",
  "询价": "Inquiry",
  "退出": "Exit",
  "退出批量设置": "Exit Batch Setting",
  "确定": "Confirm",
  "全选": "Select all",
  "：": ":",
  "取消": "Cancel",

  "请输入您的姓名": "Please enter your name",
  "请输入您的邮箱": "Please enter your email address",
  "请输入您的地区": "Please enter your region",
  "暂无附件": "No attachments",
  "未开通国际版": "The international edition is not open",
  "电话咨询": "Phone inquiry",
  "所有图片": "All pictures",
  "附件不支持下载，请联系供应商": "The attachment is not available for download. Please contact the supplier.",
  "附件不支持下载，请联系管理员": "The attachment is not available for download. Please contact the administrator.",
  "品牌馆": "Brand Pavilion",
  "进入品牌": "Enter the brand",
  "请至少选择一条产品": "Please select at least one product",
  "数量不能小于1": "Quantity must be at least 1",
  "附件下载": "Attachment Download",
  "下载附件": "Download attachments",
  "应用案例": "Cases",
  // "入库时间":"Storage time",
  "名称": "Name",
  "已认证": "Certified",
  "海外版官网": "Overseas official website",
  "开发中": "In Development",
  "选择类型": "Select type",
  "选择": "Select",
  "分享设置": "Sharing settings",
  "已选": "Selected",
  "已选：": "Selected:",
  "已选：{{n}}/{{total}}": "{{n}}/{{total}} selected",
  "上一步": "Previous",
  "下一步": "Next",
  "分享": "Share",
  "请输入搜索": "Please enter search",
  "请输入搜索内容": "Search",
  "选择展示方式": "Choose display method",
  "平铺模式": "Tile Mode",
  "合集": "Collection",
  "设置默认视图": "Set the default view",
  "已选择": "Selected",
  "拖动排序": "Drag Sort",
  "单次分享上限100个": "Up to 100 items per share",
  "浏览次数：": "Number of views:",
  "不限制": "No limit",
  "限制": "Limitation",
  "请输入": "Enter",
  "有效期限：": "Valid period:",
  "1天": "1 day",
  "7天": "7 days",
  "永久": "Permanent",
  "确认订单": "Confirm Order",
  "购买语言：": "Language:",
  "选择支付方式：": "Payment Method:",
  "购买即同意": "By purchasing, you agree to",
  "《不觉付费服务协议》": "Bujue Paid Service Agreement",
  "《不觉付费协议》": "Bujue Paid Service Agreement",
  "合计：": "Total:",
  "立即支付": "Pay Now",
  "语言包": "Language Packs",
  "套餐对比": "Compare Plans",
  "服务咨询": "Contact Us",
  "示例效果": "Example",
  "即将上线，敬请期待！": "Coming soon, stay tuned!",
  "当前语言已开通": "This language is already enabled",
  "订单已结束": "Order has ended",
  "开通成功": "Enabled Successfully",
  "该语言": "The language",
  "{{lang}}开通成功！正在自动翻译当前私域数据，稍后将收到翻译完成提醒":
    "{{lang}} has been enabled. Your private data is being translated automatically, and you will be notified once the translation is complete.",
  "英语": "English",
  "日语": "Japanese",
  "俄罗斯语": "Russian",
  "法语": "French",
  "德语": "German",
  "阿拉伯语": "Arabic",
  "自定义": "Customize",
  "次": "times",
  "天": "days",
  "{{days}}天": "{{days}} days",
  "作品锚点：": "Anchor point:",
  "显示": "Show",
  "不显示": "Hide",
  "个人名片": "Personal business card",
  "个人名片:": "Business card:",
  "产品价格：": "Product price:",
  "还未设置名片信息，": "Business card information has not been set yet, ",
  "立即设置": " set it now",
  "编辑": "Edit",
  "请选择介绍内容": "Please select the introduction content",
  "请选择作品": "Please select a work",
  "请选择产品": "Please select products",
  "预览": "Preview",
  "分享标题：": "Share Title:",
  '请输入分享标题': "Please enter the share title",
  '请输入分享描述': "Please enter a sharing description",
  "设置名片信息": "Set business card information",
  "设置成功": "Setting successful",
  "姓名不能为空": "Name cannot be empty",
  "职位": "Position",
  "电话": "Phone",
  "电话不能为空": "Phone cannot be empty",
  "微信号": "WeChat ID",
  "微信号_供应商管理": "WeChat",
  "联系地址": "Contact address",
  "联系地址不能为空": "Contact address cannot be empty",
  "logo不得为空": "Logo cannot be empty",
  "建议尺寸50*50，png图片": "Suggested size 50 * 50, PNG image",
  "确认": "OK",
  "全部导出": "Export All",
  "部分导出": "Partial export",
  "国内二维码": "Domestic QR code",
  "海外二维码": "Overseas QR code",
  "产品二维码": "Product QR code",
  "供应商": "Supplier",
  "热门品牌": "Popular brands",
  "封面": "Cover",
  "一键导出二维码": "One click export of QR code",
  "退出导出": "Exit export",
  "基础信息": "Basic Info",
  "未分组": "Ungrouped",
  "使用微信、钉钉APP扫码分享": "Scan the code with WeChat or DingTalk to share",
  "也可以复制链接发送给小伙伴": "You can also copy the link and send it to your friends",
  "复制链接": "Copy link",
  "生成图片": "Generate image",
  "生成失败": "Generation failed",
  "产品信息不存在": "Product info not found",
  "长按图片保存或分享": "Long press image to save or share",
  "长按图片保存到相册": "Long press image to save to album",
  "已加入咨询清单": "Added to inquiry list",
  "加入失败": "Failed to add",
  "请先选择规格": "Please select specifications first",
  "请先选择产品": "Please select products first",
  "个月": "months",
  " 天": " days",
  "条数据": "pieces of data in total",
  "取消选择": "Deselect",
  "请选择下载附件": "Please select the attachment to download",
  "请选择日期": "Please select the date",
  "至少选择一个附件": "Please select at least one attachment",
  "下载": "Download",
  "高清贴图": "High definition texture",
  "请选择节点": "Please select a node",
  "请选择图片": "Please select an image",
  "请先上传贴图": "Please upload texture images first",
  "没有匹配的SKU": "No matching SKUs",
  "下载素材": "Download materials",
  "编辑封面": "Edit Cover",
  "名称 ": "Name",
  "已失效": "Expired",
  "未过审原因": "Reason",
  "我知道了": "I got it",
  "封面图不可取消勾选！": "The cover image cannot be deselected",
  "默认比例": "Default ratio",
  "自由比例": "Free proportion",
  "切换为暗色": "Switch to dark mode",
  "切换为亮色": "Switch to light mode",
  "链接已失效": "The link has expired",
  "链接访问次数已达上限": "The number of link visits has reached the maximum limit",
  "取消全选": "Deselect all",
  "贴图库": "Texture library",
  "搜索贴图": "Search textures",
  "文件夹（{{count}}）": "Folders ({{count}})",
  "图片（{{count}}）": "Images ({{count}})",
  "已关联不可重复关联": "Already linked",
  "已关联": "Linked",
  "请至少勾选一张关联图": "Select at least one related image",
  "退出全选": "Exit Select All",
  "项": "items",
  "请选择要下载的图片": "Please select the image to download",
  "请输入自定义有效期天数！": "Please enter the custom validity period in days",
  "暂无权限": "No permission at present",
  "进入管理": "Enter Management",
  "进入空间":"Enter Space",
  "成功关注": "Successful follow",
  "已关注":"Followed",

  "取消成功！": "Canceled successfully",
  "取消成功":"Canceled successfully",
  //作品
  "更多筛选": "Show more",
  "更少筛选": "Show less",
  "随机排序": "Random Sorting",
  "小卡片": "Mini Card",
  "大卡片": "Large Card",
  "链接有效期：": "Expires:",
  "个项目": "Projects in Total",
  "共{{total}}个项目": "{{total}} Projects in Total",
  "作品分享": {
    "介绍": "Intro"
  },
  "锚点": "Hotspots",
  "暂无高清贴图": "No high-definition texture",
  "暂无锚点": "No Hotspots",
  "当前私域未认证": "Private space not certified",
  "已删除": "Deleted",
  "暂无": "None",
  "查看权限": "View Permissions",
  "未发布": "Unpublished",
  "YYYY年M月": "YYYY/M",
  "未开通海外版": "The overseas edition is not open",
  "暂无名片": "No business card",
  "项目管理": "Proj Mgmt",
  "盘八斗项目": "Panbadou project",
  "关联盘八斗项目管理": "Link to Panbadou PM",
  "排序依据": "Sorting basis",
  "随机的": "Random",
  "名字": "Name",
  "时间正序": "Time ascending",
  "时间倒序": "Time descending",
  "排序": "Sort",
  "产品下载：": "Product Download:",
  "允许": "Allowed",
  "禁止": "Blocked",
  "颜色筛选": "Color filtering",
  "颜色筛选结果": "Color filtering results",
  "请在电脑上进行批量下载": "Please open the link on computers for batch download.",
  "确认清单": "Confirm List",

  '入库权限未开放': "Access to stock entry is not granted.",
  "下载权限未开放": "Access to download is not granted",
  "可以通过联系人获得产品入库权限": "Please obtain permission through a contact",
  "可以通过联系人获得产品下载权限": "Please obtain download permission through a contact",
  "{{authName}}权限未开放": "{{authName}} permission is not enabled.",
  "可以通过联系人获得产品{{authName}}权限": "You can obtain product {{authName}} permission through a contact.",
  "联系人:": "Contact:",
  "手机号:": "Phone:",
  "入库": "Stock In",
  "入库失败": "Stock-in failed",
  "入库失败,数据完整性校验未通过": "Stock-in failed, data integrity check not passed",
  "入库至": "Stock In to",
  "选择入库的产品将加入每个私域的未入库列表，需要管理员的确认才能成功入库": "Products will be added to the \"unstocked list\" in the private space, and can only be completed after the administrator's confirmation.",
  '请至少勾选一条！': "Please select at least one",
  "入库成功！": "Stock In Success",
  "入库成功": "Stock In Success",
  "发布成功": "Published Successfully",
  "加入采购清单成功": "Successfully added to purchase list",
  "合作": "Cooperation",
  "默认分组": "Default Group",
  "中文": "Zh",
  "中文N": "Chinese",
  "默认使用首个开启的语言": "The first enabled language is used by default",
  "英文": "En",

  "当前私域的主体认证未通过，无法访问": "The current private space has not passed business verification and cannot be accessed",
  "返回上一级":"Go Back",
  "上传日期":"Upload date",
  "大小":"Size",
  "按名称":"By name",
  "按时间":"By time",
  "按大小":"By size",
  "这里还没有合作方的介绍":"There is no introduction of the cooperating party here yet",
  "创建私域": "Create a private space",
  "切换私域": "Switch private space",
  "未查到相关私域": "No relevant private space found",
  "已入库":"In Stock",
  "我拥有":"Owned",
  "推荐成功！":"Recommendation successful",
  "成功！":"Success",
  "提示":"Notice",
  "会员状态确认中，请稍候":"Checking membership status, please wait",
  "协议模板未配置":"No agreement template configured",
  "请使用电脑打开链接！":"Open this link on a computer",
  "浙ICP备17033477号-5":"Zhejiang ICP No. 17033477-5",
  "绑定手机号/邮箱":"Link phone or email",
  "绑定成功！":"Linked successfully",
  "请输入验证码!":"Enter verification code",
  "请先完成拼图":"Complete the puzzle first",
  "请按住滑块拖动完成拼图":"Hold and drag the slider to complete the puzzle",
  "该私域":"This Private Space",
  "盘子登录":"Panzi login",
  "支付宝登录":"Alipay login",
  "登录/注册":"Log in / Register",
  "注册登录协议说明":"By registering or logging in, you agree to our <user>Terms of Service</user>, <privacy>Privacy Policy</privacy> and <child>Children's Privacy Notice & Guardian Guidelines</child>.",
  "注册登录协议说明2":"By registering or logging in, you agree to our <user>Terms of Service</user>, <privacy>Privacy Policy</privacy>, <child>Children's Privacy Notice & Guardian Guidelines</child><contracts/>",
  "两个协议之间连接的文案":",",
  "最后一个协议和倒数第二个协议连接的文案":" and ",
  "登录":"Log in",
  "验证码登录":"Log in with verification code",
  "密码登录":"Log in with password",
  "微信登录":"WeChat login",
  "验证码":"Verification code",
  "发送验证码":"Send code",
  "已发送":"Sent",
  "账号密码登录":"Account password login",
  "密码":"Password",
  "忘记密码":"Forgot password",
  "请完成拼图":"Please complete the puzzle",
  "验证码登录/注册":"Verification code login/registration",
  "密码至少6~18个字符":"Password must be 6-18 characters",
  "请输入有效手机号码!":"Please enter a valid phone number",
  "请输入正确的手机号或邮箱账号!":"Enter a valid phone number or email address.",
  "验证码不能为空!":"The verification code cannot be empty",
  "密码不能为空!":"The password cannot be empty",
  "确保密码长度是 6-16 位":"Password length must be 6–16",
  "密码不允许纯数字":"Pure numeric passwords are not permitted",
  "只能输入数字、英文字母和符号":"Only numbers, letters and symbols are allowed",
  "密码中不能出现 3 位以上连续字符（如aaaa,1234）":"No more than 3 consecutive identical/sequential chars (e.g. aaaa, 1234)",
  "找回密码":"Retrieve password",
  "以下信息仅私域管理员查看":"The following information is only available for Private Space administrators to view",
  "客户":"Customer",
  // "联系方式":"contact information",
  "详细地址":"Detailed address",
  "验证码错误！":"Verification code error",
  "密码错误！":"Password error",
  "入库请先登录":"Log in first to add to the library",
  "下载请先登录": "Please log in before downloading",
  "分享请先登录":"Please log in before sharing",
  "设置新密码":"Set a new password",
  "输入新密码":"Enter new password",
  "请确认您的密码!":"Please confirm your password",
  "您输入的两个密码不匹配!":"The two passwords you entered do not match",
  "输入确认密码":"Enter confirmation password",
  "登录不觉账号":"Sign in to your Bujue account",
  "注册不觉账号并加入 {{privateDomainName}} 会员,享受会员专属权益与服务。":"Create a Bujue account and join {{privateDomainName}} to access exclusive member benefits and services.",
  "由不觉科技提供技术支持":"Powered by Bujue Technology",
  "Powered By Bujue":"Powered By Bujue",
  "二维码加载中...":"二维码加载中...",
  "二维码加载失败，请重试":"二维码加载失败，请重试",
  "重新加载":"Refresh",
  "微信登录二维码":"微信登录二维码",
  "使用微信扫一扫登录“不觉”":"Scan with WeChat to sign in to \"Bujue\"",
  "使用微信扫一扫登录“不觉空间”":"Scan with WeChat to sign in to \"Bujue Space\"",
  "返回其他登录方式":"返回其他登录方式",
  "其他登录方式":"Other login methods",
  "使用微信登录":"使用微信登录",
  "暂无可入库私域":"No Private Space is available to add to",
  "搜索":"Search",
  "修改密码成功！":"Password changed successfully",
  "请间隔5秒后再点击":"Please wait for 5 seconds before clicking again",
  // "正序":"Positive sequence",
  // "倒序":"Reverse order",
  "置顶":"Pin",

  "产品库":"Product Library",
  "筛选颜色":"Filter colors",
  "收起更多筛选":"Hide more filters",
  "效果图":"Rendering",
  "素材图":"Texture",
  "委托添加":"Delegated Add",
  "手动添加":"Manual Add",
  "批量添加":"Batch Add",
  "批量替换":"Batch replace",
  "确认批量操作": "Confirm batch operation",
  "确认批量替换贴图吗？": "Confirm replacing textures in batch?",
  "确认批量添加贴图吗？": "Confirm adding textures in batch?",
  "贴图数量超过上限": "The texture count exceeds the limit",
  "未入库":"Not Stocked",
  "产品空间":"Product space",
  "公域产品管理":"Public Product Management",
  "已上架":"Already listed",
  "展开更多筛选":"Expand more filters",
  "管理":"Manage",
  "产品分类":"Classification of products",
  "材料属性":"Attributes",
  "固定周期":"Fixed lead time",
  "区间周期":"Lead time range",
  "新增字段":"New fields",
  "新增分类":"Add category",
  "上传/关联贴图":"Upload/Associate texture",
  "标签":"Label",
  "备注":"Notes",
  "保存":"Save",
  "介绍页Tab名称不能重复":"Introduction tab names cannot be duplicated",
  "名称不能重复！":"The name cannot be repeated",
  "名称不能重复":"The name cannot be repeated",
  "请输入字段名称":"Please enter the field name",
  "双击修改字段名称":"Double click to modify field name",
  "确定要删除吗?":"Are you sure you want to delete it?",
  "您确定要批量删除选中的图片吗?":"Are you sure you want to delete the selected images in bulk?",
  "确定要删除选中的图片，并同步删除备份在不觉云的原图吗？":"Delete the selected images and the original files backed up to Bujue Cloud?",
  "同步删除":"Delete All",
  "只删图片":"Keep Backup",
  "删除图片":"Delete Image",
  "同时删除不觉云备份文件":"Also delete the backup files in Bujue Cloud",
  "其他款式同步删除":"Also delete from other styles",
  "请选择":"Please select",
  "请选择{{name}}":"Select {{name}}",
  "不觉云存储空间不足":"Insufficient Bujue Cloud storage",
  "系列型号":"Series model",
  "区间价格":"Price range",
  "固定价格":"Fixed price",
  "参数价格不能只填一个!":"Enter both parameter prices",
  "最低参考价不能大于或等于最高参考价!":"The minimum reference price cannot be greater than or equal to the maximum reference price",
  "请填写材质":"Please fill in the material",
  "尺寸规格":"Size & specs",
  "请填写尺寸":"Please fill in the size",
  "检测到未上传贴图，请先上传哦！":"Some textures have not been uploaded. Please upload them first.",
  "所有产品名称":"All product names",
  "拖动可以排序":"Drag to sort",
  "至少保留一张贴图":"Keep at least one texture",
  "已关联贴图":"Associated texture",
  "产品介绍":"Product Introduction",
  "多图片":"Multiple images",
  "多文档":"Multiple Documents",
  "清空":"Clear",
  "请完善款式信息！":"Complete the style information",
  "请完善当前款式信息！":"Complete the current style information",
  "封面还未上传完！":"The cover has not finished uploading",
  "款式信息未完善":"Style information not complete",
  "点击/拖入单个PDF文档":"Click or drag a single PDF file",
  "将文件拖拽至此区域或点击添加":"Drag and drop files to this area or click Add",
  "支持PDF、WORD、EXCEL、3DMAX、SKP、CAD、Revit等格式":"Supports PDF, Word, Excel, 3ds Max, SKP, CAD, Revit and more",
  "正在上传中...":"Uploading...",
  "上传未完成之前，请勿保存或发布，否则可能数据错误":"Do not save or publish before the upload is completed, otherwise the data may be incorrect",
  "点击/拖入图片":"Click or drag an image",
  "还未上传图片":"No image uploaded",
  "请上传图片":"Upload image",
  "“点击” 或 “拖入” 替换图片":"\"Click\" or \"drag\" to replace the image",
  "遮罩颜色": "Mask color",
  "模糊效果": "Blur effect",
  "拖动图片可以排序":"Drag pictures to sort",
  "已上传图片":"Uploaded images",
  "标签最多5个，有助于提升产品在紫菜海洋的搜索概率":"Up to 5 tags. Tags help your products appear in Zicai Ocean search results.",
  "贴图分类":"Texture classification",
  "图片":"Picture",
  "关联已有贴图":"Associate existing textures",
  "拖动图片可以排序, 限制20张":"Drag to reorder. Up to 20 images.",
  "每次限20张":"Up to 20 images at a time",
  "管理产品":"Manage Products",
  "新增服务":"New service",
  "标签不能重名！":"Tags cannot have duplicate names",
  "标签名称不能为空":"The label name cannot be empty",
  "最多可选5个标签!":"You can select up to 5 tags",
  "确定要删除吗?已关联产品中的对应标签会一并删除！":"Are you sure you want to delete? The corresponding tags in the associated products will also be deleted",
  "添加":"Add",
  "添加标签":"Add labels",
  "已上架：":"Listed:",
  "关联品牌":"Associate Brand",
  // "产品":"Product",
  "地址":"Address",
  "服务区域":"Service Area",
  "上传合约":"Upload contract",
  "终止日期":"End Date",
  "操作":"Action",
  "删除":"Delete",
  "个品牌":"brands",
  "查看合约":"View contract",
  "设为必填":"Mark as required",
  "取消必填":"Unmark as required",
  "产品列表":"Product List",
  "进入管理模式":"Enter management mode",
  "私域工作台": "Private Space workbench",
  "退出工作台": "Exit workbench",
  "进入封面":"Enter cover",
  "我在私域的昵称":"My nickname",
  "修改我在私域的昵称":"Edit my nickname",
  "请输入昵称":"Please enter a nickname",
  "私域中的昵称": "Nickname in Private Space",
  "暂无签名": "No signature yet",
  "你不在该私域":"You are not in this Private Space",
  "退出管理":"Exit Management",
  "浏览模式":"Browse mode",
  "管理模式":"Management mode",
  "全屏":"Full screen",
  "退出全屏":"Exit Full Screen",
  "权限提醒":"Permission Reminder",
  "背景设置":"Background setting",
  "添加品牌":"Add brand",
  "品牌logo":"Brand logo",
  "筛选时不能进行编辑操作":"Editing operations cannot be performed during filtering",
  "将同时删除产品":"The products will be deleted simultaneously",
  "编辑品牌":"Edit brand",
  "品牌名称":"Brand Name",
  "请输入品牌名称":"Please enter the brand name",
  "请选择类型":"Please select the type",
  "国家":"Country",
  "请输入国家":"Please enter the country",
  "请选择国家":"Please select the country",
  "分组":"Group",
  "分组名不可重复":"Group names cannot be duplicate",
  "更多":"More",
  "更多颜色":"More colors",
  "收起":"Collapse",
  "是否确认删除":"Confirm deletion",
  "删除成功":"Deleted successfully",
  "邀请":"Invite",
  "复制成功！":"Copy successful",
  "复制成功":"Copy successful",
  "请输入供应商公司名称":"Please enter the supplier's company name",
  "头像":"Profile picture",
  "请选择区域":"Please select a region",
  "请输入联系人":"Please enter a contact",
  "请输入电话":"Please enter your phone number",
  "请输入微信号":"Please enter your WeChat ID",
  "请输入正确的手机号":"Please enter a valid phone number",
  "添加客服微信": "Add Customer Support on WeChat",
  "留下您的联系方式":"Leave your contact information",
  "私域设置":"Space Settings",
  "私域信息":"Space Info",
  "私域安全":"Space Security",
  "成员管理": "Staff Management",
  "权限管理":"Permission Management",
  "模块管理":"Module Management",
  "物料板":"Material Board",
  "分享管理":"Sharing Management",
  "小程序管理":"Mini Program Management",
  "主体认证":"Entity Certification",
  "付费服务": "Paid Services",
  "容量":"Storage",
  "原套餐已到期，部分功能不可再用，请及时续费":"The previous plan has expired. Some features are unavailable. Please renew promptly.",
  "多语言": "Languages",
  "已开通":"Enabled",
  "未开通":"Not enabled",
  "订单详情": "Order Details",
  "支付宝支付":"Alipay Payment",
  "微信支付": "WeChat Pay",
  "支付成功":"Payment Successful",
  "添加客服企业微信，为您匹配专属客户成功团队服务支持，对您进行不觉产品一对一指导":"Add us on WeCom to get a dedicated Customer Success team and one-on-one guidance on Bujue.",
  "添加客服企业微信，获取更多资讯":"Add us on WeCom for more updates",
  "请使用支付宝扫码支付":"Please scan with Alipay to pay",
  "请使用微信扫码支付":"Please scan with WeChat to pay",
  "取消支付":"Cancel Payment",
  "确认取消支付吗？":"Are you sure you want to cancel the payment?",
  "完成":"Done",
  "{{name}}页":"{{name}} Page",
  "提交成功！":"Submitted successfully",
  "信息提交成功！":"Information submitted successfully",
  "信息保存成功！":"Information saved successfully",
  "审核通过！":"Approved",
  "恭喜获得认证标识，如要修改信息请前往私域设置-主体认证":"Congratulations on obtaining the certification badge. To modify your information, please go to Space Settings - Entity Certification",
  "主体认证审核中":"Entity certification under review",
  "信息审核预计在1～2工作日内完成，审核完成后，登录不觉会有弹框提醒您":"Information review is expected to be completed within 1-2 business days. After the review is completed, you will receive a pop-up reminder when logging into Bujue",
  "审核工作时间：周一～周五，9:00-17:30":"Review hours: Monday to Friday, 9:00-17:30",
  "不觉客服":"Bujue Customer Service",
  "扫码添加客服，有任何问题请联系我们":"Scan the QR code to add customer service, please contact us with any questions",
  "订单号": "Order Number",
  "套餐": "Plan",
  "实付":"Amount Paid",
  "购买时间": "Purchase Date",
  "生效时间": "Effective Date",
  "到期时间": "Expiration Date",
  "发票": "Invoice",
  "已抵扣":"Deducted",
  "已升级":"Upgraded",
  "永久有效":"Permanently Valid",
  "开票": "Request Invoice",
  "作废": "Void",
  "开票中":"Issuing",
  "开票失败":"Invoice Issuance Failed",
  "重试":"Retry",
  "重开":"Reissue",
  "发票作废中":"Voiding Invoice",
  "申请重开发票成功":"Invoice reissue request submitted",
  "确认作废发票吗？":"Are you sure you want to void this invoice?",
  "申请发票作废中":"Invoice void request submitted",
  "确认开票信息":"Confirm Invoice Information",
  "选择开票信息":"Select Invoice Information",
  "添加开票信息":"Add Invoice Information",
  "确认开票":"Confirm Invoice",
  "单位":"Company",
  "个人":"Individual",
  "普票":"General Invoice",
  "专票":"Special Invoice",
  "发票抬头":"Invoice Title",
  "请输入发票抬头":"Please enter the invoice title",
  "税号":"Tax ID",
  "请输入税号":"Please enter the tax ID",
  "格式有误":"Incorrect format",
  "注册电话(包括区号)":"Registered Phone (including area code)",
  "请输入注册电话(包括区号)":"Please enter the registered phone number (including area code)",
  "注册地址":"Registered Address",
  "请输入注册地址":"Please enter the registered address",
  "银行账号":"Bank Account",
  "请输入银行账号":"Please enter the bank account number",
  "开户银行":"Bank Name",
  "请输入开户银行":"Please enter the bank name",
  "请输入姓名":"Please enter the name",
  "身份证":"ID Card",
  "请输入身份证":"Please enter the ID card number",
  "个人普票":"Individual General Invoice",
  "注册电话":"Registered Phone",
  "开票失败，请":"Invoice issuance failed, please",
  "已购买":"Purchased",
  "认证流程：":"Certification Process:",
  "准备营业执照、公司法人信息":"Prepare business license and legal representative information",
  "在线填写认证基本信息":"Fill in basic certification information online",
  "上传公司法人信息":"Upload company legal representative information",
  "完成提交等待官方审核":"Complete submission and wait for official review",
  "完成主体认证，您的私域可以获得以下权限": "Complete entity certification to unlock the following permissions for your private space",
  "认证标识":"Certification Badge",
  "发布空间":"Publish Space",
  "开通小程序":"Enable Mini Program",
  "访客权限":"Visitor Permissions",
  "私域人数可以超过50人": "Private space can exceed 50 staff",
  "作品分享查看锚点":"View anchor points when sharing works",
  "认证须知：":"Certification Notice:",
  "私域名称提交后，修改名称需要再次提交认证流程": "After the private space name is submitted, changing the name requires resubmitting the certification process",
  "填写前请准备好：营业执照、公司法人证件信息。如果主体资质虚假、不符合资质审核标准的，将做认证失败处理。":"Before filling in, please prepare: business license, company legal representative's ID information. If the entity's qualifications are false or do not meet the review standards, the certification will be treated as failed.",
  "完成主体认证，你可以获得以下权限：认证标识、发布空间、开通小程序、私域人数可以超过50人、作品分享查看锚点": "Complete entity certification to unlock the following permissions: certification badge, publish space, enable mini program, private space staff exceeding 50, view anchor points when sharing works",
  "驳回原因：":"Rejection Reason:",
  "账号信息":"Account Information",
  "私域名称不能为空！": "The private space name cannot be empty",
  "请输入私域名称": "Please enter the private space name",
  "账号名称需与主体企业、或品牌商标信息一致，例如主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词等":"The account name must be consistent with the entity company or brand/trademark information. For example, if the entity company is \"Hangzhou Bujue Technology Co., Ltd.\", the account name can use: \"Bujue Technology Co., Ltd.\", \"Hangzhou Bujue Technology\", \"Bujue Technology + industry term\", etc.",
  "查看更多规范":"View More Guidelines",
  "私域Logo": "Private Space Logo",
  "私域Logo不能为空！": "Private Space Logo cannot be empty",
  "私域类型": "Private Space Type",
  "私域类型不能为空！": "Private space type cannot be empty!",
  "请选择私域类型": "Please select the private space type",
  "设计团队":"Design Team",
  "产品团队":"Product Team",
  "机构（协会）":"Institution (Association)",
  "装修企业":"Renovation Company",
  "主体信息":"Entity Information",
  "企业名称":"Company Name",
  "请输入企业名称":"Please enter the company name",
  "营业执照":"Business License",
  "主营业务":"Main Business",
  "请输入主营业务":"Please enter the main business",
  "法人验证":"Legal Representative Verification",
  "法人姓名":"Legal Representative's Name",
  "请输入法人姓名":"Please enter the legal representative's name",
  "法人身份证号":"Legal Representative's ID Number",
  "请输入法人身份证号":"Please enter the legal representative's ID number",
  "法人身份证信息":"Legal Representative's ID Information",
  "身份证正面":"ID Card Front",
  "身份证反面":"ID Card Back",
  "人脸识别":"Facial Recognition",
  "法人未认证":"Legal representative not verified",
  "用微信扫码，完成人脸识别":"Scan with WeChat to complete facial recognition",
  "已认证成功，如需修改，":"Verified successfully. To modify,",
  "请重新认证":"Please re-verify",
  "法人认证成功":"Legal representative verified successfully",
  "同意并遵守":"Agree and comply with",
  "《不觉私域主体认证须知》": "\"Bujue Private Space Entity Certification Notice\"",
  "，确保提供的信息及材料真实有效":", and ensure the information and materials provided are true and valid",
  "未勾选服务协议":"Service agreement not checked",
  "企业名称不能为空！":"Company name cannot be empty",
  "请上传营业执照！":"Please upload the business license",
  "请上传最新版三证合一的营业执照清晰正面图，或清晰完整的组织机构代码证":"Please upload a clear front image of the latest \"three-in-one\" business license, or a clear and complete organization code certificate",
  "主营业务不能为空！":"Main business cannot be empty",
  "法人姓名不能为空！":"Legal representative's name cannot be empty",
  "法人身份证号不能为空！":"Legal representative's ID number cannot be empty",
  "请上传身份证正面！":"Please upload the front of the ID card",
  "请上传身份证反面！":"Please upload the back of the ID card",
  "请完成人脸识别！":"Please complete facial recognition",
  "认证{{status}}":"Certification {{status}}",
  "命名规范":"Naming Guidelines",
  "1、账号名称需命名规范，与主体企业、或品牌商标信息一致：":"1. The account name must follow the naming guidelines and be consistent with the entity or brand/trademark information:",
  "使用认证主体企业命名：即与营业执照名称保持一致，支持企业全称或简称；如：主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词（例：不觉科技设计师平台）":"Use the certified entity's company name: i.e. consistent with the business license name, full or abbreviated company name supported; e.g. if the entity is \"Hangzhou Bujue Technology Co., Ltd.\", the account name can use: \"Bujue Technology Co., Ltd.\", \"Hangzhou Bujue Technology\", \"Bujue Technology + industry term\" (e.g. \"Bujue Technology Designer Platform\")",
  "使用品牌/商标信息命名，需提供对应资质；如：主体为可口可乐公司，账号名称可使用：芬达饮品":"Use brand/trademark information for naming; corresponding qualifications must be provided. E.g. if the entity is Coca-Cola Company, the account name can use: Fanta Beverage",
  "如是app、网站支持使用app/网站命名，需提供对应资质；如：app软著中全称为星野软件，账号名称可以为星野软件、星野、星野App等；":"If it is an app or website, naming based on the app/website name is supported; corresponding qualifications must be provided. E.g. if the app's software copyright full name is \"Xingye Software\", the account name can be \"Xingye Software\", \"Xingye\", \"Xingye App\", etc.;",
  "2、账号名称不超过40字，仅支持特殊符号如下：“”、“ ”、“”、“ ”、“ 、“《》”，其他特殊符号不支持":"2. The account name must not exceed 40 characters, and only supports the following special symbols: \"\", \" \", \"\", \" \", \", 《》\"; other special symbols are not supported",
  "3、账号名称&头像，不得含有歧义、侵犯、仿冒官方等内容，不能有广告法禁用词，如“第一”、“最”；":"3. The account name & avatar must not contain ambiguous, infringing, or officially-impersonating content, and must not contain words prohibited by advertising law, such as \"No.1\" or \"Best\";",
  "4、账号名称&头像，如包含品牌名/商标，需选择对应品牌并提供商标注册证或相关授权材料；":"4. If the account name & avatar contains a brand name/trademark, you must select the corresponding brand and provide the trademark registration certificate or relevant authorization materials;",
  "5、账号名称不得单独使用人名、或以人名作结尾，不得为职位化昵称，如：XX董事长、XX厂长、XX经理，不得含有“招商”、“加盟”字样；如您后续需开通店铺，请确保名称中不含“旗舰店”、“专卖店”、“集合店”、“卖场型旗舰店”、“工厂店”等字样，否则入驻店铺将被驳回。":"5. The account name must not consist solely of a personal name or end with a personal name, and must not be a title-based nickname (e.g. “XX Chairman”, “XX Factory Director”, “XX Manager”), and must not contain the words “recruitment” or “franchise”; if you plan to open a store later, please ensure the name does not contain “flagship store”, “specialty store”, “collection store”, “mega flagship store”, “factory store”, etc., otherwise the store application will be rejected.",
  "没有私域信息": "No private space info",
  "分享人":"Sharer",
  "统一联系人":"Unified Contact",
  "设置":"Settings",
  "图片水印：":"Image Watermark:",
  "logo水印":"Logo Watermark",
  "作品下载：":"Works Download:",
  "官网入口：":"Official Website Entry:",
  "产品入库：":"Add Product to Stock:",
  "单图logo":"Single Logo",
  "平铺logo":"Tiled Logo",
  "透明度":"Opacity",
  "请输入透明度":"Please enter opacity",
  "更换Logo":"Change Logo",
  "至少保留一个内容!":"Keep at least one item.",
  "拖动调整顺序":"Drag to reorder",
  "目录":"Contents",
  "访客登录设置":"Visitor Login Settings",
"登录注册":"Login/Register",
"需要":"Required",
"不需要":"Not Required",
"登录触发条件":"Login Trigger Conditions",
"累计查看":"Cumulative Viewing",
"进入小程序":"Enter Mini Program",
"分钟":"min",
"触发后登录":"Login After Trigger",
"必须登录":"Login Required",
"不必须登录":"Login Optional",
"图片水印":"Image Watermark",
"分享封面":"Share Cover",
"头部背景图":"Header Background",
"图片限制规格：5:4尺寸，<200KB，png图片":"Image spec: 5:4 ratio, <200KB, PNG",
"图片限制：<800KB，png图片":"Image limit: <800KB, PNG",
"图片大小超过上限":"Image size exceeds limit",
"内容管理":"Content Management",
"客户管理":"Customer Management",
"下载用户清单":"Download User List",
"未认证":"Uncertified",
"已通过":"Approved",
"VR展厅":"VR Showroom",
  "不觉云":"Bujue Cloud",
  "工具箱":"Toolbox",
  "查看为基础权限，如需取消查看权限，请关闭模块开关":"View is a basic permission. To remove it, please turn off the module switch",
  "近期上线":"Coming soon",
  "素材、模型可应用于创意板、画图软件等":"Materials and models can be used in mood boards, drawing software, etc.",
  "访客":"Visitor",
  "私域管理员": "Private Space Admin",
  "管理员拥有所有权限":"Admins have all permissions",
  "完成主体认证，才能解锁访客访问":"Complete entity certification to unlock visitor access",
  "审核中":"Under Review",
  "查看供应商":"View Suppliers",
  "查看联系方式":"View Contact Info",
  "查看合同":"View Contracts",
  "查看备注":"View Remarks",
  "素材应用":"Material Application",
  "导出产品二维码":"Export Product QR Code",
  "隐藏系统文件夹":"Hide System Folders",
  "价格显示":"Show Price",
  "成员": "Staff",
  "管理员":"Admin",
  "二级管理员":"Sub-admin",
  "未加入":"Not Joined",
  "申请加入":"Requested to Join",
  "申请成功": "Application submitted",
  "等待管理员审核": "Waiting for administrator review",
  "已申请": "Applied",
  "{{count}}秒后自动进入私域": "Entering the Private Space in {{count}}s",
  "进入私域": "Enter Private Space",
  "您已是该私域成员": "You are already staff of this Private Space",
  "打开APP": "Open the app",
  "我":"Me",
  "仅管理员可以操作":"Only admins can perform this action",
  "加入日期":"Join Date",
  "确定退出当前私域？": "Are you sure you want to leave this private space?",
  "同意":"Agree",
  "拒绝":"Reject",
  "加入成功":"Joined successfully",
  "无可删除的成员": "No staff available to delete",
  "操作成功":"Operation successful",
  "退出失败":"Failed to leave",
  "退出成功":"Left successfully",
  "无可操作的成员": "No staff available for this action",
  "无可操作产品":"No products available for this action",
  "刷新成功":"Refreshed successfully",
  "批量编辑":"Batch Edit",
  "编辑项目信息":"Edit project details",
  "导出":"Export",
  "导出选中项":"Export selected",
  "导出全部数据":"Export All Data",
  "确认导出当前选中的数据吗？":"Export the selected data?",
  "确认导出当前全部数据吗？":"Export all current data?",
  "确认导出当前搜索结果中的全部数据吗？":"Export all data in the current search results?",
  "创建人":"Created by",
  "创建时间":"Created",
  "更新时间":"Updated",
  "根据协议，当前项目信息将向{{team}}披露":"Under the agreement, this project's information will be disclosed to {{team}}.",
  "当前项目信息将向{{team}}披露":"Project information will be disclosed to {{team}}",
  "本私域":"this private domain",
  "添加成员": "Add Staff",
  "邀请成员": "Invite Staff",
  "使用微信、钉钉APP扫码加入":"Scan with WeChat or DingTalk to join",
  "成员加入需管理员审核": "New staff require admin approval to join",
  "批量编辑时，修改任一成员信息，会同步其他已选成员": "In batch edit mode, changing any staff's info will sync to all other selected staff",
  "批量编辑时，修改任一会员信息，会同步其他已选会员": "In batch edit mode, changing any member's info will sync to all other selected members",
  "确定要删除选中成员吗？": "Are you sure you want to delete the selected staff?",
  "确定要删除当前成员吗？": "Are you sure you want to delete this staff?",
  "角色":"Role",
  "昵称":"Nickname",
  "邀请人":"Invited by",
  "关联成员":"Assignee",
  "关联私域":"Linked Spaces",
  "注册时间":"Registered at",
  "注册来源":"Sign-up source",
  "最近访问":"Last visit",
  "会员标签":"Member tags",
  "使用中":"In Use",
  "未使用":"Unused",
  "作品分享": "{\"介绍\":\"Intro\"}",
  "产品分享": "Product Share",
  "小程序分享": "Share via mini program",
  "私域会员":"Member",
  "会员管理":"Member Management",
  "开启私域会员":"Enable Membership",
  "将私域访客高效沉淀为会员，深度洞察其来源渠道，让运营策略精准施策。":"Efficiently convert visitors into members, gain deep insight into their sign-up sources, and make your operations more targeted.",
  "开启后，您可轻松查看会员档案、来源归属，并利用标签系统实现灵活的分类与高效管理。":"Once enabled, you can easily view member profiles and sign-up sources, and use tags for flexible grouping and efficient management.",
  "立即开启":"Enable now",
  "校验中":"Checking",
  "开启私域会员管理需完成主体认证，是否前往认证？":"Business verification is required to enable member management. Go to verification now?",
  "请先开启会员管理，再开启本功能。否则会导致无法获取访客个人数据":"Please enable Member Management before enabling this feature. Otherwise, visitor personal data cannot be retrieved.",
  "查看协议":"View Agreement",
  "搜索昵称/手机号/邮箱":"Search by name, phone, or email",
  "标签管理":"Tag management",
  "获取标签失败":"Failed to get tags",
  "最多可添加1000个标签":"Up to 1000 tags can be added",
  "缺少团队信息":"Missing team info",
  "确认删除该标签吗?\n保存后将同步删除用户已绑定的标签":"Confirm deleting this tag?\nAfter saving, the tag bound to users will also be deleted",
  "完成主体认证，才能解锁私域会员": "Complete entity certification to unlock private space members",
  "开启私域会员，才能解锁会员权限": "Enable private space membership to unlock member permissions",
  "前往开启":"Go to Enable",
  "协议列表":"Agreement List",
  "协议名称":"Agreement Name",
  "协议类型":"Agreement Type",
  "协议来源":"Agreement Source",
  "协议状态":"Agreement Status",
  "私域会员协议":"Member Agreement",
  "私域隐私协议":"Member Privacy Policy",
  "私域隐私政策": "Private Space Privacy Policy",
  "《私域会员协议》":"Member Agreement",
  "《私域隐私协议》":"Member Privacy Policy",
  "《私域隐私政策》": "Private Space Privacy Policy",
  "{{privateName}}私域会员协议": "{{privateName}} Private Space Member Agreement",
  "{{privateName}}私域隐私政策": "{{privateName}} Private Space Privacy Policy",
  "用户昵称": "Display name",
  "请先阅读并同意相关协议": "Please read and agree to the agreements first",
  "请先确认并勾选协议": "Please confirm and check the agreement first",
  "关闭": "Close",
  "您将加入 [{{privateName}}] 会员，享受会员专属权益与服务。": "You're joining [{{privateName}}] as a member, with access to member-only benefits and services.",
  "加入中": "Joining",
  "加入私域会员": "Become a member",
  "加入会员": "Join",
  "该私域素材仅会员可用": "Materials from this private space are available to members only",
  "是否加入私域会员？": "Would you like to join as a private space member?",
  "仅会员可用": "Members only",
  "选择私域": "Select a private space",
  "服务到期": "Service expired",
  "违规封禁": "Banned for violation",
  "无权限查询": "No permission to query",
  "当前关注的私域暂无可用素材": "No available materials in the private spaces you follow",
  "权限状态获取失败": "Failed to load permission status",
  "已加入会员，素材权限尚未生效，请稍后重试": "Membership joined, but material access is not active yet. Please try again later",
  "已加入{{privateName}}会员": "Joined {{privateName}} as a member",
  "加入私域会员失败，请稍后重试": "Failed to join the private space membership. Please try again later",
  "加载私域会员信息失败，请稍后重试": "Failed to load private space membership information. Please try again later",
  "我已阅读并同意": "I have read and agree to ",
  "加入会员后才可继续操作": "Please join as a member to continue.",
  "会员协议":"Member Agreement",
  "系统协议":"System Agreement",
  "生效中":"Active",
  "访客在官网触发登录（关注/入库等行为）后，将自动加入私域会员。":"When a visitor triggers sign-in on the official website (e.g., by following or adding to the library), they will automatically become a member.",
  "确认协议配置，开启会员管理":"Confirm agreement settings to enable member management",
  "开启会员管理前，需先确认用户注册/登录时需同意的《私域会员协议》与《私域隐私协议》": "Before enabling member management, confirm the Private Space Member Agreement and Private Space Privacy Agreement that users must agree to when registering or logging in.",
  "官方默认":"Official default",
  "我已确认以上协议内容，用户注册时将展示并要求同意":"I have confirmed the agreements above. They will be shown to users for acceptance during sign-up.",
  "确认开启":"Enable",
  "不分组":"No Grouping",
  "审核通过":"Approved",
  "审核不通过":"Rejected",
  "主体认证{{status}},审核通过后再添加": "Entity certification {{status}}. Please add staff after approval",
  "邀请加入-不觉空间艺术馆\n{{nickName}}邀请您加入{{teamName}}，点击下方链接立即加入。\n":"Invitation to join - Bujue Space Art Gallery\n{{nickName}} invites you to join {{teamName}}. Click the link below to join now.\n",
  "邀请加入-{{teamName}}，成为内部成员。\n": "Invitation to join {{teamName}} as an internal member.",
  "私域成员超过50人，需要完成主体认证，才能继续添加": "Private space staff exceed 50. Entity certification is required to add more",
  "使用微信扫码":"Scan with WeChat",
  "已加载全部数据":"All data loaded",
  "数据加载失败":"Failed to load data",
  "网络异常，请重试":"Network error, please try again",
  "请输入内容":"Please enter content",
  "以下字段不支持排序:":"The following fields do not support sorting:",
  "以下候选值不支持排序:":"The following candidate values do not support sorting:",
  "当前候选值被引用，不可删除":"This candidate value is in use and cannot be deleted",
  "不支持输入反斜杠 {{bs}}":"Backslash {{bs}} is not allowed",
  "最多可添加{{max}}个候选值":"Up to {{max}} candidate values can be added",
  "最多可添加{{max}}个字段":"Up to {{max}} fields can be added",
  "该域名可使用!":"This domain is available",
  "该域名已使用，请重新输入！":"This domain is already in use, please enter another one",
  "私域LOGO": "Private Space Logo",
  "网址定制":"Custom URL",
  "域名不支持使用大写字母!":"The domain cannot contain uppercase letters",
  "域名不能包含汉字!":"The domain cannot contain Chinese characters",
  "域名不能包含标点符号!":"The domain cannot contain punctuation marks",
  "重名校验":"Check availability",
  "可以输入一个拼音或单词(小写)、数字，不能包含标点符号，比如“panzitech”":"Use lowercase letters and numbers only, no punctuation. Example: \"panzitech\"",
  "添加私域介绍...": "Add a private space description...",
  "{{name}}上传失败":"{{name}} upload failed",
  "{{name}}不是图片":"{{name}} is not an image",
  "主体认证审核中，暂时无法修改私域名称": "Entity certification is under review, the private space name cannot be changed temporarily",
  "修改私域名称，需要重新提交主体认证": "Changing the private space name requires resubmitting entity certification",
  "前往认证":"Go to Certification",
  "AI翻译中":"AI Translating",
  "翻译完成":"Translation complete",
  "选择套餐":"Select Package",
  "到期日期":"Expiration Date",
  "查看全部权益":"View All Benefits",
  "全部权益":"All Features",
  "云盘容量":"Cloud drive capacity",
  "已使用：{{used}}/{{total}}":"Used: {{used}}/{{total}}",
  "尊敬的用户，您的不觉云存储空间即将达到上限，为避免影响正常使用，建议您尽快进行容量升级。":"Dear user, your Bujue Cloud storage space is about to reach its limit. To avoid affecting normal use, we recommend upgrading your capacity as soon as possible.",
  "{{time}}到期":"Expires {{time}}",
  "永久免费":"Permanently Free",
  "￥{{price}}/年":"￥{{price}}CNY/year",
  "价格说明":"Price Description",
  "套餐购买或套餐续期是，原价=新套餐单价*购买时长":"When purchasing or renewing a package, original price = new package unit price × purchase duration",
  "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数":"When upgrading a package, original price = new package's original unit price × (total original package duration − gifted duration) / total original package days × remaining days",
  "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生  效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和":"Deduction only applies when upgrading a package. Deduction = active order's discounted price / active order's valid days × active order's remaining days + total paid amount of all pending renewal orders",
  "优惠码：请联系不觉客服获取优惠码":"Discount code: please contact Bujue Support to get a discount code",
  "请输入优惠码享受优惠，优惠金额=*（1-折扣）":"Enter a discount code to enjoy a discount. Discount amount = × (1 − discount rate)",
  "温馨提示：使用苹果设备购买服务，苹果公司将收取30%，建议您在不觉网站购买服务。":"Reminder: Apple charges a 30% fee for purchases made on Apple devices. We recommend purchasing on the Bujue website instead.",
  "保存二维码":"Save QR Code",
  "微信客服":"WeChat Support",
  "套餐无法降级":"The package cannot be downgraded",
  "当前套餐": "Current Plan",
  "年": "Year",
  "无需付费":"Free",
  "定制版":"Custom Edition",
  "按需定制功能和云盘容量":"Custom features and storage on demand",
  "免费咨询":"Consultation",
  "立即升级": "Upgrade",
  "赠送升级":"Complimentary Upgrade",
  "付费扩容":"Expand Capacity",
  "大文件上传":"Large File Upload",
  "批量上传文件":"Batch File Upload",
  "视频高清画质":"HD Video Quality",
  "自定义权限":"Custom Permissions",
  "你的私域已使用{{size}}容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。": "Your private space has used {{size}} of storage. Please purchase a package with higher capacity, or enter management mode to clean up unused data and try again.",
  "说明": "Notes",
  "原套餐时长：":"Original Package Duration:",
  "数量：":"Quantity:",
  "套餐时长一次最多购买3年":"You can purchase up to 3 years of package duration at a time",
  "套餐时长一次最多延长3年":"You can extend the package duration by up to 3 years at a time",
  "有效期至：":"Valid Until:",
  "(赠送{{time}}个{{unit}})":"(Gifted {{time}} {{unit}})",
  "剩余时长：":"Remaining Duration:",
  "原价：":"Original Price:",
  "抵扣：":"Deduction:",
  "优惠码：":"Discount Code:",
  "请输入优惠码":"Enter discount code",
  "已为您兑换{{discount}}折优惠码：{{code}}":"A {{discount}}% off discount code has been redeemed for you: {{code}}",
  "优惠：":"Discount:",
  "补差价：":"Price Difference:",
  "请求失败，请稍后重试":"Request failed, please try again later",
  "不觉云套餐":"Bujue Cloud Package",
  "咨询": "Contact Sales",
  "更多专属特权":"More Exclusive Privileges",
  "请输入地址":"Please enter the address",
  "请选择关联品牌":"Please select the associated brand",
  "请输入备注":"Please enter a comment",
  "供应商公司名称不能为空！":"The supplier company name cannot be empty",
  "联系人":"Contacts",
  "添加供应商":"Add supplier",
  "编辑供应商":"Edit supplier",
  "分类名不能为空":"The category name cannot be empty",
  "管理分类":"Manage categories",
  "*请指定私有分类":"*Please specify a private category",
  "确定要删除该一级分类吗?":"Are you sure you want to delete this first level classification",
  "确定要删除该二级分类吗?":"Are you sure you want to delete this secondary category",
  "确定要删除该顶级分类吗?":"Are you sure you want to delete this primary category?",
  "将同时删除下属产品":"Subordinate products will also be deleted",
  "将同时删除下属分类和产品":"Subordinate categories and products will also be deleted",
  "分类名称已存在":"The category name already exists",
  "分类名称重复":"Duplicate classification names",
  "上传图片":"Upload images",
  "上传PDF":"Upload PDF",
  "一键清空":"One click clearing",
  "页":"Pages",
  "删除分组将同时删除下属的所有品牌及对应的产品，确认删除分组吗？":"Deleting a group will also delete all subordinate brands and their corresponding products. Are you sure you want to delete the group",
  "亲爱的供应商朋友：":"Dear supplier friend:",
  "恭喜您获得":"Congratulations on receiving the invitation from the ",
  "的邀请":"",
  "，您可以在下方列表中录入产品信息并提交，":",You can enter product information in the list below and submit it, ",
  "在通过私域管理员审核后，产品将自动加入": "After being reviewed by the private space administrator, the product will be automatically added ",
  "如需详细咨询，请联系":"For detailed consultation, please contact the",
  "“不觉”":"\"Bujue\"",
  " 私域Saas工具 ": "  Private Space Saas Tool  ",
  "客服小助手微信：bujuekefu":"customer service assistant on WeChat: bujuekefu",
  "委托入库":"Request to add",
  "提交成功！可以继续添加下一个产品。":"Submitted successfully! You can continue adding the next product.",
  "好的":"OK",
  "空间不足":"Not enough space",
  "创建成功！":"Created successfully!",
  "已保存为草稿":"Saved as draft",
  "更新成功":"Updated",
  "该产品已存在，是否进行替换？":"The product already exists. Should it be replaced?",
  "添加成功":"Added successfully",
  "提交成功！可以继续添加更多产品":"Submitted successfully! You can continue to add more products",
  "数据提交截止时间：":"Data submission deadline:",
  "已选产品":"Selected products",
  "产品导入":"Product import",
  "私域": "Private space",
  "复制":"Copy",
  "添加产品":"Add Product",
  "确认删除？":"Confirm deletion?",
  "未通过":"Fail",
  "关联官方品牌":"Associate official brands",
  "自定义筛选字段":"Customize filtering fields",
  "自定义字段":"Custom Fields",
  "自定义项目字段":"Customize project fields",
  "拖拽卡片以排序":"Drag and drop cards to sort",
  "规格尺寸":"Size",
  "发布产品空间":"Publish product space",
  "异常：":"Exception:",
  "产品空间上新啦!":"New features have been added to the product space!",
  "公域产品管理上新啦!":"New features have been added to public product management!",
  "一键发布，可分享，可被关注":"One click publishing, shareable, and can be followed",
  "让设计师随时了解您 的最新产品":"Keep designers informed of your latest products at all times",
  "完成认证":"Verify",
  "批量入库":"Batch add",
  "批量删除":"Batch Delete",
  "批量修改分类":"Batch modify classification",
  "详情":"Details",
  "删除成功！":"Deleted successfully",
  "修改成功！":"Modified successfully",
  "是否确认删除？":"Are you sure you want to delete?",
  "月":"Month",
  "缺少图片，先补充一下吧！":"Missing pictures, please add them first",
  "产品图":"Product image",
  "最低参考价":"Minimum reference price",
  "最高参考价":"Highest reference price",
  "请选择分类":"Select category",
  "上传失败，请重新上传！":"Upload failed, please upload again",
  "管理品牌":"Manage brands",
  "新增供应商":"Add new supplier",
  "请选择供应商":"Select supplier",
  "确认删除?":"Confirm deletion?",
  "供应商已删除":"Supplier has been deleted",
  "*请选择品牌":"*Select brand",
  "请选择品牌":"Select brand",
  "*请选择分类":"*Select category",
  "请填写名称!":"Please fill in the name",
  "*请填写名称":"*Please fill in the name",
  "请选择属性":"Select attributes",
  "*请选择属性":"*Select attributes",
  "还未上传图片/视频":"No image/video uploaded yet",
  "请填写系列型号":"Please fill in the series model",
  "请输入供货周期":"Please enter the lead time",
  "请上传封面":"Please upload the cover",
  "最小区间周期不能为0!":"The minimum interval period cannot be 0",
  "最大区间周期不能为0!":"The maximum interval period cannot be 0",
  "区间周期不能只填一个!":"Enter both the minimum and maximum interval period",
  "最小区间周期不能大于或等于最大区间周期!":"The minimum interval period cannot be greater than or equal to the maximum interval period",
  "请输入最小区间周期":"Please enter the minimum interval period",
  "请输入最大区间周期":"Please enter the maximum interval period",
  "内容排序":"Sorted By",
  "添加照片":"Add photo",
  "选择导入内容":"Select import content",
  "添加PDF":"Add PDF",
  "导入":"Import",
  "请输入贴图分类":"Please enter the texture classification",
  "页数不能为0！":"The number of pages cannot be 0",
  "加载中":"LOADING",
  "确认删除选中图片吗":"Are you sure you want to delete the selected image",
  "移动至":"Move to",
  "移动至第":"Move to page",
  "移动":"Move",
  "导入成功！":"Import successful",
  "导入失败":"Import failed",
  "确定要删除吗？已关联产品中的对应服务会一并删除！":"Are you sure you want to delete this? The corresponding services in the associated products will be deleted together",
  "产品：":"Product:",
  "移动成功":"Moved successfully",
  "操作失败":"Operation failed",
  "修改成功":"Modified successfully",
  "重置筛选":"Reset filter",
  "精准筛选":"Advanced filter",
  "对方已解除与您的合作，点击移除":"The other party has terminated their cooperation with you. Click to remove",
  "请使用鼠标拖动":"Please drag with the mouse",
  "默认背景":"Default Background",
  "透明":"Transparent",
  "模糊":"Blur",
  "上传失败":"Upload failed",
  "更改未保存，是否保存?":"Change not saved, do you want to save?",
  "正面":"Front",
  "反面":"Back",
  "点击或拖入更换图片":"Click or drag to replace image",
  "保存成功":"Successfully saved",
  "来源":"Source",
  "委托方":"Client",
  "提交时间":"Submission time",
  "状态":"State",
  "提交人":"Submitted by",
  "确定删除":"Delete",
  "确定入库":"Add",
  "30天":"30 days",
  "新增":"Add",
  "请填写备注":"Please fill in the remarks",
  "确认清空介绍吗？":"Are you sure you want to clear the introduction?",
  "pdf还没全部加载完！":"The PDF hasn't been fully loaded yet",
  "至少保留一个产品！":"Keep at least one product",
  "保存到草稿":"Save to draft",
  "更改":"Change",
  "添加分类":"Add classification",
  "敏感词审核未通过":"Sensitive word review failed",
  "必填项未填写":"Required fields not filled in",
  "不可以移动至默认分组":"Cannot move to default group",
  "确定要删除分组吗？组内所有合作伙伴会一并删除":"Are you sure you want to delete the group? All partners within the group will be deleted together",
  "是":"Yes",
  "否":"No",
  "官网":"Official website",
  "小程序":"Mini program",
  "没有可下架的资源":"There are no resources available for removal",
  "没有可上架的资源":"There are no resources available for listing",
  "一键上架":"List",
  "一键下架":"Delist",
  "团队店铺本次提交": "items submitted",
  "团队店铺全部内容": "items in total",
  "团队店铺上架内容统计": "<total>{{totalCount}}</total> {{scope}}, <status>{{statusCount}}</status> unlisted, total content pending listing: <pending>{{statusCount}}</pending>",
  "团队店铺下架内容统计": "<total>{{totalCount}}</total> {{scope}}, <status>{{statusCount}}</status> listed, total content pending delisting: <pending>{{statusCount}}</pending>",
  "团队店铺上架成功统计": "<submit>{{submitCount}}</submit> items submitted for listing, <success>{{successCount}}</success> items successfully listed.",
  "团队店铺上架驳回统计": "<submit>{{submitCount}}</submit> items submitted for listing, <success>{{successCount}}</success> items successfully listed, <fail>{{failCount}}</fail> items automatically rejected.",
  "下架":"Delist",
  "请选择要下架的内容":"Please select the content to be taken down",
  "确认下架":"Confirm removal",
  "上架后访客可在小程序、官网查看该产品，确认上架吗？":"After listing, visitors can view this product on the mini program and website. Confirm listing?",
  "下架后访客将无法在小程序、官网查看该产品，确认下架吗？":"After removal, visitors will no longer be able to view this product on the mini program and website. Confirm removal?",
  "上架":"List",
  "请选择要上架的内容":"Please select the content to be listed",
  "确认上架":"Confirm listing",
  "批量下载中，请等待片刻":"Batch download in progress, please wait for a moment",
  "下载中":"Downloading",
  "一键操作":"Actions (all)",
  "搜索结果页暂不支持一键操作":"Bulk actions are not available on the search results page",
  "空间预览":"Space Preview",
  "请选择要导出的产品":"Please select the product to export",
  "导出二维码":"Export QR codes",
  "确认导出二维码":"Confirm exporting QR code",
  "确定要将选中的产品批量上架吗?": "Confirm batch list for selected products?",
  "确定要将选中的产品批量上架吗?\n包含被驳回产品，请填写申请上架理由": "Confirm batch list for selected products?\\nRejected products need a reason for applying to list.",
  "确定要将选中的产品批量下架吗?": "Confirm batch delist for selected products?",
  "确定要将选中的产品批量删除吗?": "Confirm batch delete for selected products?",
  "确定要将选中的产品批量入库吗?": "Are you sure you want to add the selected products to the library?",
  "已选产品容量超出剩余容量，无法入库。": "Selected product capacity exceeds remaining capacity. Cannot stock in.",
  "正在入库处理中，请等待": "Processing, please wait.",
  "部分产品已存在，是否进行替换？": "Some products already exist. Replace them?",
  "产品已存在，是否进行替换？": "The product already exists. Replace it?",
  "确定要将选中的产品导出二维码吗?": "Are you sure you want to export QR codes for the selected products?",
  "确定一键上架全部产品吗?": "Are you sure you want to list all products at once?",
  "确定一键下架全部产品吗?": "Are you sure you want to delist all products at once?",
  "确定一键入库全部产品吗?": "Are you sure you want to add all products to the library at once?",
  "确定一键删除全部产品吗?": "Are you sure you want to delete all products at once?",
  "确定要将全部产品导出二维码吗?": "Are you sure you want to export QR codes for all products?",
  "确定一键上架符合当前筛选条件的{{total}}项产品吗？": "Are you sure you want to list all {{total}} products matching the current filters?",
  "确定一键下架符合当前筛选条件的{{total}}项产品吗？": "Are you sure you want to delist all {{total}} products matching the current filters?",
  "确定一键入库符合当前筛选条件的{{total}}项产品吗？": "Are you sure you want to add all {{total}} products matching the current filters to the library?",
  "确定一键删除符合当前筛选条件的{{total}}项产品吗？": "Are you sure you want to delete all {{total}} products matching the current filters?",
  "确定要导出符合当前筛选条件的{{total}}项产品二维码吗？": "Are you sure you want to export QR codes for all {{total}} products matching the current filters?",
  "确定批量修改分类?": "Confirm batch modify category?",
  "审核异常：":"Audit exception:",
  "待审核：":"Pending review:",
  "未上架：":"Not listed:",
  "内容总数：":"Total Content:",
  "一键导出码":"One click export code",
  "没有可导出的产品":"There are no products available for export",
  "完成私域主体认证，才能继续使用空间功能": "Complete private space entity authentication before continuing to use space functions",
  "去认证":"Go authenticate",
  "上架状态":"Listing status",
  "审核异常":"Audit exception",
  "未上架":"Not listed yet",
  "待审核":"Pending approval",
  "已驳回":"Rejected",
  "审核结果":"Audit result",
  "通过":"Approve",
  "不通过":"Reject",
  "确认上架吗？将提交至不觉官方进行上架审核":"Are you sure you want to list it? It will be submitted to Bujue for listing review.",
  "取消置顶":"Unpin",
  "空间管理":"Space Management",
  "店铺信息":"Information",
  "私域名称不能为空": "The private space name cannot be empty",
  "请输入私域介绍": "Please enter your private space introduction",
  "私域介绍":"Introduction",
  "私域名称": "Private space name",
  "累计上架：":"Total listed:",
  "服务区域：":"Service Area:",
  "退出编辑":"Exit Editing",
  "退出批量编辑":"Exit Batch Editing",
  "美元":"US dollar",
  "单次最多上传20张":"Up to 20 images can be uploaded at a time",
  "敏感词审核不通过":"Sensitive word review failed",
  "请输入服务":"Please enter the service",
  "确认删除吗?":"Confirm deletion?",
  "请选择入库的数据":"Please select the data to add to the library",
  "操作成功！":"Operation successful",
  "确定要执行批量上架吗？已选 ": "Confirm batch listing? Selected ",
  " 件产品中包含 ": " products contain ",
  " 件被驳回的产品，确定要重新提交上架吗？": " rejected products. Are you sure to resubmit for listing?",
  "产品名称":"Product name",
  "请先勾选数据":"Please check the data first",
  "搜索产品":"Search product",
  "最近搜索":"Recent Searches",
  "确定要清空搜索吗?":"Are you sure you want to clear your search history?",
  "已选中当前已加载项":"The currently loaded items have been selected",
  "全部分类":"All categories",
  "尚未设置密码，请选择其他方式登录！":"Password has not been set yet, please choose another way to log in",
  "请上传PDF文档":"Please upload PDF document",
  "上传品牌介绍":"Upload brand introduction",
  "编辑内容":"Edit content",
  "编辑文字":"Edit Text",
  "团队剩余空间不足":"The team has insufficient remaining space",
  "此次待上传的图片大小超出团队剩余容量，请联系管理员购买容量或重新选择图片":"The size of the images to be uploaded exceeds the team's remaining capacity. Please contact the administrator to purchase more capacity or reselect the images.",
  "作品中存在上传中的图片，不可操作":"Some images in this work are still uploading, so this action is unavailable",
  "全部导入":"Import All",
  "确定导入该私域所有产品吗？": "Are you sure you want to import all products from this private space?",
  "添加分组":"Add Group",
  "编辑分组":"Edit Group",
  "显示锚点":"Display anchor points",
  "隐藏锚点":"Hide anchor points",
  "添加图片":"Add Pics",
  "添加文档":"Add document",
  "存在重名分类，请修改分类名称后再拖动！":"Duplicate category names. Modify the name before dragging.",
  "排序数据已过期，请刷新页面后重试":"The sorted data has expired, please try again after refreshing the page.",
  "请不要拖动到添加后面":"Please do not drag items after the Add button.",
  "确定要删除吗?已关联产品中的对应供应商会一并删除！":"Are you sure you want to delete it? The corresponding suppliers in the associated products will be deleted together",
  "/永久":"/permanent",
  "确定要删除该顶级分类及下属分类吗?":"Are you sure you want to delete this primary category and its subordinate categories?",
  "确定要删除该一级分类及下属分类吗?":"Are you sure you want to delete this secondary category and its subordinate categories?",
  "无法继续放大卡片":"Unable to continue enlarging the card",
  "无法继续缩小卡片":"Unable to continue shrinking the card",
  "登录失效！":"Session expired",
  "您可以通过以下方式便捷续费：":"You can easily renew through the following methods:",
  "1.通过Android手机APP续费":"1. Renewal through Android app",
  "2.使用电脑访问官网续费: www.bujue.art":"2. Use a computer to access the official website for renewal: www.bujue.art",
  "感谢您的支持！":"Thank you for your support!",
  "当前私域容量套餐已到期，为不影响使用，请及时续费。":"Your cloud storage package has expired. To maintain service, please renew your subscription.",
  "当前私域容量套餐已到期，为不影响使用，请联系私域管理员续费。":"Your cloud storage package has expired. To maintain service, please contact your administrator for renewal.",
  "容量到期": "Capacity expired",
  "忽略":"Ignore",
  "立即续费": "Renew",
  "去我的空间":"Go to my space",
  "。":'.',
  "官网分享":"Official Website Sharing",
  "定向分享":"Targeted Sharing",
  "没有可入库的产品！":"There are no products available to add to the library",
  "批量分类":"Batch categorize",
  "选择分类":"Select Category",
  "批量出库":"Batch remove",
  "确定出库":"Remove",
  "请输入关键词":"Please enter keywords",
  "请选择完整的三级分类":"Please select a complete three-level category",
  "请选择完整的规格":"Please select complete specifications",
  "请选择完整的SKU":"Please select a complete SKU",

  "历史搜索":"Search History",
  "其他成员正在管理筛选字段，请稍候再试。": "Other staff are managing the filter fields. Please try again later.",
  "当前有未保存的更改，是否确认关闭？":"Unsaved changes. Confirm closing?",
  "其他成员正在管理自定义字段，请稍候再试。": "Other staff are managing the custom fields. Please try again later.",
  "数据发生变化，已自动刷新。":"The data has changed and has been automatically refreshed.",
  "请输入候选值":"Please enter candidate values",
  "仅支持输入汉字、英文字母、数字及以下标点符号：- _ ， , 。' . 空格 () （）【】[]":"Only Chinese characters, letters, numbers, and the following punctuation marks are supported: - _ ， , 。' . space () （）【】[]",
  "确认删除该候选值吗？":"Confirm deletion of this candidate value?",
  "确认删除该字段吗？":"Confirm deletion of this field?",
  "确认删除该候选值吗？\n已关联产品不会同步删除,如需调整需手动修改":"Confirm deletion of this candidate value?\nAssociated products will not be deleted in sync. Please modify them manually if needed.",
  "确认删除该字段吗？\n已关联产品不会同步删除,如需调整需手动修改":"Confirm deletion of this field?\nAssociated products will not be deleted in sync. Please modify them manually if needed.",
  "确认删除该字段吗？\n后续新增/编辑表单时将不再具有该字段":"Delete this field?\nThis field will no longer appear when you add or edit forms",
  "确认删除该候选值吗？\n后续新增/编辑表单时该字段将不再具有该候选值":"Delete this candidate value?\nThis candidate value will no longer be available for the field when you add or edit forms",
  "检测到敏感词，请修改后重试":"Sensitive words detected, please modify and try again",
  "候选值不能为空":"Candidate values cannot be empty",
  "候选值不能重名":"Candidate values cannot have duplicate names",
  "候选值中文不能重名":"Candidate values cannot have duplicate names in Chinese",
  "候选值英文不能重名":"Candidate values cannot have duplicate names in English",
  "字段不能为空":"Field cannot be empty",
  "字段不能重名":"Fields cannot have duplicate names",
  "字段中文不能重名":"Fields cannot have duplicate Chinese names",
  "字段英文不能重名":"Fields cannot have duplicate names in English",
  "英文长度超出,请修改后重试":"The length of the English exceeds the limit, please modify and try again",
  "翻译长度超出,请修改后重试":"The translation exceeds the length limit, please modify and try again",
  "已经是第一个":"It's already the first one",
  "已经是最后一个":"It's already the last one",
  "请输入中文字段名称":"Please enter the Chinese field name",
  "请输入中文分类名称":"Please enter the Chinese category name",
  "请先填写中文内容":"Please fill in the Chinese content first",
  "请输入英文字段名称":"Please enter the English field name",
  "请输入{{language}}字段名称":"Please enter the {{language}} field name",
  "请输入字段名称翻译":"Please enter the field name translation",
  "请输入中文候选值":"Please enter Chinese candidate values",
  "请输入英文候选值":"Please enter English candidate values",
  "请输入{{language}}候选值":"Please enter {{language}} candidate values",
  "请输入候选值翻译":"Please enter the candidate value translation",
  "请先完成当前项的编辑。":"Complete the current item editing first.",
  "中文长度超出,请修改后重试":"The Chinese length exceeds the limit. Please modify it and try again",
  "“未分组”为系统保留选项，不支持添加。":'"Ungrouped" is a system-reserved candidate value and cannot be added.',
  "产品字段":"Product Field",
  "产品管理：通过手动和委托的方式添加产品，对未入库/已入库的产品审核后进行批量入库、修改分类的操作。":"Product Management: Add products manually or via delegation; after reviewing products that are not yet in the library or already in the library, add them to the library or change their categories in bulk.",
  "品类管理：对产品的分类、品牌、供应商信息进行统一管理。":"Catalog Management: Uniformly manage the information regarding product categories, brands and suppliers.",
  "字段管理：管理产品中的自定义字段信息，设置产品列表的筛选条件。":"Field Management：Manage custom field information of products and set filtering criteria.",
  "展示配置：控制各终端产品的平铺、分类、品牌3个列表的显示和排序，以及产品封面呈现效果":"Display Settings: Control the display and sorting of the tile, category, and brand lists for products on each client, as well as how product covers are presented.",
  "展示配置":"Display Settings",
  "公域发布：发布私域产品到公域，产品信息未通过官方审核会被驳回，重新修改后再发布。":"Release products to the public domain. If product information fails official audit, it will be rejected and must be revised before republishing.",
  "小程序-定制化配置：管理小程序的定制化内容": "Mini Program - Customized Configuration: Manage the customized content of the mini program",
  "入库审核":"Stock-In Audit",
  "产品管理":"Product Management",
  "品类管理":"Catalog Management",
  "分类管理":"Category",
  "品牌管理":"Brand",
  "供应商管理":"Supplier",
  "字段管理":"Field Management",
  "展示顺序":"Display Order",
  "公域发布":"Public Domain Release",
  "小程序-定制化配置": "Mini Program - Customized Configuration",
  "定制页面管理": "Custom Page Management",
  "一级分类主页": "Primary category Home",
  "新品页": "New Products Page",
  "分类名称": "Category Name",
  "指针页面": "Target Page",
  "请输入页面路径": "Please enter a page path",
  "新品页名称": "New Products Page Name",
  "h5地址": "H5 URL",
  "*调整该配置将直接影响小程序对应页面，请谨慎处理": "*Adjusting this configuration will directly affect the corresponding Mini Program pages. Please proceed with caution.",
  "品牌轮播图管理": "Brand Carousel Management",
  "确定要清空该品牌下所有轮播图吗？": "Are you sure you want to clear all banners for this brand?",
  "清空后数据将无法恢复，请谨慎操作": "This action cannot be undone. Please proceed with caution.",
  "确定清空": "Confirm Clear",
  "清空失败": "Failed to clear banners",
  "图片太大，请重新上传(文件最大8MB)": "Image too large, please re-upload (max 8MB)",
  "图片上传失败": "Image upload failed",
  "上传或保存失败": "Upload or save failed",
  "确定要删除该图片吗？": "Are you sure you want to delete this image?",
  "保存失败": "Save failed",
  "暂无品牌": "No brands available",
  "一次最多上传5张图片": "You can upload up to 5 images at a time",
  "请上传JPG、PNG、GIF、WebP格式的图片，推荐尺寸1650×1000px": "Please upload images in JPG, PNG, GIF, or WebP format. Recommended size: 1650×1000px",
  "已发布":"Released",
  "管理字段":"Manage fields",
  "请前往<manage>管理字段</manage>添加":"Please go to <manage>Manage fields</manage> to add options",
  "默认顺序":"Default",
  "产品备注":"Product Notes",
  "款式备注":"Style Notes",
  "新增备注":"Add Notes",
  "名称A-Z":"Name A-Z",
  "名称Z-A":"Name Z-A",
  "暂无结果":"No results",
  "暂无选项":"No options",
  "操作失败，请检查数据版本":"Operation failed, please check the data version",



  "筛选字段":"Filter Field",
  "待选项":"Options",

  "最多支持":"Supports up to",
  "个筛选字段。":" filtering fields.",
  "至少设置":"Set at least",






  //作品相关
  "添加链接":"Add link",
  "视频描述":"Video description",
  "图片描述":"Picture description",
  "请输入图片名称":"Please enter the picture name",
  "图片名称":"Picture name",
  "编辑链接":"Edit link",
  "粘贴或输入bujue.art域名的网页链接， 如：https://www.bujue.art":"Please paste or enter the web link of the bujue.art domain name, such as: https://www.bujue.art",
  "请粘贴有效链接":"Please paste a valid link",
  "文本":"Text",
  "请输入链接":"Please enter the link",
  "链接":"Link",
    "请输入有效链接":"Please enter a valid link",
  "添加宣传链接":"Add promotional link",
  "请先保存":"Please save first",
  "请先保存当前编辑内容":"Please save the current editing content first",
  "更换":"Change",
  "请输入网址":"Please enter the URL",
  "你确定要删除吗?":"Are you sure you want to delete?",
  "你确定要取消上传吗?":"Are you sure you want to cancel the upload?",
  "请输入合法的网址":"Please enter a valid URL",
  "不是图片":"Not an image",
  "在图上点击添加锚点":"Click on the image to add an anchor point",
  "拖拽锚点移动位置":"Drag the anchor point to move the position",
  "拖拽产品卡片调整顺序":"Drag the product card to adjust the order",
  "设置保密级别":"Set confidentiality level",
  "选择下级时自动选中上级":"When selecting a subordinate, the superior is automatically selected",
  "私域拥有者可见":"Visible to owner",
  "管理员可见":"Visible to administrator",
  "成员可见": "Visible to staff",
  "访客可见":"Visible to visitors",
  "请输入,限150个字":"Please enter, limited to 150 characters",
  "请选择时间":"Please select time",
  "正在翻译中":"Translation in progress",
  "一键翻译":"Translate all",
  "建筑面积":"Building area",
  "摄影版权":"Photography copyright",
  "{{name}}方":"{{name}} party",
  "请输入,限{{maxLength}}个字":"Please enter, limited to {{maxLength}} characters",
  "请填写名称":"Please fill in the name",
  "请填写时间":"Please enter a time",
  "请填写{{name}}":"Please enter {{name}}",
  "请填写{{name}}-{{language}}":"Please enter {{name}} - {{language}}",
  "请输入字段":"Please enter a field",
  "正在翻译中，请勿重复提交":"Translation in progress. Please do not submit again.",
  "关联盘八斗项目":"Link to Panbadou project",
  "项目名称":"Project name",
  "项目名称必填!":"Project name is required",
  "请填写项目名称":"Please fill in the project name",
  "项目链接":"Project link",
  "请输入正确的盘八斗项目管理链接":"Please enter the correct Panbadou project management link",
  "请粘贴盘八斗的项目链接":"Please paste the Panbadou project link",
  "请输入介绍":"Please enter an introduction",
  "请输入客户":"Please enter the customer",
  "请输入联系方式":"Please enter contact information",
  "请输入详细地址":"Please enter the detailed address",
  "创建":"Create",
  "英文字段长度有问题请修改后重试":"The length of the English field is wrong. Please modify and try again",
  "字段已存在":"The field already exists",
    "请输入其他值":"Please enter another value",
  "保密":"Confidentiality",
  "是否同步删除云盘“":"Also delete the \"",
  "”文件夹":"\" folder in the cloud drive?",
  "置顶成功":"Pinned to top",
  "取消置顶成功":"Unpinned",
  "输入字段":"Input field",
  "点击添加VR":"Click to add VR",
  "添加VR":"Add VR",
  "上传图片/视频":"Upload image / video",
  "正在上传中，请稍后":"Uploading, please wait...",
  "请勾选":"Please check",
  "修改失败":"Modification failed",
  "删除失败":"Deletion failed",
  "未改变顺序":"No change in order",
  "排序成功":"Sort successful",
  "排序失败":"Sort failed",
  "库被关闭":"The library is closed",
  "库":"Library",
  "正在获取预览图...":"Getting preview...",
  "预览图":"Preview",
  "确认解除关联？":"Are you sure you want to unlink?",
  "解除成功":"Unlink successful",
  "项目链接必填!":"Project link is required",
  "设置封面":"Set cover",
  "更改未保存，确定离开？":"Unsaved changes. Are you sure you want to leave?",
  "文件上传未完成，确定离开？":"File upload is not complete. Are you sure you want to leave?",
  "文件上传未完成，稍后再试":"File upload is not complete, please try again later",
  "容量不足":"Insufficient capacity",
  "尊敬的用户，您的不觉云存储空间不足，为避免影响正常使用，建议您尽快进行容量升级。":"Your Bujue Cloud storage space is insufficient. To avoid service disruption, we recommend upgrading your capacity soon.",
  "去扩容":"Expand capacity",
  "请输入正确的地址":"Please enter the correct address",
  "请填写中文名称":"Please fill in the Chinese name",
  "关注":"Follow",
  "请在电脑上打开链接进行批量下载":"Please open the link on the computer to download in batches",
  "查看": "View",
  "智能排序":"Smart Sort",
  "浏览量排序": "Views Sort",
  "上新": "New Arrivals",
  "以下信息仅管理员可见":"Information below is visible only to administrators",
  "列数": "Number of columns",
  '列': "Column",
  '作品视图': "Work View",
  '合集视图': "Collection View",
  '照片视图': "Photo View",
  '默认': "Default",
  "分享添加":"Added via share",
  "默认语言：":"Default language:",
  "默认语言":"Default language",
  "分享语言：":"Share language:",
  "介绍册":"Brochure",
  "作品集":"Works",
  "产品册":"Products",

  "为了最佳使用体验，单次最多可添加30个文件。": "For the best experience, you can add up to 30 files at a time.",
  "照片": "Photo",
  "排序筛选": "Sorting and filtering",
  "合集方式": "Collection method",
  "其他成员正在调整图片顺序，请稍后再试。": "Other staff are currently adjusting the order of the pictures. Please try again later.",
  "操作超时": "Operation timeout",
  "选品": "Hotspots",
  "当前候选值被作品引用，不可删除": "This candidate value is referenced by a work and cannot be deleted.",
  '其他成员更新了自定义字段，点击刷新获取最新内容再试。': 'A team member has updated the custom fields. Click "Refresh" to get the latest content and try again.',
  "刷新":"Refresh",
  "其他成员更新了自定义字段，":'A team member has updated the custom fields.',
  "点击刷新获取最新内容再试。":'Click "Refresh" to get the latest content and try again.',
  "总计": "Total",
  "作品详情": "Works Details",
  "卡片大小": "Card Size",
  "进入官网":"Enter website",

  "本次上架被自动驳回。":"This listing has been automatically rejected.",
  "上传介绍":"Upload Intro",
  "修改介绍": "Edit Intro",
  "确认要删除该品牌吗？": "Confirm deletion of this brand?",
  "删除分组后，关联的所有的品牌都清空这个分组": "Delete group: All associated brands will be removed from it.",
  "确认要删除该分组吗？": "Confirm deletion of this group?",
  "选择分组": "Select group",
  "所有款式名称": "All style names",
  "管理款式": "Manage Styles",
  "颜色": "Color",
  "尺寸": "Size",

  "点击升序":"Click to sort ascending",
  "点击降序":"Click to sort descending",
  "取消排序":"Click to cancel sorting",
  "请先完善分类信息再操作":"Complete category info first.",
  "删除分类":"Delete classification",
  "只删分类":"Delete classification only",
  "确定要删除选中的分类，并同步删除分类下的产品吗？": "Are you sure you want to delete the selected classification and the products under it?",
  "图片大小限制500kb":"Image size limit 500kb",
  "默认首个款式图为封面": "Default cover: first style image",
  "图片比例1:1": "Image Ratio 1:1",
  "分类副标题": "Category Subtitle",
  "分类主标题*": "Classification Main Title*",
  "分类标题*": "Category Title*",
  "请输入分组名称": "Enter group name",
  "更新分类": "Update Classification",
  "请填写分类": "Please fill in category",
  "请填写一级分类": "Please fill in primary category",
  "请填写二级分类": "Please fill in secondary category",
  "请先在左侧栏添加二级分类": "Please add a secondary category in the left sidebar first",
  "请先在左侧栏添加分类": "Please add a category in the left sidebar first",
  "请填写分类副标题":"Please fill in subtitle",

  // 插件/官网相关
  "资源库": "Library",
  "紫菜海洋": "Laver Ocean",
  "设计师专属的产品、艺术品数据库": "Designer's Product & Art Database",
  "工具": "Tools",
  "创意板": "Creative Board",
  "创意板项目": "Creative-Board-Project",
  "物料板后台": "Material Board admin",
  "会员项目": "Member projects",
  "成员项目": "Team member projects",
  "负责人": "Owner",
  "未指定负责人": "No owner assigned",
  "请选择项目": "Please select a project",
  "搜索项目名称/负责人": "Search project name / owner",
  "搜索项目名称/创建人": "Search project name / creator",
  "批量导出": "Batch Export",
  "批量指派": "Batch Assign",
  "指派": "Assign",
  "将": "Assign ",
  "项目指派给": " to",
  "将{{projectName}}项目指派给": "Assign {{projectName}} to",
  "将选中的{{count}}个项目指派给": "Assign the {{count}} selected projects to",
  "获取成员列表失败": "Failed to load team members",
  "指派失败": "Failed to assign project",
  "指派成功": "Project assigned",
  "确认删除该项目吗？删除后不可恢复": "Delete this project? It cannot be recovered",
  "确认删除当前选中的{{count}}个项目吗？": "Delete the {{count}} selected projects?",
  "项目类型": "Project type",
  "确认导出当前选中的{{count}}个项目的数据吗？": "Export data for the {{count}} selected projects?",
  "{{action}}功能待接口联调": "{{action}} is pending API integration",
  "会员版物料板": "Material Board (Member view)",
  "成员版物料板": "Material Board (Team member view)",
  " · 会员版": " · Member view",
  " · 成员版": " · Team member view",
  "存在需要迁移的历史项目": "Legacy projects pending migration",
  "创意板现已变更为私域级工具物料板": "Creative Board is now Material Board, a Private Space tool",
  "请为历史项目指定归属私域": "Assign your legacy projects to a Private Space",
  "项目信息将对私域可见并可使用对应私域素材": "Project information becomes visible to the Private Space, and its assets become available",
  "项目的所属权将变更为对应私域，管理员可对其进行调整与指派": "Project ownership transfers to the Private Space, and admins can adjust and assign them",
  "关注、收藏的产品素材不再可用，历史相关数据保留": "Followed and favorited product assets become unavailable, but historical data is retained",
  "迁移完成后不可修改": "Migration cannot be undone",
  "如有疑问请联系不觉客服咨询": "Contact Bujue Support if you have any questions",
  "稍后处理": "Later",
  "立即迁移": "Migrate now",
  "指定私域归属": "Assign Private Space",
  "已指定 {{assigned}}/{{total}}": "{{assigned}}/{{total}} assigned",
  "请选择私域": "请选择私域",
  "迁移指定项目": "迁移指定项目",
  "请为历史项目指定归属私域，项目信息将对私域可见并可使用对应私域素材；迁移完成后不可修改。": "Assign your legacy projects to a Private Space. Project information becomes visible to the Private Space, and its assets become available; migration cannot be undone.",
  "快速设计软硬装搭配方案，导出材料及报价清单": "Quickly design decoration schemes and export material & quotation lists.",
  "盘八斗": "Panbadou",
  "设计师的项目管理小秘书": "Designer's Project Assistant",
  "插件": "Plugins",
  "Revit插件，直接调用私域产品库的贴图和模型": "Revit Plugin: Direct access textures & models from private product library.",
  "3DSMax插件，直接调用私域产品库的贴图和模型": "3DSMax plugin: Direct access textures & models from private product library.",
  "Rhino插件，直接调用私域产品库的贴图和模型": "Rhino plugin: Direct access textures & models from private product library.",
  "SketchUp插件，直接调用私域产品库的贴图和模型": "SketchUp plugin: Direct access textures & models from private product library.",
  "不觉官方": "Bujue Official",
  "不觉官网": "Bujue Official Website",
  "了解更多关于不觉": "Learn More About Bujue",
  "不觉APP": "Bujue APP",
  "随时随地使用不觉": "Use Bujue Anytime, Anywhere",
  "操作说明": "Operation Manual",
  "新手用户操作指引": "New User Guide",
  "一键导入": "One-Click Import",
  "轻点鼠标即可从丰富的不觉产品库中选取所需的模型或材质贴图，一键添加到您的项目中。": "Simply click to select models or textures from the Bujue Product Library and add them to your project.",
  "简化工作流": "Streamline Workflow",
  "插件与Revit软件完美兼容，与不觉产品库深度集成，您可以在Revit中完成所有操作，享受无中断的工作体验。": "Fully compatible with Revit & deeply integrated with Bujue Library, enabling seamless operation and uninterrupted workflow.",
  "持续更新": "Continuous Updates",
  "我们将持续丰富不觉产品库内容，并持续迭代插件，确保您始终能够获得最前沿的设计元素和最专业的技术支持。": "Constantly enriching the Bujue Product Library and iterating plugins, delivering cutting-edge design resources and professional support.",
  "不觉 · BIM": "Bujue · BIM",
  "让每一个创意都能迅速转化为精确的数字模型": "Turn every idea into an accurate digital model instantly.",
  "立即下载": "Download Now",
  "插件与3DSMax软件完美兼容，与不觉产品库深度集成，您可以在3DSMax中完成所有操作，享受无中断的工作体验。": "Fully compatible with 3DSMax & deeply integrated with Bujue Library, enabling seamless operation and uninterrupted workflow.",
  "不觉 · 3DS Max": "Bujue · 3DS Max",
  "插件与Rhino软件完美兼容，与不觉产品库深度集成，您可以在Rhino中完成所有操作，享受无中断的工作体验。": "Fully compatible with Rhino & deeply integrated with Bujue Library, enabling seamless operation and uninterrupted workflow.",
  "不觉 · Rhino": "Bujue · Rhino",
  "插件与SketchUp软件完美兼容，与不觉产品库深度集成，您可以在SketchUp中完成所有操作，享受无中断的工作体验。": "Fully compatible with SketchUp & deeply integrated with Bujue Library, enabling seamless operation and uninterrupted workflow.",
  "不觉 · SketchUp": "Bujue · SketchUp",
  "不觉":"Bujue",
  "添加不觉客服微信，咨询开通详情":"Add Bujue Support on WeChat to consult activation details.",
  "添加不觉客服微信":"Add Bujue Support on WeChat",
  "填写产品信息":"Enter Product Info",
  "上传产品介绍":"Upload Product Intro",
  "上传产品附件":"Upload Attachment",
  "产品封面":"Product Cover",
  "官方字段":"Standard Fields",
  "产品类别":"Product category",
  "物流发货":"With Express",
  "无需物流":"No Express",
  "送样服务":"Sample Service",
  "提供样品赠送服务，便于用户在正式购买前确认材质、颜色、尺寸等产品细节。":"Free sample service available to confirm product details before purchase.",
  "每个产品字段可以下拉多选，所选内容展示于产品详情页，可用于产品列表筛选。":"Each product field supports dropdown multi-selection. Selected options are displayed on the product detail page and can be used for filtering in the product list.",
  "更多属性":"More Attributes",
  "翻译中...": "Translating...",
  "翻译中⋯": "Translating⋯",
  "每个产品支持添加最多 5 个属性字段，编辑纯文本内容，字段内容展示于产品详情页，不支持筛选。":"Each product supports adding a maximum of 5 attribute fields. Only plain text content is editable. The field content is displayed on the product detail page and is not available for filtering.",
  "添加属性":"Add Attr",
  "最多添加5个属性":"Max 5 attributes allowed",
  "推荐":"Recommended",
  "规格信息":"Spec Info",
  "产品规格":"Product Spec",
  "请填写产品规格":"Please enter product spec",
  "添加产品规格":"Add Spec",
  "系统规格":"System Specs",
  "管理系统规格":"Manage Spec Fields",
  "其他成员正在管理系统规格字段，请稍候再试。": "Another staff is managing the system spec fields. Please try again later.",
  "请前往<manage>管理系统规格</manage>添加":"Please go to <manage>System specs</manage> to add options",
  "暂无可用规格，请前往产品信息添加":"No available specs. Please add them in Product Info.",
  "规格名":"Spec",
  "规格名已存在，请重新输入":"Spec name already exists. Please enter again.",
  "支持手动输入创建新规格名/值，鼠标点击或回车均可添加，规格名称不超过6个字符，规格值不超过50个字符":"Manually enter spec name/value. Click Enter to add. Spec name: max 6 characters, spec value: max 50 characters.",
  "规格值":"Value",
  "规格值已存在，请重新输入":"Value name already exists. Please enter again.",
  "规格名翻译不能为空":"Spec name translation cannot be empty",
  "规格值翻译不能为空":"Spec value translation cannot be empty",
  "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png/webp":"Cover image: 1:1 aspect ratio, < 500KB, JPG/PNG/Webp",
  "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png":"Cover image: 1:1 aspect ratio, < 500KB, JPG/PNG",
  "规格明细表":"Spec Detail",
  "批量设置":"Batch Setting",
  "选择规格":"Select Specs",
  "填写内容":"Fill Content",
  "填写":"Fill",
  "填写面价":"Enter list price",
  "填写底价":"Enter base price",
  "填写包装体积（m³）":"Enter volume (m³)",
  "填写重量（kg）":"Enter weight (kg)",
  "填写更多属性":"Enter more attributes",
  "库存预警":"Inv Alert",
  "体积":"Volume",
  "重量":"Weight",
  "更多图片":"Pics",
  "最多上传3张":"Max 3 images only",
  "产品规格启用：开启后，产品详情页可选择该规格；关闭后将无法选择。":"Product Specification Enable: When enabled, this specification can be selected on the product details page; when disabled, it will be unavailable.",
  "确认禁用该规格吗？产品详情页将无法选择该规格":"Confirm to disable this specification? It will not be selectable on the product detail page.",
  "库存总和":"Total Inv",
  "每个规格的库存之和":"Total of each specification in stock",
  "*面价":"*List Price",
  "底价":"Base Price",
  "库存":"Stock",
  "包装体积（m³）":"Volume(m³)",
  "重量（kg）":"Weight(kg)",
  "面价":"List Price",
  "产品提交":"Product Submission",
  "请先完善必填信息":"Complete required info first.",
  "最多添加5个规格！":"Max 5 specs allowed",
  "最多添加100个规格值！":"Max 100 values allowed",
  "请先完成上一个规格或规格值的填写":"Complete the previous spec or spec value first.",
  "单个产品规格组合数量不能超过1000个":"A single product cannot have more than 1000 spec combinations.",
  "请至少选择一个规格值":"Please select at least one spec value.",
  "请至少添加一个规格":"Please add at least one spec.",
  "底价不能高于面价":"Base Price should be lower than List Price.",
  "图片不能超过20张":"Max 20 images only",
  "提示：请为每种语言单独上传介绍内容，避免切换语言后出现内容空缺":"Tip: Please upload intro content for each language separately to avoid content gaps when switching languages.",
  "文件：":"Files:",
  "添加文件 支持PDF/PPT/WORD/EXCEL/压缩包等格式":"Add files. Supports PDF, PPT, Word, Excel, archives and more",
  "添加文件":"Add Files",
  "支持PDF/PPT/WORD/EXCEL/压缩包等格式":"Supports PDF, PPT, Word, Excel, archives and more",
  "模型：":"Model:",
  "添加模型 支持CAD/SU/3dsMax/Revit格式":"Add Models Support CAD/SU/3dsMax/Revit",
  "添加模型":"Add Models",
  "支持CAD/SU/3dsMax/Revit格式":"Support CAD/SU/3dsMax/Revit",
  "文件格式不支持":"File format not supported",
  "贴图：":"Texture:",
  "查看底价":"View base price",
  "暂无文件":"No files yet",
  "暂无案例":"No cases yet",
  "暂无贴图":"No textures yet",
  "收藏":"Favorite",
  "取消收藏":"Unfavorite",
  "已收藏":"Favorited",
  "已添加收藏":"Favorited",
  "已取消收藏":"Unfavorited",
  "登录已过期，请重新登录":"Login session expired. Please log in again.",
  "其他文件":"Other Files",
  "暂无模型":"No models yet",
  "文件":"Files",

  // 产品列表 - 查漏补缺
  "规格字段":"Spec Field",
  "关联规格字段":"Associate Spec Field",
  "批量关联":"Batch Associate",
  "添加规格":"Add Spec",
  "请选择关联规格字段":"Please select spec field",
  "关联规格字段与产品分类后，该分类下的产品筛选条件将自动增加对应规格。":"After associating spec fields with product categories, the filter conditions for products under that category will automatically include the corresponding specs.",
  "请先选择分类":"Please select a category first",
  "商家后台":"Merchant Backend",
  "实际销量":"Actual Sales",
  "实物":"Physical",
  "虚拟":"Virtual",
  "配送方式":"Delivery Type",
  "快递配送":"Express Delivery",
  "无需快递":"No Express",
  "入库状态":"Stock Status",
  "入库状态的产品，成员可以在APP、Web工作台查看，访客不能查看": "Instock status products are visible to staff in the APP and Web Workbench, but not accessible to visitors.",
  "上架状态的产品，成员和访客在小程序、官网可以查看": "Listed products are visible to both staff and visitors on the Mini Program and Official Website.",
  "申请上架":"Apply to List",
  "其他成员正在编辑该产品，请稍候再试。": "Another staff is editing this product. Please try again later.",
  "复制成功!":"Copied successfully",
  "删除成功!":"Deleted successfully",
  "上架成功！":"Published successfully",
  "上架成功":"Published successfully",
  "已提交审核":"Submitted for review",
  "已下架":"Delisted",
  "下架成功！":"Delisted successfully",
  "申请上架成功！":"Listing application submitted successfully",
  "下架理由":"Delisting reason",
  "下架时间":"Delisting time",
  "申请理由":"Reason for request",
  "请填写申请理由":"Enter a reason for your request",
  "提交申请":"Submit request",
  "批量操作":"Actions (selected)",
  "退出批量操作":"Exit Batch Mode",
  "批量上架":"Batch List",
  "批量下架":"Batch Delist",
  "一键入库":"Quick Stock In",
  "一键删除":"Delete",
  "最低价":"Min Price",
  "最高价":"Max Price",
  "模型":"Models",
  "价格":"Price",

  "有贴图":"Has Texture",
  "无贴图":"No Texture",
  "被驳回":"Rejected",
  "条每页":"/ page",
  "条/页":"/ page",
  "跳至":"Jump to",
  "第":"",
  "条/共":"of",

  "请先前往私域设置，开启访客查看产品权限。": "Please go to Private Space Settings first to enable visitor product view permission.",
  "跳转": "Go",
  "有": "Yes",
  "基本": "Basic",
  "新增属性": "Add Attr",
  "选择款式": "Select Style",
  "起": "From",
  "本地上传":"Upload",
  "关联贴图":"Link texture",
  "请填写":"Please Enter",
  "点击添加":"Click to add",
  "请先完成上一个规格值的填写":"Complete the previous spec value first.",
  "建议图片大小不超过500KB":"Recommended image size: 500KB or less.",
  "产品贴图文件夹不存在":"Product texture folder does not exist.",
  "云存储空间不足":"Insufficient cloud storage space.",
  "产品图片文件夹不存在":"Product image folder does not exist.",
  "请等待当前图片上传完成":"Please wait for the current image upload to finish.",
  "查看更多":"More",
  "其他规格同步删除":"Synchronize deletion of other specs",
  "压缩包":"Archives",
  "确认删除该附件吗？":"Confirm deletion of this attachment?",
  "文件最多上传50个":"Max 50 files allowed",
  "模型最多上传50个":"Max 50 models allowed",
  "贴图最多上传1000个":"Max 1000 textures allowed",
  "入库时间-正序":"Storage Time (ASC)",
  "入库时间-倒序":"Storage Time (DESC)",
  "上架时间-正序":"Listing Time (ASC)",
  "上架时间-倒序":"Listing Time (DESC)",
  "名称 A→Z":"Name A→Z",
  "名称 Z→A":"Name Z→A",
  "请至少保留一个生效规格！":"Please retain at least one active spec",

  // 批量下载弹窗(cloud_disk/components/batch_download_modal)
  "下载文件":"Download Files",
  "下载任务正在启动中请稍后尝试":"The download task is starting, please try again later",
  "正在启动不觉云下载器，请稍候。":"Starting Bujue Cloud Downloader, please wait.",
  // 这2条拼成一句「未安装…请点击[下载]，…」，中间夹着可点击的「下载」，
  // 所以首尾的空格写在词条里(中文值同理),JSX 里不额外加空格
  "您暂未安装不觉云下载器，请点击":"Bujue Cloud Downloader is not installed yet. Please click ",
  "，完成安装后点击重试即可开始下载。":" and click Retry after installation to start downloading.",
  "请使用Windows或苹果电脑进行批量下载":"Please use a Windows or Mac computer for batch download",
  "启用{language}": "Enabling {{language}}",
  "系统将自动翻译现有数据,翻译期间请勿改动数据": "Existing data will be translated automatically. Please do not modify your data until translation is complete.",
  "将为您的私域开启多语言-{language}": "Enable multi-language for your Private Space - {{language}}",
  "系统将自动翻译现有数据，请勿操作任何私域数据以免引发翻译问题": "The system will automatically translate existing data. Please do not modify any Private Space data to avoid translation issues.",
  "排队中...": "In queue...",
  "排队中⋯": "In queue⋯",
  "简体中文": "Simplified Chinese",
  "拖动卡片调整顺序；默认使用首个开启的语言。": "Drag cards to reorder. The first enabled language is used by default.",
  "私域容量使用情况": "Private Space Storage",
  "查看权益": "View Plan Features",
  "免费": "Free",
  "/年": "/year",
  "当前生效": "Active",
  "核心基础服务": "Core Services",
  "补差价升级": "Upgrade",
  "暂不支持降级": "Downgrade not supported",
  "到期日期：": "Expiration date:",
  "到期时间：": "Expires at:",
  "确定订单": "Order Summary",
  "当前套餐剩余时长": "Remaining on Current Plan",
  "升级套餐": "Upgrade Plan",
  "购买时长": "Subscription Term",
  "有效期至": "Valid Until",
  "原价": "Original Price",
  "抵扣": "Credit Applied",
  "优惠码": "Promo Code",
  "优惠": "Discount",
  "支付方式": "Payment Method",
  "支付宝": "Alipay",
  "合计": "Total",
  "立即订阅": "Subscribe",
  "优惠金额": "Discount Amount",
  "容量不足，请及时升级套餐": "Capacity is running low. Please upgrade your plan.",
  "容量已满，请及时升级套餐": "Capacity limit reached. Please upgrade your plan.",
  "原套餐已到期，部分功能不再可用，请及时续费": "Your previous plan has expired and some features are no longer available. Please renew your plan.",
  "不觉-套餐订阅": "Bujue - Plan Subscription",
  "不觉·套餐订阅": "Bujue · Plan Subscription",
  "* 更多权益需求&定制服务请联系客服": "* For Additional Benefits or Custom Services, Please Contact Customer Support",
  "你的私域已使用 {私域已用容量} 容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。": "Your private space has used {私域已用容量} of storage. Please purchase a higher-capacity plan, or switch to management mode to remove unused data and try again.",
  "/页": "/page",
  "跳至 {页码} 页": "Go to Page {{pageNum}}",
  "当前私域套餐容量不足": "The current private space plan has insufficient capacity.",
  "为不影响使用，请及时处理": "To avoid service disruption, please take action promptly.",
  "为不影响使用，请联系私域管理员处理": "To avoid service disruption, please contact your private space administrator for assistance.",
  "当前私域套餐容量不足，为不影响使用，请及时处理": "The current private space plan has insufficient capacity. To avoid service disruption, please take action promptly.",
  "当前私域套餐容量不足，为不影响使用，请联系私域管理员处理": "The current private space plan has insufficient capacity. To avoid service disruption, please contact your private space administrator for assistance.",
  "立即续费/升级": "Renew / Upgrade",
  "暂不支持降级套餐": "Plan downgrades are not currently supported",
  "套餐购买或套餐续期时，原价=新套餐单价*购买时长.": "When purchasing or renewing a plan, the original price = new plan unit price × subscription term.",
  "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数.": "When upgrading a plan, the original price = new plan original unit price × (original plan total term - gifted term) / original plan total days × remaining days.",
  "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和.": "Credits apply only to plan upgrades. Credit amount = active order discounted price / active order valid days × active order remaining days + total amount paid for all pending renewal orders.",
  "套餐新购买或续费时：优惠金额 = 原价 * (1 - 折扣)": "For a new purchase or renewal: discount amount = original price × (1 - discount rate)",
  "升级套餐时：优惠金额 = (原价 - 抵扣) * (1 - 折扣)": "When upgrading a plan: discount amount = (original price - credit) × (1 - discount rate)",
  "你的私域已使用 {cloudStorage} 容量，请购买更高容量套餐，\n或进入管理模式清理无用数据后再试": "Your private space is using {{cloudStorage}} of storage. Please purchase a higher-capacity plan,\\nor enter management mode to remove unused data and try again.",
  "请输入6位优惠码": "Please enter a 6-digit promo code",
  "输入优惠码": "Enter Promo Code",
  "请输入有效优惠码": "Please enter a valid promo code",
  "优惠码：请联系不觉客服获取优惠码.": "Promo code: Please contact Bujue Customer Support to obtain a promo code.",
  "请输入优惠码享受优惠:": "Enter a promo code to apply:",
  "立即扩容": "Expand Capacity Now",
  "立即购买": "Buy Now",
  // Cloud disk
  "文件名": "File name",
  "目标文件夹中的文件": "Files in destination folder",
  "正在上传的文件": "File being uploaded",
  "保留两者": "Keep both",
  "覆盖": "Replace",
  "已有的文件": "Existing files",
  "文件信息": "File information",
  "文件路径": "File path",
  "上传文件": "Upload file",
  "上传文件夹": "Upload folder",
  "未命名文件夹": "Unnamed folder",
  "创建文件夹": "Create folder",
  "重命名": "Rename",
  "产品素材库只能上传图片！": "Only images can be uploaded to the product asset library",
  "云盘容量耗尽": "Cloud drive is full",
  "云盘容量不足": "Not enough cloud drive space",
  "部分文件超出云盘容量": "Some files exceed the available cloud drive space",
  "上传列表": "Upload list",
  "没有上传任务": "No upload tasks",
  "上传中": "Uploading",
  "已完成": "Completed",
  "暂无上传任务": "No upload tasks",
  "上传成功": "Uploaded successfully",
  "文件夹名不能为空": "Folder name is required",
  "文件名不能为空": "File name is required",
  "文件名不能包含以下字符:": "File names cannot contain the following characters:",
  "当前文件夹名字已存在": "A folder with this name already exists",
  "当前文件名已存在": "A file with this name already exists",
  "重命名成功": "Renamed",
  "重命名失败": "Rename failed",
  "当前文件暂不支持在线预览": "Online preview is not supported for this file.",
  "当前文件暂不支持在线预览,是否下载查看": "This file cannot be previewed online. Download it to view?",
  "贴图库文件夹不能向内外移动！": "Texture library folders cannot be moved in or out",
  "文件只能移动到产品素材库文件夹里！": "Files can only be moved into the product asset library folder",
  "贴图库文件夹不能向外移动！": "Texture library folders cannot be moved out",
  "非贴图库文件夹不能向内移动！": "Folders other than texture library folders cannot be moved in",
  "移动失败": "Move failed",
  "文件重名": "Duplicate name",
  "文件重复": "Duplicate files",
  "以下文件重名，请选择操作。选择保留两者时，正在上传的文件将被自动重命名；选择覆盖时，目标文件夹中的文件将被正在上传的文件覆盖。": "The following files have the same name. Choose an action: Keep both renames the file being uploaded; Replace overwrites the file in the target folder with the file being uploaded.",
  "以下文件和正在上传的文件重复，请确认是否继续上传？确认继续上传，如果存在文件重名，正在上传的文件将会被自动重命名。": "The following files duplicate the files being uploaded. Continue uploading? If you continue and a name conflict occurs, the file being uploaded is renamed automatically.",
  "（仅管理员可见）": "(Admin only)",
  "（系统）": "(System)",
  "无法移动至产品素材库外": "Cannot move outside the product asset library",
  "无法移动至产品素材库文件夹": "Cannot move to the product asset library folder",
  "无法移动至{{name}}文件夹": "Cannot move to the {{name}} folder",
  "{{name}}库不能重命名、移动和删除，不能添加文件/文件夹": "The {{name}} library cannot be renamed, moved, or deleted, and no files or folders can be added to it",
  "{{name}}不能重命名、移动和删除": "{{name}} cannot be renamed, moved, or deleted",
  "确认要删除吗？该图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。": "Delete this image? It is linked to a product. To delete it permanently, go to the linked product and remove or replace the image.",
  "确认要删除吗？已选图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。": "Delete the selected images? They are linked to products. To delete them permanently, go to the linked products and remove or replace the images.",
  "共{{count}}项": "{{count}} items in total",
  "管理当前文件夹中的文件，不会影响关联{{name}}的展示图片": "Manage files in this folder. Display images linked to {{name}} are not affected.",
  "管理当前文件夹中的文件，不会影响关联{{name}}的获奖证书": "Manage files in this folder. Award certificates linked to {{name}} are not affected.",
  "{{count}}个任务上传完成": "{{count}} uploads completed",
  "{{count}}个任务正在上传": "{{count}} uploads in progress",
  // User space tabs
  "私域列表": "Private Space list",
  "私域数据": "Private Space data",
  "内容清单": "Content list",
  "数据总览": "Data overview",
  "数据明细": "Data details",
  "作品分享类型": "Work sharing",
  "全部内容": "All content",
  "上新{{count}}个!": "{{count}} new!",
  "上架：": "Listed:",
  "内容": "Content",
  "内容未开放": "Not available",
  "产品分享": "Shared product",
  "产品已被下架": "This product has been unpublished",
  "产品数量": "Product count",
  "仅作品分享、产品分享统计时长，每隔15分钟刷新数据": "Dwell time is tracked only for work shares and product shares; data refreshes every 15 minutes.",
  "介绍分享": "Introduction sharing",
  "停留时长统计": "Dwell time statistics",
  "停留时长": "Time spent",
  "停留时长(累计)": "Time spent (total)",
  "每日时长": "Daily time spent",
  "升序": "Ascending",
  "降序": "Descending",
  "分享标题": "Share title",
  "分享次数": "Number of shares",
  "分享类型": "Share type",
  "分享记录": "Shares",
  "分享链接": "Share link",
  "区域：": "Region:",
  "单价": "Unit price",
  "单价不能小于1": "The unit price cannot be less than 1",
  "咨询对象": "Inquiry recipient",
  "型号": "Model",
  "处理中": "Processing",
  "正在处理...": "Processing...",
  "官方模板": "Official template",
  "小程序空间分享": "Mini Program space sharing",
  "已回复": "Replied",
  "已处理": "Processed",
  "已忽略": "Ignored",
  "待处理": "Pending",
  "报价单": "Quotation",
  "按私域": "By space",
  "描述": "Description",
  "搜索关键字": "Search keywords",
  "数量": "Quantity",
  "时长": "Duration",
  "暂无数据！": "No data",
  "暂无联系方式！": "No contact information available",
  "暂无规格": "No specifications yet",
  "材料名称": "Material name",
  "查看次数": "Views",
  "查看次数统计": "View count statistics",
  "标题": "Title",
  "正常": "Active",
  "生成报价单": "Generate quotation",
  "生成": "Generate",
  "导出成功！": "Exported",
  "确认要删除这条记录吗？": "Are you sure you want to delete this record?",
  "私域已停用": "Space disabled",
  "取消关注": "Unfollow",
  "置顶成功！": "Pinned",
  "进入": "Enter",
  "空间分享": "Space sharing",
  "置顶卡片": "Pinned card",
  "至少选择一个": "Choose at least one",
  "设计风格": "Design style",
  "设计类型": "Design type",
  "请填写单价": "Enter unit price",
  "请填写型号": "Enter model",
  "请填写数量": "Enter quantity",
  "请填写规格": "Enter specifications",
  "请完善材料的合计价格": "Enter the total price of the materials",
  "折扣不能超过1": "Discount cannot exceed 1",
  "折扣要大于0": "Discount must exceed 0",
  "请选择单位": "Select unit",
  "请选择成员！": "Select staff",
  "暂无可转单的成员！": "No staff available to reassign to",
  "请选择规格": "Select specifications",
  "转单成功！": "Transferred",
  "选择模板": "Select template",
  "阅读次数": "Reads",
  "限制次数": "Usage limit",
  "收件箱": "Inbox",
  "发件箱": "Outbox",
  "下载报价单": "Download quotation",
  "保存草稿": "Save draft",
  "共{{count}}条": "Total {{count}} items",
  "已收藏（{{count}}）": "Favorited ({{count}})",
  "设置折扣：": "Set discount:",
  "材料数：": "Number of materials:",
  "总价：": "Total price:",
  "折扣价：": "Discounted price:",
  "请联系客服": "Contact support",
  "定制模板": "Custom template",
  "定制": "Custom",
  "分": "min",
  "秒": "sec",
  "小时": "hr",
  "手机：": "Mobile",
  "邮箱：": "Email:",
  "提交人：": "Submitted by:",
  "提交时间：": "Submitted at:",
  "其他联系方式：": "Other contact:",
  "该": "This",
  "生成报价": "Generate quotation",
  "查看报价": "View quotation",
  "转单": "Reassign",
  "恢复": "Restore",
  "请选择处理的成员": "Select staff to handle it",
  "小计：": "Subtotal:",
  // WEB+H5 新增文案（2026-09-07）
  "私域会员（{数量}）": "Member({数量})",
  "作品类型偏好Top5": "Top 5 project types",
  "内容浏览：{数量}": "Content views: {数量}",
  "产品收藏：{数量}": "Product favorites: {数量}",
  "{数量}条/页": "{数量} per page",
  "登录不觉账号并加入  {teamName} 会员，享受会员专属权益与服务。": "Sign in to your Bujue account and join  {teamName}to access member-only benefits and services.",
  "{次数}次": "{次数} times",
  "{分钟}分{秒}秒": "{分钟}m {秒}s",
  "{秒}秒": "{秒}s",
  "开启私域会员管理": "Enable member management",
  "内容偏好": "Content preferences",
  "会员昵称": "Member name",
  "会员状态": "Member status",
  "用户信息": "Member info",
  "用户画像": "Member insights",
  "互动记录": "Activity history",
  "已离职": "Departed",
  "近7天": "Last 7 days",
  "近30天": "Last 30 days",
  "累计访问次数": "Total visits",
  "平均停留时长": "Average time spent",
  "浏览作品数": "Works viewed",
  "浏览产品数": "Products viewed",
  "分享产品数": "Products shared",
  "内容浏览": "Content views",
  "最近浏览日期": "Last viewed",
  "介绍页": "About page",
  "选品官": "Product curator",
  "主动注册": "Direct sign-up",
  "请输入标签名称": "The label name cannot be empty",
  "该标签已存在，请换一个名称": "This tag already exists. Please use a different name.",
  "标签存在问题，请修改后再保存": "There is an issue with the tag. Please fix it before saving.",
  "批量编辑时，修改任一会员信息将同步至其他已选会员": "When batch editing, changes to any member’s information will be applied to the other selected members.",
  "登录/注册不觉账号": "Sign in or sign up for a Bujue account",
  "请输入手机号或邮箱": "Please enter your phone number or email address.",
  "注册不觉账号并加入 {teamName} 会员，享受会员专属权益与服务": "Create a Bujue account and join {teamName}to access exclusive member benefits and services.",
  "请先开启私域会员，再开启本功能。否则会导致无法获取访客个人数据。": "Please enable Member Management before enabling this feature. Otherwise, visitor personal data cannot be accessed.",
  "已选中：{{count}}": "Selected: {{count}}",
  "已同步更新 {{count}} 位会员的 {{fieldName}}": "Updated {{fieldName}} for {{count}} members",
  "开启会员管理前，需先确认用户注册 / 登录时需同意的《私域会员协议》与《私域隐私协议》": "Before enabling member management, please confirm the Member Agreement and Privacy Policy that users must agree to when registering or signing in.",
  "暂无会员数据": "No member data yet",
  "查看次数": "Views",
  "圈子私域": "Circle Space",
  "我已阅读并同意《私域会员协议》《私域隐私政策》": "I have read and agree to the Member Agreement and Privacy Policy.",
  "请阅读并勾选同意协议和隐私政策": "Please read and agree to the Member Agreement and Privacy Policy.",
  "浏览收藏": "Views & favorites",
  "内容名称": "Content name",
  "收藏时间": "Favorited at",
  "收藏产品数": "Products favorited",
  "产品收藏": "Product favorites",
  "产品分类偏好Top5": "Top 5 product categories",
  "登录成功": "Signed in successfully",
  // 创建私域引导页文案
  "私域是指个人或团队通过不觉建立的数据信息库，可广泛应用于品牌展示、销售转化及精准营销等场景。": "Private Space refers to a data and information library built by an individual or team on Bujue, and it can be widely used for brand showcasing, sales conversion, precision marketing and similar scenarios.",
  "私域logo": "Space logo",
  "创建私域空间，可以自动保存您添加的产品数据": "Create a Private Space to automatically save the product data you add",
  "名称不能为纯数字": "Name cannot contain only numbers",
  "专属产品库": "Exclusive product library",
  "创建私域，即可将产品入库至个人或团队产品库，集中管理更高效": "Create a Private Space and add products to your personal or team product library for more efficient centralized management.",
  "创意板工具": "Creative board tool",
  "直接调用产品及贴图，一键生成产品清单或白皮书，轻松展示方案": "Pull in products and textures directly, generate a product list or white paper with one click, and present your proposal with ease.",
  "插件工具库": "Plug-in tool library",
  "联动 Revit、3DMax、Rhino、SketchUp 等设计软件，随时调用产品模型与贴图，提升设计效率": "Works with Revit, 3DMax, Rhino, SketchUp and other design software, so you can pull in product models and textures at any time and improve design efficiency.",
  "支持产品一键上架至公域（紫菜海洋），拓展产品曝光": "Publish products to the public marketplace (Zicai Ocean) with one click to expand exposure.",
  "名称不能超过40个字": "The name cannot exceed 40 characters",
  "私域名称包含敏感词汇": "The Private Space name contains sensitive words",
  "请输入 私域名称": "Please enter the private space name",
  "我已阅读并同意协议": "I have read and agree to the agreement",
  "《不觉私域服务协议》": "Bujue Private Space Terms of Service",
  "查看第{{index}}项": "View item {{index}}",
  // 私域语言开通提示
  "配置说明": "Setup guide",
  "语言": "Language",
  "前往设置": "Go to settings",
  "暂不设置": "Set up later",
  "1.介绍在不同语言下，都是同一套配置": "1. The introduction uses the same content across all languages.",
  "2.作品图片、视频、链接上传一次，文本需要按照语言包配置多套": "2. Portfolio images, videos, and links are uploaded once; text must be configured separately for each language pack.",
  "3.产品图片、视频、介绍、附件上传一次，文本需要按照语言包配置多套": "3. Product images, videos, descriptions, and attachments are uploaded once; text must be configured separately for each language pack.",
  "4、合作的邀请链接只需要分享一次，分组名称需要按照语言包配置": "4. The collaboration invitation link only needs to be shared once; group names must be configured for each language pack.",
  "{{teamName}}已成功开通{{langNames}}语言包": "{{langNames}} language packs have been activated for {{teamName}}.",
  "请前往设置基础信息": "Go to Basic info settings.",
  // —— 团队首页封面效果配置弹窗（2026-09-18）——
  "封面效果": "Cover Effect",
  "封面预览": "Cover preview",
  "封面模糊背景": "Blurred cover background",
  "图片裁剪：": "Image Crop:",
  "长边撑满": "Fit to long edge",
  "短边撑满": "Fill to short edge",
  "背景效果：": "Background:",
  "白色背景": "White",
  "灰色背景": "Gray",
  "模糊背景": "Blurred",
  "封面配置查询失败": "Failed to load cover settings",
  // —— Product recommendation modal (recommend settings / new product settings) 2026-10-14 ——
  "产品推荐管理": "Product recommendation management",
  "推荐设置": "Recommendation settings",
  "新品设置": "New product settings",
  "新品": "New",
  "可选产品": "Available products",
  "全部删除": "Delete all",
  "已添加": "Added",
  "最多可设置{{maxCount}}个": "You can set up to {{maxCount}} items",
  '在"{分类名称}"中搜索': 'Search in "{分类名称}"',
  "推荐排序": "Recommended Sort",
  "浏览量排序": "Views Sort",
  "上新": "New Arrivals",
  "上市时间：": "Launch date:",
  "上市时间": "Launch date",
  "已下架": "Unpublished",
  "其他成员正在编辑，请稍候再试。": "Another member is editing. Please try again later.",
  "仅已上架产品可设为推荐，拖动右侧产品可调整展示顺序。": "Only listed products can be recommended. Drag the products on the right to adjust the display order.",
  "仅已上架产品可设为新品，拖动右侧产品可调整展示顺序。": "Only listed products can be set as new products. Drag the products on the right to adjust the display order.",
  "产品附件": "Product attachment",

  "个人名片：": "Business card:",
  "封面图不可取消勾选": "The cover image cannot be deselected",
  "请输入有效手机号码": "Please enter a valid phone number",
  "请输入正确的手机号或邮箱账号": "Please enter a valid phone number or email address",
  "验证码不能为空": "The verification code cannot be empty",
  "密码不能为空": "The password cannot be empty",
  "验证码错误": "Verification code error",
  "密码错误": "Password error",
  "请确认您的密码": "Please confirm your password",
  "您输入的两个密码不匹配": "The two passwords you entered do not match",
  "最低参考价不能大于或等于最高参考价": "The minimum reference price cannot be greater than or equal to the maximum reference price",
  "标签不能重名": "Tags cannot have duplicate names",
  "最多可选5个标签": "You can select up to 5 tags",
  "确定要删除吗?已关联产品中的对应标签会一并删除": "Are you sure you want to delete? The corresponding tags in the associated products will also be deleted",
  "私域类型不能为空": "Private space type cannot be empty",
  "请输入优惠码享受优惠，优惠金额=原价*（1-折扣）": "Enter a discount code to enjoy a discount. Discount amount = × (1 − discount rate)",
  "私域Saas工具": "Private Space SaaS Tool",
  "件被驳回的产品，确定要重新提交上架吗？": "rejected products. Are you sure you want to resubmit for listing?",
  "确定要执行批量上架吗？已选": "Confirm batch listing? Selected",
  "件产品中包含": "products contain",

  "select_product_origin": "Select product origin",
  "province_city": "Province/City",
  "select_province_city": "Select province/city",
  "supplier_name_is_required": "Supplier name is required",
  "enter_supplier_name": "Enter supplier name",
  "supplier_avatar_is_required": "Supplier avatar is required",
  "select_date": "Select date",
  "terms_updated": "Terms updated",
  "in_my_space_you_can_view_your_share_history_follows_and_private_space": "In My Space, you can view your share history, follows, and Private Space.",
  "the_platform_has_given_you_a_free_three_month_membership": "The platform has given you a free three-month membership",
  "free_gift": "Free gift",
  "three_month_membership": "Three-month membership",
  "value_items": "{{value}} items",
  "new_inquiries_need_to_be_processed": "New inquiries need to be processed",
  "you_can_upload_up_to_value_attachments": "You can upload up to {{value}} attachments.",
  "failed_to_upload_value": "Failed to upload {{value}}",
  "upload_attachment": "Upload attachment",
  "value_is_not_a_pdf_file": "{{value}} is not a PDF file",
  "value_is_not_an_image": "{{value}} is not an image",
  "value_must_not_exceed_4_mb": "{{value}} must not exceed 4 MB",
  "brand_logo": "*Brand logo",
  "brand_logoV2": "Brand logo",
  "china": "China",
  "logo": "Logo",
  "name_is_required": "Name is required",
  "brand_already_exists": "Brand already exists",
  "enter_brand_name": "Enter brand name",
  "brand_name": "*Brand name",
  "upload_a_logo": "Upload a logo",
  "enter_country": "Enter country",
  "select_brand_category": "Select brand category",
  "edit_brand_type": "Edit brand type",
  "add_brand_type": "Add brand type",
  "type_name": "Type name",
  "enter_type_name": "Enter type name",
  "chinaV2": "China",
  "brand_nameV2": "Brand name*",
  "logoV2": "Logo",
  "type": "Type*",
  "select_brand_type": "Select brand type",
  "country": "Country*",
  "others": "Others",
  "equipment": "Equipment",
  "name": "Name",
  "free_version": "Free version",
  "free_versionV2": "Free version",
  "buy": "Buy",
  "upgrade": "Upgrade",
  "renew": "Renew",
  "used_capacity": "Used capacity:",
  "original_plan_expiration_date": "Original plan expiration date:",
  "quantity": "Quantity",
  "plan_duration_is_up_to_value_3_years_at_a_time": "Plan duration is up to {{value}}3 years at a time",
  "select_at_least_1_year": "Select at least 1 year",
  "original_price_new_plan_original_unit_price_original_plan_total_term_bonus_duration_original_plan_total_days_remaining_days": "Original price = new plan original unit price × (original plan total term - bonus duration) / original plan total days × remaining days",
  "original_price_list_price_subscription_term": "Original price = list price × subscription term",
  "the_value_promo_code_has_been_redeemed_for_you_value": "The {{value}} promo code has been redeemed for you: {{value}}",
  "pay_difference": "Pay difference",
  "select_payment_method": "Select payment method",
  "dear_user_your_storage_is_running_out_to_prevent_important_files_from_being_deleted_automatically_upgrade_your_plan_or_manually_delete_unnecessary_files_as_soon_as_possible": "Dear user, your storage is running out. To prevent important files from being deleted automatically, upgrade your plan or manually delete unnecessary files as soon as possible.",
  "failed_to_upload_value_please_try_again": "Failed to upload {{value}}. Please try again.",
  "upload_hd_assets": "Upload HD assets",
  "name_number": "Name/number",
  "asset_name_number": "Asset name/number",
  "image_is_required": "Image is required",
  "pdf_image": "PDF image",
  "this_is_the_content_on_the_right": "This is the content on the right",
  "cad": "CAD",
  "product_texture": "Product texture",
  "hd_assets": "HD assets",
  "pdf_imageV2": "PDF image",
  "residential": "Residential",
  "commercial": "Commercial",
  "attachment_upload_is_not_complete": "Attachment upload is not complete.",
  "publish": "Publish",
  "are_you_sure_you_want_to_clear_the_product_introduction": "Are you sure you want to clear the product introduction?",
  "enter_product_name": "Enter product name",
  "enter_product_nameV2": "*Enter product name",
  "enter_model": "Enter model",
  "enter_series_and_model": "*Enter series and model",
  "enter_series_and_modelV2": "Enter series and model",
  "enter_specifications_and_size": "Enter specifications and size",
  "enter_supplier": "Enter supplier",
  "select_product_attributes": "Select product attributes",
  "piece": "Piece",
  "hd_assets_texture_maps": "HD assets (texture maps)",
  "s_invitation_you_can_enter_product_information_in_the_list_below_and_submit_it_after_the_private_space_administrator_approves_it_the_product_will_be_automatically_added_to": "'s invitation. You can enter product information in the list below and submit it. After the Private Space administrator approves it, the product will be automatically added to",
  "private_space_saas_tools": "Private Space SaaS tools",
  "keep_at_least_one_tab": "Keep at least one tab",
  "hd_assetsV2": "HD assets",
  "pdf_imageV3": "PDF image",
  "residentialV2": "Residential",
  "commercialV2": "Commercial",
  "product_textureV2": "Product texture",
  "chinese_n": "Chinese N",
  "english": "English",
  "japanese": "Japanese",
  "test": "Test",
  "chinese_nV2": "Chinese N",
  "validity_period_updated": "Validity period updated",
  "adjust_validity_period": "Adjust validity period",
  "card_expiry": "Card expiry",
  "select_dateV2": "Select date",
  "are_you_sure_you_want_to_value_this_request_card": "Are you sure you want to {{value}} this request card?",
  "visible_to_everyone": "Visible to everyone",
  "block_peers": "Block peers",
  "complete_the_request_and_close_the_card": "Complete the request and close the card",
  "are_you_sure_you_want_to_close_this_request_card": "Are you sure you want to close this request card?",
  "withdraw_card_to_drafts": "Withdraw card to drafts",
  "are_you_sure_you_want_to_withdraw_this_request_card": "Are you sure you want to withdraw this request card?",
  "withdrawn": "Withdrawn",
  "withdrawal_failed": "Withdrawal failed",
  "adjust_card_expiry": "Adjust card expiry",
  "edit_contact_information": "Edit contact information",
  "are_you_sure_you_want_to_delete_this_request_card": "Are you sure you want to delete this request card?",
  "delete_card": "Delete card",
  "show_less": "Show less",
  "show_more": "Show more",
  "request_details": "Request details",
  "unlimited": "Unlimited",
  "value_yuan_unit": "{{value}} yuan/unit",
  "curated": "Curated",
  "about_value_value": "About {{value}}{{value}}",
  "reference_image": "Reference image",
  "register_as_a_supplier_to_add_favorites_or_participate": "Register as a supplier to add favorites or participate.",
  "switch_to_the_supplier_role": "Switch to the supplier role",
  "participate": "Participate",
  "are_you_sure_you_want_to_close_this_page": "Are you sure you want to close this page?",
  "anonymous": "Anonymous",
  "card_expiryV2": "Card expiry",
  "to": "To",
  "curatedV2": "Curated",
  "series": "Series",
  "show_lessV2": "Show less",
  "show_moreV2": "Show more",
  "request_detailsV2": "Request details",
  "unlimitedV2": "Unlimited",
  "value_yuan_unitV2": "{{value}} yuan/unit",
  "about_value_valueV2": "About {{value}}{{value}}",
  "you_cannot_participate_in_your_own_cards": "You cannot participate in your own cards.",
  "delete_all_participation_in_this_item": "Delete all participation in this item?",
  "your_submission_is_not_complete_exit_anyway": "Your submission is not complete. Exit anyway?",
  "you_cannot_add_your_own_cards_to_favorites": "You cannot add your own cards to favorites.",
  "removed_from_favorites": "Removed from favorites",
  "added_to_favorites": "Added to favorites",
  "anonymousV2": "Anonymous",
  "card_expiryV3": "Card expiry",
  "toV2": "To",
  "rejection_reason": "Rejection Reason:",
  "rejection_reason_value": "Rejection reason: {{value}}",
  "public": "Public",
  "block_peersV2": "Block peers",
  "are_you_sure_you_want_to_delete_this_request_cardV2": "Are you sure you want to delete this request card?",
  "register_as_a_supplier_to_add_favorites_or_participateV2": "Register as a supplier to add favorites or participate.",
  "switch_to_the_supplier_roleV2": "Switch to the supplier role",
  "unlimitedV3": "Unlimited",
  "anonymousV3": "Anonymous",
  "expired": "Expired",
  "downloading": "Downloading...",
  "file_not_found": "File not found",
  "this_file_is_too_large_to_preview": "This file is too large to preview.",
  "import_pdf": "Import PDF",
  "complete_import": "Complete import",
  "invalid_page_number_format": "Invalid page number format",
  "import_pdfV2": "Import PDF",
  "specific_pages": "Specific pages",
  "e_g_1_2_5_7_10": "e.g. 1, 2-5, 7-10",
  "the_higher_the_resolution_the_longer_the_import_time": "The higher the resolution, the longer the import time.",
  "complete_importV2": "Complete import",
  "file_size_exceeds_the_limit_upload_again": "File size exceeds the limit. Upload again.",
  "upload_attachmentV2": "Upload attachment",
  "supported_formats_pdf_ppt_doc_under_50mb": "Supported formats: PDF, PPT, DOC (under 50MB)",
  "duplicate_parameter_name": "Duplicate parameter name",
  "enter_feature_name": "Enter feature name",
  "enter_feature_nameV2": "Enter feature name",
  "date_modified": "Date modified",
  "edit_folder": "Edit folder",
  "add_folder": "Add folder",
  "cannot_exceed_30_characters": "Cannot exceed 30 characters",
  "file_folder_name": "File/folder name",
  "new_file": "New file",
  "post_request": "Post request",
  "select_none": "Select none",
  "private": "Private",
  "about_us": "About us",
  "features": "Features",
  "partnerships": "Partnerships",
  "contact_us": "Contact us",
  "finished_product": "Finished product",
  "all_statuses": "All statuses",
  "draft": "Draft",
  "not_approved": "Not approved",
  "privateV2": "Private",
  "curatedV3": "Curated",
  "this_product_has_already_been_added": "This product has already been added",
  "origin": "Origin",
  "crop_the_image": "Crop the image",
  "download_failed": "Download failed",
  "crop_me": "Crop me",
  "failed_to_load_the_image_please_try_again_later": "Failed to load the image. Please try again later.",
  "crop_the_imageV2": "Crop the image",
  "download_failedV2": "Download failed",
  "crop": "Crop",
  "unlock_default_ratio": "Unlock default ratio",
  "lock_default_ratio": "Lock default ratio",
  "rotate_right": "Rotate right",
  "rotate_left": "Rotate left",
  "zoom_in": "Zoom in",
  "zoom_out": "Zoom out",
  "crop_meV2": "Crop me",
  "click_to_upload": "Click to upload",
  "image_size_cannot_exceed_value_mb": "Image size cannot exceed {{value}}MB",
  "enter_description": "Enter description",
  "click_to_uploadV2": "Click to upload",
  "value_is_not_an_imageV2": "{{value}} is not an image",
  "image_size_limit_4mb": "Image size limit: 4MB",
  "no_more_than_4mb": "No more than 4MB",
  "added_to_favoritesV2": "Added to favorites",
  "failed_to_get_verification_code_try_again": "Failed to get verification code. Try again.",
  "complete_the_puzzle_first": "Complete the puzzle first",
  "enter_your_phone_number": "Enter your phone number",
  "enter_verification_code": "Enter verification code",
  "failed_to_get_verification_code_try_againV2": "Failed to get verification code. Try again.",
  "complete_the_puzzle_firstV2": "Complete the puzzle first",
  "failed_to_get_verification_code_try_againV3": "Failed to get verification code. Try again.",
  "confirm_that_you_have_read_the_agreement": "Confirm that you have read the agreement",
  "user_agreement": "\"User Agreement\"",
  "privacy_policy": "\"Privacy Policy\"",
  "terms_of_service": "\"Terms of Service\"",
  "children_s_personal_information_protection_rules_and_instructions_for_guardians": "\"Children's Personal Information Protection Rules and Instructions for Guardians\"",
  "wechat_login": "WeChat login",
  "panzi_login": "Panzi login",
  "wechat_loginV2": "WeChat login",
  "panzi_loginV2": "Panzi login",
  "alipay_login": "Alipay login",
  "other_login_methods": "Other login methods",
  "hold_and_drag_the_slider_to_complete_the_puzzle": "Hold and drag the slider to complete the puzzle",
  "value_upload_failed": "{{value}} upload failed",
  "insufficient_storage_capacity": "Insufficient storage capacity",
  "video_files_cannot_exceed_200mb": "Video files cannot exceed 200MB",
  "video_upload_failed_due_to_insufficient_storage": "Video upload failed due to insufficient storage.",
  "upload_video": "Upload video",
  "to_ensure_smooth_playback_we_recommend_videos_of_20_30mb_up_to_a_maximum_of_200mb": "To ensure smooth playback, we recommend videos of 20-30MB, up to a maximum of 200MB.",
  "this_will_take_about_2_minutes_please_wait": "This will take about 2 minutes. Please wait.",
  "heiti": "Heiti",
  "kaiti": "Kaiti",
  "fangsong": "Fangsong",
  "songti": "Songti",
  "gongfan_font": "Gongfan font",
  "pangmenzhengdao_bold_calligraphy": "Pangmenzhengdao bold calligraphy",
  "yanshi_chunfeng_kai": "Yanshi Chunfeng Kai",
  "youshe_haoshenti": "Youshe Haoshenti",
  "sanji_xingkai_simplified_chinese": "Sanji Xingkai Simplified Chinese",
  "alignment": "Alignment",
  "letter_spacing": "Letter spacing",
  "biaukai": "BiauKai",
  "stfangsong": "STFangsong",
  "stkaiti": "STKaiti",
  "microsoft_yahei": "Microsoft YaHei",
  "alimama_dongfangdakai": "Alimama DongFangDaKai",
  "alimama_fangyuanti": "Alimama FangYuanTi",
  "dingtalk_jinbuti": "DingTalk JinBuTi",
  "youshe_biaoti_hei": "Youshe Biaoti Hei",
  "mobile": "Mobile",
  "web": "Web",
  "enter_title": "Enter title...",
  "upload_videoV2": "Upload video",
  "compression_failed": "Compression failed",
  "drag_within_the_image_area": "Drag within the image area",
  "link_click_areas_cannot_overlap": "Link click areas cannot overlap",
  "complete_the_link": "Complete the link",
  "link_must_start_with_http_or_https": "Link must start with http:// or https://",
  "layout_effect": "Layout effect",
  "exit_tiling_mode": "Exit tiling mode",
  "amap": "Amap",
  "apple_maps": "Apple Maps",
  "duplicate_outline_name": "Duplicate outline name",
  "confirm_deletion": "Confirm deletion?",
  "failed_to_save_the_long_image": "Failed to save the long image",
  "value_upload_failedV2": "{{value}} upload failed",
  "p_style_text_align_center_line_height_2_title_p": "<p style=\"text-align: center; line-height: 2;\">Title</p>",
  "enter_titleV2": "Enter title...",
  "alignmentV2": "Alignment",
  "enter_content": "Enter content...",
  "spacing": "Spacing",
  "letter_spacingV2": "Letter spacing",
  "no_animation": "No animation",
  "text_animation": "Text animation",
  "text_shadow": "Text shadow",
  "text_color": "Text color",
  "value_upload_failedV3": "{{value}} upload failed",
  "failed_to_generate_the_qr_code_enter_a_valid_link": "Failed to generate the QR code. Enter a valid link.",
  "could_not_detect_an_address": "Could not detect an address",
  "qr_code": "QR code",
  "enter_the_address_or_upload_a_qr_code": "Enter the address or upload a QR code",
  "enter_web_address": "Enter web address",
  "upload_logo": "Upload logo",
  "logoV3": "Logo",
  "value_upload_failedV4": "{{value}} upload failed",
  "click_to_view_map": "Click to view map",
  "enter_contentV2": "Enter content...",
  "enter_titleV3": "Enter title...",
  "value_upload_failedV5": "{{value}} upload failed",
  "upload": "Upload",
  "enter_titleV4": "Enter title...",
  "the_desktop_version_has_not_been_uploaded_the_mobile_version_will_be_shown": "The desktop version has not been uploaded; the mobile version will be shown.",
  "value_upload_failedV6": "{{value}} upload failed",
  "click_or_drag_a_single_image": "Click or drag a single image",
  "the_mobile_version_has_not_been_uploaded_the_desktop_version_will_be_shown": "The mobile version has not been uploaded; the desktop version will be shown.",
  "value_upload_failedV7": "{{value}} upload failed",
  "error": "Error",
  "enter_contentV3": "Enter content...",
  "value_upload_failedV8": "{{value}} upload failed",
  "enter_titleV5": "Enter title...",
  "enter_contentV4": "Enter content...",
  "enter_contentV5": "Enter content...",
  "you_can_select_up_to_value_items": "You can select up to {{value}} items",
  "contact_supplier": "Contact supplier",
  "reference_price": "Reference price",
  "material_origin": "Material origin",
  "custom": "Custom",
  "unlike": "Unlike",
  "like": "Like",
  "are_you_sure_you_want_to_value": "Are you sure you want to {{value}}?",
  "request_sample": "Request sample",
  "add_to_comparison": "Add to comparison",
  "different_categories_cannot_be_compared": "Different categories cannot be compared",
  "add_to_my_materials": "Add to my materials",
  "free_1gb_traffic": "Free 1GB traffic",
  "failed_to_upload_valueV2": "Failed to upload {{value}}",
  "you_can_upload_up_to_5_files": "You can upload up to 5 files",
  "value_is_not_a_pdf_fileV2": "{{value}} is not a PDF file",
  "file_size_limit_100_mb": "File size limit: 100 MB",
  "drag_files_here_or_click_to_add_pdf_format_supported": "Drag files here or click to add. PDF format supported.",
  "pdf_imageV4": "PDF image",
  "you_can_upload_up_to_value_items": "You can upload up to {{value}} items",
  "pdf_imageV5": "PDF image",
  "you_can_import_up_to_value_templates_at_a_time": "You can import up to {{value}} templates at a time",
  "you_can_upload_up_to_value_pdfs": "You can upload up to {{value}} PDFs",
  "successfully_followed_the_value_private_space": "Successfully followed the {{value}} Private Space",
  "click_to_create_a_requirement": "Click to create a requirement",
  "replace_image": "Replace image",
  "edit_image": "Edit image",
  "yuan_piece": "Yuan/piece",
  "the_background_image_has_changed_anchor_points_outside_the_image_must_be_moved_back_into_the_image_area_manually": "The background image has changed. Anchor points outside the image must be moved back into the image area manually.",
  "keep_anchor_points_when_replacing_the_image": "Keep anchor points when replacing the image?",
  "value_is_not_an_imageV3": "{{value}} is not an image",
  "the_background_image_has_changed_anchor_points_outside_the_image_must_be_moved_back_into_the_image_area_manuallyV2": "The background image has changed. Anchor points outside the image must be moved back into the image area manually.",
  "deactivated": "Deactivated",
  "services_information": "Services/information",
  "fully_open": "Fully open",
  "anyone_can_join": "Anyone can join",
  "semi_open": "Semi-open",
  "closed": "Closed",
  "invitation_only": "Invitation only",
  "access_settings": "Access settings",
  "member_joining": "Staff joining",
  "visitor_browsing": "Visitor browsing",
  "settings": "Settings",
  "submit_results": "Submit results",
  "closedV2": "Closed",
  "semi_openV2": "Semi-open",
  "fully_openV2": "Fully open",
  "submit_resultsV2": "Submit results",
  "pay": "Pay",
  "contact_support": "Contact support",
  "following": "Following",
  "my_shares": "My shares",
  "mine": "Mine",
  "my_inquiries": "My inquiries",
  "language": "Language",
  "go_to_settings": "Go to settings",
  "set_up_later": "Set up later",
  "1_the_introduction_uses_the_same_content_across_all_languages": "1. The introduction uses the same content across all languages.",
  "2_portfolio_images_videos_and_links_are_uploaded_once_text_must_be_configured_separately_for_each_language_pack": "2. Portfolio images, videos, and links are uploaded once; text must be configured separately for each language pack.",
  "3_product_images_videos_descriptions_and_attachments_are_uploaded_once_text_must_be_configured_separately_for_each_language_pack": "3. Product images, videos, descriptions, and attachments are uploaded once; text must be configured separately for each language pack.",
  "4_the_collaboration_invitation_link_only_needs_to_be_shared_once_group_names_must_be_configured_for_each_language_pack": "4. The collaboration invitation link only needs to be shared once; group names must be configured for each language pack.",
  "setup_guide": "Setup guide",
  "private_space_name": "Private Space name*",
  "enter_contact_address": "Enter contact address",
  "failed_to_get_the_team_language_list_please_try_again": "Failed to get the team language list. Please try again.",
  "failed_to_get_private_space_information": "Failed to get Private Space information",
  "set_space_information": "Set Space information",
  "the_value_plugin_lets_you_use_textures_and_models_from_your_private_space_product_library_directly": "The {{value}} plugin lets you use textures and models from your Private Space product library directly",
  "stay_tuned": "Stay tuned",
  "product_publishing_review": "Product publishing review",
  "logoV4": "Logo",
  "uploading_image": "Uploading image...",
  "scan_to_download_the_app": "Scan to download the app",
  "page_settings": "Page settings",
  "private_space_data_is_being_translated_please_do_not_add_new_data": "Private Space data is being translated. Please do not add new data.",
  "this_private_space_has_not_passed_business_verification_so_visitors_cannot_access_it": "This Private Space has not passed business verification, so visitors cannot access it.",
  "cadV2": "CAD",
  "total_value_files": "Total {{value}} files",
  "total_value_textures": "Total {{value}} textures",
  "total_value_models": "Total {{value}} models",
  "hd_assetsV3": "HD assets",
  "total_value_items": "Total {{value}} items",
  "all_attachments": "All attachments",
  "customizable": "Customizable",
  "parameter_error": "Parameter error",
  "published_successfully": "Published successfully",
  "empty": "Empty",
  "emptyV2": "Empty",
  "select_service_area": "Select service area",
  "latest": "Latest",
  "publish_date": "Publish date",
  "views": "Views",
  "saves": "Saves",
  "date_added": "Date added",
  "high_tech_only": "High-tech only",
  "home_page_display": "Home page display",
  "sample_availability": "Sample availability",
  "keywords": "Keywords",
  "search": "Search",
  "reference_priceV2": "Reference price",
  "originV2": "Origin",
  "texture_library": "Texture library",
  "search_textures": "Search textures",
  "already_linked": "Already linked",
  "linked": "Linked",
  "select_at_least_one_related_image": "Select at least one related image",
  "you_can_link_up_to_value_images": "You can link up to {{value}} images",
  "external_platform": "External platform",
  "global": "Global",
  "ignored": "Ignored",
  "value_records_imported": "{{value}} records imported",
  "are_you_sure_you_want_to_ignore_it": "Are you sure you want to ignore it?",
  "privateV3": "Private",
  "originV3": "Origin",
  "crop_meV3": "Crop me",
  "image_size_cannot_exceed_30mb": "Image size cannot exceed 30MB",
  "image_dimensions_must_be_between_100_100_and_4096_4096": "Image dimensions must be between 100*100 and 4096*4096",
  "network_error_please_try_again_later": "Network error. Please try again later.",
  "paste_image": "Paste image",
  "supported_formats_jpg_jpeg_png_webp_gif": "Supported formats: jpg, jpeg, png, webp, gif",
  "paste_images_with_ctrl_c_ctrl_v": "Paste images with Ctrl+C / Ctrl+V",
  "image_size_up_to_30mb": "Image size up to 30MB",
  "select_image": "Select image",
  "drag_to_select_the_area_you_want_to_search_or_click_next_to_skip": "Drag to select the area you want to search, or click Next to skip",
  "style_genre": "Style/genre",
  "artwork_type": "Artwork type",
  "artist_nationality": "Artist nationality",
  "art_origins": "Art origins",
  "popular": "Popular",
  "international": "International",
  "beijing": "Beijing",
  "shanghai": "Shanghai",
  "guangzhou": "Guangzhou",
  "shenzhen": "Shenzhen",
  "hangzhou": "Hangzhou",
  "chengdu": "Chengdu",
  "chongqing": "Chongqing",
  "wuhan": "Wuhan",
  "nanjing": "Nanjing",
  "tianjin": "Tianjin",
  "xi_an": "Xi'an",
  "suzhou": "Suzhou",
  "changsha": "Changsha",
  "qingdao": "Qingdao",
  "shenyang": "Shenyang",
  "ningbo": "Ningbo",
  "wuxi": "Wuxi",
  "dongguan": "Dongguan",
  "united_states": "United States",
  "russia": "Russia",
  "united_kingdom": "United Kingdom",
  "france": "France",
  "germany": "Germany",
  "italy": "Italy",
  "canada": "Canada",
  "japan": "Japan",
  "south_korea": "South Korea",
  "nationwide": "China (nationwide)",
  "globalV2": "Global",
  "reposition": "Reposition",
  "discover": "Discover",
  "all_categories": "All categories",
  "nationwideV2": "China (nationwide)",
  "zhejiang": "Zhejiang",
  "hangzhouV2": "Hangzhou",
  "enter_company_name": "Enter company name",
  "you_can_enter_up_to_30_characters": "You can enter up to 30 characters",
  "enter_detailed_address": "Enter detailed address",
  "you_can_enter_up_to_50_characters": "You can enter up to 50 characters",
  "legal_representative": "Legal representative",
  "enter_legal_representative": "Enter legal representative",
  "you_can_enter_up_to_10_characters": "You can enter up to 10 characters",
  "same_as_legal_representative": "Same as legal representative?",
  "different_person": "Different person",
  "same_person": "Same person",
  "id_document_photos": "ID document photos",
  "upload_the_portrait_side_of_your_id": "Upload the portrait side of your ID",
  "upload_the_emblem_side_of_your_id": "Upload the emblem side of your ID",
  "name_on_id": "Name on ID",
  "enter_name_on_id": "Enter name on ID",
  "id_number": "ID number",
  "enter_id_number": "Enter ID number",
  "enter_a_valid_id_number": "Enter a valid ID number",
  "id_validity_period": "ID validity period",
  "valid_for_a_fixed_period": "Valid for a fixed period",
  "no_expiry": "No expiry",
  "select_expiry_date": "Select expiry date",
  "power_of_attorney": "Power of attorney",
  "upload_power_of_attorney": "Upload power of attorney",
  "url_email": "URL (email)",
  "enter_url_email": "Enter URL (email)",
  "enter_phone_number": "Enter phone number",
  "telex": "Telex",
  "enter_telex": "Enter telex",
  "zip_code": "Zip code",
  "enter_zip_code": "Enter zip code",
  "enterprise_type": "Enterprise type",
  "select_enterprise_type": "Select enterprise type",
  "trading_company": "Trading company",
  "manufacturer": "Manufacturer",
  "state_owned_enterprise": "State-owned enterprise",
  "wholly_state_owned_company": "Wholly state-owned company",
  "other_limited_liability_company": "Other limited liability company",
  "joint_stock_limited_company": "Joint stock limited company",
  "collective_enterprise": "Collective enterprise",
  "private_enterprise": "Private enterprise",
  "foreign_hong_kong_macao_and_taiwan_invested_enterprise": "Foreign, Hong Kong, Macao and Taiwan-invested enterprise",
  "main_business_industry": "Main business industry",
  "select_your_main_business_industry": "Select your main business industry",
  "agriculture_forestry_animal_husbandry_and_fishery": "Agriculture, forestry, animal husbandry and fishery",
  "metallurgical_industry": "Metallurgical industry",
  "machinery_industry": "Machinery industry",
  "chemical_industry": "Chemical industry",
  "light_industry": "Light industry",
  "electronics_and_telecommunications": "Electronics and telecommunications",
  "oil_petrochemical": "Oil & petrochemical",
  "building_materials": "Building materials",
  "pharmaceutical_industry": "Pharmaceutical industry",
  "textile_industry": "Textile industry",
  "electricity_and_gas_industry": "Electricity and gas industry",
  "other_industries": "Other industries",
  "civil_engineering_construction_industry": "Civil engineering construction industry",
  "construction_installation": "Construction & installation",
  "interior_decoration": "Interior decoration",
  "foreign_trade_industry": "Foreign trade industry",
  "wholesale": "Wholesale",
  "retail_industry": "Retail industry",
  "transportation_and_warehousing_industry": "Transportation and warehousing industry",
  "postal_industry": "Postal industry",
  "accommodation_and_catering_industry": "Accommodation and catering industry",
  "real_estate_industry": "Real estate industry",
  "information_technology_industry": "Information technology industry",
  "information_and_consulting_services_industry": "Information and consulting services industry",
  "investment": "Investment",
  "other_service_industries": "Other service industries",
  "research_institutes": "Research institutes",
  "business_site_area_m2": "Business site area (M2",
  "enter_business_site_area": "Enter business site area",
  "enter_a_positive_integer": "Enter a positive integer",
  "registered_capital_10_000_yuan": "Registered capital (10,000 yuan",
  "enter_registered_capital_10_000_yuan": "Enter registered capital (10,000 yuan",
  "enter_an_amount_with_up_to_two_decimal_places": "Enter an amount with up to two decimal places",
  "number_of_employees": "Number of employees",
  "enter_number_of_employees": "Enter number of employees",
  "technical_staff_count": "Technical staff count",
  "enter_technical_staff_count": "Enter technical staff count",
  "product_standards": "Product standards",
  "standard_products": "Standard products",
  "non_standard_products": "Non-standard products",
  "main_product_name": "Main product name",
  "enter_main_product_name": "Enter main product name",
  "applicable_quality_standard": "Applicable quality standard",
  "enter_applicable_quality_standard": "Enter applicable quality standard",
  "review": "Review",
  "rejected": "Rejected",
  "review_comments": "Review comments",
  "enter_rejection_reason": "Enter rejection reason",
  "enter_rejection_reason_required": "Enter rejection reason (required)",
  "supplier_name": "*Supplier name",
  "supplier_is_already_in_use": "Supplier is already in use",
  "enter_supplier_nameV2": "Enter supplier name",
  "enter_supplier_nameV3": "*Enter supplier name",
  "enter_business_contact_name": "Enter business contact name",
  "enter_business_contact_nameV2": "*Enter business contact name",
  "business_contact_phone_number": "*Business contact phone number",
  "enter_business_contact_phone_number": "Enter business contact phone number",
  "enter_business_contact_phone_numberV2": "*Enter business contact phone number",
  "enter_contact_addressV2": "Enter contact address",
  "enter_business_wechat_id": "Enter business WeChat ID",
  "other_social_media_accounts": "Other social media accounts",
  "upload_supplier_logo": "Upload supplier logo",
  "service_area": "*Service area",
  "select_service_areaV2": "Select service area",
  "select_service_areaV3": "*Select service area",
  "select_supplier_type": "Select supplier type",
  "upload_business_license": "Upload business license",
  "upload_business_licenseV2": "*Upload business license",
  "upload_company_profile": "Upload company profile",
  "upload_award_certificates": "Upload award certificates",
  "boosts_credit_score": "(Boosts credit score)",
  "brand_authorization_letter": "Brand authorization letter",
  "trademark_registration_certificate": "Trademark registration certificate",
  "enter_company_nameV2": "Enter company name",
  "enter_company_nameV3": "*Enter company name",
  "company_introduction": "Company introduction",
  "enter_company_introduction": "Enter company introduction",
  "legal_representativeV2": "*Legal representative",
  "enter_legal_representativeV2": "Enter legal representative",
  "enter_legal_representativeV3": "*Enter legal representative",
  "id_photo": "*ID photo",
  "upload_photo": "Upload photo",
  "upload_photo_side_of_id": "*Upload photo side of ID",
  "upload_emblem_side_of_id": "*Upload emblem side of ID",
  "select_service_areaV4": "Select service area",
  "add_planet": "Add planet",
  "import_new_brands": "Import new brands",
  "ignoredV2": "Ignored",
  "value_records_importedV2": "{{value}} records imported",
  "you_are_just_one_verification_step_away_from_becoming_a_platform_supplier": "You are just one verification step away from becoming a platform supplier",
  "attribute_name": "Attribute name",
  "enter_specification_name": "Enter specification name",
  "enter_attribute_name": "Enter attribute name",
  "this_specification_already_exists": "This specification already exists",
  "this_attribute_already_exists": "This attribute already exists",
  "enter_specifications": "Enter specifications",
  "attribute_value": "Attribute value",
  "enter_attribute_value": "Enter attribute value",
  "enter_attribute": "Enter attribute",
  "add_attribute": "Add attribute",
  "within_two_weeks": "Within two weeks",
  "within_one_year": "Within one year",
  "more_than_one_year": "More than one year",
  "curatedV4": "Curated",
  "seriesV2": "Series",
  "specification_customizable": "Specification / customizable",
  "attributes": "Attributes",
  "no_attributes_yet": "No attributes yet",
  "reference_priceV3": "Reference price",
  "originV4": "Origin",
  "notes": "Notes",
  "delete_this_item": "Delete this item?",
  "unlimitedV4": "Unlimited",
  "value_yuan_unitV3": "{{value}} yuan/unit",
  "about_value_valueV3": "About {{value}}{{value}}",
  "reference_imageV2": "Reference image",
  "this_product_already_exists": "This product already exists",
  "this_area_cannot_be_dragged": "This area cannot be dragged",
  "drag_curated_products_from_the_left": "Drag curated products from the left",
  "or_left_click_here_to_upload_a_product": "Or left-click here to upload a product",
  "cancel_your_participation": "Cancel your participation?",
  "joined": "Joined",
  "upload_local_products": "Upload local products",
  "add_product_images": "Add product images",
  "enter_series_name": "Enter series name",
  "enter_product_nameV3": "Enter product name",
  "customizableV2": "Customizable",
  "reference_priceV4": "Reference price",
  "price_must_exceed_0": "Price must exceed 0",
  "price_must_be_a_number": "Price must be a number",
  "approx": "Approx.",
  "yuan_unit_price": "Yuan/unit price",
  "select_delivery_period": "Select delivery period",
  "additional_information": "Additional information",
  "enter_additional_information": "Enter additional information",
  "all_categoriesV2": "All categories",
  "search_materials": "Search materials",
  "select_brand": "Select brand",
  "use_cases": "Use cases",
  "reference_priceV5": "Reference price",
  "my_uploads": "My uploads",
  "one_month": "One month",
  "three_months": "Three months",
  "six_months": "Six months",
  "within_one_yearV2": "Within one year",
  "more_than_one_yearV2": "More than one year",
  "a": "a",
  "confirm_download": "Confirm download",
  "cancel_download": "Cancel download",
  "please_save_the_qr_code_and_use_a_third_party_application_to_scan_the_code_to_open_it": "Please save the QR code and use a third-party application to scan the code to open it.",
  "press_and_hold_to_scan_qr_code": "Press and hold to scan QR code",
  "texture_libraryV2": "Texture library",
  "search_texturesV2": "Search textures",
  "linkedV2": "Linked",
  "select_at_least_one_related_imageV2": "Select at least one related image",
  "failed_to_upload_valueV3": "Failed to upload {{value}}",
  "by_space": "By space",
  "choose_at_least_one": "Choose at least one",
  "disabled": "Disabled",
  "space_disabled": "Space disabled",
  "unlimitedV5": "Unlimited",
  "substituteInstallation": "Installation service",
  "substituteProcessing": "Processing service",
  "substituteConstruction": "Construction service",
  "detailedDesign": "Detailed design",
  "within_two_weeksV2": "Within two weeks",
  "within_one_yearV3": "Within one year",
  "more_than_one_yearV3": "More than one year",
  "show_lessV3": "Show less",
  "show_moreV3": "Show more",
  "anonymousV4": "Anonymous",
  "toV3": "To",
  "curatedV5": "Curated",
  "seriesV3": "Series",
  "specification_customizableV2": "Specification / customizable",
  "attributesV2": "Attributes",
  "reference_priceV6": "Reference price",
  "originV5": "Origin",
  "unlimitedV6": "Unlimited",
  "notesV2": "Notes",
  "my_choice": "My choice",
  "request_detailsV3": "Request details",
  "value_yuan_unitV4": "{{value}} yuan/unit",
  "about_value_valueV4": "About {{value}}{{value}}",
  "supplier_ignored": "Supplier ignored",
  "supplier": "Supplier",
  "this_card_ignores_all_information_about_this_supplier_do_you_want_to_continue": "This card ignores all information about this supplier. Do you want to continue?",
  "messages": "Messages",
  "visible_after_you_submit": "Visible after you submit",
  "request_detailsV4": "Request details",
  "request_address": "Request address",
  "unlimitedV7": "Unlimited",
  "approx_value_value": "Approx. {{value}} {{value}}",
  "adopted": "Adopted",
  "shortlisted": "Shortlisted",
  "eliminated": "Eliminated",
  "no": "No.",
  "seriesV4": "Series",
  "originV6": "Origin",
  "reference_priceV7": "Reference price",
  "contact": "Contact",
  "you_cannot_add_your_own_cards_to_favoritesV2": "You cannot add your own cards to favorites.",
  "remove_from_favorites": "Remove from favorites?",
  "removed_from_favoritesV2": "Removed from favorites",
  "add_this_request_card_to_favorites": "Add this request card to favorites?",
  "added_to_favoritesV3": "Added to favorites",
  "return_to_preview_page": "Return to preview page?",
  "submitted_successfully": "Submitted successfully",
  "enter_contact_name": "Enter contact name",
  "enter_a_valid_phone_number": "Enter a valid phone number",
  "invalid_phone_number_format": "Invalid phone number format",
  "enter_contact_number": "Enter contact number",
  "enter_a_valid_email_address": "Enter a valid email address",
  "invalid_email_format": "Invalid email format",
  "wechat": "WeChat",
  "enter_wechat_id": "Enter WeChat ID",
  "curatedV6": "Curated",
  "seriesV5": "Series",
  "specification_customizableV3": "Specification / customizable",
  "attributesV3": "Attributes",
  "reference_priceV8": "Reference price",
  "originV7": "Origin",
  "unlimitedV8": "Unlimited",
  "notesV3": "Notes",
  "request_detailsV5": "Request details",
  "value_yuan_unitV5": "{{value}} yuan/unit",
  "about_value_valueV5": "About {{value}}{{value}}",
  "visible_after_you_submitV2": "Visible after you submit",
  "request_detailsV6": "Request details",
  "request_addressV2": "Request address",
  "unlimitedV9": "Unlimited",
  "approx_value_valueV2": "Approx. {{value}} {{value}}",
  "toV4": "To",
  "enter_keywords_to_search_or_create_works": "Enter keywords to search or create works",
  "join": "Join",
  "joinedV2": "Joined",
  "loading_please_try_again_later": "Loading, please try again later",
  "this_material_color_already_exists_and_cannot_be_added_again": "This material color already exists and cannot be added again.",
  "replace_current_material": "Replace current material?",
  "you_have_reached_the_material_limit_remove_some_materials_before_adding_more": "You have reached the material limit. Remove some materials before adding more.",
  "drag_from_the_material_library_on_the_left_to_add": "Drag from the material library on the left to add",
  "all_categoriesV3": "All categories",
  "search_materialsV2": "Search materials",
  "select_brandV2": "Select brand",
  "use_casesV2": "Use cases",
  "reference_priceV9": "Reference price",
  "my_uploadsV2": "My uploads",
  "private_site": "Private site",
  "designer_edition": "Designer edition",
  "build_your_own_designer_brand_platform_own_your_data_and_run_it_your_way": "Build your own designer-brand platform, own your data, and run it your way",
  "i_am_in_charge_of_my_private_space": "I am in charge of my Private Space",
  "i_decide_what_content_to_put_on_it": "I decide what content to put on it",
  "i_decide_how_confidential_each_file_is": "I decide how confidential each file is",
  "i_decide_how_much_access_to_grant": "I decide how much access to grant",
  "i_decide_what_to_send_to_clients": "I decide what to send to clients",
  "i_decide_who_to_partner_with": "I decide who to partner with",
  "i_decide_who_gets_into_my_library": "I decide who gets into my library",
  "i_decide_how_the_portfolio_is_presented": "I decide how the portfolio is presented",
  "i_decide_the_portfolio_s_validity_period_and_number_of_views": "I decide the portfolio's validity period and number of views",
  "submit_proposals_that_self_destruct_after_reading_no_freeloading": "Submit proposals that self-destruct after reading; no freeloading",
  "brand_edition": "Brand edition",
  "my_private_space_is_my_sales_assistant": "My Private Space is my sales assistant",
  "i_want_to_send_all_the_files_of_the_products_the_designer_needs_anytime_anywhere": "I want to send all the files of the products the designer needs anytime, anywhere",
  "i_want_to_get_into_designers_private_space_libraries": "I want to get into designers' Private Space libraries",
  "i_want_designers_to_use_my_products_directly": "I want designers to use my products directly",
  "i_want_designers_to_follow_me_and_be_notified_of_new_products": "I want designers to follow me and be notified of new products",
  "i_want_multi_device_business_presentation_desktop_large_screen_ipad_and_mobile": "I want multi-device business presentation: desktop, large screen, iPad, and mobile",
  "i_want_seamless_links_between_case_studies_and_related_products": "I want seamless links between case studies and related products",
  "i_want_viral_sharing_and_growth": "I want viral sharing and growth",
  "i_want_to_be_able_to_get_customer_information": "I want to be able to get customer information",
  "i_want_to_form_an_industrial_alliance_and_exchange_resources": "I want to form an industrial alliance and exchange resources",
  "organization_edition": "Organization edition",
  "our_private_space_does_it_all": "Our Private Space does it all",
  "we_need_multi_platform_presence_official_site_app_and_mini_program": "We need multi-platform presence: official site, app, and mini program",
  "we_need_members_to_sign_up": "We need staff to sign up",
  "we_need_event_promotion": "We need event promotion",
  "we_need_members_work_to_be_showcased": "We need staff's work to be showcased",
  "we_need_our_own_curated_material_library_for_designers_to_choose_from": "We need our own curated material library for designers to choose from",
  "we_need_works_linked_to_products": "We need works linked to products",
  "contact_supportV2": "Contact support",
  "get_started": "Get started",
  "30_minutes_to_build": "30 minutes to build",
  "everything_is_under_your_control": "Everything is under your control",
  "management_work_business_sales": "Management, work, business, sales...",
  "enter_bujue": "Enter Bujue",
  "multiple_roles_multiple_platforms": "Multiple roles, multiple platforms",
  "learn_more": "Learn more",
  "support": "Support",
  "help": "Help",
  "services": "Services",
  "privacy_policyV2": "Privacy policy",
  "user_agreementV2": "User agreement",
  "contactV2": "Contact",
  "support_qr_code": "Support QR code",
  "scan_to_download_the_appV2": "Scan to download the app",
  "enter_new_phone_number": "Enter new phone number",
  "enter_new_email": "Enter new email",
  "the_new_phone_number_is_the_same_as_the_old_phone_number": "The new phone number is the same as the old phone number",
  "failed_to_get_verification_code_try_againV4": "Failed to get verification code. Try again.",
  "linked_successfully": "Linked successfully",
  "you_are_not_logged_in": "You are not logged in",
  "get_the_verification_code": "Get the verification code",
  "account_management": "Account management",
  "not_set": "Not set",
  "wechatV2": "WeChat",
  "are_you_sure_you_want_to_unlink": "Are you sure you want to unlink?",
  "unlinked_successfully": "Unlinked successfully",
  "unlink": "Unlink",
  "not_linked": "Not linked",
  "identity_verification": "Identity verification",
  "verify": "Verify",
  "enter_verification_codeV2": "Enter verification code",
  "link_phone_number": "Link phone number",
  "enter_verification_codeV3": "Enter verification code",
  "link_email": "Link email",
  "enter_a_valid_email_addressV2": "Enter a valid email address",
  "enter_verification_codeV4": "Enter verification code",
  "password_setup": "Password setup",
  "enter_password": "Enter password",
  "confirm_password": "Confirm password",
  "confirm_your_password": "Confirm your password",
  "new_password": "New password",
  "confirm_new_password": "Confirm new password",
  "link_wechat": "Link WeChat",
  "scan_the_qr_code_to_link_wechat": "Scan the QR code to link WeChat",
  "loading": "Loading",
  "switch_interval": "Switch interval",
  "enter_an_integer_greater_than_0": "Enter an integer greater than 0",
  "switch_effect": "Switch effect",
  "are_you_sure_you_want_to_update_this_agreement_today": "Are you sure you want to update this agreement today?",
  "upload_document": "Upload document",
  "agreement_document": "Agreement document:",
  "upload_agreement": "Upload agreement",
  "uploaded_successfully": "Uploaded successfully",
  "upload_a_docx_file": "Upload a .docx file",
  "agreement_number": "Agreement number:",
  "enter_agreement_number": "Enter agreement number",
  "agreement_version": "Agreement version:",
  "enter_agreement_version": "Enter agreement version",
  "effective_date": "Effective date:",
  "select_effective_date": "Select effective date",
  "not_uploaded": "Not uploaded",
  "uploaded_file_agreement": "Uploaded file agreement",
  "fixed_agreement": "Fixed agreement",
  "membership_agreement": "Membership agreement",
  "add_new_artwork": "Add new artwork",
  "parse": "Parse",
  "upload_image": "Upload image",
  "color_scheme": "Color scheme",
  "select_color_scheme": "Select color scheme",
  "enter_artist": "Enter artist",
  "artist": "Artist",
  "style_genreV2": "Style/genre",
  "enter_style_genre": "Enter style/genre",
  "enter_art_type": "Enter art type",
  "art_type": "Art type",
  "creation_date": "Creation date",
  "enter_creation_date": "Enter creation date",
  "nationality": "Nationality",
  "theme": "Theme",
  "historical_and_cultural_background": "Historical and cultural background",
  "emotional_symbolism": "Emotional symbolism",
  "collection_location": "Collection location",
  "prompt": "Prompt",
  "artistV2": "Artist",
  "style_genreV3": "Style/genre",
  "art_typeV2": "Art type",
  "creation_dateV2": "Creation date",
  "nationalityV2": "Nationality",
  "themeV2": "Theme",
  "historical_and_cultural_backgroundV2": "Historical and cultural background",
  "emotional_symbolismV2": "Emotional symbolism",
  "color_schemeV2": "Color scheme",
  "collection_locationV2": "Collection location",
  "promptV2": "Prompt",
  "art_provenance_library": "Art provenance library",
  "product_count": "Product count",
  "cannot_delete_a_brand_that_contains_products": "Cannot delete a brand that contains products",
  "chinaV3": "China",
  "select_odd_row": "Select odd row",
  "select_even_row": "Select even row",
  "creation_failed": "Creation failed",
  "edited_successfully": "Edited successfully",
  "edit_failed": "Edit failed",
  "enter_brand_nameV2": "Enter brand name",
  "the_brand_name_already_exists": "The brand name already exists",
  "logoV5": "Logo",
  "select_brand_typeV2": "Select brand type",
  "official": "Official",
  "enter_value": "Enter {{value}}",
  "duration_year": "Duration/year",
  "bonus_duration_month": "Bonus duration/month",
  "confirm_cancellation": "Confirm cancellation?",
  "candidate_duration": "Candidate duration",
  "save_the_current_data_first": "Save the current data first",
  "my_account_change_password": "My account/Change password",
  "current_password": "Current password",
  "enter_current_password": "Enter current password",
  "new_passwordV2": "New password",
  "confirm_new_passwordV2": "Confirm new password",
  "edit_language_plan": "Edit language plan",
  "add_language_plan": "Add language plan",
  "languageV2": "Language",
  "select_language": "Select language",
  "enter_price": "Enter price",
  "enter_plan_description": "Enter plan description",
  "default": "Default",
  "enter_valueV2": "Enter {{value}}",
  "plan_name": "Plan name",
  "plan_description": "Plan description",
  "capacity_gb": "Capacity/GB",
  "original_price": "Original price",
  "default_plan": "Default plan",
  "save_the_current_data_firstV2": "Save the current data first",
  "plan_nameV2": "Plan name",
  "plan_descriptionV2": "Plan description",
  "select_languageV2": "Select language",
  "default_planV2": "Default plan",
  "complaint_time": "Complaint time",
  "reason_for_complaint": "Reason for complaint",
  "complaint_content": "Complaint content",
  "complaint_user_id": "Complaint user ID",
  "complaints_panel": "Complaints panel",
  "total_value_itemsV2": "Total {{value}} items",
  "commonly_used": "Commonly used",
  "creation_failedV2": "Creation failed",
  "are_you_sure_you_want_to_delete_the_group_value": "Are you sure you want to delete the group \"{{value}}\"?",
  "are_you_sure_you_want_to_delete_the_country_value": "Are you sure you want to delete the country \"{{value}}\"?",
  "are_you_sure_you_want_to_remove_value_from_commonly_used": "Are you sure you want to remove \"{{value}}\" from Commonly used?",
  "removed_successfully": "Removed successfully",
  "removal_failed": "Removal failed",
  "add_failed": "Add failed",
  "select_an_svg_file": "Select an SVG file",
  "no_files_to_upload": "No files to upload",
  "upload_completed": "Upload completed",
  "no_data_to_export": "No data to export",
  "file_name": "File name",
  "pending_upload": "Pending upload",
  "no_data_to_import_all_data_already_exists": "No data to import. All data already exists.",
  "bulk_import_country_data": "Bulk import country data",
  "about_to_import_value_groups_and_value_countries_value_existing_skipped_continue": "About to import {{value}} groups and {{value}} countries ({{value}} existing skipped). Continue?",
  "confirm_import": "Confirm import",
  "create_group": "Create group",
  "create_country": "Create country",
  "bulk_import_completed": "Bulk import completed",
  "bulk_import_error": "Bulk import error",
  "country_name": "Country name",
  "country_code": "Country code",
  "country_management": "Country management",
  "bulk_importing": "Bulk importing",
  "chinese_name": "Chinese name",
  "enter_chinese_name": "Enter Chinese name",
  "enter_chinese_group_name": "Enter Chinese group name",
  "value_name": "{{value}} name",
  "enter_value_group_name": "Enter {{value}} group name",
  "edit_country": "Edit country",
  "add_country": "Add country",
  "chinese_country_name": "Chinese country name",
  "enter_chinese_country_name": "Enter Chinese country name",
  "value_country_name": "{{value}} country name",
  "enter_value_country_name": "Enter {{value}} country name",
  "enter_country_code": "Enter country code",
  "country_code_must_be_2_letters": "Country code must be 2 letters",
  "only_letters_are_allowed": "Only letters are allowed",
  "2_english_letters": "2 English letters",
  "add_country_to_commonly_used": "Add country to Commonly used",
  "bulk_upload_svgs": "Bulk upload SVGs",
  "version_number": "Version number",
  "force_update": "Force update",
  "release_notes": "Release notes",
  "installer": "Installer",
  "update_file": "Update file",
  "creation_time": "Creation time",
  "updater": "Updater",
  "file_upload_failed": "File upload failed",
  "uploadV2": "Upload",
  "app_store_link": "App store link",
  "enter_version_number": "Enter version number",
  "upload_installer": "Upload installer",
  "enter_release_notes": "Enter release notes",
  "enter_banner_link": "Enter banner link",
  "enter_banner_linkV2": "Enter banner link",
  "upload_imageV2": "Upload image",
  "delete_banner": "Delete banner",
  "are_you_sure_you_want_to_delete_it": "Are you sure you want to delete it?",
  "switch_intervalV2": "Switch interval",
  "enter_an_integer_greater_than_0V2": "Enter an integer greater than 0",
  "switch_effectV2": "Switch effect",
  "select_languageV3": "Select language",
  "add_new_language_pack": "Add new language pack",
  "select_languageV4": "Select language",
  "existing_languages": "Existing languages",
  "translation_progress": "Translation progress",
  "are_you_sure_you_want_to_delete": "Are you sure you want to delete?",
  "not_uploadedV2": "Not uploaded",
  "uploaded": "Uploaded",
  "space_language_packs": "Space language packs",
  "space_management": "Space management",
  "official_settings": "Official settings",
  "select_space": "Select space",
  "select_spaceV2": "Select space",
  "select_language_pack": "Select language pack",
  "plan_nameV3": "Plan name",
  "order_time": "Order time",
  "order_source": "Order source",
  "wechatV3": "WeChat",
  "order": "Order",
  "version_numberV2": "Version number",
  "operation_time": "Operation time",
  "api": "API",
  "request": "Request",
  "response": "Response",
  "ipv4_address": "IPv4 address",
  "ipv6_address": "IPv6 address",
  "operator_id": "Operator ID",
  "operation_log": "Operation log",
  "total_value_itemsV3": "Total {{value}} items",
  "value_is_not_an_imageV4": "{{value}} is not an image",
  "image_size_limit_4mbV2": "Image size limit: 4MB",
  "add_certificate": "Add certificate",
  "material_image_must_not_exceed_4_mb_800_800_px_or_larger_with_the_same_aspect_ratio_is_recommended": "Material image must not exceed 4 MB; 800×800 px or larger with the same aspect ratio is recommended",
  "image_is_requiredV2": "Image is required",
  "are_you_sure_you_want_to_add_this_material_to_the_comparison": "Are you sure you want to add this material to the comparison?",
  "are_you_sure_you_want_to_clear_it": "Are you sure you want to clear it?",
  "cleared_successfully": "Cleared successfully",
  "product_comparison": "Product comparison",
  "add_attributeV2": "Add attribute",
  "enter_feature_nameV3": "Enter feature name",
  "node_name_is_required": "Node name is required",
  "node_name": "Node name",
  "schematic_diagram_is_required": "Schematic diagram is required",
  "schematic_diagram": "Schematic diagram",
  "applicable_materials_are_required": "Applicable materials are required",
  "applicable_materials": "Applicable materials",
  "drawings": "Drawings",
  "enter_node_name": "Enter node name",
  "node": "Node",
  "upload_schematic_diagram": "Upload schematic diagram",
  "applicable_materials_are_requiredV2": "Applicable materials are required",
  "pack_box": "Pack/box",
  "pieces_pack": "Pieces/pack",
  "kg_piece": "kg/piece",
  "fields_with_existing_data_cannot_be_deleted": "Fields with existing data cannot be deleted.",
  "field_name_is_empty_or_already_exists": "Field name is empty or already exists",
  "field_name_already_exists_or_is_empty": "Field name already exists or is empty",
  "upload_imageV3": "Upload image",
  "new_shipping_address": "New shipping address",
  "application_submitted": "Application submitted",
  "shipping_address": "Shipping address",
  "requested_quantity": "Requested quantity",
  "value_is_not_an_imageV5": "{{value}} is not an image",
  "image_size_limit_4mbV3": "Image size limit: 4MB",
  "customization_notes": "Customization notes",
  "specification_name_already_exists": "Specification name already exists",
  "name_is_requiredV2": "Name is required",
  "reason_for_terminating_the_partnership": "Reason for terminating the partnership",
  "partnership_terminated": "Partnership terminated",
  "note_added_successfully": "Note added successfully",
  "rejection_reasonV2": "Rejection Reason:",
  "application_rejected": "Application rejected",
  "supplier_nameV2": "Supplier name",
  "onboarding_date": "Onboarding date",
  "products": "Products",
  "end_partnership": "End partnership",
  "reason_for_termination": "Reason for termination",
  "application_rejectedV2": "Application rejected",
  "rejection_reasonV3": "Rejection Reason:",
  "enable_this_partnership": "Enable this partnership?",
  "enabled": "Enabled",
  "approve_this_application": "Approve this application?",
  "total_value_itemsV4": "Total {{value}} items",
  "rejection_number": "Rejection number:",
  "termination_number": "Termination number:",
  "rejection_time": "Rejection time:",
  "termination_time": "Termination time:",
  "reason_for_terminating_the_partnershipV2": "Reason for terminating the partnership:",
  "enter_required": "Enter (required)",
  "rating_submitted": "Rating submitted",
  "brand_nameV3": "Brand name",
  "main_product_nameV2": "Main product name",
  "product_quality": "Product quality",
  "contract_performance": "Contract performance",
  "service_level": "Service level",
  "product_price": "Product price",
  "corporate_reputation": "Corporate reputation",
  "review_score": "Review score",
  "qualified": "Qualified",
  "unqualified": "Unqualified",
  "improvement_suggestions": "Improvement suggestions",
  "handling_notes": "Handling notes",
  "creation_timeV2": "Creation time",
  "display": "Show",
  "are_you_sure_you_want_to_delete_this_category": "Are you sure you want to delete this category?",
  "document_category": "Document category",
  "enter_category_name": "Enter category name",
  "enter_sort_order": "Enter sort order",
  "displayV2": "Display",
  "added_successfully": "Added successfully",
  "are_you_sure_you_want_to_delete_this_document": "Are you sure you want to delete this document?",
  "are_you_sure_you_want_to_disable_this_document": "Are you sure you want to disable this document?",
  "are_you_sure_you_want_to_enable_this_document": "Are you sure you want to enable this document?",
  "enabledV2": "Enabled",
  "disabled_successfully": "Disabled successfully",
  "title": "Title",
  "question_category": "Question category",
  "date_addedV2": "Date added",
  "pin_to_top": "Pin to top",
  "pinned": "Pinned",
  "not_pinned": "Not pinned",
  "enable": "Enable",
  "disabledV2": "Disabled",
  "are_you_sure_you_want_to_pin_it": "Are you sure you want to pin it?",
  "are_you_sure_you_want_to_unpin_it": "Are you sure you want to unpin it?",
  "help_documentation": "Help documentation",
  "enter_titleV6": "Enter title",
  "end_time": "End time",
  "start_time": "Start time",
  "select_status": "Select status",
  "enabledV3": "Enabled",
  "disabledV3": "Disabled",
  "edit_document": "Edit document",
  "add_document": "Add document",
  "document_categoryV2": "Document category",
  "enter_sort_orderV2": "Enter sort order",
  "operation_details": "Operation details",
  "enter_document_details": "Enter document details",
  "import_pdfV3": "Import PDF",
  "complete_importV3": "Complete import",
  "invalid_page_number_formatV2": "Invalid page number format",
  "import_pdfV4": "Import PDF",
  "specific_pagesV2": "Specific pages",
  "e_g_1_2_5_7_10V2": "e.g. 1, 2-5, 7-10",
  "the_higher_the_resolution_the_longer_the_import_timeV2": "The higher the resolution, the longer the import time.",
  "complete_importV4": "Complete import",
  "subcategory_order_updated": "Subcategory order updated",
  "are_you_sure_you_want_to_delete_value": "Are you sure you want to delete {{value}}?",
  "name_is_requiredV3": "Name is required",
  "duplicate_name": "Duplicate name",
  "edit_primary_category": "Edit primary category",
  "add_primary_category": "Add primary category",
  "enter_category_nameV2": "Enter category name",
  "percentage": "Percentage",
  "enter_product_percentage": "Enter product percentage",
  "global_field_management": "Global field management",
  "code": "Code",
  "creation_timeV3": "Creation time",
  "displayV3": "Display",
  "delete_this_category": "Delete this category?",
  "are_you_sure_you_want_to_delete_the_category": "Are you sure you want to delete the category?",
  "name_is_requiredV4": "Name is required",
  "subcategory_added": "Subcategory added",
  "subcategory_updated": "Subcategory updated",
  "primary_category_order_updated": "primary category order updated",
  "enter_category_nameV3": "Enter category name",
  "enter_code": "Enter code",
  "logo_image": "Logo image",
  "reject_application": "Reject application",
  "enter_rejection_reason_requiredV2": "Enter rejection reason (required)",
  "rejection_reasonV4": "Rejection Reason:",
  "reason_for_unpublishing": "Reason for unpublishing:",
  "review_center_material_review": "Review center/Material review",
  "user_id": "User ID",
  "enter_user_id": "Enter user ID",
  "material": "Material",
  "enter_material_and_color_name": "Enter material and color name",
  "application_type": "Application type",
  "material_name": "Material name",
  "regular_user": "Regular user",
  "official_material": "Official material",
  "username": "Username",
  "phone_number": "phone number",
  "publicV2": "Public",
  "privateV4": "Private",
  "publicV3": "Public",
  "description": "Description",
  "application_time": "Application time",
  "created": "Created",
  "rejection_reasonV5": "Rejection Reason:",
  "approve_this_applicationV2": "Approve this application?",
  "enter_valueV3": "Enter {{value}}",
  "view_details": "View details",
  "reviewV2": "Review",
  "enter_rejection_reasonV2": "Enter rejection reason",
  "rejectedV2": "Rejected",
  "review_commentsV2": "Review comments",
  "node_nameV2": "Node name",
  "schematic_diagramV2": "Schematic diagram",
  "creation_timeV4": "Creation time",
  "drawingsV2": "Drawings",
  "click_to_download": "Click to download",
  "last_modified": "Last modified",
  "material_node_management": "Material node management",
  "nodeV2": "Node",
  "node_name_is_requiredV2": "Node name is required",
  "schematic_diagram_is_requiredV2": "Schematic diagram is required",
  "applicable_materials_are_requiredV3": "Applicable materials are required",
  "applicable_materialsV2": "Applicable materials",
  "upload_drawings": "Upload drawings",
  "add_parameters": "Add parameters",
  "parameter_name_is_required": "Parameter name is required",
  "field_name": "Field name",
  "input_field": "Input field",
  "dropdown": "Dropdown",
  "enter_field_name": "Enter field name",
  "display_name": "Display name",
  "enter_display_name": "Enter display name",
  "control_type_is_required": "Control type is required",
  "control_type": "Control type",
  "default_value": "Default value",
  "candidate_values_are_required": "Candidate values are required",
  "candidate_value": "Candidate value",
  "select_material_category": "Select material category",
  "material_category": "Material category",
  "as_filter": "As filter",
  "name_is_requiredV5": "Name is required",
  "parameter_name": "Parameter name",
  "material_categoryV2": "Material category",
  "control_typeV2": "Control type",
  "input_fieldV2": "Input field",
  "dropdownV2": "Dropdown",
  "default_valueV2": "Default value",
  "candidate_valueV2": "Candidate value",
  "creation_timeV5": "Creation time",
  "are_you_sure_you_want_to_delete_this_field_under_all_related_categories": "Are you sure you want to delete this field under all related categories?",
  "are_you_sure_you_want_to_delete_this_field_under_value": "Are you sure you want to delete this field under ${{value}}?",
  "configuration_load_failed": "Configuration load failed:",
  "configuration_load_failedV2": "Configuration load failed:",
  "edit_benefits": "Edit benefits",
  "add_benefits": "Add benefits",
  "titleV2": "Title",
  "enter_titleV7": "Enter title",
  "subtitle": "Subtitle",
  "enter_subtitle": "Enter subtitle",
  "icon": "Icon",
  "benefits": "Benefits",
  "benefit_name": "Benefit name",
  "benefitsV2": "Benefits",
  "switch": "Switch",
  "application_timeV2": "Application time",
  "delete_this_benefit": "Delete this benefit?",
  "membership_benefits": "Membership benefits",
  "add_agreement": "Add agreement",
  "agreement_name": "Agreement name",
  "enter_agreement_name": "Enter agreement name",
  "agreement": "Agreement",
  "upload_agreementV2": "Upload agreement",
  "upload_a_pdf_file": "Upload a .pdf file",
  "size_must_not_exceed_2mb": "Size must not exceed 2MB",
  "click_to_uploadV3": "Click to upload",
  "titleV3": "Title",
  "enter_titleV8": "Enter title",
  "agreementV2": "Agreement",
  "fees_and_benefits": "Fees and benefits",
  "enter_paid_benefits": "Enter paid benefits",
  "membership_rules": "Membership rules",
  "membership_name": "Membership name",
  "membership_validity_period": "Membership validity period",
  "benefitsV3": "Benefits",
  "fees_and_benefitsV2": "Fees and benefits",
  "select_membership_validity_period": "Select membership validity period",
  "original_priceV2": "Original price",
  "enter_priceV2": "Enter price",
  "amount_paid": "Amount Paid",
  "select_benefits": "Select benefits",
  "edit_basic_information": "Edit basic information",
  "membership_validity_periodV2": "Membership validity period:",
  "member_price": "Member price:",
  "membership_rulesV2": "Membership rules:",
  "membership_rulesV3": "Membership rules",
  "user_agreementV3": "User agreement:",
  "membership_settings": "Membership settings",
  "enter_valueV4": "Enter {{value}}",
  "distributor": "Distributor",
  "discount": "Discount",
  "discountV2": "Discount",
  "channel_code": "Channel code",
  "5_digit_channel_code": "5-digit channel code",
  "transaction_volume": "Transaction volume",
  "sales": "Sales",
  "enableV2": "Enable",
  "deactivatedV2": "Deactivated",
  "referral_code": "Referral code",
  "purchase_date": "Purchase date",
  "value_yuan": "{{value}} yuan",
  "amount_paidV2": "Amount Paid",
  "customer_contact": "Customer contact",
  "item": "Item",
  "payment_platform": "Payment platform",
  "payment_order_number": "Payment order number",
  "select_partner_information_first": "Select partner information first",
  "distributor_management": "Distributor management",
  "update_partner_information": "Update partner information",
  "add_partner_information": "Add partner information",
  "partner": "Partner",
  "enter_partner_name": "Enter partner name",
  "enter_discount": "Enter discount",
  "5_digit_discount_code": "5-digit discount code",
  "sales_data": "Sales data",
  "select_a_supplier": "Select a supplier",
  "search_suppliers": "Search suppliers",
  "search_team": "Search team",
  "private_space": "Private Space",
  "creation_timeV6": "Creation time",
  "review_status": "Review status",
  "rejection_reasonV6": "Rejection Reason:",
  "approve_this_product": "Approve this product?",
  "enter_reason": "Enter reason",
  "search_product_private_space_name": "Search product/Private Space name",
  "approve_these_products": "Approve these products?",
  "force_unpublish": "Force unpublish",
  "total_quantity": "Total quantity",
  "curatedV7": "Curated",
  "top_pick": "Top pick",
  "are_you_sure_you_want_to_publish_these_products": "Are you sure you want to publish these products?",
  "are_you_sure_you_want_to_cancel_the_homepage_promotion": "Are you sure you want to cancel the homepage promotion?",
  "private_spaceV2": "Private Space",
  "creation_timeV7": "Creation time",
  "curatedV8": "Curated",
  "not_curated": "Not curated",
  "completeness_status": "Completeness status",
  "review_information": "Review information",
  "review_statusV2": "Review status",
  "rejection_reasonV7": "Rejection Reason:",
  "approve_this": "Approve this?",
  "are_you_sure_you_want_to_publish_this_product": "Are you sure you want to publish this product?",
  "promote_this_on_the_homepage": "Promote this on the homepage?",
  "ban_publishing": "Ban publishing",
  "enter_publishing_ban_reason": "Enter publishing ban reason",
  "enter_rejection_reasonV3": "Enter rejection reason",
  "add_recommended_supplier": "Add recommended supplier",
  "search_private_space_name": "Search Private Space name",
  "enter_keywords_to_search_private_space": "Enter keywords to search Private Space",
  "no_matching_results": "No matching results",
  "added": "Added",
  "saved": "Saved",
  "save_failed_restored_to_the_latest_server_state": "Save failed. Restored to the latest server state:",
  "valid": "Valid",
  "validV2": "Valid",
  "remove_this_recommendation": "Remove this recommendation?",
  "saving": "Saving...",
  "supplier_nameV3": "Supplier name",
  "officialV2": "Official",
  "materialV2": "Material",
  "usernameV2": "Username",
  "phone_numberV2": "phone number",
  "application_timeV3": "Application time",
  "requested_quantityV2": "Requested quantity",
  "review_center_swatch_management": "Review center/Swatch management",
  "enter_material_name": "Enter material name",
  "consignee": "Consignee",
  "enter_consignee_id": "Enter consignee ID",
  "bundled_service_settings": "Bundled service settings",
  "edit_service": "Edit service",
  "service_name": "Service name",
  "value_nameV2": "{{value}} name",
  "automatic_trigger": "Automatic trigger",
  "manual_trigger": "Manual trigger",
  "processing": "Processing",
  "failed": "Failed",
  "file_path_does_not_exist": "File path does not exist",
  "start_timeV2": "Start time",
  "end_timeV2": "End time",
  "statistical_period": "Statistical period",
  "statistics_completion_time": "Statistics completion time",
  "trigger_mode": "Trigger mode",
  "statistics_file": "Statistics file",
  "query_failed": "Query failed",
  "statistics": "Statistics",
  "time_range_by_end_time": "Time range (by end time)",
  "month": "Month",
  "total_value_itemsV5": "Total {{value}} items",
  "on_value_grant_the_value_team_value_gb_of_bujue_cloud_storage": "On {{value}}, grant the {{value}} team {{value}}GB of Bujue Cloud storage?",
  "grant_the_value_team_value_gb_of_bujue_cloud_storage_now": "Grant the {{value}} team {{value}}GB of Bujue Cloud storage now?",
  "operation_failed": "Operation failed:",
  "current_granted_capacity": "Current granted capacity:",
  "granted_capacity": "Granted capacity",
  "granted_capacity_is_required": "Granted capacity is required",
  "enter_granted_capacity": "Enter granted capacity",
  "issue_date": "Issue date",
  "select_issue_date": "Select issue date",
  "if_you_do_not_select_an_issue_date_it_will_take_effect_immediately": "If you do not select an issue date, it will take effect immediately.",
  "reminder_is_required": "Reminder is required",
  "team_name": "Team name",
  "granted_capacityV2": "Granted capacity",
  "active_plan": "Active plan",
  "total_capacity_gb": "Total capacity/GB",
  "used_gb": "Used/GB",
  "cancel_this_grant": "Cancel this grant?",
  "cancel_grant": "Cancel grant",
  "team_capacity_management": "Team capacity management",
  "team_nameV2": "Team name",
  "select_purchase_duration": "Select purchase duration",
  "enter_amount_paid": "Enter amount paid",
  "adjust_amount_paid_must_be_less_than_amount_due": "Adjust amount paid (must be less than amount due)",
  "select_payment_channel": "Select payment channel",
  "enter_payment_order_number": "Enter payment order number",
  "please_value_first": "Please {{value}} first",
  "free_versionV3": "Free version",
  "set_plan": "Set plan",
  "plan": "Plan:",
  "planV2": "Plan*",
  "value_year": "(￥{{value}}/year)",
  "free_forever": "(free forever)",
  "renewV2": "Renew",
  "upgradeV2": "Upgrade",
  "purchase_duration": "Purchase duration*",
  "the_value_promo_code_has_been_redeemed_for_you_valueV2": "The {{value}} promo code has been redeemed for you: {{value}}",
  "amount_paidV3": "Amount paid*",
  "unionpay": "UnionPay",
  "offline_payment": "Offline payment",
  "rejection_reasonV8": "Rejection Reason:",
  "rejection_reasonV9": "Rejection reason",
  "enter_requiredV2": "Enter (required)",
  "team_nameV3": "Team name",
  "team_type": "Team type",
  "approve_this_applicationV3": "Approve this application?",
  "enter_rejection_reasonV4": "Enter rejection reason",
  "total_value_itemsV6": "Total {{value}} items",
  "rejection_id": "Rejection ID:",
  "rejection_timeV2": "Rejection time:",
  "rejection_reasonV10": "Rejection reason:",
  "view_team_verification": "View team verification",
  "are_you_sure_you_want_to_restore_this_team": "Are you sure you want to restore this team?",
  "restored": "Restored",
  "incomplete_form": "Incomplete form",
  "configured": "Configured",
  "attachment_deleted": "Attachment deleted",
  "uploaded_successfullyV2": "Uploaded successfully",
  "team_nameV4": "Team name",
  "registered_at": "Registered at",
  "public_mini_program": "Public Mini Program",
  "custom_mini_program": "Custom Mini Program",
  "redirect_official_site_to_mini_program": "Redirect official site to Mini Program ⬇",
  "deactivatedV3": "Deactivated",
  "active": "Active",
  "team_management": "Team management",
  "total_value_itemsV7": "Total {{value}} items",
  "suspend_team": "Suspend team",
  "enter_requiredV3": "Enter (required)",
  "reason_for_deactivation": "Reason for deactivation",
  "set_custom_wechat_mini_program_info": "Set custom WeChat Mini Program info",
  "team_settings": "Team settings",
  "bujue_operations_team": "Bujue operations team",
  "space_mode": "Space mode",
  "internationalV2": "International",
  "domestic": "Domestic",
  "product_category_wrap": "Product category wrap",
  "click_to_uploadV4": "Click to upload",
  "uploaded_images": "Uploaded images",
  "are_you_sure_you_want_to_delete_this_item": "Are you sure you want to delete this item?",
  "3d_plugin_update": "3D plugin update",
  "updaterV2": "Updater",
  "plugin_name": "Plugin name",
  "enter_plugin_name": "Enter plugin name",
  "enter_software_name": "Enter software name",
  "software_name": "Software name",
  "select_icon": "Select icon",
  "iconV2": "Icon",
  "updaterV3": "Updater",
  "upload_update_package": "Upload update package",
  "file_upload_failedV2": "File upload failed",
  "uploadV3": "Upload",
  "version_numberV3": "Version number",
  "enter_version_numberV2": "Enter version number",
  "transaction_number": "Transaction number",
  "income_source": "Income source",
  "application_timeV4": "Application time",
  "transaction_amount": "Transaction amount",
  "finance_center_transaction_history": "Finance center/Transaction history",
  "enter_transaction_number": "Enter transaction number",
  "transaction_time": "Transaction time",
  "searchV2": "Search",
  "associated_suppliers": "Associated suppliers",
  "mobileV2": "Mobile",
  "gender": "Gender",
  "id_numberV2": "ID number",
  "registered_atV2": "Registered at",
  "bio": "Bio",
  "disabledV4": "Disabled",
  "activeV2": "Active",
  "bujue_team": "Bujue team",
  "update_failed": "Update failed:",
  "user_management": "User management",
  "enter_name_email_phone_number_or_nickname": "Enter name, email, phone number, or nickname",
  "edit_information": "Edit information",
  "add_information": "Add information",
  "remaining_quantity": "Remaining quantity",
  "number_of_teams": "Number of teams",
  "delete_information": "Delete information",
  "are_you_sure_you_want_to_delete_itV2": "Are you sure you want to delete it?",
  "draftV2": "Draft",
  "rejectedV3": "Rejected",
  "unpublished": "Unpublished",
  "work_management": "Work management",
  "user_idV2": "User ID",
  "enter_user_idV2": "Enter user ID",
  "work_title": "Work title",
  "enter_work_title": "Enter work title",
  "unpublished_for_violation": "Unpublished for violation",
  "work_id": "Work ID",
  "user": "User",
  "phone_numberV3": "phone number",
  "application_timeV5": "Application time",
  "reason_for_unpublishingV2": "Reason for unpublishing",
  "display_this_on_the_home_page": "Display this on the home page?",
  "remove_from_the_home_page": "Remove from the home page?",
  "view_detailsV2": "View details",
  "rejection_reasonV11": "Rejection Reason:",
  "reason_for_violation": "Reason for violation",
  "rejection_timeV3": "Rejection time:",
  "violation_application_time": "Violation application time",
  "reason_for_violationV2": "Reason for violation:",
  "design_style_management": "Design style management",
  "style_name": "Style name",
  "style_name_value": "Style name-{{value}}",
  "creation_timeV8": "Creation time",
  "displayV4": "Display",
  "delete_this_categoryV2": "Delete this category?",
  "primary_category_order_updatedV2": "primary category order updated",
  "design_style": "Design style",
  "duplicate_style_name": "Duplicate style name",
  "enter_category_nameV4": "Enter category name",
  "subcategory_order_updatedV2": "Subcategory order updated",
  "building_type_management": "Building type management",
  "category_name_value": "Category name-{{value}}",
  "creation_timeV9": "Creation time",
  "displayV5": "Display",
  "delete_this_categoryV3": "Delete this category?",
  "are_you_sure_you_want_to_delete_the_categoryV2": "Are you sure you want to delete the category?",
  "subcategory_addedV2": "Subcategory added",
  "subcategory_updatedV2": "Subcategory updated",
  "primary_category_order_updatedV3": "primary category order updated",
  "building_type_classification": "Building type classification",
  "enter_category_nameV5": "Enter category name",
  "category_name_valueV2": "Category name {{value}}",
  "enter_category_name_value": "Enter category name {{value}}",
  "platform_management": "Platform management",
  "carousel": "Carousel",
  "app_carousel": "App carousel",
  "agreement_template": "Agreement template",
  "product_library_management": "Product library management",
  "bundled_service_settingsV2": "Bundled service settings",
  "material_categoryV3": "Material category",
  "private_space_product_management": "Private Space product management",
  "country_managementV2": "Country management",
  "work_managementV2": "Work management",
  "building_type_managementV2": "Building type management",
  "design_style_managementV2": "Design style management",
  "cloud_drive_admin": "Cloud drive admin",
  "team_capacity_managementV2": "Team capacity management",
  "cloud_drive_operations": "Cloud drive operations",
  "candidate_durationV2": "Candidate duration",
  "distributor_managementV2": "Distributor management",
  "idea_board_management": "Idea board management",
  "promptV3": "Prompt",
  "basic_asset_management": "Basic asset management",
  "recommended_supplier_management": "Recommended supplier management",
  "ai_configuration": "AI configuration",
  "models_and_keys": "Models and keys",
  "ai_usage": "AI usage",
  "tools_admin": "Tools admin",
  "custom_template": "Custom template",
  "art_provenance_libraryV2": "Art provenance library",
  "3d_plugin_updateV2": "3D plugin update",
  "node_library_management": "Node library management",
  "help_documentationV2": "Help documentation",
  "document_categoryV3": "Document category",
  "review_center": "Review center",
  "material_review": "Material review",
  "swatch_management": "Swatch management",
  "user_managementV2": "User management",
  "membership_settingsV2": "Membership settings",
  "membership_benefitsV2": "Membership benefits",
  "business_entity_management": "Business entity management",
  "design_team_management": "Design team management",
  "log_panel": "Log panel",
  "complaints_panelV2": "Complaints panel",
  "space_language_packsV2": "Space language packs",
  "finance_center": "Finance center",
  "transaction_history": "Transaction history",
  "client_version": "Client version",
  "downloader_version": "Downloader version",
  "statisticsV2": "Statistics",
  "change_password": "Change password",
  "please_act_soon": "Please act soon",
  "this_is_the_last_page": "This is the last page",
  "bujue_space_gallery": "Bujue Space Gallery",
  "the_platform_that_empowers_designers": "The platform that empowers designers",
  "folder_name_is_required": "Folder name is required",
  "file_name_is_required": "File name is required",
  "file_names_cannot_contain_the_following_characters": "File names cannot contain the following characters:",
  "a_folder_with_this_name_already_exists": "A folder with this name already exists",
  "a_file_with_this_name_already_exists": "A file with this name already exists",
  "renamed": "Renamed",
  "rename_failed": "Rename failed",
  "online_preview_is_not_supported_for_this_file_download_it_instead": "Online preview is not supported for this file. Download it instead?",
  "online_preview_is_not_supported_for_this_file": "Online preview is not supported for this file.",
  "rename": "Rename",
  "file_nameV2": "File name",
  "folder_name_is_requiredV2": "Folder name is required",
  "file_name_is_requiredV2": "File name is required",
  "file_names_cannot_contain_the_following_charactersV2": "File names cannot contain the following characters:",
  "a_folder_with_this_name_already_existsV2": "A folder with this name already exists",
  "a_file_with_this_name_already_existsV2": "A file with this name already exists",
  "renamedV2": "Renamed",
  "rename_failedV2": "Rename failed",
  "online_preview_is_not_supported_for_this_file_download_it_insteadV2": "Online preview is not supported for this file. Download it instead?",
  "online_preview_is_not_supported_for_this_fileV2": "Online preview is not supported for this file.",
  "file_nameV3": "File name",
  "files_in_destination_folder": "Files in destination folder",
  "file_being_uploaded": "File being uploaded",
  "existing_files": "Existing files",
  "file_information": "File information",
  "file_path": "File path",
  "only_images_can_be_uploaded_to_the_product_asset_library": "Only images can be uploaded to the product asset library",
  "cloud_drive_is_full": "Cloud drive is full",
  "not_enough_cloud_drive_space": "Not enough cloud drive space,",
  "some_files_exceed_the_available_cloud_drive_space": "Some files exceed the available cloud drive space",
  "upload_file": "Upload file",
  "upload_folder": "Upload folder",
  "unnamed_folder": "Unnamed folder",
  "original_image_for_content_display": "Original image for content display",
  "texture_library_folders_cannot_be_moved_in_or_out": "Texture library folders cannot be moved in or out",
  "files_can_only_be_moved_into_the_product_asset_library_folder": "Files can only be moved into the product asset library folder",
  "folders_other_than_texture_library_folders_cannot_be_moved_in": "Folders other than texture library folders cannot be moved in",
  "texture_library_folders_cannot_be_moved_out": "Texture library folders cannot be moved out",
  "move_failed": "Move failed",
  "duplicate_nameV2": "Duplicate name",
  "duplicate_files": "Duplicate files",
  "admin_only": "(Admin only)",
  "system": "(System)",
  "cannot_move_outside_the_product_asset_library": "Cannot move outside the product asset library",
  "cannot_move_to_the_product_asset_library_folder": "Cannot move to the product asset library folder",
  "cannot_move_to_the_value_folder": "Cannot move to the {{value}} folder",
  "not_enough_cloud_drive_spaceV2": "Not enough cloud drive space,",
  "uploaded_successfullyV3": "Uploaded successfully",
  "file_names_cannot_contain_the_following_charactersV3": "File names cannot contain the following characters:",
  "no_upload_tasks": "No upload tasks",
  "x_files_are_being_uploaded": "X files are being uploaded",
  "upload_list": "Upload list",
  "uploading": "Uploading",
  "completed": "Completed",
  "no_upload_tasksV2": "No upload tasks",
  "my_company": "My company",
  "my_companyV2": "My company",
  "company_administrator": "Company administrator",
  "private_deployment_for_enterprises": "Private deployment for enterprises",
  "on_premises_data_deployment": "On-premises data deployment",
  "iconV3": "Icon",
  "private_cloud_server": "Private cloud server",
  "custom_homepage": "Custom homepage",
  "delegated_data_management": "Delegated data management",
  "number_of_members": "Number of staff",
  "unlimitedV10": "Unlimited",
  "technical_services": "Technical services",
  "online_one_on_one_support": "Online one-on-one support",
  "class_a": "Class A",
  "class_b": "Class B",
  "activeV3": "Active",
  "terminated": "Terminated",
  "level": "Level",
  "partnership_status": "Partnership status",
  "date_addedV3": "Date added",
  "terminate_this_partnership": "Terminate this partnership?",
  "resume_this_partnership": "Resume this partnership?",
  "are_you_sure_you_want_to_delete_this_contracted_supplier": "Are you sure you want to delete this contracted supplier?",
  "change_end_date": "Change end date",
  "select_dateV3": "Select date",
  "add_contracted_supplier": "Add contracted supplier",
  "select_a_supplier_to_add": "Select a supplier to add",
  "search_suppliersV2": "Search suppliers",
  "addedV2": "Added",
  "contracted_suppliers": "Contracted suppliers",
  "unnamed_folderV2": "Unnamed folder",
  "assets": "Assets",
  "value_is_not_an_imageV6": "{{value}} is not an image",
  "value_file_upload_failed": "{{value}} file upload failed.",
  "published_successfullyV2": "Published successfully",
  "drag_an_image_of_your_work_here_to_use_as_the_cover": "Drag an image of your work here to use as the cover",
  "select_building_type": "Select building type",
  "select_style": "Select style",
  "enter_work_titleV2": "Enter work title",
  "enter_work_titleV3": "Enter work title",
  "unnamed": "Unnamed",
  "enter_body_text": "Enter body text",
  "failed_to_upload_valueV4": "Failed to upload {{value}}",
  "you_can_upload_up_to_value_attachmentsV2": "You can upload up to {{value}} attachments.",
  "added_attachments": "Added attachments",
  "only_images_and_videos_can_be_uploaded": "Only images and videos can be uploaded",
  "pdf_imageV6": "PDF image",
  "the_introduction_is_still_uploading_try_saving_again_in_a_moment": "The introduction is still uploading. Try saving again in a moment.",
  "attachment_upload_is_not_completeV2": "Attachment upload is not complete.",
  "name_is_requiredV6": "Name is required",
  "supplier_is_required": "Supplier is required",
  "select_material_properties": "Select material properties",
  "minimum_period_cannot_be_greater_than_maximum_period": "Minimum period cannot be greater than maximum period",
  "product_style": "Product style",
  "only_pdf_files_can_be_uploaded": "Only PDF files can be uploaded",
  "failed_to_upload_valueV5": "Failed to upload {{value}}",
  "added_attachmentsV2": "Added attachments",
  "chinese_pdf": "Chinese PDF",
  "upload_chinese_pdf": "Upload Chinese PDF",
  "english_pdf": "English PDF",
  "upload_english_pdf": "Upload English PDF",
  "value_is_not_an_imageV7": "{{value}} is not an image",
  "image_size_limit_4mbV4": "Image size limit: 4MB",
  "you_can_upload_up_to_value_images": "You can upload up to {{value}} images",
  "no_more_than_4mbV2": "No more than 4MB",
  "value_is_not_an_imageV8": "{{value}} is not an image",
  "image_size_limit_4mbV5": "Image size limit: 4MB",
  "select_styleV2": "Select style",
  "select_styleV3": "*Select style",
  "enter_work_titleV4": "Enter work title",
  "enter_work_titleV5": "*Enter work title",
  "enter_descriptionV2": "Enter description",
  "enter_descriptionV3": "*Enter description",
  "upload_photos": "Upload photos",
  "upload_photoV2": "Upload photo",
  "material_list": "* Material list",
  "exporting": "Exporting...",
  "material_listV2": "Material list",
  "no_materials_added": "No materials added",
  "drag_materials_from_the_material_library_on_the_left_to_add_them": "Drag materials from the material library on the left to add them",
  "nodeV3": "Node",
  "add_a_node": "Add a node",
  "project_case": "Project case",
  "published_successfullyV3": "Published successfully",
  "case_description": "Case description",
  "enter_case_description": "Enter case description",
  "upload_imageV4": "Upload image",
  "company_created_redirecting_to_company_management": "Company created. Redirecting to company management.",
  "create_company": "Create company",
  "create_companyV2": "Create company",
  "company_logo": "Company logo",
  "company_profile": "Company profile",
  "tell_us_about_your_business": "Tell us about your business",
  "edit_material": "Edit material",
  "create_material": "Create material",
  "created_and_published": "Created and published",
  "changes_published": "Changes published",
  "publishV2": "Publish",
  "at_least_one_image_is_required": "At least one image is required",
  "material_category_name": "*Material category & name",
  "select_material_categoryV2": "Select material category",
  "select_material_categoryV3": "Select material category",
  "enter_material_nameV2": "Enter material name",
  "upload_brand_logo": "Upload brand logo",
  "an_incorrect_material_brand_name_may_reduce_search_traffic_enter_it_carefully_and_accurately": "An incorrect material brand name may reduce search traffic. Enter it carefully and accurately.",
  "enter_brand_nameV3": "Enter brand name",
  "select_unit": "Select unit",
  "enter_series_and_modelV3": "Enter series and model",
  "enter_series": "Enter series",
  "enter_origin": "Enter origin",
  "select_delivery_periodV2": "Select delivery period",
  "within_one_yearV4": "Within one year",
  "more_than_one_yearV4": "More than one year",
  "select_supporting_services": "Select supporting services",
  "select_use_case": "Select use case",
  "airport": "Airport",
  "railway_station": "Railway station",
  "shopping_mall_supermarket": "Shopping mall/supermarket",
  "plaza": "Plaza",
  "hotel": "Hotel",
  "museum_exhibition_hall": "Museum/exhibition hall",
  "theater_ktv": "Theater/KTV",
  "office_building": "Office building",
  "school": "School",
  "hospital": "Hospital",
  "restaurant": "Restaurant",
  "house_villa": "House/villa",
  "pool": "Pool",
  "sports_field": "Sports field",
  "at_least_one_specification_is_required": "At least one specification is required",
  "upload_node": "Upload node",
  "upload_parts": "Upload parts",
  "enter_experience": "Enter experience",
  "more_materials": "More materials",
  "published_visible_to_everyone": "Published: visible to everyone",
  "privateV5": "Private",
  "unlimitedV11": "Unlimited",
  "anonymousV5": "Anonymous",
  "expiredV2": "Expired",
  "favorite_requests": "Favorite requests",
  "view_all": "View all",
  "clear_invalid_items": "Clear invalid items",
  "unlimitedV12": "Unlimited",
  "request_addressV3": "Request address",
  "select_province": "Select province",
  "select_city": "Select city",
  "select_area": "Select area",
  "unlimitedV13": "Unlimited",
  "materialV3": "Material",
  "finished_productV2": "Finished product",
  "equipmentV2": "Equipment",
  "museum_exhibition_hallV2": "Museum/exhibition hall",
  "restaurantV2": "Restaurant",
  "sports_fieldV2": "Sports field",
  "basement": "Basement",
  "shopping_mall_supermarketV2": "Shopping mall/supermarket",
  "plazaV2": "Plaza",
  "semi_outdoor_space": "Semi-outdoor space",
  "railway_stationV2": "Railway station",
  "airportV2": "Airport",
  "hotelV2": "Hotel",
  "theater_ktvV2": "Theater/KTV",
  "indoor": "Indoor",
  "outdoor": "Outdoor",
  "courtyard": "Courtyard",
  "exterior_wall": "Exterior wall",
  "roof": "Roof",
  "office_buildingV2": "Office building",
  "schoolV2": "School",
  "hospitalV2": "Hospital",
  "poolV2": "Pool",
  "house_villaV2": "House/villa",
  "within_100_000": "Within 100,000",
  "within_500_000": "Within 500,000",
  "within_1_000_000": "Within 1,000,000",
  "1_000_000_or_more": "1,000,000 or more",
  "failed_to_get_your_location": "Failed to get your location",
  "request_detailsV7": "Request details",
  "enter_request_details": "Enter request details",
  "card_expiryV4": "Card expiry",
  "select_card_validity_period": "Select card validity period",
  "when_the_validity_period_expires_the_system_automatically_unpublishes_the_card_set_the_card_period_shorter_than_the_time_you_actually_need": "When the validity period expires, the system automatically unpublishes the card. Set the card period shorter than the time you actually need.",
  "request_addressV4": "Request address",
  "use_casesV3": "Use cases",
  "select_use_caseV2": "Select use case",
  "indoorV2": "Indoor",
  "outdoorV2": "Outdoor",
  "semi_outdoor_spaceV2": "Semi-outdoor space",
  "basementV2": "Basement",
  "roofV2": "Roof",
  "exterior_wallV2": "Exterior wall",
  "courtyardV2": "Courtyard",
  "airportV3": "Airport",
  "railway_stationV3": "Railway station",
  "shopping_mall_supermarketV3": "Shopping mall/supermarket",
  "plazaV3": "Plaza",
  "hotelV3": "Hotel",
  "museum_exhibition_hallV3": "Museum/exhibition hall",
  "theater_ktvV3": "Theater/KTV",
  "office_buildingV3": "Office building",
  "schoolV3": "School",
  "hospitalV3": "Hospital",
  "restaurantV3": "Restaurant",
  "house_villaV3": "House/villa",
  "poolV3": "Pool",
  "sports_fieldV3": "Sports field",
  "budget": "Budget",
  "yuan": "yuan",
  "approxV2": "Approx.",
  "show_lessV4": "Show less",
  "show_moreV4": "Show more",
  "enter_a_valid_mobile_or_landline_number": "Enter a valid mobile or landline number",
  "enter_a_valid_email_addressV3": "Enter a valid email address",
  "enter_at_least_one_contact_method": "Enter at least one contact method",
  "enter_nickname": "Enter nickname",
  "enter_phone_numberV2": "Enter phone number",
  "enter_email_address": "Enter email address",
  "enter_wechat_idV2": "Enter WeChat ID",
  "requestV2": "Request",
  "delete_this_anchor_and_all_its_content": "Delete this anchor and all its content?",
  "s_request_card": "'s request card",
  "yuanV2": "yuan",
  "this_request_has_not_been_published_exit_anyway": "This request has not been published. Exit anyway?",
  "save_as_draft": "Save as draft",
  "upload_an_image_and_create_an_anchor_first": "Upload an image and create an anchor first",
  "publishV3": "Publish",
  "value_is_not_an_imageV9": "{{value}} is not an image",
  "click_to_uploadV5": "Click to upload",
  "finished_products_2": "Finished products: 2",
  "finished_productV3": "Finished product",
  "equipment_3": "Equipment: 3",
  "equipmentV3": "Equipment",
  "materialV4": "Material",
  "request_detailsV8": "Request details",
  "briefly_describe_your_request": "Briefly describe your request",
  "show_lessV5": "Show less",
  "show_moreV5": "Show more",
  "unlimitedV14": "Unlimited",
  "price_limit": "Price limit",
  "yuan_unit_priceV2": "Yuan/unit price",
  "within_two_weeksV3": "Within two weeks",
  "reference_imageV3": "Reference image",
  "submission_materials": "Submission materials",
  "curatedV9": "Curated",
  "quantityV2": "Quantity",
  "approxV3": "Approx.",
  "m": "m",
  "detailed_design_service": "Detailed design service",
  "value_succeeded_value_failed": "{{value}} succeeded, {{value}} failed",
  "brand_category": "Brand category",
  "select_data_1_first": "Select data 1 first",
  "space": "Space:",
  "you_can_add_more_products": "You can add more products",
  "enter_supplier_nameV4": "Enter supplier name",
  "supplier_nameV4": "Supplier name",
  "failed_to_get_verification_code_try_againV5": "Failed to get verification code. Try again.",
  "get_the_verification_codeV2": "Get the verification code",
  "identity_verificationV2": "Identity verification",
  "verifyV2": "Verify",
  "enter_verification_codeV5": "Enter verification code",
  "store_logo": "Store logo",
  "upload_store_logo": "Upload store logo",
  "platform_name": "Platform name",
  "enter_platform_name": "Enter platform name",
  "enter_platform_nameV2": "*Enter platform name",
  "store_address": "Store address",
  "enter_store_address": "Enter store address",
  "enter_store_addressV2": "*Enter store address",
  "supplier_logo": "*Supplier logo",
  "upload_supplier_logoV2": "Upload supplier logo",
  "supplier_is_already_in_useV2": "Supplier is already in use",
  "enter_supplier_nameV5": "Enter supplier name",
  "enter_supplier_nameV6": "*Enter supplier name",
  "deprecated": "(Deprecated)",
  "upload_company_profileV2": "Upload company profile",
  "address_cannot_be_entered": "Address cannot be entered",
  "enter_company_introductionV2": "Enter company introduction",
  "honors": "Honors",
  "upload_honors": "Upload honors",
  "verification_information": "Verification information",
  "upload_business_licenseV3": "Upload business license",
  "upload_business_licenseV4": "*Upload business license",
  "company_name": "*Company name",
  "enter_company_nameV4": "Enter company name",
  "enter_company_nameV5": "*Enter company name",
  "enter_detailed_addressV2": "Enter detailed address",
  "enter_full_address": "*Enter full address",
  "legal_representativeV3": "*Legal representative",
  "enter_legal_representativeV4": "Enter legal representative",
  "enter_legal_representativeV5": "*Enter legal representative",
  "legal_representative_format_is_incorrect": "Legal representative format is incorrect",
  "enter_the_legal_representative_s_phone_number": "Enter the legal representative's phone number",
  "enter_the_legal_representative_s_phone_numberV2": "*Enter the legal representative's phone number",
  "supplier_type": "*Supplier type",
  "select_supplier_typeV2": "Select supplier type",
  "manufacturerV2": "Manufacturer",
  "dealer": "Dealer",
  "business_contact_name": "*Business contact name",
  "enter_business_contact_nameV3": "Enter business contact name",
  "enter_business_contact_nameV4": "*Enter business contact name",
  "contact_phone_number_format_is_incorrect": "Contact phone number format is incorrect",
  "enter_business_contact_phone_numberV3": "Enter business contact phone number",
  "enter_business_contact_phone_numberV4": "*Enter business contact phone number",
  "enter_contact_addressV3": "Enter contact address",
  "enter_business_wechat_idV2": "Enter business WeChat ID",
  "service_areaV2": "*Service area",
  "select_service_areaV5": "Select service area",
  "security_settings": "Security settings",
  "glass_supplier": "Glass supplier",
  "transfer": "Transfer",
  "unfreeze": "Unfreeze",
  "delete_supplier": "Delete supplier",
  "third_party_store": "Third-party store",
  "verification_informationV2": "Verification information",
  "security_settingsV2": "Security settings",
  "taobao": "Taobao",
  "tmall": "Tmall",
  "jd_com": "JD.com",
  "pinduoduo": "Pinduoduo",
  "douyin": "Douyin",
  "kuaishou": "Kuaishou",
  "suning": "Suning",
  "add_at_least_one_store": "Add at least one store",
  "third_party_storeV2": "Third-party store",
  "enter_store_url": "Enter store URL",
  "supplier_onboarding_under_review": "Supplier onboarding under review",
  "supplier_onboarding_rejected": "Supplier onboarding rejected",
  "our_review_team_will_review_your_application_within_2_business_days": "Our review team will review your application within 2 business days.",
  "please_wait_you_will_be_notified_by_sms_once_your_application_is_approved": "Please wait. You will be notified by SMS once your application is approved.",
  "contact_400_189_9196": "Contact: 400-189-9196",
  "preview_information": "Preview information",
  "reapply": "Reapply",
  "business_verification": "Business verification",
  "turn_on_the_front_camera": "Turn on the front camera",
  "image_uploaded_successfully": "Image uploaded successfully",
  "server_error": "Server error",
  "face_detected": "Face detected",
  "no_face_detected": "No face detected",
  "face_authentication_passed": "Face authentication passed",
  "return_to_your_computer_to_complete_business_verification": "Return to your computer to complete business verification",
  "face_authentication_failed": "Face authentication failed",
  "file_upload_failedV3": "File upload failed",
  "the_image_is_too_large_please_upload_it_again_maximum_file_size_value_mb": "The image is too large. Please upload it again (maximum file size: {{value}}MB).",
  "image_uploaded_successfullyV2": "Image uploaded successfully",
  "upload_your_id_card_first": "Upload your ID card first",
  "id_card_submitted_successfully": "ID card submitted successfully",
  "added_to_favoritesV4": "Added to favorites",
  "team_logo": "Team logo",
  "10k": "10K",
  "header_background": "Header background",
  "tile_n": "Tile N",
  "delete_all": "Delete all",
  "about": "About",
  "partnership": "Partnership",
  "productsV2": "Products",
  "shared_product": "Shared product",
  "shared_productV2": "Shared product",
  "assetsV2": "Assets",
  "to_value_select_at_least_one_value": "To {{value}}, select at least one {{value}}",
  "invite_value": "Invite {{value}}",
  "no_private_spaces_yet": "No Private Spaces yet",
  "please_read_the_following_supplier_onboarding_service_agreement_and_rules_carefully": "Please read the following supplier onboarding service agreement and rules carefully.",
  "i_have_read_the_above_agreement": "I have read the above agreement",
  "read_and_accept_the_agreement": "Read and accept the agreement",
  "you_cannot_invite_yourself": "You cannot invite yourself",
  "recommended_designers": "Recommended designers",
  "company_nameV2": "Company name",
  "company_name_is_required": "Company name is required",
  "enter_company_nameV6": "Enter company name",
  "business_contact": "Business contact",
  "business_contact_is_required": "Business contact is required",
  "enter_business_contact": "Enter business contact",
  "contact_number": "Contact number",
  "contact_phone_number_is_required": "Contact phone number is required",
  "enter_contact_numberV2": "Enter contact number",
  "create_an_introduction_page": "Create an introduction page",
  "manage_product_data": "Manage product data",
  "dear_supplier": "Dear supplier:",
  "congratulations_a_designer_friend_has_recommended_you_as_a_curated_supplier_on_bujue_bujue_is_a_curated_high_quality_supplier_platform_built_on_designer_recommendations_once_you_complete_the_curated_supplier_onboarding_process_you_can": "Congratulations. A designer friend has recommended you as a curated supplier on Bujue. Bujue is a curated, high-quality supplier platform built on designer recommendations. Once you complete the curated supplier onboarding process, you can:",
  "share_product_library_cards_directly_with_designers_and_on_social_media": "Share product library cards directly with designers and on social media",
  "we_look_forward_to_having_you_on_board_to_make_bujue_even_better_and_to_helping_more_designers_discover_you_contact_you_and_build_win_win_partnerships": "We look forward to having you on board to make Bujue even better, and to helping more designers discover you, contact you, and build win-win partnerships.",
  "join_company": "Join company",
  "confirm_request": "Confirm request",
  "cancel": "Cancel",
  "apply_to_join_value": "Apply to join {{value}}",
  "verification": "Verification",
  "enter_what_you_want_to_know": "Enter what you want to know",
  "zhejiang_icp_no_17033477_5": "Zhejiang ICP No. 17033477-5",
  "failed_to_get_verification_code_try_againV6": "Failed to get verification code. Try again.",
  "complete_the_puzzle_firstV3": "Complete the puzzle first",
  "linked_successfullyV2": "Linked successfully",
  "enter_verification_codeV6": "Enter verification code",
  "failed_to_get_verification_code_try_againV7": "Failed to get verification code. Try again.",
  "complete_the_puzzle_firstV4": "Complete the puzzle first",
  "registration_and_login_agreement": "Registration and login agreement",
  "wechat_loginV3": "WeChat login",
  "wechat_loginV4": "WeChat login",
  "panzi_loginV3": "Panzi login",
  "alipay_loginV2": "Alipay login",
  "hold_and_drag_the_slider_to_complete_the_puzzleV2": "Hold and drag the slider to complete the puzzle",
  "choose_ai_layout_style": "Choose AI layout style",
  "dense_grid": "Dense grid",
  "seamless_tight_tiling": "Seamless tight tiling",
  "loose_grid": "Loose grid",
  "spaced_layout_with_optional_rounded_corners": "Spaced layout with optional rounded corners",
  "artistic_layout": "Artistic layout",
  "free_composition_with_ai_color_palette": "Free composition with AI color palette",
  "start_layout": "Start layout",
  "detecting_material_colors": "Detecting material colors...",
  "analyzing_texture": "Analyzing texture...",
  "deducing_composition": "Deducing composition...",
  "matching_background_swatches": "Matching background swatches...",
  "selecting_decorative_elements": "Selecting decorative elements...",
  "balancing_white_space": "Balancing white space...",
  "generating_layout": "Generating layout...",
  "ai_processing": "AI processing...",
  "connector_layout": "Connector layout",
  "model": "Model",
  "material_information": "Material information",
  "materials_in_the_library_information_comes_from_the_product_library_and_cannot_be_edited": "Materials in the library: information comes from the product library and cannot be edited.",
  "material_nameV2": "Material name",
  "optional": "Optional",
  "select_material_propertiesV2": "Select material properties",
  "value_automatically_selected": "{{value}} automatically selected",
  "the_original_specification_is_no_longer_valid_select_another_one": "The original specification is no longer valid. Select another one.",
  "this_specification_combination_is_disabled": "This specification combination is disabled",
  "select_value": "Select {{value}}",
  "specification_code": "Specification code",
  "enter_specification_code": "Enter specification code...",
  "this_specification_has_no_image_and_cannot_be_selected_here": "This specification has no image and cannot be selected here",
  "this_specification_has_multiple_images_you_can_replace_the_image_used_in_the_canvas": "This specification has multiple images. You can replace the image used in the canvas.",
  "changing_the_specification_will_also_replace_the_image_of_this_element_in_the_canvas": "Changing the specification will also replace the image of this element in the canvas.",
  "this_specification_has_no_current_images_and_cannot_be_selected_here": "This specification has no current images and cannot be selected here",
  "select_at_least_one_image_first": "Select at least one image first",
  "loading_data_source": "Loading data source...",
  "ai_is_analyzing_this_image_please_wait": "AI is analyzing this image. Please wait...",
  "ai_recognition_in_progress": "AI recognition in progress...",
  "image_loading_failed": "Image loading failed",
  "recognition_failed_task_does_not_exist_or_has_expired": "Recognition failed: task does not exist or has expired",
  "recognition_failed": "Recognition failed:",
  "unknown_error": "Unknown error",
  "no_matching_material_was_found_in_the_current_asset_library_drag_one_in_manually_from_the_asset_library_on_the_left_or_try_again_later": "No matching material was found in the current asset library. Drag one in manually from the asset library on the left, or try again later.",
  "no_matching_material_image_was_found_in_the_library_you_can_add_it_manually_from_the_asset_library_on_the_left": "No matching material image was found in the library. You can add it manually from the asset library on the left.",
  "identified_value_materials_fetching_images": "Identified {{value}} materials, fetching images...",
  "placed_value_identified_materials": "Placed {{value}} identified materials ✓",
  "select_at_least_one_asset_first": "Select at least one asset first",
  "ai_photorealistic_renderings_cannot_be_used_as_materials_in_layout": "AI-photorealistic renderings cannot be used as materials in layout",
  "material_board_is_empty": "Material board is empty",
  "ai_material_board": "AI material board",
  "materialV5": "Material",
  "material_board_generated": "Material board generated ✓",
  "layout_failed": "Layout failed:",
  "layout_completed": "Layout completed ✓",
  "no_connector_found_in_the_selection": "No connector found in the selection",
  "base_image_not_found": "Base image not found",
  "child_image_not_found": "Child image not found",
  "connector_layoutV2": "· Connector layout",
  "base_image": "Base image",
  "connector_layout_completed": "Connector layout completed ✓",
  "select_a_material_board_in_the_workbench_first": "Select a material board in the workbench first",
  "material_board_is_empty_add_assets_first": "Material board is empty. Add assets first",
  "material_board": "Material board",
  "ai_photorealism_in_progress_about_60_120_seconds": "AI photorealism in progress... (about 60-120 seconds)",
  "ai_photorealism_in_progress_about_60_120_secondsV2": "AI photorealism in progress, about 60-120 seconds...",
  "ai_photorealism_failed_task_does_not_exist_or_has_expired": "AI photorealism failed: task does not exist or has expired",
  "photorealistic": "· Photorealistic",
  "ai_photorealism_completed": "AI photorealism completed ✓",
  "ai_photorealism_completed_reused_existing_result": "AI photorealism completed ✓ (reused existing result)",
  "ai_photorealism_failed": "AI photorealism failed:",
  "cutting_out": "Cutting out...",
  "ai_cutout_in_progress_please_wait": "AI cutout in progress, please wait...",
  "cutout_failed_task_does_not_exist_or_has_expired": "Cutout failed: task does not exist or has expired",
  "cutout_completed": "Cutout completed ✓",
  "cutout_failed": "Cutout failed:",
  "white_paper": "White paper",
  "quotation_list": "Quotation list",
  "script": "Script",
  "token_placeholder": "Token placeholder",
  "loading_failed": "Loading failed:",
  "export_script_metadata_loading_failed": "Export script metadata loading failed:",
  "are_you_sure_you_want_to_delete_this_template": "Are you sure you want to delete this template?",
  "template_deleted": "Template deleted",
  "delete_failed": "Delete failed:",
  "uploadingV2": "Uploading...",
  "file_uploaded": "File uploaded",
  "upload_failedV2": "Upload failed:",
  "enter_template_name": "Enter template name",
  "select_script": "Select script",
  "upload_template_file": "Upload template file",
  "template_updated": "Template updated",
  "template_uploaded": "Template uploaded",
  "create": "Create",
  "save_failed": "Save failed:",
  "scene": "Scene",
  "enter_private_space_name_to_search": "Enter Private Space name to search",
  "retry_loading_script": "Retry loading script",
  "retrying": "Retrying...",
  "upload_template": "Upload template",
  "creation_timeV10": "Creation time",
  "update_time": "Update time",
  "spaceV2": "Space",
  "engine": "Engine",
  "globalV3": "Global",
  "this_script_is_not_in_the_current_script_metadata_legacy_dirty_data_or_removed": "This script is not in the current script metadata (legacy dirty data or removed)",
  "the_built_in_default_template_is_not_editable": "The built-in default template is not editable",
  "the_built_in_default_template_cannot_be_deleted": "The built-in default template cannot be deleted",
  "no_custom_templates": "No custom templates",
  "edit_template": "Edit template",
  "template_name": "Template name",
  "example_official_template_quotation_list_2026_edition": "Example: Official template - Quotation list (2026 edition)",
  "enter_private_space_name_to_search_none_global": "Enter Private Space name to search (none = global)",
  "token_placeholder_placeholder_filling": "Token placeholder (placeholder filling)",
  "script_pre_registration_script": "Script (pre-registration script)",
  "no_scripts_available": "(No scripts available)",
  "no_file": "(No file)",
  "undo_replacement": "Undo replacement",
  "uploadedV2": "Uploaded",
  "idea_board_managementV2": "Idea board management",
  "promptV4": "Prompt",
  "basic_assets": "Basic assets",
  "recommended_suppliers": "Recommended suppliers",
  "models_and_keysV2": "Models and keys",
  "ai_configurationV2": "AI configuration",
  "ai_usageV2": "AI usage",
  "export": "Export",
  "export_template": "Export template",
  "loading_failedV2": "Loading failed:",
  "background": "Background",
  "decoration": "Decoration",
  "enter_category_nameV6": "Enter category name",
  "category_created": "Category created",
  "category_renamed": "Category renamed",
  "createV2": "Create",
  "save_failedV2": "Save failed:",
  "are_you_sure_you_want_to_delete_the_category_value_and_its_official_assets": "Are you sure you want to delete the category \"{{value}}\" and its official assets?",
  "category_deleted": "Category deleted",
  "delete_failedV2": "Delete failed:",
  "image_uploaded": "Image uploaded",
  "upload_failedV3": "Upload failed:",
  "are_you_sure_you_want_to_delete_this_official_asset": "Are you sure you want to delete this official asset?",
  "new_category": "New category",
  "no_images": "No images",
  "create_new_value_category": "Create new {{value}} category",
  "rename_category": "Rename category",
  "category_name": "Category name",
  "configuration_load_failedV3": "Configuration load failed:",
  "overwrite_the_existing_super_admin_configuration_with_the_current_runtime_configuration_key_model_prompt": "Overwrite the existing super admin configuration with the current runtime configuration (key/model/prompt)?",
  "current_runtime_configuration_imported": "Current runtime configuration imported ✓",
  "import_failed": "Import failed:",
  "material_recognition": "Material recognition",
  "area_detection": "Area detection",
  "artistic_layout_asset_selection": "Artistic layout asset selection",
  "primary_model": "Primary model",
  "fallback_model": "Fallback model",
  "capability_name": "Capability name",
  "example_deep_thinking": "Example: Deep thinking",
  "label_on_off_high": "Label (on/off/high)",
  "request_fragment_json_e_g_thinking_type_enabled": "Request fragment JSON, e.g. {\"thinking\":{\"type\":\"enabled\"}}",
  "set": "Set",
  "format": "Format ✓",
  "should_start_with_sk_or_ark": "Should start with sk- or ark-",
  "testing": "Testing...",
  "connection_successful": "Connection successful",
  "connection_failed": "Connection failed",
  "connection_test_failed": "Connection test failed:",
  "request_failed": "Request failed",
  "enter_model_name": "Enter model name",
  "current_value_leave_blank_to_keep_unchanged": "Current: {{value}} (leave blank to keep unchanged)",
  "enter_api_key": "Enter API key",
  "edit_model": "Edit model",
  "model_name_e_g_doubao_vision": "Model name (e.g. Doubao Vision)",
  "api_endpoint": "API endpoint",
  "api_key": "API key",
  "example_doubao_seed_1_6_vision_250815": "Example: doubao-seed-1-6-vision-250815",
  "test_connection": "Test connection",
  "disable_value_the_following_prompts_are_using_it_value_after_disabling_they_fall_back_automatically_and_ai_calls_are_not_interrupted_confirm": "⚠ Disable \"{{value}}\"? The following prompts are using it: {{value}} After disabling, they fall back automatically and AI calls are not interrupted. Confirm?",
  "delete_value_the_following_prompts_are_using_it_value_after_deletion_these_bindings_become_invalid_and_the_runtime_falls_back_to_the_fallback_or_system_default_confirm_deletion": "⚠ Delete \"{{value}}\"? The following prompts are using it: {{value}} After deletion these bindings become invalid and the runtime falls back to the fallback or system default. Confirm deletion?",
  "delete_model_value": "Delete model \"{{value}}\"?",
  "deleted_click_save_to_write_to_the_server": "Deleted (click \"Save\" to write to the server)",
  "updated_click_save_to_write_to_the_server": "Updated (click \"Save\" to write to the server)",
  "savedV2": "Saved",
  "model_configuration_saved": "Model configuration saved",
  "save_failedV3": "Save failed:",
  "no_models_yet_click_add_model_below": "No models yet. Click \"Add model\" below",
  "referenced": "Referenced",
  "model_id": "Model ID",
  "there_are_new_unsaved_keys": "There are new unsaved keys",
  "material_recognitionV2": "Material recognition",
  "area_detectionV2": "Area detection",
  "artistic_layout_asset_selectionV2": "Artistic layout asset selection",
  "missing_required_placeholder": "Missing required placeholder:",
  "save_failed_missing_required_placeholder": "Save failed: missing required placeholder",
  "content_is_required": "Content is required",
  "prompt_content_is_required": "Prompt content is required",
  "savedV3": "Saved",
  "prompt_saved": "Prompt saved",
  "save_failedV4": "Save failed:",
  "failed_to_restore_defaults_no_response_from_the_server": "Failed to restore defaults: no response from the server",
  "restored_to_default": "Restored to default",
  "default_prompt_restored": "Default prompt restored",
  "failed_to_restore_defaults": "Failed to restore defaults:",
  "no_model_selected": "No model selected",
  "this_model_has_no_available_capabilities": "This model has no available capabilities",
  "do_not_enable": "(Do not enable)",
  "using_the_server_default_click_restore_default_to_view_the_default_content": "(Using the server default; click \"Restore default\" to view the default content)",
  "do_not_bind": "(Do not bind)",
  "leave_blank_default": "Leave blank = default",
  "temperature": "Temperature",
  "recommended_suppliers_legacy_admin": "Recommended suppliers (legacy admin)",
  "select_team_none_global": "Select team (none = global)",
  "failed_to_load_usage": "Failed to load usage:",
  "30_days": "30 days",
  "7_days": "7 days",
  "today": "Today",
  "total_calls": "Total calls",
  "failure_rate": "Failure rate",
  "total_tokens": "Total tokens",
  "loadingV2": "Loading...",
  "dimensions": "Dimensions:",
  "metrics": "Metrics:",
  "no_records_yet": "No records yet",
  "no_trend_data_yet": "No trend data yet",
  "value_files_exceed_25mb": "{{value}} files exceed 25MB",
  "value_files_have_unsupported_formats": "{{value}} files have unsupported formats",
  "ignored_value_files": "Ignored {{value}} files",
  "no_number": "No number",
  "modelV2": "Model",
  "no_value": "No. {{value}}",
  "specification_value": "Specification {{value}}",
  "undone": "Undone",
  "redone": "Redone",
  "ai_material_boardV2": "AI material board",
  "select_the_material_to_delete_first": "Select the material to delete first",
  "workbench": "Workbench",
  "material_boardV2": "Material board",
  "select_v": "Select V",
  "pan_h": "Pan H",
  "fit_to_artboard_f": "Fit to artboard F",
  "undo": "Undo",
  "redo": "Redo",
  "ai_layout": "AI layout",
  "ai_realistic_renderings_do_not_support_material_replacement": "AI realistic renderings do not support material replacement",
  "off": "Off",
  "number_only": "Number only",
  "material_name_only": "Material name only",
  "number_material_name": "Number + material name",
  "exportV2": "Export",
  "png_images": "PNG images",
  "callout": "Callout",
  "white_paperV2": "White paper",
  "white_paper_template": "White paper template",
  "defaultV2": "(Default)",
  "savedV4": "Saved ✓",
  "save_failed_try_again": "Save failed. Try again.",
  "paste_imageV2": "Paste image",
  "ignored_value": "Ignored: {{value}}",
  "ignored_this_format_is_not_supported_yet": "Ignored: this format is not supported yet",
  "ignored_only_image_pasting_is_supported_jpg_png_gif_webp_bmp_heic_tiff": "Ignored: only image pasting is supported (jpg/png/gif/webp/bmp/heic/tiff)",
  "backgroundV2": "Background",
  "your_browser_does_not_support_the_eyedropper": "Your browser does not support the eyedropper",
  "custom_color": "+ Custom color",
  "custom_colorV2": "▲ Custom color",
  "saturation": "Saturation",
  "brightness": "Brightness",
  "hue": "Hue",
  "eyedropper": "Eyedropper",
  "select_or_open_a_material_board_first": "Select or open a material board first",
  "background_color_applied": "Background color applied ✓",
  "background_replaced": "Background replaced ✓",
  "image_uploadedV2": "Image uploaded ✓",
  "upload_failed_value": "Upload failed: {{value}}",
  "deleted": "Deleted ✓",
  "delete_failed_value": "Delete failed: {{value}}",
  "solid_color_background": "Solid color background",
  "custom_colorV3": "Custom color",
  "no_saved_colors_yet": "No saved colors yet",
  "decoration_replaced": "Decoration replaced ✓",
  "decoration_added": "Decoration added ✓",
  "new_decoration_category_name": "New decoration category name",
  "creation_failed_value": "Creation failed: {{value}}",
  "rename_categoryV2": "Rename category",
  "rename_failed_value": "Rename failed: {{value}}",
  "delete_category_value": "Delete category \"{{value}}\"?",
  "decoration_assets": "Decoration assets",
  "category": "+ Category",
  "renameV2": "Rename",
  "no_filter_fields_available_yet": "No filter fields available yet",
  "lowest": "Lowest",
  "highest": "Highest",
  "select_service_areaV6": "Select service area",
  "unnamedV2": "Unnamed",
  "my_space": "My Space",
  "public_space": "Public Space",
  "backgroundV3": "Background",
  "decorationV2": "Decoration",
  "search_for_materials": "Search for materials...",
  "clear_search": "Clear search",
  "material_replaced": "Material replaced ✓",
  "reference_priceV10": "Reference price",
  "back": "← Back",
  "view_product_details": "View product details",
  "this_specification_combination_is_disabledV2": "This specification combination is disabled",
  "value_automatically_selectedV2": "{{value}} automatically selected",
  "select_valueV2": "Select {{value}}",
  "no_imagesV2": "No images",
  "view_product_detailsV2": "View product details",
  "recommended_suppliersV2": "Recommended suppliers",
  "loading_data_sourceV2": "Loading data source...",
  "failed_to_load_data_source": "Failed to load data source",
  "you_re_not_following_any_private_spaces_yet": "You're not following any Private Spaces yet",
  "you_haven_t_joined_or_created_any_private_spaces_yet": "You haven't joined or created any Private Spaces yet",
  "no_data_sources_yet": "No data sources yet",
  "no_categories": "No categories",
  "loading_subcategories": "Loading subcategories...",
  "loading_products": "Loading products...",
  "no_matching_products_try_relaxing_the_filters": "No matching products. Try relaxing the filters.",
  "no_products": "No products",
  "select_a_subcategory_to_view_products": "Select a subcategory to view products",
  "loading_more": "Loading more...",
  "source": "Source",
  "service_expired": "Service expired",
  "banned_for_violation": "Banned for violation",
  "no_permission_to_query": "No permission to query",
  "select_spaceV3": "Select space",
  "regulations": "Regulations",
  "clear": "Clear",
  "this_specification_combination_is_disabledV3": "This specification combination is disabled",
  "unnamedV3": "Unnamed",
  "public_spaceV2": "Public Space",
  "failed_to_load_data_sourceV2": "Failed to load data source",
  "numbering_example_st_01_st_01_1_st_01_2_split_skus_of_the_same_material_into_sub_numbers": "Numbering example: ST-01 · ST-01-1 · ST-01-2 (split SKUs of the same material into sub-numbers)",
  "numbering_example_st_01_st_02_one_row_per_material_main_number_only": "Numbering example: ST-01 · ST-02 (one row per material, main number only)",
  "export_quotation_list": "Export quotation list",
  "close": "Close",
  "defaultV3": "(Default)",
  "material_quotation": "Material quotation",
  "there_is_no_layout_canvas_in_the_workbench": "There is no layout canvas in the workbench",
  "all_canvases_value": "All canvases ({{value}})",
  "value_canvases_selected": "{{value}} canvases selected",
  "the_material": "The material",
  "example_open_the_material_details_page_in_the_existing_system": "(Example) Open the material details page in the existing system:",
  "this_material_has_no_image_id": "This material has no image ID",
  "the_default_specification_row_cannot_be_deleted": "The default specification row cannot be deleted",
  "renumbered": "Renumbered ✓",
  "material_information_saved": "Material information saved ✓",
  "no_materials_available_for_export": "No materials available for export",
  "loading_template": "Loading template...",
  "select_a_quotation_template": "Select a quotation template",
  "generating_export_file": "Generating export file...",
  "the_quotation_export_task_does_not_exist_or_has_expired": "The quotation export task does not exist or has expired",
  "export_completed": "Export completed ✓",
  "quotation_export_failed": "Quotation export failed:",
  "unknown_errorV2": "Unknown error",
  "timeout": "Timeout",
  "export_failed": "Export failed:",
  "remove_gaps_and_renumber_consecutively_in_the_current_order": "Remove gaps and renumber consecutively in the current order.",
  "total_price": "Total price",
  "0_1_e_g_0_850_means_15_off": "0–1; e.g. 0.850 means 15% off",
  "discounted_price": "Discounted price",
  "by_canvas": "By canvas",
  "by_category": "By category",
  "by_supplier": "By supplier",
  "no_supplier": "No supplier",
  "material_quotationV2": "Material quotation",
  "material_library": "Material library",
  "material_database": "Material database",
  "uncategorized": "Uncategorized",
  "material_boardV3": "Material board",
  "product_id_value": "Product ID: {{value}}",
  "image_id_value": "Image ID: {{value}}",
  "name_value": "Name: {{value}}",
  "brand_value": "Brand: {{value}}",
  "supplier_value": "Supplier: {{value}}",
  "primary_category_value": "Primary category: {{value}}",
  "secondary_category_value": "Secondary category: {{value}}",
  "tertiary_category_value": "Tertiary category: {{value}}",
  "custom_field_value": "Custom field: {{value}}",
  "spec_value": "Spec: {{value}}",
  "no_supplierV2": "No supplier",
  "noV2": "No.",
  "noV3": "No.",
  "material_nameV3": "Material name",
  "material_categoryV4": "Material category",
  "canvas": "Canvas",
  "spec_attributes": "Spec attributes",
  "quantityV3": "Quantity",
  "unit_price_yuan": "Unit price (yuan)",
  "total_yuan": "Total (yuan)",
  "no_spec_selected": "No spec selected",
  "drag_to_reorder": "Drag to reorder",
  "open_material_details": "Open material details",
  "locate_in_material_library": "Locate in material library",
  "click_to_select_material_attributes": "Click to select material attributes",
  "click_to_select_change_specifications": "Click to select/change specifications",
  "click_to_change_specifications": "Click to change specifications",
  "edit_quantity_by_canvas": "Edit quantity by canvas",
  "delete_this_spec_row": "Delete this spec row",
  "this_material_has_only_one_specification_left_and_cannot_be_deleted": "This material has only one specification left and cannot be deleted.",
  "subtotal": "Subtotal",
  "material_replacedV2": "Material replaced ✓",
  "material_replaced_globally_value_occurrences": "Material replaced globally ✓ ({{value}} occurrences)",
  "replace_material": "Replace material",
  "new_material": "New material",
  "single_replacement": "Single replacement",
  "rectangle": "Rectangle",
  "square": "Square",
  "circle": "Circle",
  "ellipse": "Ellipse",
  "triangle": "Triangle",
  "rhombus": "Rhombus",
  "trapezoid": "Trapezoid",
  "hexagon": "Hexagon",
  "locate_material": "Locate material",
  "noV4": "No.",
  "uncategorizedV2": "Uncategorized",
  "select_product_specifications": "Select product specifications",
  "select_a_material_first": "Select a material first",
  "click_any_material_in_the_material_library_to_replace_the_image": "Click any material in the material library to replace the image",
  "select_a_decoration_first": "Select a decoration first",
  "click_any_decoration_in_the_decoration_asset_library_to_replace_it": "Click any decoration in the decoration asset library to replace it",
  "click_asset": "Click asset",
  "size_and_position": "Size and position",
  "width": "Width",
  "height": "Height",
  "ratio": "Ratio",
  "material_callouts_in_the_product_library_cannot_be_edited": "Material callouts in the product library cannot be edited.",
  "image_name": "Image name...",
  "replace_materialV2": "Replace material",
  "cutting_outV2": "Cutting out...",
  "ai_cutout": "AI cutout",
  "replace_decoration": "Replace decoration",
  "images": "images",
  "canvas_list": "Canvas list",
  "search_canvases": "Search canvases...",
  "clear_searchV2": "Clear search",
  "no_related_canvas_found_for_value": "No related canvas found for \"{{value}}\"",
  "no_material_boards_yet": "No material boards yet",
  "unnamedV4": "Unnamed",
  "value_double_click_to_locate": "{{value}} · Double-click to locate",
  "material_boardV4": "Material board",
  "widthV2": "Width",
  "heightV2": "Height",
  "enter_edit_mode": "Enter edit mode",
  "ai_relayout": "AI relayout",
  "ai_realistic_material_board": "AI realistic material board",
  "layout": "Layout",
  "background_image_adjustment": "Background image adjustment",
  "horizontal": "Horizontal",
  "show_material_callouts": "Show material callouts",
  "show_material_numbers": "Show material numbers",
  "grid_layout": "Grid layout",
  "rows": "Rows",
  "widthV3": "Width",
  "automatic": "Automatic",
  "heightV3": "Height",
  "background_image_effect": "Background image effect",
  "brightnessV2": "Brightness",
  "unnamedV5": "Unnamed",
  "ai_material_boardV3": "AI material board",
  "uncategorizedV3": "Uncategorized",
  "material_information_number": "Material information/number",
  "locate_this_product_card_in_the_material_library": "Locate this product card in the material library",
  "select_product_specificationsV2": "Select product specifications",
  "apply_canvas": "Apply canvas",
  "unnamedV6": "Unnamed",
  "asset_images": "Asset images",
  "heightV4": "Height",
  "image_nameV2": "Image name...",
  "material_callouts_in_the_product_library_cannot_be_editedV2": "Material callouts in the product library cannot be edited.",
  "loading_data_sourceV3": "Loading data source...",
  "loadingV3": "Loading...",
  "ai_recognition": "AI recognition",
  "view_properties_here": "View properties here",
  "ai_realistic_renderings_do_not_support_material_replacementV2": "AI realistic renderings do not support material replacement",
  "generating_material_board_please_wait": "Generating material board, please wait...",
  "value_images_value": "{{value}} images{{value}}",
  "multi_select": "Multi-select",
  "loading_data_sourceV4": "Loading data source...",
  "loadingV4": "Loading...",
  "ai_recognitionV2": "AI recognition",
  "rectangleV2": "Rectangle",
  "heightV5": "Height",
  "line_width": "Line width",
  "text": "Text",
  "failed_to_save_project_name_please_try_again": "Failed to save project name, please try again",
  "create_new_material_board": "Create new material board",
  "fit_all_f": "Fit all F",
  "form_mode": "Form mode",
  "workbench_mode": "Workbench mode",
  "exportV3": "Export",
  "select_vV2": "Select V",
  "pan_hV2": "Pan H",
  "connector_c": "Connector C",
  "rectangle_r": "Rectangle R",
  "text_t": "Text T",
  "undo_z": "Undo ⌘Z",
  "redo_z": "Redo ⌘⇧Z",
  "duplicate": "Duplicate",
  "ai_material_boardV4": "AI material board",
  "undoneV2": "Undone",
  "redoneV2": "Redone",
  "duplicated": "Duplicated ✓",
  "connector_deleted": "Connector deleted",
  "ai_realistic_renderings_cannot_be_dragged_into_a_material_board": "AI realistic renderings cannot be dragged into a material board",
  "copied_to_layout_canvas": "Copied to layout canvas ✓",
  "decoration_addedV2": "Decoration added ✓",
  "generating_ai_realistic_image": "Generating AI realistic image...",
  "generating_material_board_please_waitV2": "Generating material board, please wait...",
  "savedV5": "Saved ✓",
  "save_failed_try_againV2": "Save failed. Try again.",
  "select_a_material_or_material_board_first": "Select a material or material board first",
  "rendering_value_items_for_export": "Rendering {{value}} items for export...",
  "export_completedV2": "Export completed ✓",
  "export_timed_out_please_reduce_the_number_and_try_again": "Export timed out, please reduce the number and try again.",
  "png_export_failed": "PNG export failed:",
  "select_the_material_board_to_export_first": "Select the material board to export first",
  "the_selected_material_board_contains_no_materials_so_the_list_cannot_be_exported": "The selected material board contains no materials, so the list cannot be exported.",
  "generating_export_fileV2": "Generating export file...",
  "material_list_xlsx": "Material list.xlsx",
  "export_timed_out_please_try_again": "Export timed out, please try again",
  "material_list_export_failed": "Material list export failed:",
  "the_selected_material_board_has_no_materials": "The selected material board has no materials",
  "material_quotationV3": "Material quotation",
  "the_quotation_export_task_does_not_exist_or_has_expiredV2": "The quotation export task does not exist or has expired",
  "quotation_export_failedV2": "Quotation export failed:",
  "unknown_errorV3": "Unknown error",
  "failed_to_generate_the_screenshot_for_material_board_value_skipped": "Failed to generate the screenshot for material board \"{{value}}\"; skipped.",
  "no_exportable_material_board_screenshot_or_material_parsing_failed": "No exportable material board (screenshot or material parsing failed)",
  "the_white_paper_has_skipped_value_material_elements_value_that_are_missing_required_fields": "The white paper has skipped {{value}} material elements{{value}} that are missing required fields",
  "material_white_paper": "Material white paper",
  "the_white_paper_export_task_does_not_exist_or_has_expired": "The white paper export task does not exist or has expired",
  "the_white_paper_has_been_generated_and_will_be_downloaded_soon": "The white paper has been generated and will be downloaded soon.",
  "white_paper_generation_failed": "White paper generation failed:",
  "white_paper_export_failed": "White paper export failed:",
  "materialname_is_missing": "materialName is missing",
  "toptypename_is_missing": "topTypeName is missing",
  "delete_connector": "Delete connector",
  "create_new_material_boardV2": "Create new material board",
  "enter_edit_modeV2": "Enter edit mode",
  "ai_relayoutV2": "AI relayout",
  "value_files_exceed_25mbV2": "{{value}} files exceed 25MB",
  "value_files_have_unsupported_formatsV2": "{{value}} files have unsupported formats",
  "ignored_value_filesV2": "Ignored {{value}} files",
  "drag_onto_the_material_board_to_add_a_decoration": "Drag onto the material board to add a decoration",
  "drag_assets_from_the_material_library_or_drag_in_image_files_directly": "Drag assets from the material library, or drag in image files directly",
  "right_click_to_create_a_new_material_board": "Right-click to create a new material board",
  "selected": "selected",
  "ai_realistic_renderings": "AI realistic renderings",
  "unnamedV7": "Unnamed",
  "name_valueV2": "Name {{value}}",
  "modelV3": "Model",
  "specification_valueV2": "Specification {{value}}",
  "price_value": "Price {{value}}",
  "ai_material_boardV5": "AI material board",
  "double_click_to_edit": "Double-click to edit",
  "unnamed_project": "Unnamed project",
  "material_inspiration": "Material inspiration",
  "search_projects": "Search projects...",
  "clear_searchV3": "Clear search",
  "project_name": "Project name...",
  "drag": "Drag",
  "pin": "Pin",
  "unpin": "Unpin",
  "design_styleV2": "Design style",
  "originV8": "Origin",
  "reference_priceV11": "Reference price",
  "experience": "Experience",
  "nodeV4": "Node",
  "inspection_certificate": "Inspection certificate",
  "open_this_link_on_a_computer": "Open this link on a computer",
  "add_planetV2": "Add planet",
  "onboarding_information": "Onboarding information",
  "enter_material_name_color_name": "Enter material name/color name",
  "draftV3": "Draft",
  "reject_applicationV2": "Reject application",
  "unpublishedV2": "Unpublished",
  "use_casesV4": "Use cases",
  "airportV4": "Airport",
  "railway_stationV4": "Railway station",
  "shopping_mall_supermarketV4": "Shopping mall/supermarket",
  "plazaV4": "Plaza",
  "hotelV4": "Hotel",
  "museum_exhibition_hallV4": "Museum/exhibition hall",
  "theater_ktvV4": "Theater/KTV",
  "office_buildingV4": "Office building",
  "schoolV4": "School",
  "hospitalV4": "Hospital",
  "restaurantV4": "Restaurant",
  "house_villaV4": "House/villa",
  "poolV4": "Pool",
  "sports_fieldV4": "Sports field",
  "within_one_yearV5": "Within one year",
  "more_than_one_yearV5": "More than one year",
  "material_originV2": "Material origin",
  "reference_priceV12": "Reference price",
  "reason_for_unpublishingV3": "Reason for unpublishing:",
  "unlikeV2": "Unlike",
  "bulk_deletion_completed": "Bulk deletion completed",
  "upgrading_data_to_adapt_to_new_creative_board_features_please_wait": "Upgrading data to adapt to new creative board features, please wait...",
  "updating_numbering": "Updating numbering",
  "no_renumbering_needed": "No renumbering needed",
  "white_paperV3": "White paper",
  "the_color_swatch_image_is_empty_and_cannot_be_exported": "The color swatch image is empty and cannot be exported.",
  "export_failedV2": "Export failed",
  "export_failed_contact_your_administrator": "Export failed. Contact your administrator.",
  "cancel_export": "Cancel export",
  "unnamed_projectV2": "Unnamed project",
  "your_work_is_saved_automatically_are_you_sure_you_want_to_exit": "Your work is saved automatically. Are you sure you want to exit?",
  "creative": "Creative",
  "project": "Project",
  "unnamed_project_value": "Unnamed project_{{value}}",
  "create_project": "Create project",
  "export_white_paper": "Export white paper",
  "select_spaceV4": "Select space",
  "select_a_template_to_export": "Select a template to export",
  "exporting_please_wait": "Exporting, please wait...",
  "customV2": "Custom",
  "contact_supportV3": "Contact support",
  "are_you_sure_you_want_to_cancel_the_export": "Are you sure you want to cancel the export?",
  "exporting_please_waitV2": "Exporting, please wait...",
  "exported": "Exported",
  "if_the_download_does_not_start_automatically_please": "If the download does not start automatically, please",
  "project_list": "Project list",
  "search_projectsV2": "Search projects",
  "delete_this_project_and_its_related_information": "Delete this project and its related information?",
  "the_image_has_not_finished_uploading": "The image has not finished uploading",
  "upload_an_image_and_enter_a_category_name_first": "Upload an image and enter a category name first",
  "backgroundV4": "Background",
  "accent": "Accent",
  "enter_category": "Enter category*",
  "category_deletedV2": "Category deleted",
  "failed_to_delete_category": "Failed to delete category",
  "are_you_sure_you_want_to_delete_valueV2": "Are you sure you want to delete {{value}}?",
  "value_deleted": "{{value}} deleted",
  "official_selection": "Official selection",
  "user_upload": "User upload",
  "search_assets": "Search assets",
  "adjust_texture_scale": "Adjust texture scale",
  "spaceV3": "Space",
  "quantityV4": "Quantity",
  "nameV6": "Name",
  "finished_productV4": "Finished product",
  "noV5": "No.",
  "enter_product_nameV4": "Enter product name",
  "modelV4": "Model",
  "enter_modelV2": "Enter model",
  "unknown_category": "Unknown category",
  "enter_specificationsV2": "Enter specifications",
  "spaceV4": "Space",
  "quantityV5": "Quantity",
  "unit_price": "Unit price",
  "enter_unit_price": "Enter unit price",
  "enter_brand": "Enter brand",
  "enter_supplierV2": "Enter supplier",
  "select_unitV2": "Select unit",
  "export_product_list": "Export product list",
  "are_you_sure_you_want_to_cancel_the_exportV2": "Are you sure you want to cancel the export?",
  "exportedV2": "Exported",
  "export_failedV3": "Export failed",
  "if_the_download_does_not_start_automatically_pleaseV2": "If the download does not start automatically, please",
  "product_list": "Product list",
  "save_changes": "Save changes?",
  "exportedV3": "Exported",
  "export_failedV4": "Export failed",
  "product_listV2": "Product list",
  "exportV4": "Export",
  "categoryV2": "Category",
  "spaceV5": "Space",
  "discountV3": "Discount:",
  "tip_when_grouping_by_category_drag_products_within_a_group_to_change_their_order_note_products_are_numbered_in_order_so_reordering_also_changes_the_numbers": "Tip: When grouping by category, drag products within a group to change their order (note: products are numbered in order, so reordering also changes the numbers)",
  "tip_drag_groups_to_change_their_order": "Tip: Drag groups to change their order",
  "noV6": "No.",
  "subtotalV2": "Subtotal:",
  "quantityV6": "Quantity",
  "enter_quantity": "Enter quantity",
  "unknown_supplier": "Unknown supplier",
  "noV7": "No.",
  "subtotalV3": "Subtotal:",
  "noV8": "No.",
  "subtotalV4": "Subtotal:",
  "failed_to_get_image": "Failed to get image",
  "unknown_supplierV2": "Unknown supplier",
  "materialV6": "Material",
  "already_at_the_front": "Already at the front",
  "already_at_the_back": "Already at the back",
  "materialV7": "Material",
  "adjust_texture_scaleV2": "Adjust texture scale",
  "move_up_one_level": "Move up one level",
  "move_down_one_level": "Move down one level",
  "move_to_front": "Move to front",
  "move_to_back": "Move to back",
  "enter_a_category_name_first": "Enter a category name first",
  "save_background_image": "Save background image",
  "enter_categoryV2": "Enter category*",
  "projection_type": "Projection type",
  "ground": "Ground",
  "top_surface": "Top surface",
  "materialV8": "Material",
  "rectangleV3": "Rectangle",
  "round": "Round",
  "hexagonV2": "Hexagon",
  "trapezoidV2": "Trapezoid",
  "undoV2": "Undo",
  "redoV2": "Redo",
  "cutout": "Cutout",
  "shadow": "Shadow",
  "reflection": "Reflection",
  "flip_horizontal": "Flip horizontal",
  "flip_vertical": "Flip vertical",
  "global_projection": "Global projection",
  "projection_length": "Projection length",
  "global_shadow": "Global shadow",
  "product_number": "Product number",
  "canvas_ratio": "Canvas ratio",
  "fit_to_background_image": "Fit to background image",
  "canvasV2": "Canvas",
  "your_work_is_saved_automatically_are_you_sure_you_want_to_exitV2": "Your work is saved automatically. Are you sure you want to exit?",
  "search_teamV2": "Search team",
  "productsV3": "Products",
  "followingV2": "Following",
  "main_product_image": "Main product image",
  "materialV9": "Material",
  "all_value": "All {{value}}",
  "materialV10": "Material",
  "move_up_one_levelV2": "Move up one level",
  "move_down_one_levelV2": "Move down one level",
  "move_to_frontV2": "Move to front",
  "move_to_backV2": "Move to back",
  "delete": "Delete",
  "i_have_renewed": "I have renewed",
  "checking_private_space_plan_status": "Checking Private Space plan status",
  "accentV2": "Accent",
  "backgroundV5": "Background",
  "delete_this_space_and_its_related_information": "Delete this space and its related information?",
  "regenerating_value_artboard": "Regenerating {{value}} artboard",
  "unknown_product": "Unknown product",
  "unknown_product_value": "Unknown product {{value}}",
  "finished_productV5": "Finished product",
  "uploading_background": "Uploading background",
  "failed_to_get_imageV2": "Failed to get image",
  "materialV11": "Material",
  "equipmentV4": "Equipment",
  "are_you_sure_you_want_to_reset": "Are you sure you want to reset?",
  "copying_image_addresses_from_third_party_websites_is_not_supported": "Copying image addresses from third-party websites is not supported",
  "processing_images_please_wait": "Processing images, please wait...",
  "no_extractable_object_was_found": "No extractable object was found.",
  "materialV12": "Material",
  "add_to_my_materialsV2": "Add to my materials",
  "you_cannot_add_your_own_material": "You cannot add your own material",
  "this_material_has_already_been_added": "This material has already been added",
  "add_to_comparisonV2": "Add to comparison",
  "different_categories_cannot_be_comparedV2": "Different categories cannot be compared",
  "all_materials": "All materials",
  "brand_categoryV2": "Brand category",
  "use_casesV5": "Use cases",
  "airportV5": "Airport",
  "railway_stationV5": "Railway station",
  "shopping_mall_supermarketV5": "Shopping mall/supermarket",
  "plazaV5": "Plaza",
  "hotelV5": "Hotel",
  "museum_exhibition_hallV5": "Museum/exhibition hall",
  "theater_ktvV5": "Theater/KTV",
  "office_buildingV5": "Office building",
  "schoolV5": "School",
  "hospitalV5": "Hospital",
  "restaurantV5": "Restaurant",
  "house_villaV5": "House/villa",
  "poolV5": "Pool",
  "sports_fieldV5": "Sports field",
  "within_one_yearV6": "Within one year",
  "more_than_one_yearV6": "More than one year",
  "material_originV3": "Material origin",
  "reference_priceV13": "Reference price",
  "all_categoriesV4": "All categories",
  "pull_to_load": "Pull to load",
  "content": "Content",
  "pinned_card": "Pinned card",
  "unfollow": "Unfollow",
  "no_contact_information_available": "No contact information available",
  "not_available": "Not available",
  "select_a_member": "Select staff",
  "no_members_available_to_reassign_to": "No staff available to reassign to",
  "select_a_member_to_handle_it": "Select staff to handle it",
  "pending": "Pending",
  "processed": "Processed",
  "ignoredV3": "Ignored",
  "quotation": "Quotation",
  "order_reassigned": "Order reassigned",
  "generate_quotation": "Generate quotation",
  "select_template": "Select template",
  "official_template": "Official template",
  "customV3": "Custom",
  "contact_supportV4": "Contact support",
  "material_nameV4": "Material name",
  "quantityV7": "Quantity",
  "enter_quantityV2": "Enter quantity",
  "unit_priceV2": "Unit price",
  "the_unit_price_cannot_be_less_than_1": "The unit price cannot be less than 1",
  "enter_unit_priceV2": "Enter unit price",
  "material_nameV5": "Material name",
  "modelV5": "Model",
  "enter_modelV3": "Enter model",
  "enter_specificationsV3": "Enter specifications",
  "select_unitV3": "Select unit",
  "quantityV8": "Quantity",
  "enter_quantityV3": "Enter quantity",
  "unit_priceV3": "Unit price",
  "the_unit_price_cannot_be_less_than_1V2": "The unit price cannot be less than 1",
  "enter_unit_priceV3": "Enter unit price",
  "no_specifications_yet": "No specifications yet",
  "select_specifications": "Select specifications",
  "activeV4": "Active",
  "this": "This",
  "this_product_has_been_unpublished": "This product has been unpublished",
  "enter_the_total_price_of_the_materials": "Enter the total price of the materials",
  "set_discount": "Set discount:",
  "discount_cannot_exceed_1": "Discount cannot exceed 1",
  "discount_must_exceed_0": "Discount must exceed 0",
  "number_of_materials": "Number of materials:",
  "total_priceV2": "Total price:",
  "discounted_priceV2": "Discounted price:",
  "quotationV2": "Quotation",
  "exportedV4": "Exported",
  "processingV2": "Processing",
  "replied": "Replied",
  "inquiry_recipient": "Inquiry recipient",
  "product_countV2": "Product count",
  "activeV5": "Active",
  "thisV2": "This",
  "this_product_has_been_unpublishedV2": "This product has been unpublished",
  "download_quotation": "Download quotation",
  "draftV4": "Draft",
  "not_approvedV2": "Not approved",
  "expiring_soon": "Expiring soon",
  "closedV3": "Closed",
  "new_participation": "New participation",
  "1_month": "1 month",
  "2_months": "2 months",
  "3_months": "3 months",
  "4_months": "4 months",
  "5_months": "5 months",
  "6_months": "6 months",
  "7_months": "7 months",
  "8_months": "8 months",
  "9_months": "9 months",
  "10_months": "10 months",
  "11_months": "11 months",
  "12_months": "12 months",
  "enter_a_valid_mobile_or_landline_numberV2": "Enter a valid mobile or landline number",
  "enter_a_valid_email_addressV4": "Enter a valid email address",
  "edit_contact_informationV2": "Edit contact information",
  "enter_at_least_one_contact_methodV2": "Enter at least one contact method",
  "enter_the_contact": "Enter the contact",
  "enter_phone_numberV3": "Enter phone number",
  "enter_email_addressV2": "Enter email address",
  "enter_wechat_name": "Enter WeChat name",
  "adjust_validity_periodV2": "Adjust validity period",
  "card_expiryV5": "Card expiry",
  "select_validity_period": "Select validity period",
  "republish": "Republish",
  "set_card_expiry": "Set card expiry",
  "set_card_expiry_date": "Set card expiry date",
  "official_site_builder": "Official site builder",
  "generate_portfolio_product_catalog": "Generate portfolio / product catalog",
  "business_partner_circle": "Business partner circle",
  "wechat_mini_program": "WeChat mini program",
  "helpV2": "Help",
  "build_a_brand_personal_enterprise_website_with_zero_code": "Build a brand (personal/enterprise) website with zero code",
  "build_a_personalized_brand_official_site_without_a_single_line_of_code": "Build a personalized brand official site without a single line of code",
  "stunning_visual_aesthetics_with_multi_language_support_for_global_expansion": "Stunning visual aesthetics with multi-language support for global expansion",
  "responsive_on_desktop_and_mobile_launch_your_brand_s_official_site_fast": "Responsive on desktop and mobile; launch your brand's official site fast",
  "generate_a_bespoke_portfolio_product_catalog": "Generate a bespoke portfolio / product catalog",
  "upload_once_and_get_a_digitized_structured_library_of_your_works_and_products": "Upload once and get a digitized, structured library of your works and products",
  "share_by_link_with_no_tedious_image_production_or_huge_files_taking_up_space": "Share by link, with no tedious image production or huge files taking up space",
  "no_manual_layout_work_aesthetic_layouts_are_generated_automatically_and_can_be_freely_categorized": "No manual layout work; aesthetic layouts are generated automatically and can be freely categorized",
  "set_sharing_content_automatically_and_track_the_entire_sharing_process": "Set sharing content automatically and track the entire sharing process",
  "multi_language_support_with_automatic_adaptation_to_desktop_tablet_mobile_large_screens_and_more": "Multi-language support with automatic adaptation to desktop, tablet, mobile, large screens, and more",
  "business_circle_business_partner_circle": "Business circle - Business partner circle",
  "traffic_between_private_spaces_gain_mutual_brand_and_product_exposure_with_the_business_partners_you_have_connected_with": "Traffic between Private Spaces: gain mutual brand and product exposure with the business partners you have connected with",
  "quickly_generate_branded_wechat_mini_programs": "Quickly generate branded WeChat mini programs",
  "no_code_required_we_generate_a_wechat_mini_program_with_your_own_branding_and_refined_visuals_in_no_time": "No code required. We generate a WeChat mini program with your own branding and refined visuals in no time",
  "bujue_zero_code_brand_website_builder_private_space_trading_tool": "Bujue — Zero-code brand website builder · Private Space trading tool",
  "get_the_app": "Get the app",
  "menu": "Menu",
  "closeV2": "Close",
  "enter_private_space": "Enter Private Space",
  "let_every_creator_and_every_enterprise": "Let every creator and every enterprise",
  "have_a_brand_home_of_their_own": "Have a brand home of their own",
  "build_a_brand_website_with_zero_code": "Build a brand website with zero code",
  "portfolio_product_catalog": "Portfolio / product catalog",
  "new_business_tools_for_private_space": "New business tools for Private Space",
  "use_now": "Use now",
  "contact_usV2": "Contact us",
  "bujue_features": "Bujue features",
  "what_bujue_does": "What Bujue does",
  "dedicated_to_the_design_home_furnishings_and_building_materials_and_wider_aesthetics_industries": "Dedicated to the design, home furnishings and building materials, and wider aesthetics industries",
  "china_s_first_luxury_home_design_and_construction_consulting_company": "China's first luxury home design and construction consulting company",
  "consulting_firm_for_the_design_and_construction_of_private_mansions": "Consulting firm for the design and construction of private mansions",
  "service_case": "Service case",
  "case_showcase": "Case showcase",
  "case_value": "Case {{value}}",
  "partner_links": "Partner links",
  "design_dedao": "Design Dedao",
  "archbase_building_materials_supply_chain": "ARCHBASE building materials supply chain",
  "help_support": "Help & support",
  "2026_hangzhou_bujue_technology_co_ltd": "© 2026 Hangzhou Bujue Technology Co., Ltd.",
  "zhejiang_icp_no_17033477_5V2": "Zhejiang ICP No. 17033477-5",
  "support_qr_codeV2": "Support QR code",
  "free_to_use": "Free to use",
  "individual_small_team": "Individual/small team",
  "medium_team": "Medium team",
  "large_team": "Large team",
  "try_bujue_for_free": "Try Bujue for free",
  "free_plan": "Free plan",
  "core_services_start_at_zero_cost": "Core services, start at zero cost",
  "free_trial_with_500mb_storage_capacity": "Free trial with 500MB storage capacity",
  "create_websites_and_portfolios_for_free": "Create websites and portfolios for free",
  "basic_business_card": "Basic business card",
  "basic": "Basic",
  "personal_plan": "Personal plan",
  "suitable_for_individuals_and_independent_creators_who_need_a_website_without_product_display_or_transaction_features": "Suitable for individuals and independent creators who need a website, without product display or transaction features",
  "10gb_storage_capacity": "10GB storage capacity",
  "custom_bujue_subdomain": "Custom Bujue subdomain",
  "basic_website_and_portfolio_features": "Basic website and portfolio features",
  "for_personal_use_only": "For personal use only",
  "contact_usV3": "Contact us",
  "standard": "Standard",
  "team_plan": "Team plan",
  "suitable_for_small_teams_and_studios_with_product_display_features": "Suitable for small teams and studios, with product display features",
  "50gb_storage_capacity": "50GB storage capacity",
  "custom_domain_redirection_service": "Custom domain redirection service",
  "no_limit_on_team_size": "No limit on team size",
  "complete_website_portfolio_and_product_library_functions": "Complete website, portfolio, and product library functions",
  "bilingual_cn_en": "Bilingual (CN/EN)",
  "professional": "Professional",
  "suitable_for_medium_sized_merchants_and_enterprises_with_product_display_and_transaction_features": "Suitable for medium-sized merchants and enterprises, with product display and transaction features",
  "200gb_storage_capacity": "200GB storage capacity",
  "transactions_supported_in_development": "Transactions supported (in development)",
  "export_file_template_customization": "Export file template customization",
  "product_qr_code_customization_service": "Product QR code customization service",
  "business_card_customization": "Business card customization",
  "website_visual_customization_service": "Website visual customization service",
  "assisted_upload_service_for_works_and_products": "Assisted upload service for works and products",
  "online_offline_training": "Online/offline training",
  "rendering_optimization": "Rendering optimization",
  "exclusive_brand_space": "Exclusive brand space",
  "build_a_brand_website_with_zero_code_individual_enterprise": "Build a brand website with zero code (individual/enterprise)",
  "portfolio_product_catalogV2": "Portfolio / product catalog",
  "new_business_tools_for_private_spaceV2": "New business tools for Private Space",
  "get_the_plan_now": "Get the plan now",
  "switch_plan": "Switch plan",
  "other_services": "Other services",
  "from_brand_domains_to_export_templates_we_offer_both_standardized_and_deep_customization_and_lower_the_barrier_to_entry_with_assisted_upload_professional_training_and_more": "From brand domains to export templates, we offer both standardized and deep customization, and lower the barrier to entry with assisted upload, professional training, and more",
  "bujue_zero_code_brand_website_builder_private_space_trading_toolV2": "Bujue — Zero-code brand website builder · Private Space trading tool",
  "website_builder": "Website builder",
  "portfolio_product_catalogV3": "Portfolio / product catalog",
  "business_circle": "Business circle",
  "wechat_mini_programV2": "WeChat mini program",
  "helpV3": "Help",
  "enter_private_spaceV2": "Enter Private Space",
  "free_registration": "Free registration",
  "let_every_creator_and_every_enterpriseV2": "Let every creator and every enterprise",
  "no_code": "No-code",
  "aesthetic_visuals": "Aesthetic visuals",
  "multi_language_support": "Multi-language support",
  "responsive_on_desktop_and_mobile": "Responsive on desktop and mobile",
  "china_s_first_luxury_home_design_and_construction_consulting_companyV2": "China's first luxury home design and construction consulting company",
  "consulting_firm_for_the_design_and_construction_of_private_mansionsV2": "Consulting firm for the design and construction of private mansions",
  "click_the_highlighted_area_in_the_top_bar": "Click the highlighted area in the top bar",
  "click_the_highlighted_products_area": "Click the highlighted \"Products\" area",
  "portfolio_product_catalogV4": "Portfolio / product catalog",
  "generate_a_bespoke_portfolio_product_catalogV2": "Generate a bespoke portfolio / product catalog",
  "upload_once_and_get_a_digitized_structured_library_of_your_works_and_productsV2": "Upload once and get a digitized, structured library of your works and products",
  "share_by_link_with_no_tedious_catalog_production_or_huge_files_taking_up_space": "Share by link, with no tedious catalog production or huge files taking up space",
  "no_manual_layout_work_aesthetic_layouts_are_generated_automatically_and_can_be_freely_categorizedV2": "No manual layout work; aesthetic layouts are generated automatically and can be freely categorized",
  "set_sharing_content_yourself_and_track_the_entire_sharing_process": "Set sharing content yourself and track the entire sharing process",
  "multi_language_support_with_automatic_adaptation_to_desktop_tablet_mobile_large_screens_and_moreV2": "Multi-language support with automatic adaptation to desktop, tablet, mobile, large screens, and more",
  "space_traffic": "Space traffic",
  "brand_exposure": "Brand exposure",
  "click_the_highlighted_business_circle_area": "Click the highlighted Business circle area",
  "click_the_highlighted_partner_network_area": "Click the highlighted Partner network area",
  "quickly_generate_branded_wechat_mini_programsV2": "Quickly generate branded WeChat mini programs",
  "previous": "Previous",
  "next": "Next",
  "use_casesV6": "Use cases",
  "how_to_use_bujue": "How to use Bujue",
  "3_500_teams_and_businesses_have_made_bujue_part_of_their_daily_work_turning_every_share_and_every_link_into_value": "3,500+ teams and businesses have made Bujue part of their daily work, turning every share and every link into value",
  "play_video": "Play video",
  "contact_usV4": "Contact us",
  "wechat_official_account_qr_code": "WeChat Official Account QR code",
  "xiaohongshu_qr_code": "Xiaohongshu QR code",
  "partner_linksV2": "Partner links",
  "design_dedaoV2": "Design Dedao",
  "project_management_tools": "Project management tools",
  "furniture_materials": "Furniture & materials",
  "archbase_building_materials_supply_chainV2": "ARCHBASE building materials supply chain",
  "bujue_featuresV2": "Bujue features",
  "help_supportV2": "Help & support",
  "zhejiang_icp_no_17033477_5V3": "Zhejiang ICP No. 17033477-5",
  "wechat_support_qr_code": "WeChat support QR code",
  "try_bujue_for_freeV2": "Try Bujue for free",
  "free_planV2": "Free plan",
  "core_services_start_at_zero_costV2": "Core services, start at zero cost",
  "free_trial_with_500mb_storage_capacityV2": "Free trial with 500MB storage capacity",
  "create_websites_and_portfolios_for_freeV2": "Create websites and portfolios for free",
  "basic_business_cardV2": "Basic business card",
  "free_to_useV2": "Free to use",
  "basicV2": "Basic",
  "personal_planV2": "Personal plan",
  "suitable_for_individuals_and_independent_creators_who_need_a_website_without_product_display_or_transaction_featuresV2": "Suitable for individuals and independent creators who need a website, without product display or transaction features",
  "10gb_storage_capacityV2": "10GB storage capacity",
  "custom_bujue_subdomainV2": "Custom Bujue subdomain",
  "basic_website_and_portfolio_featuresV2": "Basic website and portfolio features",
  "for_personal_use_onlyV2": "For personal use only",
  "standardV2": "Standard",
  "team_planV2": "Team plan",
  "suitable_for_small_teams_and_studios_with_product_display_featuresV2": "Suitable for small teams and studios, with product display features",
  "50gb_storage_capacityV2": "50GB storage capacity",
  "custom_domain_redirection_serviceV2": "Custom domain redirection service",
  "no_limit_on_team_sizeV2": "No limit on team size",
  "complete_website_portfolio_and_product_library_functionsV2": "Complete website, portfolio, and product library functions",
  "bilingual_cn_enV2": "Bilingual (CN/EN)",
  "professionalV2": "Professional",
  "suitable_for_medium_sized_merchants_and_enterprises_with_product_display_and_transaction_featuresV2": "Suitable for medium-sized merchants and enterprises, with product display and transaction features",
  "200gb_storage_capacityV2": "200GB storage capacity",
  "transactions_supported_in_developmentV2": "Transactions supported (in development)",
  "399_year": "¥399/year",
  "299_year": "¥299/year",
  "699_year": "¥699/year",
  "499_year": "¥499/year",
  "999_year": "¥999/year",
  "799_year": "¥799/year",
  "1899_year": "¥1899/year",
  "1499_year": "¥1499/year",
  "5499_year": "¥5499/year",
  "3899_year": "¥3899/year",
  "19999_year": "¥19999/year",
  "9999_year": "¥9999/year",
  "export_file_template_customizationV2": "Export file template customization",
  "product_qr_code_customization_serviceV2": "Product QR code customization service",
  "business_card_customizationV2": "Business card customization",
  "website_visual_customization_serviceV2": "Website visual customization service",
  "assisted_upload_service_for_works_and_productsV2": "Assisted upload service for works and products",
  "online_offline_trainingV2": "Online/offline training",
  "rendering_optimizationV2": "Rendering optimization",
  "contact_usV5": "Contact us",
  "other_servicesV2": "Other services",
  "from_brand_domains_to_export_templates_we_offer_both_standardized_and_deep_customization_and_lower_the_barrier_to_entry_with_assisted_upload_professional_training_and_moreV2": "From brand domains to export templates, we offer both standardized and deep customization, and lower the barrier to entry with assisted upload, professional training, and more",
  "10_000_individuals_and_3_500_team_and_business_users_are_using_bujue": "10,000+ individuals and 3,500+ team and business users are using Bujue",
  "opening_the_app_please_wait": "Opening the app, please wait",
  "service_hours_9_00_17_30": "Service hours: 9:00-17:30",
  "consultation_analysis_and_answers": "Consultation, analysis, and answers",
  "pairing_recommendations_and_usage_tips": "Pairing recommendations and usage tips",
  "configuration_list": "Configuration list",
  "members_only_privileges": "Members-only privileges",
  "membership_rulesV4": "Membership rules",
  "payment_countdown": "Payment countdown:",
  "become_a_member": "Become a member",
  "payment_status": "Payment status",
  "view_my_membership": "View my membership",
  "modern_style": "Modern style",
  "villa": "Villa",
  "works_library": "Works library",
  "publish_work": "Publish work",
  "value_is_not_an_imageV10": "{{value}} is not an image",
  "other_fields": "Other fields",
  "no_product_information": "No product information",
  "related_works": "Related works",
  "shared_productV3": "Shared product",
  "removed_from_favoritesV3": "Removed from favorites",
  "added_to_favoritesV5": "Added to favorites",
  "product_unavailable": "Product unavailable",
  "other_fieldsV2": "Other fields",
  "total_value_itemsV8": "Total {{value}} items",
  "emptyV3": "Empty",
  "reference_priceV14": "Reference price",
  "other_contact_details": "Other contact details",
  "other_fieldsV3": "Other fields",
  "other_fieldsV4": "Other fields",
  "all_certificates": "All certificates",
  "all_accessories": "All accessories",
  "all_nodes": "All nodes",
  "other_fieldsV5": "Other fields",
  "add_to_comparisonV3": "Add to comparison",
  "add_failedV2": "Add failed",
  "request_sampleV2": "Request sample",
  "my_product_library": "My product library",
  "related_worksV2": "Related works",
  "customizableV3": "Customizable",
  "material_libraryV2": "Material library",
  "device_library": "Device library",
  "finished_product_library": "Finished product library",
  "device_libraryV2": "Device library",
  "curatedV10": "Curated",
  "material_libraryV3": "Material library",
  "curatedV11": "Curated",
  "finished_productV6": "Finished product",
  "globalV4": "Global",
  "reference_priceV15": "Reference price",
  "views_ascending": "Views (ascending)",
  "views_descending": "Views (descending)",
  "name_a_z": "Name A→Z",
  "name_z_a": "Name Z→A",
  "this_private_space_has_been_suspended": "This Private Space has been suspended",
  "get_the_discount_code_first": "Get the discount code first",
  "discount_code_copied": "Discount code copied",
  "channel_codeV2": "Channel code",
  "congratulations_your_value_has_been_published_successfully": "Congratulations! Your \"{{value}}\" has been published successfully",
  "or": "Or",
  "check_it_out": "Check it out",
  "edit_shipping_address": "Edit shipping address",
  "add_shipping_address": "Add shipping address",
  "area": "Area",
  "enter_detailed_addressV3": "Enter detailed address",
  "enter_recipient_name": "Enter recipient name",
  "enter_recipient_phone_number": "Enter recipient phone number",
  "are_you_sure_you_want_to_delete_this_shipping_address": "Are you sure you want to delete this shipping address?",
  "material_nameV6": "Material name",
  "application_timeV6": "Application time",
  "requested_quantityV3": "Requested quantity",
  "bujue_supplier_onboarding_agreement_and_rules": "Bujue Supplier Onboarding Agreement and Rules",
  "introduction": "Introduction",
  "1_conclusion_of_this_agreement": "1. Conclusion of this agreement",
  "2_instructions_for_using_the_onboarding_system": "2. Instructions for using the onboarding system",
  "3_supplier_onboarding_requirements_and_supporting_documents": "3. Supplier onboarding requirements and supporting documents",
  "1_suppliers_must_meet_the_following_conditions_to_register_on_this_website": "(1) Suppliers must meet the following conditions to register on this website:",
  "2_submission_of_supporting_documents": "(2) Submission of supporting documents:",
  "4_supplier_onboarding_process": "4. Supplier onboarding process",
  "suppliers_must_complete_all_of_the_following_steps_before_they_can_use_supplier_related_features_normally_on_the_bujue_platform": "Suppliers must complete all of the following steps before they can use supplier-related features normally on the Bujue platform:",
  "5_fees_charged_by_the_bujue_platform": "5. Fees charged by the Bujue platform",
  "1_good_faith_deposit": "(1) Good-faith deposit",
  "suppliers_that_meet_all_of_the_following_conditions_may_apply_for_a_refund_of_the_good_faith_deposit_on_the_good_faith_deposit_management_page": "Suppliers that meet all of the following conditions may apply for a refund of the good-faith deposit on the good-faith deposit management page:",
  "1_there_are_no_outstanding_reports_and_or_dispute_cases": "1. There are no outstanding reports and/or dispute cases;",
  "2_there_are_no_outstanding_advances_payable_to_the_bujue_platform": "2. There are no outstanding advances payable to the Bujue platform;",
  "3_there_are_no_unfinished_shipments": "3. There are no unfinished shipments;",
  "4_the_completion_time_of_the_last_transaction_has_exceeded_90_calendar_days": "4. The completion time of the last transaction has exceeded 90 calendar days;",
  "2_technical_service_fees": "(2) Technical service fees",
  "1_when_a_user_purchases_materials_from_a_supplier_through_the_bujue_platform_and_the_order_is_completed_including_partially_completed_the_bujue_platform_has_the_right_to_charge_the_supplier_a_technical_service_fee_of_0_20_of_the_order_amount_the_exact_rate_is_determined_by_the_relevant_rules_of_the_bujue_platform": "1. When a user purchases materials from a supplier through the Bujue platform and the order is completed (including partially completed), the Bujue platform has the right to charge the supplier a technical service fee of 0%-20% of the order amount (the exact rate is determined by the relevant rules of the Bujue platform);",
  "6_description_of_the_service_agreement_and_rules": "6. Description of the service agreement and rules",
  "1_supplier_s_rights_and_obligations": "(1) Supplier's rights and obligations",
  "2_rights_and_obligations_of_this_website": "(2) Rights and obligations of this website",
  "3_intellectual_property_rights": "(3) Intellectual property rights",
  "4_anti_bribery_clause": "(4) Anti-bribery clause",
  "1_in_order_to_build_a_sound_market_order_on_the_bujue_platform_and_a_healthy_platform_environment_suppliers_agree_to_and_voluntarily_comply_with_all_of_the_following_rules": "1. In order to build a sound market order on the Bujue platform and a healthy platform environment, suppliers agree to and voluntarily comply with all of the following rules:",
  "5_termination_of_onboarding_system_services": "(5) Termination of onboarding system services",
  "6_modifications_to_this_agreement": "(6) Modifications to this agreement",
  "7_application_of_law_and_dispute_resolution": "(7) Application of law and dispute resolution",
  "i_have_read_the_above_agreementV2": "I have read the above agreement",
  "read_and_accept_the_agreementV2": "Read and accept the agreement",
  "supplier_onboarding": "Supplier onboarding",
  "supplier_onboarding_application": "Supplier onboarding application",
  "value_sharing": "{{value}} sharing",
  "space_sharing": "Space sharing",
  "value_sharingV2": "-{{value}} sharing",
  "value_products_in_total": "{{value}} products in total",
  "hd_assetsV4": "HD assets",
  "warning": "Warning",
  "heitiV2": "Heiti",
  "kaitiV2": "Kaiti",
  "fangsongV2": "Fangsong",
  "biaukaiV2": "BiauKai",
  "stfangsongV2": "STFangsong",
  "stkaitiV2": "STKaiti",
  "songtiV2": "Songti",
  "microsoft_yaheiV2": "Microsoft YaHei",
  "gongfan_fontV2": "Gongfan font",
  "pangmenzhengdao_bold_calligraphyV2": "Pangmenzhengdao bold calligraphy",
  "yanshi_chunfeng_kaiV2": "Yanshi Chunfeng Kai",
  "youshe_haoshentiV2": "Youshe Haoshenti",
  "sanji_xingkai_simplified_chineseV2": "Sanji Xingkai Simplified Chinese",
  "header_backgroundV2": "Header background",
  "header_backgroundV3": "Header background",
  "shared_productV4": "Shared product",
  "globalV5": "Global",
  "nationwideV3": "China (nationwide)",
  "space_sharingV2": "Space sharing",
  "follow_space": "Follow Space",
  "up_to_500_items_per_inquiry": "Up to 500 items per inquiry",
  "enter_your_phone_number_or_email": "Enter your phone number or email",
  "shared_productV5": "Shared product",
  "overseas_version_product_sharing": "Overseas version product sharing",
  "shares": "Shares",
  "titleV4": "Title",
  "descriptionV2": "Description",
  "duration": "Duration",
  "value_minutes_value_seconds": "{{value}} minutes {{value}} seconds",
  "value_minutes": "{{value}} minutes",
  "value_minutes_value_secondsV2": "{{value}} minutes {{value}} seconds",
  "value_hours_value_minutes_value_seconds": "{{value}} hours {{value}} minutes {{value}} seconds",
  "value_days_value_hours_value_minutes_value_seconds": "{{value}} days {{value}} hours {{value}} minutes {{value}} seconds",
  "share_title": "Share title",
  "share_link": "Share link",
  "usage_limit": "Usage limit",
  "share_type": "Share type",
  "shared_productV6": "Shared product",
  "space_sharingV3": "Space sharing",
  "mini_program_space_sharing": "Mini Program space sharing",
  "introduction_sharing": "Introduction sharing",
  "time_spent": "Time spent",
  "dwell_time_is_tracked_only_for_work_shares_and_product_shares_data_refreshes_every_15_minutes": "Dwell time is tracked only for work shares and product shares; data refreshes every 15 minutes.",
  "reads": "Reads",
  "content_list": "Content list",
  "are_you_sure_you_want_to_delete_this_record": "Are you sure you want to delete this record?",
  "search_keywords": "Search keywords",
  "total_value_itemsV9": "Total {{value}} items",
  "number_of_shares": "Number of shares",
  "content_listV2": "Content list",
  "view_count_statistics": "View count statistics",
  "dwell_time_statistics": "Dwell time statistics",
  "finished_productV7": "Finished product",
  "update_failedV2": "Update failed",
  "update_to_this_version": "Update to this version?",
  "already_up_to_date": "Already up to date",
  "stack_bond": "Stack bond",
  "straight_lay": "Straight lay",
  "herringbone_paving": "Herringbone paving",
  "herringbone": "Herringbone",
  "staggered": "Staggered",
  "brick_bond": "Brick bond",
  "bevel": "Bevel",
  "corner": "Corner",
  "center": "Center",
  "gap_depth_lower_limit": "Gap depth lower limit",
  "value_must_be_an_integer_greater_than_or_equal_to_0": "Value must be an integer greater than or equal to 0",
  "value_must_be_a_positive_integer": "Value must be a positive integer",
  "gap_depth": "Gap depth",
  "the_left_value_of_brick_thickness_must_be_less_than_or_equal_to_the_right_value": "The left value of brick thickness must be less than or equal to the right value",
  "paving_style": "Paving style",
  "row_offset": "Row offset",
  "brick_length": "Brick length",
  "brick_width": "Brick width",
  "fixed_thickness": "Fixed thickness",
  "brick_joint_width": "Brick joint width",
  "gap_width": "Gap width",
  "add_chamfer": "Add chamfer",
  "chamfer_size": "Chamfer size",
  "starting_point": "Starting point",
  "degree": "Degree",
  "rotation_angle": "Rotation angle",
  "starting_point_0_degree_offset": "Starting point 0 degree offset",
  "starting_point_90_degree_offset": "Starting point 90 degree offset",
  "processingV3": "Processing...",
  "start_processing": "Start processing",
  "stop_processing": "Stop processing",
  "specification_valueV3": "Specification {{value}}",
  "no_textures_match_the_current_filter": "No textures match the current filter",
  "you_do_not_have_permission_to_access_this_team_s_library_request_permission_from_an_administrator_and_try_again": "You do not have permission to access this team's library. Request permission from an administrator and try again.",
  "the_product_library_is_disabled_for_this_team": "The product library is disabled for this team",
  "the_team_has_been_deactivated": "The team has been deactivated",
  "the_team_has_been_deleted": "The team has been deleted",
  "all_rights_reserved": "All rights reserved",
  "bujue_technology_co_ltd": "Bujue Technology Co., Ltd.",
  "update_to_this_versionV2": "Update to this version?",
  "already_up_to_dateV2": "Already up to date",
  "my_participation": "My participation",
  "prepare_documents": "Prepare documents",
  "prepare_all_the_required_documents_in_advance_so_you_can_pass_the_review_in_one_go": "Prepare all the required documents in advance so you can pass the review in one go.",
  "business_license_id_card_photo": "Business license, ID card photo",
  "apply_to_join": "Apply to join",
  "fill_in_your_onboarding_information_as_prompted_and_upload_the_required_qualifications": "Fill in your onboarding information as prompted and upload the required qualifications.",
  "submit_for_review": "Submit for review",
  "review_takes_up_to_2_business_days_actual_time_may_vary": "Review takes up to 2 business days (actual time may vary).",
  "whether_or_not_your_application_is_approved_we_will_notify_you_of_the_result_by_sms": "Whether or not your application is approved, we will notify you of the result by SMS.",
  "onboarding_complete": "Onboarding complete",
  "you_can_log_in_to_bujue_space_gallery_supplier_platform_to_manage_your_store": "You can log in to \"Bujue Space Gallery - Supplier Platform\" to manage your store.",
  "join_now": "Join now",
  "supplier_onboarding_process": "Supplier onboarding process",
  "loadingV5": "Loading",
  "are_you_sure_you_want_to_valueV2": "Are you sure you want to {{value}}?",
  "value_successful": "{{value}} successful",
  "are_you_sure_you_want_to_valueV3": "Are you sure you want to {{value}}?",
  "value_successfulV2": "{{value}} successful",
  "are_you_sure_you_want_to_valueV4": "Are you sure you want to {{value}}?",
  "value_successfulV3": "{{value}} successful",
  "finished_productV8": "Finished product",
  "operation_failed_please_try_again_later": "Operation failed, please try again later",
  "brand_categoryV3": "Brand category",
  "all_statusesV2": "All statuses",
  "curatedV12": "Curated",
  "unpublish_all_items": "Unpublish all items?",
  "creation_time_status": "Creation time & status",
  "ban_publishingV2": "Ban publishing",
  "set_recommended_products": "Set recommended products",
  "confirm_settings": "Confirm settings",
  "new_picks": "New picks",
  "supplier_settings": "Supplier settings",
  "qualification_is_deactivated": "Qualification is deactivated",
  "supplier_closure": "Supplier closure",
  "your_supplier_qualification_has_been_deactivated_due_to_value_and_similar_conduct": "Your supplier qualification has been deactivated due to {{value}} and similar conduct.",
  "this_supplier_has_been_shut_down_for_rule_violations_and_illegal_conduct": "This supplier has been shut down for rule violations and illegal conduct.",
  "name_cannot_exceed_20_characters": "Name cannot exceed 20 characters",
  "position_cannot_exceed_20_characters": "Position cannot exceed 20 characters",
  "phone_number_cannot_exceed_50_characters": "Phone number cannot exceed 50 characters",
  "email_cannot_exceed_100_characters": "Email cannot exceed 100 characters",
  "remarks_cannot_exceed_100_characters": "Remarks cannot exceed 100 characters",
  "click_to_refresh": "Click to refresh",
  "wechatV4": "WeChat",
  "wechat_pay_has_a_daily_limit_of_cny_10_000": "WeChat Pay has a daily limit of CNY 10,000",
  "chinese_nV3": "Chinese N",
  "mini_program_share_image": "Mini Program share image",
  "recommended_size_40x50_png_image": "Recommended size: 40x50 PNG image",
  "private_space_data_is_being_translated_please_do_not_add_new_dataV2": "Private Space data is being translated. Please do not add new data.",
  "open": "Open",
  "offV2": "Off",
  "value_is_not_an_imageV11": "{{value}} is not an image",
  "value_file_upload_failedV2": "{{value}} file upload failed.",
  "space_logo": "Space logo",
  "i_have_read_and_agree_to_the_agreement": "I have read and agree to the agreement",
  "1_exclusive_product_library_create_a_private_space_and_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "1. Exclusive product library: Create a Private Space and add products to your personal or team product library for more efficient centralized management.",
  "2_creative_board_tool_pull_in_products_and_textures_directly_generate_a_product_list_or_white_paper_with_one_click_and_present_your_proposal_with_ease": "2. Creative board tool: Pull in products and textures directly, generate a product list or white paper with one click, and present your proposal with ease.",
  "3_plug_in_tool_library_works_with_revit_3dmax_rhino_sketchup_and_other_design_software_so_you_can_pull_in_product_models_and_textures_at_any_time_and_improve_design_efficiency": "3. Plug-in tool library: Works with Revit, 3DMax, Rhino, SketchUp and other design software, so you can pull in product models and textures at any time and improve design efficiency.",
  "4_zicai_ocean_publish_products_to_the_public_marketplace_zicai_ocean_with_one_click_to_expand_exposure": "4. Zicai Ocean: Publish products to the public marketplace (Zicai Ocean) with one click to expand exposure.",
  "closeV3": "Close",
  "create_a_private_space_to_automatically_save_the_product_data_you_add": "Create a Private Space to automatically save the product data you add",
  "design_private_space_service_slogandesign_private_space_service_slogan": "Design Private Space service sloganDesign Private Space service slogan",
  "address_is_required": "Address is required",
  "logoV6": "Logo",
  "private_space_product_publish_unpublish_review": "Private Space product publish/unpublish review",
  "view_now": "View now",
  "you_have_new_review_results_for_your_private_space_products_check_them_now": "You have new review results for your Private Space products. Check them now.",
  "enter_your_space_nickname": "Enter your Space nickname",
  "application_submittedV2": "Application submitted",
  "join_the_private_space": "Join the Private Space",
  "no_signature_yet": "No signature yet",
  "app_not_installed_tap_to_download": "App not installed. Tap to download",
  "a_sharing_platform_that_empowers_designers": "A sharing platform that empowers designers",
  "free_personalized_official_site": "Free, personalized official site",
  "efficient_and_fast_customization_platform": "Efficient and fast customization platform",
  "professional_presentation_of_business_negotiations": "Professional presentation of business negotiations",
  "branding_and_marketing_assistant": "Branding and marketing assistant",
  "efficient_professional_portfolio_library": "Efficient, professional portfolio library",
  "photos_videos_and_vr_works_presented_in_multiple_formats": "Photos, videos and VR works presented in multiple formats",
  "share_your_content_with_one_click": "Share your content with one click",
  "quickly_share_what_you_need": "Quickly share what you need",
  "share_your_portfolio_freely": "Share your portfolio freely",
  "open_bujue": "Open Bujue",
  "download_bujue": "Download Bujue",
  "open_this_page_in_a_browser": "Open this page in a browser",
  "enter_your_space_nicknameV2": "Enter your Space nickname",
  "application_submittedV3": "Application submitted",
  "you_are_already_a_member_of_this_private_space": "You are already staff of this Private Space",
  "the_application_has_been_sent_and_is_waiting_for_review": "The application has been sent and is waiting for review",
  "no_signature_yetV2": "No signature yet",
  "this_content_is_private_you_can_view_it_after_joining_the_private_space": "This content is private. You can view it after joining the Private Space.",
  "nickname_in_private_space": "Nickname in Private Space",
  "application_submittedV4": "Application submitted",
  "search_design_spaces": "Search design Spaces",
  "joinedV3": "Joined",
  "applied": "Applied",
  "join_nowV2": "Join now",
  "fully_openV3": "Fully open",
  "anyone_can_joinV2": "Anyone can join",
  "semi_openV3": "Semi-open",
  "closedV4": "Closed",
  "invitation_onlyV2": "Invitation only",
  "access_settingsV2": "Access settings",
  "member_joiningV2": "Staff joining",
  "visitor_browsingV2": "Visitor browsing",
  "get_the_verification_codeV3": "Get the verification code",
  "enter_new_phone_numberV2": "Enter new phone number",
  "enter_new_emailV2": "Enter new email",
  "the_new_phone_number_is_the_same_as_the_old_phone_numberV2": "The new phone number is the same as the old phone number",
  "failed_to_get_verification_code_try_againV8": "Failed to get verification code. Try again.",
  "delete_this_space": "Delete this Space?",
  "select_a_recipient": "Select a recipient",
  "select_a_member_to_transfer_to": "Select staff to transfer to",
  "this_user_already_owns_the_maximum_number_of_private_spaces_so_the_transfer_cannot_be_completed": "This user already owns the maximum number of Private Spaces, so the transfer cannot be completed",
  "delete_space": "Delete Space",
  "identity_verificationV3": "Identity verification",
  "verifyV3": "Verify",
  "enter_verification_codeV7": "Enter verification code",
  "transfer_administrator_rights": "Transfer administrator rights",
  "confirm_transfer": "Confirm transfer",
  "search_people": "Search people",
  "enter_username_or_password": "Enter username or password",
  "enter_confirmation_password": "Enter confirmation password",
  "set_login_password": "Set login password",
  "enter_username": "Enter username",
  "enter_passwordV2": "Enter password",
  "enter_password_again": "Enter password again",
  "permission_settings": "Permission settings",
  "team_store_published_content_statistics": "Team store published content statistics",
  "team_store_unpublished_content_statistics": "Team store unpublished content statistics",
  "team_store_publish_rejection_statistics": "Team store publish rejection statistics",
  "team_store_publish_success_statistics": "Team store publish success statistics",
  "service_area_value": "Service area: {{value}}",
  "globalV6": "Global",
  "private_space_status_is_normal": "Private Space status is normal",
  "this_private_space_has_been_deleted": "This Private Space has been deleted",
  "space_deleted": "Space deleted",
  "space_disabledV2": "Space disabled",
  "space_disabledV3": "Space disabled",
  "all_brands": "All brands",
  "search_brands": "Search brands",
  "no_brand_data_yet": "No brand data yet",
  "brand_supplier_list": "Brand supplier list",
  "sign_contract": "Sign contract",
  "contract_expired": "Contract expired",
  "you_can_upload_up_to_value_itemsV2": "You can upload up to {{value}} items",
  "device_libraryV3": "Device library",
  "material_libraryV4": "Material library",
  "hd_assetsV5": "HD assets",
  "warningV2": "Warning",
  "materialV13": "Material",
  "equipmentV5": "Equipment",
  "finished_productV9": "Finished product",
  "info": "Info",
  "member": "Staff",
  "security_settingsV3": "Security settings",
  "billing": "Billing",
  "finished_productV10": "Finished product",
  "this_product_has_already_been_addedV2": "This product has already been added",
  "product_list_fixed_price": "Product list fixed price",
  "product_list_price_range": "Product list price range",
  "unknown_categoryV2": "Unknown category",
  "titleV5": "Title:",
  "link": "Link:",
  "no_download_link_yet": "No download link yet",
  "the_value_plugin_lets_you_use_textures_and_models_from_your_private_space_product_library_directlyV2": "The {{value}} plugin lets you use textures and models from your Private Space product library directly",
  "stay_tunedV2": "Stay tuned",
  "invitee": "Invitee",
  "onboarding_dateV2": "Onboarding date",
  "download_poster": "Download poster",
  "brand_categoryV4": "Brand category",
  "personal_information": "Personal information",
  "bioV2": "Bio",
  "add_a_personalized_signature": "Add a personalized signature..",
  "brand_categoryV5": "Brand category",
  "my_materials": "My materials",
  "enter_material_name_color_nameV2": "Enter material name/color name",
  "use_casesV7": "Use cases",
  "airportV6": "Airport",
  "railway_stationV6": "Railway station",
  "shopping_mall_supermarketV6": "Shopping mall/supermarket",
  "plazaV6": "Plaza",
  "hotelV6": "Hotel",
  "museum_exhibition_hallV6": "Museum/exhibition hall",
  "theater_ktvV6": "Theater/KTV",
  "office_buildingV6": "Office building",
  "schoolV6": "School",
  "hospitalV6": "Hospital",
  "restaurantV6": "Restaurant",
  "house_villaV6": "House/villa",
  "poolV6": "Pool",
  "sports_fieldV6": "Sports field",
  "within_one_yearV7": "Within one year",
  "more_than_one_yearV7": "More than one year",
  "material_originV4": "Material origin",
  "reference_priceV16": "Reference price",
  "set_to_public": "Set to public",
  "reason_for_unpublishingV4": "Reason for unpublishing:",
  "privateV6": "Private",
  "material_added": "Material added",
  "different_categories_cannot_be_comparedV3": "Different categories cannot be compared",
  "unlikeV3": "Unlike",
  "brand_categoryV6": "Brand category",
  "disabledV5": "Disabled",
  "view_reason": "View reason",
  "enter_private_spaceV3": "Enter Private Space",
  "user_agreement_to_be_added": "User agreement, to be added",
  "modern_minimalist_style": "Modern minimalist style",
  "classical_style": "Classical style",
  "art_deco_style_shanghai_style": "Art Deco style/Shanghai style",
  "industrial_style_urban_style": "Industrial style/urban style",
  "country_style_pastoral_style": "Country style/pastoral style",
  "chinese_style": "Chinese style",
  "mediterranean_style": "Mediterranean style",
  "southeast_asian_style": "Southeast Asian style",
  "wabi_sabi_style": "Wabi-sabi style",
  "japanese_style": "Japanese style",
  "draftV5": "Draft",
  "unpublishedV3": "Unpublished",
  "privateV7": "Private",
  "material_listV3": "Material list",
  "no_description_yet": "No description yet",
  "renderings_photos": "Renderings/photos",
  "main_material_list": "Main material list",
  "no_materials_addedV2": "No materials added",
  "export_material_list": "Export material list",
  "select_export_template": "Select export template",
  "default_template": "Default template",
  "export_nodes_simultaneously": "Export nodes simultaneously",
  "export_asset_textures_simultaneously": "Export asset textures simultaneously",
  "select_export_templateV2": "Select export template",
  "exportV5": "Export",
  "exportingV2": "Exporting...",
  "envelope_s": "Envelope(s)",
  "surface": "Surface",
  "video_optimization_pending": "Video optimization pending",
  "optimizing_video": "Optimizing video",
  "annotation_points_overlap": "Annotation points overlap",
  "save_the_previous_annotation_first": "Save the previous annotation first",
  "select_valueV3": "Select {{value}}",
  "chinese_nV4": "Chinese N",
  "value_m": "{{value}} m²",
  "value_present": "{{value}}-present",
  "summary": "Summary",
  "this_is_sample_text": "This is sample text",
  "drag_to_reorderV2": "Drag to reorder",
  "merge_into": "\" merge into \"",
  "confirm": "Confirm \"",
  "merge_successful": "Merge successful",
  "merge_failed": "Merge failed",
  "drag_here_to_merge_categories": "Drag here to merge categories",
  "value_file_upload_failedV3": "{{value}} file upload failed.",
  "logoV7": "Logo",
  "value_file_upload_failedV4": "{{value}} file upload failed.",
  "video": "Video",
  "cover_cannot_be_reordered": "Cover cannot be reordered",
  "cloud_drive_is_fullV2": "Cloud drive is full",
  "some_files_exceed_the_available_cloud_drive_spaceV2": "Some files exceed the available cloud drive space",
  "duplicate_style_name_merge": "Duplicate style name. Merge?",
  "duplicate_type_name_merge": "Duplicate type name. Merge?",
  "no_url": "No URL",
  "enter_node_nameV2": "Enter node name",
  "nodeV5": "Node",
  "node_name_is_requiredV3": "Node name is required",
  "node_nameV3": "Node name",
  "upload_schematic_diagramV2": "Upload schematic diagram",
  "schematic_diagramV3": "Schematic diagram",
  "applicable_materials_are_requiredV4": "Applicable materials are required",
  "applicable_materialsV3": "Applicable materials",
  "drawingsV3": "Drawings",
  "draftV6": "Draft",
  "reject_applicationV3": "Reject application",
  "unpublishedV4": "Unpublished",
  "all_styles": "All styles",
  "modern_minimalist_styleV2": "Modern minimalist style",
  "classical_styleV2": "Classical style",
  "art_deco_style_shanghai_styleV2": "Art Deco style/Shanghai style",
  "industrial_style_urban_styleV2": "Industrial style/urban style",
  "country_style_pastoral_styleV2": "Country style/pastoral style",
  "chinese_styleV2": "Chinese style",
  "mediterranean_styleV2": "Mediterranean style",
  "southeast_asian_styleV2": "Southeast Asian style",
  "wabi_sabi_styleV2": "Wabi-sabi style",
  "japanese_styleV2": "Japanese style",
  "value_reason": "{{value}} reason",
  "value_reason_value": "{{value}} reason: {{value}}",
  "delete_this_work": "Delete this work?",
  "search_my_work": "Search my work",
  "work_style": "Work style",
  "scan_the_qr_code_with_wechat_to_open": "Scan the QR code with WeChat to open",
  "click_to_learn_more": "Click to learn more",
  "click_to_learn_moreV2": "Click to learn more",
  "unpublishedV5": "Unpublished",
  "overview": "Overview",
  "attributesV4": "Attributes",
  "experienceV2": "Experience",
  "inspection_certificateV2": "Inspection certificate",
  "usage_scenarios": "Usage scenarios",
  "styling_suggestions": "Styling suggestions",
  "nodeV6": "Node",
  "packaging_information": "Packaging information",
  "accessories": "Accessories",
  "detailed_design_serviceV2": "Detailed design service",
  "regular_customer": "Regular customer",
  "officialV3": "Official",
  "indoorV3": "Indoor",
  "outdoorV3": "Outdoor",
  "semi_outdoor_spaceV3": "Semi-outdoor space",
  "basementV3": "Basement",
  "roofV3": "Roof",
  "exterior_wallV3": "Exterior wall",
  "courtyardV3": "Courtyard",
  "airportV7": "Airport",
  "railway_stationV7": "Railway station",
  "shopping_mall_supermarketV7": "Shopping mall/supermarket",
  "plazaV7": "Plaza",
  "hotelV7": "Hotel",
  "museum_exhibition_hallV7": "Museum/exhibition hall",
  "theater_ktvV7": "Theater/KTV",
  "office_buildingV7": "Office building",
  "schoolV7": "School",
  "hospitalV7": "Hospital",
  "restaurantV7": "Restaurant",
  "house_villaV7": "House/villa",
  "poolV7": "Pool",
  "sports_fieldV7": "Sports field",
  "draftV7": "Draft",
  "publication_under_review": "Publication under review",
  "sensitive_words": "Sensitive words",
  "completeness": "Completeness",
  "reject": "Reject",
  "not_curatedV2": "Not curated",
  "sensitive_content_review": "Sensitive content review",
  "not_approvedV3": "Not approved",
  "sensitive_content_review_passed": "Sensitive content review passed",
  "completeness_review_passed": "Completeness review passed",
  "completeness_review_failed": "Completeness review failed",
  "main_image": "Main image",
  "related_worksV3": "Related works",
  "materialV14": "Material",
  "equipmentV6": "Equipment",
  "finished_productV11": "Finished product",
  "material_libraryV5": "Material library",
  "device_libraryV4": "Device library",
  "finished_product_libraryV2": "Finished product library",
  "activeV6": "Active",
  "terminatedV2": "Terminated",
  "about_page": "About page",
  "works_libraryV2": "Works library",
  "team_supplier": "Team supplier",
  "not_signed": "Not signed",
  "sign_contractV2": "Sign contract",
  "partnership_expired": "Partnership expired",
  "slice": "Slice",
  "bottle": "Bottle",
  "case": "Case",
  "box": "Box",
  "bundle": "Bundle",
  "package": "Package",
  "barrel": "Barrel",
  "pallet": "Pallet",
  "roll": "Roll",
  "m²": "m²",
  "l": "L",
  "kg": "Kg",
  "t": "t",
  "upload_up_to": "Upload up to",
  "size_exceeds_the_limit_width_height_must_be_15000_pixels_or_less": "Size exceeds the limit (width/height must be 15000 pixels or less)",
  "beijingV2": "Beijing",
  "tianjinV2": "Tianjin",
  "shanghaiV2": "Shanghai",
  "chongqingV2": "Chongqing",
  "hebei": "Hebei",
  "shanxi": "Shanxi",
  "liaoning": "Liaoning",
  "jilin": "Jilin",
  "heilongjiang": "Heilongjiang",
  "jiangsu": "Jiangsu",
  "zhejiangV2": "Zhejiang",
  "anhui": "Anhui",
  "fujian": "Fujian",
  "jiangxi": "Jiangxi",
  "shandong": "Shandong",
  "henan": "Henan",
  "hubei": "Hubei",
  "hunan": "Hunan",
  "guangdong": "Guangdong",
  "guangxi": "Guangxi",
  "hainan": "Hainan",
  "sichuan": "Sichuan",
  "guizhou": "Guizhou",
  "yunnan": "Yunnan",
  "tibet": "Tibet",
  "shaanxi": "Shaanxi",
  "gansu": "Gansu",
  "qinghai": "Qinghai",
  "ningxia": "Ningxia",
  "inner_mongolia": "Inner Mongolia",
  "inner_mongoliaV2": "Inner Mongolia",
  "xinjiang": "Xinjiang",
  "taiwan": "Taiwan",
  "hong_kong": "Hong Kong",
  "macau": "Macau",
  "aba": "Aba",
  "aksu": "Aksu",
  "altay": "Altay",
  "ngari": "Ngari",
  "anqing": "Anqing",
  "anshan": "Anshan",
  "anshun": "Anshun",
  "anyang": "Anyang",
  "baicheng": "Baicheng",
  "baise": "Baise",
  "baishan": "Baishan",
  "baiyin": "Baiyin",
  "bengbu": "Bengbu",
  "baoding": "Baoding",
  "baoji": "Baoji",
  "baoshan": "Baoshan",
  "baotou": "Baotou",
  "bayannur": "Bayannur",
  "bayingolin": "Bayingolin",
  "benxi": "Benxi",
  "bijie": "Bijie",
  "binzhou": "Binzhou",
  "bortala": "Bortala",
  "bozhou": "Bozhou",
  "cangzhou": "Cangzhou",
  "changchun": "Changchun",
  "changde": "Changde",
  "changji": "Changji",
  "changshaV2": "Changsha",
  "changzhou": "Changzhou",
  "chaohu": "Chaohu",
  "chaoyang": "Chaoyang",
  "chaozhou": "Chaozhou",
  "chengde": "Chengde",
  "chengduV2": "Chengdu",
  "chenzhou": "Chenzhou",
  "chifeng": "Chifeng",
  "chizhou": "Chizhou",
  "chongzuo": "Chongzuo",
  "chuzhou": "Chuzhou",
  "dali": "Dali",
  "dalian": "Dalian",
  "dandong": "Dandong",
  "daqing": "Daqing",
  "datong": "Datong",
  "daxing_anling": "Daxing'anling",
  "dazhou": "Dazhou",
  "dehong": "Dehong",
  "deyang": "Deyang",
  "dezhou": "Dezhou",
  "dingxi": "Dingxi",
  "dongguanV2": "Dongguan",
  "dongying": "Dongying",
  "ezhou": "Ezhou",
  "enshi": "Enshi",
  "ordos": "Ordos",
  "foshan": "Foshan",
  "fushun": "Fushun",
  "fuxin": "Fuxin",
  "fuyang": "Fuyang",
  "fuzhou": "Fuzhou",
  "gannan": "Gannan",
  "ganzhou": "Ganzhou",
  "guang_an": "Guang'an",
  "guangyuan": "Guangyuan",
  "guangzhouV2": "Guangzhou",
  "guigang": "Guigang",
  "guilin": "Guilin",
  "guiyang": "Guiyang",
  "guyuan": "Guyuan",
  "harbin": "Harbin",
  "haibei": "Haibei",
  "haidong": "Haidong",
  "haikou": "Haikou",
  "haixi": "Haixi",
  "hami": "Hami",
  "handan": "Handan",
  "hangzhouV3": "Hangzhou",
  "hanzhong": "Hanzhong",
  "hebi": "Hebi",
  "hechi": "Hechi",
  "hefei": "Hefei",
  "hegang": "Hegang",
  "heihe": "Heihe",
  "hengshui": "Hengshui",
  "hengyang": "Hengyang",
  "hotan": "Hotan",
  "heyuan": "Heyuan",
  "heze": "Heze",
  "hezhou": "Hezhou",
  "honghe": "Honghe",
  "huai_an": "Huai'an",
  "huaibei": "Huaibei",
  "huaihua": "Huaihua",
  "huainan": "Huainan",
  "huanggang": "Huanggang",
  "huangnan": "Huangnan",
  "huangshan": "Huangshan",
  "huangshi": "Huangshi",
  "hohhot": "Hohhot",
  "huizhou": "Huizhou",
  "hulunbuir": "Hulunbuir",
  "huzhou": "Huzhou",
  "jiamusi": "Jiamusi",
  "ji_an": "Ji'an",
  "jiangmen": "Jiangmen",
  "jiaozuo": "Jiaozuo",
  "jiaxing": "Jiaxing",
  "jiayuguan": "Jiayuguan",
  "jieyang": "Jieyang",
  "jinan": "Jinan",
  "jinchang": "Jinchang",
  "jincheng": "Jincheng",
  "jingdezhen": "Jingdezhen",
  "jingmen": "Jingmen",
  "jingzhou": "Jingzhou",
  "jinhua": "Jinhua",
  "jining": "Jining",
  "jinzhong": "Jinzhong",
  "jinzhou": "Jinzhou",
  "jiujiang": "Jiujiang",
  "jiuquan": "Jiuquan",
  "jixi": "Jixi",
  "kaifeng": "Kaifeng",
  "kashgar": "Kashgar",
  "karamay": "Karamay",
  "kizilsu": "Kizilsu",
  "kunming": "Kunming",
  "laibin": "Laibin",
  "laiwu": "Laiwu",
  "langfang": "Langfang",
  "lanzhou": "Lanzhou",
  "lhasa": "Lhasa",
  "leshan": "Leshan",
  "liangshan": "Liangshan",
  "lianyungang": "Lianyungang",
  "liaocheng": "Liaocheng",
  "liaoyang": "Liaoyang",
  "liaoyuan": "Liaoyuan",
  "lijiang": "Lijiang",
  "lincang": "Lincang",
  "linfen": "Linfen",
  "linxia": "Linxia",
  "linyi": "Linyi",
  "nyingchi": "Nyingchi",
  "lishui": "Lishui",
  "liuzhou": "Liuzhou",
  "longnan": "Longnan",
  "longyan": "Longyan",
  "loudi": "Loudi",
  "luohe": "Luohe",
  "luoyang": "Luoyang",
  "luzhou": "Luzhou",
  "l_liang": "Lüliang",
  "ma_anshan": "Ma'anshan",
  "maoming": "Maoming",
  "meishan": "Meishan",
  "meizhou": "Meizhou",
  "mianyang": "Mianyang",
  "mudanjiang": "Mudanjiang",
  "nanchang": "Nanchang",
  "nanchong": "Nanchong",
  "nanjingV2": "Nanjing",
  "nanning": "Nanning",
  "nanping": "Nanping",
  "nanyang": "Nanyang",
  "nagqu": "Nagqu",
  "neijiang": "Neijiang",
  "ningboV2": "Ningbo",
  "ningde": "Ningde",
  "nujiang": "Nujiang",
  "panjin": "Panjin",
  "panzhihua": "Panzhihua",
  "pingdingshan": "Pingdingshan",
  "pingliang": "Pingliang",
  "pingxiang": "Pingxiang",
  "putian": "Putian",
  "puyang": "Puyang",
  "qiandongnan": "Qiandongnan",
  "qiannan": "Qiannan",
  "qianxinan": "Qianxinan",
  "qingdaoV2": "Qingdao",
  "qingyang": "Qingyang",
  "qingyuan": "Qingyuan",
  "qinhuangdao": "Qinhuangdao",
  "qinzhou": "Qinzhou",
  "qiqihar": "Qiqihar",
  "qitaihe": "Qitaihe",
  "quanzhou": "Quanzhou",
  "qujing": "Qujing",
  "quzhou": "Quzhou",
  "shigatse": "Shigatse",
  "rizhao": "Rizhao",
  "sanmenxia": "Sanmenxia",
  "sanming": "Sanming",
  "sanya": "Sanya",
  "shangluo": "Shangluo",
  "shangqiu": "Shangqiu",
  "shangrao": "Shangrao",
  "shannan": "Shannan",
  "shantou": "Shantou",
  "shanwei": "Shanwei",
  "shaoguan": "Shaoguan",
  "shaoxing": "Shaoxing",
  "shaoyang": "Shaoyang",
  "shennongjia": "Shennongjia",
  "shenyangV2": "Shenyang",
  "shenzhenV2": "Shenzhen",
  "shijiazhuang": "Shijiazhuang",
  "shiyan": "Shiyan",
  "shizuishan": "Shizuishan",
  "shuangyashan": "Shuangyashan",
  "shuozhou": "Shuozhou",
  "siping": "Siping",
  "songyuan": "Songyuan",
  "suihua": "Suihua",
  "suining": "Suining",
  "suizhou": "Suizhou",
  "suqian": "Suqian",
  "suzhouV2": "Suzhou",
  "tacheng": "Tacheng",
  "tai_an": "Tai'an",
  "taiyuan": "Taiyuan",
  "taizhou": "Taizhou",
  "tangshan": "Tangshan",
  "tianshui": "Tianshui",
  "tieling": "Tieling",
  "tongchuan": "Tongchuan",
  "tonghua": "Tonghua",
  "tongliao": "Tongliao",
  "tongling": "Tongling",
  "tongren": "Tongren",
  "turpan": "Turpan",
  "weifang": "Weifang",
  "weihai": "Weihai",
  "weinan": "Weinan",
  "wenshan": "Wenshan",
  "wenzhou": "Wenzhou",
  "wuhai": "Wuhai",
  "wuhanV2": "Wuhan",
  "wuhu": "Wuhu",
  "ulanqab": "Ulanqab",
  "urumqi": "Urumqi",
  "wuwei": "Wuwei",
  "wuxiV2": "Wuxi",
  "wuzhong": "Wuzhong",
  "wuzhou": "Wuzhou",
  "xiamen": "Xiamen",
  "xi_anV2": "Xi'an",
  "xiangtan": "Xiangtan",
  "xiangxi": "Xiangxi",
  "xianning": "Xianning",
  "xianyang": "Xianyang",
  "xiaogan": "Xiaogan",
  "xilingol": "Xilingol",
  "xing_an": "Xing'an",
  "xingtai": "Xingtai",
  "xining": "Xining",
  "xinxiang": "Xinxiang",
  "xinyang": "Xinyang",
  "xinyu": "Xinyu",
  "xinzhou": "Xinzhou",
  "xishuangbanna": "Xishuangbanna",
  "xuancheng": "Xuancheng",
  "xuchang": "Xuchang",
  "xuzhou": "Xuzhou",
  "ya_an": "Ya'an",
  "yan_an": "Yan'an",
  "yanbian": "Yanbian",
  "yancheng": "Yancheng",
  "yangjiang": "Yangjiang",
  "yangquan": "Yangquan",
  "yangzhou": "Yangzhou",
  "yantai": "Yantai",
  "yibin": "Yibin",
  "yichang": "Yichang",
  "yichun": "Yichun",
  "ili_kazakh": "Ili Kazakh",
  "yinchuan": "Yinchuan",
  "yingkou": "Yingkou",
  "yingtan": "Yingtan",
  "yiyang": "Yiyang",
  "yongzhou": "Yongzhou",
  "yueyang": "Yueyang",
  "yulin": "Yulin",
  "yulinV2": "Yulin",
  "yuncheng": "Yuncheng",
  "yunfu": "Yunfu",
  "yunlin": "Yunlin",
  "yuxi": "Yuxi",
  "zaozhuang": "Zaozhuang",
  "zhangjiajie": "Zhangjiajie",
  "zhangjiakou": "Zhangjiakou",
  "zhangye": "Zhangye",
  "zhangzhou": "Zhangzhou",
  "zhanjiang": "Zhanjiang",
  "zhaoqing": "Zhaoqing",
  "zhaotong": "Zhaotong",
  "zhengzhou": "Zhengzhou",
  "zhenjiang": "Zhenjiang",
  "zhongshan": "Zhongshan",
  "zhongwei": "Zhongwei",
  "zhoukou": "Zhoukou",
  "zhoushan": "Zhoushan",
  "zhuhai": "Zhuhai",
  "zhuzhou": "Zhuzhou",
  "zibo": "Zibo",
  "zigong": "Zigong",
  "ziyang": "Ziyang",
  "zunyi": "Zunyi",
  "japaneseV2": "Japanese",
  "wechatV5": "WeChat",
  "unknown_device": "Unknown device",
  "only_image_files_are_allowed": "Only image files are allowed.",
  "product_textureV3": "Product texture",
  "commissioned_assets": "Commissioned assets",
  "insufficient_capacity": "Insufficient capacity",
  "your_cloud_storage_is_running_low_to_avoid_interruptions_we_recommend_upgrading_your_capacity_as_soon_as_possible": "Your cloud storage is running low. To avoid interruptions, we recommend upgrading your capacity as soon as possible.",
  "expand_capacity": "Expand capacity",
  "for_proper_display_the_long_edge_must_be_at_least_value_we_recommend_uploading_images_of_value_value_or_larger": "For proper display, the long edge must be at least {{value}}. We recommend uploading images of {{value}}*{{value}} or larger.",
  "for_better_display_quality_upload_images_of_value_value_or_larger": "For better display quality, upload images of {{value}}*{{value}} or larger.",
  "exit_failed_use_f11_to_exit_full_screen": "Exit failed. Use F11 to exit full screen.",
  "network_busy_try_again_later": "Network busy. Try again later.",
  "the_user_is_currently_in_the_queue": "The user is currently in the queue.",
  "the_image_does_not_exist": "The image does not exist.",
  "the_image_size_or_resolution_does_not_meet_the_requirements": "The image size or resolution does not meet the requirements.",
  "you_have_already_added_this_product_to_favorites_do_not_add_it_again": "You have already added this product to favorites. Do not add it again.",
  "the_current_product_type_does_not_match_the_products_in_the_pk_list": "The current product type does not match the products in the PK list.",
  "this_brand_name_already_exists": "This brand name already exists.",
  "an_error_occurred_while_deleting_the_supplier_associated_with_the_team_brand_brandid_id": "An error occurred while deleting the supplier associated with the team brand. brandId:{{id}}",
  "an_error_occurred_while_deleting_the_product_associated_with_the_team_brand_brandid_id": "An error occurred while deleting the product associated with the team brand. brandId:{{id}}",
  "the_token_is_invalid": "The token is invalid.",
  "alipay_payment_error_error": "Alipay payment error: {{error}}",
  "token_expired": "Token expired",
  "the_user_is_not_logged_in": "The user is not logged in.",
  "this_supplier_name_already_exists": "This supplier name already exists.",
  "the_deadline_cannot_be_earlier_than_today": "The deadline cannot be earlier than today.",
  "associated_brands_exist_remove_the_associations_first": "Associated brands exist. Remove the associations first.",
  "id_is_required": "ID is required",
  "parameters_are_required": "Parameters are required",
  "log_in_to_download": "Log in to download.",
  "the_file_does_not_exist": "The file does not exist.",
  "log_in_to_preview": "Log in to preview.",
  "missing_parameters": "Missing parameters",
  "the_token_is_invalidV2": "The token is invalid.",
  "user_information_is_required": "User information is required",
  "system_busy_try_again_later": "System busy. Try again later.",
  "complete_security_verification": "Complete security verification.",
  "general_notice": "General notice",
  "general_notice_we_have_launched_the_featurename_feature": "General notice: We have launched the {{featureName}} feature.",
  "in_my_space_you_can_view_your_share_history_following_and_spaces": "In My Space, you can view your share history, following, and spaces.",
  "the_current_account_does_not_have_a_space_yet": "The current account does not have a space yet.",
  "create_a_space_first_to_unlock_a_new_product_management_experience": "Create a space first to unlock a new product management experience.",
  "click_create_below_to_finish_creating_your_space_and_access_the_following_resources": "Click Create below to finish creating your space and access the following resources.",
  "exclusive_product_library_create_a_space_to_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "Exclusive product library: Create a space to add products to your personal or team product library for more efficient centralized management.",
  "space_logoV2": "Space logo",
  "name_is_requiredV7": "Name is required",
  "i_have_read_and_agree_to_the_bujue_space_service_agreement": "I have read and agree to the Bujue Space Service Agreement.",
  "thank_you_for_choosing_our_product_you_now_receive_capacity_mb_of_permanently_free_storage_effective_immediately_enjoy": "Thank you for choosing our product. You now receive {{capacity}} MB of permanently free storage, effective immediately. Enjoy!",
  "english_and_japanese_language_packs_have_been_activated_for": "English and Japanese language packs have been activated for {私域名称}.",
  "go_to_basic_info_settings": "Go to Basic info settings.",
  "the_introduction_uses_the_same_configuration_across_all_languages": "The introduction uses the same configuration across all languages.",
  "scan_and_share_qr_code": "Scan and share QR code",
  "share_language": "Share language",
  "you_can_also_copy_the_link_and_send_it_to_your_friends": "You can also copy the link and send it to your friends.",
  "one_click_download_batch_download_chinese_source_text_to_be_confirmed": "One-click download / batch download (Chinese source text to be confirmed)",
  "key_vault": "Key vault",
  "product_asset_library": "Product asset library",
  "reviews": "Reviews",
  "space_id": "Space ID",
  "panbagua": "Panbagua",
  "bujue_app": "Bujue App",
  "cny": "￥{价格}CNY",
  "bioV3": "Bio:",
  "add_a_bio": "Add a bio…",
  "spaces_i_manage": "Spaces I manage",
  "spaces_i_ve_joined": "Spaces I've joined",
  "third_party_accounts": "Third-party accounts",
  "to_keep_your_account_secure_please_verify_your_identity_you_can_continue_once_verification_succeeds": "To keep your account secure, please verify your identity. You can continue once verification succeeds.",
  "use_phone_number": "Use phone number",
  "use_email": "Use email",
  "enter_the_email_address_you_want_to_link": "Enter the email address you want to link",
  "enter_the_phone_number_you_want_to_link": "Enter the phone number you want to link",
  "you_are_not_logged_inV2": "You are not logged in",
  "failed_to_get_the_verification_code_please_try_again": "Failed to get the verification code. Please try again.",
  "waiting_for_administrator_review": "Waiting for administrator review",
  "entering_the_private_space_in_count_s": "Entering the Private Space in {{count}}s",
  "open_the_app": "Open the app",
  "keep_both": "Keep both",
  "replace": "Replace",
  "create_folder": "Create folder",
  "only_images_can_be_uploaded_to_the_product_asset_libraryV2": "Only images can be uploaded to the product asset library",
  "file_names_cannot_contain_the_following_charactersV4": "File names cannot contain the following characters:",
  "this_file_cannot_be_previewed_online_download_it_to_view": "This file cannot be previewed online. Download it to view?",
  "texture_library_folders_cannot_be_moved_in_or_outV2": "Texture library folders cannot be moved in or out",
  "files_can_only_be_moved_into_product_asset_library_folders": "Files can only be moved into the product asset library folder",
  "texture_library_folders_cannot_be_moved_outV2": "Texture library folders cannot be moved out",
  "folders_other_than_texture_library_folders_cannot_be_moved_inV2": "Folders other than texture library folders cannot be moved in",
  "cannot_move_to_the_name_folder": "Cannot move to the {{name}} folder",
  "the_name_library_cannot_be_renamed_moved_or_deleted_and_no_files_or_folders_can_be_added_to_it": "The {{name}} library cannot be renamed, moved, or deleted, and no files or folders can be added to it",
  "name_cannot_be_renamed_moved_or_deleted": "{{name}} cannot be renamed, moved, or deleted",
  "count_items_in_total": "{{count}} items in total",
  "manage_files_in_this_folder_display_images_linked_to_name_are_not_affected": "Manage files in this folder. Display images linked to {{name}} are not affected.",
  "manage_files_in_this_folder_award_certificates_linked_to_name_are_not_affected": "Manage files in this folder. Award certificates linked to {{name}} are not affected.",
  "count_uploads_completed": "{{count}} uploads completed",
  "count_uploads_in_progress": "{{count}} uploads in progress",
  "private_space_list": "Private Space list",
  "private_space_data": "Private Space data",
  "data_overview": "Data overview",
  "data_details": "Data details",
  "all_content": "All content",
  "count_new": "{{count}} new items!",
  "listed": "Listed:",
  "time_spent_total": "Time spent (total)",
  "daily_time_spent": "Daily time spent",
  "ascending": "Ascending",
  "descending": "Descending",
  "region": "Area",
  "no_contact_information_availableV2": "No contact information available",
  "generate": "Generate",
  "exportedV5": "Exported",
  "design_type": "Design type",
  "select_a_memberV2": "Select staff",
  "no_members_available_to_reassign_toV2": "No staff available to reassign to",
  "save_draft": "Save draft",
  "total_count_items": "Total {{count}} items",
  "favorited_count": "Favorited ({{count}})",
  "min": "min",
  "sec": "sec",
  "hr": "Time",
  "phone": "phone",
  "email": "Email:",
  "submitted_by": "Submitted by:",
  "submitted_at": "Submission time",
  "other_contact": "Other contact details",
  "generate_quotationV2": "Generate quotation",
  "view_quotation": "View quotation",
  "checking_membership_status_please_wait": "Checking membership status, please wait",
  "no_agreement_template_configured": "No agreement template configured",
  "open_this_link_on_a_computerV2": "Open this link on a computer",
  "link_phone_or_email": "Link phone or email",
  "linked_successfullyV3": "Linked successfully",
  "this_private_space": "This Private Space",
  "exclusive_product_library": "Exclusive product library",
  "create_a_private_space_and_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "Create a Private Space and add products to your personal or team product library for more efficient centralized management.",
  "creative_board_tool": "Creative board tool",
  "pull_in_products_and_textures_directly_generate_a_product_list_or_white_paper_with_one_click_and_present_your_proposal_with_ease": "Pull in products and textures directly, generate a product list or white paper with one click, and present your proposal with ease.",
  "plug_in_tool_library": "Plug-in tool library",
  "works_with_revit_3dmax_rhino_sketchup_and_other_design_software_so_you_can_pull_in_product_models_and_textures_at_any_time_and_improve_design_efficiency": "Works with Revit, 3DMax, Rhino, SketchUp and other design software, so you can pull in product models and textures at any time and improve design efficiency.",
  "publish_products_to_the_public_marketplace_zicai_ocean_with_one_click_to_expand_exposure": "Publish products to the public marketplace (Zicai Ocean) with one click to expand exposure.",
  "the_name_cannot_exceed_40_characters": "The name cannot exceed 40 characters",
  "the_private_space_name_contains_sensitive_words": "The Private Space name contains sensitive words",
  "enter_the_private_space_name": "Enter the Private Space name",
  "view_item_index": "View item {{index}}",
  "please_confirm_and_check_the_agreement_first": "Please confirm and check the agreement first",
  "password_box": "Password box",
  // —— 设计中心下拉「项目管理工具」入口（2026-10-26）——
  "项目管理工具": "Project management tool",
}

export const PolyglotZhJson = {
  // 用户中心下拉菜单及弹窗
  "let_every_creator_and_every_enterpriseV2": "让每一个创作者、每一个企业",
  "最多只能关联 {{maxCount}} 张图片": "最多只能关联 {{maxCount}} 张图片",
  "个人信息": "个人信息",
  "名片信息": "名片信息",
  "账号管理": "账号管理",
  "个性签名": "个性签名",
  "个性签名：": "个性签名：",
  "添加个性签名..": "添加个性签名..",
  "当前账号暂无私域": "当前账号暂无私域",
  "请先创建私域，开启产品管理新体验": "请先创建私域，开启产品管理新体验",
  "我管理的私域": "我管理的私域",
  "我加入的私域": "我加入的私域",
  "已停用": "已停用",
  "删除私域": "删除私域",
  "删除私域之后，私域在平台上的数据将被清除，且不可恢复。": "删除私域之后，私域在平台上的数据将被清除，且不可恢复。",
  "移交私域": "移交私域",
  "会员": "会员",
  "查看原因": "查看原因",
  "第三方账号": "第三方账号",
  "微信": "微信",
  "解绑": "解绑",
  "未绑定": "未绑定",
  "解绑成功": "解绑成功",
  "确认要解除绑定吗？": "确认要解除绑定吗？",
  "身份验证": "身份验证",
  "验证": "验证",
  "为了你的账户安全,请验证身份,验证成功后进行下一步操作.": "为了你的账户安全,请验证身份,验证成功后进行下一步操作.",
  "使用手机号": "使用手机号",
  "使用邮箱": "使用邮箱",
  "请输入验证码": "请输入验证码",
  "请获取验证码": "请获取验证码",
  "绑定成功": "绑定成功",
  "绑定邮箱": "绑定邮箱",
  "请输入您要绑定的邮箱地址": "请输入您要绑定的邮箱地址",
  "请输入有效邮箱地址": "请输入有效邮箱地址",
  "绑定手机号": "绑定手机号",
  "请输入您要绑定的手机号码": "请输入您要绑定的手机号码",
  "请输入用户名或密码": "请输入用户名或密码",
  "请输入确认密码": "请输入确认密码",
  "请输入密码": "请输入密码",
  "请输入用户名": "请输入用户名",
  "请确认密码": "请确认密码",
  "确认密码": "确认密码",
  "两次密码不一致": "两次密码不一致",
  "请再次输入密码": "请再次输入密码",
  "确认新密码": "确认新密码",
  "新密码": "新密码",
  "密码绑定": "密码绑定",
  "设置登录密码": "设置登录密码",
  "绑定微信": "绑定微信",
  "请扫二维码绑定微信": "请扫二维码绑定微信",
  "当前用户未登录！": "当前用户未登录！",
  "暂无权限！": "暂无权限！",
  "该手机号/邮箱账号已被占用，请更换其他手机号/邮箱账号再试。": "该手机号/邮箱账号已被占用，请更换其他手机号/邮箱账号再试。",
  "请输入新手机号": "请输入新手机号",
  "请输入新邮箱": "请输入新邮箱",
  "新手机号与旧手机号相同": "新手机号与旧手机号相同",
  "获取验证码失败,请重新获取": "获取验证码失败,请重新获取",
  "未设置": "未设置",
  "姓名不能超过20个字": "姓名不能超过20个字",
  "职位不能超过20个字": "职位不能超过20个字",
  "电话不能超过50个字": "电话不能超过50个字",
  "邮箱不能超过100个字": "邮箱不能超过100个字",
  "备注不能超过100个字": "备注不能超过100个字",
  "我的空间": "我的空间",
  "入驻成为供应商": "入驻成为供应商",
  "切换为设计师": "切换为设计师",
  "账户设置": "账户设置",
  "帮助中心": "帮助中心",
  "您的浏览器暂时不支持添加快捷方式，推荐使用chrome或safari浏览器": "您的浏览器暂时不支持添加快捷方式，推荐使用chrome或safari浏览器",
  "安装快捷方式": "安装快捷方式",
  "退出登录": "退出登录",
  "供应商终止合作": "供应商终止合作",
  "咨询电话：{{phone}}": "咨询电话：{{phone}}",
  "恭喜您领取成功": "恭喜您领取成功",
  "平台已免费赠送您三个月会员": "平台已<gift>免费赠送</gift>您<membership>三个月会员</membership>",
  "有效期至：{{date}}": "有效期至：{{date}}",
  "开心收下": "开心收下",
  "您有<count>{{count}}条</count>新的询价需要处理": "您有<count>{{count}}条</count>新的询价需要处理",
  "共计{{count}}个产品": "共计{{count}}个产品",
  // —— 二元文案 t() 化新增（2026-07-17）——
  "{{name}}字段已存在！": "{{name}}字段已存在",
  "您的数据我们将为您保留至{{time}}。为保证数据安全，请及时续费。": "您的数据我们将为您保留至{{time}}。为保证数据安全，请及时续费。",
  "一次最多只能导入{{n}}张模版": "一次最多只能导入{{n}}张模版",
  "共{{n}}页": "共{{n}}页",
  "已选{{n}}页": "已选{{n}}页",
  "第{{n}}页": "第{{n}}页",
  "新增标记": "新增",
  "输入手机号或邮箱": "输入手机号或邮箱",
  "委托添加{{name}}数据": "委托添加{{name}}数据",
  "{{team}}委托您添加私域库数据，点击链接开始操作：{{url}}": "{{team}}委托您添加私域库数据，点击链接开始操作：{{url}}",
  "确认将该{{name}}下架吗？": "确认将该{{name}}下架吗？",
  "确认导出{{count}}个已入库产品的二维码？": "确认导出 {{count}}个已入库产品的二维码？",
  "你没有{{name}}的管理权限，继续操作将退出管理模式，是否继续？": "你没有{{name}}的管理权限，继续操作将退出管理模式，是否继续？",
  "暂无可{{type}}私域": "暂无可{{type}}私域",
  "已解除{{name}}，确认是否删除，确认后消失。": "已解除{{name}}，确认是否删除，确认后消失。",
  "取消{{name}}": "取消{{name}}",
  "这里还没有{{name}}方的介绍": "这里还没有{{name}}方的介绍",
  // —— 入库数据完整性校验（2026-07-28）——
  "数据完整性校验未通过": "数据完整性校验未通过",
  "入库失败{{count}}条": "入库失败{{count}}条",
  "入库成功{{count}}条": "入库成功{{count}}条",
  "入库成功{{successCount}}条": "入库成功{{successCount}}条",
  "入库成功{{successCount}}条,失败{{failCount}}条": "入库成功{{successCount}}条,失败{{failCount}}条",
  "入库成功{{successCount}}条，失败{{failCount}}条": "入库成功{{successCount}}条，失败{{failCount}}条",
  "入库成功{{successCount}}条，未处理{{unprocessedCount}}条": "入库成功{{successCount}}条，未处理{{unprocessedCount}}条",
  "入库成功{{successCount}}条，失败{{failCount}}条，未处理{{unprocessedCount}}条": "入库成功{{successCount}}条，失败{{failCount}}条，未处理{{unprocessedCount}}条",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失": "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，未处理{{unprocessedCount}}条": "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，未处理{{unprocessedCount}}条",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词": "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词": "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条",
  "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词": "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词",
  "入库失败,{{requiredCount}}个产品必填项缺失": "入库失败,{{requiredCount}}个产品必填项缺失",
  "入库失败,{{sensitiveCount}}条产品存在敏感词": "入库失败,{{sensitiveCount}}条产品存在敏感词",
  "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条",
  "入库失败,{{requiredCount}}个产品必填项缺失，未处理{{unprocessedCount}}条": "入库失败,{{requiredCount}}个产品必填项缺失，未处理{{unprocessedCount}}条",
  "入库失败,{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "入库失败,{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条",
  "当前选中产品不支持入库操作": "当前选中产品不支持入库操作",
  "当前选中产品不支持上架操作": "当前选中产品不支持上架操作",
  "当前选中产品不支持下架操作": "当前选中产品不支持下架操作",
  "提交审核{{submitCount}}条": "提交审核{{submitCount}}条",
  "已提交审核{{submitCount}}条": "已提交审核{{submitCount}}条",
  "已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条": "已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条",
  "上架成功{{successCount}}条": "上架成功{{successCount}}条",
  "上架成功{{successCount}}条，未处理{{unprocessedCount}}条": "上架成功{{successCount}}条，未处理{{unprocessedCount}}条",
  "上架成功{{successCount}}条，已提交审核{{submitCount}}条": "上架成功{{successCount}}条，已提交审核{{submitCount}}条",
  "上架成功{{successCount}}条，已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条": "上架成功{{successCount}}条，已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条",
  "上架失败{{failCount}}条": "上架失败{{failCount}}条",
  "下架成功{{successCount}}条": "下架成功{{successCount}}条",
  "已下架{{successCount}}条": "已下架{{successCount}}条",
  "已下架{{successCount}}条，未处理{{unprocessedCount}}条": "已下架{{successCount}}条，未处理{{unprocessedCount}}条",
  "下架失败{{failCount}}条": "下架失败{{failCount}}条",
  "状态不支持{{unsupportedCount}}条": "状态不支持{{unsupportedCount}}条",
  "未处理{{unprocessedCount}}条": "未处理{{unprocessedCount}}条",
  "上架成功{{successCount}}条,失败{{failCount}}条": "上架成功{{successCount}}条,失败{{failCount}}条",
  "入库成功{{successCount}}条,失败{{failCount}}条": "入库成功{{successCount}}条，失败{{failCount}}条",
  "句号": "。",
  "逗号": "，",
  //需要配置 中文的中文 不然如果先用 当前语言环境下没有的内容优先取上一个语言环境的内容
  "时间": "时间",
  "风格": "风格",
  "类型": "类型",
  "内容展示": "内容展示",
  "基本信息": "基本信息",
  "获奖证书": "获奖证书",
  "媒体宣传": "媒体宣传",
  "无": "无",
  "暂无数据": "暂无数据",
  "没有更多了": "没有更多了",
  "上架时间": "上架时间",
  "上市时间": "上市时间",
  "入库时间": "入库时间",
  "名称排序": "名称排序",
  "默认排序": "默认排序",
  "正序": "正序",
  "倒序": "倒序",
  "分类": "分类",
  "分类N": "分类",
  "全部": "全部",
  "所有产品": "所有产品",
  "全部{{name}}": "全部{{name}}",
  "现场勘测": "现场勘测",
  "深化设计": "深化设计",
  "代安装": "代安装",
  "代施工": "代施工",
  "代加工": "代加工",
  "送货上门": "送货上门",
  "其他": "其他",
  "保养": "保养",
  "一周内": "一周内",
  "一个月内": "一个月内",
  "三个月内": "三个月内",
  "半年内": "半年内",
  "重置": "重置",
  "确认内容": "确认内容",
  "效果": "效果",
  "效果N": "效果",
  "素材": "素材",
  "款式": "款式",
  "款式N": "款式",
  "产品参数": "产品参数",
  "品牌": "品牌",
  "品牌N": "品牌",
  "合资": "合资",
  "进口": "进口",
  "国产": "国产",
  "原创": "原创",
  "产品类型": "产品类型",
  "选择产品类型": "选择产品类型",
  "供货周期": "供货周期",
  "配套服务": "配套服务",
  "附件": "附件",
  "名片": "名片",
  "价格:": "价格：",
  "案例": "案例",
  "联系方式": "联系方式",
  "姓名": "姓名",
  "手机号": "手机号",
  "邮箱": "邮箱",
  "已选内容": "已选内容",
  "提交询价": "提交询价",
  "返回": "返回",
  "提交成功": "提交成功",
  "您的询价正在处理中": "您的询价正在处理中",
  "您的询价正在处理中，前往不觉app查看询价记录": "您的询价正在处理中，前往不觉app查看询价记录",
  "您的询价正在处理中，前往不觉官网-我的询价查看": "您的询价正在处理中，前往不觉官网-我的询价查看",
  "新手引导": "新手引导",
  "知道了": "知道了",
  "无附件数据": "无附件数据",
  "供应商信息": "供应商信息",
  "品牌信息": "品牌信息",
  "分类信息": "分类信息",
  "产品": "产品",
  "介绍": "介绍",
  "作品": "作品",
  "筛选": "筛选",
  "滑动查看": "滑动查看",
  "点击进入": "点击进入",
  "点击开始": "点击开始",
  "￥": "￥",
  "品牌类型": "品牌类型",
  "安全防护": "安全防护",
  "厨房电器": "厨房电器",
  "电气设备": "电气设备",
  "儿童家具": "儿童家具",
  "辅材配件": "辅材配件",
  "户外园艺": "户外园艺",
  "基础结构": "基础结构",
  "家居纺织品": "家居纺织品",
  "建筑节能": "建筑节能",
  "建筑围护": "建筑围护",
  "洁具卫浴": "洁具卫浴",
  "楼梯与扶手": "楼梯与扶手",
  "门窗类": "门窗类",
  "面层材料": "面层材料",
  "全屋定制": "全屋定制",
  "软装家居": "软装家居",
  "施工工具": "施工工具",
  "水电暖通": "水电暖通",
  "照明灯具": "照明灯具",
  "智能家居": "智能家居",
  "装饰线条": "装饰线条",
  "件": "件",
  "/件": "/件",
  "张": "张",
  "个": "个",
  "台": "台",
  "片": "片",
  "瓶": "瓶",
  "箱": "箱",
  "盒": "盒",
  "捆": "捆",
  "包": "包",
  "桶": "桶",
  "托": "托",
  "卷": "卷",
  "米": "米",
  "平方米": "平方米",
  "升": "升",
  "千克": "千克",
  "吨": "吨",
  "扇": "扇",
  "套": "套",
  "跳过": "跳过",
  "暂无价格": "暂无价格",
  "¥ {{price}} 起": "¥ {{price}} 起",
  "¥ {{price}} 起": "¥ {{price}} 起",
  "产品列表固定价格": "¥ {{price}}",
  "产品列表区间价格": "¥ {{price}}<unit> 起</unit>",
  "请输入名称": "请输入名称",
  "请输入手机号": "请输入手机号",
  "请输入邮箱": "请输入邮箱",
  "请输地区": "请输地区",
  "请输其他联系方式": "请输其他联系方式",
  "提交": "提交",
  "至少保留一项": "至少保留一项",
  "品牌：": "品牌：",
  "展开": "展开",
  "折叠": "折叠",
  "品牌:": "品牌:",
  "类型:": "类型:",
  "周期:": "周期:",
  "上市时间:": "上市时间:",
  "服务:": "服务:",
  "供货周期:": "供货周期:",
  "备注:": "备注:",
  "贴图": "贴图",
  "贴图N": "贴图",
  "平铺": "平铺",
  "平铺N": "平铺",
  "列表": "列表",
  "批量下载": "批量下载",
  "共": "共",
  "个文件": "个文件",
  "张贴图": "张贴图",
  "个模型": "个模型",
  "材质": "材质",
  "规格:": "规格：",
  "规格": "规格",
  "作品信息": "作品信息",
  "时间：": "时间：",
  "类型：": "类型：",
  "查看作品": "查看作品",
  "材质:": "材质：",
  "图库": "图库",
  "简介": "简介",
  "当前锚点": "当前锚点",
  "所有锚点": "所有锚点",
  "选择资材类型": "选择资材类型",
  "资材类型": "资材类型",
  "服务范围": "服务范围",
  "选择服务范围": "选择服务范围",
  "询价": "询价",
  "退出": "退出",
  "确定": "确定",
  "退出批量设置": "退出批量设置",
  "全选": "全选",
  "：": "：",
  "取消": "取消",
  "请输入您的姓名": "请输入您的姓名",
  "请输入您的邮箱": "请输入您的邮箱",
  "请输入您的地区": "请输入您的地区",
  "暂无附件": "暂无附件",
  "未开通国际版": "未开通国际版",
  "电话咨询": "电话咨询",
  "所有图片": "所有图片",
  "附件不支持下载，请联系供应商": "附件不支持下载，请联系供应商",
  "附件不支持下载，请联系管理员": "附件不支持下载，请联系管理员",
  "品牌馆": "品牌馆",
  "进入品牌": "进入品牌",
  "请至少选择一条产品": "请至少选择一条产品",
  "数量不能小于1": "数量不能小于1",
  "附件下载": "附件下载",
  "下载附件": "下载附件",
  "应用案例": "应用案例",
  "名称": "名称",
  "已认证": "已认证",
  "海外版官网": "海外版官网",
  "开发中": "开发中",
  "选择类型": "选择类型",
  "选择": "选择",
  "分享设置": "分享设置",
  "已选": "已选",
  "已选：": "已选：",
  "已选：{{n}}/{{total}}": "已选：{{n}}/{{total}}",
  "上一步": "上一步",
  "下一步": "下一步",
  "分享": "分享",
  "请输入搜索": "请输入搜索",
  "请输入搜索内容": "请输入搜索内容",
  "选择展示方式": "选择展示方式",
  "平铺模式": "平铺模式",
  "合集": "合集",
  "设置默认视图": "设置默认视图",
  "已选择": "已选择",
  "拖动排序": "拖动排序",
  "单次分享上限100个": "单次分享上限100个",
  "浏览次数：": "浏览次数：",
  "不限制": "不限制",
  "限制": "限制",
  "请输入": "请输入",
  "有效期限：": "有效期限：",
  "1天": "1天",
  "7天": "7天",
  "永久": "永久",
  "确认订单": "确认订单",
  "购买语言：": "购买语言：",
  "选择支付方式：": "选择支付方式：",
  "购买即同意": "购买即同意",
  "《不觉付费服务协议》": "《不觉付费服务协议》",
  "《不觉付费协议》": "《不觉付费协议》",
  "合计：": "合计：",
  "立即支付": "立即支付",
  "语言包": "语言包",
  "套餐对比": "套餐对比",
  "服务咨询": "服务咨询",
  "示例效果": "示例效果",
  "即将上线，敬请期待！": "即将上线，敬请期待！",
  "当前语言已开通": "当前语言已开通",
  "订单已结束": "订单已结束",
  "开通成功": "开通成功",
  "该语言": "该语言",
  "{{lang}}开通成功！正在自动翻译当前私域数据，稍后将收到翻译完成提醒":
    "{{lang}}开通成功，正在自动翻译当前私域数据，稍后将收到翻译完成提醒",
  "英语": "英语",
  "日语": "日语",
  "俄罗斯语": "俄罗斯语",
  "法语": "法语",
  "德语": "德语",
  "阿拉伯语": "阿拉伯语",
  "自定义": "自定义",
  "次": "次",
  "天": "天",
  "{{days}}天": "{{days}}天",
  "作品锚点：": "作品锚点：",
  "显示": "显示",
  "不显示": "不显示",
  "个人名片": "个人名片",
  "个人名片:": "个人名片:",
  "产品价格：": "产品价格：",
  "还未设置名片信息，": "还未设置名片信息，",
  "立即设置": "立即设置",
  "编辑": "编辑",
  "请选择介绍内容": "请选择介绍内容",
  "请选择作品": "请选择作品",
  "请选择产品": "请选择产品",
  "预览": "预览",
  "分享标题：": "分享标题：",
  "请输入分享标题": "请输入分享标题",
  "请输入分享描述": "请输入分享描述",
  "设置名片信息": "设置名片信息",
  "设置成功": "设置成功",
  "姓名不能为空": "姓名不能为空",
  "职位": "职位",
  "电话": "电话",
  "电话不能为空": "电话不能为空",
  "微信号": "微信号",
  "微信号_供应商管理": "微信号",
  "联系地址": "联系地址",
  "联系地址不能为空": "联系地址不能为空",
  "logo不得为空": "logo不得为空",
  "建议尺寸50*50，png图片": "建议尺寸50*50，png图片",
  "确认": "确认",
  "全部导出": "全部导出",
  "部分导出": "部分导出",
  "国内二维码": "国内二维码",
  "海外二维码": "海外二维码",
  "产品二维码": "产品二维码",
  "供应商": "供应商",
  "热门品牌": "热门品牌",
  "封面": "封面",
  "一键导出二维码": "一键导出二维码",
  "退出导出": "退出导出",
  "基础信息": "基础信息",
  "未分组": "未分组",
  "使用微信、钉钉APP扫码分享": "使用微信、钉钉APP扫码分享",
  "也可以复制链接发送给小伙伴": "也可以复制链接发送给小伙伴",
  "复制链接": "复制链接",
  "生成图片": "生成图片",
  "生成失败": "生成失败",
  "产品信息不存在": "产品信息不存在",
  "长按图片保存或分享": "长按图片保存或分享",
  "长按图片保存到相册": "长按图片保存到相册",
  "已加入咨询清单": "已加入咨询清单",
  "加入失败": "加入失败",
  "请先选择规格": "请先选择规格",
  "请先选择产品": "请先选择产品",
  "个月": "个月",
  " 天": " 天",
  "条数据": "条数据",
  "取消选择": "取消选择",
  "请选择下载附件": "请选择下载附件",
  "请选择日期": "请选择日期",
  "至少选择一个附件": "至少选择一个附件",
  "下载": "下载",
  "高清贴图": "高清贴图",
  "请选择节点": "请选择节点",
  "请选择图片": "请选择图片",
  "请先上传贴图": "请先上传贴图",
  "没有匹配的SKU": "没有匹配的SKU",
  "下载素材": "下载素材",
  "编辑封面": "编辑封面",
  "名称 ": "名称 ",
  "已失效": "已失效",
  "未过审原因": "未过审原因",
  "我知道了": "我知道了",
  "封面图不可取消勾选！": "封面图不可取消勾选！",
  "默认比例": "默认比例",
  "自由比例": "自由比例",
  "切换为暗色": "切换为暗色",
  "切换为亮色": "切换为亮色",
  "链接已失效": "链接已失效",
  "链接访问次数已达上限": "链接访问次数已达上限",
  "取消全选": "取消全选",
  "贴图库": "贴图库",
  "搜索贴图": "搜索贴图",
  "文件夹（{{count}}）": "文件夹（{{count}}）",
  "图片（{{count}}）": "图片（{{count}}）",
  "已关联不可重复关联": "已关联不可重复关联",
  "已关联": "已关联",
  "请至少勾选一张关联图": "请至少勾选一张关联图",
  "退出全选": "退出全选",
  "项": "项",
  "请选择要下载的图片": "请选择要下载的图片",
  "请输入自定义有效期天数！": "请输入自定义有效期天数",
  "暂无权限": "暂无权限",
  "进入管理": "进入管理",
  "进入空间": "进入空间",
  "成功关注": "成功关注",
  "已关注": "已关注",
  "取消成功！": "取消成功",
  "取消成功": "取消成功",
  "更多筛选": "更多筛选",
  "更少筛选": "更少筛选",
  "随机排序": "随机排序",
  "小卡片": "小卡片",
  "大卡片": "大卡片",
  "链接有效期：": "链接有效期：",
  "个项目": "个项目",
  "共{{total}}个项目": "共{{total}}个项目",
  "作品分享": "作品分享",
  "锚点": "锚点",
  "暂无高清贴图": "暂无高清贴图",
  "暂无锚点": "暂无锚点",
  "当前私域未认证": "当前私域未认证",
  "已删除": "已删除",
  "暂无": "暂无",
  "查看权限": "查看权限",
  "未发布": "未发布",
  "YYYY年M月": "YYYY年M月",
  "未开通海外版": "未开通海外版",
  "暂无名片": "暂无名片",
  "项目管理": "项目管理",
  "盘八斗项目": "盘八斗项目",
  "关联盘八斗项目管理": "关联盘八斗项目管理",
  "排序依据": "排序依据",
  "随机的": "随机的",
  "名字": "名字",
  "时间正序": "时间正序",
  "时间倒序": "时间倒序",
  "排序": "排序",
  "产品下载：": "产品下载：",
  "允许": "允许",
  "禁止": "禁止",
  "颜色筛选": "颜色筛选",
  "颜色筛选结果": "颜色筛选结果",
  "请在电脑上进行批量下载": "请在电脑上进行批量下载",
  "确认清单": "确认清单",
  "入库权限未开放": "入库权限未开放",
  "下载权限未开放": "下载权限未开放",
  "可以通过联系人获得产品入库权限": "可以通过联系人获得产品入库权限",
  "可以通过联系人获得产品下载权限": "可以通过联系人获得产品下载权限",
  "{{authName}}权限未开放": "{{authName}}权限未开放",
  "可以通过联系人获得产品{{authName}}权限": "可以通过联系人获得产品{{authName}}权限",
  "联系人:": "联系人：",
  "手机号:": "手机号：",
  "入库": "入库",
  "入库失败": "入库失败",
  "入库失败,数据完整性校验未通过": "入库失败，数据完整性校验未通过",
  "入库至": "入库至",
  "选择入库的产品将加入每个私域的未入库列表，需要管理员的确认才能成功入库": "选择入库的产品将加入每个私域的未入库列表，需要管理员的确认才能成功入库",
  "请至少勾选一条！": "请至少勾选一条",
  "入库成功！": "入库成功",
  "入库成功": "入库成功",
  "发布成功": "发布成功",
  "合作": "合作",
  "默认分组": "默认分组",
  "中文": "中文",
  "中文N": "中文",
  "默认使用首个开启的语言": "默认使用首个开启的语言",
  "英文": "英文",
  "当前私域的主体认证未通过，无法访问": "当前私域的主体认证未通过，无法访问",
  "返回上一级": "返回上一级",
  "上传日期": "上传日期",
  "大小": "大小",
  "按名称": "按名称",
  "按时间": "按时间",
  "按大小": "按大小",
  "这里还没有合作方的介绍": "这里还没有合作方的介绍",
  "创建私域": "创建私域",
  "切换私域": "切换私域",
  "未查到相关私域": "未查到相关私域",
  "已入库": "已入库",
  "我拥有": "我拥有",
  "推荐成功！": "推荐成功",
  "成功！": "成功",
  "提示": "提示",
  "会员状态确认中，请稍候": "会员状态确认中，请稍候",
  "协议模板未配置": "协议模板未配置",
  "请使用电脑打开链接！": "请使用电脑打开链接！",
  "浙ICP备17033477号-5": "浙ICP备17033477号-5",
  "绑定手机号/邮箱": "绑定手机号/邮箱",
  "绑定成功！": "绑定成功！",
  "请输入验证码!": "请输入验证码!",
  "请先完成拼图": "请先完成拼图",
  "请按住滑块拖动完成拼图": "请按住滑块拖动完成拼图",
  "该私域": "该私域",
  "盘子登录": "盘子登录",
  "支付宝登录": "支付宝登录",
  "登录/注册": "登录/注册",
  "注册登录协议说明": "注册登录即同意\u00a0<user>《用户协议》</user>\u00a0<privacy>《隐私政策》</privacy>\u00a0<child>《儿童个人信息保护规则及监护人须知》</child>",
  "注册登录协议说明2": "注册登录即同意\u00a0<user>《用户协议》</user>\u00a0<privacy>《隐私政策》</privacy>\u00a0<child>《儿童个人信息保护规则及监护人须知》</child><contracts/>",
  "两个协议之间连接的文案":" ",
  "最后一个协议和倒数第二个协议连接的文案":" ",
  "登录": "登录",
  "验证码登录": "验证码登录",
  "密码登录": "密码登录",
  "验证码": "验证码",
  "发送验证码": "发送验证码",
  "已发送": "已发送",
  "账号密码登录": "账号密码登录",
  "密码": "密码",
  "忘记密码": "忘记密码",
  "请完成拼图": "请完成拼图",
  "验证码登录/注册": "验证码登录/注册",
  "密码至少6~18个字符": "密码至少6~18个字符",
  "请输入有效手机号码!": "请输入有效手机号码!",
  "请输入正确的手机号或邮箱账号!": "请输入正确的手机号或邮箱账号!",
  "验证码不能为空!": "验证码不能为空!",
  "密码不能为空!": "密码不能为空!",
  "确保密码长度是 6-16 位": "确保密码长度是 6-16 位",
  "密码不允许纯数字": "密码不允许纯数字",
  "只能输入数字、英文字母和符号": "只能输入数字、英文字母和符号",
  "密码中不能出现 3 位以上连续字符（如aaaa,1234）": "密码中不能出现 3 位以上连续字符（如aaaa,1234）",
  "找回密码": "找回密码",
  "以下信息仅私域管理员查看": "以下信息仅私域管理员查看",
  "客户": "客户",
  "详细地址": "详细地址",
  "验证码错误！": "验证码错误！",
  "密码错误！": "密码错误！",
  "入库请先登录": "入库请先登录",
  "下载请先登录": "下载请先登录",
  "分享请先登录": "分享请先登录",
  "设置新密码": "设置新密码",
  "输入新密码": "输入新密码",
  "请确认您的密码!": "请确认您的密码!",
  "您输入的两个密码不匹配!": "您输入的两个密码不匹配!",
  "输入确认密码": "输入确认密码",
  "登录不觉账号": "登录不觉账号",
  "注册不觉账号并加入 {{privateDomainName}} 会员,享受会员专属权益与服务。": "注册不觉账号并加入 {{privateDomainName}} 会员,享受会员专属权益与服务。",
  "由不觉科技提供技术支持": "由不觉科技提供技术支持",
  "Powered By Bujue": "Powered By Bujue",
  "微信登录": "微信登录",
  "二维码加载中...": "二维码加载中...",
  "二维码加载失败，请重试": "二维码加载失败，请重试",
  "重新加载": "重新加载",
  "微信登录二维码": "微信登录二维码",
  "使用微信扫一扫登录“不觉”": "使用微信扫一扫登录“不觉”",
  "使用微信扫一扫登录“不觉空间”": "使用微信扫一扫登录“不觉空间”",
  "返回其他登录方式": "返回其他登录方式",
  "其他登录方式": "其他登录方式",
  "使用微信登录": "使用微信登录",
  "暂无可入库私域": "暂无可入库私域",
  "搜索": "搜索",
  "修改密码成功！": "修改密码成功",
  "请间隔5秒后再点击": "请间隔5秒后再点击",
  "置顶": "置顶",
  "产品库": "产品库",
  "筛选颜色": "筛选颜色",
  "收起更多筛选": "收起更多筛选",
  "效果图": "效果图",
  "素材图": "素材图",
  "委托添加": "委托添加",
  "手动添加": "手动添加",
  "批量添加": "批量添加",
  "批量替换": "批量替换",
  "确认批量操作": "确认批量操作",
  "确认批量替换贴图吗？": "确认批量替换贴图吗？",
  "确认批量添加贴图吗？": "确认批量添加贴图吗？",
  "贴图数量超过上限": "贴图数量超过上限",
  "未入库": "未入库",
  "产品空间": "产品空间",
  "公域产品管理": "公域产品管理",
  "已上架": "已上架",
  "展开更多筛选": "展开更多筛选",
  "管理": "管理",
  "产品分类": "产品分类",
  "材料属性": "材料属性",
  "固定周期": "固定周期",
  "区间周期": "区间周期",
  "新增字段": "新增字段",
  "新增分类": "新增分类",
  "上传/关联贴图": "上传/关联贴图",
  "标签": "标签",
  "备注": "备注",
  "保存": "保存",
  "介绍页Tab名称不能重复": "介绍页Tab名称不能重复",
  "名称不能重复！": "名称不能重复",
  "名称不能重复": "名称不能重复",
  "请输入字段名称": "请输入字段名称",
  "双击修改字段名称": "双击修改字段名称",
  "确定要删除吗?": "确定要删除吗？",
  "您确定要批量删除选中的图片吗?": "您确定要批量删除选中的图片吗？",
  "确定要删除选中的图片，并同步删除备份在不觉云的原图吗？": "确定要删除选中的图片，并同步删除备份在不觉云的原图吗？",
  "同步删除": "同步删除",
  "只删图片": "只删图片",
  "删除图片": "删除图片",
  "同时删除不觉云备份文件": "同时删除不觉云备份文件",
  "其他款式同步删除": "其他款式同步删除",
  "请选择": "请选择",
  "请选择{{name}}": "请选择{{name}}",
  "不觉云存储空间不足": "不觉云存储空间不足",
  "系列型号": "系列型号",
  "区间价格": "区间价格",
  "固定价格": "固定价格",
  "参数价格不能只填一个!": "参数价格不能只填一个",
  "最低参考价不能大于或等于最高参考价!": "最低参考价不能大于或等于最高参考价!",
  "请填写材质": "请填写材质",
  "尺寸规格": "尺寸规格",
  "请填写尺寸": "请填写尺寸",
  "检测到未上传贴图，请先上传哦！": "检测到未上传贴图，请先上传哦",
  "所有产品名称": "所有产品名称",
  "拖动可以排序": "拖动可以排序",
  "至少保留一张贴图": "至少保留一张贴图",
  "已关联贴图": "已关联贴图",
  "产品介绍": "产品介绍",
  "多图片": "多图片",
  "多文档": "多文档",
  "清空": "清空",
  "请完善款式信息！": "请完善款式信息",
  "请完善当前款式信息！": "请完善当前款式信息",
  "封面还未上传完！": "封面还未上传完",
  "款式信息未完善": "款式信息未完善",
  "点击/拖入单个PDF文档": "点击/拖入单个PDF文档",
  "将文件拖拽至此区域或点击添加": "将文件拖拽至此区域或点击添加",
  "支持PDF、WORD、EXCEL、3DMAX、SKP、CAD、Revit等格式": "支持PDF、WORD、EXCEL、3DMAX、SKP、CAD、Revit等格式",
  "正在上传中...": "正在上传中…",
  "上传未完成之前，请勿保存或发布，否则可能数据错误": "上传未完成之前，请勿保存或发布，否则可能数据错误",
  "点击/拖入图片": "点击/拖入图片",
  "还未上传图片": "还未上传图片",
  "请上传图片": "请上传图片",
  "“点击” 或 “拖入” 替换图片": "“点击” 或 “拖入” 替换图片",
  "遮罩颜色": "遮罩颜色",
  "模糊效果": "模糊效果",
  "拖动图片可以排序": "拖动图片可以排序",
  "已上传图片": "已上传图片",
  "标签最多5个，有助于提升产品在紫菜海洋的搜索概率": "标签最多5个，有助于提升产品在紫菜海洋的搜索概率",
  "贴图分类": "贴图分类",
  "图片": "图片",
  "关联已有贴图": "关联已有贴图",
  "拖动图片可以排序, 限制20张": "拖动图片可以排序，限制20张",
  "每次限20张": "每次限20张",
  "管理产品": "管理产品",
  "新增服务": "新增服务",
  "标签不能重名！": "标签不能重名！",
  "标签名称不能为空": "标签名称不能为空",
  "最多可选5个标签!": "最多可选5个标签!",
  "确定要删除吗?已关联产品中的对应标签会一并删除！": "确定要删除吗?已关联产品中的对应标签会一并删除！",
  "添加": "添加",
  "添加标签": "添加标签",
  "已上架：": "已上架：",
  "关联品牌": "关联品牌",
  "地址": "地址",
  "服务区域": "服务区域",
  "上传合约": "上传合约",
  "终止日期": "终止日期",
  "操作": "操作",
  "删除": "删除",
  "个品牌": "个品牌",
  "查看合约": "查看合约",
  "设为必填": "设为必填",
  "取消必填": "取消必填",
  "产品列表": "产品列表",
  "进入管理模式": "进入管理模式",
  "私域工作台": "私域工作台",
  "退出工作台": "退出工作台",
  "进入封面": "进入封面",
  "我在私域的昵称": "我在私域的昵称",
  "修改我在私域的昵称": "修改我在私域的昵称",
  "请输入昵称": "请输入昵称",
  "私域中的昵称": "私域中的昵称",
  "暂无签名": "暂无签名",
  "你不在该私域": "你不在该私域",
  "退出管理": "退出管理",
  "浏览模式": "浏览模式",
  "管理模式": "管理模式",
  "全屏": "全屏",
  "退出全屏": "退出全屏",
  "权限提醒": "权限提醒",
  "背景设置": "背景设置",
  "添加品牌": "添加品牌",
  "品牌logo": "品牌logo",
  "筛选时不能进行编辑操作": "筛选时不能进行编辑操作",
  "将同时删除产品": "将同时删除产品",
  "编辑品牌": "编辑品牌",
  "品牌名称": "品牌名称",
  "请输入品牌名称": "请输入品牌名称",
  "请选择类型": "请选择类型",
  "国家": "国家",
  "请输入国家": "请输入国家",
  "请选择国家": "请选择国家",
  "分组": "分组",
  "分组名不可重复": "分组名不可重复",
  "更多": "更多",
  "更多颜色": "更多颜色",
  "收起": "收起",
  "是否确认删除": "是否确认删除",
  "删除成功": "删除成功",
  "邀请": "邀请",
  "复制成功！": "复制成功",
  "复制成功": "复制成功",
  "请输入供应商公司名称": "请输入供应商公司名称",
  "头像": "头像",
  "请选择区域": "请选择区域",
  "请输入联系人": "请输入联系人",
  "请输入电话": "请输入电话",
  "请输入微信号": "请输入微信号",
  "请输入正确的手机号": "请输入正确的手机号",
  "添加客服微信": "添加客服微信",
  "留下您的联系方式": "留下您的联系方式",
  "私域设置": "私域设置",
  "私域信息": "私域信息",
  "私域安全": "私域安全",
  "成员管理": "成员管理",
  "权限管理": "权限管理",
  "模块管理": "模块管理",
  "物料板": "物料板",
  "分享管理": "分享管理",
  "小程序管理": "小程序管理",
  "主体认证": "主体认证",
  "付费服务": "付费服务",
  "容量": "容量",
  "容量不足，请及时升级套餐": "容量不足，请及时升级套餐",
  "原套餐已到期，部分功能不可再用，请及时续费": "原套餐已到期，部分功能不可再用，请及时续费",
  "容量已满，请及时升级套餐": "容量已满，请及时升级套餐",
  "多语言": "多语言",
  "已开通": "已开通",
  "未开通": "未开通",
  "订单详情": "订单详情",
  "支付宝支付": "支付宝支付",
  "微信支付": "微信支付",
  "支付成功": "支付成功",
  "添加客服企业微信，为您匹配专属客户成功团队服务支持，对您进行不觉产品一对一指导": "添加客服企业微信，为您匹配专属客户成功团队服务支持，对您进行不觉产品一对一指导",
  "添加客服企业微信，获取更多资讯":"添加客服企业微信，获取更多资讯",
  "请使用支付宝扫码支付": "请使用支付宝扫码支付",
  "请使用微信扫码支付": "请使用微信扫码支付",
  "取消支付": "取消支付",
  "确认取消支付吗？": "确认取消支付吗？",
  "完成": "完成",
  "{{name}}页": "{{name}}页",
  "提交成功！": "提交成功",
  "信息提交成功！": "信息提交成功",
  "信息保存成功！": "信息保存成功",
  "审核通过！": "审核通过",
  "恭喜获得认证标识，如要修改信息请前往私域设置-主体认证": "恭喜获得认证标识，如要修改信息请前往私域设置-主体认证",
  "主体认证审核中": "主体认证审核中",
  "信息审核预计在1～2工作日内完成，审核完成后，登录不觉会有弹框提醒您": "信息审核预计在1～2工作日内完成，审核完成后，登录不觉会有弹框提醒您",
  "审核工作时间：周一～周五，9:00-17:30": "审核工作时间：周一～周五，9:00-17:30",
  "不觉客服": "不觉客服",
  "扫码添加客服，有任何问题请联系我们": "扫码添加客服，有任何问题请联系我们",
  "订单号": "订单号",
  "套餐": "套餐",
  "实付": "实付",
  "购买时间": "购买时间",
  "生效时间": "生效时间",
  "到期时间": "到期时间",
  "发票": "发票",
  "已抵扣": "已抵扣",
  "已升级": "已升级",
  "永久有效": "永久有效",
  "开票": "开票",
  "作废": "作废",
  "开票中": "开票中",
  "开票失败": "开票失败",
  "重试": "重试",
  "重开": "重开",
  "发票作废中": "发票作废中",
  "申请重开发票成功": "申请重开发票成功",
  "确认作废发票吗？": "确认作废发票吗？",
  "申请发票作废中": "申请发票作废中",
  "确认开票信息": "确认开票信息",
  "选择开票信息": "选择开票信息",
  "添加开票信息": "添加开票信息",
  "确认开票": "确认开票",
  "单位": "单位",
  "个人": "个人",
  "普票": "普票",
  "专票": "专票",
  "发票抬头": "发票抬头",
  "请输入发票抬头": "请输入发票抬头",
  "税号": "税号",
  "请输入税号": "请输入税号",
  "格式有误": "格式有误",
  "注册电话(包括区号)": "注册电话（包括区号）",
  "请输入注册电话(包括区号)": "请输入注册电话（包括区号）",
  "注册地址": "注册地址",
  "请输入注册地址": "请输入注册地址",
  "银行账号": "银行账号",
  "请输入银行账号": "请输入银行账号",
  "开户银行": "开户银行",
  "请输入开户银行": "请输入开户银行",
  "请输入姓名": "请输入姓名",
  "身份证": "身份证",
  "请输入身份证": "请输入身份证",
  "个人普票": "个人普票",
  "注册电话": "注册电话",
  "开票失败，请": "开票失败，请",
  "已购买": "已购买",
  "认证流程：": "认证流程：",
  "准备营业执照、公司法人信息": "准备营业执照、公司法人信息",
  "在线填写认证基本信息": "在线填写认证基本信息",
  "上传公司法人信息": "上传公司法人信息",
  "完成提交等待官方审核": "完成提交等待官方审核",
  "完成主体认证，您的私域可以获得以下权限": "完成主体认证，您的私域可以获得以下权限",
  "认证标识": "认证标识",
  "发布空间": "发布空间",
  "开通小程序": "开通小程序",
  "访客权限": "访客权限",
  "私域人数可以超过50人": "私域人数可以超过50人",
  "作品分享查看锚点": "作品分享查看锚点",
  "认证须知：": "认证须知：",
  "私域名称提交后，修改名称需要再次提交认证流程": "私域名称提交后，修改名称需要再次提交认证流程",
  "填写前请准备好：营业执照、公司法人证件信息。如果主体资质虚假、不符合资质审核标准的，将做认证失败处理。": "填写前请准备好：营业执照、公司法人证件信息。如果主体资质虚假、不符合资质审核标准的，将做认证失败处理。",
  "完成主体认证，你可以获得以下权限：认证标识、发布空间、开通小程序、私域人数可以超过50人、作品分享查看锚点": "完成主体认证，你可以获得以下权限：认证标识、发布空间、开通小程序、私域人数可以超过50人、作品分享查看锚点",
  "驳回原因：": "驳回原因：",
  "账号信息": "账号信息",
  "私域名称不能为空！": "私域名称不能为空！",
  "请输入私域名称": "请输入私域名称",
  "账号名称需与主体企业、或品牌商标信息一致，例如主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词等": "账号名称需与主体企业、或品牌商标信息一致，例如主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词等",
  "查看更多规范": "查看更多规范",
  "私域Logo": "私域Logo",
  "私域Logo不能为空！": "私域Logo不能为空",
  "私域类型": "私域类型",
  "私域类型不能为空！": "私域类型不能为空！",
  "请选择私域类型": "请选择私域类型",
  "设计团队": "设计团队",
  "产品团队": "产品团队",
  "机构（协会）": "机构（协会）",
  "装修企业": "装修企业",
  "主体信息": "主体信息",
  "企业名称": "企业名称",
  "请输入企业名称": "请输入企业名称",
  "营业执照": "营业执照",
  "主营业务": "主营业务",
  "请输入主营业务": "请输入主营业务",
  "法人验证": "法人验证",
  "法人姓名": "法人姓名",
  "请输入法人姓名": "请输入法人姓名",
  "法人身份证号": "法人身份证号",
  "请输入法人身份证号": "请输入法人身份证号",
  "法人身份证信息": "法人身份证信息",
  "身份证正面": "身份证正面",
  "身份证反面": "身份证反面",
  "人脸识别": "人脸识别",
  "法人未认证": "法人未认证",
  "用微信扫码，完成人脸识别": "用微信扫码，完成人脸识别",
  "已认证成功，如需修改，": "已认证成功，如需修改，",
  "请重新认证": "请重新认证",
  "法人认证成功": "法人认证成功",
  "同意并遵守": "同意并遵守",
  "《不觉私域主体认证须知》": "《不觉私域主体认证须知》",
  "，确保提供的信息及材料真实有效": "，确保提供的信息及材料真实有效",
  "未勾选服务协议": "未勾选服务协议",
  "企业名称不能为空！": "企业名称不能为空",
  "请上传营业执照！": "请上传营业执照",
  "请上传最新版三证合一的营业执照清晰正面图，或清晰完整的组织机构代码证": "请上传最新版三证合一的营业执照清晰正面图，或清晰完整的组织机构代码证",
  "主营业务不能为空！": "主营业务不能为空",
  "法人姓名不能为空！": "法人姓名不能为空",
  "法人身份证号不能为空！": "法人身份证号不能为空",
  "请上传身份证正面！": "请上传身份证正面",
  "请上传身份证反面！": "请上传身份证反面",
  "请完成人脸识别！": "请完成人脸识别",
  "认证{{status}}": "认证{{status}}",
  "命名规范": "命名规范",
  "1、账号名称需命名规范，与主体企业、或品牌商标信息一致：": "1、账号名称需命名规范，与主体企业、或品牌商标信息一致：",
  "使用认证主体企业命名：即与营业执照名称保持一致，支持企业全称或简称；如：主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词（例：不觉科技设计师平台）": "使用认证主体企业命名：即与营业执照名称保持一致，支持企业全称或简称；如：主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词（例：不觉科技设计师平台）",
  "使用品牌/商标信息命名，需提供对应资质；如：主体为可口可乐公司，账号名称可使用：芬达饮品": "使用品牌/商标信息命名，需提供对应资质；如：主体为可口可乐公司，账号名称可使用：芬达饮品",
  "如是app、网站支持使用app/网站命名，需提供对应资质；如：app软著中全称为星野软件，账号名称可以为星野软件、星野、星野App等；": "如是app、网站支持使用app/网站命名，需提供对应资质；如：app软著中全称为星野软件，账号名称可以为星野软件、星野、星野App等；",
  "2、账号名称不超过40字，仅支持特殊符号如下：“”、“ ”、“”、“ ”、“ 、“《》”，其他特殊符号不支持": "2、账号名称不超过40字，仅支持特殊符号如下：“”、“ ”、“”、“ ”、“ 、“《》”，其他特殊符号不支持",
  "3、账号名称&头像，不得含有歧义、侵犯、仿冒官方等内容，不能有广告法禁用词，如“第一”、“最”；": "3、账号名称&头像，不得含有歧义、侵犯、仿冒官方等内容，不能有广告法禁用词，如“第一”、“最”；",
  "4、账号名称&头像，如包含品牌名/商标，需选择对应品牌并提供商标注册证或相关授权材料；": "4、账号名称&头像，如包含品牌名/商标，需选择对应品牌并提供商标注册证或相关授权材料；",
  "5、账号名称不得单独使用人名、或以人名作结尾，不得为职位化昵称，如：XX董事长、XX厂长、XX经理，不得含有“招商”、“加盟”字样；如您后续需开通店铺，请确保名称中不含“旗舰店”、“专卖店”、“集合店”、“卖场型旗舰店”、“工厂店”等字样，否则入驻店铺将被驳回。": "5、账号名称不得单独使用人名、或以人名作结尾，不得为职位化昵称，如：XX董事长、XX厂长、XX经理，不得含有“招商”、“加盟”字样；如您后续需开通店铺，请确保名称中不含“旗舰店”、“专卖店”、“集合店”、“卖场型旗舰店”、“工厂店”等字样，否则入驻店铺将被驳回。",
  "没有私域信息": "没有私域信息",
  "分享人": "分享人",
  "统一联系人": "统一联系人",
  "设置": "设置",
  "图片水印：": "图片水印：",
  "logo水印": "logo水印",
  "作品下载：": "作品下载：",
  "官网入口：": "官网入口：",
  "产品入库：": "产品入库：",
  "单图logo": "单图logo",
  "平铺logo": "平铺logo",
  "透明度": "透明度",
  "请输入透明度": "请输入透明度",
  "更换Logo": "更换Logo",
  "至少保留一个内容!": "至少保留一个内容",
  "拖动调整顺序": "拖动调整顺序",
  "目录": "目录",
  "访客登录设置": "访客登录设置",
"登录注册": "登录注册",
"需要": "需要",
"不需要": "不需要",
"登录触发条件": "登录触发条件",
"累计查看": "累计查看",
"进入小程序": "进入小程序",
"分钟": "分钟",
"触发后登录": "触发后登录",
"必须登录": "必须登录",
"不必须登录": "不必须登录",
"图片水印": "图片水印",
"分享封面": "分享封面",
"头部背景图": "头部背景图",
"图片限制规格：5:4尺寸，<200KB，png图片": "图片限制规格：5:4尺寸，<200KB，png图片",
"图片限制：<800KB，png图片": "图片限制：<800KB，png图片",
"图片大小超过上限": "图片大小超过上限",
"内容管理": "内容管理",
"客户管理": "客户管理",
"下载用户清单": "下载用户清单",
"未认证": "未认证",
"已通过": "已通过",
"VR展厅": "VR展厅",
  "不觉云": "不觉云",
  "工具箱": "工具箱",
  "查看为基础权限，如需取消查看权限，请关闭模块开关": "查看为基础权限，如需取消查看权限，请关闭模块开关",
  "近期上线": "近期上线",
  "素材、模型可应用于创意板、画图软件等": "素材、模型可应用于创意板、画图软件等",
  "访客": "访客",
  "私域管理员": "私域管理员",
  "管理员拥有所有权限": "管理员拥有所有权限",
  "完成主体认证，才能解锁访客访问": "完成主体认证，才能解锁访客访问",
  "审核中": "审核中",
  "查看供应商": "查看供应商",
  "查看联系方式": "查看联系方式",
  "查看合同": "查看合同",
  "查看备注": "查看备注",
  "素材应用": "素材应用",
  "导出产品二维码": "导出产品二维码",
  "隐藏系统文件夹": "隐藏系统文件夹",
  "价格显示": "价格显示",
  "成员": "成员",
  "管理员": "管理员",
  "二级管理员": "二级管理员",
  "未加入": "未加入",
  "申请加入": "申请加入",
  "申请成功": "申请成功",
  "等待管理员审核": "等待管理员审核",
  "已申请": "已申请",
  "{{count}}秒后自动进入私域": "{{count}}秒后自动进入私域",
  "进入私域": "进入私域",
  "您已是该私域成员": "您已是该私域成员",
  "打开APP": "打开APP",
  "我": "我",
  "仅管理员可以操作": "仅管理员可以操作",
  "加入日期": "加入日期",
  "确定退出当前私域？": "确定退出当前私域？",
  "同意": "同意",
  "拒绝": "拒绝",
  "加入成功": "加入成功",
  "无可删除的成员": "无可删除的成员",
  "操作成功": "操作成功",
  "退出失败": "退出失败",
  "退出成功": "退出成功",
  "无可操作的成员": "无可操作的成员",
  "无可操作产品": "无可操作产品",
  "刷新成功": "刷新成功",
  "批量编辑": "批量编辑",
  "编辑项目信息": "编辑项目信息",
  "导出": "导出",
  "导出选中项": "导出选中项",
  "导出全部数据": "导出全部数据",
  "确认导出当前选中的数据吗？": "确认导出当前选中的数据吗？",
  "确认导出当前全部数据吗？": "确认导出当前全部数据吗？",
  "确认导出当前搜索结果中的全部数据吗？": "确认导出当前搜索结果中的全部数据吗？",
  "创建人": "创建人",
  "创建时间": "创建时间",
  "更新时间": "更新时间",
  "根据协议，当前项目信息将向{{team}}披露": "根据协议，当前项目信息将向{{team}}披露。",
  "当前项目信息将向{{team}}披露": "当前项目信息将向{{team}}披露",
  "本私域": "本私域",
  "添加成员": "添加成员",
  "邀请成员": "邀请成员",
  "使用微信、钉钉APP扫码加入": "使用微信、钉钉APP扫码加入",
  "成员加入需管理员审核": "成员加入需管理员审核",
  "批量编辑时，修改任一成员信息，会同步其他已选成员": "批量编辑时，修改任一成员信息，会同步其他已选成员",
  "批量编辑时，修改任一会员信息，会同步其他已选会员": "批量编辑时，修改任一会员信息，会同步其他已选会员",
  "确定要删除选中成员吗？": "确定要删除选中成员吗？",
  "确定要删除当前成员吗？": "确定要删除当前成员吗？",
  "角色": "角色",
  "昵称": "昵称",
  "邀请人": "邀请人",
  "关联成员": "关联成员",
  "关联私域": "关联私域",
  "注册时间": "注册时间",
  "注册来源": "注册来源",
  "最近访问": "最近访问",
  "会员标签": "会员标签",
  "使用中": "使用中",
  "未使用": "未使用",
  "小程序分享": "小程序分享",
  "私域会员": "私域会员",
  "会员管理": "会员管理",
  "开启私域会员": "开启私域会员",
  "将私域访客高效沉淀为会员，深度洞察其来源渠道，让运营策略精准施策。": "将私域访客高效沉淀为会员，深度洞察其来源渠道，让运营策略精准施策。",
  "开启后，您可轻松查看会员档案、来源归属，并利用标签系统实现灵活的分类与高效管理。": "开启后，您可轻松查看会员档案、来源归属，并利用标签系统实现灵活的分类与高效管理。",
  "立即开启": "立即开启",
  "校验中": "校验中",
  "开启私域会员管理需完成主体认证，是否前往认证？": "开启私域会员管理需完成主体认证，是否前往认证？",
  "请先开启会员管理，再开启本功能。否则会导致无法获取访客个人数据": "请先开启会员管理，再开启本功能。否则会导致无法获取访客个人数据",
  "查看协议": "查看协议",
  "搜索昵称/手机号/邮箱": "搜索昵称/手机号/邮箱",
  "标签管理": "标签管理",
  "获取标签失败": "获取标签失败",
  "最多可添加1000个标签": "最多可添加1000个标签",
  "缺少团队信息": "缺少团队信息",
  "确认删除该标签吗?\n保存后将同步删除用户已绑定的标签": "确认删除该标签吗?\n保存后将同步删除用户已绑定的标签",
  "完成主体认证，才能解锁私域会员": "完成主体认证，才能解锁私域会员",
  "开启私域会员，才能解锁会员权限": "开启私域会员，才能解锁会员权限",
  "前往开启": "前往开启",
  "协议列表": "协议列表",
  "协议名称": "协议名称",
  "协议类型": "协议类型",
  "协议来源": "协议来源",
  "协议状态": "协议状态",
  "私域会员协议": "私域会员协议",
  "私域隐私协议": "私域隐私协议",
  "私域隐私政策": "私域隐私政策",
  "《私域会员协议》": "《私域会员协议》",
  "《私域隐私协议》": "《私域隐私协议》",
  "《私域隐私政策》": "《私域隐私政策》",
  "{{privateName}}私域会员协议": "{{privateName}}私域会员协议",
  "{{privateName}}私域隐私政策": "{{privateName}}私域隐私政策",
  "用户昵称": "用户昵称",
  "请先阅读并同意相关协议": "请先阅读并同意相关协议",
  "请先确认并勾选协议": "请先确认并勾选协议",
  "关闭": "关闭",
  "您将加入 [{{privateName}}] 会员，享受会员专属权益与服务。": "您将加入 [{{privateName}}] 会员，享受会员专属权益与服务。",
  "加入中": "加入中",
  "加入私域会员": "加入私域会员",
  "加入会员": "加入会员",
  "该私域素材仅会员可用": "该私域素材仅会员可用",
  "是否加入私域会员？": "是否加入私域会员？",
  "仅会员可用": "仅会员可用",
  "选择私域": "选择私域",
  "服务到期": "服务到期",
  "违规封禁": "违规封禁",
  "无权限查询": "无权限查询",
  "当前关注的私域暂无可用素材": "当前关注的私域暂无可用素材",
  "权限状态获取失败": "权限状态获取失败",
  "已加入会员，素材权限尚未生效，请稍后重试": "已加入会员，素材权限尚未生效，请稍后重试",
  "已加入{{privateName}}会员": "已加入{{privateName}}会员",
  "加入私域会员失败，请稍后重试": "加入私域会员失败，请稍后重试",
  "加载私域会员信息失败，请稍后重试": "加载私域会员信息失败，请稍后重试",
  "我已阅读并同意": "我已阅读并同意",
  "加入会员后才可继续操作": "加入会员后才可继续操作",
  "会员协议": "会员协议",
  "系统协议": "系统协议",
  "生效中": "生效中",
  "访客在官网触发登录（关注/入库等行为）后，将自动加入私域会员。": "访客在官网触发登录（关注/入库等行为）后，将自动加入私域会员。",
  "确认协议配置，开启会员管理": "确认协议配置，开启会员管理",
  "开启会员管理前，需先确认用户注册/登录时需同意的《私域会员协议》与《私域隐私协议》": "开启会员管理前，需先确认用户注册/登录时需同意的《私域会员协议》与《私域隐私协议》",
  "官方默认": "官方默认",
  "我已确认以上协议内容，用户注册时将展示并要求同意": "我已确认以上协议内容，用户注册时将展示并要求同意",
  "确认开启": "确认开启",
  "不分组": "不分组",
  "审核通过": "审核通过",
  "审核不通过": "审核不通过",
  "主体认证{{status}},审核通过后再添加": "主体认证{{status}}，审核通过后再添加",
  "邀请加入-不觉空间艺术馆\n{{nickName}}邀请您加入{{teamName}}，点击下方链接立即加入。\n": "邀请加入-不觉空间艺术馆\n{{nickName}}邀请您加入{{teamName}}，点击下方链接立即加入。\n",
  "邀请加入-{{teamName}}，成为内部成员。\n": "邀请加入-{{teamName}}，成为内部成员。\n",
  "私域成员超过50人，需要完成主体认证，才能继续添加": "私域成员超过50人，需要完成主体认证，才能继续添加",
  "使用微信扫码": "使用微信扫码",
  "已加载全部数据": "已加载全部数据",
  "数据加载失败": "数据加载失败",
  "网络异常，请重试": "网络异常，请重试",
  "请输入内容": "请输入内容",
  "以下字段不支持排序:": "以下字段不支持排序：",
  "以下候选值不支持排序:": "以下候选值不支持排序：",
  "当前候选值被引用，不可删除": "当前候选值被引用，不可删除",
  "不支持输入反斜杠 {{bs}}": "不支持输入反斜杠 {{bs}}",
  "最多可添加{{max}}个候选值": "最多可添加{{max}}个候选值",
  "最多可添加{{max}}个字段": "最多可添加{{max}}个字段",
  "该域名可使用!": "该域名可使用",
  "该域名已使用，请重新输入！": "该域名已使用，请重新输入",
  "私域LOGO": "私域LOGO",
  "网址定制": "网址定制",
  "域名不支持使用大写字母!": "域名不支持使用大写字母",
  "域名不能包含汉字!": "域名不能包含汉字",
  "域名不能包含标点符号!": "域名不能包含标点符号",
  "重名校验": "重名校验",
  "可以输入一个拼音或单词(小写)、数字，不能包含标点符号，比如“panzitech”": "可以输入一个拼音或单词（小写）、数字，不能包含标点符号，比如“panzitech”",
  "添加私域介绍...": "添加私域介绍…",
  "{{name}}上传失败": "{{name}}上传失败",
  "{{name}}不是图片": "{{name}}不是图片",
  "主体认证审核中，暂时无法修改私域名称": "主体认证审核中，暂时无法修改私域名称",
  "修改私域名称，需要重新提交主体认证": "修改私域名称，需要重新提交主体认证",
  "前往认证": "前往认证",
  "AI翻译中": "AI翻译中",
  "翻译完成": "翻译完成",
  "选择套餐": "选择套餐",
  "到期日期": "到期日期",
  "查看全部权益": "查看全部权益",
  "全部权益": "全部权益",
  "* 更多权益需求&定制服务请联系客服": "* 更多权益需求&定制服务请联系客服",
  "云盘容量": "云盘容量",
  "已使用：{{used}}/{{total}}": "已使用：{{used}}/{{total}}",
  "尊敬的用户，您的不觉云存储空间即将达到上限，为避免影响正常使用，建议您尽快进行容量升级。": "尊敬的用户，您的不觉云存储空间即将达到上限，为避免影响正常使用，建议您尽快进行容量升级。",
  "{{time}}到期": "{{time}}到期",
  "永久免费": "永久免费",
  "免费": "免费",
  "￥{{price}}/年": "￥{{price}}/年",
  "价格说明": "价格说明",
  "套餐购买或套餐续期是，原价=新套餐单价*购买时长": "套餐购买或套餐续期是，原价=新套餐单价*购买时长",
  "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数": "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数",
  "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生  效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和": "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和",
  "优惠码：请联系不觉客服获取优惠码": "优惠码：请联系不觉客服获取优惠码",
  "请输入优惠码享受优惠，优惠金额=*（1-折扣）": "请输入优惠码享受优惠，优惠金额=*（1-折扣）",
  "温馨提示：使用苹果设备购买服务，苹果公司将收取30%，建议您在不觉网站购买服务。": "温馨提示：使用苹果设备购买服务，苹果公司将收取30%，建议您在不觉网站购买服务。",
  "保存二维码": "保存二维码",
  "微信客服": "微信客服",
  "套餐无法降级": "套餐无法降级",
  "当前套餐": "当前套餐",
  "年": "年",
  "无需付费": "无需付费",
  "定制版": "定制版",
  "按需定制功能和云盘容量": "按需定制功能和云盘容量",
  "免费咨询": "免费咨询",
  "核心基础服务": "核心基础服务",
  "暂不支持降级": "暂不支持降级",
  "当前生效": "当前生效",
  "立即升级": "立即升级",
  "赠送升级": "赠送升级",
  "付费扩容": "付费扩容",
  "大文件上传": "大文件上传",
  "批量上传文件": "批量上传文件",
  "视频高清画质": "视频高清画质",
  "自定义权限": "自定义权限",
  "你的私域已使用{{size}}容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。": "你的私域已使用{{size}}容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。",
  "说明": "说明",
  "原套餐时长：": "原套餐时长：",
  "数量：": "数量：",
  "套餐时长一次最多购买3年": "套餐时长一次最多购买3年",
  "套餐时长一次最多延长3年": "套餐时长一次最多延长3年",
  "有效期至：": "有效期至：",
  "(赠送{{time}}个{{unit}})": "(赠送{{time}}个{{unit}})",
  "剩余时长：": "剩余时长：",
  "原价：": "原价：",
  "抵扣：": "抵扣：",
  "优惠码：": "优惠码：",
  "请输入优惠码": "请输入优惠码",
  "已为您兑换{{discount}}折优惠码：{{code}}": "已为您兑换{{discount}}折优惠码：{{code}}",
  "优惠：": "优惠：",
  "补差价：": "补差价：",
  "请求失败，请稍后重试": "请求失败，请稍后重试",
  "不觉云套餐": "不觉云套餐",
  "咨询": "咨询",
  "更多专属特权": "更多专属特权",
  "请输入地址": "请输入地址",
  "请选择关联品牌": "请选择关联品牌",
  "请输入备注": "请输入备注",
  "供应商公司名称不能为空！": "供应商公司名称不能为空",
  "联系人": "联系人",
  "添加供应商": "添加供应商",
  "编辑供应商": "编辑供应商",
  "分类名不能为空": "分类名不能为空",
  "管理分类": "管理分类",
  "*请指定私有分类": "*请指定私有分类",
  "确定要删除该一级分类吗?": "确定要删除该一级分类吗？",
  "确定要删除该二级分类吗?": "确定要删除该二级分类吗？",
  "确定要删除该顶级分类吗?": "确定要删除该一级分类吗？",
  "将同时删除下属产品": "将同时删除下属产品",
  "将同时删除下属分类和产品": "将同时删除下属分类和产品",
  "分类名称已存在": "分类名称已存在",
  "分类名称重复": "分类名称重复",
  "上传图片": "上传图片",
  "上传PDF": "上传PDF",
  "一键清空": "一键清空",
  "页": "页",
  "删除分组将同时删除下属的所有品牌及对应的产品，确认删除分组吗？": "删除分组将同时删除下属的所有品牌及对应的产品，确认删除分组吗？",
  "亲爱的供应商朋友：": "亲爱的供应商朋友：",
  "恭喜您获得": "恭喜您获得",
  "的邀请": "的邀请",
  "，您可以在下方列表中录入产品信息并提交，": "，您可以在下方列表中录入产品信息并提交，",
  "在通过私域管理员审核后，产品将自动加入": "在通过私域管理员审核后，产品将自动加入",
  "如需详细咨询，请联系": "如需详细咨询，请联系",
  "“不觉”": "“不觉”",
  " 私域Saas工具 ": " 私域Saas工具 ",
  "客服小助手微信：bujuekefu": "客服小助手微信：bujuekefu",
  "委托入库": "委托入库",
  "提交成功！可以继续添加下一个产品。": "提交成功！可以继续添加下一个产品。",
  "好的": "好的",
  "空间不足": "空间不足",
  "创建成功！": "创建成功！",
  "入库成功": "入库成功",
  "已保存为草稿": "已保存为草稿",
  "更新成功": "更新成功",
  "该产品已存在，是否进行替换？": "该产品已存在，是否进行替换？",
  "添加成功": "添加成功",
  "提交成功！可以继续添加更多产品": "提交成功，可以继续添加更多产品",
  "数据提交截止时间：": "数据提交截止时间：",
  "已选产品": "已选产品",
  "产品导入": "产品导入",
  "私域": "私域",
  "复制": "复制",
  "添加产品": "添加产品",
  "确认删除？": "确认删除？",
  "未通过": "未通过",
  "关联官方品牌": "关联官方品牌",
  "自定义筛选字段": "自定义筛选字段",
  "自定义字段": "自定义字段",
  "自定义项目字段": "自定义项目字段",
  "拖拽卡片以排序": "拖拽卡片以排序",
  "规格尺寸": "规格尺寸",
  "发布产品空间": "发布产品空间",
  "异常：": "异常：",
  "产品空间上新啦!": "产品空间上新啦！",
  "公域产品管理上新啦!": "公域产品管理上新啦！",
  "一键发布，可分享，可被关注": "一键发布，可分享，可被关注",
  "让设计师随时了解您 的最新产品": "让设计师随时了解您的最新产品",
  "完成认证": "完成认证",
  "批量入库": "批量入库",
  "批量删除": "批量删除",
  "批量修改分类": "批量修改分类",
  "详情": "详情",
  "删除成功！": "删除成功",
  "修改成功！": "修改成功",
  "是否确认删除？": "是否确认删除？",
  "月": "月",
  "缺少图片，先补充一下吧！": "缺少图片，先补充一下吧",
  "产品图": "产品图",
  "最低参考价": "最低参考价",
  "最高参考价": "最高参考价",
  "请选择分类": "请选择分类",
  "上传失败，请重新上传！": "上传失败，请重新上传",
  "管理品牌": "管理品牌",
  "新增供应商": "新增供应商",
  "请选择供应商": "请选择供应商",
  "确认删除?": "确认删除？",
  "供应商已删除": "供应商已删除",
  "*请选择品牌": "*请选择品牌",
  "请选择品牌": "请选择品牌",
  "*请选择分类": "*请选择分类",
  "请填写名称!": "请填写名称",
  "*请填写名称": "*请填写名称",
  "请选择属性": "请选择属性",
  "*请选择属性": "*请选择属性",
  "还未上传图片/视频": "还未上传图片/视频",
  "请填写系列型号": "请填写系列型号",
  "请输入供货周期": "请输入供货周期",
  "请上传封面": "请上传封面",
  "最小区间周期不能为0!": "最小区间周期不能为0",
  "最大区间周期不能为0!": "最大区间周期不能为0",
  "区间周期不能只填一个!": "区间周期不能只填一个",
  "最小区间周期不能大于或等于最大区间周期!": "最小区间周期不能大于或等于最大区间周期",
  "请输入最小区间周期": "请输入最小区间周期",
  "请输入最大区间周期": "请输入最大区间周期",
  "内容排序": "内容排序",
  "添加照片": "添加照片",
  "选择导入内容": "选择导入内容",
  "添加PDF": "添加PDF",
  "导入": "导入",
  "请输入贴图分类": "请输入贴图分类",
  "页数不能为0！": "页数不能为0",
  "加载中": "加载中",
  "确认删除选中图片吗": "确认删除选中图片吗",
  "移动至": "移动至",
  "移动至第": "移动至第",
  "移动": "移动",
  "导入成功！": "导入成功",
  "导入失败": "导入失败",
  "确定要删除吗？已关联产品中的对应服务会一并删除！": "确定要删除吗？已关联产品中的对应服务会一并删除",
  "产品：": "产品：",
  "移动成功": "移动成功",
  "操作失败": "操作失败",
  "修改成功": "修改成功",
  "重置筛选": "重置筛选",
  "精准筛选": "精准筛选",
  "对方已解除与您的合作，点击移除": "对方已解除与您的合作，点击移除",
  "请使用鼠标拖动": "请使用鼠标拖动",
  "默认背景": "默认背景",
  "透明": "透明",
  "模糊": "模糊",
  "上传失败": "上传失败",
  "更改未保存，是否保存?": "更改未保存，是否保存？",
  "正面": "正面",
  "反面": "反面",
  "点击或拖入更换图片": "点击或拖入更换图片",
  "保存成功": "保存成功",
  "来源": "来源",
  "委托方": "委托方",
  "提交时间": "提交时间",
  "状态": "状态",
  "提交人": "提交人",
  "确定删除": "确定删除",
  "确定入库": "确定入库",
  "30天": "30天",
  "新增": "新增",
  "请填写备注": "请填写备注",
  "确认清空介绍吗？": "确认清空介绍吗？",
  "pdf还没全部加载完！": "pdf还没全部加载完",
  "至少保留一个产品！": "至少保留一个产品",
  "保存到草稿": "保存到草稿",
  "更改": "更改",
  "添加分类": "添加分类",
  "敏感词审核未通过": "敏感词审核未通过",
  "必填项未填写": "必填项未填写",
  "不可以移动至默认分组": "不可以移动至默认分组",
  "确定要删除分组吗？组内所有合作伙伴会一并删除": "确定要删除分组吗？组内所有合作伙伴会一并删除",
  "是": "是",
  "否": "否",
  "官网": "官网",
  "小程序": "小程序",
  "没有可下架的资源": "没有可下架的资源",
  "没有可上架的资源": "没有可上架的资源",
  "一键上架": "一键上架",
  "一键下架": "一键下架",
  "团队店铺本次提交": "本次提交",
  "团队店铺全部内容": "全部内容",
  "团队店铺上架内容统计": "{{scope}}<total>{{totalCount}}</total>个，未上架<status>{{statusCount}}</status>个，即将上架内容合计：<pending>{{statusCount}}</pending>个",
  "团队店铺下架内容统计": "{{scope}}<total>{{totalCount}}</total>个，已上架<status>{{statusCount}}</status>个，即将下架内容合计：<pending>{{statusCount}}</pending>个",
  "团队店铺上架成功统计": "本次上架<submit>{{submitCount}}</submit>个，上架成功<success>{{successCount}}</success>个",
  "团队店铺上架驳回统计": "本次上架<submit>{{submitCount}}</submit>个，上架成功<success>{{successCount}}</success>个，自动驳回<fail>{{failCount}}</fail>个",
  "下架": "下架",
  "请选择要下架的内容": "请选择要下架的内容",
  "确认下架": "确认下架",
  "上架后访客可在小程序、官网查看该产品，确认上架吗？": "上架后访客可在小程序、官网查看该产品，确认上架吗？",
  "下架后访客将无法在小程序、官网查看该产品，确认下架吗？": "下架后访客将无法在小程序、官网查看该产品，确认下架吗？",
  "上架": "上架",
  "请选择要上架的内容": "请选择要上架的内容",
  "确认上架": "确认上架",
  "批量下载中，请等待片刻": "批量下载中，请等待片刻",
  "下载中": "下载中",
  "一键操作": "一键操作",
  "搜索结果页暂不支持一键操作": "搜索结果页暂不支持一键操作",
  "空间预览": "空间预览",
  "请选择要导出的产品": "请选择要导出的产品",
  "导出二维码": "导出二维码",
  "确认导出二维码": "确认导出二维码",
  "确定要将选中的产品批量上架吗?": "确定要将选中的产品批量上架吗？",
  "确定要将选中的产品批量上架吗?\n包含被驳回产品，请填写申请上架理由": "确定要将选中的产品批量上架吗？\n包含被驳回产品，请填写申请上架理由",
  "确定要将选中的产品批量下架吗?": "确定要将选中的产品批量下架吗？",
  "确定要将选中的产品批量删除吗?": "确定要将选中的产品批量删除吗？",
  "确定要将选中的产品批量入库吗?": "确定要将选中的产品批量入库吗？",
  "已选产品容量超出剩余容量，无法入库。": "已选产品容量超出剩余容量，无法入库。",
  "正在入库处理中，请等待": "正在入库处理中，请等待",
  "部分产品已存在，是否进行替换？": "部分产品已存在，是否进行替换？",
  "产品已存在，是否进行替换？": "产品已存在，是否进行替换？",
  "确定要将选中的产品导出二维码吗?": "确定要将选中的产品导出二维码吗？",
  "确定一键上架全部产品吗?": "确定一键上架全部产品吗？",
  "确定一键下架全部产品吗?": "确定一键下架全部产品吗？",
  "确定一键入库全部产品吗?": "确定一键入库全部产品吗？",
  "确定一键删除全部产品吗?": "确定一键删除全部产品吗？",
  "确定要将全部产品导出二维码吗?": "确定要将全部产品导出二维码吗？",
  "确定一键上架符合当前筛选条件的{{total}}项产品吗？": "确定一键上架符合当前筛选条件的{{total}}项产品吗？",
  "确定一键下架符合当前筛选条件的{{total}}项产品吗？": "确定一键下架符合当前筛选条件的{{total}}项产品吗？",
  "确定一键入库符合当前筛选条件的{{total}}项产品吗？": "确定一键入库符合当前筛选条件的{{total}}项产品吗？",
  "确定一键删除符合当前筛选条件的{{total}}项产品吗？": "确定一键删除符合当前筛选条件的{{total}}项产品吗？",
  "确定要导出符合当前筛选条件的{{total}}项产品二维码吗？": "确定要导出符合当前筛选条件的{{total}}项产品二维码吗？",
  "确定批量修改分类?": "确定批量修改分类？",
  "审核异常：": "审核异常：",
  "待审核：": "待审核：",
  "未上架：": "未上架：",
  "内容总数：": "内容总数：",
  "一键导出码": "一键导出码",
  "没有可导出的产品": "没有可导出的产品",
  "完成私域主体认证，才能继续使用空间功能": "完成私域主体认证，才能继续使用空间功能",
  "去认证": "去认证",
  "上架状态": "上架状态",
  "审核异常": "审核异常",
  "未上架": "未上架",
  "待审核": "待审核",
  "已驳回": "已驳回",
  "审核结果": "审核结果",
  "通过": "通过",
  "不通过": "不通过",
  "确认上架吗？将提交至不觉官方进行上架审核": "确认上架吗？将提交至不觉官方进行上架审核",
  "取消置顶": "取消置顶",
  "空间管理": "空间管理",
  "店铺信息": "店铺信息",
  "私域名称不能为空": "私域名称不能为空",
  "请输入私域介绍": "请输入私域介绍",
  "私域介绍": "私域介绍",
  "私域名称": "私域名称",
  "累计上架：": "累计上架：",
  "服务区域：": "服务区域：",
  "退出编辑": "退出编辑",
  "退出批量编辑": "退出批量编辑",
  "美元": "美元",
  "单次最多上传20张": "单次最多上传20张",
  "敏感词审核不通过": "敏感词审核不通过",
  "请输入服务": "请输入服务",
  "确认删除吗?": "确认删除吗？",
  "请选择入库的数据": "请选择入库的数据",
  "操作成功！": "操作成功",
  "确定要执行批量上架吗？已选 ": "确定要执行批量上架吗？已选 ",
  " 件产品中包含 ": " 件产品中包含 ",
  " 件被驳回的产品，确定要重新提交上架吗？": " 件被驳回的产品，确定要重新提交上架吗？",
  "产品名称": "产品名称",
  "请先勾选数据": "请先勾选数据",
  "搜索产品": "搜索产品",
  "已选中当前已加载项": "已选中当前已加载项",
  "全部分类": "全部分类",
  "尚未设置密码，请选择其他方式登录！": "尚未设置密码，请选择其他方式登录",
  "请上传PDF文档": "请上传PDF文档",
  "上传品牌介绍": "上传品牌介绍",
  "编辑内容": "编辑内容",
  "编辑文字": "编辑文字",
  "团队剩余空间不足": "团队剩余空间不足",
  "此次待上传的图片大小超出团队剩余容量，请联系管理员购买容量或重新选择图片": "此次待上传的图片大小超出团队剩余容量，请联系管理员购买容量或重新选择图片",
  "作品中存在上传中的图片，不可操作": "作品中存在上传中的图片，不可操作",
  "全部导入": "全部导入",
  "确定导入该私域所有产品吗？": "确定导入该私域所有产品吗？",
  "添加分组": "添加分组",
  "编辑分组": "编辑分组",
  "显示锚点": "显示锚点",
  "隐藏锚点": "隐藏锚点",
  "添加图片": "添加图片",
  "添加文档": "添加文档",
  "存在重名分类，请修改分类名称后再拖动！": "存在重名分类，请修改分类名称后再拖动",
  "排序数据已过期，请刷新页面后重试": "排序数据已过期，请刷新页面后重试",
  "请不要拖动到添加后面": "请不要拖动到添加后面",
  "确定要删除吗?已关联产品中的对应供应商会一并删除！": "确定要删除吗？已关联产品中的对应供应商会一并删除",
  "/永久": "/永久",
  "确定要删除该顶级分类及下属分类吗?": "确定要删除该一级分类及下属分类吗？",
  "确定要删除该一级分类及下属分类吗?": "确定要删除该二级分类及下属分类吗？",
  "无法继续放大卡片": "无法继续放大卡片",
  "无法继续缩小卡片": "无法继续缩小卡片",
  "登录失效！": "登录失效",
  "您可以通过以下方式便捷续费：": "您可以通过以下方式便捷续费：",
  "1.通过Android手机APP续费": "1.通过Android手机APP续费",
  "2.使用电脑访问官网续费: www.bujue.art": "2.使用电脑访问官网续费：www.bujue.art",
  "感谢您的支持！": "感谢您的支持！",
  "当前私域容量套餐已到期，为不影响使用，请及时续费。": "当前私域容量套餐已到期，为不影响使用，请及时续费。",
  "当前私域容量套餐已到期，为不影响使用，请联系私域管理员续费。": "当前私域容量套餐已到期，为不影响使用，请联系私域管理员续费。",
  "容量到期": "容量到期",
  "忽略": "忽略",
  "立即续费": "立即续费",
  "去我的空间": "去我的空间",
  "。": "。",
  "官网分享": "官网分享",
  "定向分享": "定向分享",
  "没有可入库的产品！": "没有可入库的产品",
  "批量分类": "批量分类",
  "选择分类": "选择分类",
  "批量出库": "批量出库",
  "确定出库": "确定出库",
  "请输入关键词": "请输入关键词",
  "请选择完整的三级分类": "请选择完整的三级分类",
  "请选择完整的规格": "请选择完整的规格",
  "请选择完整的SKU": "请选择完整的SKU",
  "加入采购清单成功": "加入采购清单成功",
  "最近搜索": "最近搜索",
  "确定要清空搜索吗?": "确定要清空搜索吗？",
  "历史搜索": "历史搜索",
  "其他成员正在管理筛选字段，请稍候再试。": "其他成员正在管理筛选字段，请稍候再试。",
  "当前有未保存的更改，是否确认关闭？": "当前有未保存的更改，是否确认关闭？",
  "其他成员正在管理自定义字段，请稍候再试。": "其他成员正在管理自定义字段，请稍候再试。",
  "数据发生变化，已自动刷新。": "数据发生变化，已自动刷新。",
  "请输入候选值": "请输入候选值",
  "仅支持输入汉字、英文字母、数字及以下标点符号：- _ ， , 。' . 空格 () （）【】[]": "仅支持输入汉字、英文字母、数字及以下标点符号：- _，,。' . 空格 ()（）【】[]",
  "确认删除该候选值吗？": "确认删除该候选值吗？",
  "确认删除该字段吗？": "确认删除该字段吗？",
  "确认删除该候选值吗？\n已关联产品不会同步删除,如需调整需手动修改": "确认删除该候选值吗？\n已关联产品不会同步删除，如需调整需手动修改",
  "确认删除该字段吗？\n已关联产品不会同步删除,如需调整需手动修改": "确认删除该字段吗？\n已关联产品不会同步删除，如需调整需手动修改",
  "确认删除该字段吗？\n后续新增/编辑表单时将不再具有该字段": "确认删除该字段吗？\n后续新增/编辑表单时将不再具有该字段",
  "确认删除该候选值吗？\n后续新增/编辑表单时该字段将不再具有该候选值": "确认删除该候选值吗？\n后续新增/编辑表单时该字段将不再具有该候选值",
  "检测到敏感词，请修改后重试": "检测到敏感词，请修改后重试",
  "候选值不能为空": "候选值不能为空",
  "候选值不能重名": "候选值不能重名",
  "候选值中文不能重名": "候选值中文不能重名",
  "候选值英文不能重名": "候选值英文不能重名",
  "字段不能为空": "字段不能为空",
  "字段不能重名": "字段不能重名",
  "字段中文不能重名": "字段中文不能重名",
  "字段英文不能重名": "字段英文不能重名",
  "英文长度超出,请修改后重试": "英文长度超出，请修改后重试",
  "翻译长度超出,请修改后重试": "翻译长度超出，请修改后重试",
  "已经是第一个": "已经是第一个",
  "已经是最后一个": "已经是最后一个",
  "请输入中文字段名称": "请输入中文字段名称",
  "请输入中文分类名称": "请输入中文分类名称",
  "请先填写中文内容": "请先填写中文内容",
  "请输入英文字段名称": "请输入英文字段名称",
  "请输入{{language}}字段名称": "请输入{{language}}字段名称",
  "请输入字段名称翻译": "请输入字段名称翻译",
  "请输入中文候选值": "请输入中文候选值",
  "请输入英文候选值": "请输入英文候选值",
  "请输入{{language}}候选值": "请输入{{language}}候选值",
  "请输入候选值翻译": "请输入候选值翻译",
  "请先完成当前项的编辑。": "请先完成当前项的编辑。",
  "中文长度超出,请修改后重试": "中文长度超出，请修改后重试",
  "“未分组”为系统保留选项，不支持添加。": "“未分组”为系统保留选项，不支持添加。",
  "产品字段": "产品字段",
  "产品管理：通过手动和委托的方式添加产品，对未入库/已入库的产品审核后进行批量入库、修改分类的操作。": "产品管理：通过手动和委托的方式添加产品，对未入库/已入库的产品审核后进行批量入库、修改分类的操作。",
  "品类管理：对产品的分类、品牌、供应商信息进行统一管理。": "品类管理：对产品的分类、品牌、供应商信息进行统一管理。",
  "字段管理：管理产品中的自定义字段信息，设置产品列表的筛选条件。": "字段管理：管理产品中的自定义字段信息，设置产品列表的筛选条件。",
  "展示配置：控制各终端产品的平铺、分类、品牌3个列表的显示和排序，以及产品封面呈现效果": "展示配置：控制各终端产品的平铺、分类、品牌3个列表的显示和排序，以及产品封面呈现效果",
  "展示配置": "展示配置",
  "公域发布：发布私域产品到公域，产品信息未通过官方审核会被驳回，重新修改后再发布。": "公域发布：发布私域产品到公域，产品信息未通过官方审核会被驳回，重新修改后再发布。",
  "小程序-定制化配置：管理小程序的定制化内容": "小程序-定制化配置：管理小程序的定制化内容",
  "入库审核": "入库审核",
  "产品管理": "产品管理",
  "品类管理": "品类管理",
  "分类管理": "分类管理",
  "品牌管理": "品牌管理",
  "供应商管理": "供应商管理",
  "字段管理": "字段管理",
  "展示顺序": "展示顺序",
  "公域发布": "公域发布",
  "小程序-定制化配置": "小程序-定制化配置",
  "定制页面管理": "定制页面管理",
  "一级分类主页": "一级分类主页",
  "新品页": "新品页",
  "分类名称": "分类名称",
  "指针页面": "指针页面",
  "请输入页面路径": "请输入页面路径",
  "新品页名称": "新品页名称",
  "h5地址": "h5地址",
  "*调整该配置将直接影响小程序对应页面，请谨慎处理": "*调整该配置将直接影响小程序对应页面，请谨慎处理",
  "品牌轮播图管理": "品牌轮播图管理",
  "确定要清空该品牌下所有轮播图吗？": "确定要清空该品牌下所有轮播图吗？",
  "清空后数据将无法恢复，请谨慎操作": "清空后数据将无法恢复，请谨慎操作",
  "确定清空": "确定清空",
  "清空失败": "清空失败",
  "图片太大，请重新上传(文件最大8MB)": "图片太大，请重新上传(文件最大8MB)",
  "图片上传失败": "图片上传失败",
  "上传或保存失败": "上传或保存失败",
  "确定要删除该图片吗？": "确定要删除该图片吗？",
  "保存失败": "保存失败",
  "暂无品牌": "暂无品牌",
  "一次最多上传5张图片": "一次最多上传5张图片",
  "请上传JPG、PNG、GIF、WebP格式的图片，推荐尺寸1650×1000px": "请上传JPG、PNG、GIF、WebP格式的图片，推荐尺寸1650×1000px",
  "已发布": "已发布",
  "管理字段": "管理字段",
  "请前往<manage>管理字段</manage>添加": "请前往<manage>管理字段</manage>添加",
  "默认顺序": "默认顺序",
  "产品备注": "产品备注",
  "款式备注": "款式备注",
  "新增备注": "新增备注",
  "名称A-Z": "名称A-Z",
  "名称Z-A": "名称Z-A",
  "暂无结果": "暂无结果",
  "暂无选项": "暂无选项",
  "操作失败，请检查数据版本": "操作失败，请检查数据版本",
  "筛选字段": "筛选字段",
  "待选项": "待选项",
  "最多支持": "最多支持",
  "个筛选字段。": "个筛选字段。",
  "至少设置": "至少设置",
  "添加链接": "添加链接",
  "视频描述": "视频描述",
  "图片描述": "图片描述",
  "请输入图片名称": "请输入图片名称",
  "图片名称": "图片名称",
  "编辑链接": "编辑链接",
  "粘贴或输入bujue.art域名的网页链接， 如：https://www.bujue.art": "粘贴或输入bujue.art域名的网页链接，如：https://www.bujue.art",
  "请粘贴有效链接": "请粘贴有效链接",
  "文本": "文本",
  "请输入链接": "请输入链接",
  "链接": "链接",
  "请输入有效链接": "请输入有效链接",
  "添加宣传链接": "添加宣传链接",
  "请先保存": "请先保存",
  "请先保存当前编辑内容": "请先保存当前编辑内容",
  "更换": "更换",
  "请输入网址": "请输入网址",
  "你确定要删除吗?": "你确定要删除吗？",
  "你确定要取消上传吗?": "你确定要取消上传吗？",
  "请输入合法的网址": "请输入合法的网址",
  "不是图片": "不是图片",
  "在图上点击添加锚点": "在图上点击添加锚点",
  "拖拽锚点移动位置": "拖拽锚点移动位置",
  "拖拽产品卡片调整顺序": "拖拽产品卡片调整顺序",
  "设置保密级别": "设置保密级别",
  "选择下级时自动选中上级": "选择下级时自动选中上级",
  "私域拥有者可见": "私域拥有者可见",
  "管理员可见": "管理员可见",
  "成员可见": "成员可见",
  "访客可见": "访客可见",
  "请输入,限150个字": "请输入，限150个字",
  "请选择时间": "请选择时间",
  "正在翻译中": "正在翻译中",
  "一键翻译": "一键翻译",
  "建筑面积": "建筑面积",
  "摄影版权": "摄影版权",
  "{{name}}方": "{{name}}方",
  "请输入,限{{maxLength}}个字": "请输入，限{{maxLength}}个字",
  "请填写名称": "请填写名称",
  "请填写时间": "请填写时间",
  "请填写{{name}}": "请填写{{name}}",
  "请填写{{name}}-{{language}}": "请填写{{name}}-{{language}}",
  "请输入字段": "请输入字段",
  "正在翻译中，请勿重复提交": "正在翻译中，请勿重复提交",
  "关联盘八斗项目": "关联盘八斗项目",
  "项目名称": "项目名称",
  "项目名称必填!": "项目名称必填",
  "请填写项目名称": "请填写项目名称",
  "项目链接": "项目链接",
  "请输入正确的盘八斗项目管理链接": "请输入正确的盘八斗项目管理链接",
  "请粘贴盘八斗的项目链接": "请粘贴盘八斗的项目链接",
  "请输入介绍": "请输入介绍",
  "请输入客户": "请输入客户",
  "请输入联系方式": "请输入联系方式",
  "请输入详细地址": "请输入详细地址",
  "创建": "创建",
  "英文字段长度有问题请修改后重试": "英文字段长度有问题请修改后重试",
  "字段已存在": "字段已存在",
  "请输入其他值": "请输入其他值",
  "保密": "保密",
  "是否同步删除云盘“": "是否同步删除云盘“",
  "”文件夹": "”文件夹",
  "置顶成功": "置顶成功",
  "取消置顶成功": "取消置顶成功",
  "输入字段": "输入字段",
  "点击添加VR": "点击添加VR",
  "添加VR": "添加VR",
  "上传图片/视频": "上传图片/视频",
  "正在上传中，请稍后": "正在上传中，请稍后",
  "请勾选": "请勾选",
  "修改失败": "修改失败",
  "删除失败": "删除失败",
  "未改变顺序": "未改变顺序",
  "排序成功": "排序成功",
  "排序失败": "排序失败",
  "库被关闭": "库被关闭",
  "库": "库",
  "正在获取预览图...": "正在获取预览图…",
  "预览图": "预览图",
  "确认解除关联？": "确认解除关联？",
  "解除成功": "解除成功",
  "项目链接必填!": "项目链接必填",
  "设置封面": "设置封面",
  "更改未保存，确定离开？": "更改未保存，确定离开？",
  "文件上传未完成，确定离开？": "文件上传未完成，确定离开？",
  "文件上传未完成，稍后再试": "文件上传未完成，稍后再试",
  "容量不足": "容量不足",
  "尊敬的用户，您的不觉云存储空间不足，为避免影响正常使用，建议您尽快进行容量升级。": "尊敬的用户，您的不觉云存储空间不足，为避免影响正常使用，建议您尽快进行容量升级。",
  "去扩容": "去扩容",
  "请输入正确的地址": "请输入正确的地址",
  "请填写中文名称": "请填写中文名称",
  "关注": "关注",
  "请在电脑上打开链接进行批量下载": "请在电脑上打开链接进行批量下载",
  "查看": "查看",
  "智能排序": "智能排序",
  "浏览量排序": "浏览量排序",
  "上新": "上新",
  "以下信息仅管理员可见": "以下信息仅管理员可见",
  "列数": "列数",
  "列": "列",
  "作品视图": "作品视图",
  "合集视图": "合集视图",
  "照片视图": "照片视图",
  "默认": "默认",
  "分享添加": "分享添加",
  "默认语言：": "默认语言：",
  "默认语言": "默认语言",
  "分享语言：": "分享语言：",
  "介绍册": "介绍册",
  "作品集": "作品集",
  "产品册": "产品册",
  "为了最佳使用体验，单次最多可添加30个文件。": "为了最佳使用体验，单次最多可添加30个文件。",
  "照片": "照片",
  "排序筛选": "排序筛选",
  "合集方式": "合集方式",
  "其他成员正在调整图片顺序，请稍后再试。": "其他成员正在调整图片顺序，请稍后再试。",
  "操作超时": "操作超时",
  "选品": "选品",
  "当前候选值被作品引用，不可删除": "当前候选值被作品引用，不可删除",
  "其他成员更新了自定义字段，点击刷新获取最新内容再试。": "其他成员更新了自定义字段，点击刷新获取最新内容再试。",
  "刷新": "刷新",
  "其他成员更新了自定义字段，": "其他成员更新了自定义字段，",
  "点击刷新获取最新内容再试。": "点击刷新获取最新内容再试。",
  "总计": "总计",
  "作品详情": "作品详情",
  "卡片大小": "卡片大小",
  "进入官网": "进入官网",
  "本次上架被自动驳回。": "本次上架被自动驳回。",
  "上传介绍": "上传介绍",
  "修改介绍": "修改介绍",
  "确认要删除该品牌吗？": "确认要删除该品牌吗？",
  "删除分组后，关联的所有的品牌都清空这个分组": "删除分组后，关联的所有的品牌都清空这个分组",
  "确认要删除该分组吗？": "确认要删除该分组吗？",
  "选择分组": "选择分组",
  "所有款式名称": "所有款式名称",
  "管理款式": "管理款式",
  "颜色": "颜色",
  "尺寸": "尺寸",
  "点击升序": "点击升序",
  "点击降序": "点击降序",
  "取消排序": "取消排序",
  "请先完善分类信息再操作": "请先完善分类信息再操作",
  "删除分类": "删除分类",
  "只删分类": "只删分类",
  "确定要删除选中的分类，并同步删除分类下的产品吗？": "确定要删除选中的分类，并同步删除分类下的产品吗？",
  "图片大小限制500kb": "图片大小限制500kb",
  "默认首个款式图为封面": "默认首个款式图为封面",
  "图片比例1:1": "图片比例1:1",
  "分类副标题": "分类副标题",
  "分类主标题*": "分类主标题*",
  "分类标题*": "分类标题*",
  "请输入分组名称": "请输入分组名称",
  "更新分类": "更新分类",
  "请填写分类": "请填写分类",
  "请填写一级分类": "请填写一级分类",
  "请填写二级分类": "请填写二级分类",
  "请先在左侧栏添加二级分类": "请先在左侧栏添加二级分类",
  "请先在左侧栏添加分类": "请先在左侧栏添加分类",
  "请填写分类副标题": "请填写分类副标题",
  "资源库": "资源库",
  "紫菜海洋": "紫菜海洋",
  "设计师专属的产品、艺术品数据库": "设计师专属的产品、艺术品数据库",
  "工具": "工具",
  "创意板": "创意板",
  "创意板项目": "创意板项目",
  "物料板后台": "物料板后台",
  "会员项目": "会员项目",
  "成员项目": "成员项目",
  "负责人": "负责人",
  "未指定负责人": "未指定负责人",
  "请选择项目": "请选择项目",
  "搜索项目名称/负责人": "搜索项目名称/负责人",
  "搜索项目名称/创建人": "搜索项目名称/创建人",
  "批量导出": "批量导出",
  "批量指派": "批量指派",
  "指派": "指派",
  "将": "将",
  "项目指派给": "项目指派给",
  "将{{projectName}}项目指派给": "将{{projectName}}项目指派给",
  "将选中的{{count}}个项目指派给": "将选中的{{count}}个项目指派给",
  "获取成员列表失败": "获取成员列表失败",
  "指派失败": "指派失败",
  "指派成功": "指派成功",
  "确认删除该项目吗？删除后不可恢复": "确认删除该项目吗？删除后不可恢复",
  "确认删除当前选中的{{count}}个项目吗？": "确认删除当前选中的{{count}}个项目吗？",
  "项目类型": "项目类型",
  "确认导出当前选中的{{count}}个项目的数据吗？": "确认导出当前选中的{{count}}个项目的数据吗？",
  "{{action}}功能待接口联调": "{{action}}功能待接口联调",
  "会员版物料板": "会员版物料板",
  "成员版物料板": "成员版物料板",
  " · 会员版": " · 会员版",
  " · 成员版": " · 成员版",
  "存在需要迁移的历史项目": "存在需要迁移的历史项目",
  "创意板现已变更为私域级工具物料板": "创意板现已变更为私域级工具物料板",
  "请为历史项目指定归属私域": "请为历史项目指定归属私域",
  "项目信息将对私域可见并可使用对应私域素材": "项目信息将对私域可见并可使用对应私域素材",
  "项目的所属权将变更为对应私域，管理员可对其进行调整与指派": "项目的所属权将变更为对应私域，管理员可对其进行调整与指派",
  "关注、收藏的产品素材不再可用，历史相关数据保留": "关注、收藏的产品素材不再可用，历史相关数据保留",
  "迁移完成后不可修改": "迁移完成后不可修改",
  "如有疑问请联系不觉客服咨询": "如有疑问请联系不觉客服咨询",
  "稍后处理": "稍后处理",
  "立即迁移": "立即迁移",
  "指定私域归属": "指定私域归属",
  "已指定 {{assigned}}/{{total}}": "已指定 {{assigned}}/{{total}}",
  "请选择私域": "请选择私域",
  "迁移指定项目": "迁移指定项目",
  "请为历史项目指定归属私域，项目信息将对私域可见并可使用对应私域素材；迁移完成后不可修改。": "请为历史项目指定归属私域，项目信息将对私域可见并可使用对应私域素材；迁移完成后不可修改。",
  "快速设计软硬装搭配方案，导出材料及报价清单": "快速设计软硬装搭配方案，导出材料及报价清单",
  "盘八斗": "盘八斗",
  "设计师的项目管理小秘书": "设计师的项目管理小秘书",
  "插件": "插件",
  "Revit插件，直接调用私域产品库的贴图和模型": "Revit插件，直接调用私域产品库的贴图和模型",
  "3DSMax插件，直接调用私域产品库的贴图和模型": "3DSMax插件，直接调用私域产品库的贴图和模型",
  "Rhino插件，直接调用私域产品库的贴图和模型": "Rhino插件，直接调用私域产品库的贴图和模型",
  "SketchUp插件，直接调用私域产品库的贴图和模型": "SketchUp插件，直接调用私域产品库的贴图和模型",
  "不觉官方": "不觉官方",
  "不觉官网": "不觉官网",
  "了解更多关于不觉": "了解更多关于不觉",
  "不觉APP": "不觉APP",
  "随时随地使用不觉": "随时随地使用不觉",
  "操作说明": "操作说明",
  "新手用户操作指引": "新手用户操作指引",
  "一键导入": "一键导入",
  "轻点鼠标即可从丰富的不觉产品库中选取所需的模型或材质贴图，一键添加到您的项目中。": "轻点鼠标即可从丰富的不觉产品库中选取所需的模型或材质贴图，一键添加到您的项目中。",
  "简化工作流": "简化工作流",
  "插件与Revit软件完美兼容，与不觉产品库深度集成，您可以在Revit中完成所有操作，享受无中断的工作体验。": "插件与Revit软件完美兼容，与不觉产品库深度集成，您可以在Revit中完成所有操作，享受无中断的工作体验。",
  "持续更新": "持续更新",
  "我们将持续丰富不觉产品库内容，并持续迭代插件，确保您始终能够获得最前沿的设计元素和最专业的技术支持。": "我们将持续丰富不觉产品库内容，并持续迭代插件，确保您始终能够获得最前沿的设计元素和最专业的技术支持。",
  "不觉 · BIM": "不觉 · BIM",
  "让每一个创意都能迅速转化为精确的数字模型": "让每一个创意都能迅速转化为精确的数字模型",
  "立即下载": "立即下载",
  "插件与3DSMax软件完美兼容，与不觉产品库深度集成，您可以在3DSMax中完成所有操作，享受无中断的工作体验。": "插件与3DSMax软件完美兼容，与不觉产品库深度集成，您可以在3DSMax中完成所有操作，享受无中断的工作体验。",
  "不觉 · 3DS Max": "不觉 · 3DS Max",
  "插件与Rhino软件完美兼容，与不觉产品库深度集成，您可以在Rhino中完成所有操作，享受无中断的工作体验。": "插件与Rhino软件完美兼容，与不觉产品库深度集成，您可以在Rhino中完成所有操作，享受无中断的工作体验。",
  "不觉 · Rhino": "不觉 · Rhino",
  "插件与SketchUp软件完美兼容，与不觉产品库深度集成，您可以在SketchUp中完成所有操作，享受无中断的工作体验。": "插件与SketchUp软件完美兼容，与不觉产品库深度集成，您可以在SketchUp中完成所有操作，享受无中断的工作体验。",
  "不觉 · SketchUp": "不觉 · SketchUp",
  "不觉": "不觉",
  "添加不觉客服微信，咨询开通详情": "添加不觉客服微信，咨询开通详情",
  "添加不觉客服微信": "添加不觉客服微信",
  "填写产品信息": "填写产品信息",
  "上传产品介绍": "上传产品介绍",
  "上传产品附件": "上传产品附件",
  "产品封面": "产品封面",
  "官方字段": "官方字段",
  "产品类别": "产品类别",
  "物流发货": "物流发货",
  "无需物流": "无需物流",
  "送样服务": "送样服务",
  "提供样品赠送服务，便于用户在正式购买前确认材质、颜色、尺寸等产品细节。": "提供样品赠送服务，便于用户在正式购买前确认材质、颜色、尺寸等产品细节。",
  "每个产品字段可以下拉多选，所选内容展示于产品详情页，可用于产品列表筛选。": "每个产品字段可以下拉多选，所选内容展示于产品详情页，可用于产品列表筛选。",
  "更多属性": "更多属性",
  "翻译中...": "翻译中…",
  "翻译中⋯": "翻译中⋯",
  "每个产品支持添加最多 5 个属性字段，编辑纯文本内容，字段内容展示于产品详情页，不支持筛选。": "每个产品支持添加最多 5 个属性字段，编辑纯文本内容，字段内容展示于产品详情页，不支持筛选。",
  "添加属性": "添加属性",
  "最多添加5个属性": "最多添加5个属性",
  "推荐": "推荐",
  "规格信息": "规格信息",
  "产品规格": "产品规格",
  "请填写产品规格": "请填写产品规格",
  "添加产品规格": "添加产品规格",
  "系统规格": "系统规格",
  "管理系统规格": "管理系统规格",
  "其他成员正在管理系统规格字段，请稍候再试。": "其他成员正在管理系统规格字段，请稍候再试。",
  "请前往<manage>管理系统规格</manage>添加": "请前往<manage>管理系统规格</manage>添加",
  "暂无可用规格，请前往产品信息添加": "暂无可用规格，请前往产品信息添加",
  "规格名": "规格名",
  "规格名已存在，请重新输入": "规格名已存在，请重新输入",
  "支持手动输入创建新规格名/值，鼠标点击或回车均可添加，规格名称不超过6个字符，规格值不超过50个字符": "支持手动输入创建新规格名/值，鼠标点击或回车均可添加，规格名称不超过6个字符，规格值不超过50个字符",
  "规格值": "规格值",
  "规格值已存在，请重新输入": "规格值已存在，请重新输入",
  "规格名翻译不能为空": "规格名翻译不能为空",
  "规格值翻译不能为空": "规格值翻译不能为空",
  "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png/webp": "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png/webp",
  "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png": "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png",
  "规格明细表": "规格明细表",
  "批量设置": "批量设置",
  "选择规格": "选择规格",
  "填写内容": "填写内容",
  "填写": "填写",
  "填写面价": "填写面价",
  "填写底价": "填写底价",
  "填写包装体积（m³）": "填写包装体积（m³）",
  "填写重量（kg）": "填写重量（kg）",
  "填写更多属性": "填写更多属性",
  "库存预警": "库存预警",
  "体积": "体积",
  "重量": "重量",
  "更多图片": "更多图片",
  "最多上传3张": "最多上传3张",
  "产品规格启用：开启后，产品详情页可选择该规格；关闭后将无法选择。": "产品规格启用：开启后，产品详情页可选择该规格；关闭后将无法选择。",
  "确认禁用该规格吗？产品详情页将无法选择该规格": "确认禁用该规格吗？产品详情页将无法选择该规格",
  "库存总和": "库存总和",
  "每个规格的库存之和": "每个规格的库存之和",
  "*面价": "*面价",
  "底价": "底价",
  "库存": "库存",
  "包装体积（m³）": "包装体积（m³）",
  "重量（kg）": "重量（kg）",
  "面价": "面价",
  "产品提交": "产品提交",
  "请先完善必填信息": "请先完善必填信息",
  "最多添加5个规格！": "最多添加5个规格",
  "最多添加100个规格值！": "最多添加100个规格值",
  "请先完成上一个规格或规格值的填写": "请先完成上一个规格或规格值的填写",
  "单个产品规格组合数量不能超过1000个": "单个产品规格组合数量不能超过1000个",
  "请至少选择一个规格值": "请至少选择一个规格值",
  "请至少添加一个规格": "请至少添加一个规格",
  "底价不能高于面价": "底价不能高于面价",
  "图片不能超过20张": "图片不能超过20张",
  "提示：请为每种语言单独上传介绍内容，避免切换语言后出现内容空缺": "提示：请为每种语言单独上传介绍内容，避免切换语言后出现内容空缺",
  "文件：": "文件：",
  "添加文件 支持PDF/PPT/WORD/EXCEL/压缩包等格式": "添加文件支持PDF/PPT/WORD/EXCEL/压缩包等格式",
  "添加文件": "添加文件",
  "支持PDF/PPT/WORD/EXCEL/压缩包等格式": "支持PDF/PPT/WORD/EXCEL/压缩包等格式",
  "模型：": "模型：",
  "添加模型 支持CAD/SU/3dsMax/Revit格式": "添加模型支持CAD/SU/3dsMax/Revit格式",
  "添加模型": "添加模型",
  "支持CAD/SU/3dsMax/Revit格式": "支持CAD/SU/3dsMax/Revit格式",
  "文件格式不支持": "文件格式不支持",
  "贴图：": "贴图：",
  "查看底价": "查看底价",
  "暂无文件": "暂无文件",
  "暂无案例": "暂无案例",
  "暂无贴图": "暂无贴图",
  "收藏": "收藏",
  "取消收藏": "取消收藏",
  "已收藏": "已收藏",
  "已添加收藏":"已添加收藏",
  "已取消收藏":"已取消收藏",
  "登录已过期，请重新登录":"登录已过期，请重新登录",
  "其他文件": "其他文件",
  "暂无模型": "暂无模型",
  "文件": "文件",
  "规格字段": "规格字段",
  "关联规格字段": "关联规格字段",
  "批量关联": "批量关联",
  "添加规格": "添加规格",
  "请选择关联规格字段": "请选择关联规格字段",
  "关联规格字段与产品分类后，该分类下的产品筛选条件将自动增加对应规格。": "关联规格字段与产品分类后，该分类下的产品筛选条件将自动增加对应规格。",
  "请先选择分类": "请先选择分类",
  "商家后台": "商家后台",
  "实际销量": "实际销量",
  "实物": "实物",
  "虚拟": "虚拟",
  "配送方式": "配送方式",
  "快递配送": "快递配送",
  "无需快递": "无需快递",
  "入库状态": "入库状态",
  "入库状态的产品，成员可以在APP、Web工作台查看，访客不能查看": "入库状态的产品，成员可以在APP、Web工作台查看，访客不能查看",
  "上架状态的产品，成员和访客在小程序、官网可以查看": "上架状态的产品，成员和访客在小程序、官网可以查看",
  "申请上架": "申请上架",
  "其他成员正在编辑该产品，请稍候再试。": "其他成员正在编辑该产品，请稍候再试。",
  "复制成功!": "复制成功",
  "删除成功!": "删除成功",
  "上架成功！": "上架成功",
  "上架成功": "上架成功",
  "已提交审核": "已提交审核",
  "已下架": "已下架",
  "下架成功！": "下架成功",
  "申请上架成功！": "申请上架成功",
  "下架理由": "下架理由",
  "下架时间": "下架时间",
  "申请理由": "申请理由",
  "请填写申请理由": "请填写申请理由",
  "提交申请": "提交申请",
  "批量操作": "批量操作",
  "退出批量操作": "退出批量操作",
  "批量上架": "批量上架",
  "批量下架": "批量下架",
  "一键入库": "一键入库",
  "一键删除": "一键删除",
  "最低价": "最低价",
  "最高价": "最高价",
  "模型": "模型",
  "价格": "价格",
  "有贴图": "有贴图",
  "无贴图": "无贴图",
  "被驳回": "被驳回",
  "条每页": "条每页",
  "条/页": "条/页",
  "跳至": "跳至",
  "第": "第",
  "条/共": "条/共",
  "请先前往私域设置，开启访客查看产品权限。": "请先前往私域设置，开启访客查看产品权限。",
  "跳转": "跳转",
  "有": "有",
  "基本": "基本",
  "新增属性": "新增属性",
  "选择款式": "选择款式",
  "起": "起",
  "本地上传": "本地上传",
  "关联贴图": "关联贴图",
  "请填写": "请填写",
  "点击添加": "点击添加",
  "请先完成上一个规格值的填写": "请先完成上一个规格值的填写",
  "建议图片大小不超过500KB": "建议图片大小不超过500KB",
  "产品贴图文件夹不存在": "产品贴图文件夹不存在",
  "云存储空间不足": "云存储空间不足",
  "产品图片文件夹不存在": "产品图片文件夹不存在",
  "请等待当前图片上传完成": "请等待当前图片上传完成",
  "查看更多": "查看更多",
  "其他规格同步删除": "其他规格同步删除",
  "压缩包": "压缩包",
  "确认删除该附件吗？": "确认删除该附件吗？",
  "文件最多上传50个": "文件最多上传50个",
  "模型最多上传50个": "模型最多上传50个",
  "贴图最多上传1000个": "贴图最多上传1000个",
  "入库时间-正序": "入库时间-正序",
  "入库时间-倒序": "入库时间-倒序",
  "上架时间-正序": "上架时间-正序",
  "上架时间-倒序": "上架时间-倒序",
  "名称 A→Z": "名称 A→Z",
  "名称 Z→A": "名称 Z→A",
  "请至少保留一个生效规格！": "请至少保留一个生效规格",

  // 批量下载弹窗(cloud_disk/components/batch_download_modal)
  // 弹窗里两段提示原本是「每个字之间加一个空格」的排版,这层字间距保留在中文值里,
  // key 用不带空格的自然文案(英文才不会被空格污染),末尾/开头的空格是为了和中间可点击的「下载」拼接
  "下载文件": "下载文件",
  "下载任务正在启动中请稍后尝试": "下载任务正在启动中请稍后尝试",
  "正在启动不觉云下载器，请稍候。": "正 在 启 动 不 觉 云 下 载 器 ， 请 稍 候 。",
  "您暂未安装不觉云下载器，请点击": "您 暂 未 安 装 不 觉 云 下 载 器 ， 请 点 击 ",
  "，完成安装后点击重试即可开始下载。": " ， 完 成 安 装 后 点 击 重 试 即 可 开 始 下 载 。",
  "请使用Windows或苹果电脑进行批量下载": "请使用Windows或苹果电脑进行批量下载",
  "启用{language}": "启用{{language}}",
  "系统将自动翻译现有数据,翻译期间请勿改动数据": "系统将自动翻译现有数据，翻译期间请勿改动数据",
  "将为您的私域开启多语言-{language}": "将为您的私域开启多语言-{{language}}",
  "系统将自动翻译现有数据，请勿操作任何私域数据以免引发翻译问题": "系统将自动翻译现有数据，请勿操作任何私域数据以免引发翻译问题",
  "排队中...": "排队中…",
  "排队中⋯": "排队中⋯",
  "简体中文": "简体中文",
  "拖动卡片调整顺序；默认使用首个开启的语言。": "拖动卡片调整顺序；默认使用首个开启的语言。",
  "私域容量使用情况": "私域容量使用情况",
  "查看权益": "查看权益",
  "/年": "/年",
  "补差价升级": "补差价升级",
  "到期日期：": "到期日期：",
  "到期时间：": "到期时间：",
  "确定订单": "确定订单",
  "当前套餐剩余时长": "当前套餐剩余时长",
  "升级套餐": "升级套餐",
  "购买时长": "购买时长",
  "有效期至": "有效期至",
  "原价": "原价",
  "抵扣": "抵扣",
  "优惠码": "优惠码",
  "优惠": "优惠",
  "支付方式": "支付方式",
  "支付宝": "支付宝",
  "合计": "合计",
  "立即订阅": "立即订阅",
  "优惠金额": "优惠金额",
  "原套餐已到期，部分功能不再可用，请及时续费": "原套餐已到期，部分功能不再可用，请及时续费",
  "不觉-套餐订阅": "不觉-套餐订阅",
  "不觉·套餐订阅": "不觉·套餐订阅",
  "你的私域已使用 {私域已用容量} 容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。": "你的私域已使用 {私域已用容量} 容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。",
  "/页": "/页",
  "跳至 {页码} 页": "跳至 {{pageNum}} 页",
  "当前私域套餐容量不足": "当前私域套餐容量不足",
  "为不影响使用，请及时处理": "为不影响使用，请及时处理",
  "为不影响使用，请联系私域管理员处理": "为不影响使用，请联系私域管理员处理",
  "当前私域套餐容量不足，为不影响使用，请及时处理": "当前私域套餐容量不足，为不影响使用，请及时处理",
  "当前私域套餐容量不足，为不影响使用，请联系私域管理员处理": "当前私域套餐容量不足，为不影响使用，请联系私域管理员处理",
  "立即续费/升级": "立即续费/升级",
  "暂不支持降级套餐": "暂不支持降级套餐",
  "套餐购买或套餐续期时，原价=新套餐单价*购买时长.": "套餐购买或套餐续期时，原价=新套餐单价*购买时长.",
  "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数.": "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数.",
  "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和.": "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和.",
  "套餐新购买或续费时：优惠金额 = 原价 * (1 - 折扣)": "套餐新购买或续费时：优惠金额 = 原价 * (1 - 折扣)",
  "升级套餐时：优惠金额 = (原价 - 抵扣) * (1 - 折扣)": "升级套餐时：优惠金额 = (原价 - 抵扣) * (1 - 折扣)",
  "你的私域已使用 {cloudStorage} 容量，请购买更高容量套餐，\n或进入管理模式清理无用数据后再试": "你的私域已使用 {{cloudStorage}} 容量，请购买更高容量套餐，\n或进入管理模式清理无用数据后再试",
  "请输入6位优惠码": "请输入6位优惠码",
  "输入优惠码": "输入优惠码",
  "请输入有效优惠码": "请输入有效优惠码",
  "优惠码：请联系不觉客服获取优惠码.": "优惠码：请联系不觉客服获取优惠码.",
  "请输入优惠码享受优惠:": "请输入优惠码享受优惠：",
  "立即扩容": "立即扩容",
  "立即购买": "立即购买",
  // 云盘
  "文件名": "文件名",
  "目标文件夹中的文件": "目标文件夹中的文件",
  "正在上传的文件": "正在上传的文件",
  "保留两者": "保留两者",
  "覆盖": "覆盖",
  "已有的文件": "已有的文件",
  "文件信息": "文件信息",
  "文件路径": "文件路径",
  "上传文件": "上传文件",
  "上传文件夹": "上传文件夹",
  "未命名文件夹": "未命名文件夹",
  "创建文件夹": "创建文件夹",
  "重命名": "重命名",
  "产品素材库只能上传图片！": "产品素材库只能上传图片！",
  "云盘容量耗尽": "云盘容量耗尽",
  "云盘容量不足": "云盘容量不足",
  "部分文件超出云盘容量": "部分文件超出云盘容量",
  "上传列表": "上传列表",
  "没有上传任务": "没有上传任务",
  "上传中": "上传中",
  "已完成": "已完成",
  "暂无上传任务": "暂无上传任务",
  "上传成功": "上传成功",
  "文件夹名不能为空": "文件夹名不能为空",
  "文件名不能为空": "文件名不能为空",
  "文件名不能包含以下字符:": "文件名不能包含以下字符:",
  "当前文件夹名字已存在": "当前文件夹名字已存在",
  "当前文件名已存在": "当前文件名已存在",
  "重命名成功": "重命名成功",
  "重命名失败": "重命名失败",
  "当前文件暂不支持在线预览": "当前文件暂不支持在线预览",
  "当前文件暂不支持在线预览,是否下载查看": "当前文件暂不支持在线预览,是否下载查看",
  "贴图库文件夹不能向内外移动！": "贴图库文件夹不能向内外移动！",
  "文件只能移动到产品素材库文件夹里！": "文件只能移动到产品素材库文件夹里！",
  "贴图库文件夹不能向外移动！": "贴图库文件夹不能向外移动！",
  "非贴图库文件夹不能向内移动！": "非贴图库文件夹不能向内移动！",
  "移动失败": "移动失败",
  "文件重名": "文件重名",
  "文件重复": "文件重复",
  "以下文件重名，请选择操作。选择保留两者时，正在上传的文件将被自动重命名；选择覆盖时，目标文件夹中的文件将被正在上传的文件覆盖。": "以下文件重名，请选择操作。选择保留两者时，正在上传的文件将被自动重命名；选择覆盖时，目标文件夹中的文件将被正在上传的文件覆盖。",
  "以下文件和正在上传的文件重复，请确认是否继续上传？确认继续上传，如果存在文件重名，正在上传的文件将会被自动重命名。": "以下文件和正在上传的文件重复，请确认是否继续上传？确认继续上传，如果存在文件重名，正在上传的文件将会被自动重命名。",
  "（仅管理员可见）": "（仅管理员可见）",
  "（系统）": "（系统）",
  "无法移动至产品素材库外": "无法移动至产品素材库外",
  "无法移动至产品素材库文件夹": "无法移动至产品素材库文件夹",
  "无法移动至{{name}}文件夹": "无法移动至{{name}}文件夹",
  "{{name}}库不能重命名、移动和删除，不能添加文件/文件夹": "{{name}}库不能重命名、移动和删除，不能添加文件/文件夹",
  "{{name}}不能重命名、移动和删除": "{{name}}不能重命名、移动和删除",
  "确认要删除吗？该图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。": "确认要删除吗？该图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。",
  "确认要删除吗？已选图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。": "确认要删除吗？已选图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。",
  "共{{count}}项": "共{{count}}项",
  "管理当前文件夹中的文件，不会影响关联{{name}}的展示图片": "管理当前文件夹中的文件，不会影响关联{{name}}的展示图片",
  "管理当前文件夹中的文件，不会影响关联{{name}}的获奖证书": "管理当前文件夹中的文件，不会影响关联{{name}}的获奖证书",
  "{{count}}个任务上传完成": "{{count}}个任务上传完成",
  "{{count}}个任务正在上传": "{{count}}个任务正在上传",
  // 我的空间各 tab
  "私域列表": "私域列表",
  "私域数据": "私域数据",
  "内容清单": "内容清单",
  "数据总览": "数据总览",
  "数据明细": "数据明细",
  "作品分享类型": "作品分享",
  "全部内容": "全部内容",
  "上新{{count}}个!": "上新{{count}}个!",
  "上架：": "上架：",
  "内容": "内容",
  "内容未开放": "内容未开放",
  "产品分享": "产品分享",
  "产品已被下架": "产品已被下架",
  "产品数量": "产品数量",
  "仅作品分享、产品分享统计时长，每隔15分钟刷新数据": "仅作品分享、产品分享统计时长，每隔15分钟刷新数据",
  "介绍分享": "介绍分享",
  "停留时长统计": "停留时长统计",
  "停留时长": "停留时长",
  "停留时长(累计)": "停留时长(累计)",
  "每日时长": "每日时长",
  "升序": "升序",
  "降序": "降序",
  "分享标题": "分享标题",
  "分享次数": "分享次数",
  "分享类型": "分享类型",
  "分享记录": "分享记录",
  "分享链接": "分享链接",
  "区域：": "区域：",
  "单价": "单价",
  "单价不能小于1": "单价不能小于1",
  "咨询对象": "咨询对象",
  "型号": "型号",
  "处理中": "处理中",
  "正在处理...": "正在处理...",
  "官方模板": "官方模板",
  "小程序空间分享": "小程序空间分享",
  "已回复": "已回复",
  "已处理": "已处理",
  "已忽略": "已忽略",
  "待处理": "待处理",
  "报价单": "报价单",
  "按私域": "按私域",
  "描述": "描述",
  "搜索关键字": "搜索关键字",
  "数量": "数量",
  "时长": "时长",
  "暂无数据！": "暂无数据！",
  "暂无联系方式！": "暂无联系方式！",
  "暂无规格": "暂无规格",
  "材料名称": "材料名称",
  "查看次数": "查看次数",
  "查看次数统计": "查看次数统计",
  "标题": "标题",
  "正常": "正常",
  "生成报价单": "生成报价单",
  "生成": "生成",
  "导出成功！": "导出成功！",
  "确认要删除这条记录吗？": "确认要删除这条记录吗？",
  "私域已停用": "私域已停用",
  "取消关注": "取消关注",
  "置顶成功！": "置顶成功！",
  "进入": "进入",
  "空间分享": "空间分享",
  "置顶卡片": "置顶卡片",
  "至少选择一个": "至少选择一个",
  "设计风格": "设计风格",
  "设计类型": "设计类型",
  "请填写单价": "请填写单价",
  "请填写型号": "请填写型号",
  "请填写数量": "请填写数量",
  "请填写规格": "请填写规格",
  "请完善材料的合计价格": "请完善材料的合计价格",
  "折扣不能超过1": "折扣不能超过1",
  "折扣要大于0": "折扣要大于0",
  "请选择单位": "请选择单位",
  "请选择成员！": "请选择成员！",
  "暂无可转单的成员！": "暂无可转单的成员！",
  "请选择规格": "请选择规格",
  "转单成功！": "转单成功！",
  "选择模板": "选择模板",
  "阅读次数": "阅读次数",
  "限制次数": "限制次数",
  "收件箱": "收件箱",
  "发件箱": "发件箱",
  "下载报价单": "下载报价单",
  "保存草稿": "保存草稿",
  "共{{count}}条": "共{{count}}条",
  "已收藏（{{count}}）": "已收藏（{{count}}）",
  "设置折扣：": "设置折扣：",
  "材料数：": "材料数：",
  "总价：": "总价：",
  "折扣价：": "折扣价：",
  "请联系客服": "请联系客服",
  "定制模板": "定制模板",
  "定制": "定制",
  "分": "分",
  "秒": "秒",
  "小时": "小时",
  "手机：": "手机：",
  "邮箱：": "邮箱：",
  "提交人：": "提交人：",
  "提交时间：": "提交时间：",
  "其他联系方式：": "其他联系方式：",
  "该": "该",
  "生成报价": "生成报价",
  "查看报价": "查看报价",
  "转单": "转单",
  "恢复": "恢复",
  "请选择处理的成员": "请选择处理的成员",
  "小计：": "小计：",
  // WEB+H5 新增文案（2026-09-07）
  "私域会员（{数量}）": "私域会员（{数量}）",
  "作品类型偏好Top5": "作品类型偏好Top5",
  "内容浏览：{数量}": "内容浏览：{数量}",
  "产品收藏：{数量}": "产品收藏：{数量}",
  "{数量}条/页": "{数量}条/页",
  "登录不觉账号并加入  {teamName} 会员，享受会员专属权益与服务。": "登录不觉账号并加入  {teamName} 会员，享受会员专属权益与服务。",
  "{次数}次": "{次数}次",
  "{分钟}分{秒}秒": "{分钟}分{秒}秒",
  "{秒}秒": "{秒}秒",
  "开启私域会员管理": "开启私域会员管理",
  "内容偏好": "内容偏好",
  "会员昵称": "会员昵称",
  "会员状态": "会员状态",
  "用户信息": "用户信息",
  "用户画像": "用户画像",
  "互动记录": "互动记录",
  "已离职": "已离职",
  "产品分享": "产品分享",
  "近7天": "近7天",
  "近30天": "近30天",
  "累计访问次数": "累计访问次数",
  "平均停留时长": "平均停留时长",
  "浏览作品数": "浏览作品数",
  "浏览产品数": "浏览产品数",
  "分享产品数": "分享产品数",
  "内容浏览": "内容浏览",
  "最近浏览日期": "最近浏览日期",
  "介绍页": "介绍页",
  "选品官": "选品官",
  "主动注册": "主动注册",
  "请输入标签名称": "请输入标签名称",
  "该标签已存在，请换一个名称": "该标签已存在，请换一个名称",
  "标签存在问题，请修改后再保存": "标签存在问题，请修改后再保存",
  "批量编辑时，修改任一会员信息将同步至其他已选会员": "批量编辑时，修改任一会员信息将同步至其他已选会员",
  "登录/注册不觉账号": "登录/注册不觉账号",
  "请输入手机号或邮箱": "请输入手机号或邮箱",
  "注册不觉账号并加入 {teamName} 会员，享受会员专属权益与服务": "注册不觉账号并加入 {teamName} 会员，享受会员专属权益与服务",
  "请先开启私域会员，再开启本功能。否则会导致无法获取访客个人数据。": "请先开启私域会员，再开启本功能。否则会导致无法获取访客个人数据。",
  "已选中：{{count}}": "已选中：{{count}}",
  "已同步更新 {{count}} 位会员的 {{fieldName}}": "已同步更新 {{count}} 位会员的 {{fieldName}}",
  "开启会员管理前，需先确认用户注册 / 登录时需同意的《私域会员协议》与《私域隐私协议》": "开启会员管理前，需先确认用户注册 / 登录时需同意的《私域会员协议》与《私域隐私协议》",
  "暂无会员数据": "暂无会员数据",
  "查看次数": "查看次数",
  "圈子私域": "圈子私域",
  "我已阅读并同意《私域会员协议》《私域隐私政策》": "我已阅读并同意《私域会员协议》《私域隐私政策》",
  "请阅读并勾选同意协议和隐私政策": "请阅读并勾选同意协议和隐私政策",
  "浏览收藏": "浏览收藏",
  "内容名称": "内容名称",
  "收藏时间": "收藏时间",
  "收藏产品数": "收藏产品数",
  "产品收藏": "产品收藏",
  "产品分类偏好Top5": "产品分类偏好Top5",
  "登录成功": "登录成功",
  // 创建私域引导页文案
  "私域是指个人或团队通过不觉建立的数据信息库，可广泛应用于品牌展示、销售转化及精准营销等场景。": "私域是指个人或团队通过不觉建立的数据信息库，可广泛应用于品牌展示、销售转化及精准营销等场景。",
  "私域logo": "私域logo",
  "创建私域空间，可以自动保存您添加的产品数据": "创建私域空间，可以自动保存您添加的产品数据",
  "名称不能为纯数字": "名称不能为纯数字",
  "专属产品库": "专属产品库",
  "创建私域，即可将产品入库至个人或团队产品库，集中管理更高效": "创建私域，即可将产品入库至个人或团队产品库，集中管理更高效",
  "创意板工具": "创意板工具",
  "直接调用产品及贴图，一键生成产品清单或白皮书，轻松展示方案": "直接调用产品及贴图，一键生成产品清单或白皮书，轻松展示方案",
  "插件工具库": "插件工具库",
  "联动 Revit、3DMax、Rhino、SketchUp 等设计软件，随时调用产品模型与贴图，提升设计效率": "联动 Revit、3DMax、Rhino、SketchUp 等设计软件，随时调用产品模型与贴图，提升设计效率",
  "支持产品一键上架至公域（紫菜海洋），拓展产品曝光": "支持产品一键上架至公域（紫菜海洋），拓展产品曝光",
  "名称不能超过40个字": "名称不能超过40个字",
  "私域名称包含敏感词汇": "私域名称包含敏感词汇",
  "请输入 私域名称": "请输入 私域名称",
  "我已阅读并同意协议": "我已阅读并同意协议",
  "《不觉私域服务协议》": "《不觉私域服务协议》",
  "查看第{{index}}项": "查看第{{index}}项",
  // 私域语言开通提示
  "配置说明": "配置说明",
  "语言": "语言",
  "前往设置": "前往设置",
  "暂不设置": "暂不设置",
  "1.介绍在不同语言下，都是同一套配置": "1.介绍在不同语言下，都是同一套配置",
  "2.作品图片、视频、链接上传一次，文本需要按照语言包配置多套": "2.作品图片、视频、链接上传一次，文本需要按照语言包配置多套",
  "3.产品图片、视频、介绍、附件上传一次，文本需要按照语言包配置多套": "3.产品图片、视频、介绍、附件上传一次，文本需要按照语言包配置多套",
  "4、合作的邀请链接只需要分享一次，分组名称需要按照语言包配置": "4、合作的邀请链接只需要分享一次，分组名称需要按照语言包配置",
  "{{teamName}}已成功开通{{langNames}}语言包": "{{teamName}}已成功开通{{langNames}}语言包",
  "请前往设置基础信息": "请前往设置基础信息",
  // —— 团队首页封面效果配置弹窗（2026-09-18）——
  "封面效果": "封面效果",
  "封面预览": "封面预览",
  "封面模糊背景": "封面模糊背景",
  "图片裁剪：": "图片裁剪：",
  "长边撑满": "长边撑满",
  "短边撑满": "短边撑满",
  "背景效果：": "背景效果：",
  "白色背景": "白色背景",
  "灰色背景": "灰色背景",
  "模糊背景": "模糊背景",
  "封面配置查询失败": "封面配置查询失败",
  // —— 产品推荐管理弹窗（推荐设置 / 新品设置）2026-10-14 ——
  "产品推荐管理": "产品推荐管理",
  "推荐设置": "推荐设置",
  "新品设置": "新品设置",
  "新品": "新品",
  "可选产品": "可选产品",
  "全部删除": "全部删除",
  "已添加": "已添加",
  "最多可设置{{maxCount}}个": "最多可设置{{maxCount}}个",
  '在"{分类名称}"中搜索': '在"{分类名称}"中搜索',
  "推荐排序": "推荐排序",
  "浏览量排序": "浏览量排序",
  "上新": "上新",
  "上市时间：": "上市时间：",
  "上市时间": "上市时间",
  "已下架": "已下架",
  "其他成员正在编辑，请稍候再试。": "其他成员正在编辑，请稍候再试。",
  "仅已上架产品可设为推荐，拖动右侧产品可调整展示顺序。": "仅已上架产品可设为推荐，拖动右侧产品可调整展示顺序。",
  "仅已上架产品可设为新品，拖动右侧产品可调整展示顺序。": "仅已上架产品可设为新品，拖动右侧产品可调整展示顺序。",
  "产品附件": "产品附件",

  "个人名片：": "个人名片：",
  "封面图不可取消勾选": "封面图不可取消勾选",
  "请输入有效手机号码": "请输入有效手机号码",
  "请输入正确的手机号或邮箱账号": "请输入正确的手机号或邮箱账号",
  "验证码不能为空": "验证码不能为空",
  "密码不能为空": "密码不能为空",
  "验证码错误": "验证码错误",
  "密码错误": "密码错误",
  "请确认您的密码": "请确认您的密码",
  "您输入的两个密码不匹配": "您输入的两个密码不匹配",
  "最低参考价不能大于或等于最高参考价": "最低参考价不能大于或等于最高参考价",
  "标签不能重名": "标签不能重名",
  "最多可选5个标签": "最多可选5个标签",
  "确定要删除吗?已关联产品中的对应标签会一并删除": "确定要删除吗？已关联产品中的对应标签会一并删除",
  "私域类型不能为空": "私域类型不能为空",
  "请输入优惠码享受优惠，优惠金额=原价*（1-折扣）": "请输入优惠码享受优惠，优惠金额=原价*（1-折扣）",
  "私域Saas工具": "私域Saas工具",
  "件被驳回的产品，确定要重新提交上架吗？": "件被驳回的产品，确定要重新提交上架吗？",
  "确定要执行批量上架吗？已选": "确定要执行批量上架吗？已选",
  "件产品中包含": "件产品中包含",

  "select_product_origin": "请选择产品产地",
  "province_city": "省市选择",
  "select_province_city": "请选择省市",
  "supplier_name_is_required": "供应商名称不能为空",
  "enter_supplier_name": "请输入供应商名称",
  "supplier_avatar_is_required": "供应商头像不能为空",
  "select_date": "请选择日期",
  "terms_updated": "协议更新",
  "in_my_space_you_can_view_your_share_history_follows_and_private_space": "在我的空间，可以查看分享记录、我的关注、我的私域啦~",
  "the_platform_has_given_you_a_free_three_month_membership": "平台已免费赠送您三个月会员",
  "free_gift": "免费赠送",
  "three_month_membership": "三个月会员",
  "value_items": "{{value}}条",
  "new_inquiries_need_to_be_processed": "新的询价需要处理",
  "you_can_upload_up_to_value_attachments": "附件最多上传{{value}}个",
  "failed_to_upload_value": "{{value}} 上传失败",
  "upload_attachment": "上传附件",
  "value_is_not_a_pdf_file": "{{value}} 不是pdf文件",
  "value_is_not_an_image": "{{value}} 不是图片",
  "value_must_not_exceed_4_mb": "{{value}} 不能超过4M",
  "brand_logo": "*品牌LOGO",
  "brand_logoV2": "品牌LOGO",
  "china": "中国",
  "logo": "LOGO",
  "name_is_required": "名称不能为空",
  "brand_already_exists": "品牌已存在",
  "enter_brand_name": "请填写品牌名称",
  "brand_name": "*品牌名称",
  "upload_a_logo": "请填写上传logo",
  "enter_country": "请填写国家",
  "select_brand_category": "请选择品牌分类",
  "edit_brand_type": "编辑品牌类型",
  "add_brand_type": "添加品牌类型",
  "type_name": "类型名称",
  "enter_type_name": "请输入类型名称",
  "chinaV2": "中国",
  "brand_nameV2": "品牌名称*",
  "logoV2": "LOGO",
  "type": "类型*",
  "select_brand_type": "请选择品牌类型",
  "country": "国家*",
  "others": "其他",
  "equipment": "设备",
  "name": "name",
  "free_version": "免费版",
  "free_versionV2": "免费版",
  "buy": "购买",
  "upgrade": "升级",
  "renew": "续费",
  "used_capacity": "已使用容量：",
  "original_plan_expiration_date": "原套餐到期时间：",
  "quantity": "数量",
  "plan_duration_is_up_to_value_3_years_at_a_time": "套餐时长一次最多{{value}}3年",
  "select_at_least_1_year": "至少选择1年",
  "original_price_new_plan_original_unit_price_original_plan_total_term_bonus_duration_original_plan_total_days_remaining_days": "原价 = 新套餐原单价 * ( 原套餐总时长 - 赠送时长 ) / 原套餐总时长天数 * 剩余时长天数",
  "original_price_list_price_subscription_term": "原价=划线价*购买时长",
  "the_value_promo_code_has_been_redeemed_for_you_value": "已为您兑换{{value}}折优惠码：{{value}}",
  "pay_difference": "补差价",
  "select_payment_method": "请选择支付方式",
  "dear_user_your_storage_is_running_out_to_prevent_important_files_from_being_deleted_automatically_upgrade_your_plan_or_manually_delete_unnecessary_files_as_soon_as_possible": "尊敬的用户，您的储存容量不足，为避免重要文件被系统自动清理，请及时升级套餐或手动清理不需要的文件",
  "failed_to_upload_value_please_try_again": "{{value}} 上传失败，请重新上传",
  "upload_hd_assets": "上传高清素材",
  "name_number": "名称/编号",
  "asset_name_number": "素材名称/编号",
  "image_is_required": "图片必传",
  "pdf_image": "pdf图片",
  "this_is_the_content_on_the_right": "这是右边的内容",
  "cad": "CAD",
  "product_texture": "产品贴图",
  "hd_assets": "高清素材",
  "pdf_imageV2": "pdf图片",
  "residential": "家装",
  "commercial": "公装",
  "attachment_upload_is_not_complete": "附件未上传完成",
  "publish": "发布",
  "are_you_sure_you_want_to_clear_the_product_introduction": "确认清空产品介绍吗？",
  "enter_product_name": "请填写产品名称",
  "enter_product_nameV2": "*请填写产品名称",
  "enter_model": "请填写型号",
  "enter_series_and_model": "*请填写系列及型号",
  "enter_series_and_modelV2": "请填写系列及型号",
  "enter_specifications_and_size": "请填写规格尺寸",
  "enter_supplier": "请输入供应商",
  "select_product_attributes": "请选择产品属性",
  "piece": "件",
  "hd_assets_texture_maps": "高清素材（效果贴图）",
  "s_invitation_you_can_enter_product_information_in_the_list_below_and_submit_it_after_the_private_space_administrator_approves_it_the_product_will_be_automatically_added_to": "的邀请，您可以在下方列表中录入产品信息并提交，在通过私域管理员审核后，产品将自动加入",
  "private_space_saas_tools": "私域SaaS工具",
  "keep_at_least_one_tab": "请至少保留一个tab",
  "hd_assetsV2": "高清素材",
  "pdf_imageV3": "pdf图片",
  "residentialV2": "家装",
  "commercialV2": "公装",
  "product_textureV2": "产品贴图",
  "chinese_n": "中文N",
  "english": "英语",
  "japanese": "日语",
  "test": "测试",
  "chinese_nV2": "中文N",
  "validity_period_updated": "调整有效期成功",
  "adjust_validity_period": "调整有效期",
  "card_expiry": "卡片时效",
  "select_dateV2": "请选择日期",
  "are_you_sure_you_want_to_value_this_request_card": "确定{{value}}此需求卡吗？",
  "visible_to_everyone": "所有人可见",
  "block_peers": "屏蔽同行",
  "complete_the_request_and_close_the_card": "完成需求并关闭卡片",
  "are_you_sure_you_want_to_close_this_request_card": "确定关闭此需求卡吗？",
  "withdraw_card_to_drafts": "撤回卡片到草稿",
  "are_you_sure_you_want_to_withdraw_this_request_card": "确定撤回此需求卡吗？",
  "withdrawn": "撤回成功",
  "withdrawal_failed": "撤回失败",
  "adjust_card_expiry": "调整卡片时效",
  "edit_contact_information": "修改联系方式",
  "are_you_sure_you_want_to_delete_this_request_card": "确定删除此需求卡吗？",
  "delete_card": "删除卡片",
  "show_less": "收缩更多",
  "show_more": "展开更多",
  "request_details": "需求描述",
  "unlimited": "不限",
  "value_yuan_unit": "{{value}}元/单价",
  "curated": "严选",
  "about_value_value": "约{{value}}{{value}}",
  "reference_image": "意向图",
  "register_as_a_supplier_to_add_favorites_or_participate": "请入驻成供应商才可收藏或参与",
  "switch_to_the_supplier_role": "请切换为供应商角色",
  "participate": "我要参与",
  "are_you_sure_you_want_to_close_this_page": "你确定关闭此页面吗？",
  "anonymous": "匿名",
  "card_expiryV2": "卡片时效",
  "to": "止",
  "curatedV2": "严选",
  "series": "系列",
  "show_lessV2": "收缩更多",
  "show_moreV2": "展开更多",
  "request_detailsV2": "需求描述",
  "unlimitedV2": "不限",
  "value_yuan_unitV2": "{{value}}元/单价",
  "about_value_valueV2": "约{{value}}{{value}}",
  "you_cannot_participate_in_your_own_cards": "不能参与自己创建的卡",
  "delete_all_participation_in_this_item": "是否删除本项所有参与？",
  "your_submission_is_not_complete_exit_anyway": "还未投递成功，是否要退出？",
  "you_cannot_add_your_own_cards_to_favorites": "不能收藏自己创建的卡",
  "removed_from_favorites": "取消收藏成功",
  "added_to_favorites": "添加收藏成功",
  "anonymousV2": "匿名",
  "card_expiryV3": "卡片时效",
  "toV2": "止",
  "rejection_reason": "驳回原因",
  "rejection_reason_value": "驳回原因：{{value}}",
  "public": "公开",
  "block_peersV2": "屏蔽同行",
  "are_you_sure_you_want_to_delete_this_request_cardV2": "确认删除当前需求卡吗？",
  "register_as_a_supplier_to_add_favorites_or_participateV2": "请入驻成供应商才可收藏或参与",
  "switch_to_the_supplier_roleV2": "请切换为供应商角色",
  "unlimitedV3": "不限",
  "anonymousV3": "匿名",
  "expired": "已过期",
  "downloading": "下载中…",
  "file_not_found": "未找到对应文件",
  "this_file_is_too_large_to_preview": "文件较大，不支持预览",
  "import_pdf": "导入pdf",
  "complete_import": "完成导入",
  "invalid_page_number_format": "输入的页码不规范",
  "import_pdfV2": "导入PDF",
  "specific_pages": "指定页",
  "e_g_1_2_5_7_10": "如：1、2-5、7-10",
  "the_higher_the_resolution_the_longer_the_import_time": "清晰度越高导入时间越长",
  "complete_importV2": "完成导入",
  "file_size_exceeds_the_limit_upload_again": "文件大小超出限制，请重新上传",
  "upload_attachmentV2": "上传附件",
  "supported_formats_pdf_ppt_doc_under_50mb": "支持格式pdf、ppt、doc(小于50M)",
  "duplicate_parameter_name": "参数不能同名",
  "enter_feature_name": "请填写特性名称",
  "enter_feature_nameV2": "请填写特性名称",
  "date_modified": "上次日期",
  "edit_folder": "编辑文件夹",
  "add_folder": "添加文件夹",
  "cannot_exceed_30_characters": "不能超过30个字符",
  "file_folder_name": "文件/文件夹名称",
  "new_file": "新建文件",
  "post_request": "发需求",
  "select_none": "全不选",
  "private": "私密",
  "about_us": "关于我们",
  "features": "功能介绍",
  "partnerships": "业务合作",
  "contact_us": "联系我们",
  "finished_product": "成品",
  "all_statuses": "全部状态",
  "draft": "草稿",
  "not_approved": "未过审",
  "privateV2": "私有",
  "curatedV3": "严选",
  "this_product_has_already_been_added": "该产品已添加",
  "origin": "产地",
  "crop_the_image": "请裁剪图片",
  "download_failed": "下载失败",
  "crop_me": "Crop me",
  "failed_to_load_the_image_please_try_again_later": "图片加载失败，请稍后再试",
  "crop_the_imageV2": "请裁剪图片",
  "download_failedV2": "下载失败",
  "crop": "确定裁剪",
  "unlock_default_ratio": "取消默认比例",
  "lock_default_ratio": "锁定默认比例",
  "rotate_right": "向右旋转",
  "rotate_left": "向左旋转",
  "zoom_in": "放大",
  "zoom_out": "缩小",
  "crop_meV2": "Crop me",
  "click_to_upload": "点击上传",
  "image_size_cannot_exceed_value_mb": "图片大小不能超过{{value}}M",
  "enter_description": "请输入说明",
  "click_to_uploadV2": "点击上传",
  "value_is_not_an_imageV2": "{{value}} 不是图片",
  "image_size_limit_4mb": "图片大小限制4M",
  "no_more_than_4mb": "不超过4M",
  "added_to_favoritesV2": "收藏成功",
  "failed_to_get_verification_code_try_again": "获取验证码失败，请重新获取",
  "complete_the_puzzle_first": "请先完成拼图",
  "enter_your_phone_number": "Please input your phone",
  "enter_verification_code": "Please input your code",
  "failed_to_get_verification_code_try_againV2": "获取验证码失败，请重新获取",
  "complete_the_puzzle_firstV2": "请先完成拼图",
  "failed_to_get_verification_code_try_againV3": "获取验证码失败，请重新获取",
  "confirm_that_you_have_read_the_agreement": "请确认阅读协议",
  "user_agreement": "《用户协议》",
  "privacy_policy": "《隐私政策》",
  "terms_of_service": "《服务条款》",
  "children_s_personal_information_protection_rules_and_instructions_for_guardians": "《儿童个人信息保护规则及监护人须知》",
  "wechat_login": "微信登录",
  "panzi_login": "盘子登录",
  "wechat_loginV2": "微信登录",
  "panzi_loginV2": "盘子登录",
  "alipay_login": "支付宝登录",
  "other_login_methods": "其他登录方式",
  "hold_and_drag_the_slider_to_complete_the_puzzle": "请按住滑块拖动完成拼图",
  "value_upload_failed": "{{value}}上传失败",
  "insufficient_storage_capacity": "存储容量不足",
  "video_files_cannot_exceed_200mb": "视频文件不能超过200M",
  "video_upload_failed_due_to_insufficient_storage": "存储容量不足，视频上传失败",
  "upload_video": "上传视频",
  "to_ensure_smooth_playback_we_recommend_videos_of_20_30mb_up_to_a_maximum_of_200mb": "为了保证视频播放流畅，建议上传视频大小20~30M，最大不超过200M",
  "this_will_take_about_2_minutes_please_wait": "预计需要2分钟，请稍等片刻",
  "heiti": "黑体",
  "kaiti": "楷体",
  "fangsong": "仿宋",
  "songti": "宋体",
  "gongfan_font": "龚帆字体",
  "pangmenzhengdao_bold_calligraphy": "庞门正道粗书体",
  "yanshi_chunfeng_kai": "演示春风楷",
  "youshe_haoshenti": "优设好身体",
  "sanji_xingkai_simplified_chinese": "三极行楷简体",
  "alignment": "对齐",
  "letter_spacing": "字间距",
  "biaukai": "标楷体",
  "stfangsong": "华文仿宋",
  "stkaiti": "华文楷体",
  "microsoft_yahei": "微软雅黑",
  "alimama_dongfangdakai": "阿里妈妈东方大楷",
  "alimama_fangyuanti": "阿里妈妈方圆体",
  "dingtalk_jinbuti": "钉钉进步体",
  "youshe_biaoti_hei": "优设标题黑",
  "mobile": "手机",
  "web": "网页",
  "enter_title": "请输入标题…",
  "upload_videoV2": "上传视频",
  "compression_failed": "压缩失败",
  "drag_within_the_image_area": "请保持在图片区域内拖拽",
  "link_click_areas_cannot_overlap": "链接点击范围不允许重叠",
  "complete_the_link": "请完成链接",
  "link_must_start_with_http_or_https": "链接必须以 http:// 或 https:// 开头",
  "layout_effect": "版式效果",
  "exit_tiling_mode": "退出平铺模式",
  "amap": "高德地图",
  "apple_maps": "苹果地图",
  "duplicate_outline_name": "大纲名称重复",
  "confirm_deletion": "确定删除吗？",
  "failed_to_save_the_long_image": "手机长图保存失败",
  "value_upload_failedV2": "{{value}}上传失败",
  "p_style_text_align_center_line_height_2_title_p": "<p style=\"text-align: center; line-height: 2;\">标题</p>",
  "enter_titleV2": "请输入标题…",
  "alignmentV2": "对齐",
  "enter_content": "请输入内容…",
  "spacing": "间距",
  "letter_spacingV2": "字间距",
  "no_animation": "无动效",
  "text_animation": "文字动效",
  "text_shadow": "文字阴影",
  "text_color": "文字颜色",
  "value_upload_failedV3": "{{value}}上传失败",
  "failed_to_generate_the_qr_code_enter_a_valid_link": "生产二维码失败，请输入正确的链接",
  "could_not_detect_an_address": "未解析出地址",
  "qr_code": "二维码",
  "enter_the_address_or_upload_a_qr_code": "请输入地址或上传二维码",
  "enter_web_address": "请输入网页地址",
  "upload_logo": "请上传logo",
  "logoV3": "logo",
  "value_upload_failedV4": "{{value}}上传失败",
  "click_to_view_map": "点击查看地图",
  "enter_contentV2": "请输入内容…",
  "enter_titleV3": "请输入标题…",
  "value_upload_failedV5": "{{value}}上传失败",
  "upload": "上传",
  "enter_titleV4": "请输入标题…",
  "the_desktop_version_has_not_been_uploaded_the_mobile_version_will_be_shown": "电脑端文件未上传，当前将展示手机端内容",
  "value_upload_failedV6": "{{value}}上传失败",
  "click_or_drag_a_single_image": "点击/拖入单个图片",
  "the_mobile_version_has_not_been_uploaded_the_desktop_version_will_be_shown": "手机端文件未上传，当前将展示电脑端内容",
  "value_upload_failedV7": "{{value}}上传失败",
  "error": "错误",
  "enter_contentV3": "请输入内容…",
  "value_upload_failedV8": "{{value}}上传失败",
  "enter_titleV5": "请输入标题…",
  "enter_contentV4": "请输入内容…",
  "enter_contentV5": "请输入内容…",
  "you_can_select_up_to_value_items": "最多可勾选{{value}}个",
  "contact_supplier": "联系供应商",
  "reference_price": "参考价格",
  "material_origin": "材料产地",
  "custom": "定制",
  "unlike": "取消喜欢",
  "like": "加入喜欢",
  "are_you_sure_you_want_to_value": "你确定要{{value}}",
  "request_sample": "申请小样",
  "add_to_comparison": "加对比",
  "different_categories_cannot_be_compared": "不同分类不能加入对比",
  "add_to_my_materials": "加入我的材料",
  "free_1gb_traffic": "赠送1GB流量啦",
  "failed_to_upload_valueV2": "{{value}} 上传失败",
  "you_can_upload_up_to_5_files": "最多上传5个文件",
  "value_is_not_a_pdf_fileV2": "{{value}} 不是pdf文件",
  "file_size_limit_100_mb": "文件大小限制100M",
  "drag_files_here_or_click_to_add_pdf_format_supported": "将文件拖拽至此区域或点击添加支持PDF格式",
  "pdf_imageV4": "pdf图片",
  "you_can_upload_up_to_value_items": "最多上传{{value}}个",
  "pdf_imageV5": "pdf图片",
  "you_can_import_up_to_value_templates_at_a_time": "一次最多只能导入{{value}}张模版",
  "you_can_upload_up_to_value_pdfs": "最多可上传{{value}}个pdf",
  "successfully_followed_the_value_private_space": "成功关注{{value}}私域",
  "click_to_create_a_requirement": "单击创建需求",
  "replace_image": "替换图片",
  "edit_image": "编辑图片",
  "yuan_piece": "元/件",
  "the_background_image_has_changed_anchor_points_outside_the_image_must_be_moved_back_into_the_image_area_manually": "背景图片变化，超出图片的锚点需要手动移入图片范围",
  "keep_anchor_points_when_replacing_the_image": "替换图片锚点是否保留？",
  "value_is_not_an_imageV3": "{{value}} 不是图片",
  "the_background_image_has_changed_anchor_points_outside_the_image_must_be_moved_back_into_the_image_area_manuallyV2": "背景图片变化，超出图片的锚点需要手动移入图片范围",
  "deactivated": "停用",
  "services_information": "服务/资讯",
  "fully_open": "全开放",
  "anyone_can_join": "自由加入",
  "semi_open": "半开放",
  "closed": "不开放",
  "invitation_only": "邀请加入",
  "access_settings": "开放性设置",
  "member_joining": "成员加入",
  "visitor_browsing": "访客浏览",
  "settings": "設定",
  "submit_results": "提交结果",
  "closedV2": "不开放",
  "semi_openV2": "半开放",
  "fully_openV2": "全开放",
  "submit_resultsV2": "提交结果",
  "pay": "付费",
  "contact_support": "联系客服",
  "following": "我的关注",
  "my_shares": "我的分享",
  "mine": "我的",
  "my_inquiries": "我的询价",
  "language": "语言",
  "go_to_settings": "前往设置",
  "set_up_later": "暂不设置",
  "1_the_introduction_uses_the_same_content_across_all_languages": "1.介绍在不同语言下，都是同一套配置",
  "2_portfolio_images_videos_and_links_are_uploaded_once_text_must_be_configured_separately_for_each_language_pack": "2.作品图片、视频、链接上传一次，文本需要按照语言包配置多套",
  "3_product_images_videos_descriptions_and_attachments_are_uploaded_once_text_must_be_configured_separately_for_each_language_pack": "3.产品图片、视频、介绍、附件上传一次，文本需要按照语言包配置多套",
  "4_the_collaboration_invitation_link_only_needs_to_be_shared_once_group_names_must_be_configured_for_each_language_pack": "4、合作的邀请链接只需要分享一次，分组名称需要按照语言包配置",
  "setup_guide": "配置说明",
  "private_space_name": "私域名称*",
  "enter_contact_address": "请输入联系地址",
  "failed_to_get_the_team_language_list_please_try_again": "获取团队语言列表失败，请重试",
  "failed_to_get_private_space_information": "获取私域信息失败",
  "set_space_information": "设置私域信息",
  "the_value_plugin_lets_you_use_textures_and_models_from_your_private_space_product_library_directly": "{{value}}插件，直接调用私域产品库的贴图和模型",
  "stay_tuned": "敬请期待",
  "product_publishing_review": "产品上架审核",
  "logoV4": "logo",
  "uploading_image": "图片上传中",
  "scan_to_download_the_app": "扫一扫下载APP",
  "page_settings": "页面设置",
  "private_space_data_is_being_translated_please_do_not_add_new_data": "正在翻译私域数据，请不要新增数据",
  "this_private_space_has_not_passed_business_verification_so_visitors_cannot_access_it": "当前私域的主体认证未通过，访客无法访问",
  "cadV2": "CAD",
  "total_value_files": "共{{value}}个文件",
  "total_value_textures": "共{{value}}张贴图",
  "total_value_models": "共{{value}}个模型",
  "hd_assetsV3": "高清素材",
  "total_value_items": "共{{value}}条数据",
  "all_attachments": "所有附件",
  "customizable": "可定制",
  "parameter_error": "参数错误",
  "published_successfully": "发布成功",
  "empty": "空",
  "emptyV2": "空",
  "select_service_area": "请选择服务区域",
  "latest": "最新",
  "publish_date": "发布时间",
  "views": "浏览量",
  "saves": "收集数",
  "date_added": "添加时间",
  "high_tech_only": "只看高新特",
  "home_page_display": "首页展示",
  "sample_availability": "有无样品",
  "keywords": "关键词",
  "search": "查询",
  "reference_priceV2": "参考价格",
  "originV2": "产地",
  "texture_library": "贴图库",
  "search_textures": "搜索贴图",
  "already_linked": "已关联不可重复关联",
  "linked": "已关联",
  "select_at_least_one_related_image": "请至少勾选一张关联图",
  "you_can_link_up_to_value_images": "最多只能关联 {{value}} 张图片",
  "external_platform": "外部平台",
  "global": "全球",
  "ignored": "忽略成功",
  "value_records_imported": "成功导入{{value}}条",
  "are_you_sure_you_want_to_ignore_it": "是否确认忽略？",
  "privateV3": "私有",
  "originV3": "产地",
  "crop_meV3": "Crop me",
  "image_size_cannot_exceed_30mb": "图片大小不能超过30MB",
  "image_dimensions_must_be_between_100_100_and_4096_4096": "图片尺寸不能超过4096*4096，且不能小于100*100",
  "network_error_please_try_again_later": "网络错误，请稍后再试",
  "paste_image": "粘贴图片",
  "supported_formats_jpg_jpeg_png_webp_gif": "支持jpg、jpeg、png、webp、gif 图片格式",
  "paste_images_with_ctrl_c_ctrl_v": "支持crtl C+V粘贴图片",
  "image_size_up_to_30mb": "图片大小不超过30M",
  "select_image": "选择图片",
  "drag_to_select_the_area_you_want_to_search_or_click_next_to_skip": "可以在图片中框选出要查找的内容，也可以点击下一步跳过",
  "style_genre": "风格/流派",
  "artwork_type": "艺术品类型",
  "artist_nationality": "作者国籍",
  "art_origins": "名画溯源",
  "popular": "热门",
  "international": "国际",
  "beijing": "北京",
  "shanghai": "上海",
  "guangzhou": "广州",
  "shenzhen": "深圳",
  "hangzhou": "杭州",
  "chengdu": "成都",
  "chongqing": "重庆",
  "wuhan": "武汉",
  "nanjing": "南京",
  "tianjin": "天津",
  "xi_an": "西安",
  "suzhou": "苏州",
  "changsha": "长沙",
  "qingdao": "青岛",
  "shenyang": "沈阳",
  "ningbo": "宁波",
  "wuxi": "无锡",
  "dongguan": "东莞",
  "united_states": "美国",
  "russia": "俄罗斯",
  "united_kingdom": "英国",
  "france": "法国",
  "germany": "德国",
  "italy": "意大利",
  "canada": "加拿大",
  "japan": "日本",
  "south_korea": "韩国",
  "nationwide": "全国",
  "globalV2": "全球",
  "reposition": "重新定位",
  "discover": "发现",
  "all_categories": "所有分类",
  "nationwideV2": "全国",
  "zhejiang": "浙江",
  "hangzhouV2": "杭州",
  "enter_company_name": "请填写企业名称",
  "you_can_enter_up_to_30_characters": "最多可输入30个字符",
  "enter_detailed_address": "请填写详细地址",
  "you_can_enter_up_to_50_characters": "最多可输入50个字符",
  "legal_representative": "法定代表人",
  "enter_legal_representative": "请填写法定代表人",
  "you_can_enter_up_to_10_characters": "最多可输入10个字符",
  "same_as_legal_representative": "是否与法人同一个人",
  "different_person": "不是同一个人",
  "same_person": "是同一个人",
  "id_document_photos": "证件照片",
  "upload_the_portrait_side_of_your_id": "请上传证件人像照片",
  "upload_the_emblem_side_of_your_id": "请上传证件国徽照片",
  "name_on_id": "证件姓名",
  "enter_name_on_id": "请填写证件姓名",
  "id_number": "身份证号",
  "enter_id_number": "请填写身份证号",
  "enter_a_valid_id_number": "请填写正确身份证号码",
  "id_validity_period": "证件期限",
  "valid_for_a_fixed_period": "固定期限有效",
  "no_expiry": "长期有效",
  "select_expiry_date": "请选择证件有效期",
  "power_of_attorney": "委托书",
  "upload_power_of_attorney": "请上传委托书",
  "url_email": "网址（电子信箱）",
  "enter_url_email": "请填写网址（电子信箱）",
  "enter_phone_number": "请填写电话",
  "telex": "电传",
  "enter_telex": "请填写电传",
  "zip_code": "邮编",
  "enter_zip_code": "请填写邮编",
  "enterprise_type": "企业性质",
  "select_enterprise_type": "请选择企业性质",
  "trading_company": "贸易型",
  "manufacturer": "生产型",
  "state_owned_enterprise": "国有企业",
  "wholly_state_owned_company": "国有独资公司",
  "other_limited_liability_company": "其他有限责任公司",
  "joint_stock_limited_company": "股份有限公司",
  "collective_enterprise": "集体企业",
  "private_enterprise": "私营企业",
  "foreign_hong_kong_macao_and_taiwan_invested_enterprise": "外商及港澳台资企业",
  "main_business_industry": "主营业务所属行业",
  "select_your_main_business_industry": "请选择主营业务所属行业",
  "agriculture_forestry_animal_husbandry_and_fishery": "农林牧渔业",
  "metallurgical_industry": "冶金工业",
  "machinery_industry": "机械工业",
  "chemical_industry": "化学工业",
  "light_industry": "轻工业",
  "electronics_and_telecommunications": "电子通讯业",
  "oil_petrochemical": "石油石化工业",
  "building_materials": "建材工业",
  "pharmaceutical_industry": "医药工业",
  "textile_industry": "纺织工业",
  "electricity_and_gas_industry": "电力燃气工业",
  "other_industries": "其他工业",
  "civil_engineering_construction_industry": "土木工程建筑业",
  "construction_installation": "建筑安装业",
  "interior_decoration": "装修装饰业",
  "foreign_trade_industry": "对外贸易业",
  "wholesale": "批发业",
  "retail_industry": "零售业",
  "transportation_and_warehousing_industry": "交通运输仓储业",
  "postal_industry": "邮政业",
  "accommodation_and_catering_industry": "住宿和餐饮业",
  "real_estate_industry": "房地产业",
  "information_technology_industry": "信息技术业",
  "information_and_consulting_services_industry": "信息、咨询服务业",
  "investment": "投资业",
  "other_service_industries": "其他服务业",
  "research_institutes": "科研院所",
  "business_site_area_m2": "经营场地面积（M2",
  "enter_business_site_area": "请填写经营场地面积",
  "enter_a_positive_integer": "请输入正整数",
  "registered_capital_10_000_yuan": "注册资金（万元",
  "enter_registered_capital_10_000_yuan": "请填写注册资金（万元",
  "enter_an_amount_with_up_to_two_decimal_places": "请输入保留两位小数的金额",
  "number_of_employees": "职工人数",
  "enter_number_of_employees": "请填写职工人数",
  "technical_staff_count": "专业技术人员数",
  "enter_technical_staff_count": "请填写专业技术人员数",
  "product_standards": "产品标准",
  "standard_products": "标准产品",
  "non_standard_products": "非标产品",
  "main_product_name": "主营产品名称",
  "enter_main_product_name": "请填写主营产品名称",
  "applicable_quality_standard": "执行质量标准",
  "enter_applicable_quality_standard": "请填写执行质量标准",
  "review": "审核",
  "rejected": "审核驳回",
  "review_comments": "审核批注",
  "enter_rejection_reason": "请填写驳回申请理由",
  "enter_rejection_reason_required": "请填写驳回申请理由（必填项）",
  "supplier_name": "*供应商名称",
  "supplier_is_already_in_use": "供应商已被使用",
  "enter_supplier_nameV2": "请填写供应商名称",
  "enter_supplier_nameV3": "*请填写供应商名称",
  "enter_business_contact_name": "请填写业务联系人名称",
  "enter_business_contact_nameV2": "*请填写业务联系人名称",
  "business_contact_phone_number": "*业务联系人电话",
  "enter_business_contact_phone_number": "请填写业务联系人电话",
  "enter_business_contact_phone_numberV2": "*请填写业务联系人电话",
  "enter_contact_addressV2": "请填写联系地址",
  "enter_business_wechat_id": "请填写业务联系微信",
  "other_social_media_accounts": "其他自媒体账号",
  "upload_supplier_logo": "请上传供应商LOGO",
  "service_area": "*服务区域",
  "select_service_areaV2": "请选择服务区域",
  "select_service_areaV3": "*请选择服务区域",
  "select_supplier_type": "请选择供应商类型",
  "upload_business_license": "上传营业执照",
  "upload_business_licenseV2": "*上传营业执照",
  "upload_company_profile": "上传企业简介",
  "upload_award_certificates": "上传荣誉证书",
  "boosts_credit_score": "（提升信用值）",
  "brand_authorization_letter": "品牌授权书",
  "trademark_registration_certificate": "商标注册证",
  "enter_company_nameV2": "请填写企业名称",
  "enter_company_nameV3": "*请填写企业名称",
  "company_introduction": "企业介绍",
  "enter_company_introduction": "请填写企业介绍",
  "legal_representativeV2": "*法定代表人",
  "enter_legal_representativeV2": "请填写法定代表人",
  "enter_legal_representativeV3": "*请填写法定代表人",
  "id_photo": "*证件照片",
  "upload_photo": "请上传照片",
  "upload_photo_side_of_id": "*上传人像面",
  "upload_emblem_side_of_id": "*上传国徽面",
  "select_service_areaV4": "请选择服务区域",
  "add_planet": "星球添加",
  "import_new_brands": "新品牌导入",
  "ignoredV2": "忽略成功",
  "value_records_importedV2": "成功导入{{value}}条",
  "you_are_just_one_verification_step_away_from_becoming_a_platform_supplier": "您距离成为平台供应商，还差一步认证~",
  "attribute_name": "特性名",
  "enter_specification_name": "请输入规格名",
  "enter_attribute_name": "请输入特性名",
  "this_specification_already_exists": "该规格已存在",
  "this_attribute_already_exists": "该特性已存在",
  "enter_specifications": "请输入规格",
  "attribute_value": "特性值",
  "enter_attribute_value": "请输入特性值",
  "enter_attribute": "请输入特性",
  "add_attribute": "添加特性",
  "within_two_weeks": "两周内",
  "within_one_year": "一年内",
  "more_than_one_year": "一年以上",
  "curatedV4": "严选",
  "seriesV2": "系列",
  "specification_customizable": "规格/能否定制",
  "attributes": "特性",
  "no_attributes_yet": "暂无特性",
  "reference_priceV3": "参考价",
  "originV4": "产地",
  "notes": "补充",
  "delete_this_item": "确定删除？",
  "unlimitedV4": "不限",
  "value_yuan_unitV3": "{{value}}元/单价",
  "about_value_valueV3": "约{{value}}{{value}}",
  "reference_imageV2": "意向图",
  "this_product_already_exists": "已存在该产品",
  "this_area_cannot_be_dragged": "此区域不可拖拽",
  "drag_curated_products_from_the_left": "请从左侧拖入严选产品",
  "or_left_click_here_to_upload_a_product": "或左键单击此处上传产品",
  "cancel_your_participation": "是否放弃参与？",
  "joined": "参与成功",
  "upload_local_products": "上传本地产品",
  "add_product_images": "请添加产品图",
  "enter_series_name": "请输入系列名称",
  "enter_product_nameV3": "请输入产品名称",
  "customizableV2": "能否定制",
  "reference_priceV4": "参考价格",
  "price_must_exceed_0": "价格应大于0",
  "price_must_be_a_number": "价格应为数字",
  "approx": "约",
  "yuan_unit_price": "元/单价",
  "select_delivery_period": "请选择供货周期",
  "additional_information": "补充说明",
  "enter_additional_information": "请输入补充说明",
  "all_categoriesV2": "所有分类",
  "search_materials": "搜索材料",
  "select_brand": "选择品牌",
  "use_cases": "应用场景",
  "reference_priceV5": "参考价格",
  "my_uploads": "我上传",
  "one_month": "一个月",
  "three_months": "三个月",
  "six_months": "半年",
  "within_one_yearV2": "一年以内",
  "more_than_one_yearV2": "一年以上",
  "a": "个",
  "confirm_download": "确认下载",
  "cancel_download": "取消下载",
  "please_save_the_qr_code_and_use_a_third_party_application_to_scan_the_code_to_open_it": "请保存二维码，使用第三方应用扫码打开",
  "press_and_hold_to_scan_qr_code": "长按识别二维码",
  "texture_libraryV2": "贴图库",
  "search_texturesV2": "搜索贴图",
  "linkedV2": "已关联",
  "select_at_least_one_related_imageV2": "请至少勾选一张关联图",
  "failed_to_upload_valueV3": "{{value}} 上传失败",
  "by_space": "按私域",
  "choose_at_least_one": "至少选择一个",
  "disabled": "已停用",
  "space_disabled": "私域已停用",
  "unlimitedV5": "不限",
  "substituteInstallation": "代安装",
  "substituteProcessing": "代加工",
  "substituteConstruction": "代施工",
  "detailedDesign": "深化设计",
  "within_two_weeksV2": "两周内",
  "within_one_yearV3": "一年内",
  "more_than_one_yearV3": "一年以上",
  "show_lessV3": "收缩更多",
  "show_moreV3": "展开更多",
  "anonymousV4": "匿名",
  "toV3": "止",
  "curatedV5": "严选",
  "seriesV3": "系列",
  "specification_customizableV2": "规格/能否定制",
  "attributesV2": "特性",
  "reference_priceV6": "参考价",
  "originV5": "产地",
  "unlimitedV6": "不限",
  "notesV2": "补充",
  "my_choice": "我的抉择",
  "request_detailsV3": "需求描述",
  "value_yuan_unitV4": "{{value}}元/单价",
  "about_value_valueV4": "约{{value}}{{value}}",
  "supplier_ignored": "忽略商家成功",
  "supplier": "供应商家",
  "this_card_ignores_all_information_about_this_supplier_do_you_want_to_continue": "此张卡片忽略这家供应商所有信息，是否继续？",
  "messages": "消息",
  "visible_after_you_submit": "投递后可查看",
  "request_detailsV4": "需求说明",
  "request_address": "需求地址",
  "unlimitedV7": "不限",
  "approx_value_value": "约{{value}} {{value}}",
  "adopted": "已采纳",
  "shortlisted": "已备选",
  "eliminated": "已淘汰",
  "no": "序号",
  "seriesV4": "系列",
  "originV6": "产地",
  "reference_priceV7": "参考价",
  "contact": "联系",
  "you_cannot_add_your_own_cards_to_favoritesV2": "不能收藏自己创建的卡",
  "remove_from_favorites": "你确定取消收藏吗？",
  "removed_from_favoritesV2": "取消收藏成功",
  "add_this_request_card_to_favorites": "你要收藏此需求卡吗？",
  "added_to_favoritesV3": "添加收藏成功",
  "return_to_preview_page": "是否返回预览页面？",
  "submitted_successfully": "投递成功",
  "enter_contact_name": "请输入联系性名",
  "enter_a_valid_phone_number": "请输入正确手机号",
  "invalid_phone_number_format": "手机号格式不正确",
  "enter_contact_number": "请输入联系电话",
  "enter_a_valid_email_address": "请输入正确邮箱",
  "invalid_email_format": "邮箱格式不正确",
  "wechat": "微信",
  "enter_wechat_id": "请输入微信",
  "curatedV6": "严选",
  "seriesV5": "系列",
  "specification_customizableV3": "规格/能否定制",
  "attributesV3": "特性",
  "reference_priceV8": "参考价",
  "originV7": "产地",
  "unlimitedV8": "不限",
  "notesV3": "补充",
  "request_detailsV5": "需求描述",
  "value_yuan_unitV5": "{{value}}元/单价",
  "about_value_valueV5": "约{{value}}{{value}}",
  "visible_after_you_submitV2": "投递后可查看",
  "request_detailsV6": "需求说明",
  "request_addressV2": "需求地址",
  "unlimitedV9": "不限",
  "approx_value_valueV2": "约{{value}} {{value}}",
  "toV4": "止",
  "enter_keywords_to_search_or_create_works": "输入关键词搜索或创建作品",
  "join": "加入",
  "joinedV2": "已加入",
  "loading_please_try_again_later": "加载中，请稍后再试",
  "this_material_color_already_exists_and_cannot_be_added_again": "该材料颜色已存在，不可重复添加",
  "replace_current_material": "是否替换当前材料？",
  "you_have_reached_the_material_limit_remove_some_materials_before_adding_more": "添加材料上限已满，请先清理后继续添加",
  "drag_from_the_material_library_on_the_left_to_add": "请从左侧材料库拖动添加",
  "all_categoriesV3": "所有分类",
  "search_materialsV2": "搜索材料",
  "select_brandV2": "选择品牌",
  "use_casesV2": "应用场景",
  "reference_priceV9": "参考价格",
  "my_uploadsV2": "我上传",
  "private_site": "私有官网",
  "designer_edition": "设计师版",
  "build_your_own_designer_brand_platform_own_your_data_and_run_it_your_way": "打造设计师品牌自有平台，数据确权，你的平台你做主",
  "i_am_in_charge_of_my_private_space": "我的私域我做主",
  "i_decide_what_content_to_put_on_it": "放什么内容我做主",
  "i_decide_how_confidential_each_file_is": "每个文件保密程度我做主",
  "i_decide_how_much_access_to_grant": "权限开放程度我做主",
  "i_decide_what_to_send_to_clients": "发什么给客户我做主",
  "i_decide_who_to_partner_with": "跟谁联盟我做主",
  "i_decide_who_gets_into_my_library": "请谁入库我做主",
  "i_decide_how_the_portfolio_is_presented": "作品集呈现方式我做主",
  "i_decide_the_portfolio_s_validity_period_and_number_of_views": "作品集有效期，阅读次数我做主",
  "submit_proposals_that_self_destruct_after_reading_no_freeloading": "方案提报，阅后即焚，禁止白嫖",
  "brand_edition": "品牌商版",
  "my_private_space_is_my_sales_assistant": "我的私域是销售助手",
  "i_want_to_send_all_the_files_of_the_products_the_designer_needs_anytime_anywhere": "我要随时随地发设计师所需产品的全部文件",
  "i_want_to_get_into_designers_private_space_libraries": "我要入设计师私域库",
  "i_want_designers_to_use_my_products_directly": "我要设计师直接调用我的产品",
  "i_want_designers_to_follow_me_and_be_notified_of_new_products": "我要设计师能关注我，产品上新有通知",
  "i_want_multi_device_business_presentation_desktop_large_screen_ipad_and_mobile": "我要多端口商务呈现：电脑、大屏、Ipad、手机",
  "i_want_seamless_links_between_case_studies_and_related_products": "我要案例和相关产品的无缝链接",
  "i_want_viral_sharing_and_growth": "我要能传播裂变",
  "i_want_to_be_able_to_get_customer_information": "我要能获得客户信息",
  "i_want_to_form_an_industrial_alliance_and_exchange_resources": "我要形成产业联盟，资源互通",
  "organization_edition": "组织机构版",
  "our_private_space_does_it_all": "我们的私域是多面手",
  "we_need_multi_platform_presence_official_site_app_and_mini_program": "我们需要多端呈现：官网、App、小程序",
  "we_need_members_to_sign_up": "我们需要会员入驻",
  "we_need_event_promotion": "我们需要活动宣发",
  "we_need_members_work_to_be_showcased": "我们需要会员作品展示",
  "we_need_our_own_curated_material_library_for_designers_to_choose_from": "我们需要经过自己严选的材料库供设计师选用",
  "we_need_works_linked_to_products": "我们需要作品链接产品",
  "contact_supportV2": "咨询客服",
  "get_started": "开始使用",
  "30_minutes_to_build": "30分钟搭建",
  "everything_is_under_your_control": "一切皆由你掌控",
  "management_work_business_sales": "管理、工作、商务、销售…",
  "enter_bujue": "进入不觉",
  "multiple_roles_multiple_platforms": "多角色，多平台",
  "learn_more": "了解更多",
  "support": "支持",
  "help": "客服帮助",
  "services": "服务",
  "privacy_policyV2": "隐私条款",
  "user_agreementV2": "用户协议",
  "contactV2": "联系",
  "support_qr_code": "客服二维码",
  "scan_to_download_the_appV2": "扫一扫下载App",
  "enter_new_phone_number": "请输入新手机号",
  "enter_new_email": "请输入新邮箱",
  "the_new_phone_number_is_the_same_as_the_old_phone_number": "新手机号与旧手机号相同",
  "failed_to_get_verification_code_try_againV4": "获取验证码失败，请重新获取",
  "linked_successfully": "绑定成功",
  "you_are_not_logged_in": "当前用户未登录",
  "get_the_verification_code": "请获取验证码",
  "account_management": "账号管理",
  "not_set": "未设置",
  "wechatV2": "微信",
  "are_you_sure_you_want_to_unlink": "确认要解除绑定吗？",
  "unlinked_successfully": "解绑成功",
  "unlink": "解绑",
  "not_linked": "未绑定",
  "identity_verification": "身份验证",
  "verify": "验证",
  "enter_verification_codeV2": "请输入验证码",
  "link_phone_number": "绑定手机号",
  "enter_verification_codeV3": "请输入验证码",
  "link_email": "绑定邮箱",
  "enter_a_valid_email_addressV2": "请输入有效邮箱地址",
  "enter_verification_codeV4": "请输入验证码",
  "password_setup": "密码绑定",
  "enter_password": "请输入密码",
  "confirm_password": "确认密码",
  "confirm_your_password": "请确认密码",
  "new_password": "新密码",
  "confirm_new_password": "确认新密码",
  "link_wechat": "绑定微信",
  "scan_the_qr_code_to_link_wechat": "请扫二维码绑定微信",
  "loading": "loading",
  "switch_interval": "切换时间",
  "enter_an_integer_greater_than_0": "请填入大于0的整数",
  "switch_effect": "切换效果",
  "are_you_sure_you_want_to_update_this_agreement_today": "请问是否确认要当天更新该协议吗？",
  "upload_document": "请上传文档",
  "agreement_document": "协议文件：",
  "upload_agreement": "请上传协议",
  "uploaded_successfully": "上传成功",
  "upload_a_docx_file": "请上传.docx文件",
  "agreement_number": "协议编号：",
  "enter_agreement_number": "请输入协议编号",
  "agreement_version": "协议版本：",
  "enter_agreement_version": "请输入协议版本",
  "effective_date": "生效日期：",
  "select_effective_date": "请选择生效日期",
  "not_uploaded": "协议未上传",
  "uploaded_file_agreement": "上传文件协议",
  "fixed_agreement": "固定协议",
  "membership_agreement": "会员协议",
  "add_new_artwork": "新增艺术品",
  "parse": "解析",
  "upload_image": "请上传图片",
  "color_scheme": "配色",
  "select_color_scheme": "请选择配色",
  "enter_artist": "请输入作者",
  "artist": "作者",
  "style_genreV2": "风格/流派",
  "enter_style_genre": "请输入风格/流派",
  "enter_art_type": "请输入艺术类型",
  "art_type": "艺术类型",
  "creation_date": "创作时间",
  "enter_creation_date": "请输入创作时间",
  "nationality": "国籍",
  "theme": "主题",
  "historical_and_cultural_background": "历史文化背景",
  "emotional_symbolism": "情感象征",
  "collection_location": "收藏地点",
  "prompt": "提示词",
  "artistV2": "作者",
  "style_genreV3": "风格/流派",
  "art_typeV2": "艺术类型",
  "creation_dateV2": "创作时间",
  "nationalityV2": "国籍",
  "themeV2": "主题",
  "historical_and_cultural_backgroundV2": "历史文化背景",
  "emotional_symbolismV2": "情感象征",
  "color_schemeV2": "配色",
  "collection_locationV2": "收藏地点",
  "promptV2": "提示词",
  "art_provenance_library": "艺术溯源艺术品库",
  "product_count": "产品数量",
  "cannot_delete_a_brand_that_contains_products": "品牌包含产品时，不可删除",
  "chinaV3": "中国",
  "select_odd_row": "Select Odd Row",
  "select_even_row": "Select Even Row",
  "creation_failed": "创建失败",
  "edited_successfully": "编辑成功",
  "edit_failed": "编辑失败",
  "enter_brand_nameV2": "请填写品牌名称",
  "the_brand_name_already_exists": "品牌名称已经存在",
  "logoV5": "logo",
  "select_brand_typeV2": "请选择品牌类型",
  "official": "是否时官方",
  "enter_value": "请输入{{value}}",
  "duration_year": "时长/年",
  "bonus_duration_month": "赠送时长/月",
  "confirm_cancellation": "确认取消？",
  "candidate_duration": "候选时长",
  "save_the_current_data_first": "请先保存当前数据",
  "my_account_change_password": "个人中心/修改密码",
  "current_password": "旧密码",
  "enter_current_password": "输入旧密码",
  "new_passwordV2": "新密码",
  "confirm_new_passwordV2": "重复新密码",
  "edit_language_plan": "编辑语言套餐",
  "add_language_plan": "新增语言套餐",
  "languageV2": "语言",
  "select_language": "请选择语言",
  "enter_price": "请输入价格",
  "enter_plan_description": "请输入套餐说明",
  "default": "是否默认",
  "enter_valueV2": "请输入{{value}}",
  "plan_name": "套餐名称",
  "plan_description": "套餐说明",
  "capacity_gb": "容量/GB",
  "original_price": "划线价",
  "default_plan": "是否为默认套餐",
  "save_the_current_data_firstV2": "请先保存当前数据",
  "plan_nameV2": "套餐名称",
  "plan_descriptionV2": "套餐说明",
  "select_languageV2": "选择语言",
  "default_planV2": "是否为默认套餐",
  "complaint_time": "投诉时间",
  "reason_for_complaint": "投诉原因",
  "complaint_content": "投诉内容",
  "complaint_user_id": "投诉用户id",
  "complaints_panel": "投诉面板",
  "total_value_itemsV2": "共{{value}}条",
  "commonly_used": "常用",
  "creation_failedV2": "创建失败",
  "are_you_sure_you_want_to_delete_the_group_value": "确定要删除分组「{{value}}」吗？",
  "are_you_sure_you_want_to_delete_the_country_value": "确定要删除国家「{{value}}」吗？",
  "are_you_sure_you_want_to_remove_value_from_commonly_used": "确定要将「{{value}}」从常用中移除吗？",
  "removed_successfully": "移除成功",
  "removal_failed": "移除失败",
  "add_failed": "添加失败",
  "select_an_svg_file": "请选择SVG文件",
  "no_files_to_upload": "没有需要上传的文件",
  "upload_completed": "上传完成",
  "no_data_to_export": "没有可导出的数据",
  "file_name": "文件名",
  "pending_upload": "待上传",
  "no_data_to_import_all_data_already_exists": "没有需要导入的数据，所有数据已存在",
  "bulk_import_country_data": "批量导入国家数据",
  "about_to_import_value_groups_and_value_countries_value_existing_skipped_continue": "即将导入 {{value}} 个分组和 {{value}} 个国家（跳过已存在 {{value}} 个），确认继续？",
  "confirm_import": "确认导入",
  "create_group": "创建分组",
  "create_country": "创建国家",
  "bulk_import_completed": "批量导入完成",
  "bulk_import_error": "批量导入出错",
  "country_name": "国家名称",
  "country_code": "国家编码",
  "country_management": "国家管理",
  "bulk_importing": "批量导入中",
  "chinese_name": "中文名称",
  "enter_chinese_name": "请输入中文名称",
  "enter_chinese_group_name": "请输入中文分组名称",
  "value_name": "{{value}}名称",
  "enter_value_group_name": "请输入{{value}}分组名称",
  "edit_country": "编辑国家",
  "add_country": "添加国家",
  "chinese_country_name": "中文国家名",
  "enter_chinese_country_name": "请输入中文国家名",
  "value_country_name": "{{value}}国家名",
  "enter_value_country_name": "请输入{{value}}国家名",
  "enter_country_code": "请输入国家编码",
  "country_code_must_be_2_letters": "国家编码必须为2位字母",
  "only_letters_are_allowed": "只能输入英文字母",
  "2_english_letters": "2位英文字母",
  "add_country_to_commonly_used": "添加国家到常用",
  "bulk_upload_svgs": "批量上传SVG",
  "version_number": "版本号",
  "force_update": "强制更新",
  "release_notes": "更新说明",
  "installer": "安装包",
  "update_file": "更新包",
  "creation_time": "创建时间",
  "updater": "更新程序",
  "file_upload_failed": "文件上传失败",
  "uploadV2": "上传",
  "app_store_link": "应用商店链接",
  "enter_version_number": "请输入版本号",
  "upload_installer": "请上传安装包",
  "enter_release_notes": "请输入更新说明",
  "enter_banner_link": "请输入banner链接",
  "enter_banner_linkV2": "请输入banner链接",
  "upload_imageV2": "请上传图片",
  "delete_banner": "删除Banner",
  "are_you_sure_you_want_to_delete_it": "你确定要删除吗",
  "switch_intervalV2": "切换时间",
  "enter_an_integer_greater_than_0V2": "请填入大于0的整数",
  "switch_effectV2": "切换效果",
  "select_languageV3": "请选择语言",
  "add_new_language_pack": "新增语言包",
  "select_languageV4": "请选择语言",
  "existing_languages": "已有语言",
  "translation_progress": "翻译进度",
  "are_you_sure_you_want_to_delete": "是否确定删除？",
  "not_uploadedV2": "未上传",
  "uploaded": "已上传",
  "space_language_packs": "私域语言包",
  "space_management": "私域管理",
  "official_settings": "官方设置",
  "select_space": "选择私域",
  "select_spaceV2": "请选择私域",
  "select_language_pack": "请选择语言包",
  "plan_nameV3": "套餐名称",
  "order_time": "订单时间",
  "order_source": "订单来源",
  "wechatV3": "微信",
  "order": "订单",
  "version_numberV2": "版本号",
  "operation_time": "操作时间",
  "api": "接口",
  "request": "请求",
  "response": "响应",
  "ipv4_address": "IPv4地址",
  "ipv6_address": "IPv6地址",
  "operator_id": "操作用户id",
  "operation_log": "操作日志",
  "total_value_itemsV3": "共{{value}}条",
  "value_is_not_an_imageV4": "{{value}} 不是图片",
  "image_size_limit_4mbV2": "图片大小限制4M",
  "add_certificate": "添加证书",
  "material_image_must_not_exceed_4_mb_800_800_px_or_larger_with_the_same_aspect_ratio_is_recommended": "材料图片大小不能超过4M；建议800*800以上等比例尺寸",
  "image_is_requiredV2": "图片必传",
  "are_you_sure_you_want_to_add_this_material_to_the_comparison": "你确定要将该材料加入对比吗？",
  "are_you_sure_you_want_to_clear_it": "你确定要清空吗？",
  "cleared_successfully": "清空成功",
  "product_comparison": "产品PK",
  "add_attributeV2": "添加特性",
  "enter_feature_nameV3": "请填写特性名称",
  "node_name_is_required": "节点名称必填",
  "node_name": "节点名称",
  "schematic_diagram_is_required": "示意图必填",
  "schematic_diagram": "示意图",
  "applicable_materials_are_required": "适用材料必选",
  "applicable_materials": "适用材料",
  "drawings": "图纸",
  "enter_node_name": "请输入节点名称",
  "node": "节点",
  "upload_schematic_diagram": "示意图请上传",
  "applicable_materials_are_requiredV2": "适用材料必填",
  "pack_box": "包/箱",
  "pieces_pack": "片/包",
  "kg_piece": "kg/片",
  "fields_with_existing_data_cannot_be_deleted": "有数据的情况下不能删除字段",
  "field_name_is_empty_or_already_exists": "字段不能为空或者已存在",
  "field_name_already_exists_or_is_empty": "字段已存在或字段不能为空",
  "upload_imageV3": "请输入图片",
  "new_shipping_address": "新建收货地址",
  "application_submitted": "申请成功",
  "shipping_address": "收货地址",
  "requested_quantity": "申请数量",
  "value_is_not_an_imageV5": "{{value}} 不是图片",
  "image_size_limit_4mbV3": "图片大小限制4M",
  "customization_notes": "定制说明",
  "specification_name_already_exists": "规格名称已存在或名称不能重复",
  "name_is_requiredV2": "名称必填",
  "reason_for_terminating_the_partnership": "终止合作理由",
  "partnership_terminated": "终止合作成功",
  "note_added_successfully": "备注添加成功",
  "rejection_reasonV2": "驳回申请理由",
  "application_rejected": "驳回申请成功",
  "supplier_nameV2": "供应商名称",
  "onboarding_date": "入驻时间",
  "products": "产品数",
  "end_partnership": "终止合作",
  "reason_for_termination": "终止理由",
  "application_rejectedV2": "申请驳回",
  "rejection_reasonV3": "驳回理由",
  "enable_this_partnership": "是否确认启用合作？",
  "enabled": "启用成功",
  "approve_this_application": "是否确定通过审核？",
  "total_value_itemsV4": "共{{value}}条",
  "rejection_number": "驳回编号：",
  "termination_number": "终止编号：",
  "rejection_time": "驳回申请时间：",
  "termination_time": "终止合作时间：",
  "reason_for_terminating_the_partnershipV2": "终止合作理由：",
  "enter_required": "请填写（必填项）",
  "rating_submitted": "评分成功",
  "brand_nameV3": "品牌商名称",
  "main_product_nameV2": "主营产品名称",
  "product_quality": "产品质量",
  "contract_performance": "覆约情况",
  "service_level": "服务水准",
  "product_price": "产品价格",
  "corporate_reputation": "企业信誉",
  "review_score": "评价得分",
  "qualified": "合格",
  "unqualified": "不合格",
  "improvement_suggestions": "改进建议",
  "handling_notes": "处理意见",
  "creation_timeV2": "创建时间",
  "display": "是否显示",
  "are_you_sure_you_want_to_delete_this_category": "你确定要删除该分类吗？",
  "document_category": "文档分类",
  "enter_category_name": "请填写分类名称",
  "enter_sort_order": "请填写排序",
  "displayV2": "是否展示",
  "added_successfully": "新增成功",
  "are_you_sure_you_want_to_delete_this_document": "你确定要删除该文档吗？",
  "are_you_sure_you_want_to_disable_this_document": "你确定要禁用该文档吗？",
  "are_you_sure_you_want_to_enable_this_document": "你确定要启用该文档吗？",
  "enabledV2": "启用成功",
  "disabled_successfully": "禁用成功",
  "title": "标题",
  "question_category": "问题分类",
  "date_addedV2": "添加时间",
  "pin_to_top": "是否置顶",
  "pinned": "已置顶",
  "not_pinned": "未置顶",
  "enable": "启用",
  "disabledV2": "禁用",
  "are_you_sure_you_want_to_pin_it": "你确定要置顶吗？",
  "are_you_sure_you_want_to_unpin_it": "你确定要取消置顶吗？",
  "help_documentation": "帮助文档",
  "enter_titleV6": "请填写标题",
  "end_time": "结束时间",
  "start_time": "开始时间",
  "select_status": "请选择状态",
  "enabledV3": "启用中",
  "disabledV3": "禁用中",
  "edit_document": "编辑文档",
  "add_document": "新增文档",
  "document_categoryV2": "文档分类",
  "enter_sort_orderV2": "请填写排序",
  "operation_details": "操作详情",
  "enter_document_details": "请填写文档详情",
  "import_pdfV3": "导入pdf",
  "complete_importV3": "完成导入",
  "invalid_page_number_formatV2": "输入的页码不规范",
  "import_pdfV4": "导入PDF",
  "specific_pagesV2": "指定页",
  "e_g_1_2_5_7_10V2": "如：1、2-5、7-10",
  "the_higher_the_resolution_the_longer_the_import_timeV2": "清晰度越高导入时间越长",
  "complete_importV4": "完成导入",
  "subcategory_order_updated": "二级分类排序成功",
  "are_you_sure_you_want_to_delete_value": "确定要删除{{value}}?",
  "name_is_requiredV3": "名称不能全为空",
  "duplicate_name": "名称重复",
  "edit_primary_category": "编辑一级分类",
  "add_primary_category": "添加一级分类",
  "enter_category_nameV2": "请填写分类名称",
  "percentage": "占比",
  "enter_product_percentage": "请填写产品占比",
  "global_field_management": "全局字段管理",
  "code": "代号",
  "creation_timeV3": "创建时间",
  "displayV3": "是否显示",
  "delete_this_category": "是否确认删除分类？",
  "are_you_sure_you_want_to_delete_the_category": "你确定要删除分类吗？",
  "name_is_requiredV4": "名称不能全空",
  "subcategory_added": "新增子分类成功",
  "subcategory_updated": "修改子分类成功",
  "primary_category_order_updated": "一级分类排序成功",
  "enter_category_nameV3": "请输入分类名称",
  "enter_code": "请输入代号",
  "logo_image": "logo图片",
  "reject_application": "驳回申请",
  "enter_rejection_reason_requiredV2": "请填写驳回申请理由（必填项）",
  "rejection_reasonV4": "驳回理由：",
  "reason_for_unpublishing": "下架原因：",
  "review_center_material_review": "审核中心/材料审核",
  "user_id": "用户ID",
  "enter_user_id": "请填写用户ID",
  "material": "材料",
  "enter_material_and_color_name": "请填写材料，颜色名称",
  "application_type": "申请类型",
  "material_name": "材料名称",
  "regular_user": "普通用户",
  "official_material": "官方材料",
  "username": "用户名称",
  "phone_number": "用户手机号",
  "publicV2": "是否公开",
  "privateV4": "不公开",
  "publicV3": "公开",
  "description": "描述",
  "application_time": "申请时间",
  "created": "已创建",
  "rejection_reasonV5": "驳回理由",
  "approve_this_applicationV2": "是否确认通过审核？",
  "enter_valueV3": "请填写{{value}}",
  "view_details": "查看详情",
  "reviewV2": "审核",
  "enter_rejection_reasonV2": "请填写驳回申请理由",
  "rejectedV2": "审核驳回",
  "review_commentsV2": "审核批注",
  "node_nameV2": "节点名称",
  "schematic_diagramV2": "示意图",
  "creation_timeV4": "创建时间",
  "drawingsV2": "图纸",
  "click_to_download": "点击下载",
  "last_modified": "修改时间",
  "material_node_management": "材料节点管理",
  "nodeV2": "节点",
  "node_name_is_requiredV2": "节点名称必填",
  "schematic_diagram_is_requiredV2": "示意图必填",
  "applicable_materials_are_requiredV3": "适用材料必填",
  "applicable_materialsV2": "适用材料",
  "upload_drawings": "上传图纸",
  "add_parameters": "添加参数",
  "parameter_name_is_required": "参数名称必填",
  "field_name": "字段名称",
  "input_field": "输入框",
  "dropdown": "下拉框",
  "enter_field_name": "请填写字段名称",
  "display_name": "显示名称",
  "enter_display_name": "请填写显示名称",
  "control_type_is_required": "控件类型必选",
  "control_type": "控件类型",
  "default_value": "默认值",
  "candidate_values_are_required": "候选值必添加",
  "candidate_value": "候选值",
  "select_material_category": "请选择材料分类",
  "material_category": "材料分类",
  "as_filter": "作为过滤条件",
  "name_is_requiredV5": "名称必填",
  "parameter_name": "参数名称",
  "material_categoryV2": "材料分类",
  "control_typeV2": "控件类型",
  "input_fieldV2": "输入框",
  "dropdownV2": "下拉框",
  "default_valueV2": "默认值",
  "candidate_valueV2": "候选值",
  "creation_timeV5": "创建时间",
  "are_you_sure_you_want_to_delete_this_field_under_all_related_categories": "确定要删除所有关联分类下的这个字段吗",
  "are_you_sure_you_want_to_delete_this_field_under_value": "确认删除${{value}}下的这个字段吗？",
  "configuration_load_failed": "配置加载失败：",
  "configuration_load_failedV2": "配置加载失败：",
  "edit_benefits": "编辑权益",
  "add_benefits": "添加权益",
  "titleV2": "标题",
  "enter_titleV7": "请填写标题",
  "subtitle": "副标题",
  "enter_subtitle": "请填写副标题",
  "icon": "图标",
  "benefits": "权益说明",
  "benefit_name": "权益名称",
  "benefitsV2": "权益说明",
  "switch": "开关",
  "application_timeV2": "申请时间",
  "delete_this_benefit": "是否确认删除权益吗？",
  "membership_benefits": "会员权益",
  "add_agreement": "添加协议",
  "agreement_name": "协议名称",
  "enter_agreement_name": "请填写协议名称",
  "agreement": "协议",
  "upload_agreementV2": "请上传协议",
  "upload_a_pdf_file": "请上传.pdf文件",
  "size_must_not_exceed_2mb": "大小不超过2M",
  "click_to_uploadV3": "点击上传",
  "titleV3": "标题",
  "enter_titleV8": "请填写标题",
  "agreementV2": "协议",
  "fees_and_benefits": "付费和权益",
  "enter_paid_benefits": "请填写付费权益",
  "membership_rules": "会员规则",
  "membership_name": "会员名称",
  "membership_validity_period": "会员有效期",
  "benefitsV3": "权益",
  "fees_and_benefitsV2": "付费和权益",
  "select_membership_validity_period": "请选择会员有效期",
  "original_priceV2": "划线价",
  "enter_priceV2": "请填写价格",
  "amount_paid": "实付价",
  "select_benefits": "请选择权益",
  "edit_basic_information": "编辑基本信息",
  "membership_validity_periodV2": "会员有效期：",
  "member_price": "会员价格：",
  "membership_rulesV2": "会员规则：",
  "membership_rulesV3": "会员规则",
  "user_agreementV3": "用户协议：",
  "membership_settings": "会员设置",
  "enter_valueV4": "请输入{{value}}",
  "distributor": "渠道商",
  "discount": "折扣",
  "discountV2": "折",
  "channel_code": "渠道码",
  "5_digit_channel_code": "五位渠道码",
  "transaction_volume": "成交量",
  "sales": "销售额",
  "enableV2": "启用",
  "deactivatedV2": "停用",
  "referral_code": "推荐码",
  "purchase_date": "购买日期",
  "value_yuan": "{{value}} 元",
  "amount_paidV2": "实付款",
  "customer_contact": "客户联系人",
  "item": "商品",
  "payment_platform": "支付平台",
  "payment_order_number": "支付单号",
  "select_partner_information_first": "请先选择合作方信息",
  "distributor_management": "渠道商管理",
  "update_partner_information": "更新合作方信息",
  "add_partner_information": "新增合作方信息",
  "partner": "合作方",
  "enter_partner_name": "请输入合作方名称",
  "enter_discount": "请输入折扣",
  "5_digit_discount_code": "5位优惠码",
  "sales_data": "销售数据",
  "select_a_supplier": "请选择一个供应商",
  "search_suppliers": "搜索供应商",
  "search_team": "搜索团队",
  "private_space": "所属私域",
  "creation_timeV6": "创建时间",
  "review_status": "审核状态",
  "rejection_reasonV6": "驳回原因",
  "approve_this_product": "确定审核通过该产品？",
  "enter_reason": "请填写原因",
  "search_product_private_space_name": "搜索产品/私域名称",
  "approve_these_products": "确定批量审核通过这些产品？",
  "force_unpublish": "强制下架",
  "total_quantity": "全部数量",
  "curatedV7": "严选",
  "top_pick": "首推",
  "are_you_sure_you_want_to_publish_these_products": "你确定要上架这些产品吗？",
  "are_you_sure_you_want_to_cancel_the_homepage_promotion": "你确定要取消首页推广吗？",
  "private_spaceV2": "所属私域",
  "creation_timeV7": "创建时间",
  "curatedV8": "是否严选",
  "not_curated": "非严选",
  "completeness_status": "完整性状态",
  "review_information": "审核信息",
  "review_statusV2": "审核状态",
  "rejection_reasonV7": "驳回原因",
  "approve_this": "你确定要通过吗？",
  "are_you_sure_you_want_to_publish_this_product": "你确定要上架该产品吗？",
  "promote_this_on_the_homepage": "你确定要首页推广吗？",
  "ban_publishing": "禁止上架",
  "enter_publishing_ban_reason": "请填写禁止上架原因",
  "enter_rejection_reasonV3": "请填写不通过原因",
  "add_recommended_supplier": "添加推荐供应商",
  "search_private_space_name": "搜索私域名称",
  "enter_keywords_to_search_private_space": "输入关键词搜索私域",
  "no_matching_results": "无匹配结果",
  "added": "已添加",
  "saved": "已保存",
  "save_failed_restored_to_the_latest_server_state": "保存失败，已恢复为服务器最新状态：",
  "valid": "是否有效",
  "validV2": "有效",
  "remove_this_recommendation": "确认移除该推荐？",
  "saving": "保存中…",
  "supplier_nameV3": "供应商名称",
  "officialV2": "官方",
  "materialV2": "材料",
  "usernameV2": "用户名称",
  "phone_numberV2": "手机号码",
  "application_timeV3": "申请时间",
  "requested_quantityV2": "申请数量",
  "review_center_swatch_management": "审核中心/小样管理",
  "enter_material_name": "请输入材料名称",
  "consignee": "收货人",
  "enter_consignee_id": "请输入收货人id",
  "bundled_service_settings": "配套服务配置",
  "edit_service": "编辑服务",
  "service_name": "服务名称",
  "value_nameV2": "{{value}}名称",
  "automatic_trigger": "自动触发",
  "manual_trigger": "手动触发",
  "processing": "处理中",
  "failed": "失败",
  "file_path_does_not_exist": "文件地址不存在",
  "start_timeV2": "起始时间",
  "end_timeV2": "结束时间",
  "statistical_period": "统计周期",
  "statistics_completion_time": "统计完成时间",
  "trigger_mode": "触发方式",
  "statistics_file": "统计文件",
  "query_failed": "查询失败",
  "statistics": "数据统计",
  "time_range_by_end_time": "时间范围（按结束时间）",
  "month": "月份",
  "total_value_itemsV5": "共 {{value}} 条",
  "on_value_grant_the_value_team_value_gb_of_bujue_cloud_storage": "确认于{{value}}向{{value}}团队赠送不觉云存储容量{{value}}GB？",
  "grant_the_value_team_value_gb_of_bujue_cloud_storage_now": "确认立即向{{value}}团队赠送不觉云存储容量{{value}}GB？",
  "operation_failed": "操作失败：",
  "current_granted_capacity": "当前赠送容量：",
  "granted_capacity": "赠送容量",
  "granted_capacity_is_required": "赠送容量不能为空",
  "enter_granted_capacity": "请输入赠送容量",
  "issue_date": "发放日期",
  "select_issue_date": "请选择发放日期",
  "if_you_do_not_select_an_issue_date_it_will_take_effect_immediately": "不选发放日期立即生效",
  "reminder_is_required": "提醒不能为空",
  "team_name": "团队名称",
  "granted_capacityV2": "赠送容量",
  "active_plan": "生效套餐",
  "total_capacity_gb": "总容量/GB",
  "used_gb": "已使用/GB",
  "cancel_this_grant": "是否确认取消本次赠送？",
  "cancel_grant": "取消本次赠送",
  "team_capacity_management": "团队容量管理",
  "team_nameV2": "团队名称",
  "select_purchase_duration": "选择购买时长",
  "enter_amount_paid": "填写实付",
  "adjust_amount_paid_must_be_less_than_amount_due": "调整实付（实付应该小于应付）",
  "select_payment_channel": "选择支付渠道",
  "enter_payment_order_number": "输入支付单号",
  "please_value_first": "请先{{value}}",
  "free_versionV3": "免费版",
  "set_plan": "设置套餐",
  "plan": "套餐：",
  "planV2": "套餐*",
  "value_year": "(￥{{value}}/年)",
  "free_forever": "（永久免费）",
  "renewV2": "续期",
  "upgradeV2": "升级",
  "purchase_duration": "购买时长*",
  "the_value_promo_code_has_been_redeemed_for_you_valueV2": "已为您兑换{{value}}折优惠码：{{value}}",
  "amount_paidV3": "实付*",
  "unionpay": "银联支付",
  "offline_payment": "线下支付",
  "rejection_reasonV8": "驳回理由",
  "rejection_reasonV9": "审核不通过理由",
  "enter_requiredV2": "请填写（必填项）",
  "team_nameV3": "团队名称",
  "team_type": "团队类型",
  "approve_this_applicationV3": "是否确定通过审核？",
  "enter_rejection_reasonV4": "请输入审核不通过理由",
  "total_value_itemsV6": "共{{value}}条",
  "rejection_id": "审核不通过编号：",
  "rejection_timeV2": "审核不通过时间：",
  "rejection_reasonV10": "审核不通过理由：",
  "view_team_verification": "查看团队认证",
  "are_you_sure_you_want_to_restore_this_team": "是否确认恢复该团队？",
  "restored": "恢复成功",
  "incomplete_form": "有表单没有填写",
  "configured": "配置成功",
  "attachment_deleted": "附件已删除",
  "uploaded_successfullyV2": "上传成功",
  "team_nameV4": "团队名称",
  "registered_at": "注册时间",
  "public_mini_program": "公共小程序",
  "custom_mini_program": "定制小程序",
  "redirect_official_site_to_mini_program": "官网是否是否跳转到小程序 ⬇",
  "deactivatedV3": "被停用",
  "active": "正常",
  "team_management": "团队管理",
  "total_value_itemsV7": "共{{value}}条",
  "suspend_team": "暂停团队",
  "enter_requiredV3": "请填写（必填项）",
  "reason_for_deactivation": "停用原因",
  "set_custom_wechat_mini_program_info": "设置定制微信小程序信息",
  "team_settings": "团队设置",
  "bujue_operations_team": "不觉运营团队",
  "space_mode": "私域模式",
  "internationalV2": "国际",
  "domestic": "国内",
  "product_category_wrap": "产品分类换行",
  "click_to_uploadV4": "点击上传",
  "uploaded_images": "上传的图片",
  "are_you_sure_you_want_to_delete_this_item": "确定要删除该项吗？",
  "3d_plugin_update": "三维插件更新",
  "updaterV2": "更新程序",
  "plugin_name": "插件名称",
  "enter_plugin_name": "请输入插件名称",
  "enter_software_name": "请输入软件名称",
  "software_name": "软件名称",
  "select_icon": "请选择图标",
  "iconV2": "图标",
  "updaterV3": "更新程序",
  "upload_update_package": "请上传更新程序",
  "file_upload_failedV2": "文件上传失败",
  "uploadV3": "上传",
  "version_numberV3": "版本号",
  "enter_version_numberV2": "请输入版本号",
  "transaction_number": "交易单号",
  "income_source": "收入场景",
  "application_timeV4": "申请时间",
  "transaction_amount": "交易金额",
  "finance_center_transaction_history": "财务中心/交易记录",
  "enter_transaction_number": "请填写交易单号",
  "transaction_time": "交易时间",
  "searchV2": "查询",
  "associated_suppliers": "关联供应商",
  "mobileV2": "手机",
  "gender": "性别",
  "id_numberV2": "身份证号",
  "registered_atV2": "注册时间",
  "bio": "个性签名",
  "disabledV4": "禁用",
  "activeV2": "正常",
  "bujue_team": "不觉团队",
  "update_failed": "更新失败：",
  "user_management": "用户管理",
  "enter_name_email_phone_number_or_nickname": "输入姓名邮箱手机号昵称",
  "edit_information": "编辑信息",
  "add_information": "添加信息",
  "remaining_quantity": "剩余数量",
  "number_of_teams": "团队数量",
  "delete_information": "删除信息",
  "are_you_sure_you_want_to_delete_itV2": "你确定要删除吗",
  "draftV2": "草稿",
  "rejectedV3": "审核驳回",
  "unpublished": "已下架",
  "work_management": "作品管理",
  "user_idV2": "用户ID",
  "enter_user_idV2": "请填写用户ID",
  "work_title": "作品名称",
  "enter_work_title": "请填写作品名称",
  "unpublished_for_violation": "违规下架",
  "work_id": "作品ID",
  "user": "用户",
  "phone_numberV3": "手机号码",
  "application_timeV5": "申请时间",
  "reason_for_unpublishingV2": "违规下架理由",
  "display_this_on_the_home_page": "是否设为首页展示？",
  "remove_from_the_home_page": "是否取消首页展示？",
  "view_detailsV2": "查看详情",
  "rejection_reasonV11": "驳回理由",
  "reason_for_violation": "违规理由",
  "rejection_timeV3": "驳回申请时间：",
  "violation_application_time": "违规申请时间",
  "reason_for_violationV2": "违规原因：",
  "design_style_management": "设计风格管理",
  "style_name": "风格名称",
  "style_name_value": "风格名称-{{value}}",
  "creation_timeV8": "创建时间",
  "displayV4": "是否显示",
  "delete_this_categoryV2": "是否确认删除分类？",
  "primary_category_order_updatedV2": "一级分类排序成功",
  "design_style": "设计风格",
  "duplicate_style_name": "风格名称重复",
  "enter_category_nameV4": "请填写分类名称",
  "subcategory_order_updatedV2": "二级分类排序成功",
  "building_type_management": "建筑类型管理",
  "category_name_value": "分类名称-{{value}}",
  "creation_timeV9": "创建时间",
  "displayV5": "是否显示",
  "delete_this_categoryV3": "是否确认删除分类？",
  "are_you_sure_you_want_to_delete_the_categoryV2": "你确定要删除分类吗？",
  "subcategory_addedV2": "新增子分类成功",
  "subcategory_updatedV2": "修改子分类成功",
  "primary_category_order_updatedV3": "一级分类排序成功",
  "building_type_classification": "建筑类型分类",
  "enter_category_nameV5": "请填写分类名称",
  "category_name_valueV2": "分类名称{{value}}",
  "enter_category_name_value": "请填写分类名称{{value}}",
  "platform_management": "平台管理",
  "carousel": "轮播图",
  "app_carousel": "App轮播图",
  "agreement_template": "协议模版",
  "product_library_management": "产品库管理",
  "bundled_service_settingsV2": "配套服务配置",
  "material_categoryV3": "材料分类",
  "private_space_product_management": "私域产品管理",
  "country_managementV2": "国家管理",
  "work_managementV2": "作品管理",
  "building_type_managementV2": "建筑类型管理",
  "design_style_managementV2": "设计风格管理",
  "cloud_drive_admin": "云盘后台管理",
  "team_capacity_managementV2": "团队容量管理",
  "cloud_drive_operations": "云盘运营",
  "candidate_durationV2": "候选时长",
  "distributor_managementV2": "渠道商管理",
  "idea_board_management": "创意板管理",
  "promptV3": "提示词",
  "basic_asset_management": "基础素材管理",
  "recommended_supplier_management": "推荐供应商管理",
  "ai_configuration": "AI 配置",
  "models_and_keys": "模型与密钥",
  "ai_usage": "AI 用量",
  "tools_admin": "小工具后台管理",
  "custom_template": "定制模板",
  "art_provenance_libraryV2": "艺术溯源艺术品库",
  "3d_plugin_updateV2": "三维插件更新",
  "node_library_management": "节点库管理",
  "help_documentationV2": "帮助文档",
  "document_categoryV3": "文档分类",
  "review_center": "审核中心",
  "material_review": "材料审核",
  "swatch_management": "小样管理",
  "user_managementV2": "用户管理",
  "membership_settingsV2": "会员设置",
  "membership_benefitsV2": "会员权益",
  "business_entity_management": "主体管理",
  "design_team_management": "设计团队管理",
  "log_panel": "日志面板",
  "complaints_panelV2": "投诉面板",
  "space_language_packsV2": "私域语言包",
  "finance_center": "财务中心",
  "transaction_history": "交易记录",
  "client_version": "客户端版本",
  "downloader_version": "下载器版本",
  "statisticsV2": "数据统计",
  "change_password": "修改密码",
  "please_act_soon": "请尽快处理",
  "this_is_the_last_page": "已经是最后一页了",
  "bujue_space_gallery": "不觉空间艺术馆",
  "the_platform_that_empowers_designers": "设计师背后的赋能平台",
  "folder_name_is_required": "文件夹名不能为空",
  "file_name_is_required": "文件名不能为空",
  "file_names_cannot_contain_the_following_characters": "文件名不能包含以下字符：",
  "a_folder_with_this_name_already_exists": "当前文件夹名字已存在",
  "a_file_with_this_name_already_exists": "当前文件名已存在",
  "renamed": "重命名成功",
  "rename_failed": "重命名失败",
  "online_preview_is_not_supported_for_this_file_download_it_instead": "当前文件暂不支持在线预览，是否下载查看",
  "online_preview_is_not_supported_for_this_file": "当前文件暂不支持在线预览",
  "rename": "重命名",
  "file_nameV2": "文件名",
  "folder_name_is_requiredV2": "文件夹名不能为空",
  "file_name_is_requiredV2": "文件名不能为空",
  "file_names_cannot_contain_the_following_charactersV2": "文件名不能包含以下字符：",
  "a_folder_with_this_name_already_existsV2": "当前文件夹名字已存在",
  "a_file_with_this_name_already_existsV2": "当前文件名已存在",
  "renamedV2": "重命名成功",
  "rename_failedV2": "重命名失败",
  "online_preview_is_not_supported_for_this_file_download_it_insteadV2": "当前文件暂不支持在线预览，是否下载查看",
  "online_preview_is_not_supported_for_this_fileV2": "当前文件暂不支持在线预览",
  "file_nameV3": "文件名",
  "files_in_destination_folder": "目标文件夹中的文件",
  "file_being_uploaded": "正在上传的文件",
  "existing_files": "已有的文件",
  "file_information": "文件信息",
  "file_path": "文件路径",
  "only_images_can_be_uploaded_to_the_product_asset_library": "产品素材库只能上传图片",
  "cloud_drive_is_full": "云盘容量耗尽",
  "not_enough_cloud_drive_space": "云盘容量不足",
  "some_files_exceed_the_available_cloud_drive_space": "部分文件超出云盘容量",
  "upload_file": "上传文件",
  "upload_folder": "上传文件夹",
  "unnamed_folder": "未命名文件夹",
  "original_image_for_content_display": "内容展示原图",
  "texture_library_folders_cannot_be_moved_in_or_out": "贴图库文件夹不能向内外移动",
  "files_can_only_be_moved_into_the_product_asset_library_folder": "文件只能移动到产品素材库文件夹里",
  "folders_other_than_texture_library_folders_cannot_be_moved_in": "非贴图库文件夹不能向内移动",
  "texture_library_folders_cannot_be_moved_out": "贴图库文件夹不能向外移动",
  "move_failed": "移动失败",
  "duplicate_nameV2": "文件重名",
  "duplicate_files": "文件重复",
  "admin_only": "（仅管理员可见）",
  "system": "（系统）",
  "cannot_move_outside_the_product_asset_library": "无法移动至产品素材库外",
  "cannot_move_to_the_product_asset_library_folder": "无法移动至产品素材库文件夹",
  "cannot_move_to_the_value_folder": "无法移动至{{value}}文件夹",
  "not_enough_cloud_drive_spaceV2": "云盘容量不足",
  "uploaded_successfullyV3": "上传成功",
  "file_names_cannot_contain_the_following_charactersV3": "文件名不能包含以下字符：",
  "no_upload_tasks": "没有上传任务",
  "x_files_are_being_uploaded": "X个文件正在上传",
  "upload_list": "上传列表",
  "uploading": "上传中",
  "completed": "已完成",
  "no_upload_tasksV2": "暂无上传任务",
  "my_company": "我的企业",
  "my_companyV2": "My business",
  "company_administrator": "企业管理员",
  "private_deployment_for_enterprises": "企业私有化部署",
  "on_premises_data_deployment": "数据本地化部署",
  "iconV3": "图标",
  "private_cloud_server": "私有云服务器",
  "custom_homepage": "个性化主页",
  "delegated_data_management": "委托数据管理",
  "number_of_members": "成员人数",
  "unlimitedV10": "不限",
  "technical_services": "技术服务",
  "online_one_on_one_support": "在线一对一客服",
  "class_a": "A级",
  "class_b": "B级",
  "activeV3": "正常",
  "terminated": "已终止",
  "level": "级别",
  "partnership_status": "合作状态",
  "date_addedV3": "添加日期",
  "terminate_this_partnership": "确认终止合作？",
  "resume_this_partnership": "是否重新合作？",
  "are_you_sure_you_want_to_delete_this_contracted_supplier": "确认删除该签约供应商信息吗？",
  "change_end_date": "修改终止日期",
  "select_dateV3": "请选择日期",
  "add_contracted_supplier": "添加签约供应商",
  "select_a_supplier_to_add": "请选择要添加的供应商",
  "search_suppliersV2": "搜索供应商",
  "addedV2": "已添加",
  "contracted_suppliers": "签约供应商",
  "unnamed_folderV2": "未命名文件夹",
  "assets": "素材资源",
  "value_is_not_an_imageV6": "{{value}} 不是图片",
  "value_file_upload_failed": "{{value}} file upload failed.",
  "published_successfullyV2": "发布成功",
  "drag_an_image_of_your_work_here_to_use_as_the_cover": "拖入作品图片作为封面",
  "select_building_type": "请选择建筑类型",
  "select_style": "请选择风格",
  "enter_work_titleV2": "请输入作品名称",
  "enter_work_titleV3": "输入作品名称",
  "unnamed": "未命名",
  "enter_body_text": "请输入正文",
  "failed_to_upload_valueV4": "{{value}} 上传失败",
  "you_can_upload_up_to_value_attachmentsV2": "附件最多上传{{value}}个",
  "added_attachments": "已添加的附件",
  "only_images_and_videos_can_be_uploaded": "只能上传图片和视频",
  "pdf_imageV6": "pdf图片",
  "the_introduction_is_still_uploading_try_saving_again_in_a_moment": "介绍还没上传完，请稍后再保存",
  "attachment_upload_is_not_completeV2": "附件未上传完成",
  "name_is_requiredV6": "名称不能为空",
  "supplier_is_required": "供应商不能为空",
  "select_material_properties": "请选择材料属性",
  "minimum_period_cannot_be_greater_than_maximum_period": "最小区间周期不能大于最大区间周期",
  "product_style": "产品款式",
  "only_pdf_files_can_be_uploaded": "只允许上传PDF",
  "failed_to_upload_valueV5": "{{value}} 上传失败",
  "added_attachmentsV2": "已添加的附件",
  "chinese_pdf": "中文PDF",
  "upload_chinese_pdf": "上传中文PDF",
  "english_pdf": "英文PDF",
  "upload_english_pdf": "上传英文PDF",
  "value_is_not_an_imageV7": "{{value}} 不是图片",
  "image_size_limit_4mbV4": "图片大小限制4M",
  "you_can_upload_up_to_value_images": "最多可上传{{value}}张",
  "no_more_than_4mbV2": "不超过4M",
  "value_is_not_an_imageV8": "{{value}} 不是图片",
  "image_size_limit_4mbV5": "图片大小限制4M",
  "select_styleV2": "请选择风格",
  "select_styleV3": "*请选择风格",
  "enter_work_titleV4": "请填写作品名称",
  "enter_work_titleV5": "*请填写作品名称",
  "enter_descriptionV2": "请填写说明",
  "enter_descriptionV3": "*请填写说明",
  "upload_photos": "上传照片",
  "upload_photoV2": "请上传照片",
  "material_list": "* 材料清单",
  "exporting": "正在导出…",
  "material_listV2": "材料清单",
  "no_materials_added": "未添加材料",
  "drag_materials_from_the_material_library_on_the_left_to_add_them": "请从左侧材料库拖动添加材料",
  "nodeV3": "节点",
  "add_a_node": "请添加节点",
  "project_case": "项目案例",
  "published_successfullyV3": "发布成功",
  "case_description": "案例说明",
  "enter_case_description": "请填写案例说明",
  "upload_imageV4": "请上传图片",
  "company_created_redirecting_to_company_management": "创建企业成功，即将进入企业管理页面",
  "create_company": "创建企业",
  "create_companyV2": "Create a business",
  "company_logo": "企业LOGO",
  "company_profile": "企业简介",
  "tell_us_about_your_business": "介绍一下你的企业",
  "edit_material": "编辑材料",
  "create_material": "创建材料",
  "created_and_published": "创建发布成功",
  "changes_published": "修改发布成功",
  "publishV2": "发布",
  "at_least_one_image_is_required": "至少有1个图片",
  "material_category_name": "*材料分类&名称",
  "select_material_categoryV2": "请选择材料分类",
  "select_material_categoryV3": "请选择材料所属分类",
  "enter_material_nameV2": "请填写材料名称",
  "upload_brand_logo": "请上传品牌LOGO",
  "an_incorrect_material_brand_name_may_reduce_search_traffic_enter_it_carefully_and_accurately": "错误填写材料品牌名称，可能会导致搜索流量减少，请认真准确填写",
  "enter_brand_nameV3": "请填写品牌名称",
  "select_unit": "请选择单位",
  "enter_series_and_modelV3": "请填写系列/型号",
  "enter_series": "请填写系列",
  "enter_origin": "请填写产地",
  "select_delivery_periodV2": "请选择供货周期",
  "within_one_yearV4": "一年内",
  "more_than_one_yearV4": "一年以上",
  "select_supporting_services": "请选择配套服务",
  "select_use_case": "请选择应用场景",
  "airport": "机场",
  "railway_station": "火车站",
  "shopping_mall_supermarket": "购物中心/超市",
  "plaza": "广场",
  "hotel": "酒店",
  "museum_exhibition_hall": "博物馆/展览馆",
  "theater_ktv": "剧院/KTV",
  "office_building": "写字楼",
  "school": "学校",
  "hospital": "医院",
  "restaurant": "餐厅",
  "house_villa": "住宅/别墅",
  "pool": "泳池",
  "sports_field": "操场",
  "at_least_one_specification_is_required": "至少有一个规格",
  "upload_node": "上传节点",
  "upload_parts": "上传配件",
  "enter_experience": "请输入经验",
  "more_materials": "更多材料",
  "published_visible_to_everyone": "发布所有人可见",
  "privateV5": "私密",
  "unlimitedV11": "不限",
  "anonymousV5": "匿名",
  "expiredV2": "已过期",
  "favorite_requests": "需求收藏",
  "view_all": "查看所有",
  "clear_invalid_items": "清空失效项",
  "unlimitedV12": "不限",
  "request_addressV3": "需求地址",
  "select_province": "选择省份",
  "select_city": "选择城市",
  "select_area": "选择区域",
  "unlimitedV13": "不限",
  "materialV3": "材料",
  "finished_productV2": "成品",
  "equipmentV2": "设备",
  "museum_exhibition_hallV2": "博物馆/展览馆",
  "restaurantV2": "餐厅",
  "sports_fieldV2": "操场",
  "basement": "地下室",
  "shopping_mall_supermarketV2": "购物中心/超市",
  "plazaV2": "广场",
  "semi_outdoor_space": "灰空间",
  "railway_stationV2": "火车站",
  "airportV2": "机场",
  "hotelV2": "酒店",
  "theater_ktvV2": "剧院/KTV",
  "indoor": "室内",
  "outdoor": "室外",
  "courtyard": "庭院",
  "exterior_wall": "外墙",
  "roof": "屋顶",
  "office_buildingV2": "写字楼",
  "schoolV2": "学校",
  "hospitalV2": "医院",
  "poolV2": "泳池",
  "house_villaV2": "住宅/别墅",
  "within_100_000": "10万以内",
  "within_500_000": "50万以内",
  "within_1_000_000": "100万以内",
  "1_000_000_or_more": "100万以上",
  "failed_to_get_your_location": "定位失败",
  "request_detailsV7": "需求说明",
  "enter_request_details": "请填写需求说明",
  "card_expiryV4": "卡片时效",
  "select_card_validity_period": "请选择卡片时效",
  "when_the_validity_period_expires_the_system_automatically_unpublishes_the_card_set_the_card_period_shorter_than_the_time_you_actually_need": "时效过期，系统自动下架卡片，建议卡片时间小于实际需求时间",
  "request_addressV4": "需求地址",
  "use_casesV3": "应用场景",
  "select_use_caseV2": "请选择应用场景",
  "indoorV2": "室内",
  "outdoorV2": "室外",
  "semi_outdoor_spaceV2": "灰空间",
  "basementV2": "地下室",
  "roofV2": "屋顶",
  "exterior_wallV2": "外墙",
  "courtyardV2": "庭院",
  "airportV3": "机场",
  "railway_stationV3": "火车站",
  "shopping_mall_supermarketV3": "购物中心/超市",
  "plazaV3": "广场",
  "hotelV3": "酒店",
  "museum_exhibition_hallV3": "博物馆/展览馆",
  "theater_ktvV3": "剧院/KTV",
  "office_buildingV3": "写字楼",
  "schoolV3": "学校",
  "hospitalV3": "医院",
  "restaurantV3": "餐厅",
  "house_villaV3": "住宅/别墅",
  "poolV3": "泳池",
  "sports_fieldV3": "操场",
  "budget": "投入预算",
  "yuan": "元",
  "approxV2": "约",
  "show_lessV4": "收缩更多",
  "show_moreV4": "展开更多",
  "enter_a_valid_mobile_or_landline_number": "请填写正确的手机号或固定电话",
  "enter_a_valid_email_addressV3": "请填写正确的邮箱",
  "enter_at_least_one_contact_method": "请至少填写一项联系方式",
  "enter_nickname": "请填写用户昵称",
  "enter_phone_numberV2": "请填写电话",
  "enter_email_address": "请填写电子邮箱",
  "enter_wechat_idV2": "请填写微信账号",
  "requestV2": "需求",
  "delete_this_anchor_and_all_its_content": "删除锚点和所有内容吗？",
  "s_request_card": "的需求卡",
  "yuanV2": "元",
  "this_request_has_not_been_published_exit_anyway": "需求未发布，确认退出吗？",
  "save_as_draft": "保存为草稿",
  "upload_an_image_and_create_an_anchor_first": "请确认已上传图片并创建锚点",
  "publishV3": "发布",
  "value_is_not_an_imageV9": "{{value}} 不是图片",
  "click_to_uploadV5": "点击上传",
  "finished_products_2": "成品：2",
  "finished_productV3": "成品",
  "equipment_3": "设备：3",
  "equipmentV3": "设备",
  "materialV4": "材料",
  "request_detailsV8": "需求描述",
  "briefly_describe_your_request": "适当描述下您的需求",
  "show_lessV5": "收缩更多",
  "show_moreV5": "展开更多",
  "unlimitedV14": "不限",
  "price_limit": "价格限制",
  "yuan_unit_priceV2": "元/单价",
  "within_two_weeksV3": "两周内",
  "reference_imageV3": "意向图",
  "submission_materials": "投稿材源",
  "curatedV9": "严选",
  "quantityV2": "工程量",
  "approxV3": "约",
  "m": "米",
  "detailed_design_service": "代深化设计",
  "value_succeeded_value_failed": "操作成功{{value}}条，操作失败{{value}}条",
  "brand_category": "品牌分类",
  "select_data_1_first": "请先勾选数据1",
  "space": "私域：",
  "you_can_add_more_products": "可以继续添加更多产品",
  "enter_supplier_nameV4": "请输入供应商名称",
  "supplier_nameV4": "供应商名称",
  "failed_to_get_verification_code_try_againV5": "获取验证码失败，请重新获取",
  "get_the_verification_codeV2": "请获取验证码",
  "identity_verificationV2": "身份验证",
  "verifyV2": "验证",
  "enter_verification_codeV5": "请输入验证码",
  "store_logo": "店铺Logo",
  "upload_store_logo": "请上传店铺Logo",
  "platform_name": "平台名称",
  "enter_platform_name": "请填写平台名称",
  "enter_platform_nameV2": "*请填写平台名称",
  "store_address": "店铺地址",
  "enter_store_address": "请填写店铺地址",
  "enter_store_addressV2": "*请填写店铺地址",
  "supplier_logo": "*供应商LOGO",
  "upload_supplier_logoV2": "请上传供应商LOGO",
  "supplier_is_already_in_useV2": "供应商已被使用",
  "enter_supplier_nameV5": "请填写供应商名称",
  "enter_supplier_nameV6": "*请填写供应商名称",
  "deprecated": "（ 已废弃 ）",
  "upload_company_profileV2": "上传企业简介",
  "address_cannot_be_entered": "不允许填写地址",
  "enter_company_introductionV2": "请填写企业介绍",
  "honors": "荣誉展示",
  "upload_honors": "上传荣誉展示",
  "verification_information": "认证信息",
  "upload_business_licenseV3": "上传营业执照",
  "upload_business_licenseV4": "*上传营业执照",
  "company_name": "*企业名称",
  "enter_company_nameV4": "请填写企业名称",
  "enter_company_nameV5": "*请填写企业名称",
  "enter_detailed_addressV2": "请填写详细地址",
  "enter_full_address": "*请填写详细地址",
  "legal_representativeV3": "*法定代表人",
  "enter_legal_representativeV4": "请填写法定代表人",
  "enter_legal_representativeV5": "*请填写法定代表人",
  "legal_representative_format_is_incorrect": "法定代表人格式不正确",
  "enter_the_legal_representative_s_phone_number": "请填写法定代表人电话",
  "enter_the_legal_representative_s_phone_numberV2": "*请填写法定代表人电话",
  "supplier_type": "*供应商类型",
  "select_supplier_typeV2": "请选择供应商类型",
  "manufacturerV2": "厂家",
  "dealer": "代理商",
  "business_contact_name": "*业务联系人名称",
  "enter_business_contact_nameV3": "请填写业务联系人名称",
  "enter_business_contact_nameV4": "*请填写业务联系人名称",
  "contact_phone_number_format_is_incorrect": "联系人电话格式不正确",
  "enter_business_contact_phone_numberV3": "请填写业务联系人电话",
  "enter_business_contact_phone_numberV4": "*请填写业务联系人电话",
  "enter_contact_addressV3": "请填写联系地址",
  "enter_business_wechat_idV2": "请填写业务联系微信",
  "service_areaV2": "*服务区域",
  "select_service_areaV5": "请选择服务区域",
  "security_settings": "安全设置",
  "glass_supplier": "玻璃供应商",
  "transfer": "移交",
  "unfreeze": "解冻",
  "delete_supplier": "删除供应商",
  "third_party_store": "第三方店铺",
  "verification_informationV2": "认证信息",
  "security_settingsV2": "安全设置",
  "taobao": "淘宝",
  "tmall": "天猫",
  "jd_com": "京东",
  "pinduoduo": "拼多多",
  "douyin": "抖音",
  "kuaishou": "快手",
  "suning": "苏宁",
  "add_at_least_one_store": "请至少添加一个店铺",
  "third_party_storeV2": "第三方店铺",
  "enter_store_url": "请输入店铺网址",
  "supplier_onboarding_under_review": "供应商入驻审核中",
  "supplier_onboarding_rejected": "供应商入驻审核拒绝",
  "our_review_team_will_review_your_application_within_2_business_days": "您的申请信息审核组同事会在2个工作日内审核完成",
  "please_wait_you_will_be_notified_by_sms_once_your_application_is_approved": "请耐心等待，审核通过后会通过短信通知您",
  "contact_400_189_9196": "咨询电话：400-189-9196",
  "preview_information": "预览信息",
  "reapply": "重新申请",
  "business_verification": "法人认证",
  "turn_on_the_front_camera": "请打开前置摄像头",
  "image_uploaded_successfully": "图片上传成功",
  "server_error": "服务器异常",
  "face_detected": "检测到人脸",
  "no_face_detected": "未检测到人脸",
  "face_authentication_passed": "人脸认证通过",
  "return_to_your_computer_to_complete_business_verification": "请返回电脑端继续完成主体认证",
  "face_authentication_failed": "人脸认证未通过",
  "file_upload_failedV3": "文件上传失败",
  "the_image_is_too_large_please_upload_it_again_maximum_file_size_value_mb": "图片太大，请重新上传(文件最大{{value}}MB)",
  "image_uploaded_successfullyV2": "图片上传成功",
  "upload_your_id_card_first": "请先上传身份证",
  "id_card_submitted_successfully": "身份证提交成功",
  "added_to_favoritesV4": "收藏成功",
  "team_logo": "team logo",
  "10k": "万",
  "header_background": "header background",
  "tile_n": "平铺N",
  "delete_all": "全部删除",
  "about": "紹介",
  "partnership": "提携",
  "productsV2": "製品",
  "shared_product": "产品分享",
  "shared_productV2": "产品分享",
  "assetsV2": "资财",
  "to_value_select_at_least_one_value": "请选择要{{value}}的{{value}}",
  "invite_value": "邀请{{value}}",
  "no_private_spaces_yet": "暂无私域",
  "please_read_the_following_supplier_onboarding_service_agreement_and_rules_carefully": "请仔细阅读以下供应商入驻服务协议及规则",
  "i_have_read_the_above_agreement": "我已阅读以上协议",
  "read_and_accept_the_agreement": "请阅读并勾选协议",
  "you_cannot_invite_yourself": "不能邀请自己",
  "recommended_designers": "推荐设计师",
  "company_nameV2": "公司名称",
  "company_name_is_required": "公司名称不能为空",
  "enter_company_nameV6": "请输入公司名称",
  "business_contact": "业务联系人",
  "business_contact_is_required": "业务联系人不能为空",
  "enter_business_contact": "请输入业务联系人",
  "contact_number": "联系电话",
  "contact_phone_number_is_required": "联系电话不能为空",
  "enter_contact_numberV2": "请输入联系电话",
  "create_an_introduction_page": "创建介绍主页",
  "manage_product_data": "管理产品数据",
  "dear_supplier": "亲爱的供应商：",
  "congratulations_a_designer_friend_has_recommended_you_as_a_curated_supplier_on_bujue_bujue_is_a_curated_high_quality_supplier_platform_built_on_designer_recommendations_once_you_complete_the_curated_supplier_onboarding_process_you_can": "恭喜您被设计师朋友推荐成为不觉的严选供应商，不觉平台是由设计师推荐共建的严选优质供应商平台。完成严选供应商入驻流程您可以：",
  "share_product_library_cards_directly_with_designers_and_on_social_media": "直接分享产品库卡片给设计师、朋友圈",
  "we_look_forward_to_having_you_on_board_to_make_bujue_even_better_and_to_helping_more_designers_discover_you_contact_you_and_build_win_win_partnerships": "期待您的加入能让不觉更加完美，同时有更多的设计师朋友能够发现您，联系您，合作共赢",
  "join_company": "加入企业",
  "confirm_request": "确认申请加入",
  "cancel": "我再想想",
  "apply_to_join_value": "申请加入{{value}}",
  "verification": "验证信息",
  "enter_what_you_want_to_know": "请输入你想了解的内容",
  "zhejiang_icp_no_17033477_5": "浙ICP备17033477号-5",
  "failed_to_get_verification_code_try_againV6": "获取验证码失败，请重新获取",
  "complete_the_puzzle_firstV3": "请先完成拼图",
  "linked_successfullyV2": "绑定成功",
  "enter_verification_codeV6": "请输入验证码",
  "failed_to_get_verification_code_try_againV7": "获取验证码失败，请重新获取",
  "complete_the_puzzle_firstV4": "请先完成拼图",
  "registration_and_login_agreement": "注册登录协议说明",
  "wechat_loginV3": "微信登录",
  "wechat_loginV4": "微信登录",
  "panzi_loginV3": "盘子登录",
  "alipay_loginV2": "支付宝登录",
  "hold_and_drag_the_slider_to_complete_the_puzzleV2": "请按住滑块拖动完成拼图",
  "choose_ai_layout_style": "选择 AI 排版方式",
  "dense_grid": "密拼网格",
  "seamless_tight_tiling": "无缝紧密平铺",
  "loose_grid": "疏松网格",
  "spaced_layout_with_optional_rounded_corners": "间距排列可圆角",
  "artistic_layout": "艺术排版",
  "free_composition_with_ai_color_palette": "自由构图 AI配色",
  "start_layout": "开始排版",
  "detecting_material_colors": "识别材料配色…",
  "analyzing_texture": "分析纹理质感…",
  "deducing_composition": "推演构图…",
  "matching_background_swatches": "匹配背景色板…",
  "selecting_decorative_elements": "挑选装饰元素…",
  "balancing_white_space": "平衡留白层次…",
  "generating_layout": "生成排版方案…",
  "ai_processing": "AI 处理中…",
  "connector_layout": "连线排版布局",
  "model": "型号",
  "material_information": "材料信息",
  "materials_in_the_library_information_comes_from_the_product_library_and_cannot_be_edited": "库内材料，信息来自产品库，不可编辑",
  "material_nameV2": "材料名称",
  "optional": "选填",
  "select_material_propertiesV2": "请选择材料属性",
  "value_automatically_selected": "已自动选择 {{value}}",
  "the_original_specification_is_no_longer_valid_select_another_one": "原规格已失效，请重新选择",
  "this_specification_combination_is_disabled": "该规格组合已禁用",
  "select_value": "选择{{value}}",
  "specification_code": "规格编码",
  "enter_specification_code": "手填规格编码…",
  "this_specification_has_no_image_and_cannot_be_selected_here": "该规格无图片，无法在此选择",
  "this_specification_has_multiple_images_you_can_replace_the_image_used_in_the_canvas": "该规格有多张图片，可选择替换画布中使用的图片",
  "changing_the_specification_will_also_replace_the_image_of_this_element_in_the_canvas": "更换规格将同时替换画布中该元素的图片",
  "this_specification_has_no_current_images_and_cannot_be_selected_here": "该规格没有当前图片，无法在此选择",
  "select_at_least_one_image_first": "请先选中至少1张图片",
  "loading_data_source": "数据源加载中，请稍候…",
  "ai_is_analyzing_this_image_please_wait": "该图片正在 AI 识别中，请稍候…",
  "ai_recognition_in_progress": "正在 AI 识别…",
  "image_loading_failed": "图片加载失败",
  "recognition_failed_task_does_not_exist_or_has_expired": "识别失败：任务不存在或已过期",
  "recognition_failed": "识别失败：",
  "unknown_error": "未知错误",
  "no_matching_material_was_found_in_the_current_asset_library_drag_one_in_manually_from_the_asset_library_on_the_left_or_try_again_later": "未在当前素材库匹配到材料，可从左侧素材库手动拖入，或稍后重试",
  "no_matching_material_image_was_found_in_the_library_you_can_add_it_manually_from_the_asset_library_on_the_left": "未匹配到库内材料图片，可从左侧素材库手动添加",
  "identified_value_materials_fetching_images": "识别到 {{value}} 种材料，获取图片…",
  "placed_value_identified_materials": "已放置 {{value}} 种识别材料 ✓",
  "select_at_least_one_asset_first": "请先选择至少1个素材",
  "ai_photorealistic_renderings_cannot_be_used_as_materials_in_layout": "AI真实化效果图不能作为材料参与排版",
  "material_board_is_empty": "材料板为空",
  "ai_material_board": "AI 材料板",
  "materialV5": "材料",
  "material_board_generated": "材料板已生成 ✓",
  "layout_failed": "排版失败：",
  "layout_completed": "排版完成 ✓",
  "no_connector_found_in_the_selection": "未找到选中项中的连线",
  "base_image_not_found": "找不到母图",
  "child_image_not_found": "没有找到子图",
  "connector_layoutV2": "· 连线排版",
  "base_image": "母图",
  "connector_layout_completed": "连线排版完成 ✓",
  "select_a_material_board_in_the_workbench_first": "请先在工作台选中一个材料板",
  "material_board_is_empty_add_assets_first": "材料板为空，请先添加素材",
  "material_board": "材料板",
  "ai_photorealism_in_progress_about_60_120_seconds": "正在 AI 真实化…（约 60-120 秒）",
  "ai_photorealism_in_progress_about_60_120_secondsV2": "AI 真实化中，约需 60-120 秒…",
  "ai_photorealism_failed_task_does_not_exist_or_has_expired": "AI真实化失败：任务不存在或已过期",
  "photorealistic": "· 真实效果",
  "ai_photorealism_completed": "AI 真实化完成 ✓",
  "ai_photorealism_completed_reused_existing_result": "AI 真实化完成 ✓（复用已有结果）",
  "ai_photorealism_failed": "AI真实化失败：",
  "cutting_out": "抠图中…",
  "ai_cutout_in_progress_please_wait": "AI 抠图中，请稍候…",
  "cutout_failed_task_does_not_exist_or_has_expired": "抠图失败：任务不存在或已过期",
  "cutout_completed": "抠图完成 ✓",
  "cutout_failed": "抠图失败：",
  "white_paper": "白皮书",
  "quotation_list": "报价清单",
  "script": "脚本",
  "token_placeholder": "token占位",
  "loading_failed": "加载失败：",
  "export_script_metadata_loading_failed": "导出脚本元数据加载失败：",
  "are_you_sure_you_want_to_delete_this_template": "确定删除该模板？",
  "template_deleted": "已删除模板",
  "delete_failed": "删除失败：",
  "uploadingV2": "上传中…",
  "file_uploaded": "文件已上传",
  "upload_failedV2": "上传失败：",
  "enter_template_name": "请填写模板名",
  "select_script": "请选择脚本",
  "upload_template_file": "请上传模板文件",
  "template_updated": "模板已更新",
  "template_uploaded": "模板已上传",
  "create": "create",
  "save_failed": "保存失败：",
  "scene": "场景",
  "enter_private_space_name_to_search": "输入私域名称搜索",
  "retry_loading_script": "重试加载脚本",
  "retrying": "重试中…",
  "upload_template": "上传模板",
  "creation_timeV10": "创建时间",
  "update_time": "更新时间",
  "spaceV2": "归属私域",
  "engine": "引擎",
  "globalV3": "全局",
  "this_script_is_not_in_the_current_script_metadata_legacy_dirty_data_or_removed": "该 script 不在当前脚本元数据中（存量脏数据或已下线）",
  "the_built_in_default_template_is_not_editable": "内置默认模板不可编辑",
  "the_built_in_default_template_cannot_be_deleted": "内置默认模板不可删除",
  "no_custom_templates": "暂无定制模板",
  "edit_template": "编辑模板",
  "template_name": "模板名",
  "example_official_template_quotation_list_2026_edition": "如：官方模板-报价清单（2026版）",
  "enter_private_space_name_to_search_none_global": "输入私域名称搜索（不选=全局）",
  "token_placeholder_placeholder_filling": "token占位（占位符填充）",
  "script_pre_registration_script": "脚本（预注册脚本）",
  "no_scripts_available": "（暂无可选脚本）",
  "no_file": "（无文件）",
  "undo_replacement": "撤销更换",
  "uploadedV2": "已上传",
  "idea_board_managementV2": "创意板管理",
  "promptV4": "提示词",
  "basic_assets": "基础素材",
  "recommended_suppliers": "推荐供应商",
  "models_and_keysV2": "模型与密钥",
  "ai_configurationV2": "AI 配置",
  "ai_usageV2": "AI 用量",
  "export": "导出",
  "export_template": "导出模板",
  "loading_failedV2": "加载失败：",
  "background": "背景",
  "decoration": "装饰",
  "enter_category_nameV6": "请填写分类名",
  "category_created": "分类已创建",
  "category_renamed": "分类已重命名",
  "createV2": "create",
  "save_failedV2": "保存失败：",
  "are_you_sure_you_want_to_delete_the_category_value_and_its_official_assets": "确定删除分类「{{value}}」及其官方素材？",
  "category_deleted": "分类已删除",
  "delete_failedV2": "删除失败：",
  "image_uploaded": "图片已上传",
  "upload_failedV3": "上传失败：",
  "are_you_sure_you_want_to_delete_this_official_asset": "确定删除该官方素材？",
  "new_category": "新建分类",
  "no_images": "暂无图片",
  "create_new_value_category": "新建{{value}}分类",
  "rename_category": "重命名分类",
  "category_name": "分类名",
  "configuration_load_failedV3": "配置加载失败：",
  "overwrite_the_existing_super_admin_configuration_with_the_current_runtime_configuration_key_model_prompt": "将用当前运行配置(密钥/模型/提示词)覆盖现有超管配置，确认？",
  "current_runtime_configuration_imported": "已导入当前运行配置 ✓",
  "import_failed": "导入失败：",
  "material_recognition": "材料识别",
  "area_detection": "区域检测",
  "artistic_layout_asset_selection": "艺术排版素材选择",
  "primary_model": "主模型",
  "fallback_model": "备模型",
  "capability_name": "能力名",
  "example_deep_thinking": "如深度思考",
  "label_on_off_high": "标签（开 / 关 / high）",
  "request_fragment_json_e_g_thinking_type_enabled": "请求片段 JSON，如 {\"thinking\":{\"type\":\"enabled\"}}",
  "set": "已设置",
  "format": "格式 ✓",
  "should_start_with_sk_or_ark": "应以 sk- 或 ark- 开头",
  "testing": "测试中…",
  "connection_successful": "连接成功",
  "connection_failed": "连接失败",
  "connection_test_failed": "测试连接失败：",
  "request_failed": "请求失败",
  "enter_model_name": "请填写模型名称",
  "current_value_leave_blank_to_keep_unchanged": "当前：{{value}} 留空=不修改",
  "enter_api_key": "输入 API 密钥",
  "edit_model": "编辑模型",
  "model_name_e_g_doubao_vision": "模型名称（如豆包视觉）",
  "api_endpoint": "API 地址",
  "api_key": "API 密钥",
  "example_doubao_seed_1_6_vision_250815": "如 doubao-seed-1-6-vision-250815",
  "test_connection": "测试连接",
  "disable_value_the_following_prompts_are_using_it_value_after_disabling_they_fall_back_automatically_and_ai_calls_are_not_interrupted_confirm": "⚠ 停用「{{value}}」？以下提示词正在使用它：{{value}} 停用后会自动降级，AI 调用不会中断。确认停用？",
  "delete_value_the_following_prompts_are_using_it_value_after_deletion_these_bindings_become_invalid_and_the_runtime_falls_back_to_the_fallback_or_system_default_confirm_deletion": "⚠ 删除「{{value}}」？以下提示词正在使用它：{{value}} 删除后这些绑定将失效，运行时回退到备用 / 系统默认。确认删除？",
  "delete_model_value": "删除模型「{{value}}」？",
  "deleted_click_save_to_write_to_the_server": "已删除（点「保存」写入服务器）",
  "updated_click_save_to_write_to_the_server": "已更新（点「保存」写入服务器）",
  "savedV2": "已保存",
  "model_configuration_saved": "模型配置已保存",
  "save_failedV3": "保存失败：",
  "no_models_yet_click_add_model_below": "暂无模型，点击下方「添加模型」",
  "referenced": "被引用",
  "model_id": "模型 ID",
  "there_are_new_unsaved_keys": "有未保存的新密钥",
  "material_recognitionV2": "材料识别",
  "area_detectionV2": "区域检测",
  "artistic_layout_asset_selectionV2": "艺术排版素材选择",
  "missing_required_placeholder": "缺少必需占位符：",
  "save_failed_missing_required_placeholder": "保存失败：缺少必需占位符",
  "content_is_required": "内容不能为空",
  "prompt_content_is_required": "提示词内容不能为空",
  "savedV3": "已保存",
  "prompt_saved": "提示词已保存",
  "save_failedV4": "保存失败：",
  "failed_to_restore_defaults_no_response_from_the_server": "恢复默认失败：服务端无返回",
  "restored_to_default": "已恢复默认",
  "default_prompt_restored": "已恢复默认提示词",
  "failed_to_restore_defaults": "恢复默认失败：",
  "no_model_selected": "未选择模型",
  "this_model_has_no_available_capabilities": "该模型无可选能力",
  "do_not_enable": "（不启用）",
  "using_the_server_default_click_restore_default_to_view_the_default_content": "（使用服务端默认，点击「恢复默认」可查看默认内容）",
  "do_not_bind": "（不绑定）",
  "leave_blank_default": "留空=默认",
  "temperature": "温度",
  "recommended_suppliers_legacy_admin": "推荐供应商（老后台）",
  "select_team_none_global": "选择团队（不选=全局）",
  "failed_to_load_usage": "用量加载失败：",
  "30_days": "30 天",
  "7_days": "7 天",
  "today": "今日",
  "total_calls": "总调用数",
  "failure_rate": "失败率",
  "total_tokens": "总 Tokens",
  "loadingV2": "加载中…",
  "dimensions": "维度：",
  "metrics": "指标：",
  "no_records_yet": "暂无记录",
  "no_trend_data_yet": "暂无趋势数据",
  "value_files_exceed_25mb": "{{value}} 个超过 25MB",
  "value_files_have_unsupported_formats": "{{value}} 个格式不支持",
  "ignored_value_files": "已忽略 {{value}} 的文件",
  "no_number": "无编号",
  "modelV2": "型号",
  "no_value": "编号 {{value}}",
  "specification_value": "规格 {{value}}",
  "undone": "已撤销",
  "redone": "已重做",
  "ai_material_boardV2": "AI 材料板",
  "select_the_material_to_delete_first": "请先选中要删除的材料",
  "workbench": "工作台",
  "material_boardV2": "材料板",
  "select_v": "选择 V",
  "pan_h": "平移 H",
  "fit_to_artboard_f": "适应画板 F",
  "undo": "撤销",
  "redo": "重做",
  "ai_layout": "AI 排版",
  "ai_realistic_renderings_do_not_support_material_replacement": "AI 真实化效果图不支持替换材料",
  "off": "关",
  "number_only": "仅编号",
  "material_name_only": "仅材料名称",
  "number_material_name": "编号+材料名称",
  "exportV2": "导出",
  "png_images": "PNG 图片",
  "callout": "标注",
  "white_paperV2": "白皮书",
  "white_paper_template": "白皮书模板",
  "defaultV2": "（默认）",
  "savedV4": "已保存 ✓",
  "save_failed_try_again": "保存失败，请重试",
  "paste_imageV2": "粘贴图片",
  "ignored_value": "已忽略：{{value}}",
  "ignored_this_format_is_not_supported_yet": "已忽略：暂不支持该格式",
  "ignored_only_image_pasting_is_supported_jpg_png_gif_webp_bmp_heic_tiff": "已忽略：仅支持粘贴图片（jpg/png/gif/webp/bmp/heic/tiff）",
  "backgroundV2": "背景",
  "your_browser_does_not_support_the_eyedropper": "当前浏览器不支持吸色器",
  "custom_color": "+ 自定义颜色",
  "custom_colorV2": "▲ 自定义颜色",
  "saturation": "饱和",
  "brightness": "明度",
  "hue": "色相",
  "eyedropper": "吸色器",
  "select_or_open_a_material_board_first": "请先选中或打开一个材料板",
  "background_color_applied": "背景色已应用 ✓",
  "background_replaced": "背景已替换 ✓",
  "image_uploadedV2": "图片已上传 ✓",
  "upload_failed_value": "上传失败：{{value}}",
  "deleted": "已删除 ✓",
  "delete_failed_value": "删除失败：{{value}}",
  "solid_color_background": "纯色背景",
  "custom_colorV3": "自定义颜色",
  "no_saved_colors_yet": "暂无保存的颜色",
  "decoration_replaced": "装饰已替换 ✓",
  "decoration_added": "装饰已添加 ✓",
  "new_decoration_category_name": "新建装饰分类名称",
  "creation_failed_value": "创建失败：{{value}}",
  "rename_categoryV2": "重命名分类",
  "rename_failed_value": "重命名失败：{{value}}",
  "delete_category_value": "删除分类「{{value}}」？",
  "decoration_assets": "装饰素材",
  "category": "+ 分类",
  "renameV2": "重命名",
  "no_filter_fields_available_yet": "暂无可用筛选字段",
  "lowest": "最低",
  "highest": "最高",
  "select_service_areaV6": "请选择服务区域",
  "unnamedV2": "未命名",
  "my_space": "我的私域",
  "public_space": "公域",
  "backgroundV3": "背景",
  "decorationV2": "装饰",
  "search_for_materials": "搜索材料…",
  "clear_search": "清空搜索",
  "material_replaced": "材料已替换 ✓",
  "reference_priceV10": "参考价格",
  "back": "← 返回",
  "view_product_details": "查看产品详情",
  "this_specification_combination_is_disabledV2": "该规格组合已禁用",
  "value_automatically_selectedV2": "已自动选择 {{value}}",
  "select_valueV2": "请选择{{value}}",
  "no_imagesV2": "该规格暂无图片",
  "view_product_detailsV2": "查看产品详情",
  "recommended_suppliersV2": "推荐供应商",
  "loading_data_sourceV2": "加载数据源…",
  "failed_to_load_data_source": "数据源加载失败",
  "you_re_not_following_any_private_spaces_yet": "暂无关注的私域",
  "you_haven_t_joined_or_created_any_private_spaces_yet": "暂无加入 / 创建的私域",
  "no_data_sources_yet": "暂无数据源",
  "no_categories": "暂无分类",
  "loading_subcategories": "加载子分类…",
  "loading_products": "加载产品…",
  "no_matching_products_try_relaxing_the_filters": "无匹配产品，试试放宽筛选",
  "no_products": "该分类暂无产品",
  "select_a_subcategory_to_view_products": "选择子分类查看产品",
  "loading_more": "加载更多…",
  "source": "源",
  "service_expired": "服务到期",
  "banned_for_violation": "违规封禁",
  "no_permission_to_query": "无权限查询",
  "select_spaceV3": "选择私域",
  "regulations": "规",
  "clear": "清除",
  "this_specification_combination_is_disabledV3": "该规格组合已禁用",
  "unnamedV3": "未命名",
  "public_spaceV2": "公域",
  "failed_to_load_data_sourceV2": "数据源加载失败",
  "numbering_example_st_01_st_01_1_st_01_2_split_skus_of_the_same_material_into_sub_numbers": "编号示意：ST-01 · ST-01-1 · ST-01-2（同材料多 SKU 拆子号）",
  "numbering_example_st_01_st_02_one_row_per_material_main_number_only": "编号示意：ST-01 · ST-02（每材料一行，仅主号）",
  "export_quotation_list": "导出报价清单",
  "close": "关闭",
  "defaultV3": "（默认）",
  "material_quotation": "材料报价单",
  "there_is_no_layout_canvas_in_the_workbench": "工作台中没有排版画布",
  "all_canvases_value": "全部画布 ({{value}})",
  "value_canvases_selected": "已选 {{value}} 个画布",
  "the_material": "该材料",
  "example_open_the_material_details_page_in_the_existing_system": "（示意）打开现有系统的材料详情页：",
  "this_material_has_no_image_id": "该材料无图片标识",
  "the_default_specification_row_cannot_be_deleted": "默认规格行不可删除",
  "renumbered": "已重新编号 ✓",
  "material_information_saved": "材料信息已保存 ✓",
  "no_materials_available_for_export": "没有可导出的材料",
  "loading_template": "加载模板…",
  "select_a_quotation_template": "请选择报价模板",
  "generating_export_file": "正在生成导出文件…",
  "the_quotation_export_task_does_not_exist_or_has_expired": "报价单导出任务不存在或已过期",
  "export_completed": "导出完成 ✓",
  "quotation_export_failed": "报价单导出失败：",
  "unknown_errorV2": "未知错误",
  "timeout": "超时",
  "export_failed": "导出失败：",
  "remove_gaps_and_renumber_consecutively_in_the_current_order": "去掉空号、按当前顺序重排为连续编号",
  "total_price": "总价",
  "0_1_e_g_0_850_means_15_off": "0–1，如 0.850 表示 85 折",
  "discounted_price": "折后价",
  "by_canvas": "按画布分类",
  "by_category": "按分类",
  "by_supplier": "按供应商分类",
  "no_supplier": "未填写供应商",
  "material_quotationV2": "材料报价单",
  "material_library": "材料库",
  "material_database": "材料数据库",
  "uncategorized": "未分类",
  "material_boardV3": "材料板",
  "product_id_value": "产品id：{{value}}",
  "image_id_value": "图片标识：{{value}}",
  "name_value": "名称：{{value}}",
  "brand_value": "品牌：{{value}}",
  "supplier_value": "供应商：{{value}}",
  "primary_category_value": "一级分类：{{value}}",
  "secondary_category_value": "二级分类：{{value}}",
  "tertiary_category_value": "三级分类：{{value}}",
  "custom_field_value": "自定义字段：{{value}}",
  "spec_value": "规格：{{value}}",
  "no_supplierV2": "未填写供应商",
  "noV2": "序号",
  "noV3": "编号",
  "material_nameV3": "材料名称",
  "material_categoryV4": "材料分类",
  "canvas": "画布",
  "spec_attributes": "规格属性",
  "quantityV3": "数量",
  "unit_price_yuan": "单价（元）",
  "total_yuan": "合计（元）",
  "no_spec_selected": "未选规格",
  "drag_to_reorder": "拖拽调整编号顺序",
  "open_material_details": "打开材料详情页",
  "locate_in_material_library": "在材料库中定位",
  "click_to_select_material_attributes": "点击选择材料属性",
  "click_to_select_change_specifications": "点击选择/更改规格",
  "click_to_change_specifications": "点击更改规格",
  "edit_quantity_by_canvas": "按画布编辑数量",
  "delete_this_spec_row": "删除此规格行",
  "this_material_has_only_one_specification_left_and_cannot_be_deleted": "该材料仅剩一条规格，无法删除",
  "subtotal": "小计",
  "material_replacedV2": "材料已替换 ✓",
  "material_replaced_globally_value_occurrences": "材料已全局替换 ✓（{{value}} 处）",
  "replace_material": "替换材料",
  "new_material": "新材料",
  "single_replacement": "单个替换",
  "rectangle": "矩形",
  "square": "正方形",
  "circle": "正圆",
  "ellipse": "椭圆",
  "triangle": "三角形",
  "rhombus": "菱形",
  "trapezoid": "梯形",
  "hexagon": "六边形",
  "locate_material": "定位材料",
  "noV4": "编号",
  "uncategorizedV2": "未分类",
  "select_product_specifications": "请选择产品规格",
  "select_a_material_first": "请先选中一个材料",
  "click_any_material_in_the_material_library_to_replace_the_image": "在材料库中点击任意材料替换图片",
  "select_a_decoration_first": "请先选中一个装饰物",
  "click_any_decoration_in_the_decoration_asset_library_to_replace_it": "在装饰素材库中点击任意装饰物替换",
  "click_asset": "点击素材",
  "size_and_position": "尺寸与位置",
  "width": "宽",
  "height": "高",
  "ratio": "比例",
  "material_callouts_in_the_product_library_cannot_be_edited": "产品库内材料的标注不可编辑",
  "image_name": "图片名称…",
  "replace_materialV2": "替换材料",
  "cutting_outV2": "抠图中…",
  "ai_cutout": "AI 抠图",
  "replace_decoration": "替换装饰物",
  "images": "张图片",
  "canvas_list": "画布列表",
  "search_canvases": "搜索画布…",
  "clear_searchV2": "清空搜索",
  "no_related_canvas_found_for_value": "未找到「{{value}}」相关画布",
  "no_material_boards_yet": "暂无材料板",
  "unnamedV4": "未命名",
  "value_double_click_to_locate": "{{value}} · 双击定位",
  "material_boardV4": "材料板",
  "widthV2": "宽",
  "heightV2": "高",
  "enter_edit_mode": "进入编辑",
  "ai_relayout": "AI 重新排版",
  "ai_realistic_material_board": "AI 真实化材料板",
  "layout": "版面设置",
  "background_image_adjustment": "背景图调整",
  "horizontal": "左右",
  "show_material_callouts": "显示材料标注",
  "show_material_numbers": "显示材料编号",
  "grid_layout": "网格排版",
  "rows": "行",
  "widthV3": "宽",
  "automatic": "自动",
  "heightV3": "高",
  "background_image_effect": "背景图效果",
  "brightnessV2": "明暗",
  "unnamedV5": "未命名",
  "ai_material_boardV3": "AI 材料板",
  "uncategorizedV3": "未分类",
  "material_information_number": "材料信息 / 编号",
  "locate_this_product_card_in_the_material_library": "在材料库中定位该产品卡片",
  "select_product_specificationsV2": "请选择产品规格",
  "apply_canvas": "应用画布",
  "unnamedV6": "未命名",
  "asset_images": "素材图片",
  "heightV4": "高",
  "image_nameV2": "图片名称…",
  "material_callouts_in_the_product_library_cannot_be_editedV2": "产品库内材料的标注不可编辑",
  "loading_data_sourceV3": "数据源加载中…",
  "loadingV3": "加载中…",
  "ai_recognition": "AI 识别",
  "view_properties_here": "在此查看属性",
  "ai_realistic_renderings_do_not_support_material_replacementV2": "AI 真实化效果图不支持替换材料",
  "generating_material_board_please_wait": "材料板正在生成中，请稍候…",
  "value_images_value": "{{value}} 张图片{{value}}",
  "multi_select": "多选",
  "loading_data_sourceV4": "数据源加载中…",
  "loadingV4": "加载中…",
  "ai_recognitionV2": "AI 识别",
  "rectangleV2": "矩形",
  "heightV5": "高",
  "line_width": "线宽",
  "text": "文字",
  "failed_to_save_project_name_please_try_again": "项目名保存失败，请重试",
  "create_new_material_board": "新建材料板",
  "fit_all_f": "适应全部 F",
  "form_mode": "表单模式",
  "workbench_mode": "工作台模式",
  "exportV3": "导出",
  "select_vV2": "选择 V",
  "pan_hV2": "平移 H",
  "connector_c": "连线 C",
  "rectangle_r": "矩形框 R",
  "text_t": "文字 T",
  "undo_z": "撤销 ⌘Z",
  "redo_z": "重做 ⌘⇧Z",
  "duplicate": "副本",
  "ai_material_boardV4": "AI 材料板",
  "undoneV2": "已撤销",
  "redoneV2": "已重做",
  "duplicated": "已复制副本 ✓",
  "connector_deleted": "连线已删除",
  "ai_realistic_renderings_cannot_be_dragged_into_a_material_board": "AI 真实化效果图不能拖入材料板",
  "copied_to_layout_canvas": "已复制到排版画布 ✓",
  "decoration_addedV2": "装饰已添加 ✓",
  "generating_ai_realistic_image": "正在 AI 真实化",
  "generating_material_board_please_waitV2": "材料板正在生成中，请稍候…",
  "savedV5": "已保存 ✓",
  "save_failed_try_againV2": "保存失败，请重试",
  "select_a_material_or_material_board_first": "请先选中材料或材料板",
  "rendering_value_items_for_export": "正在渲染导出 {{value}} 项…",
  "export_completedV2": "导出完成 ✓",
  "export_timed_out_please_reduce_the_number_and_try_again": "导出超时，请减少数量后重试",
  "png_export_failed": "PNG 导出失败：",
  "select_the_material_board_to_export_first": "请先选中要导出的材料板",
  "the_selected_material_board_contains_no_materials_so_the_list_cannot_be_exported": "选中的材料板里没有资材，无法导出清单",
  "generating_export_fileV2": "正在生成导出文件…",
  "material_list_xlsx": "材料清单.xlsx",
  "export_timed_out_please_try_again": "导出超时，请重试",
  "material_list_export_failed": "材料清单导出失败：",
  "the_selected_material_board_has_no_materials": "选中材料版中没有材料",
  "material_quotationV3": "材料报价单",
  "the_quotation_export_task_does_not_exist_or_has_expiredV2": "报价单导出任务不存在或已过期",
  "quotation_export_failedV2": "报价单导出失败：",
  "unknown_errorV3": "未知错误",
  "failed_to_generate_the_screenshot_for_material_board_value_skipped": "材料板「{{value}}」截图生成失败，已跳过",
  "no_exportable_material_board_screenshot_or_material_parsing_failed": "没有可导出的材料板（截图或资材解析均失败）",
  "the_white_paper_has_skipped_value_material_elements_value_that_are_missing_required_fields": "白皮书已跳过 {{value}} 个缺少必填字段的材料元素{{value}}",
  "material_white_paper": "材料白皮书",
  "the_white_paper_export_task_does_not_exist_or_has_expired": "白皮书导出任务不存在或已过期",
  "the_white_paper_has_been_generated_and_will_be_downloaded_soon": "白皮书生成完成，即将开始下载",
  "white_paper_generation_failed": "白皮书生成失败：",
  "white_paper_export_failed": "白皮书导出失败：",
  "materialname_is_missing": "缺少 materialName",
  "toptypename_is_missing": "缺少 topTypeName",
  "delete_connector": "删除连线",
  "create_new_material_boardV2": "新建材料板",
  "enter_edit_modeV2": "进入编辑",
  "ai_relayoutV2": "AI 重新排版",
  "value_files_exceed_25mbV2": "{{value}} 个超过 25MB",
  "value_files_have_unsupported_formatsV2": "{{value}} 个格式不支持",
  "ignored_value_filesV2": "已忽略 {{value}} 的文件",
  "drag_onto_the_material_board_to_add_a_decoration": "请拖到材料板上添加装饰物",
  "drag_assets_from_the_material_library_or_drag_in_image_files_directly": "从材料库拖拽素材，或直接拖入图片文件",
  "right_click_to_create_a_new_material_board": "右键可新建材料板",
  "selected": "个已选",
  "ai_realistic_renderings": "AI 真实化效果图",
  "unnamedV7": "未命名",
  "name_valueV2": "名称 {{value}}",
  "modelV3": "型号",
  "specification_valueV2": "规格 {{value}}",
  "price_value": "价格 {{value}}",
  "ai_material_boardV5": "AI 材料板",
  "double_click_to_edit": "双击编辑",
  "unnamed_project": "未命名项目",
  "material_inspiration": "材料灵感",
  "search_projects": "搜索项目…",
  "clear_searchV3": "清空搜索",
  "project_name": "项目名称…",
  "drag": "拖拽",
  "pin": "固定位置",
  "unpin": "取消固定",
  "design_styleV2": "设计风格",
  "originV8": "产地",
  "reference_priceV11": "参考价格",
  "experience": "经验",
  "nodeV4": "节点",
  "inspection_certificate": "检验证书",
  "open_this_link_on_a_computer": "请使用电脑打开链接",
  "add_planetV2": "星球添加",
  "onboarding_information": "入驻信息",
  "enter_material_name_color_name": "请填写材料名称/颜色名称",
  "draftV3": "草稿",
  "reject_applicationV2": "驳回申请",
  "unpublishedV2": "已下架",
  "use_casesV4": "应用场景",
  "airportV4": "机场",
  "railway_stationV4": "火车站",
  "shopping_mall_supermarketV4": "购物中心/超市",
  "plazaV4": "广场",
  "hotelV4": "酒店",
  "museum_exhibition_hallV4": "博物馆/展览馆",
  "theater_ktvV4": "剧院/KTV",
  "office_buildingV4": "写字楼",
  "schoolV4": "学校",
  "hospitalV4": "医院",
  "restaurantV4": "餐厅",
  "house_villaV4": "住宅/别墅",
  "poolV4": "泳池",
  "sports_fieldV4": "操场",
  "within_one_yearV5": "一年内",
  "more_than_one_yearV5": "一年以上",
  "material_originV2": "材料产地",
  "reference_priceV12": "参考价格",
  "reason_for_unpublishingV3": "下架原因：",
  "unlikeV2": "取消喜欢",
  "bulk_deletion_completed": "批量删除成功",
  "upgrading_data_to_adapt_to_new_creative_board_features_please_wait": "正在升级数据以适配创意板新功能，请稍候…",
  "updating_numbering": "正在更新序号",
  "no_renumbering_needed": "无需更新序号",
  "white_paperV3": "白皮书",
  "the_color_swatch_image_is_empty_and_cannot_be_exported": "色块图片为空，无法导出",
  "export_failedV2": "导出失败",
  "export_failed_contact_your_administrator": "导出失败，请联系管理员处理",
  "cancel_export": "取消导出",
  "unnamed_projectV2": "未命名项目",
  "your_work_is_saved_automatically_are_you_sure_you_want_to_exit": "系统将自动保存你的创作，确认退出吗？",
  "creative": "创意",
  "project": "项目",
  "unnamed_project_value": "未命名项目_{{value}}",
  "create_project": "创建项目",
  "export_white_paper": "导出白皮书",
  "select_spaceV4": "请选择空间",
  "select_a_template_to_export": "请选择模板导出",
  "exporting_please_wait": "正在导出请稍候…",
  "customV2": "定制",
  "contact_supportV3": "请联系客服",
  "are_you_sure_you_want_to_cancel_the_export": "确认取消导出吗？",
  "exporting_please_waitV2": "正在导出请稍候…",
  "exported": "导出成功",
  "if_the_download_does_not_start_automatically_please": "如果下载未自动开始，请",
  "project_list": "项目列表",
  "search_projectsV2": "搜索项目",
  "delete_this_project_and_its_related_information": "确认删除该项目及相关信息吗？",
  "the_image_has_not_finished_uploading": "图片还未上传成功",
  "upload_an_image_and_enter_a_category_name_first": "请先上传图片并输入分类名称",
  "backgroundV4": "背景",
  "accent": "点缀",
  "enter_category": "输入分类*",
  "category_deletedV2": "删除分类成功",
  "failed_to_delete_category": "删除分类失败",
  "are_you_sure_you_want_to_delete_valueV2": "确定删除{{value}}吗？",
  "value_deleted": "{{value}}删除成功",
  "official_selection": "官方精选",
  "user_upload": "用户上传",
  "search_assets": "搜索素材",
  "adjust_texture_scale": "调整贴图比例",
  "spaceV3": "空间",
  "quantityV4": "数量",
  "nameV6": "name",
  "finished_productV4": "成品",
  "noV5": "编号",
  "enter_product_nameV4": "请填写产品名称",
  "modelV4": "型号",
  "enter_modelV2": "请填写型号",
  "unknown_category": "未知分类",
  "enter_specificationsV2": "请填写规格",
  "spaceV4": "空间",
  "quantityV5": "数量",
  "unit_price": "单价",
  "enter_unit_price": "请填写单价",
  "enter_brand": "请填写品牌",
  "enter_supplierV2": "请填写供应商",
  "select_unitV2": "请选择单位",
  "export_product_list": "导出产品清单",
  "are_you_sure_you_want_to_cancel_the_exportV2": "确认取消导出吗？",
  "exportedV2": "导出成功",
  "export_failedV3": "导出失败",
  "if_the_download_does_not_start_automatically_pleaseV2": "如果下载未自动开始，请",
  "product_list": "产品清单",
  "save_changes": "是否需要保存",
  "exportedV3": "导出成功",
  "export_failedV4": "导出失败",
  "product_listV2": "产品清单",
  "exportV4": "导出",
  "categoryV2": "品类",
  "spaceV5": "空间",
  "discountV3": "折扣：",
  "tip_when_grouping_by_category_drag_products_within_a_group_to_change_their_order_note_products_are_numbered_in_order_so_reordering_also_changes_the_numbers": "tips：按品类分组时，在分组内拖拽产品以调整产品顺序（注意：产品按编号排序，调整顺序将同时调整编号）",
  "tip_drag_groups_to_change_their_order": "tips：拖拽分组以调整分组顺序",
  "noV6": "编号",
  "subtotalV2": "小计：",
  "quantityV6": "数量",
  "enter_quantity": "请填写数量",
  "unknown_supplier": "未知供应商",
  "noV7": "编号",
  "subtotalV3": "小计：",
  "noV8": "编号",
  "subtotalV4": "小计：",
  "failed_to_get_image": "获取图片失败",
  "unknown_supplierV2": "未知供应商",
  "materialV6": "材料",
  "already_at_the_front": "已经在最顶层了",
  "already_at_the_back": "已经在最底层了",
  "materialV7": "材料",
  "adjust_texture_scaleV2": "调整贴图比例",
  "move_up_one_level": "上移一层",
  "move_down_one_level": "下移一层",
  "move_to_front": "移到顶层",
  "move_to_back": "移到底层",
  "enter_a_category_name_first": "请先输入分类名称",
  "save_background_image": "保存背景图",
  "enter_categoryV2": "输入分类*",
  "projection_type": "投影类型",
  "ground": "地面",
  "top_surface": "顶面",
  "materialV8": "材料",
  "rectangleV3": "矩形",
  "round": "圆形",
  "hexagonV2": "六边形",
  "trapezoidV2": "梯形",
  "undoV2": "撤销",
  "redoV2": "重做",
  "cutout": "抠图",
  "shadow": "阴影",
  "reflection": "倒影",
  "flip_horizontal": "左右镜像",
  "flip_vertical": "上下镜像",
  "global_projection": "全局投影",
  "projection_length": "投影长度",
  "global_shadow": "全局阴影",
  "product_number": "产品编号",
  "canvas_ratio": "画布比例",
  "fit_to_background_image": "适应背景图",
  "canvasV2": "画布",
  "your_work_is_saved_automatically_are_you_sure_you_want_to_exitV2": "系统将自动保存你的创作，确认退出吗？",
  "search_teamV2": "搜索团队",
  "productsV3": "私域产品",
  "followingV2": "我的关注",
  "main_product_image": "产品主图",
  "materialV9": "材料",
  "all_value": "所有{{value}}",
  "materialV10": "材料",
  "move_up_one_levelV2": "上移一层",
  "move_down_one_levelV2": "下移一层",
  "move_to_frontV2": "移到顶层",
  "move_to_backV2": "移到底层",
  "delete": "Delete",
  "i_have_renewed": "我已续费",
  "checking_private_space_plan_status": "正在检测私域套餐状态",
  "accentV2": "点缀",
  "backgroundV5": "背景",
  "delete_this_space_and_its_related_information": "确认删除该空间及相关信息吗？",
  "regenerating_value_artboard": "正在重新生成{{value}}画板",
  "unknown_product": "未知产品",
  "unknown_product_value": "未知产品{{value}}",
  "finished_productV5": "成品",
  "uploading_background": "背景上传中",
  "failed_to_get_imageV2": "获取图片失败",
  "materialV11": "材料",
  "equipmentV4": "设备",
  "are_you_sure_you_want_to_reset": "你确定要重置吗？",
  "copying_image_addresses_from_third_party_websites_is_not_supported": "不支持复制第三方网站图片地址",
  "processing_images_please_wait": "正在处理图片，请稍候…",
  "no_extractable_object_was_found": "未能识别出可供提取的物体",
  "materialV12": "材料",
  "add_to_my_materialsV2": "加入我的材料",
  "you_cannot_add_your_own_material": "您不能添加自己的材料",
  "this_material_has_already_been_added": "材料已添加，不能重复添加",
  "add_to_comparisonV2": "加对比",
  "different_categories_cannot_be_comparedV2": "不同分类不能加入对比",
  "all_materials": "所有材料",
  "brand_categoryV2": "品牌分类",
  "use_casesV5": "应用场景",
  "airportV5": "机场",
  "railway_stationV5": "火车站",
  "shopping_mall_supermarketV5": "购物中心/超市",
  "plazaV5": "广场",
  "hotelV5": "酒店",
  "museum_exhibition_hallV5": "博物馆/展览馆",
  "theater_ktvV5": "剧院/KTV",
  "office_buildingV5": "写字楼",
  "schoolV5": "学校",
  "hospitalV5": "医院",
  "restaurantV5": "餐厅",
  "house_villaV5": "住宅/别墅",
  "poolV5": "泳池",
  "sports_fieldV5": "操场",
  "within_one_yearV6": "一年内",
  "more_than_one_yearV6": "一年以上",
  "material_originV3": "材料产地",
  "reference_priceV13": "参考价格",
  "all_categoriesV4": "所有分类",
  "pull_to_load": "下拉加载",
  "content": "内容",
  "pinned_card": "置顶卡片",
  "unfollow": "取消关注",
  "no_contact_information_available": "暂无联系方式",
  "not_available": "内容未开放",
  "select_a_member": "请选择成员",
  "no_members_available_to_reassign_to": "暂无可转单的成员",
  "select_a_member_to_handle_it": "请选择处理的成员",
  "pending": "待处理",
  "processed": "已处理",
  "ignoredV3": "已忽略",
  "quotation": "报价单",
  "order_reassigned": "转单成功",
  "generate_quotation": "生成报价单",
  "select_template": "选择模板",
  "official_template": "官方模板",
  "customV3": "定制",
  "contact_supportV4": "请联系客服",
  "material_nameV4": "材料名称",
  "quantityV7": "数量",
  "enter_quantityV2": "请填写数量",
  "unit_priceV2": "单价",
  "the_unit_price_cannot_be_less_than_1": "单价不能小于1",
  "enter_unit_priceV2": "请填写单价",
  "material_nameV5": "材料名称",
  "modelV5": "型号",
  "enter_modelV3": "请填写型号",
  "enter_specificationsV3": "请填写规格",
  "select_unitV3": "请选择单位",
  "quantityV8": "数量",
  "enter_quantityV3": "请填写数量",
  "unit_priceV3": "单价",
  "the_unit_price_cannot_be_less_than_1V2": "单价不能小于1",
  "enter_unit_priceV3": "请填写单价",
  "no_specifications_yet": "暂无规格",
  "select_specifications": "请选择规格",
  "activeV4": "正常",
  "this": "该",
  "this_product_has_been_unpublished": "产品已被下架",
  "enter_the_total_price_of_the_materials": "请完善材料的合计价格",
  "set_discount": "设置折扣：",
  "discount_cannot_exceed_1": "折扣不能超过1",
  "discount_must_exceed_0": "折扣要大于0",
  "number_of_materials": "材料数：",
  "total_priceV2": "总价：",
  "discounted_priceV2": "折扣价：",
  "quotationV2": "报价单",
  "exportedV4": "导出成功",
  "processingV2": "处理中",
  "replied": "已回复",
  "inquiry_recipient": "咨询对象",
  "product_countV2": "产品数量",
  "activeV5": "正常",
  "thisV2": "该",
  "this_product_has_been_unpublishedV2": "产品已被下架",
  "download_quotation": "下载报价单",
  "draftV4": "草稿",
  "not_approvedV2": "未过审",
  "expiring_soon": "即将失效",
  "closedV3": "已关闭",
  "new_participation": "新参与",
  "1_month": "1个月",
  "2_months": "2个月",
  "3_months": "3个月",
  "4_months": "4个月",
  "5_months": "5个月",
  "6_months": "6个月",
  "7_months": "7个月",
  "8_months": "8个月",
  "9_months": "9个月",
  "10_months": "10个月",
  "11_months": "11个月",
  "12_months": "12个月",
  "enter_a_valid_mobile_or_landline_numberV2": "请填写正确的手机号或固定电话",
  "enter_a_valid_email_addressV4": "请填写正确的邮箱",
  "edit_contact_informationV2": "修改联系方式",
  "enter_at_least_one_contact_methodV2": "请至少填写一项联系方式",
  "enter_the_contact": "请填写联系人",
  "enter_phone_numberV3": "请填写电话",
  "enter_email_addressV2": "请填写电子邮箱",
  "enter_wechat_name": "请填写微信名",
  "adjust_validity_periodV2": "调整有效期",
  "card_expiryV5": "卡片时效",
  "select_validity_period": "请选择调整有效期",
  "republish": "重新发布",
  "set_card_expiry": "设置卡片时效",
  "set_card_expiry_date": "请设置卡片时效",
  "official_site_builder": "官网搭建",
  "generate_portfolio_product_catalog": "生成作品集/产品册",
  "business_partner_circle": "商业伙伴圈",
  "wechat_mini_program": "微信小程序",
  "helpV2": "帮助",
  "build_a_brand_personal_enterprise_website_with_zero_code": "零代码搭建品牌（个人/企业）网站",
  "build_a_personalized_brand_official_site_without_a_single_line_of_code": "无需一行代码，个性化搭建品牌官网",
  "stunning_visual_aesthetics_with_multi_language_support_for_global_expansion": "视觉美学精彩呈现，支持多语言助力全球出海",
  "responsive_on_desktop_and_mobile_launch_your_brand_s_official_site_fast": "电脑与手机自适应，快速上线品牌官网",
  "generate_a_bespoke_portfolio_product_catalog": "生成高定作品集/产品册",
  "upload_once_and_get_a_digitized_structured_library_of_your_works_and_products": "上传即拥有数据化、结构化的美学作品/产品库",
  "share_by_link_with_no_tedious_image_production_or_huge_files_taking_up_space": "链接可分享，避免图片的繁杂制作和庞大文件的空间占用",
  "no_manual_layout_work_aesthetic_layouts_are_generated_automatically_and_can_be_freely_categorized": "无需手动转版，自动生成美学版式，可自由分类",
  "set_sharing_content_automatically_and_track_the_entire_sharing_process": "自动设置分享内容，分享全程可追踪",
  "multi_language_support_with_automatic_adaptation_to_desktop_tablet_mobile_large_screens_and_more": "多语言支持，自动适配电脑、Pad、手机、大屏等端口",
  "business_circle_business_partner_circle": "商业圈-商业伙伴圈",
  "traffic_between_private_spaces_gain_mutual_brand_and_product_exposure_with_the_business_partners_you_have_connected_with": "私域间引流：可与自己建联的商业伙伴圈，相互实现品牌、产品曝光",
  "quickly_generate_branded_wechat_mini_programs": "快速生成品牌微信小程序",
  "no_code_required_we_generate_a_wechat_mini_program_with_your_own_branding_and_refined_visuals_in_no_time": "无需代码，为你快速生成专属品牌、精美视觉的微信小程序",
  "bujue_zero_code_brand_website_builder_private_space_trading_tool": "不觉 — 0 代码搭建品牌网站 · 私域交易工具",
  "get_the_app": "获取APP",
  "menu": "菜单",
  "closeV2": "关闭",
  "enter_private_space": "进入私域",
  "let_every_creator_and_every_enterprise": "让每一个创作者、每一个企业",
  "have_a_brand_home_of_their_own": "都有自己的品牌阵地",
  "build_a_brand_website_with_zero_code": "零代码搭建品牌网站",
  "portfolio_product_catalog": "作品集/产品册",
  "new_business_tools_for_private_space": "私域新商业工具",
  "use_now": "立即使用",
  "contact_usV2": "联系我们",
  "bujue_features": "不觉功能",
  "what_bujue_does": "不觉做什么",
  "dedicated_to_the_design_home_furnishings_and_building_materials_and_wider_aesthetics_industries": "专注服务于设计、家居建材及泛美学行业",
  "china_s_first_luxury_home_design_and_construction_consulting_company": "中国首家豪宅设计建造顾问企业",
  "consulting_firm_for_the_design_and_construction_of_private_mansions": "Consulting firm for the design and construction of private mansions",
  "service_case": "服务案例",
  "case_showcase": "案例展示",
  "case_value": "案例 {{value}}",
  "partner_links": "友情链接",
  "design_dedao": "设计得到",
  "archbase_building_materials_supply_chain": "ARCHBASE建材供应链",
  "help_support": "支持帮助",
  "2026_hangzhou_bujue_technology_co_ltd": "© 2026 杭州不觉科技有限公司",
  "zhejiang_icp_no_17033477_5V2": "浙ICP备17033477号-5",
  "support_qr_codeV2": "客服二维码",
  "free_to_use": "免费使用",
  "individual_small_team": "个人/小型团队",
  "medium_team": "中型团队",
  "large_team": "大型团队",
  "try_bujue_for_free": "免费体验不觉",
  "free_plan": "免费方案",
  "core_services_start_at_zero_cost": "核心基础服务，零成本启动",
  "free_trial_with_500mb_storage_capacity": "免费体验500MB存储容量",
  "create_websites_and_portfolios_for_free": "免费体验创建网站、作品集功能",
  "basic_business_card": "基础名片",
  "basic": "个人基础版",
  "personal_plan": "个人方案",
  "suitable_for_individuals_and_independent_creators_who_need_a_website_without_product_display_or_transaction_features": "适合个人、独立创作者等建站需求，无商品展示交易功能",
  "10gb_storage_capacity": "10GB存储容量",
  "custom_bujue_subdomain": "自定义不觉二级域名",
  "basic_website_and_portfolio_features": "网站、作品集基础功能",
  "for_personal_use_only": "仅限个人使用",
  "contact_usV3": "联系我们",
  "standard": "企业标准版",
  "team_plan": "团队方案",
  "suitable_for_small_teams_and_studios_with_product_display_features": "适合小型团队、工作室等，有商品展示功能",
  "50gb_storage_capacity": "50GB存储容量",
  "custom_domain_redirection_service": "自有域名重定向服务",
  "no_limit_on_team_size": "团队人数不限制",
  "complete_website_portfolio_and_product_library_functions": "完整的网站、作品集、产品库功能",
  "bilingual_cn_en": "中英双语支持",
  "professional": "企业专业版",
  "suitable_for_medium_sized_merchants_and_enterprises_with_product_display_and_transaction_features": "适合中型商家、企业等，有商品展示和交易功能",
  "200gb_storage_capacity": "200GB存储容量",
  "transactions_supported_in_development": "支持交易功能（开发中）",
  "export_file_template_customization": "导出文件模板定制",
  "product_qr_code_customization_service": "产品二维码定制服务",
  "business_card_customization": "名片定制",
  "website_visual_customization_service": "网站视觉定制服务",
  "assisted_upload_service_for_works_and_products": "作品 / 产品人工上传服务",
  "online_offline_training": "线上 / 线下培训",
  "rendering_optimization": "效果图优化",
  "exclusive_brand_space": "专属品牌空间",
  "build_a_brand_website_with_zero_code_individual_enterprise": "零代码搭建品牌网站（个人/企业）",
  "portfolio_product_catalogV2": "作品集/产品册",
  "new_business_tools_for_private_spaceV2": "私域圈新商业工具",
  "get_the_plan_now": "立即获取方案",
  "switch_plan": "套餐切换",
  "other_services": "其他服务",
  "from_brand_domains_to_export_templates_we_offer_both_standardized_and_deep_customization_and_lower_the_barrier_to_entry_with_assisted_upload_professional_training_and_more": "从品牌域名到导出模板，提供标准化与深度定制服务；降低使用门槛，提供上传托管、专业培训等服务",
  "bujue_zero_code_brand_website_builder_private_space_trading_toolV2": "不觉 — 0 代码搭建品牌网站 · 私域交易工具",
  "website_builder": "网站搭建",
  "portfolio_product_catalogV3": "作品集/产品册",
  "business_circle": "商业圈子",
  "wechat_mini_programV2": "微信小程序",
  "helpV3": "帮助",
  "enter_private_spaceV2": "进入私域",
  "free_registration": "免费注册",
  "no_code": "零代码",
  "aesthetic_visuals": "美学视觉",
  "multi_language_support": "多语言支持",
  "responsive_on_desktop_and_mobile": "电脑 / 移动双端自适应",
  "china_s_first_luxury_home_design_and_construction_consulting_companyV2": "中国首家豪宅设计建造顾问企业",
  "consulting_firm_for_the_design_and_construction_of_private_mansionsV2": "Consulting firm for the design and construction of private mansions",
  "click_the_highlighted_area_in_the_top_bar": "点击顶栏示意区域",
  "click_the_highlighted_products_area": "点击「产品」示意区域",
  "portfolio_product_catalogV4": "作品集 / 产品册",
  "generate_a_bespoke_portfolio_product_catalogV2": "生成高定作品集/产品册",
  "upload_once_and_get_a_digitized_structured_library_of_your_works_and_productsV2": "上传即拥有数据化、结构化的美学作品/产品库",
  "share_by_link_with_no_tedious_catalog_production_or_huge_files_taking_up_space": "链接可分享，避免图册的繁杂制作和庞大文件的空间占据",
  "no_manual_layout_work_aesthetic_layouts_are_generated_automatically_and_can_be_freely_categorizedV2": "无需手动排版，自动生成美学版式，可自由分类",
  "set_sharing_content_yourself_and_track_the_entire_sharing_process": "自助设置分享内容，分享全程可追踪",
  "multi_language_support_with_automatic_adaptation_to_desktop_tablet_mobile_large_screens_and_moreV2": "多语言支持，自动适配电脑、Pad、手机、大屏等端口",
  "space_traffic": "私域引流",
  "brand_exposure": "品牌曝光",
  "click_the_highlighted_business_circle_area": "点击商业圈子示意区域",
  "click_the_highlighted_partner_network_area": "点击伙伴网络示意区域",
  "quickly_generate_branded_wechat_mini_programsV2": "快速生成品牌微信小程序",
  "previous": "上一个",
  "next": "下一个",
  "use_casesV6": "应用场景",
  "how_to_use_bujue": "不觉怎么用",
  "3_500_teams_and_businesses_have_made_bujue_part_of_their_daily_work_turning_every_share_and_every_link_into_value": "3500+团队/企业已将不觉融入日常办公，让每一次分享、每一次链接都产生价值",
  "play_video": "播放视频",
  "contact_usV4": "联系我们",
  "wechat_official_account_qr_code": "微信公众号二维码",
  "xiaohongshu_qr_code": "小红书二维码",
  "partner_linksV2": "友情链接",
  "design_dedaoV2": "设计得到",
  "project_management_tools": "项目管理工具",
  "furniture_materials": "家具建材广场",
  "archbase_building_materials_supply_chainV2": "ARCHBASE建材供应链",
  "bujue_featuresV2": "不觉功能",
  "help_supportV2": "支持帮助",
  "zhejiang_icp_no_17033477_5V3": "浙ICP备17033477号-5",
  "wechat_support_qr_code": "微信客服二维码",
  "try_bujue_for_freeV2": "免费体验不觉",
  "free_planV2": "免费方案",
  "core_services_start_at_zero_costV2": "核心基础服务，零成本启动",
  "free_trial_with_500mb_storage_capacityV2": "免费体验500MB存储容量",
  "create_websites_and_portfolios_for_freeV2": "免费体验创建网站、作品集功能",
  "basic_business_cardV2": "基础名片",
  "free_to_useV2": "免费使用",
  "basicV2": "个人基础版",
  "personal_planV2": "个人方案",
  "suitable_for_individuals_and_independent_creators_who_need_a_website_without_product_display_or_transaction_featuresV2": "适合个人、独立创作者等建站需求，无商品展示交易功能",
  "10gb_storage_capacityV2": "10GB存储容量",
  "custom_bujue_subdomainV2": "自定义不觉二级域名",
  "basic_website_and_portfolio_featuresV2": "网站、作品集基础功能",
  "for_personal_use_onlyV2": "仅限个人使用",
  "standardV2": "企业标准版",
  "team_planV2": "团队方案",
  "suitable_for_small_teams_and_studios_with_product_display_featuresV2": "适合小型团队、工作室等，有商品展示功能",
  "50gb_storage_capacityV2": "50GB存储容量",
  "custom_domain_redirection_serviceV2": "自有域名重定向服务",
  "no_limit_on_team_sizeV2": "团队人数不限制",
  "complete_website_portfolio_and_product_library_functionsV2": "完整的网站、作品集、产品库功能",
  "bilingual_cn_enV2": "中英双语支持",
  "professionalV2": "企业专业版",
  "suitable_for_medium_sized_merchants_and_enterprises_with_product_display_and_transaction_featuresV2": "适合中型商家、企业等，有商品展示和交易功能",
  "200gb_storage_capacityV2": "200GB存储容量",
  "transactions_supported_in_developmentV2": "支持交易功能（开发中）",
  "399_year": "￥399 /年",
  "299_year": "299 元/年",
  "699_year": "￥699 /年",
  "499_year": "499 元/年",
  "999_year": "￥999 /年",
  "799_year": "799 元/年",
  "1899_year": "￥1899 /年",
  "1499_year": "1499 元/年",
  "5499_year": "￥5499 /年",
  "3899_year": "3899 元/年",
  "19999_year": "￥19999 /年",
  "9999_year": "9999 元/年",
  "export_file_template_customizationV2": "导出文件模板定制",
  "product_qr_code_customization_serviceV2": "产品二维码定制服务",
  "business_card_customizationV2": "名片定制",
  "website_visual_customization_serviceV2": "网站视觉定制服务",
  "assisted_upload_service_for_works_and_productsV2": "作品 / 产品人工上传服务",
  "online_offline_trainingV2": "线上 / 线下培训",
  "rendering_optimizationV2": "效果图优化",
  "contact_usV5": "联系我们",
  "other_servicesV2": "其他服务",
  "from_brand_domains_to_export_templates_we_offer_both_standardized_and_deep_customization_and_lower_the_barrier_to_entry_with_assisted_upload_professional_training_and_moreV2": "从品牌域名到导出模板，提供标准化与深度定制服务；降低使用门槛，提供上传托管、专业培训等服务",
  "10_000_individuals_and_3_500_team_and_business_users_are_using_bujue": "10000+个⼈、3500+团队/企业⽤户正在使⽤不觉",
  "opening_the_app_please_wait": "正在打开APP，请稍等",
  "service_hours_9_00_17_30": "服务时间：9:00-17:30",
  "consultation_analysis_and_answers": "问题咨询、分析、解答",
  "pairing_recommendations_and_usage_tips": "搭配推荐及应用建议",
  "configuration_list": "配置清单",
  "members_only_privileges": "会员专享特权",
  "membership_rulesV4": "会员规则",
  "payment_countdown": "付款倒计时：",
  "become_a_member": "开通会员",
  "payment_status": "支付状态",
  "view_my_membership": "查看我的会员",
  "modern_style": "现代风格",
  "villa": "别墅",
  "works_library": "作品库",
  "publish_work": "发作品",
  "value_is_not_an_imageV10": "{{value}} 不是图片",
  "other_fields": "其他字段",
  "no_product_information": "没有产品信息",
  "related_works": "相关作品",
  "shared_productV3": "产品分享",
  "removed_from_favoritesV3": "取消收藏成功",
  "added_to_favoritesV5": "收藏成功",
  "product_unavailable": "商品失效",
  "other_fieldsV2": "其他字段",
  "total_value_itemsV8": "共{{value}}条数据",
  "emptyV3": "空",
  "reference_priceV14": "参考价格",
  "other_contact_details": "其他联系方式",
  "other_fieldsV3": "其他字段",
  "other_fieldsV4": "其他字段",
  "all_certificates": "所有证书",
  "all_accessories": "所有配件",
  "all_nodes": "所有节点",
  "other_fieldsV5": "其他字段",
  "add_to_comparisonV3": "加入对比",
  "add_failedV2": "添加失败",
  "request_sampleV2": "申请小样",
  "my_product_library": "我的产品库",
  "related_worksV2": "相关作品",
  "customizableV3": "可定制",
  "material_libraryV2": "材料库",
  "device_library": "设备库",
  "finished_product_library": "成品库",
  "device_libraryV2": "设备库",
  "curatedV10": "严选",
  "material_libraryV3": "材料库",
  "curatedV11": "严选",
  "finished_productV6": "成品",
  "globalV4": "全球",
  "reference_priceV15": "参考价格",
  "views_ascending": "浏览量-正序",
  "views_descending": "浏览量-倒序",
  "name_a_z": "名称A→Z",
  "name_z_a": "名称Z→A",
  "this_private_space_has_been_suspended": "当前私域已停用",
  "get_the_discount_code_first": "请先获取优惠码",
  "discount_code_copied": "优惠码已复制",
  "channel_codeV2": "渠道码",
  "congratulations_your_value_has_been_published_successfully": "恭喜！您的《{{value}}》已经发布成功",
  "or": "或",
  "check_it_out": "里查看哦~",
  "edit_shipping_address": "编辑收货地址",
  "add_shipping_address": "添加收货地址",
  "area": "所在地区",
  "enter_detailed_addressV3": "请填写详细地址",
  "enter_recipient_name": "请填写收货人姓名",
  "enter_recipient_phone_number": "请填写收货人电话",
  "are_you_sure_you_want_to_delete_this_shipping_address": "您确认要删除该收货地址吗？",
  "material_nameV6": "材料名称",
  "application_timeV6": "申请时间",
  "requested_quantityV3": "申请数量",
  "bujue_supplier_onboarding_agreement_and_rules": "不觉供应商入驻协议及规则",
  "introduction": "引言",
  "1_conclusion_of_this_agreement": "一、本协议的订立",
  "2_instructions_for_using_the_onboarding_system": "二、入驻系统使用说明",
  "3_supplier_onboarding_requirements_and_supporting_documents": "三、供应商入驻条件及证明文件",
  "1_suppliers_must_meet_the_following_conditions_to_register_on_this_website": "（一）供应商在本网站入驻，须满足以下条件：",
  "2_submission_of_supporting_documents": "（二）证明文件提交：",
  "4_supplier_onboarding_process": "四、供应商入驻流程",
  "suppliers_must_complete_all_of_the_following_steps_before_they_can_use_supplier_related_features_normally_on_the_bujue_platform": "供应商应当完成以下全部流程，方可在不觉平台正常使用供应商相关功能：",
  "5_fees_charged_by_the_bujue_platform": "五、不觉平台收取的费用",
  "1_good_faith_deposit": "（一）诚信保证金",
  "suppliers_that_meet_all_of_the_following_conditions_may_apply_for_a_refund_of_the_good_faith_deposit_on_the_good_faith_deposit_management_page": "供应商满足下列全部条件可以通过诚信保证金专项管理页面申请退还诚信保证金：",
  "1_there_are_no_outstanding_reports_and_or_dispute_cases": "1、没有未处理完成的举报和/或纠纷案件；",
  "2_there_are_no_outstanding_advances_payable_to_the_bujue_platform": "2、没有未偿还的不觉平台垫付款项；",
  "3_there_are_no_unfinished_shipments": "3、没有未结束的发货；",
  "4_the_completion_time_of_the_last_transaction_has_exceeded_90_calendar_days": "4、最后一笔交易完结时间已经超过90个自然日；",
  "2_technical_service_fees": "（二）技术服务费",
  "1_when_a_user_purchases_materials_from_a_supplier_through_the_bujue_platform_and_the_order_is_completed_including_partially_completed_the_bujue_platform_has_the_right_to_charge_the_supplier_a_technical_service_fee_of_0_20_of_the_order_amount_the_exact_rate_is_determined_by_the_relevant_rules_of_the_bujue_platform": "1.用户通过不觉平台向供应商购买材料且订单成交（含部分成交）时，不觉平台有权按照订单成交金额的0%-20%（具体比例根据不觉平台相关规则确定）向供应商收取技术服务费；",
  "6_description_of_the_service_agreement_and_rules": "六、服务协议及规则说明",
  "1_supplier_s_rights_and_obligations": "（一）供应商权利义务",
  "2_rights_and_obligations_of_this_website": "（二）本网站权利义务",
  "3_intellectual_property_rights": "（三）知识产权",
  "4_anti_bribery_clause": "（四）阳光条款",
  "1_in_order_to_build_a_sound_market_order_on_the_bujue_platform_and_a_healthy_platform_environment_suppliers_agree_to_and_voluntarily_comply_with_all_of_the_following_rules": "1. 为打造良好的不觉平台市场秩序，营造健康的平台环境，供应商同意并自愿遵守以下全部规则：",
  "5_termination_of_onboarding_system_services": "（五）入驻系统服务的终止",
  "6_modifications_to_this_agreement": "（六）本协议的修改",
  "7_application_of_law_and_dispute_resolution": "（七）法律适用与争议解决",
  "i_have_read_the_above_agreementV2": "我已阅读以上协议",
  "read_and_accept_the_agreementV2": "请阅读并勾选协议",
  "supplier_onboarding": "供应商入驻",
  "supplier_onboarding_application": "供应商申请入驻",
  "value_sharing": "{{value}}分享",
  "space_sharing": "空间分享",
  "value_sharingV2": "-{{value}}分享",
  "value_products_in_total": "共计{{value}}个产品",
  "hd_assetsV4": "高清素材",
  "warning": "警告",
  "heitiV2": "黑体",
  "kaitiV2": "楷体",
  "fangsongV2": "仿宋",
  "biaukaiV2": "标楷体",
  "stfangsongV2": "华文仿宋",
  "stkaitiV2": "华文楷体",
  "songtiV2": "宋体",
  "microsoft_yaheiV2": "微软雅黑",
  "gongfan_fontV2": "龚帆字体",
  "pangmenzhengdao_bold_calligraphyV2": "庞门正道粗书体",
  "yanshi_chunfeng_kaiV2": "演示春风楷",
  "youshe_haoshentiV2": "优设好身体",
  "sanji_xingkai_simplified_chineseV2": "三极行楷简体",
  "header_backgroundV2": "header background",
  "header_backgroundV3": "header background",
  "shared_productV4": "产品分享",
  "globalV5": "全球",
  "nationwideV3": "全国",
  "space_sharingV2": "空间分享",
  "follow_space": "空间关注",
  "up_to_500_items_per_inquiry": "单次询价上限500个",
  "enter_your_phone_number_or_email": "手机或邮箱不能为空",
  "shared_productV5": "产品分享",
  "overseas_version_product_sharing": "海外版产品分享",
  "shares": "分享记录",
  "titleV4": "标题",
  "descriptionV2": "描述",
  "duration": "时长",
  "value_minutes_value_seconds": "{{value}}分{{value}}秒",
  "value_minutes": "{{value}}分",
  "value_minutes_value_secondsV2": "{{value}}分{{value}}秒",
  "value_hours_value_minutes_value_seconds": "{{value}}小时{{value}}分{{value}}秒",
  "value_days_value_hours_value_minutes_value_seconds": "{{value}}天{{value}}小时{{value}}分{{value}}秒",
  "share_title": "分享标题",
  "share_link": "分享链接",
  "usage_limit": "限制次数",
  "share_type": "分享类型",
  "shared_productV6": "产品分享",
  "space_sharingV3": "空间分享",
  "mini_program_space_sharing": "小程序空间分享",
  "introduction_sharing": "介绍分享",
  "time_spent": "停留时长",
  "dwell_time_is_tracked_only_for_work_shares_and_product_shares_data_refreshes_every_15_minutes": "仅作品分享、产品分享统计时长，每隔15分钟刷新数据",
  "reads": "阅读次数",
  "content_list": "内容清单",
  "are_you_sure_you_want_to_delete_this_record": "确认要删除这条记录吗？",
  "search_keywords": "搜索关键字",
  "total_value_itemsV9": "共{{value}}条",
  "number_of_shares": "分享次数",
  "content_listV2": "内容清单",
  "view_count_statistics": "查看次数统计",
  "dwell_time_statistics": "停留时长统计",
  "finished_productV7": "成品",
  "update_failedV2": "更新失败",
  "update_to_this_version": "是否更新到版本",
  "already_up_to_date": "已是最新版本",
  "stack_bond": "瓷砖对缝铺",
  "straight_lay": "直铺",
  "herringbone_paving": "人字铺装",
  "herringbone": "人字铺",
  "staggered": "砖块错缝铺",
  "brick_bond": "工字铺",
  "bevel": "斜角",
  "corner": "角落",
  "center": "中心",
  "gap_depth_lower_limit": "间隙深度下限",
  "value_must_be_an_integer_greater_than_or_equal_to_0": "值只能为大于或等于零的正整数",
  "value_must_be_a_positive_integer": "值只能为正整数",
  "gap_depth": "间隙深度",
  "the_left_value_of_brick_thickness_must_be_less_than_or_equal_to_the_right_value": "砖厚度左侧值须小于或等于右侧值",
  "paving_style": "铺装样式",
  "row_offset": "行偏移",
  "brick_length": "砖块长度",
  "brick_width": "砖块宽度",
  "fixed_thickness": "固定厚度",
  "brick_joint_width": "砖缝宽度",
  "gap_width": "间隙宽度",
  "add_chamfer": "添加倒角",
  "chamfer_size": "倒角尺寸",
  "starting_point": "起始点",
  "degree": "度",
  "rotation_angle": "旋转角度",
  "starting_point_0_degree_offset": "起始点0度偏移",
  "starting_point_90_degree_offset": "起始点90度偏移",
  "processingV3": "处理中…",
  "start_processing": "开始处理",
  "stop_processing": "停止处理",
  "specification_valueV3": "规格{{value}}",
  "no_textures_match_the_current_filter": "暂无符合筛选的贴图",
  "you_do_not_have_permission_to_access_this_team_s_library_request_permission_from_an_administrator_and_try_again": "您没有访问该团队下资料库的权限，请向管理员申请权限后再试",
  "the_product_library_is_disabled_for_this_team": "当前团队已关闭产品库",
  "the_team_has_been_deactivated": "团队已经被停用",
  "the_team_has_been_deleted": "团队已经被删除",
  "all_rights_reserved": "版权所有",
  "bujue_technology_co_ltd": "不觉科技",
  "update_to_this_versionV2": "是否更新到版本",
  "already_up_to_dateV2": "已是最新版本",
  "my_participation": "我的参与",
  "prepare_documents": "准备材料",
  "prepare_all_the_required_documents_in_advance_so_you_can_pass_the_review_in_one_go": "建议您事先准备齐全资料，一次性通过审核",
  "business_license_id_card_photo": "营业执照、身份证照片",
  "apply_to_join": "申请入驻",
  "fill_in_your_onboarding_information_as_prompted_and_upload_the_required_qualifications": "根据页面提示正确填写您的入驻信息、上传相关资质",
  "submit_for_review": "提交审核",
  "review_takes_up_to_2_business_days_actual_time_may_vary": "审核时效为2个工作日（以实际审核为准）",
  "whether_or_not_your_application_is_approved_we_will_notify_you_of_the_result_by_sms": "无论是否审核通过，我们将通过短信通知您审核结果",
  "onboarding_complete": "入驻成功",
  "you_can_log_in_to_bujue_space_gallery_supplier_platform_to_manage_your_store": "您可以登录“不觉空间艺术馆-供应商平台”，管理您的店铺",
  "join_now": "立即入驻",
  "supplier_onboarding_process": "供应商入驻流程",
  "loadingV5": "loading",
  "are_you_sure_you_want_to_valueV2": "你确定要{{value}}?",
  "value_successful": "{{value}}成功",
  "are_you_sure_you_want_to_valueV3": "你确定要{{value}}?",
  "value_successfulV2": "{{value}}成功",
  "are_you_sure_you_want_to_valueV4": "你确定要{{value}}?",
  "value_successfulV3": "{{value}}成功",
  "finished_productV8": "成品",
  "operation_failed_please_try_again_later": "操作失败，请稍后重试",
  "brand_categoryV3": "品牌分类",
  "all_statusesV2": "全部状态",
  "curatedV12": "严选",
  "unpublish_all_items": "确定都要下架吗",
  "creation_time_status": "创建时间&状态",
  "ban_publishingV2": "禁止上架",
  "set_recommended_products": "设置推荐产品",
  "confirm_settings": "确认设置",
  "new_picks": "新推荐",
  "supplier_settings": "供应商设置",
  "qualification_is_deactivated": "资质被停用",
  "supplier_closure": "供应商关停",
  "your_supplier_qualification_has_been_deactivated_due_to_value_and_similar_conduct": "您的供应商资质因{{value}}等行为已被停用",
  "this_supplier_has_been_shut_down_for_rule_violations_and_illegal_conduct": "该供应商因违规、违法等行为被关停",
  "name_cannot_exceed_20_characters": "姓名不能超过20个字",
  "position_cannot_exceed_20_characters": "职位不能超过20个字",
  "phone_number_cannot_exceed_50_characters": "电话不能超过50个字",
  "email_cannot_exceed_100_characters": "邮箱不能超过100个字",
  "remarks_cannot_exceed_100_characters": "备注不能超过100个字",
  "click_to_refresh": "点击刷新",
  "wechatV4": "微信",
  "wechat_pay_has_a_daily_limit_of_cny_10_000": "微信支付单日限额1万元",
  "chinese_nV3": "中文N",
  "mini_program_share_image": "小程序分享图片",
  "recommended_size_40x50_png_image": "建议尺寸：40*50，png图片",
  "private_space_data_is_being_translated_please_do_not_add_new_dataV2": "正在翻译私域数据，请不要新增数据",
  "open": "开",
  "offV2": "关",
  "value_is_not_an_imageV11": "{{value}} 不是图片",
  "value_file_upload_failedV2": "{{value}} file upload failed.",
  "space_logo": "私域logo",
  "i_have_read_and_agree_to_the_agreement": "我已阅读并同意协议",
  "1_exclusive_product_library_create_a_private_space_and_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "1、专属产品库：创建私域，即可将产品入库至个人或团队产品库，集中管理更高效",
  "2_creative_board_tool_pull_in_products_and_textures_directly_generate_a_product_list_or_white_paper_with_one_click_and_present_your_proposal_with_ease": "2、创意板工具：直接调用产品及贴图，一键生成产品清单或白皮书，轻松展示方案",
  "3_plug_in_tool_library_works_with_revit_3dmax_rhino_sketchup_and_other_design_software_so_you_can_pull_in_product_models_and_textures_at_any_time_and_improve_design_efficiency": "3、插件工具库：联动Revit、3DMax、Rhino、SketchUp等设计软件，随时调用产品模型与贴图，提升设计效率",
  "4_zicai_ocean_publish_products_to_the_public_marketplace_zicai_ocean_with_one_click_to_expand_exposure": "4、紫菜海洋：支持产品一键上架至公域（紫菜海洋），拓展产品曝光",
  "closeV3": "关闭",
  "create_a_private_space_to_automatically_save_the_product_data_you_add": "创建私域空间，可以自动保存您添加的产品数据",
  "design_private_space_service_slogandesign_private_space_service_slogan": "设计私域服务slogan设计私域服务slogan",
  "address_is_required": "地址不能为空",
  "logoV6": "logo",
  "private_space_product_publish_unpublish_review": "私域产品上下架审核",
  "view_now": "立即查看",
  "you_have_new_review_results_for_your_private_space_products_check_them_now": "您有新的私域产品审核结果，请立即查看",
  "enter_your_space_nickname": "请输入私域昵称",
  "application_submittedV2": "申请成功",
  "join_the_private_space": "加入私域",
  "no_signature_yet": "暂无签名",
  "app_not_installed_tap_to_download": "应用未安装，请点击下载",
  "a_sharing_platform_that_empowers_designers": "为设计师赋能的共享平台",
  "free_personalized_official_site": "免费、个性化官网",
  "efficient_and_fast_customization_platform": "高效快速定制化平台",
  "professional_presentation_of_business_negotiations": "业务洽谈专业化呈现",
  "branding_and_marketing_assistant": "品牌和营销得力助手",
  "efficient_professional_portfolio_library": "高效、专业作品库",
  "photos_videos_and_vr_works_presented_in_multiple_formats": "图片\\视频\\VR 作品多形式呈现",
  "share_your_content_with_one_click": "一键分享您的内容",
  "quickly_share_what_you_need": "快速分享所需内容",
  "share_your_portfolio_freely": "任意分享作品集",
  "open_bujue": "打开不觉",
  "download_bujue": "下载不觉",
  "open_this_page_in_a_browser": "请使用浏览器打开",
  "enter_your_space_nicknameV2": "请输入私域昵称",
  "application_submittedV3": "申请成功",
  "you_are_already_a_member_of_this_private_space": "您已是该私域成员",
  "the_application_has_been_sent_and_is_waiting_for_review": "申请已发出，等待审核",
  "no_signature_yetV2": "暂无签名",
  "this_content_is_private_you_can_view_it_after_joining_the_private_space": "内容未公开，加入私域后查看",
  "nickname_in_private_space": "私域中的昵称",
  "application_submittedV4": "申请成功",
  "search_design_spaces": "搜索设计私域",
  "joinedV3": "已加入",
  "applied": "已申请",
  "join_nowV2": "立即加入",
  "fully_openV3": "全开放",
  "anyone_can_joinV2": "自由加入",
  "semi_openV3": "半开放",
  "closedV4": "不开放",
  "invitation_onlyV2": "邀请加入",
  "access_settingsV2": "开放性设置",
  "member_joiningV2": "成员加入",
  "visitor_browsingV2": "访客浏览",
  "get_the_verification_codeV3": "请获取验证码",
  "enter_new_phone_numberV2": "请输入新手机号",
  "enter_new_emailV2": "请输入新邮箱",
  "the_new_phone_number_is_the_same_as_the_old_phone_numberV2": "新手机号与旧手机号相同",
  "failed_to_get_verification_code_try_againV8": "获取验证码失败，请重新获取",
  "delete_this_space": "删除当前私域？",
  "select_a_recipient": "请选择接收人",
  "select_a_member_to_transfer_to": "请选择移交成员",
  "this_user_already_owns_the_maximum_number_of_private_spaces_so_the_transfer_cannot_be_completed": "该用户拥有的私域数量达到上限，无法移交",
  "delete_space": "删除私域",
  "identity_verificationV3": "身份验证",
  "verifyV3": "验证",
  "enter_verification_codeV7": "请输入验证码",
  "transfer_administrator_rights": "移交管理员权限",
  "confirm_transfer": "确定移交",
  "search_people": "搜索人员",
  "enter_username_or_password": "请输入用户名或密码",
  "enter_confirmation_password": "请输入确认密码",
  "set_login_password": "设置登录密码",
  "enter_username": "请输入用户名",
  "enter_passwordV2": "请输入密码",
  "enter_password_again": "请再次输入密码",
  "permission_settings": "权限设置",
  "team_store_published_content_statistics": "团队店铺上架内容统计",
  "team_store_unpublished_content_statistics": "团队店铺下架内容统计",
  "team_store_publish_rejection_statistics": "团队店铺上架驳回统计",
  "team_store_publish_success_statistics": "团队店铺上架成功统计",
  "service_area_value": "服务区域：{{value}}",
  "globalV6": "全球",
  "private_space_status_is_normal": "私域状态正常",
  "this_private_space_has_been_deleted": "该私域已删除",
  "space_deleted": "私域被删除",
  "space_disabledV2": "该私域已停用",
  "space_disabledV3": "私域被停用",
  "all_brands": "全部品牌",
  "search_brands": "搜索品牌",
  "no_brand_data_yet": "暂无品牌数据",
  "brand_supplier_list": "品牌供应商列表",
  "sign_contract": "签约",
  "contract_expired": "合约过期",
  "you_can_upload_up_to_value_itemsV2": "最多上传{{value}}个",
  "device_libraryV3": "设备库",
  "material_libraryV4": "材料库",
  "hd_assetsV5": "高清素材",
  "warningV2": "警告",
  "materialV13": "材料",
  "equipmentV5": "设备",
  "finished_productV9": "成品",
  "info": "信息",
  "member": "会员",
  "security_settingsV3": "安全设置",
  "billing": "账单",
  "finished_productV10": "成品",
  "this_product_has_already_been_addedV2": "该产品已添加",
  "product_list_fixed_price": "产品列表固定价格",
  "product_list_price_range": "产品列表区间价格",
  "unknown_categoryV2": "未知分类",
  "titleV5": "标题：",
  "link": "链接地址：",
  "no_download_link_yet": "暂无下载链接",
  "the_value_plugin_lets_you_use_textures_and_models_from_your_private_space_product_library_directlyV2": "{{value}}插件，直接调用私域产品库的贴图和模型",
  "stay_tunedV2": "敬请期待",
  "invitee": "被邀请人",
  "onboarding_dateV2": "入驻时间",
  "download_poster": "下载海报",
  "brand_categoryV4": "品牌分类",
  "personal_information": "个人信息",
  "bioV2": "个性签名",
  "add_a_personalized_signature": "添加个性签名…",
  "brand_categoryV5": "品牌分类",
  "my_materials": "我的材料",
  "enter_material_name_color_nameV2": "请填写材料名称/颜色名称",
  "use_casesV7": "应用场景",
  "airportV6": "机场",
  "railway_stationV6": "火车站",
  "shopping_mall_supermarketV6": "购物中心/超市",
  "plazaV6": "广场",
  "hotelV6": "酒店",
  "museum_exhibition_hallV6": "博物馆/展览馆",
  "theater_ktvV6": "剧院/KTV",
  "office_buildingV6": "写字楼",
  "schoolV6": "学校",
  "hospitalV6": "医院",
  "restaurantV6": "餐厅",
  "house_villaV6": "住宅/别墅",
  "poolV6": "泳池",
  "sports_fieldV6": "操场",
  "within_one_yearV7": "一年内",
  "more_than_one_yearV7": "一年以上",
  "material_originV4": "材料产地",
  "reference_priceV16": "参考价格",
  "set_to_public": "设置公开成功",
  "reason_for_unpublishingV4": "下架原因：",
  "privateV6": "私密",
  "material_added": "材料已添加",
  "different_categories_cannot_be_comparedV3": "不同分类不能加入对比",
  "unlikeV3": "取消喜欢",
  "brand_categoryV6": "品牌分类",
  "disabledV5": "已停用",
  "view_reason": "查看原因",
  "enter_private_spaceV3": "进入私域",
  "user_agreement_to_be_added": "用户协议，待添加",
  "modern_minimalist_style": "现代简约风格",
  "classical_style": "古典风格",
  "art_deco_style_shanghai_style": "艺术装饰风格/海派风格",
  "industrial_style_urban_style": "工业风格／城市风格",
  "country_style_pastoral_style": "乡村风格／田园风格",
  "chinese_style": "中式风格",
  "mediterranean_style": "地中海风格",
  "southeast_asian_style": "东南亚风格",
  "wabi_sabi_style": "侘寂风",
  "japanese_style": "日式风格",
  "draftV5": "草稿",
  "unpublishedV3": "已下架",
  "privateV7": "私密",
  "material_listV3": "材料清单",
  "no_description_yet": "暂无描述",
  "renderings_photos": "效果图/实景图",
  "main_material_list": "主材清单",
  "no_materials_addedV2": "未添加材料",
  "export_material_list": "导出材料清单",
  "select_export_template": "选择导出模板",
  "default_template": "默认模版",
  "export_nodes_simultaneously": "同时导出节点",
  "export_asset_textures_simultaneously": "同时导出素材贴图",
  "select_export_templateV2": "请选择导出模板",
  "exportV5": "导出",
  "exportingV2": "正在导出…",
  "envelope_s": "封",
  "surface": "面",
  "video_optimization_pending": "等待加速视频",
  "optimizing_video": "正在加速视频",
  "annotation_points_overlap": "标注点重合",
  "save_the_previous_annotation_first": "请保存上一个标注",
  "select_valueV3": "请勾选{{value}}",
  "chinese_nV4": "中文N",
  "value_m": "{{value}}方",
  "value_present": "{{value}}-至今",
  "summary": "总结",
  "this_is_sample_text": "这是示例文案",
  "drag_to_reorderV2": "请拖拽作品排序",
  "merge_into": "”合并到“",
  "confirm": "确定将“",
  "merge_successful": "合并成功",
  "merge_failed": "合并失败",
  "drag_here_to_merge_categories": "拖动至此，合并分类",
  "value_file_upload_failedV3": "{{value}} file upload failed.",
  "logoV7": "LOGO",
  "value_file_upload_failedV4": "{{value}} file upload failed.",
  "video": "视频",
  "cover_cannot_be_reordered": "封面不支持排序",
  "cloud_drive_is_fullV2": "云盘容量耗尽",
  "some_files_exceed_the_available_cloud_drive_spaceV2": "部分文件超出云盘容量",
  "duplicate_style_name_merge": "风格重名，是否合并",
  "duplicate_type_name_merge": "类型重名，是否合并",
  "no_url": "no url",
  "enter_node_nameV2": "请输入节点名称",
  "nodeV5": "节点",
  "node_name_is_requiredV3": "节点名称必填",
  "node_nameV3": "节点名称",
  "upload_schematic_diagramV2": "示意图请上传",
  "schematic_diagramV3": "示意图",
  "applicable_materials_are_requiredV4": "适用材料必填",
  "applicable_materialsV3": "适用材料",
  "drawingsV3": "图纸",
  "draftV6": "草稿",
  "reject_applicationV3": "驳回申请",
  "unpublishedV4": "已下架",
  "all_styles": "所有风格",
  "modern_minimalist_styleV2": "现代简约风格",
  "classical_styleV2": "古典风格",
  "art_deco_style_shanghai_styleV2": "艺术装饰风格/海派风格",
  "industrial_style_urban_styleV2": "工业风格／城市风格",
  "country_style_pastoral_styleV2": "乡村风格／田园风格",
  "chinese_styleV2": "中式风格",
  "mediterranean_styleV2": "地中海风格",
  "southeast_asian_styleV2": "东南亚风格",
  "wabi_sabi_styleV2": "侘寂风",
  "japanese_styleV2": "日式风格",
  "value_reason": "{{value}}原因",
  "value_reason_value": "{{value}}原因：{{value}}",
  "delete_this_work": "确认删除当前作品吗？",
  "search_my_work": "搜索我的作品",
  "work_style": "作品风格",
  "scan_the_qr_code_with_wechat_to_open": "推荐用微信扫码打开",
  "click_to_learn_more": "点击了解详情",
  "click_to_learn_moreV2": "点击了解详情",
  "unpublishedV5": "已下架",
  "overview": "概述",
  "attributesV4": "特性",
  "experienceV2": "经验",
  "inspection_certificateV2": "检验证书",
  "usage_scenarios": "使用场景",
  "styling_suggestions": "搭配建议",
  "nodeV6": "节点",
  "packaging_information": "包装信息",
  "accessories": "配件",
  "detailed_design_serviceV2": "代深化设计",
  "regular_customer": "普通客户",
  "officialV3": "官方",
  "indoorV3": "室内",
  "outdoorV3": "室外",
  "semi_outdoor_spaceV3": "灰空间",
  "basementV3": "地下室",
  "roofV3": "屋顶",
  "exterior_wallV3": "外墙",
  "courtyardV3": "庭院",
  "airportV7": "机场",
  "railway_stationV7": "火车站",
  "shopping_mall_supermarketV7": "购物中心/超市",
  "plazaV7": "广场",
  "hotelV7": "酒店",
  "museum_exhibition_hallV7": "博物馆/展览馆",
  "theater_ktvV7": "剧院/KTV",
  "office_buildingV7": "写字楼",
  "schoolV7": "学校",
  "hospitalV7": "医院",
  "restaurantV7": "餐厅",
  "house_villaV7": "住宅/别墅",
  "poolV7": "泳池",
  "sports_fieldV7": "操场",
  "draftV7": "草稿",
  "publication_under_review": "发布审核中",
  "sensitive_words": "敏感词",
  "completeness": "完整性",
  "reject": "驳回",
  "not_curatedV2": "未严选",
  "sensitive_content_review": "敏感审核",
  "not_approvedV3": "未过审",
  "sensitive_content_review_passed": "敏感审核通过",
  "completeness_review_passed": "完整性审核通过",
  "completeness_review_failed": "完整性审核未通过",
  "main_image": "主图",
  "related_worksV3": "相关作品",
  "materialV14": "材料",
  "equipmentV6": "设备",
  "finished_productV11": "成品",
  "material_libraryV5": "材料库",
  "device_libraryV4": "设备库",
  "finished_product_libraryV2": "成品库",
  "activeV6": "正常",
  "terminatedV2": "已终止",
  "about_page": "介绍页",
  "works_libraryV2": "作品库",
  "team_supplier": "团队供应商",
  "not_signed": "未签约",
  "sign_contractV2": "签约",
  "partnership_expired": "合作到期",
  "slice": "片",
  "bottle": "瓶",
  "case": "箱",
  "box": "盒",
  "bundle": "捆",
  "package": "包",
  "barrel": "桶",
  "pallet": "托",
  "roll": "卷",
  "m²": "平方米",
  "l": "升",
  "kg": "千克",
  "t": "吨",
  "upload_up_to": "一次最多上传",
  "size_exceeds_the_limit_width_height_must_be_15000_pixels_or_less": "尺寸超过限制（宽/高不超过15000像素）",
  "beijingV2": "北京",
  "tianjinV2": "天津",
  "shanghaiV2": "上海",
  "chongqingV2": "重庆",
  "hebei": "河北",
  "shanxi": "山西",
  "liaoning": "辽宁",
  "jilin": "吉林",
  "heilongjiang": "黑龙江",
  "jiangsu": "江苏",
  "zhejiangV2": "浙江",
  "anhui": "安徽",
  "fujian": "福建",
  "jiangxi": "江西",
  "shandong": "山东",
  "henan": "河南",
  "hubei": "湖北",
  "hunan": "湖南",
  "guangdong": "广东",
  "guangxi": "广西",
  "hainan": "海南",
  "sichuan": "四川",
  "guizhou": "贵州",
  "yunnan": "云南",
  "tibet": "西藏",
  "shaanxi": "陕西",
  "gansu": "甘肃",
  "qinghai": "青海",
  "ningxia": "宁夏",
  "inner_mongolia": "内蒙古",
  "inner_mongoliaV2": "内蒙",
  "xinjiang": "新疆",
  "taiwan": "台湾",
  "hong_kong": "香港",
  "macau": "澳门",
  "aba": "阿坝",
  "aksu": "阿克苏",
  "altay": "阿勒泰",
  "ngari": "阿里",
  "anqing": "安庆",
  "anshan": "鞍山",
  "anshun": "安顺",
  "anyang": "安阳",
  "baicheng": "白城",
  "baise": "百色",
  "baishan": "白山",
  "baiyin": "白银",
  "bengbu": "蚌埠",
  "baoding": "保定",
  "baoji": "宝鸡",
  "baoshan": "保山",
  "baotou": "包头",
  "bayannur": "巴彦淖尔",
  "bayingolin": "巴音郭楞",
  "benxi": "本溪",
  "bijie": "毕节",
  "binzhou": "滨州",
  "bortala": "博尔塔拉",
  "bozhou": "亳州",
  "cangzhou": "沧州",
  "changchun": "长春",
  "changde": "常德",
  "changji": "昌吉",
  "changshaV2": "长沙",
  "changzhou": "常州",
  "chaohu": "巢湖",
  "chaoyang": "朝阳",
  "chaozhou": "潮州",
  "chengde": "承德",
  "chengduV2": "成都",
  "chenzhou": "郴州",
  "chifeng": "赤峰",
  "chizhou": "池州",
  "chongzuo": "崇左",
  "chuzhou": "滁州",
  "dali": "大理",
  "dalian": "大连",
  "dandong": "丹东",
  "daqing": "大庆",
  "datong": "大同",
  "daxing_anling": "大兴安岭",
  "dazhou": "达州",
  "dehong": "德宏",
  "deyang": "德阳",
  "dezhou": "德州",
  "dingxi": "定西",
  "dongguanV2": "东莞",
  "dongying": "东营",
  "ezhou": "鄂州",
  "enshi": "恩施",
  "ordos": "鄂尔多斯",
  "foshan": "佛山",
  "fushun": "抚顺",
  "fuxin": "阜新",
  "fuyang": "阜阳",
  "fuzhou": "福州",
  "gannan": "甘南",
  "ganzhou": "赣州",
  "guang_an": "广安",
  "guangyuan": "广元",
  "guangzhouV2": "广州",
  "guigang": "贵港",
  "guilin": "桂林",
  "guiyang": "贵阳",
  "guyuan": "固原",
  "harbin": "哈尔滨",
  "haibei": "海北",
  "haidong": "海东",
  "haikou": "海口",
  "haixi": "海西",
  "hami": "哈密",
  "handan": "邯郸",
  "hangzhouV3": "杭州",
  "hanzhong": "汉中",
  "hebi": "鹤壁",
  "hechi": "河池",
  "hefei": "合肥",
  "hegang": "鹤岗",
  "heihe": "黑河",
  "hengshui": "衡水",
  "hengyang": "衡阳",
  "hotan": "和田",
  "heyuan": "河源",
  "heze": "菏泽",
  "hezhou": "贺州",
  "honghe": "红河",
  "huai_an": "淮安",
  "huaibei": "淮北",
  "huaihua": "怀化",
  "huainan": "淮南",
  "huanggang": "黄冈",
  "huangnan": "黄南",
  "huangshan": "黄山",
  "huangshi": "黄石",
  "hohhot": "呼和浩特",
  "huizhou": "惠州",
  "hulunbuir": "呼伦贝尔",
  "huzhou": "湖州",
  "jiamusi": "佳木斯",
  "ji_an": "吉安",
  "jiangmen": "江门",
  "jiaozuo": "焦作",
  "jiaxing": "嘉兴",
  "jiayuguan": "嘉峪关",
  "jieyang": "揭阳",
  "jinan": "济南",
  "jinchang": "金昌",
  "jincheng": "晋城",
  "jingdezhen": "景德镇",
  "jingmen": "荆门",
  "jingzhou": "荆州",
  "jinhua": "金华",
  "jining": "济宁",
  "jinzhong": "晋中",
  "jinzhou": "锦州",
  "jiujiang": "九江",
  "jiuquan": "酒泉",
  "jixi": "鸡西",
  "kaifeng": "开封",
  "kashgar": "喀什",
  "karamay": "克拉玛依",
  "kizilsu": "克孜勒苏",
  "kunming": "昆明",
  "laibin": "来宾",
  "laiwu": "莱芜",
  "langfang": "廊坊",
  "lanzhou": "兰州",
  "lhasa": "拉萨",
  "leshan": "乐山",
  "liangshan": "凉山",
  "lianyungang": "连云港",
  "liaocheng": "聊城",
  "liaoyang": "辽阳",
  "liaoyuan": "辽源",
  "lijiang": "丽江",
  "lincang": "临沧",
  "linfen": "临汾",
  "linxia": "临夏",
  "linyi": "临沂",
  "nyingchi": "林芝",
  "lishui": "丽水",
  "liuzhou": "柳州",
  "longnan": "陇南",
  "longyan": "龙岩",
  "loudi": "娄底",
  "luohe": "漯河",
  "luoyang": "洛阳",
  "luzhou": "泸州",
  "l_liang": "吕梁",
  "ma_anshan": "马鞍山",
  "maoming": "茂名",
  "meishan": "眉山",
  "meizhou": "梅州",
  "mianyang": "绵阳",
  "mudanjiang": "牡丹江",
  "nanchang": "南昌",
  "nanchong": "南充",
  "nanjingV2": "南京",
  "nanning": "南宁",
  "nanping": "南平",
  "nanyang": "南阳",
  "nagqu": "那曲",
  "neijiang": "内江",
  "ningboV2": "宁波",
  "ningde": "宁德",
  "nujiang": "怒江",
  "panjin": "盘锦",
  "panzhihua": "攀枝花",
  "pingdingshan": "平顶山",
  "pingliang": "平凉",
  "pingxiang": "萍乡",
  "putian": "莆田",
  "puyang": "濮阳",
  "qiandongnan": "黔东南",
  "qiannan": "黔南",
  "qianxinan": "黔西南",
  "qingdaoV2": "青岛",
  "qingyang": "庆阳",
  "qingyuan": "清远",
  "qinhuangdao": "秦皇岛",
  "qinzhou": "钦州",
  "qiqihar": "齐齐哈尔",
  "qitaihe": "七台河",
  "quanzhou": "泉州",
  "qujing": "曲靖",
  "quzhou": "衢州",
  "shigatse": "日喀则",
  "rizhao": "日照",
  "sanmenxia": "三门峡",
  "sanming": "三明",
  "sanya": "三亚",
  "shangluo": "商洛",
  "shangqiu": "商丘",
  "shangrao": "上饶",
  "shannan": "山南",
  "shantou": "汕头",
  "shanwei": "汕尾",
  "shaoguan": "韶关",
  "shaoxing": "绍兴",
  "shaoyang": "邵阳",
  "shennongjia": "神农架",
  "shenyangV2": "沈阳",
  "shenzhenV2": "深圳",
  "shijiazhuang": "石家庄",
  "shiyan": "十堰",
  "shizuishan": "石嘴山",
  "shuangyashan": "双鸭山",
  "shuozhou": "朔州",
  "siping": "四平",
  "songyuan": "松原",
  "suihua": "绥化",
  "suining": "遂宁",
  "suizhou": "随州",
  "suqian": "宿迁",
  "suzhouV2": "苏州",
  "tacheng": "塔城",
  "tai_an": "泰安",
  "taiyuan": "太原",
  "taizhou": "泰州",
  "tangshan": "唐山",
  "tianshui": "天水",
  "tieling": "铁岭",
  "tongchuan": "铜川",
  "tonghua": "通化",
  "tongliao": "通辽",
  "tongling": "铜陵",
  "tongren": "铜仁",
  "turpan": "吐鲁番",
  "weifang": "潍坊",
  "weihai": "威海",
  "weinan": "渭南",
  "wenshan": "文山",
  "wenzhou": "温州",
  "wuhai": "乌海",
  "wuhanV2": "武汉",
  "wuhu": "芜湖",
  "ulanqab": "乌兰察布",
  "urumqi": "乌鲁木齐",
  "wuwei": "武威",
  "wuxiV2": "无锡",
  "wuzhong": "吴忠",
  "wuzhou": "梧州",
  "xiamen": "厦门",
  "xi_anV2": "西安",
  "xiangtan": "湘潭",
  "xiangxi": "湘西",
  "xianning": "咸宁",
  "xianyang": "咸阳",
  "xiaogan": "孝感",
  "xilingol": "锡林郭勒",
  "xing_an": "兴安",
  "xingtai": "邢台",
  "xining": "西宁",
  "xinxiang": "新乡",
  "xinyang": "信阳",
  "xinyu": "新余",
  "xinzhou": "忻州",
  "xishuangbanna": "西双版纳",
  "xuancheng": "宣城",
  "xuchang": "许昌",
  "xuzhou": "徐州",
  "ya_an": "雅安",
  "yan_an": "延安",
  "yanbian": "延边",
  "yancheng": "盐城",
  "yangjiang": "阳江",
  "yangquan": "阳泉",
  "yangzhou": "扬州",
  "yantai": "烟台",
  "yibin": "宜宾",
  "yichang": "宜昌",
  "yichun": "宜春",
  "ili_kazakh": "伊犁哈萨克",
  "yinchuan": "银川",
  "yingkou": "营口",
  "yingtan": "鹰潭",
  "yiyang": "益阳",
  "yongzhou": "永州",
  "yueyang": "岳阳",
  "yulin": "玉林",
  "yulinV2": "榆林",
  "yuncheng": "运城",
  "yunfu": "云浮",
  "yunlin": "云林",
  "yuxi": "玉溪",
  "zaozhuang": "枣庄",
  "zhangjiajie": "张家界",
  "zhangjiakou": "张家口",
  "zhangye": "张掖",
  "zhangzhou": "漳州",
  "zhanjiang": "湛江",
  "zhaoqing": "肇庆",
  "zhaotong": "昭通",
  "zhengzhou": "郑州",
  "zhenjiang": "镇江",
  "zhongshan": "中山",
  "zhongwei": "中卫",
  "zhoukou": "周口",
  "zhoushan": "舟山",
  "zhuhai": "珠海",
  "zhuzhou": "株洲",
  "zibo": "淄博",
  "zigong": "自贡",
  "ziyang": "资阳",
  "zunyi": "遵义",
  "japaneseV2": "日本語",
  "wechatV5": "微信",
  "unknown_device": "未知的设备",
  "only_image_files_are_allowed": "只允许上传图片",
  "product_textureV3": "产品贴图",
  "commissioned_assets": "委托素材",
  "insufficient_capacity": "Insufficient capacity",
  "your_cloud_storage_is_running_low_to_avoid_interruptions_we_recommend_upgrading_your_capacity_as_soon_as_possible": "Dear user, your cloud storage space is insufficient. To avoid affecting normal use, we suggest that you upgrade your capacity as soon as possible.",
  "expand_capacity": "Go expand the capacity",
  "for_proper_display_the_long_edge_must_be_at_least_value_we_recommend_uploading_images_of_value_value_or_larger": "为保证展示效果，图片长边尺寸不得低于{{value}}，建议上传{{value}}*{{value}}以上的图片",
  "for_better_display_quality_upload_images_of_value_value_or_larger": "建议上传{{value}}*{{value}}以上的图片，以获得更好的展示效果",
  "exit_failed_use_f11_to_exit_full_screen": "退出失败，请使用F11退出全屏",
  "network_busy_try_again_later": "网络繁忙，请稍后再试",
  "the_user_is_currently_in_the_queue": "该用户正在排队中",
  "the_image_does_not_exist": "图片不存在",
  "the_image_size_or_resolution_does_not_meet_the_requirements": "图片大小或分辨率不符合要求",
  "you_have_already_added_this_product_to_favorites_do_not_add_it_again": "你已经收藏了该产品，不要重复收藏",
  "the_current_product_type_does_not_match_the_products_in_the_pk_list": "当前产品与pk列表中的产品类型不一致",
  "this_brand_name_already_exists": "该品牌名称已存在",
  "an_error_occurred_while_deleting_the_supplier_associated_with_the_team_brand_brandid_id": "删除团队品牌关联的供应商出了错，brandId:{{id}}",
  "an_error_occurred_while_deleting_the_product_associated_with_the_team_brand_brandid_id": "删除团队品牌关联的产品出了错，brandId:{{id}}",
  "the_token_is_invalid": "token失效",
  "alipay_payment_error_error": "支付宝支付error:{{error}}",
  "token_expired": "token 过期",
  "the_user_is_not_logged_in": "用户未登录",
  "this_supplier_name_already_exists": "供应商名称已存在",
  "the_deadline_cannot_be_earlier_than_today": "截止日期不可早于今日",
  "associated_brands_exist_remove_the_associations_first": "存在关联品牌，请先解除关联",
  "id_is_required": "id不能为空",
  "parameters_are_required": "参数不能为空",
  "log_in_to_download": "请登录后下载",
  "the_file_does_not_exist": "文件不存在",
  "log_in_to_preview": "请登录后预览",
  "missing_parameters": "参数不全",
  "the_token_is_invalidV2": "token失效",
  "user_information_is_required": "用户信息不能为空",
  "system_busy_try_again_later": "系统繁忙，请稍后重试",
  "complete_security_verification": "请完成安全验证",
  "general_notice": "通用消息",
  "general_notice_we_have_launched_the_featurename_feature": "通用消息提示，我们上线了{{featureName}}功能",
  "in_my_space_you_can_view_your_share_history_following_and_spaces": "在我的空间，可以查看分享记录、我的关注、我的私域",
  "the_current_account_does_not_have_a_space_yet": "当前账号暂无私域",
  "create_a_space_first_to_unlock_a_new_product_management_experience": "请先创建私域，开启产品管理新体验",
  "click_create_below_to_finish_creating_your_space_and_access_the_following_resources": "点击下方的创建按钮，完成私域创建，即可享受以下资源",
  "exclusive_product_library_create_a_space_to_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "专属产品库：创建私域，即可将产品入库至个人或团队产品库，集中管理更高效",
  "space_logoV2": "私域 Logo",
  "name_is_requiredV7": "名称不能为空",
  "i_have_read_and_agree_to_the_bujue_space_service_agreement": "我已阅读并同意《不觉私域服务协议》",
  "thank_you_for_choosing_our_product_you_now_receive_capacity_mb_of_permanently_free_storage_effective_immediately_enjoy": "感谢你选择并使用我们的产品。现在为你送上 {{capacity}} MB 永久免费容量福利，即刻生效，尽情享用！",
  "english_and_japanese_language_packs_have_been_activated_for": "{私域名称}已成功开通英文、日语语言包",
  "go_to_basic_info_settings": "请前往设置基础信息",
  "the_introduction_uses_the_same_configuration_across_all_languages": "介绍在不同语言下，都是同一套配置",
  "scan_and_share_qr_code": "扫码和分享二维码",
  "share_language": "分享语言",
  "you_can_also_copy_the_link_and_send_it_to_your_friends": "你也可以复制链接并发送给好友",
  "one_click_download_batch_download_chinese_source_text_to_be_confirmed": "一键下载／批量下载（需确认中文源文案）",
  "key_vault": "密钥箱",
  "product_asset_library": "产品素材库",
  "reviews": "评价",
  "space_id": "私域号",
  "panbagua": "盘八卦",
  "bujue_app": "不觉 APP",
  "cny": "￥{价格}CNY",
  "bioV3": "个性签名：",
  "add_a_bio": "添加个性签名…",
  "spaces_i_manage": "我管理的私域",
  "spaces_i_ve_joined": "我加入的私域",
  "third_party_accounts": "第三方账号",
  "to_keep_your_account_secure_please_verify_your_identity_you_can_continue_once_verification_succeeds": "为了你的账户安全，请验证身份，验证成功后进行下一步操作.",
  "use_phone_number": "使用手机号",
  "use_email": "使用邮箱",
  "enter_the_email_address_you_want_to_link": "请输入您要绑定的邮箱地址",
  "enter_the_phone_number_you_want_to_link": "请输入您要绑定的手机号码",
  "you_are_not_logged_inV2": "当前用户未登录",
  "failed_to_get_the_verification_code_please_try_again": "获取验证码失败，请重新获取",
  "waiting_for_administrator_review": "等待管理员审核",
  "entering_the_private_space_in_count_s": "{{count}}秒后自动进入私域",
  "open_the_app": "打开APP",
  "keep_both": "保留两者",
  "replace": "覆盖",
  "create_folder": "创建文件夹",
  "only_images_can_be_uploaded_to_the_product_asset_libraryV2": "产品素材库只能上传图片",
  "file_names_cannot_contain_the_following_charactersV4": "文件名不能包含以下字符：",
  "this_file_cannot_be_previewed_online_download_it_to_view": "当前文件暂不支持在线预览，是否下载查看",
  "texture_library_folders_cannot_be_moved_in_or_outV2": "贴图库文件夹不能向内外移动",
  "files_can_only_be_moved_into_product_asset_library_folders": "文件只能移动到产品素材库文件夹里",
  "texture_library_folders_cannot_be_moved_outV2": "贴图库文件夹不能向外移动",
  "folders_other_than_texture_library_folders_cannot_be_moved_inV2": "非贴图库文件夹不能向内移动",
  "cannot_move_to_the_name_folder": "无法移动至{{name}}文件夹",
  "the_name_library_cannot_be_renamed_moved_or_deleted_and_no_files_or_folders_can_be_added_to_it": "{{name}}库不能重命名、移动和删除，不能添加文件/文件夹",
  "name_cannot_be_renamed_moved_or_deleted": "{{name}}不能重命名、移动和删除",
  "count_items_in_total": "共{{count}}项",
  "manage_files_in_this_folder_display_images_linked_to_name_are_not_affected": "管理当前文件夹中的文件，不会影响关联{{name}}的展示图片",
  "manage_files_in_this_folder_award_certificates_linked_to_name_are_not_affected": "管理当前文件夹中的文件，不会影响关联{{name}}的获奖证书",
  "count_uploads_completed": "{{count}}个任务上传完成",
  "count_uploads_in_progress": "{{count}}个任务正在上传",
  "private_space_list": "私域列表",
  "private_space_data": "私域数据",
  "data_overview": "数据总览",
  "data_details": "数据明细",
  "all_content": "全部内容",
  "count_new": "上新{{count}}个！",
  "listed": "上架：",
  "time_spent_total": "停留时长（累计）",
  "daily_time_spent": "每日时长",
  "ascending": "升序",
  "descending": "降序",
  "region": "区域：",
  "no_contact_information_availableV2": "暂无联系方式",
  "generate": "生成",
  "exportedV5": "导出成功",
  "design_type": "设计类型",
  "select_a_memberV2": "请选择成员",
  "no_members_available_to_reassign_toV2": "暂无可转单的成员",
  "save_draft": "保存草稿",
  "total_count_items": "共{{count}}条",
  "favorited_count": "已收藏（{{count}}）",
  "min": "分",
  "sec": "秒",
  "hr": "小时",
  "phone": "手机：",
  "email": "邮箱：",
  "submitted_by": "提交人：",
  "submitted_at": "提交时间：",
  "other_contact": "其他联系方式：",
  "generate_quotationV2": "生成报价",
  "view_quotation": "查看报价",
  "checking_membership_status_please_wait": "会员状态确认中，请稍后",
  "no_agreement_template_configured": "协议模板未配置",
  "open_this_link_on_a_computerV2": "请使用电脑打开链接",
  "link_phone_or_email": "绑定手机号/邮箱",
  "linked_successfullyV3": "绑定成功",
  "this_private_space": "该私域",
  "exclusive_product_library": "专属产品库",
  "create_a_private_space_and_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "创建私域，即可将产品入库至个人或团队产品库，集中管理更高效",
  "creative_board_tool": "创意板工具",
  "pull_in_products_and_textures_directly_generate_a_product_list_or_white_paper_with_one_click_and_present_your_proposal_with_ease": "直接调用产品及贴图，一键生成产品清单或白皮书，轻松展示方案",
  "plug_in_tool_library": "插件工具库",
  "works_with_revit_3dmax_rhino_sketchup_and_other_design_software_so_you_can_pull_in_product_models_and_textures_at_any_time_and_improve_design_efficiency": "联动 Revit、3DMax、Rhino、SketchUp 等设计软件，随时调用产品模型与贴图，提升设计效率",
  "publish_products_to_the_public_marketplace_zicai_ocean_with_one_click_to_expand_exposure": "支持产品一键上架至公域（紫菜海洋），拓展产品曝光",
  "the_name_cannot_exceed_40_characters": "名称不能超过40个字",
  "the_private_space_name_contains_sensitive_words": "私域名称包含敏感词汇",
  "enter_the_private_space_name": "请输入 私域名称",
  "view_item_index": "查看第{{index}}项",
  "please_confirm_and_check_the_agreement_first": "请先确认并勾选协议",
  "password_box": "密码箱",
  // —— 设计中心下拉「项目管理工具」入口（2026-10-26）——
  "项目管理工具": "项目管理工具",
}

//英文翻译go
export const PolyglotJaJson = {
  // ユーザーセンターのドロップダウンとダイアログ
  "最多只能关联 {{maxCount}} 张图片": "画像は最大{{maxCount}}枚まで関連付けできます",
  "个人信息": "個人情報",
  "名片信息": "名刺情報",
  "账号管理": "アカウント管理",
  "个性签名": "自己紹介",
  "个性签名：": "自己紹介：",
  "添加个性签名..": "自己紹介を追加…",
  "当前账号暂无私域": "現在のアカウントにはスペースがありません。",
  "请先创建私域，开启产品管理新体验": "まずスペースを作成して、新しい製品管理を始めましょう。",
  "我管理的私域": "管理しているプライベートスペース",
  "我加入的私域": "参加しているプライベートスペース",
  "已停用": "無効",
  "删除私域": "スペースを削除",
  "删除私域之后，私域在平台上的数据将被清除，且不可恢复。": "プライベートスペースを削除すると、プラットフォーム上のデータは消去され、復元できなくなります。",
  "移交私域": "スペースを譲渡",
  "会员": "会員",
  "查看原因": "理由を確認",
  "第三方账号": "外部アカウント",
  "微信": "WeChat",
  "解绑": "連携を解除",
  "未绑定": "未連携",
  "解绑成功": "連携を解除しました",
  "确认要解除绑定吗？": "連携を解除してもよろしいですか？",
  "身份验证": "本人確認",
  "验证": "確認",
  "为了你的账户安全,请验证身份,验证成功后进行下一步操作.": "アカウント保護のため、本人確認をしてください。確認後、次へ進みます。",
  "使用手机号": "携帯電話番号を使用",
  "使用邮箱": "メールアドレスを使用",
  "请输入验证码": "認証コードを入力してください",
  "请获取验证码": "認証コードを取得してください",
  "绑定成功": "連携しました",
  "绑定邮箱": "メールアドレスを連携",
  "请输入您要绑定的邮箱地址": "連携するメールアドレスを入力してください",
  "请输入有效邮箱地址": "有効なメールアドレスを入力してください",
  "绑定手机号": "携帯電話番号を連携",
  "请输入您要绑定的手机号码": "連携する携帯電話番号を入力してください",
  "请输入用户名或密码": "ユーザー名またはパスワードを入力してください",
  "请输入确认密码": "確認用のパスワードを入力してください",
  "请输入密码": "パスワードを入力してください",
  "请输入用户名": "ユーザー名を入力してください",
  "请确认密码": "パスワードを確認してください",
  "确认密码": "パスワードの確認",
  "两次密码不一致": "パスワードが一致しません",
  "请再次输入密码": "パスワードをもう一度入力してください",
  "确认新密码": "新しいパスワードの確認",
  "新密码": "新しいパスワード",
  "密码绑定": "パスワード設定",
  "设置登录密码": "ログインパスワードを設定",
  "绑定微信": "WeChatを連携",
  "请扫二维码绑定微信": "QRコードをスキャンしてWeChatを連携してください",
  "当前用户未登录！": "ログインしていません",
  "暂无权限！": "権限がありません。",
  "该手机号/邮箱账号已被占用，请更换其他手机号/邮箱账号再试。": "この携帯電話番号／メールアドレスはすでに使用されています。別の携帯電話番号／メールアドレスをお試しください。",
  "请输入新手机号": "新しい携帯電話番号を入力してください",
  "请输入新邮箱": "新しいメールアドレスを入力してください",
  "新手机号与旧手机号相同": "新しい携帯電話番号が現在の携帯電話番号と同じです",
  "获取验证码失败,请重新获取": "認証コードの取得に失敗しました。再度取得してください",
  "未设置": "未設定",
  "姓名不能超过20个字": "氏名は20文字以内で入力してください",
  "职位不能超过20个字": "役職は20文字以内で入力してください",
  "电话不能超过50个字": "電話番号は50文字以内で入力してください",
  "邮箱不能超过100个字": "メールアドレスは100文字以内で入力してください",
  "备注不能超过100个字": "備考は100文字以内で入力してください",
  "我的空间": "マイスペース",
  "入驻成为供应商": "サプライヤーとして登録",
  "切换为设计师": "デザイナーに切り替え",
  "账户设置": "アカウント設定",
  "帮助中心": "ヘルプセンター",
  "您的浏览器暂时不支持添加快捷方式，推荐使用chrome或safari浏览器": "お使いのブラウザはショートカットの追加に対応していません。ChromeまたはSafariのご利用をおすすめします。",
  "安装快捷方式": "ショートカットをインストール",
  "退出登录": "ログアウト",
  "供应商终止合作": "サプライヤーとの提携終了",
  "咨询电话：{{phone}}": "お問い合わせ：{{phone}}",
  "恭喜您领取成功": "お受け取りが完了しました",
  "平台已免费赠送您三个月会员": "プラットフォームから<gift>無料で</gift><membership>3か月間の会員資格</membership>をプレゼントしました。",
  "有效期至：{{date}}": "有効期限：{{date}}",
  "开心收下": "受け取る",
  "您有<count>{{count}}条</count>新的询价需要处理": "対応が必要な新しい見積依頼が<count>{{count}}件</count>あります",
  "共计{{count}}个产品": "合計{{count}}点の製品",
  // —— 二元文案 t() 化新增（2026-07-17，英文占位，待补真日文）——
  "{{name}}字段已存在！": "「{{name}}」フィールドは登録済みです",
  "您的数据我们将为您保留至{{time}}。为保证数据安全，请及时续费。": "お客様のデータは{{time}}まで保持されます。データ保護のため、お早めに契約を更新してください。",
  "一次最多只能导入{{n}}张模版": "テンプレートは1回に最大{{n}}枚まで",
  "共{{n}}页": "全{{n}}ページ",
  "已选{{n}}页": "{{n}}ページ選択済み",
  "第{{n}}页": "{{n}}ページ目",
  "新增标记": "マークを追加",
  "输入手机号或邮箱": "携帯電話番号／メールアドレス",
  "委托添加{{name}}数据": "{{name}}データの登録を依頼",
  "{{team}}委托您添加私域库数据，点击链接开始操作：{{url}}": "{{team}}よりプライベートスペースのライブラリへのデータ追加を依頼されました。リンクから開始してください：{{url}}",
  "确认将该{{name}}下架吗？": "この{{name}}を掲載停止しますか？",
  "确认导出{{count}}个已入库产品的二维码？": "ライブラリ内の製品{{count}}点のQRコードをエクスポートしますか？",
  "你没有{{name}}的管理权限，继续操作将退出管理模式，是否继续？": "{{name}}の管理権限がありません。続行すると管理モードを終了します。続行しますか？",
  "暂无可{{type}}私域": "現在{{type}}できるプライベートスペースがありません",
  "已解除{{name}}，确认是否删除，确认后消失。": "{{name}}は解除されました。削除しますか？確認後は表示されなくなります。",
  "取消{{name}}": "{{name}}をキャンセル",
  "这里还没有{{name}}方的介绍": "ここにはまだ{{name}}側の紹介がありません",
  // —— 入库データ整合性チェック（2026-07-28）——
  "数据完整性校验未通过": "データ整合性チェックに失敗しました",
  "入库失败{{count}}条": "{{count}}件入庫失敗",
  "入库成功{{count}}条": "{{count}}件入庫成功",
  "入库成功{{successCount}}条": "{{successCount}}件入庫成功",
  "入库成功{{successCount}}条,失败{{failCount}}条": "{{successCount}}件入庫成功、{{failCount}}件失敗",
  "入库成功{{successCount}}条，失败{{failCount}}条": "{{successCount}}件入庫成功、{{failCount}}件失敗",
  "入库成功{{successCount}}条，未处理{{unprocessedCount}}条": "{{successCount}}件入庫成功、未処理{{unprocessedCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，未处理{{unprocessedCount}}条": "{{successCount}}件入庫成功、{{failCount}}件失敗、未処理{{unprocessedCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失": "{{successCount}}件入庫成功、{{failCount}}件失敗、必須項目未入力{{requiredCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，未处理{{unprocessedCount}}条": "{{successCount}}件入庫成功、{{failCount}}件失敗、必須項目未入力{{requiredCount}}件、未処理{{unprocessedCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词": "{{successCount}}件入庫成功、{{failCount}}件失敗、禁止ワード検出{{sensitiveCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "{{successCount}}件入庫成功、{{failCount}}件失敗、禁止ワード検出{{sensitiveCount}}件、未処理{{unprocessedCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词": "{{successCount}}件入庫成功、{{failCount}}件失敗、必須項目未入力{{requiredCount}}件、禁止ワード検出{{sensitiveCount}}件",
  "入库成功{{successCount}}条，失败{{failCount}}条，{{requiredCount}}条产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "{{successCount}}件入庫成功、{{failCount}}件失敗、必須項目未入力{{requiredCount}}件、禁止ワード検出{{sensitiveCount}}件、未処理{{unprocessedCount}}件",
  "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词": "入庫失敗、必須項目未入力{{requiredCount}}件、禁止ワード検出{{sensitiveCount}}件",
  "入库失败,{{requiredCount}}个产品必填项缺失": "入庫失敗、必須項目未入力{{requiredCount}}件",
  "入库失败,{{sensitiveCount}}条产品存在敏感词": "入庫失敗、禁止ワード検出{{sensitiveCount}}件",
  "入库失败,{{requiredCount}}个产品必填项缺失，{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "入庫失敗、必須項目未入力{{requiredCount}}件、禁止ワード検出{{sensitiveCount}}件、未処理{{unprocessedCount}}件",
  "入库失败,{{requiredCount}}个产品必填项缺失，未处理{{unprocessedCount}}条": "入庫失敗、必須項目未入力{{requiredCount}}件、未処理{{unprocessedCount}}件",
  "入库失败,{{sensitiveCount}}条产品存在敏感词，未处理{{unprocessedCount}}条": "入庫失敗、禁止ワード検出{{sensitiveCount}}件、未処理{{unprocessedCount}}件",
  "当前选中产品不支持入库操作": "選択中の製品は入庫できません",
  "当前选中产品不支持上架操作": "選択中の製品は掲載できません",
  "当前选中产品不支持下架操作": "選択中の製品は掲載停止できません",
  "提交审核{{submitCount}}条": "{{submitCount}}件審査に提出",
  "已提交审核{{submitCount}}条": "{{submitCount}}件審査に提出",
  "已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条": "{{submitCount}}件審査に提出、未処理{{unprocessedCount}}件",
  "上架成功{{successCount}}条": "{{successCount}}件掲載成功",
  "上架成功{{successCount}}条，未处理{{unprocessedCount}}条": "{{successCount}}件掲載成功、未処理{{unprocessedCount}}件",
  "上架成功{{successCount}}条，已提交审核{{submitCount}}条": "{{successCount}}件掲載成功、{{submitCount}}件審査に提出",
  "上架成功{{successCount}}条，已提交审核{{submitCount}}条，未处理{{unprocessedCount}}条": "{{successCount}}件掲載成功、{{submitCount}}件審査に提出、未処理{{unprocessedCount}}件",
  "上架失败{{failCount}}条": "{{failCount}}件掲載失敗",
  "下架成功{{successCount}}条": "{{successCount}}件掲載停止成功",
  "已下架{{successCount}}条": "{{successCount}}件掲載停止",
  "已下架{{successCount}}条，未处理{{unprocessedCount}}条": "{{successCount}}件掲載停止、未処理{{unprocessedCount}}件",
  "下架失败{{failCount}}条": "{{failCount}}件掲載停止失敗",
  "状态不支持{{unsupportedCount}}条": "{{unsupportedCount}}件はステータス未対応",
  "未处理{{unprocessedCount}}条": "{{unprocessedCount}}件未処理",
  "上架成功{{successCount}}条,失败{{failCount}}条": "{{successCount}}件掲載成功、{{failCount}}件失敗",
  "句号": "。",
  "逗号": "、",
  "时间": "時間",
  "风格": "スタイル",
  "类型": "タイプ",
  "内容展示": "コンテンツ",
  "基本信息": "基本情報",
  "获奖证书": "受賞証明書",
  "媒体宣传": "メディア掲載",
  // "选品列表": "List Of Selected Products",
  "无": "なし",
  "暂无数据": "データがありません",
  "没有更多了": "これ以上ありません",
  "上架时间": "掲載日時",
  "上市时间": "発売日",
  "入库时间": "登録日時",
  "名称排序": "名前順",
  "默认排序": "デフォルト順",
  "正序": "昇順",
  "倒序": "降順",
  "分类": "Type",
  "分类N": "カテゴリ",
  "全部": "すべて",
  "所有产品": "すべての製品",
  "全部{{name}}": "すべての{{name}}",
  "现场勘测": "現地調査",
  "深化设计": "詳細設計",
  "代安装": "設置代行",
  "代施工": "施工代行",
  "代加工": "加工代行",
  "送货上门": "宅配",
  "其他": "その他",
  "保养": "メンテナンス",
  "一周内": "1週間以内",
  "一个月内": "1ヶ月以内",
  "三个月内": "3ヶ月以内",
  "半年内": "半年以内",
  "重置": "リセット",
  "确认内容": "内容確認",
  "效果": "Final Look",
  "效果N": "完成イメージ",
  "素材": "素材",
  "款式": "Style",
  "款式N": "スタイル",
  "产品参数": "製品仕様",
  "品牌": "Brand",
  "品牌N": "ブランド",
  "合资": "合弁",
  "进口": "輸入品",
  "国产": "国産",
  "原创": "オリジナル",
  "产品类型": "製品タイプ",
  "选择产品类型": "製品タイプを選択",
  "供货周期": "納期",
  "配套服务": "付帯サービス",
  "附件": "資料",
  "名片": "名刺",
  "价格:": "価格：",
  "案例": "事例",
  "联系方式": "連絡先",
  "姓名": "氏名",
  "手机号": "携帯電話番号",
  "邮箱": "メールアドレス",
  "已选内容": "選択済み",
  "提交询价": "見積依頼",
  "返回": "戻る",
  "提交成功": "送信しました",
  "您的询价正在处理中": "お見積もり依頼を処理中です",
  "您的询价正在处理中，前往不觉app查看询价记录": "お見積もり依頼を処理中です。Bujueアプリの「見積依頼履歴」でご確認ください",
  "您的询价正在处理中，前往不觉官网-我的询价查看": "お見積もり依頼を処理中です。Bujue公式サイトの「見積依頼履歴」でご確認ください",
  "新手引导": "操作ガイド",
  "知道了": "わかりました",
  "无附件数据": "添付ファイルなし",
  "供应商信息": "サプライヤー情報",
  "品牌信息": "ブランド情報",
  "分类信息": "カテゴリ情報",
  "产品": "製品",
  "介绍": "紹介",
  "作品": "作品",
  "筛选": "フィルター",
  "滑动查看": "スワイプして表示",
  "点击进入": "クリックで開く",
  "点击开始": "クリックで開始",
  "￥": "¥",
  "品牌类型": "ブランドタイプ",
  "安全防护": "安全保護",
  "厨房电器": "キッチン家電",
  "电气设备": "電気設備",
  "儿童家具": "子供用家具",
  "辅材配件": "補助材料・付属品",
  "户外园艺": "屋外・園芸",
  "基础结构": "基礎構造",
  "家居纺织品": "ホームテキスタイル",
  "建筑节能": "建築省エネ",
  "建筑围护": "建築外皮",
  "洁具卫浴": "衛生器具・バス",
  "楼梯与扶手": "階段・手すり",
  "门窗类": "ドア・窓",
  "面层材料": "仕上げ材",
  "全屋定制": "オーダーメイド家具",
  "软装家居": "ソフトファニシング",
  "施工工具": "施工工具",
  "水电暖通": "給排水・電気・空調",
  "照明灯具": "照明器具",
  "智能家居": "スマートホーム",
  "装饰线条": "装飾モール",
  "件": "点",
  "/件": "/点",
  "张": "枚",
  "个": "個",
  "台": "台",
  "片": "枚",
  "瓶": "本",
  "箱": "箱",
  "盒": "箱",
  "捆": "束",
  "包": "袋",
  "桶": "樽",
  "托": "パレット",
  "卷": "巻",
  "米": "メートル",
  "平方米": "平方メートル",
  "升": "リットル",
  "千克": "キログラム",
  "吨": "トン",
  "扇": "枚",
  "套": "セット",
  "跳过": "スキップ",
  "暂无价格": "価格情報がありません",
  "¥ {{price}} 起": "¥{{price}}〜",
  "¥ {{price}} 起": "¥ {{price}} 〜",
  "产品列表固定价格": "¥ {{price}}",
  "产品列表区间价格": "¥ {{price}}<unit> 〜</unit>",
  "请输入名称": "名前を入力してください",
  "请输入手机号": "電話番号を入力してください",
  "请输入邮箱": "メールアドレスを入力してください",
  "请输地区": "地域を入力してください",
  "请输其他联系方式": "その他の連絡先を入力してください",
  "提交": "送信",
  "至少保留一项": "1件以上残してください",
  "品牌：": "Brand：",
  "展开": "展開",
  "折叠": "折りたたむ",
  "品牌:": "Brand：",
  "类型:": "タイプ：",
  "周期:": "期間：",
  "上市时间:": "発売日：",
  "服务:": "サービス：",
  "供货周期:": "納期：",
  "备注:": "備考：",
  "贴图": "Texture",
  "贴图N": "テクスチャ",
  "平铺": "Tiling",
  "平铺N": "タイル表示",
  "列表": "リスト",
  "批量下载": "一括ダウンロード",
  "共": "合計",
  "个文件": "個のファイル",
  "张贴图": "枚のテクスチャ",
  "个模型": "個のモデル",
  "材质": "材質",
  "规格:": "仕様",
  "规格": "仕様",
  "作品信息": "作品情報",
  "时间：": "作成日時：",
  "类型：": "プロジェクトタイプ",
  "查看作品": "作品を見る",
  "材质:": "材質：",
  "图库": "ギャラリー",
  "简介": "概要",
  "当前锚点": "現在のアンカーポイント",
  "所有锚点": "すべてのアンカーポイント",
  "选择资材类型": "資材タイプを選択",
  "资材类型": "資材タイプ",
  "服务范围": "サービス範囲",
  "选择服务范围": "サービス範囲を選択",
  "询价": "見積依頼",
  "退出": "終了",
  "确定": "確定",
  "退出批量设置": "一括設定を終了",
  "全选": "全選択",
  "：": "：",
  "取消": "キャンセル",

  "请输入您的姓名": "お名前を入力してください",
  "请输入您的邮箱": "メールアドレスを入力してください",
  "请输入您的地区": "地域を入力してください",
  "暂无附件": "添付ファイルなし",
  "未开通国际版": "国際版は有効になっていません",
  "电话咨询": "電話で問い合わせる",
  "所有图片": "すべての画像",
  "附件不支持下载，请联系供应商": "添付ファイルはダウンロード不可です。サプライヤーにご連絡ください",
  "附件不支持下载，请联系管理员": "添付ファイルはダウンロード不可です。管理者にご連絡ください",
  "品牌馆": "ブランドギャラリー",
  "进入品牌": "ブランドページへ",
  "请至少选择一条产品": "製品を1点以上選択してください",
  "数量不能小于1": "数量は1以上にしてください",
  "附件下载": "添付ファイルのダウンロード",
  "下载附件": "添付ファイルをダウンロード",
  "应用案例": "導入事例",
  // "入库时间":"Storage time",
  "名称": "名前",
  "已认证": "認証済み",
  "海外版官网": "海外版公式サイト",
  "开发中": "開発中",
  "选择类型": "タイプを選択",
  "选择": "選択",
  "分享设置": "シェア設定",
  "已选": "選択済み",
  "已选：": "選択済み",
  "已选：{{n}}/{{total}}": "{{n}}/{{total}} 件選択中",
  "上一步": "前へ",
  "下一步": "次へ",
  "分享": "シェア",
  "请输入搜索": "検索キーワードを入力してください",
  "请输入搜索内容": "検索",
  "选择展示方式": "表示方法を選択",
  "平铺模式": "タイル表示",
  "合集": "コレクション",
  "设置默认视图": "デフォルトビューを設定",
  "已选择": "選択済み",
  "拖动排序": "ドラッグで並べ替え",
  "单次分享上限100个": "1回のシェア：最大100件",
  "浏览次数：": "閲覧回数：",
  "不限制": "制限なし",
  "限制": "制限",
  "请输入": "入力してください",
  "有效期限：": "有効期限：",
  "1天": "1日",
  "7天": "7日",
  "永久": "無期限",
  "确认订单": "ご注文内容の確認",
  "购买语言：": "購入言語：",
  "选择支付方式：": "支払い方法を選択：",
  "购买即同意": "購入すると、以下に同意したものとみなされます",
  "《不觉付费服务协议》": "「Bujue有償サービス規約」",
  "《不觉付费协议》": "「Bujue有償サービス規約」",
  "合计：": "合計：",
  "立即支付": "今すぐ支払う",
  "语言包": "言語パック",
  "服务咨询": "お問い合わせ",
  "示例效果": "表示例",
  "即将上线，敬请期待！": "近日公開予定、お楽しみに！",
  "当前语言已开通": "この言語はすでに有効になっています",
  "订单已结束": "注文は終了しました",
  "开通成功": "有効化しました",
  "该语言": "この言語",
  "{{lang}}开通成功！正在自动翻译当前私域数据，稍后将收到翻译完成提醒":
    "{{lang}}の開通が完了しました。現在プライベートデータを自動翻訳中です。完了後に通知が届きます",
  "英语": "英語",
  "日语": "日本語",
  "俄罗斯语": "ロシア語",
  "法语": "フランス語",
  "德语": "ドイツ語",
  "阿拉伯语": "アラビア語",
  "自定义": "カスタム",
  "次": "回",
  "天": "日",
  "{{days}}天": "{{days}}日",
  "作品锚点：": "作品アンカー：",
  "显示": "表示",
  "不显示": "非表示",
  "个人名片": "個人名刺",
  "个人名片:": "個人名刺:",
  "产品价格：": "製品価格：",
  "还未设置名片信息，": "名刺情報が未設定です。",
  "立即设置": "今すぐ設定",
  "编辑": "編集",
  "请选择介绍内容": "紹介コンテンツを選択してください",
  "请选择作品": "作品を選択してください",
  "请选择产品": "製品を選択してください",
  "预览": "プレビュー",
  "分享标题：": "シェアタイトル：",
  '请输入分享标题': "シェアタイトルを入力してください",
  '请输入分享描述': "シェアの説明を入力してください",
  "设置名片信息": "名刺情報を設定",
  "设置成功": "設定しました",
  "姓名不能为空": "氏名を入力してください",
  "职位": "役職",
  "电话": "電話",
  "电话不能为空": "電話番号を入力してください",
  "微信号": "WeChat ID",
  "微信号_供应商管理": "WeChat",
  "联系地址": "連絡先住所",
  "联系地址不能为空": "連絡先住所を入力してください",
  "logo不得为空": "ロゴは必須です",
  "建议尺寸50*50，png图片": "推奨サイズ：50×50、PNG形式",
  "确认": "OK",
  "全部导出": "すべてエクスポート",
  "部分导出": "一部エクスポート",
  "国内二维码": "国内QRコード",
  "海外二维码": "海外QRコード",
  "产品二维码": "製品QRコード",
  "供应商": "サプライヤー",
  "热门品牌": "人気ブランド",
  "封面": "カバー",
  "一键导出二维码": "QRコードを一括エクスポート",
  "退出导出": "エクスポートを終了",
  "基础信息": "基本情報",
  "未分组": "未分類",
  "使用微信、钉钉APP扫码分享": "WeChat／DingTalkでQRコードを読み取り、シェア",
  "也可以复制链接发送给小伙伴": "リンクをコピーして友達に送ることもできます",
  "复制链接": "リンクをコピー",
  "生成图片": "画像を生成",
  "生成失败": "生成に失敗しました",
  "产品信息不存在": "製品情報が存在しません",
  "长按图片保存或分享": "画像を長押しして保存またはシェア",
  "长按图片保存到相册": "画像を長押ししてアルバムに保存",
  "已加入咨询清单": "お問い合わせリストに追加しました",
  "加入失败": "追加に失敗しました",
  "请先选择规格": "先に仕様を選択してください",
  "请先选择产品": "先に製品を選択してください",
  "个月": "ヶ月",
  " 天": " 日",
  "条数据": "件のデータ",
  "取消选择": "選択を解除",
  "请选择下载附件": "ダウンロードする添付ファイルを選択",
  "请选择日期": "日付を選択してください",
  "至少选择一个附件": "添付ファイルを1つ以上選択",
  "下载": "ダウンロード",
  "高清贴图": "高解像度テクスチャ",
  "请选择节点": "ノードを選択してください",
  "请选择图片": "画像を選択してください",
  "请先上传贴图": "先にテクスチャ画像をアップロードしてください",
  "没有匹配的SKU": "該当するSKUがありません",
  "下载素材": "素材をダウンロード",
  "编辑封面": "表紙を編集",
  "名称 ": "名前",
  "已失效": "失効済み",
  "未过审原因": "未承認の理由",
  "我知道了": "わかりました",
  "封面图不可取消勾选！": "カバー画像は選択解除できません",
  "默认比例": "デフォルト比率",
  "自由比例": "自由比率",
  "切换为暗色": "ダークモードに切り替え",
  "切换为亮色": "ライトモードに切り替え",
  "链接已失效": "リンクは失効しました",
  "链接访问次数已达上限": "リンクのアクセス回数が上限に達しました",
  "取消全选": "全選択解除",
  "贴图库": "テクスチャライブラリ",
  "搜索贴图": "テクスチャを検索",
  "文件夹（{{count}}）": "フォルダー（{{count}}）",
  "图片（{{count}}）": "画像（{{count}}）",
  "已关联不可重复关联": "すでに連携済みです",
  "已关联": "連携済み",
  "请至少勾选一张关联图": "関連画像を1枚以上選択してください",
  "退出全选": "すべて選択解除",
  "项": "項目",
  "请选择要下载的图片": "ダウンロードする画像を選択してください",
  "请输入自定义有效期天数！": "カスタム有効期限の日数を入力してください",
  "暂无权限": "権限がありません",
  "进入管理": "管理画面へ",
  "进入空间": "スペースを開く",
  "成功关注": "フォローしました",
  "已关注": "フォロー中",

  "取消成功！": "キャンセルしました",
  "取消成功": "キャンセルしました",
  //作品
  "更多筛选": "絞り込み条件をさらに表示",
  "更少筛选": "絞り込み条件を閉じる",
  "随机排序": "ランダム順",
  "小卡片": "小さいカード",
  "大卡片": "大きいカード",
  "链接有效期：": "リンク有効期限：",
  "个项目": "件のプロジェクト",
  "共{{total}}个项目": "合計{{total}}件のプロジェクト",
  "作品分享": {
    "介绍": "紹介"
  },
  "锚点": "アンカーポイント",
  "暂无高清贴图": "高解像度テクスチャがありません",
  "暂无锚点": "アンカーがありません",
  "当前私域未认证": "プライベートスペース未認証",
  "已删除": "削除済み",
  "暂无": "なし",
  "查看权限": "閲覧権限",
  "未发布": "未公開",
  "YYYY年M月": "YYYY年M月",
  "未开通海外版": "海外版は有効になっていません",
  "暂无名片": "名刺情報がありません",
  "项目管理": "プロジェクト管理",
  "盘八斗项目": "Panbadouプロジェクト",
  "关联盘八斗项目管理": "Panbadouプロジェクト管理と連携",
  "排序依据": "並べ替え基準",
  "随机的": "ランダム",
  "名字": "名前",
  "时间正序": "時間昇順",
  "时间倒序": "時間降順",
  "排序": "並び替え",
  "产品下载：": "製品ダウンロード：",
  "允许": "許可",
  "禁止": "禁止",
  "颜色筛选": "色で絞り込み",
  "颜色筛选结果": "色で絞り込んだ結果",
  "请在电脑上进行批量下载": "パソコンで一括ダウンロードしてください",
  "确认清单": "選択内容の確認",

  '入库权限未开放': "登録権限が付与されていません",
  "下载权限未开放": "ダウンロード権限が付与されていません",
  "可以通过联系人获得产品入库权限": "担当者から製品登録権限を取得できます",
  "可以通过联系人获得产品下载权限": "担当者から製品ダウンロード権限を取得できます",
  "{{authName}}权限未开放": "{{authName}}権限が付与されていません",
  "可以通过联系人获得产品{{authName}}权限": "担当者から製品{{authName}}権限を取得できます",
  "联系人:": "連絡先：",
  "手机号:": "電話番号：",
  "入库": "登録",
  "入库失败": "入庫失敗",
  "入库失败,数据完整性校验未通过": "入庫失敗、データ整合性チェックに失敗しました",
  "入库至": "登録先",
  "选择入库的产品将加入每个私域的未入库列表，需要管理员的确认才能成功入库": "登録する製品は各プライベートスペースの「未登録」リストに追加され、管理者の承認後に登録が完了します。",
  '请至少勾选一条！': "1つ以上選択してください",
  "入库成功！": "登録しました",
  "入库成功": "登録しました",
  "发布成功": "公開しました",
  "合作": "提携",
  "默认分组": "デフォルトグループ",
  "中文": "中国語",
  "中文N": "中国語",
  "默认使用首个开启的语言": "デフォルトでは、最初に有効にした言語が使用されます",
  "英文": "英語",

  "当前私域的主体认证未通过，无法访问": "現在のプライベートスペースは事業者認証が承認されていないため、アクセスできません",
  "返回上一级": "前の階層に戻る",
  "上传日期": "アップロード日",
  "大小": "サイズ",
  "按名称": "名前順",
  "按时间": "時間順",
  "按大小": "サイズ順",
  "这里还没有合作方的介绍": "ここにはまだ提携先の紹介がありません",
  "创建私域": "スペース作成",
  "切换私域": "スペース切替",
  "未查到相关私域": "該当するプライベートスペースが見つかりません",
  "已入库": "登録済み",
  "我拥有": "所有するスペース",
  "推荐成功！": "おすすめしました",
  "成功！": "完了しました",
  "提示": "お知らせ",
  "会员状态确认中，请稍候": "会員ステータスを確認中です。しばらくお待ちください",
  "协议模板未配置": "規約テンプレートが未設定です",
  "请使用电脑打开链接！": "パソコンでリンクを開いてください",
  "浙ICP备17033477号-5": "浙江省ICP番号17033477-5",
  "绑定手机号/邮箱": "携帯電話番号・メールアドレスを連携",
  "绑定成功！": "連携しました",
  "请输入验证码!": "認証コードを入力してください",
  "请先完成拼图": "まずはパズルを完成させてください",
  "请按住滑块拖动完成拼图": "スライダーを押したままドラッグしてパズルを完成させてください",
  "该私域": "このプライベートスペース",
  "盘子登录": "Panziログイン",
  "支付宝登录": "Alipayログイン",
  "登录/注册": "ログイン／新規登録",
  "注册登录协议说明": "登録またはログインすることで、<user>『ユーザー利用規約』</user>、<privacy>『プライバシーポリシー』</privacy>および<child>『児童の個人情報保護規則および保護者向けの注意事項』</child>に同意したものとみなされます。",
  "注册登录协议说明2": "登録またはログインすることで、<user>『ユーザー利用規約』</user>、<privacy>『プライバシーポリシー』</privacy>、<child>『児童の個人情報保護規則および保護者向けの注意事項』</child><contracts/>に同意したものとみなされます",
  "两个协议之间连接的文案":"、",
  "最后一个协议和倒数第二个协议连接的文案":"および",
  "登录": "ログイン",
  "验证码登录":"認証コードでログイン",
  "密码登录":"パスワードでログイン",
  "微信登录":"WeChatログイン",
  "验证码": "認証コード",
  "发送验证码": "認証コードを送信",
  "已发送": "送信済み",
  "账号密码登录": "パスワードでログイン",
  "密码": "パスワード",
  "忘记密码": "パスワードを忘れた",
  "请完成拼图": "パズルを完成させてください",
  "验证码登录/注册": "認証コードでログイン／登録",
  "密码至少6~18个字符": "パスワードは6〜18文字で入力",
  "请输入有效手机号码!": "有効な携帯番号を入力してください",
  "请输入正确的手机号或邮箱账号!": "正しい携帯電話番号またはメールアドレスを入力してください。",
  "验证码不能为空!": "認証コードを入力してください",
  "密码不能为空!": "パスワードを入力してください",
  "确保密码长度是 6-16 位": "パスワードは6〜16文字で入力",
  "密码不允许纯数字": "数字のみのパスワードは使用できません",
  "只能输入数字、英文字母和符号": "入力可：数字・英字・記号のみ",
  "密码中不能出现 3 位以上连续字符（如aaaa,1234）": "パスワードに3文字以上の連続した文字（例：aaaa、1234）は使用できません",
  "找回密码": "パスワードを再設定",
  "以下信息仅私域管理员查看": "以下はスペース管理者のみ閲覧可",
  "客户": "顧客",
  // "联系方式":"contact information",
  "详细地址": "詳細住所",
  "验证码错误！": "認証コードが正しくありません！",
  "密码错误！": "パスワードが正しくありません！",
  "入库请先登录": "登録するにはログインしてください",
  "下载请先登录": "ダウンロードするにはログインしてください",
  "分享请先登录": "シェアするにはログインしてください",
  "设置新密码": "新しいパスワードを設定",
  "输入新密码": "新しいパスワードを入力",
  "请确认您的密码!": "パスワードを確認してください！",
  "您输入的两个密码不匹配!": "入力した2つのパスワードが一致しません！",
  "输入确认密码": "確認用パスワードを入力",
  "登录不觉账号": "Bujueアカウントにログイン",
  "注册不觉账号并加入 {{privateDomainName}} 会员,享受会员专属权益与服务。": "Bujueアカウントを作成して{{privateDomainName}}の会員に登録すると、会員限定の特典とサービスをご利用いただけます。",
  "由不觉科技提供技术支持": "技術提供：Bujue Technology",
  "Powered By Bujue": "Powered By Bujue",
  "二维码加载中...": "二维码加载中...",
  "二维码加载失败，请重试": "二维码加载失败，请重试",
  "重新加载": "再読み込み",
  "微信登录二维码": "微信登录二维码",
  "使用微信扫一扫登录“不觉”": "WeChatでQRコードをスキャンして\"Bujue\" にログイン",
  "使用微信扫一扫登录“不觉空间”": "WeChatでQRコードをスキャンして\"Bujue Space\" にログイン",
  "返回其他登录方式": "返回其他登录方式",
  "其他登录方式": "他のログイン方法",
  "使用微信登录": "使用微信登录",
  "暂无可入库私域": "登録先として選択できるプライベートスペースがありません",
  "搜索": "検索",
  "修改密码成功！": "パスワードを変更しました",
  "请间隔5秒后再点击": "5秒後に再度クリックしてください",
  // "正序":"Positive sequence",
  // "倒序":"Reverse order",
  "置顶": "トップに固定",

  "产品库": "製品ライブラリ",
  "筛选颜色": "カラーで絞り込み",
  "收起更多筛选": "絞り込みを閉じる",
  "效果图": "完成イメージ",
  "素材图": "素材画像",
  "委托添加": "登録を依頼",
  "手动添加": "手動追加",
  "批量添加": "一括追加",
  "批量替换": "一括置き換え",
  "确认批量操作": "一括操作を確認",
  "确认批量替换贴图吗？": "テクスチャを一括置換しますか？",
  "确认批量添加贴图吗？": "テクスチャを一括追加しますか？",
  "贴图数量超过上限": "テクスチャ数が上限を超えています",
  "未入库": "未登録",
  "产品空间": "製品スペース",
  "公域产品管理": "パブリック製品管理",
  "已上架": "掲載済み",
  "展开更多筛选": "絞り込みを開く",
  "管理": "管理",
  "产品分类": "製品分類",
  "材料属性": "材料属性",
  "固定周期": "固定納期",
  "区间周期": "納期範囲",
  "新增字段": "フィールドを追加",
  "新增分类": "分類を追加",
  "上传/关联贴图": "テクスチャのアップロード／関連付け",
  "标签": "タグ",
  "备注": "備考",
  "保存": "保存",
  "介绍页Tab名称不能重复": "紹介ページのタブ名は重複できません",
  "名称不能重复！": "名前が重複しています",
  "名称不能重复": "名前が重複しています",
  "请输入字段名称": "フィールド名を入力してください",
  "双击修改字段名称": "ダブルクリックでフィールド名を編集",
  "确定要删除吗?": "削除してもよろしいですか？",
  "您确定要批量删除选中的图片吗?": "選択した画像を一括削除してもよろしいですか？",
  "确定要删除选中的图片，并同步删除备份在不觉云的原图吗？": "選択した画像を削除し、Bujueクラウドにバックアップされた元画像も一緒に削除しますか？",
  "同步删除": "同時に削除",
  "只删图片": "画像のみ削除",
  "删除图片": "画像を削除",
  "同时删除不觉云备份文件": "Bujueクラウドのバックアップも削除",
  "其他款式同步删除": "他のバリエーションからも削除",
  "请选择": "選択してください",
  "请选择{{name}}": "{{name}}を選択してください",
  "不觉云存储空间不足": "Bujueクラウドの空き容量が不足",
  "系列型号": "シリーズ・型番",
  "区间价格": "価格範囲",
  "固定价格": "固定価格",
  "参数价格不能只填一个!": "パラメータ価格は片方だけ入力できません",
  "最低参考价不能大于或等于最高参考价!": "最低参考価格は最高参考価格以上にできません！",
  "请填写材质": "材質を入力してください",
  "尺寸规格": "寸法・仕様",
  "请填写尺寸": "サイズを入力してください",
  "检测到未上传贴图，请先上传哦！": "テクスチャが未アップロードです。先にアップロードしてください",
  "所有产品名称": "すべての製品名",
  "拖动可以排序": "ドラッグで並べ替え",
  "至少保留一张贴图": "テクスチャを1枚以上残してください",
  "已关联贴图": "関連付け済みテクスチャ",
  "产品介绍": "製品紹介",
  "多图片": "複数画像",
  "多文档": "複数ドキュメント",
  "清空": "クリア",
  "请完善款式信息！": "バリエーション情報を入力してください",
  "请完善当前款式信息！": "現在のバリエーション情報を入力してください",
  "封面还未上传完！": "表紙のアップロードが未完了です",
  "款式信息未完善": "バリエーション情報未入力",
  "点击/拖入单个PDF文档": "クリックまたはドラッグ＆ドロップでPDFを選択",
  "将文件拖拽至此区域或点击添加": "ここにファイルをドロップ、またはクリックして追加",
  "支持PDF、WORD、EXCEL、3DMAX、SKP、CAD、Revit等格式": "PDF、WORD、EXCEL、3DMAX、SKP、CAD、Revitなどの形式に対応",
  "正在上传中...": "アップロード中…",
  "上传未完成之前，请勿保存或发布，否则可能数据错误": "アップロード完了前に保存・公開しないでください。データが不正になる可能性があります",
  "点击/拖入图片": "クリックまたはドラッグで画像を追加",
  "还未上传图片": "画像未アップロード",
  "请上传图片": "画像をアップロードしてください",
  "“点击” 或 “拖入” 替换图片": "クリックまたはドラッグ＆ドロップで画像を差し替え",
  "遮罩颜色": "マスク色",
  "模糊效果": "ぼかし効果",
  "拖动图片可以排序": "ドラッグで画像を並べ替え",
  "已上传图片": "アップロード済み画像",
  "标签最多5个，有助于提升产品在紫菜海洋的搜索概率": "タグは最大5個まで。紫菜海洋での検索されやすさが向上します",
  "贴图分类": "テクスチャ分類",
  "图片": "画像",
  "关联已有贴图": "既存のテクスチャを関連付け",
  "拖动图片可以排序, 限制20张": "ドラッグで並べ替え（最大20枚）",
  "每次限20张": "1回20枚まで",
  "管理产品": "製品を管理",
  "新增服务": "サービスを追加",
  "标签不能重名！": "タグ名が重複しています！",
  "标签名称不能为空": "タグ名を入力してください",
  "最多可选5个标签!": "タグは最大5個まで選択できます！",
  "确定要删除吗?已关联产品中的对应标签会一并删除！": "削除してもよろしいですか？関連製品の対応するタグも一緒に削除されます！",
  "添加": "追加",
  "添加标签": "タグを追加",
  "已上架：": "掲載済み：",
  "关联品牌": "ブランドを関連付け",
  // "产品":"Product",
  "地址": "住所",
  "服务区域": "サービスエリア",
  "上传合约": "契約書をアップロード",
  "终止日期": "終了日",
  "操作": "操作",
  "删除": "削除",
  "个品牌": "ブランド",
  "查看合约": "契約書を表示",
  "设为必填": "必須に設定",
  "取消必填": "必須を解除",
  "产品列表": "製品リスト",
  "进入管理模式": "管理モードへ",
  "进入封面": "表紙へ",
  "我在私域的昵称": "ニックネーム",
  "修改我在私域的昵称": "ニックネームを変更",
  "请输入昵称": "ニックネームを入力してください",
  "私域中的昵称": "スペース内のニックネーム",
  "暂无签名": "自己紹介文は未設定です",
  "你不在该私域": "このプライベートスペースに所属していません",
  "私域工作台": "スペースダッシュボード",
  "退出工作台": "ダッシュボードを終了",
  "退出管理": "管理を終了",
  "浏览模式": "閲覧モード",
  "管理模式": "管理モード",
  "全屏": "全画面",
  "退出全屏": "全画面を終了",
  "权限提醒": "権限のお知らせ",
  "背景设置": "背景設定",
  "添加品牌": "ブランドを追加",
  "品牌logo": "ブランドロゴ",
  "筛选时不能进行编辑操作": "絞り込み中は編集できません",
  "将同时删除产品": "製品も同時に削除されます",
  "编辑品牌": "ブランドを編集",
  "品牌名称": "ブランド名",
  "请输入品牌名称": "ブランド名を入力してください",
  "请选择类型": "タイプを選択してください",
  "国家": "国",
  "请输入国家": "国を入力してください",
  "请选择国家": "国を選択してください",
  "分组": "グループ",
  "分组名不可重复": "グループ名は重複できません",
  "更多": "もっと見る",
  "更多颜色": "色をもっと見る",
  "收起": "折りたたむ",
  "是否确认删除": "削除してもよろしいですか",
  "删除成功": "削除しました",
  "邀请": "招待",
  "复制成功！": "コピーしました",
  "复制成功": "コピーしました",
  "请输入供应商公司名称": "サプライヤーの会社名を入力してください",
  "头像": "プロフィール画像",
  "请选择区域": "地域を選択してください",
  "请输入联系人": "担当者名を入力してください",
  "请输入电话": "電話番号を入力してください",
  "请输入微信号": "WeChat IDを入力してください",
  "请输入正确的手机号": "正しい携帯電話番号を入力してください",
  "添加客服微信": "カスタマーサポートのWeChatを追加",
  "留下您的联系方式": "連絡先を残してください",
  "私域设置": "スペース設定",
  "私域信息": "スペース情報",
  "私域安全": "セキュリティ",
  "成员管理": "メンバー管理",
  "权限管理": "権限管理",
  "模块管理": "モジュール管理",
  "物料板": "マテリアルボード",
  "分享管理": "シェア管理",
  "小程序管理": "ミニプログラム管理",
  "主体认证": "事業者認証",
  "付费服务": "有料サービス",
  "容量": "容量",
  "原套餐已到期，部分功能不可再用，请及时续费": "以前のプランは期限切れです。一部の機能は利用できません。お早めに更新してください",
  "多语言": "多言語",
  "已开通": "有効化済み",
  "未开通": "無効",
  "订单详情": "注文詳細",
  "支付宝支付": "Alipay決済",
  "微信支付": "WeChat Pay",
  "支付成功": "お支払いが完了しました",
  "添加客服企业微信，为您匹配专属客户成功团队服务支持，对您进行不觉产品一对一指导": "WeComを追加すると、専任のカスタマーサクセスチームによる Bujue の1対1サポートを受けられます。",
  "添加客服企业微信，获取更多资讯":"WeComを追加して最新情報を受け取る",
  "请使用支付宝扫码支付": "Alipayでスキャンしてお支払いください",
  "请使用微信扫码支付": "WeChatでスキャンしてお支払いください",
  "取消支付": "支払いをキャンセル",
  "确认取消支付吗？": "支払いをキャンセルしますか？",
  "完成": "完了",
  "{{name}}页": "{{name}}ページ",
  "提交成功！": "送信しました",
  "信息提交成功！": "情報を送信しました",
  "信息保存成功！": "情報を保存しました",
  "审核通过！": "審査通過",
  "恭喜获得认证标识，如要修改信息请前往私域设置-主体认证": "認証バッジの取得おめでとうございます。情報を変更するには、スペース設定－事業者認証へ移動してください",
  "主体认证审核中": "事業者認証審査中",
  "信息审核预计在1～2工作日内完成，审核完成后，登录不觉会有弹框提醒您": "情報審査は1～2営業日以内に完了する見込みです。審査完了後、Bujueにログインするとポップアップでお知らせします",
  "审核工作时间：周一～周五，9:00-17:30": "審査対応時間：月曜～金曜、9:00-17:30",
  "不觉客服": "Bujueカスタマーサービス",
  "扫码添加客服，有任何问题请联系我们": "QRコードをスキャンしてカスタマーサービスを追加してください。ご不明な点がございましたらお問い合わせください",
  "订单号": "注文番号",
  "套餐": "プラン",
  "实付": "支払い金額",
  "购买时间": "購入日時",
  "生效时间": "適用開始日時",
  "到期时间": "有効期限",
  "发票": "請求書",
  "已抵扣": "相殺済み",
  "已升级": "アップグレード済み",
  "永久有效": "永久に有効",
  "开票": "請求書を発行",
  "作废": "無効にする",
  "开票中": "発行中",
  "开票失败": "請求書発行失敗",
  "重试": "再試行",
  "重开": "再発行",
  "发票作废中": "請求書無効化中",
  "申请重开发票成功": "請求書再発行の申請が完了しました",
  "确认作废发票吗？": "この請求書を無効化しますか？",
  "申请发票作废中": "請求書の無効化を申請中です",
  "确认开票信息": "請求書情報の確認",
  "选择开票信息": "請求書情報の選択",
  "添加开票信息": "請求書情報を追加",
  "确认开票": "発行を確認",
  "单位": "法人",
  "个人": "個人",
  "普票": "普通請求書",
  "专票": "専用請求書",
  "发票抬头": "請求書名義",
  "请输入发票抬头": "請求書名義を入力してください",
  "税号": "納税者番号",
  "请输入税号": "納税者番号を入力してください",
  "格式有误": "形式が正しくありません",
  "注册电话(包括区号)": "登録電話番号（市外局番を含む）",
  "请输入注册电话(包括区号)": "登録電話番号を入力してください（市外局番を含む）",
  "注册地址": "登録住所",
  "请输入注册地址": "登録住所を入力してください",
  "银行账号": "銀行口座番号",
  "请输入银行账号": "銀行口座番号を入力してください",
  "开户银行": "金融機関名",
  "请输入开户银行": "金融機関名を入力してください",
  "请输入姓名": "氏名を入力してください",
  "身份证": "身分証番号",
  "请输入身份证": "身分証番号を入力してください",
  "个人普票": "個人普通請求書",
  "注册电话": "登録電話番号",
  "开票失败，请": "請求書の発行に失敗しました、",
  "已购买": "購入済み",
  "认证流程：": "認証プロセス：",
  "准备营业执照、公司法人信息": "営業許可証と法人代表者情報を準備",
  "在线填写认证基本信息": "オンラインで認証基本情報を入力",
  "上传公司法人信息": "会社法人情報をアップロード",
  "完成提交等待官方审核": "提出完了後、公式審査をお待ちください",
  "完成主体认证，您的私域可以获得以下权限": "事業者認証を完了すると、プライベートドメインで以下の権限が得られます",
  "认证标识": "認証バッジ",
  "发布空间": "公開スペース",
  "开通小程序": "ミニプログラムを有効化",
  "访客权限": "ゲスト権限",
  "私域人数可以超过50人": "プライベートドメインのメンバー数が50人を超えられます",
  "作品分享查看锚点": "作品共有時の閲覧アンカーポイント",
  "认证须知：": "認証に関する注意事項：",
  "私域名称提交后，修改名称需要再次提交认证流程": "プライベートドメイン名を提出後、名称を変更する場合は認証プロセスを再度提出する必要があります",
  "填写前请准备好：营业执照、公司法人证件信息。如果主体资质虚假、不符合资质审核标准的，将做认证失败处理。": "記入前に準備してください：営業許可証、会社法人の身分証明情報。事業者の資格が虚偽であるか、審査基準を満たさない場合、認証失敗として処理されます。",
  "完成主体认证，你可以获得以下权限：认证标识、发布空间、开通小程序、私域人数可以超过50人、作品分享查看锚点": "事業者認証を完了すると、以下の権限が得られます：認証バッジ、公開スペース、ミニプログラムの有効化、プライベートドメインのメンバー数50人超え、作品共有時の閲覧アンカーポイント",
  "驳回原因：": "却下理由：",
  "账号信息": "アカウント情報",
  "私域名称不能为空！": "スペース名は必須です",
  "请输入私域名称": "スペース名を入力",
  "账号名称需与主体企业、或品牌商标信息一致，例如主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词等": "アカウント名は事業者企業またはブランド・商標情報と一致させる必要があります。例えば、事業者が「杭州Bujue科技有限公司」の場合、アカウント名は「Bujue科技有限公司」「杭州Bujue科技」「Bujue科技＋業界属性語」などが使用可能です",
  "查看更多规范": "さらに規則を見る",
  "私域Logo": "プライベートドメインロゴ",
  "私域Logo不能为空！": "プライベートドメインロゴは空にできません",
  "私域类型": "プライベートドメインタイプ",
  "私域类型不能为空！": "プライベートドメインタイプは空にできません！",
  "请选择私域类型": "プライベートドメインタイプを選択してください",
  "设计团队": "デザインチーム",
  "产品团队": "プロダクトチーム",
  "机构（协会）": "機関（協会）",
  "装修企业": "内装企業",
  "主体信息": "事業者情報",
  "企业名称": "会社名",
  "请输入企业名称": "会社名を入力してください",
  "营业执照": "営業許可証",
  "主营业务": "主要事業",
  "请输入主营业务": "主要事業を入力してください",
  "法人验证": "法人認証",
  "法人姓名": "法人代表者名",
  "请输入法人姓名": "法人代表者名を入力してください",
  "法人身份证号": "法人代表者の身分証番号",
  "请输入法人身份证号": "法人代表者の身分証番号を入力してください",
  "法人身份证信息": "法人代表者の身分証情報",
  "身份证正面": "身分証表面",
  "身份证反面": "身分証裏面",
  "人脸识别": "顔認証",
  "法人未认证": "法人代表者が未認証です",
  "用微信扫码，完成人脸识别": "WeChatでスキャンして顔認証を完了してください",
  "已认证成功，如需修改，": "認証済みです。変更する場合は、",
  "请重新认证": "再認証してください",
  "法人认证成功": "法人代表者の認証に成功しました",
  "同意并遵守": "同意して遵守する",
  "《不觉私域主体认证须知》": "「Bujueプライベートドメイン事業者認証に関する注意事項」",
  "，确保提供的信息及材料真实有效": "提供する情報及び資料が真実かつ有効であることを保証します",
  "未勾选服务协议": "サービス規約が未チェックです",
  "企业名称不能为空！": "会社名は空にできません",
  "请上传营业执照！": "営業許可証をアップロードしてください",
  "请上传最新版三证合一的营业执照清晰正面图，或清晰完整的组织机构代码证": "最新版の三証合一営業許可証の鮮明な正面画像、または鮮明で完全な組織コード証をアップロードしてください",
  "主营业务不能为空！": "主要事業は空にできません",
  "法人姓名不能为空！": "法人代表者名は空にできません",
  "法人身份证号不能为空！": "法人代表者の身分証番号は空にできません",
  "请上传身份证正面！": "身分証の表面をアップロードしてください",
  "请上传身份证反面！": "身分証の裏面をアップロードしてください",
  "请完成人脸识别！": "顔認証を完了してください",
  "认证{{status}}": "認証{{status}}",
  "命名规范": "命名規則",
  "1、账号名称需命名规范，与主体企业、或品牌商标信息一致：": "1、アカウント名は命名規則に従い、事業者名またはブランド・商標情報と一致させる必要があります：",
  "使用认证主体企业命名：即与营业执照名称保持一致，支持企业全称或简称；如：主体公司为杭州不觉科技有限公司，账号名称可使用：不觉科技有限公司、杭州不觉科技、不觉科技＋行业属性词（例：不觉科技设计师平台）": "認証事業者の企業名を使用：営業許可証の名称と一致させ、正式名称または略称に対応；例：事業者が「杭州Bujue科技有限公司」の場合、アカウント名は「Bujue科技有限公司」「杭州Bujue科技」「Bujue科技＋業界属性語」（例：Bujue科技デザイナープラットフォーム）などが使用可能",
  "使用品牌/商标信息命名，需提供对应资质；如：主体为可口可乐公司，账号名称可使用：芬达饮品": "ブランド・商標情報での命名には、対応する資格証明の提出が必要です；例：事業者がコカ・コーラ社の場合、アカウント名は「ファンタ飲料」などが使用可能",
  "如是app、网站支持使用app/网站命名，需提供对应资质；如：app软著中全称为星野软件，账号名称可以为星野软件、星野、星野App等；": "アプリやウェブサイトの場合、アプリ/サイト名での命名に対応、対応する資格証明が必要です；例：アプリのソフトウェア著作権登録の正式名称が「星野ソフトウェア」の場合、アカウント名は「星野ソフトウェア」「星野」「星野App」などが使用可能；",
  "2、账号名称不超过40字，仅支持特殊符号如下：“”、“ ”、“”、“ ”、“ 、“《》”，其他特殊符号不支持": "2、アカウント名は40文字以内とし、使用できる特殊記号は以下のみです：「」、「 」、「」、「 」、「 、《》」。その他の特殊記号は使用できません",
  "3、账号名称&头像，不得含有歧义、侵犯、仿冒官方等内容，不能有广告法禁用词，如“第一”、“最”；": "3、アカウント名＆アイコンには、誤解を招く内容、権利侵害、公式のなりすまし等を含めることはできず、広告法で禁止されている「No.1」「最高」等の語句も使用できません；",
  "4、账号名称&头像，如包含品牌名/商标，需选择对应品牌并提供商标注册证或相关授权材料；": "4、アカウント名＆アイコンにブランド名・商標が含まれる場合、対応するブランドを選択し、商標登録証明書または関連する許可資料を提出する必要があります；",
  "5、账号名称不得单独使用人名、或以人名作结尾，不得为职位化昵称，如：XX董事长、XX厂长、XX经理，不得含有“招商”、“加盟”字样；如您后续需开通店铺，请确保名称中不含“旗舰店”、“专卖店”、“集合店”、“卖场型旗舰店”、“工厂店”等字样，否则入驻店铺将被驳回。": "5、アカウント名は人名のみ、または人名で終わることはできず、役職付きニックネーム（例：XX会長、XX工場長、XXマネージャー）も不可、また「招商」「加盟」の語句を含めることはできません；今後ショップを開設する場合、名称に「旗艦店」「専門店」「セレクトショップ」「メガ旗艦店」「工場直売店」等の語句を含めないようにしてください。含まれる場合、出店申請は却下されます。",
  "没有私域信息": "プライベートドメイン情報がありません",
  "分享人": "シェアした人",
  "统一联系人": "統一担当者",
  "设置": "設定",
  "图片水印：": "画像透かし：",
  "logo水印": "ロゴ透かし",
  "作品下载：": "作品ダウンロード：",
  "官网入口：": "公式サイト入口：",
  "产品入库：": "製品の登録：",
  "单图logo": "単一ロゴ",
  "平铺logo": "タイル状ロゴ",
  "透明度": "透明度",
  "请输入透明度": "透明度を入力してください",
  "更换Logo": "ロゴを変更",
  "至少保留一个内容!": "コンテンツを1件以上残してください",
  "拖动调整顺序": "ドラッグして並べ替え",
  "目录": "メニュー",
  "访客登录设置": "訪問者ログイン設定",
"登录注册": "ログイン/登録",
"需要": "必要",
"不需要": "不要",
"登录触发条件": "ログイントリガー条件",
"累计查看": "累計閲覧",
"进入小程序": "ミニプログラムに入る",
"分钟": "分",
"触发后登录": "トリガー後にログイン",
"必须登录": "ログイン必須",
"不必须登录": "ログイン不要",
"图片水印": "画像透かし",
"分享封面": "共有カバー",
"头部背景图": "ヘッダー背景画像",
"图片限制规格：5:4尺寸，<200KB，png图片": "画像制限：5:4比率、200KB未満、PNG画像",
"图片限制：<800KB，png图片": "画像制限：800KB未満、PNG画像",
"图片大小超过上限": "画像サイズが上限を超えています",
"内容管理": "コンテンツ管理",
"客户管理": "顧客管理",
"下载用户清单": "ユーザーリストをダウンロード",
"未认证": "未認証",
"已通过": "承認済み",
"VR展厅": "VRショールーム",
  "不觉云": "Bujueクラウド",
  "工具箱": "ツールボックス",
  "查看为基础权限，如需取消查看权限，请关闭模块开关": "閲覧は基本権限です。閲覧権限を解除する場合はモジュールスイッチをオフにしてください",
  "近期上线": "近日公開",
  "素材、模型可应用于创意板、画图软件等": "素材やモデルは、クリエイティブボードや描画ソフトなどで利用できます。",
  "访客": "訪問者",
  "私域管理员": "プライベートドメイン管理者",
  "管理员拥有所有权限": "管理者はすべての権限を持ちます",
  "完成主体认证，才能解锁访客访问": "事業者認証を完了すると、ゲストがアクセスできるようになります。",
  "审核中": "審査中",
  "查看供应商": "サプライヤーを閲覧",
  "查看联系方式": "連絡先を閲覧",
  "查看合同": "契約書を閲覧",
  "查看备注": "備考を閲覧",
  "素材应用": "素材を適用",
  "导出产品二维码": "製品QRコードをエクスポート",
  "隐藏系统文件夹": "システムフォルダを非表示",
  "价格显示": "価格表示",
  "成员": "メンバー",
  "管理员": "管理者",
  "二级管理员": "サブ管理者",
  "未加入": "未参加",
  "申请加入": "参加を申請",
  "申请成功": "申請しました",
  "等待管理员审核": "管理者の承認待ち",
  "已申请": "申請済み",
  "{{count}}秒后自动进入私域": "{{count}}秒後に自動的にプライベートスペースへ移動します",
  "进入私域": "プライベートスペースへ",
  "您已是该私域成员": "すでにこのプライベートスペースのメンバーです",
  "打开APP": "アプリを開く",
  "我": "自分",
  "仅管理员可以操作": "管理者のみ操作できます",
  "加入日期": "参加日",
  "确定退出当前私域？": "このプライベートドメインを退出しますか？",
  "同意": "同意",
  "拒绝": "拒否",
  "加入成功": "参加しました",
  "无可删除的成员": "削除できるメンバーがいません",
  "操作成功": "操作が完了しました",
  "退出失败": "退出に失敗しました",
  "退出成功": "退出しました",
  "无可操作的成员": "操作可能なメンバーがいません",
  "无可操作产品": "操作できる製品がありません",
  "刷新成功": "更新しました",
  "批量编辑": "一括編集",
  "编辑项目信息": "プロジェクト情報を編集",
  "导出": "エクスポート",
  "导出选中项": "選択項目をエクスポート",
  "导出全部数据": "すべてのデータをエクスポート",
  "确认导出当前选中的数据吗？": "選択中のデータをエクスポートしますか？",
  "确认导出当前全部数据吗？": "現在のデータをすべてエクスポートしますか？",
  "确认导出当前搜索结果中的全部数据吗？": "現在の検索結果のデータをすべてエクスポートしますか？",
  "创建人": "作成者",
  "创建时间": "作成日時",
  "更新时间": "更新日時",
  "根据协议，当前项目信息将向{{team}}披露": "契約に基づき、本プロジェクトの情報は {{team}} に開示されます。",
  "当前项目信息将向{{team}}披露": "現在のプロジェクト情報は{{team}}に開示されます",
  "本私域": "このプライベートドメイン",
  "添加成员": "メンバー追加",
  "邀请成员": "メンバーを招待",
  "使用微信、钉钉APP扫码加入": "WeChatまたはDingTalkでスキャンして参加",
  "成员加入需管理员审核": "メンバーの参加には管理者の承認が必要です",
  "批量编辑时，修改任一成员信息，会同步其他已选成员": "一括編集時、いずれかのメンバー情報を変更すると、他の選択済みメンバーにも同期されます",
  "批量编辑时，修改任一会员信息，会同步其他已选会员": "一括編集時、いずれかのメンバー情報を変更すると、他の選択済みメンバーにも同期されます",
  "确定要删除选中成员吗？": "選択したメンバーを削除しますか？",
  "确定要删除当前成员吗？": "このメンバーを削除しますか？",
  "角色": "役割",
  "昵称": "ニックネーム",
  "邀请人": "招待者",
  "关联成员": "紐づくメンバー",
  "关联私域": "関連スペース",
  "注册时间": "登録日時",
  "注册来源": "登録経路",
  "最近访问": "最終アクセス",
  "会员标签": "会員タグ",
  "使用中": "使用中",
  "未使用": "未使用",
  "作品分享": "{\"介绍\":\"紹介\"}",
  "小程序分享": "ミニプログラムでシェア",
  "官网分享": "公式サイト",
  "私域会员": "会員",
  "会员管理": "メンバー管理",
  "开启私域会员": "会員機能を有効にする",
  "将私域访客高效沉淀为会员，深度洞察其来源渠道，让运营策略精准施策。": "訪問者を効率よく会員化し、登録経路を深く把握することで、運営施策をより的確に行えます。",
  "开启后，您可轻松查看会员档案、来源归属，并利用标签系统实现灵活的分类与高效管理。": "有効にすると、会員情報や登録経路を簡単に確認でき、タグを使って柔軟な分類と効率的な管理ができます。",
  "立即开启": "今すぐ有効化",
  "校验中": "確認中",
  "开启私域会员管理需完成主体认证，是否前往认证？": "会員管理を有効にするには、事業者認証を完了する必要があります。認証に進みますか？",
  "请先开启会员管理，再开启本功能。否则会导致无法获取访客个人数据": "先に会員管理を有効にしてから、この機能を有効にしてください。有効にしない場合、訪問者の個人データを取得できません。",
  "查看协议": "規約を確認",
  "搜索昵称/手机号/邮箱": "表示名、携帯電話番号、メールアドレスで検索",
  "标签管理": "タグ管理",
  "获取标签失败": "タグの取得に失敗しました",
  "最多可添加1000个标签": "タグは最大1000個まで追加できます",
  "缺少团队信息": "チーム情報がありません",
  "确认删除该标签吗?\n保存后将同步删除用户已绑定的标签": "このタグを削除しますか？\n保存後、ユーザーに紐づいたタグも削除されます",
  "完成主体认证，才能解锁私域会员": "事業者認証を完了すると、プライベート会員を利用できます",
  "开启私域会员，才能解锁会员权限": "プライベート会員を有効にすると、会員権限を利用できます",
  "前往开启": "有効にする",
  "协议列表": "規約一覧",
  "协议名称": "規約名",
  "协议类型": "規約の種類",
  "协议来源": "規約の提供元",
  "协议状态": "規約ステータス",
  "私域会员协议": "会員規約",
  "私域隐私协议": "会員プライバシーポリシー",
  "私域隐私政策": "プライベートドメインプライバシーポリシー",
  "《私域会员协议》":"『会員規約』",
  "《私域隐私协议》":"『会員プライバシーポリシー』",
  "《私域隐私政策》":"『プライベートドメインプライバシーポリシー』",
  "{{privateName}}私域会员协议": "「{{privateName}}」プライベート会員規約",
  "{{privateName}}私域隐私政策": "「{{privateName}}」プライベートドメインプライバシーポリシー",
  "用户昵称": "表示名",
  "请先阅读并同意相关协议": "先に関連規約を確認し、同意してください",
  "请先确认并勾选协议": "先に規約を確認し、チェックを入れてください",
  "关闭": "閉じる",
  "您将加入 [{{privateName}}] 会员，享受会员专属权益与服务。": "「{{privateName}}」の会員に登録すると、会員限定の特典とサービスをご利用いただけます。",
  "加入中": "参加中",
  "加入私域会员": "会員登録",
  "加入会员": "会員になる",
  "该私域素材仅会员可用": "このプライベートドメインの素材は会員のみ利用できます",
  "是否加入私域会员？": "プライベート会員に参加しますか？",
  "仅会员可用": "会員限定",
  "选择私域": "スペースを選択",
  "服务到期": "サービス期限切れ",
  "违规封禁": "違反により利用停止",
  "无权限查询": "閲覧権限がありません",
  "当前关注的私域暂无可用素材": "フォロー中のプライベートドメインに利用可能な素材がありません",
  "权限状态获取失败": "権限状態の取得に失敗しました",
  "已加入会员，素材权限尚未生效，请稍后重试": "会員登録は完了しましたが、素材の利用権限はまだ有効になっていません。しばらくしてから再試行してください",
  "已加入{{privateName}}会员": "{{privateName}}の会員登録が完了しました",
  "加入私域会员失败，请稍后重试": "プライベートドメインへの会員登録に失敗しました。しばらくしてからもう一度お試しください",
  "加载私域会员信息失败，请稍后重试": "プライベートドメインの会員情報の読み込みに失敗しました。しばらくしてからもう一度お試しください",
  "我已阅读并同意": "内容を確認し、同意します",
  "加入会员后才可继续操作": "続行するには、会員登録が必要です。",
  "会员协议": "会員規約",
  "系统协议": "システム規約",
  "生效中": "有効",
  "访客在官网触发登录（关注/入库等行为）后，将自动加入私域会员。": "訪問者が公式サイトでフォローやライブラリ登録などのログインが必要な操作を行うと、自動的に会員になります。",
  "确认协议配置，开启会员管理": "規約設定を確認して会員管理を有効にする",
  "开启会员管理前，需先确认用户注册/登录时需同意的《私域会员协议》与《私域隐私协议》": "会員管理を有効にする前に、ユーザー登録/ログイン時に同意が必要な「プライベート会員規約」と「プライベートドメインプライバシー規約」を確認してください",
  "官方默认": "公式デフォルト",
  "我已确认以上协议内容，用户注册时将展示并要求同意": "上記の規約内容を確認しました。ユーザー登録時に表示し、同意を求めます。",
  "确认开启": "有効化",
  "不分组": "グループなし",
  "审核通过": "審査通過",
  "审核不通过": "却下",
  "主体认证{{status}},审核通过后再添加": "事業者認証{{status}}。承認後に追加してください",
  "邀请加入-不觉空间艺术馆\n{{nickName}}邀请您加入{{teamName}}，点击下方链接立即加入。\n": "参加招待 - 不覚スペースアートギャラリー\n{{nickName}}さんが{{teamName}}への参加を招待しています。以下のリンクをクリックして今すぐ参加してください。\n",
  "邀请加入-{{teamName}}，成为内部成员。\n": "内部メンバーとして{{teamName}}へ参加するよう招待されています。",
  "私域成员超过50人，需要完成主体认证，才能继续添加": "プライベートドメインのメンバーが50人を超えています。追加するには事業者認証が必要です",
  "使用微信扫码": "WeChatでスキャン",
  "已加载全部数据": "すべてのデータを読み込みました",
  "数据加载失败": "データの読み込みに失敗しました",
  "网络异常，请重试": "ネットワークエラーです。再試行してください",
  "请输入内容": "内容を入力してください",
  "以下字段不支持排序:": "以下のフィールドは並べ替えに対応していません：",
  "以下候选值不支持排序:": "以下の候補値は並べ替えに対応していません：",
  "当前候选值被引用，不可删除": "この候補値は参照されているため削除できません",
  "不支持输入反斜杠 {{bs}}": "バックスラッシュ{{bs}}は入力できません",
  "最多可添加{{max}}个候选值": "候補値は最大{{max}}個まで追加できます",
  "最多可添加{{max}}个字段": "フィールドは最大{{max}}個まで追加できます",
  "该域名可使用!": "このドメインは使用可能です",
  "该域名已使用，请重新输入！": "このドメイン名は使用中です。別の名前を入力してください",
  "私域LOGO": "ロゴ",
  "网址定制": "URL カスタマイズ",
  "域名不支持使用大写字母!": "ドメインに大文字は使用できません",
  "域名不能包含汉字!": "ドメインに漢字は使用できません",
  "域名不能包含标点符号!": "ドメインに句読点は使用できません",
  "重名校验": "重複チェック",
  "可以输入一个拼音或单词(小写)、数字，不能包含标点符号，比如“panzitech”": "小文字の英字と数字のみ使用できます。句読点は使えません。例：「panzitech」",
  "添加私域介绍...": "プライベートドメインの紹介を追加…",
  "{{name}}上传失败": "{{name}}のアップロードに失敗しました",
  "{{name}}不是图片": "{{name}}は画像ではありません",
  "主体认证审核中，暂时无法修改私域名称": "事業者認証審査中のため、プライベートドメイン名を変更できません",
  "修改私域名称，需要重新提交主体认证": "プライベートドメイン名を変更するには、事業者認証を再提出する必要があります",
  "前往认证": "認証へ進む",
  "AI翻译中": "AI翻訳中",
  "翻译完成": "翻訳完了",
  "选择套餐": "プランを選択",
  "到期日期": "有効期限",
  "查看全部权益": "すべての特典を確認",
  "全部权益": "プラン内容",
  "云盘容量": "クラウドストレージ容量",
  "已使用：{{used}}/{{total}}": "使用済み：{{used}}/{{total}}",
  "尊敬的用户，您的不觉云存储空间即将达到上限，为避免影响正常使用，建议您尽快进行容量升级。": "Bujueクラウドのストレージ容量がまもなく上限に達します。通常のご利用への影響を避けるため、早めに容量のアップグレードをお勧めします。",
  "{{time}}到期": "{{time}}に期限切れ",
  "永久免费": "ずっと無料",
  "￥{{price}}/年": "￥{{price}}CNY/year",
  "价格说明": "料金について",
  "套餐购买或套餐续期是，原价=新套餐单价*购买时长": "プラン購入またはプラン更新時、元値＝新プラン単価×購入期間",
  "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数": "プランアップグレード時、元値＝新プラン元単価×（元プラン総期間－贈呈期間）/元プラン総日数×残り日数",
  "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生  效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和": "プランアップグレード時のみ控除額が発生し、控除額＝有効注文の割引価格/有効注文の有効日数×有効注文の残り日数＋すべての未発効更新注文の実払い総額",
  "优惠码：请联系不觉客服获取优惠码": "割引コード：Bujueカスタマーサポートにご連絡ください",
  "请输入优惠码享受优惠，优惠金额=*（1-折扣）": "割引コードを入力して割引を受けてください。割引額＝×（1－割引率）",
  "温馨提示：使用苹果设备购买服务，苹果公司将收取30%，建议您在不觉网站购买服务。": "ご注意：Appleデバイスでサービスを購入すると、Apple社が30%の手数料を徴収します。Bujue公式サイトでのご購入をおすすめします。",
  "保存二维码": "QRコードを保存",
  "微信客服": "WeChatカスタマーサポート",
  "套餐无法降级": "プランはダウングレードできません",
  "当前套餐": "現在のプラン",
  "年": "年",
  "无需付费": "無料",
  "定制版": "カスタム版",
  "按需定制功能和云盘容量": "機能・クラウド容量を自由にカスタマイズ",
  "免费咨询": "無料相談",
  "立即升级": "アップグレード",
  "赠送升级": "無料アップグレード",
  "付费扩容": "容量追加購入",
  "大文件上传": "大容量ファイルアップロード",
  "批量上传文件": "一括ファイルアップロード",
  "视频高清画质": "高画質動画",
  "自定义权限": "カスタム権限",
  "你的私域已使用{{size}}容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。": "プライベートドメインの容量が{{size}}使用されています。より大きい容量のプランをご購入いただくか、管理モードで不要なデータを整理してから再度お試しください。",
  "说明": "説明",
  "原套餐时长：": "元のプラン期間：",
  "数量：": "数量：",
  "套餐时长一次最多购买3年": "プラン期間は一度に最大3年まで購入できます",
  "套餐时长一次最多延长3年": "プランは1回につき最大3年延長できます",
  "有效期至：": "有効期限：",
  "(赠送{{time}}个{{unit}})": "（{{time}}{{unit}}を贈呈）",
  "剩余时长：": "残り期間：",
  "原价：": "元の価格：",
  "抵扣：": "控除：",
  "优惠码：": "割引コード：",
  "请输入优惠码": "割引コードを入力してください",
  "已为您兑换{{discount}}折优惠码：{{code}}": "{{discount}}%オフの割引コードが引き換えられました：{{code}}",
  "优惠：": "割引：",
  "补差价：": "差額支払い：",
  "请求失败，请稍后重试": "リクエストに失敗しました。後でもう一度お試しください",
  "不觉云套餐": "Bujueクラウドプラン",
  "咨询": "お問い合わせ",
  "更多专属特权": "その他の特典",
  "请输入地址": "住所を入力してください",
  "请选择关联品牌": "関連ブランドを選択してください",
  "请输入备注": "備考を入力してください",
  "供应商公司名称不能为空！": "サプライヤーの会社名は必須です",
  "联系人": "担当者",
  "添加供应商": "サプライヤーを追加",
  "编辑供应商": "サプライヤーを編集",
  "分类名不能为空": "分類名を入力してください",
  "管理分类": "分類を管理",
  "*请指定私有分类": "*プライベート分類を指定してください",
  "确定要删除该一级分类吗?": "この一次分類を削除してもよろしいですか？",
  "确定要删除该二级分类吗?": "この二次分類を削除してもよろしいですか？",
  "确定要删除该顶级分类吗?": "大分類を削除してもよろしいですか？",
  "将同时删除下属产品": "下位の製品も同時に削除されます",
  "将同时删除下属分类和产品": "下位の分類と製品も同時に削除されます",
  "分类名称已存在": "同名のカテゴリがあります",
  "分类名称重复": "カテゴリ名が重複",
  "上传图片": "画像をアップロード",
  "上传PDF": "PDFをアップロード",
  "一键清空": "一括クリア",
  "页": "ページ",
  "删除分组将同时删除下属的所有品牌及对应的产品，确认删除分组吗？": "グループを削除すると、下位のすべてのブランドと対応する製品も削除されます。グループを削除しますか？",
  "亲爱的供应商朋友：": "サプライヤーの皆様へ：",
  "恭喜您获得": "このたび、",
  "的邀请": "から招待を受けました。",
  "，您可以在下方列表中录入产品信息并提交，": "下記の一覧に製品情報を入力して送信できます。",
  "在通过私域管理员审核后，产品将自动加入": "プライベートスペース管理者の審査を通過すると、製品は自動的に追加されます。",
  "如需详细咨询，请联系": "詳しくは、",
  "“不觉”": "「Bujue」",
  " 私域Saas工具 ": "SaaSツール",
  "客服小助手微信：bujuekefu": "カスタマーサポートのWeChat：bujuekefu までお問い合わせください。",
  "委托入库": "登録依頼",
  "提交成功！可以继续添加下一个产品。": "送信しました！続けて次の製品を追加できます。",
  "好的": "はい",
  "空间不足": "容量が不足しています",
  "创建成功！": "作成しました",
  "已保存为草稿": "下書きとして保存しました",
  "更新成功": "更新しました",
  "该产品已存在，是否进行替换？": "この製品は既に存在します。置き換えますか？",
  "添加成功": "追加しました",
  "提交成功！可以继续添加更多产品": "送信しました。続けて製品を追加できます",
  "数据提交截止时间：": "データ提出締切：",
  "已选产品": "選択済み製品",
  "产品导入": "製品インポート",
  "私域": "スペース",
  "复制": "コピー",
  "添加产品": "製品を追加",
  "确认删除？": "削除してもよろしいですか？",
  "未通过": "未承認",
  "关联官方品牌": "公式ブランドを関連付け",
  "自定义筛选字段": "絞り込みフィールドをカスタマイズ",
  "自定义字段": "カスタムフィールド",
  "自定义项目字段": "プロジェクト項目のカスタマイズ",
  "拖拽卡片以排序": "カードをドラッグして並べ替え",
  "规格尺寸": "仕様・寸法",
  "发布产品空间": "製品スペースを公開",
  "异常：": "エラー：",
  "产品空间上新啦!": "製品スペースに新機能が追加されました！",
  "公域产品管理上新啦!": "パブリック製品管理に新機能を追加しました",
  "一键发布，可分享，可被关注": "ワンクリックで公開・シェアでき、フォローも可能",
  "让设计师随时了解您 的最新产品": "デザイナーに最新製品をいつでもお届け",
  "完成认证": "認証へ進む",
  "批量入库": "一括登録",
  "批量删除": "一括削除",
  "批量修改分类": "分類を一括変更",
  "详情": "詳細",
  "删除成功！": "削除しました",
  "修改成功！": "変更しました",
  "是否确认删除？": "削除してもよろしいですか？",
  "月": "月",
  "缺少图片，先补充一下吧！": "画像が不足しています。追加してください",
  "产品图": "製品画像",
  "最低参考价": "最低参考価格",
  "最高参考价": "最高参考価格",
  "请选择分类": "カテゴリを選択してください",
  "上传失败，请重新上传！": "アップロードに失敗しました。再アップロードしてください",
  "管理品牌": "ブランドを管理",
  "新增供应商": "サプライヤーを追加",
  "请选择供应商": "サプライヤーを選択してください",
  "确认删除?": "削除してもよろしいですか？",
  "供应商已删除": "サプライヤーは削除されました",
  "*请选择品牌": "*ブランドを選択してください",
  "请选择品牌": "ブランドを選択してください",
  "*请选择分类": "*カテゴリを選択してください",
  "请填写名称!": "名前を入力してください",
  "*请填写名称": "*名前を入力",
  "请选择属性": "属性を選択してください",
  "*请选择属性": "*属性を選択してください",
  "还未上传图片/视频": "画像／動画未アップロード",
  "请填写系列型号": "シリーズ型番を入力してください",
  "请输入供货周期": "納期を入力してください",
  "请上传封面": "表紙をアップロードしてください",
  "最小区间周期不能为0!": "最小区間周期を0にできません",
  "最大区间周期不能为0!": "最大区間周期を0にできません",
  "区间周期不能只填一个!": "区間周期は片方だけ入力できません",
  "最小区间周期不能大于或等于最大区间周期!": "最小区間周期は最大区間周期以上にできません",
  "请输入最小区间周期": "最小区間周期を入力してください",
  "请输入最大区间周期": "最大区間周期を入力してください",
  "内容排序": "コンテンツ並び替え",
  "添加照片": "写真を追加",
  "选择导入内容": "インポート内容を選択",
  "添加PDF": "PDFを追加",
  "导入": "インポート",
  "请输入贴图分类": "テクスチャ分類を入力してください",
  "页数不能为0！": "ページ数を0にできません",
  "加载中": "読み込み中",
  "确认删除选中图片吗": "選択画像の削除確認",
  "移动至": "移動先",
  "移动至第": "移動先ページ",
  "移动": "移動",
  "导入成功！": "インポートしました",
  "导入失败": "インポートに失敗しました",
  "确定要删除吗？已关联产品中的对应服务会一并删除！": "削除してもよろしいですか？関連製品の対応するサービスも一緒に削除されます",
  "产品：": "製品：",
  "移动成功": "移動しました",
  "操作失败": "操作に失敗しました",
  "修改成功": "変更しました",
  "重置筛选": "リセット",
  "精准筛选": "詳細絞り込み",
  "对方已解除与您的合作，点击移除": "相手が提携を解除しました。クリックして削除",
  "请使用鼠标拖动": "マウスでドラッグしてください",
  "默认背景": "デフォルト背景",
  "透明": "透明",
  "模糊": "ぼかし",
  "上传失败": "アップロードに失敗しました",
  "更改未保存，是否保存?": "変更が保存されていません。保存しますか？",
  "正面": "正面",
  "反面": "裏面",
  "点击或拖入更换图片": "クリックまたはドラッグで画像を差し替え",
  "保存成功": "保存しました",
  "来源": "ソース",
  "委托方": "委託者",
  "提交时间": "提出日時",
  "状态": "状態",
  "提交人": "提出者",
  "确定删除": "削除",
  "确定入库": "登録する",
  "30天": "30日",
  "新增": "新規追加",
  "请填写备注": "備考を入力してください",
  "确认清空介绍吗？": "紹介をクリアしてもよろしいですか？",
  "pdf还没全部加载完！": "PDFの読み込みが完了していません",
  "至少保留一个产品！": "製品を1つ以上残してください",
  "保存到草稿": "下書きに保存",
  "更改": "変更",
  "添加分类": "分類を追加",
  "敏感词审核未通过": "センシティブワード審査：不承認",
  "必填项未填写": "必須項目未入力",
  "不可以移动至默认分组": "デフォルトグループへは移動不可",
  "确定要删除分组吗？组内所有合作伙伴会一并删除": "グループを削除しますか？グループ内のすべての提携先も一緒に削除されます",
  "是": "はい",
  "否": "いいえ",
  "官网": "公式サイト",
  "小程序": "ミニプログラム",
  "没有可下架的资源": "掲載停止できるリソースがありません",
  "没有可上架的资源": "掲載できるリソースがありません",
  "一键上架": "掲載",
  "一键下架": "掲載停止",
  "团队店铺本次提交": "今回の送信：",
  "团队店铺全部内容": "全コンテンツ：",
  "团队店铺上架内容统计": "{{scope}}<total>{{totalCount}}</total>件、未掲載<status>{{statusCount}}</status>件、掲載予定のコンテンツ合計：<pending>{{statusCount}}</pending>件",
  "团队店铺下架内容统计": "{{scope}}<total>{{totalCount}}</total>件、掲載中<status>{{statusCount}}</status>件、掲載停止予定のコンテンツ合計：<pending>{{statusCount}}</pending>件",
  "团队店铺上架成功统计": "<submit>{{submitCount}}</submit>件を掲載申請し、<success>{{successCount}}</success>件が掲載されました。",
  "团队店铺上架驳回统计": "<submit>{{submitCount}}</submit>件を掲載申請し、<success>{{successCount}}</success>件が掲載され、<fail>{{failCount}}</fail>件が自動的に却下されました。",
  "下架": "掲載停止",
  "请选择要下架的内容": "掲載停止する内容を選択してください",
  "确认下架": "掲載停止を確定",
  "上架后访客可在小程序、官网查看该产品，确认上架吗？": "掲載すると、訪問者はミニプログラム・公式サイトでこの製品を閲覧できます。掲載しますか？",
  "下架后访客将无法在小程序、官网查看该产品，确认下架吗？": "掲載停止すると、訪問者はミニプログラム・公式サイトでこの製品を閲覧できなくなります。掲載停止しますか？",
  "上架": "掲載",
  "请选择要上架的内容": "掲載する内容を選択してください",
  "确认上架": "掲載を確定",
  "批量下载中，请等待片刻": "一括ダウンロード中です。お待ちください",
  "下载中": "ダウンロード中",
  "一键操作": "全件の操作",
  "搜索结果页暂不支持一键操作": "検索結果ページでは一括操作を利用できません",
  "空间预览": "スペースプレビュー",
  "请选择要导出的产品": "エクスポートする製品を選択してください",
  "导出二维码": "QRコードをエクスポート",
  "确认导出二维码": "QRコードのエクスポート確認",
  "确定要将选中的产品批量上架吗?": "選択した製品を一括掲載しますか？",
  "确定要将选中的产品批量上架吗?\n包含被驳回产品，请填写申请上架理由": "選択した製品を一括掲載しますか？\\n却下された製品が含まれます。掲載申請の理由を入力してください",
  "确定要将选中的产品批量下架吗?": "選択した製品を一括掲載停止しますか？",
  "确定要将选中的产品批量删除吗?": "選択した製品を一括削除しますか？",
  "确定要将选中的产品批量入库吗?": "選択した製品を一括登録しますか？",
  "已选产品容量超出剩余容量，无法入库。": "選択した製品の容量が残り容量を超えているため、登録できません。",
  "正在入库处理中，请等待": "登録処理中です。しばらくお待ちください。",
  "部分产品已存在，是否进行替换？": "一部の製品は既に存在します。置き換えますか？",
  "产品已存在，是否进行替换？": "製品は既に存在します。置き換えますか？",
  "确定要将选中的产品导出二维码吗?": "選択した製品のQRコードをエクスポートしますか？",
  "确定一键上架全部产品吗?": "すべての製品を一括掲載しますか？",
  "确定一键下架全部产品吗?": "すべての製品を一括掲載停止しますか？",
  "确定一键入库全部产品吗?": "すべての製品を一括登録しますか？",
  "确定一键删除全部产品吗?": "すべての製品を一括削除しますか？",
  "确定要将全部产品导出二维码吗?": "すべての製品のQRコードをエクスポートしますか？",
  "确定一键上架符合当前筛选条件的{{total}}项产品吗？": "現在の絞り込み条件に一致する{{total}}件の製品を一括掲載しますか？",
  "确定一键下架符合当前筛选条件的{{total}}项产品吗？": "現在の絞り込み条件に一致する{{total}}件の製品を一括掲載停止しますか？",
  "确定一键入库符合当前筛选条件的{{total}}项产品吗？": "現在の絞り込み条件に一致する{{total}}件の製品を一括登録しますか？",
  "确定一键删除符合当前筛选条件的{{total}}项产品吗？": "現在の絞り込み条件に一致する{{total}}件の製品を一括削除しますか？",
  "确定要导出符合当前筛选条件的{{total}}项产品二维码吗？": "現在の絞り込み条件に一致する{{total}}件の製品のQRコードをエクスポートしますか？",
  "确定批量修改分类?": "分類を一括変更しますか？",
  "审核异常：": "審査エラー：",
  "待审核：": "審査待ち：",
  "未上架：": "未掲載：",
  "内容总数：": "コンテンツ総数：",
  "一键导出码": "コードを一括エクスポート",
  "没有可导出的产品": "エクスポートできる製品がありません",
  "完成私域主体认证，才能继续使用空间功能": "プライベートスペースの事業者認証を完了すると、スペース機能を引き続き利用できます",
  "去认证": "認証へ進む",
  "上架状态": "掲載ステータス",
  "审核异常": "審査エラー",
  "未上架": "未掲載",
  "待审核": "審査待ち",
  "已驳回": "却下済み",
  "审核结果": "審査結果",
  "通过": "承認",
  "不通过": "却下",
  "确认上架吗？将提交至不觉官方进行上架审核": "掲載を申請しますか？Bujue公式の掲載審査に提出されます。",
  "取消置顶": "トップ固定を解除",
  "空间管理": "スペース管理",
  "店铺信息": "店舗情報",
  "私域名称不能为空": "スペース名は必須です",
  "请输入私域介绍": "紹介を入力",
  "私域介绍": "紹介",
  "私域名称": "スペース名",
  "累计上架：": "累計掲載：",
  "服务区域：": "サービス地域：",
  "退出编辑": "編集を終了",
  "退出批量编辑": "一括編集を終了",
  "美元": "ドル",
  "单次最多上传20张": "1回のアップロード：最大20枚",
  "敏感词审核不通过": "センシティブワード審査：不承認",
  "请输入服务": "サービスを入力してください",
  "确认删除吗?": "削除してもよろしいですか？",
  "请选择入库的数据": "登録するデータを選択してください",
  "操作成功！": "操作が完了しました",
  "确定要执行批量上架吗？已选 ": "一括掲載を実行しますか？選択済み ",
  " 件产品中包含 ": " 件の製品のうち ",
  " 件被驳回的产品，确定要重新提交上架吗？": " 件が却下された製品です。再度掲載申請を送信しますか？",
  "产品名称": "製品名",
  "请先勾选数据": "先にデータを選択してください",
  "搜索产品": "製品を検索",
  "已选中当前已加载项": "読み込み済みの項目を選択しました",
  "全部分类": "すべてのカテゴリ",
  "尚未设置密码，请选择其他方式登录！": "パスワードが未設定です。他の方法でログインしてください",
  "请上传PDF文档": "PDFをアップロードしてください",
  "上传品牌介绍": "ブランド紹介をアップロード",
  "编辑内容": "内容を編集",
  "编辑文字": "テキストを編集",
  "团队剩余空间不足": "チームの残り容量が不足しています",
  "此次待上传的图片大小超出团队剩余容量，请联系管理员购买容量或重新选择图片":"アップロードする画像のサイズがチームの残り容量を超えています。容量の追加購入について管理者にご連絡いただくか、画像を選択し直してください。",
  "作品中存在上传中的图片，不可操作": "作品にアップロード中の画像があるため操作できません",
  "全部导入": "すべてインポート",
  "确定导入该私域所有产品吗？": "このプライベートスペースのすべての製品をインポートしますか？",
  "添加分组": "グループ追加",
  "编辑分组": "グループ編集",
  "显示锚点": "アンカーを表示",
  "隐藏锚点": "アンカーを非表示",
  "添加图片": "画像を追加",
  "添加文档": "ドキュメントを追加",
  "存在重名分类，请修改分类名称后再拖动！": "同名の分類があります。分類名を修正してからドラッグしてください",
  "排序数据已过期，请刷新页面后重试": "並べ替えデータが期限切れです。ページを更新してから再試行してください",
  "请不要拖动到添加后面": "「追加」の後ろにドラッグしないでください",
  "确定要删除吗?已关联产品中的对应供应商会一并删除！": "削除してもよろしいですか？関連製品の対応するサプライヤーも一緒に削除されます",
  "/永久": "/無期限",
  "确定要删除该顶级分类及下属分类吗?": "この大分類とその下位分類を削除してもよろしいですか？",
  "确定要删除该一级分类及下属分类吗?": "この中分類とその下位分類を削除してもよろしいですか？",
  "无法继续放大卡片": "カードをこれ以上拡大できません",
  "无法继续缩小卡片": "カードをこれ以上縮小できません",
  "登录失效！": "ログインの有効期限が切れました",
  "您可以通过以下方式便捷续费：": "以下の方法で簡単に契約を更新できます：",
  "1.通过Android手机APP续费": "1. Androidアプリで契約を更新",
  "2.使用电脑访问官网续费: www.bujue.art": "2. パソコンで公式サイトにアクセスして契約を更新：www.bujue.art",
  "感谢您的支持！": "ご利用ありがとうございます！",
  "当前私域容量套餐已到期，为不影响使用，请及时续费。": "現在のプライベートスペースの容量プランは有効期限が切れています。引き続きご利用いただくため、お早めに契約を更新してください。",
  "当前私域容量套餐已到期，为不影响使用，请联系私域管理员续费。": "現在のプライベートスペースの容量プランは有効期限が切れています。引き続きご利用いただくため、プライベートスペースの管理者に契約更新を依頼してください。",
  "容量到期": "容量期限切れ",
  "忽略": "対応不要",
  "立即续费": "更新する",
  "去我的空间": "マイスペースへ",
  "。": "。",
  "官网分享": "公式サイトをシェア",
  "定向分享": "限定シェア",
  "没有可入库的产品！": "登録できる製品がありません",
  "批量分类": "一括分類",
  "选择分类": "カテゴリを選択",
  "批量出库": "一括登録解除",
  "确定出库": "登録解除",
  "请输入关键词": "キーワードを入力してください",
  "请选择完整的三级分类": "三階層のカテゴリをすべて選択してください",
  "请选择完整的规格": "完全な規格を選択してください",
  "请选择完整的SKU": "完全なSKUを選択してください",
  "加入采购清单成功": "購入リストに追加しました",

  "最近搜索": "最近の検索",
  "确定要清空搜索吗?": "検索履歴をクリアしてもよろしいですか？",
  "历史搜索": "検索履歴",
  "其他成员正在管理筛选字段，请稍候再试。": "他のメンバーが絞り込みフィールドを管理中です。しばらくして再試行してください。",
  "当前有未保存的更改，是否确认关闭？": "未保存の変更があります。閉じてもよろしいですか？",
  "其他成员正在管理自定义字段，请稍候再试。": "他のメンバーがカスタムフィールドを管理中です。しばらくして再試行してください。",
  "数据发生变化，已自动刷新。": "データ変更を検知し、自動更新しました",
  "请输入候选值": "候補値を入力してください",
  "仅支持输入汉字、英文字母、数字及以下标点符号：- _ ， , 。' . 空格 () （）【】[]": "入力できるのは漢字・英字・数字および次の記号のみです：- _，,。' . スペース ()（）【】[]",
  "确认删除该候选值吗？": "この候補値を削除しますか？",
  "确认删除该字段吗？": "このフィールドを削除しますか？",
  "确认删除该候选值吗？\n已关联产品不会同步删除,如需调整需手动修改": "この候補値を削除しますか？\n関連製品は同期削除されません。調整が必要な場合は手動で修正してください",
  "确认删除该字段吗？\n已关联产品不会同步删除,如需调整需手动修改": "このフィールドを削除しますか？\n関連製品は同期削除されません。調整が必要な場合は手動で修正してください",
  "确认删除该字段吗？\n后续新增/编辑表单时将不再具有该字段": "このフィールドを削除しますか？\n今後、フォームの追加・編集時にこのフィールドは表示されなくなります",
  "确认删除该候选值吗？\n后续新增/编辑表单时该字段将不再具有该候选值": "この候補値を削除しますか？\n今後、フォームの追加・編集時に、このフィールドでこの候補値は選択できなくなります",
  "检测到敏感词，请修改后重试": "センシティブワードを検出しました。修正して再試行してください",
  "候选值不能为空": "候補値は必須です",
  "候选值不能重名": "候補値名は重複できません",
  "候选值中文不能重名": "候補値の中国語名は重複できません",
  "候选值英文不能重名": "候補値の英語名は重複できません",
  "字段不能为空": "フィールドは必須です",
  "字段不能重名": "フィールド名は重複できません",
  "字段中文不能重名": "フィールドの中国語名は重複できません",
  "字段英文不能重名": "フィールドの英語名は重複できません",
  "英文长度超出,请修改后重试": "英語の文字数が上限超過です。修正して再試行してください",
  "翻译长度超出,请修改后重试": "翻訳の文字数が上限を超えています。修正してから再試行してください",
  "已经是第一个": "既に先頭です",
  "已经是最后一个": "既に末尾です",
  "请输入中文字段名称": "中国語のフィールド名を入力してください",
  "请输入中文分类名称": "中国語のカテゴリ名を入力してください",
  "请先填写中文内容": "先に中国語の内容を入力してください",
  "请输入英文字段名称": "英語のフィールド名を入力してください",
  "请输入{{language}}字段名称": "{{language}}のフィールド名を入力してください",
  "请输入字段名称翻译": "フィールド名の翻訳を入力してください",
  "请输入中文候选值": "中国語の候補値を入力してください",
  "请输入英文候选值": "英語の候補値を入力してください",
  "请输入{{language}}候选值": "{{language}}の候補値を入力してください",
  "请输入候选值翻译": "候補値の翻訳を入力してください",
  "请先完成当前项的编辑。": "先に現在の項目の編集を完了してください。",
  "中文长度超出,请修改后重试": "中国語の文字数が上限超過です。修正して再試行してください",
  "“未分组”为系统保留选项，不支持添加。": "「未分類」はシステム予約の選択肢のため追加できません。",
  "产品字段": "製品フィールド",
  "产品管理：通过手动和委托的方式添加产品，对未入库/已入库的产品审核后进行批量入库、修改分类的操作。": "製品管理：手動・委託で製品を追加し、未登録／登録済み製品を審査して一括登録・カテゴリ変更します。",
  "品类管理：对产品的分类、品牌、供应商信息进行统一管理。": "カテゴリ管理：製品の分類・ブランド・サプライヤー情報を一元管理します。",
  "字段管理：管理产品中的自定义字段信息，设置产品列表的筛选条件。": "フィールド管理：製品のカスタムフィールド情報を管理し、製品リストの絞り込み条件を設定します。",
  "展示配置：控制各终端产品的平铺、分类、品牌3个列表的显示和排序，以及产品封面呈现效果": "表示設定：各端末の製品のタイル・分類・ブランドの3リストの表示と並べ替え、および製品カバーの表示効果を制御します。",
  "展示配置": "表示設定",
  "公域发布：发布私域产品到公域，产品信息未通过官方审核会被驳回，重新修改后再发布。": "パブリック公開：プライベートスペースの製品をパブリックに公開します。公式審査に通らない製品情報は却下され、修正後に再公開が必要です。",
  "小程序-定制化配置：管理小程序的定制化内容": "ミニプログラム-カスタマイズ設定：ミニプログラムのカスタマイズ内容を管理します",
  "入库审核": "登録審査",
  "产品管理": "製品管理",
  "品类管理": "カテゴリ管理",
  "分类管理": "分類管理",
  "品牌管理": "ブランド管理",
  "供应商管理": "サプライヤー管理",
  "字段管理": "フィールド管理",
  "展示顺序": "表示順",
  "公域发布": "パブリック公開",
  "小程序-定制化配置": "ミニプログラム-カスタマイズ設定",
  "定制页面管理": "カスタムページ管理",
  "一级分类主页": "大分類トップ",
  "新品页": "新製品ページ",
  "分类名称": "分類名",
  "指针页面": "リンク先ページ",
  "请输入页面路径": "ページパスを入力してください",
  "新品页名称": "新製品ページ名",
  "h5地址": "H5 URL",
  "*调整该配置将直接影响小程序对应页面，请谨慎处理": "*この設定を変更するとミニプログラムの対応ページに直接影響します。慎重に操作してください",
  "品牌轮播图管理": "ブランドカルーセル管理",
  "确定要清空该品牌下所有轮播图吗？": "このブランドのすべてのカルーセル画像をクリアしてもよろしいですか？",
  "清空后数据将无法恢复，请谨慎操作": "クリアしたデータは復元できません。慎重に操作してください",
  "确定清空": "クリアを確定",
  "清空失败": "クリアに失敗しました",
  "图片太大，请重新上传(文件最大8MB)": "画像が大きすぎます。再度アップロードしてください（最大8MB）",
  "图片上传失败": "画像のアップロードに失敗しました",
  "上传或保存失败": "アップロードまたは保存に失敗しました",
  "确定要删除该图片吗？": "この画像を削除してもよろしいですか？",
  "保存失败": "保存に失敗しました",
  "暂无品牌": "ブランドがありません",
  "一次最多上传5张图片": "1回のアップロード：最大5枚",
  "请上传JPG、PNG、GIF、WebP格式的图片，推荐尺寸1650×1000px": "JPG、PNG、GIF、WebP形式の画像をアップロードしてください。推奨サイズ1650×1000px",
  "已发布": "公開済み",
  "管理字段": "フィールドを管理",
  "请前往<manage>管理字段</manage>添加": "追加するには、<manage>フィールド管理</manage>へ移動してください",
  "默认顺序": "デフォルト順",
  "产品备注": "製品備考",
  "款式备注": "バリエーション備考",
  "新增备注": "備考を追加",
  "名称A-Z": "名前A-Z",
  "名称Z-A": "名前Z-A",
  "暂无结果": "結果がありません",
  "暂无选项": "選択肢がありません",
  "操作失败，请检查数据版本": "操作に失敗しました。データバージョンを確認してください",



  "筛选字段": "絞り込みフィールド",
  "待选项": "選択肢",

  "最多支持": "最大",
  "个筛选字段。": " 件の絞り込みフィールドに対応。",
  "至少设置": "少なくとも",






  //作品相关
  "添加链接": "リンクを追加",
  "视频描述": "動画の説明",
  "图片描述": "画像の説明",
  "请输入图片名称": "画像名を入力してください",
  "图片名称": "画像名",
  "编辑链接": "リンクを編集",
  "粘贴或输入bujue.art域名的网页链接， 如：https://www.bujue.art": "bujue.artドメインのWebリンクを貼り付けまたは入力してください。例：https://www.bujue.art",
  "请粘贴有效链接": "有効なリンクを貼り付けてください",
  "文本": "テキスト",
  "请输入链接": "リンクを入力してください",
  "链接": "リンク",
    "请输入有效链接": "有効なリンクを入力してください",
  "添加宣传链接": "プロモーション用リンクを追加",
  "请先保存": "先に保存してください",
  "请先保存当前编辑内容": "先に現在の編集内容を保存してください",
  "更换": "変更",
  "请输入网址": "URLを入力してください",
  "你确定要删除吗?": "削除してもよろしいですか？",
  "你确定要取消上传吗?": "アップロードをキャンセルしてもよろしいですか？",
  "请输入合法的网址": "有効なURLを入力してください",
  "不是图片": "画像ではありません",
  "在图上点击添加锚点": "画像クリックでアンカー追加",
  "拖拽锚点移动位置": "アンカーをドラッグして移動",
  "拖拽产品卡片调整顺序": "製品カードをドラッグして並べ替え",
  "设置保密级别": "公開範囲を設定",
  "选择下级时自动选中上级": "下位を選択すると上位が自動的に選択されます",
  "私域拥有者可见": "オーナーのみ閲覧可",
  "管理员可见": "管理者のみ閲覧可",
  "成员可见": "メンバーのみ閲覧可",
  "访客可见": "ゲストも閲覧可",
  "请输入,限150个字": "入力してください（150文字まで）",
  "请选择时间": "時間を選択してください",
  "正在翻译中": "翻訳中です",
  "一键翻译": "一括翻訳",
  "建筑面积": "建築面積",
  "摄影版权": "写真著作権",
  "{{name}}方": "{{name}}側",
  "请输入,限{{maxLength}}个字": "入力してください（{{maxLength}}文字まで）",
  "请填写名称": "名前を入力してください",
  "请填写时间": "時間を入力してください",
  "请填写{{name}}": "{{name}}を入力してください",
  "请填写{{name}}-{{language}}": "{{name}}（{{language}}）を入力してください",
  "请输入字段": "フィールドを入力してください",
  "正在翻译中，请勿重复提交": "翻訳中です。繰り返し送信しないでください",
  "关联盘八斗项目": "Panbadouプロジェクトと連携",
  "项目名称": "プロジェクト名",
  "项目名称必填!": "プロジェクト名は必須です",
  "请填写项目名称": "プロジェクト名を入力してください",
  "项目链接": "プロジェクトリンク",
  "请输入正确的盘八斗项目管理链接": "正しい盤八斗プロジェクト管理リンクを入力してください",
  "请粘贴盘八斗的项目链接": "盤八斗のプロジェクトリンクを貼り付けてください",
  "请输入介绍": "紹介を入力してください",
  "请输入客户": "顧客を入力してください",
  "请输入联系方式": "連絡先を入力してください",
  "请输入详细地址": "詳細住所を入力してください",
  "创建": "作成",
  "英文字段长度有问题请修改后重试": "英語フィールドの文字数を修正して再試行してください",
  "字段已存在": "フィールドは登録済みです",
    "请输入其他值": "別の値を入力してください",
  "保密": "機密",
  "是否同步删除云盘“": "クラウドドライブの「",
  "”文件夹": "」フォルダも同期削除しますか？",
  "置顶成功": "トップに固定しました",
  "取消置顶成功": "トップ固定を解除しました",
  "输入字段": "フィールドを入力",
  "点击添加VR": "クリックでVRを追加",
  "添加VR": "VRを追加",
  "上传图片/视频": "画像/動画をアップロード",
  "正在上传中，请稍后": "アップロード中です。お待ちください",
  "请勾选": "チェックしてください",
  "修改失败": "変更に失敗しました",
  "删除失败": "削除に失敗しました",
  "未改变顺序": "順序は変更されていません",
  "排序成功": "並び替えました",
  "排序失败": "並び替えに失敗しました",
  "库被关闭": "ライブラリ機能は無効になっています",
  "库": "ライブラリ",
  "正在获取预览图...": "プレビューを取得中…",
  "预览图": "プレビュー画像",
  "确认解除关联？": "関連付けを解除しますか？",
  "解除成功": "解除しました",
  "项目链接必填!": "プロジェクトリンクは必須です",
  "设置封面": "表紙を設定",
  "更改未保存，确定离开？": "変更が未保存です。移動しますか？",
  "文件上传未完成，确定离开？": "アップロードが完了していません。移動しますか？",
  "文件上传未完成，稍后再试": "アップロードが完了していません。後ほど再試行してください",
  "容量不足": "容量不足",
  "尊敬的用户，您的不觉云存储空间不足，为避免影响正常使用，建议您尽快进行容量升级。": "Bujueクラウドのストレージ容量が不足しています。通常のご利用への影響を避けるため、早めに容量のアップグレードをお勧めします。",
  "去扩容": "容量を拡張",
  "请输入正确的地址": "正しいアドレスを入力してください",
  "请填写中文名称": "中国語名を入力してください",
  "关注": "フォロー",
  "请在电脑上打开链接进行批量下载": "パソコンでリンクを開いて一括ダウンロードしてください",
  "查看": "表示",
  "智能排序": "スマート並び替え",
  "浏览量排序": "閲覧数順",
  "上新": "新着",
  "以下信息仅管理员可见": "以下は管理者のみ閲覧可",
  "列数": "列数",
  '列': "列",
  '作品视图': "作品ビュー",
  '合集视图': "コレクションビュー",
  '照片视图': "フォトビュー",
  '默认': "デフォルト",
  "分享添加": "シェアから追加",
  "默认语言：": "デフォルト言語：",
  "默认语言": "デフォルト言語",
  "分享语言：": "シェア時の言語：",
  "介绍册": "パンフレット",
  "作品集": "ポートフォリオ",
  "产品册": "製品カタログ",

  "为了最佳使用体验，单次最多可添加30个文件。": "最適なご利用のため、1回に最大30ファイルまで追加できます。",
  "照片": "写真",
  "排序筛选": "並び替え・フィルター",
  "合集方式": "コレクション表示形式",
  "其他成员正在调整图片顺序，请稍后再试。": "他のメンバーが画像の順序を調整中です。後ほど再試行してください。",
  "操作超时": "操作がタイムアウトしました",
  "选品": "商品選定",
  "当前候选值被作品引用，不可删除": "現在の候補値は作品で参照されているため削除できません",
  '其他成员更新了自定义字段，点击刷新获取最新内容再试。': "他のメンバーがカスタムフィールドを更新しました。「更新」を選択し、最新内容を取得して再試行してください。",
  "刷新": "再読み込み",
  "其他成员更新了自定义字段，": "他のメンバーがカスタムフィールドを更新しました。",
  "点击刷新获取最新内容再试。": "「再読み込み」を選択し、最新内容を取得して再試行してください",
  "总计": "合計",
  "作品详情": "作品の詳細",
  "卡片大小": "カードサイズ",
  "进入官网": "公式サイトへ",

  "本次上架被自动驳回。": "今回の掲載は自動的に却下されました。",
  "上传介绍": "紹介をアップロード",
  "修改介绍": "紹介を編集",
  "确认要删除该品牌吗？": "このブランドを削除してもよろしいですか？",
  "删除分组后，关联的所有的品牌都清空这个分组": "グループを削除すると、関連するすべてのブランドがこのグループから外れます。",
  "确认要删除该分组吗？": "このグループを削除してもよろしいですか？",
  "选择分组": "グループを選択",
  "所有款式名称": "すべてのバリエーション名",
  "管理款式": "バリエーションを管理",
  "颜色": "カラー",
  "尺寸": "サイズ",

  "点击升序": "クリックで昇順",
  "点击降序": "クリックで降順",
  "取消排序": "並べ替えを解除",
  "请先完善分类信息再操作": "先に分類情報を完成させてください",
  "删除分类": "分類を削除",
  "只删分类": "分類のみ削除",
  "确定要删除选中的分类，并同步删除分类下的产品吗？": "選択した分類と、その分類に属する製品も同時に削除しますか？",
  "图片大小限制500kb": "画像サイズは500KBまで",
  "默认首个款式图为封面": "先頭のバリエーション画像を表紙に設定",
  "图片比例1:1": "画像比率1:1",
  "分类副标题": "分類サブタイトル",
  "分类主标题*": "分類メインタイトル*",
  "分类标题*": "分類タイトル*",
  "请输入分组名称": "グループ名を入力してください",
  "更新分类": "分類を更新",
  "请填写分类": "分類を入力してください",
  "请填写一级分类": "大分類を入力してください",
  "请填写二级分类": "中分類を入力してください",
  "请先在左侧栏添加二级分类": "先に左側のサイドバーで中分類を追加してください",
  "请先在左侧栏添加分类": "先に左側のバーで分類を追加してください",
  "请填写分类副标题": "分類サブタイトルを入力してください",

  // 插件/官网相关
  "资源库": "リソースライブラリ",
  "紫菜海洋": "ノリオーシャン",
  "设计师专属的产品、艺术品数据库": "デザイナー専用の製品・アート作品データベース",
  "工具": "ツール",
  "创意板": "クリエイティブボード",
  "创意板项目": "クリエイティブボード案件",
  "物料板后台": "マテリアルボード管理",
  "会员项目": "会員プロジェクト",
  "成员项目": "メンバープロジェクト",
  "负责人": "担当者",
  "未指定负责人": "担当者未指定",
  "请选择项目": "プロジェクトを選択してください",
  "搜索项目名称/负责人": "プロジェクト名 / 担当者を検索",
  "搜索项目名称/创建人": "プロジェクト名 / 作成者を検索",
  "批量导出": "一括エクスポート",
  "批量指派": "一括割り当て",
  "指派": "割り当て",
  "将": "",
  "项目指派给": "の割り当て先",
  "将{{projectName}}项目指派给": "{{projectName}}の割り当て先",
  "将选中的{{count}}个项目指派给": "選択中の{{count}}件のプロジェクトの割り当て先",
  "获取成员列表失败": "メンバー一覧の取得に失敗しました",
  "指派失败": "プロジェクトの割り当てに失敗しました",
  "指派成功": "プロジェクトを割り当てました",
  "确认删除该项目吗？删除后不可恢复": "このプロジェクトを削除しますか？削除後は復元できません",
  "确认删除当前选中的{{count}}个项目吗？": "選択中の{{count}}件のプロジェクトを削除しますか？",
  "项目类型": "プロジェクト種別",
  "确认导出当前选中的{{count}}个项目的数据吗？": "選択中の{{count}}件のプロジェクトのデータをエクスポートしますか？",
  "{{action}}功能待接口联调": "{{action}}機能はAPI接続待ちです",
  "会员版物料板": "マテリアルボード（会員版）",
  "成员版物料板": "マテリアルボード（メンバー版）",
  " · 会员版": "・会員版",
  " · 成员版": "・メンバー版",
  "存在需要迁移的历史项目": "移行が必要な過去のプロジェクトがあります",
  "创意板现已变更为私域级工具物料板": "クリエイティブボードはプライベートスペース専用ツール「マテリアルボード」に変わりました",
  "请为历史项目指定归属私域": "過去のプロジェクトの所属プライベートスペースを指定してください",
  "项目信息将对私域可见并可使用对应私域素材": "プロジェクト情報はプライベートスペースに公開され、該当スペースの素材を利用できます",
  "项目的所属权将变更为对应私域，管理员可对其进行调整与指派": "プロジェクトの所有権は該当プライベートスペースに移り、管理者が調整・割り当てできます",
  "关注、收藏的产品素材不再可用，历史相关数据保留": "フォロー・お気に入りした製品素材は利用できなくなりますが、過去のデータは保持されます",
  "迁移完成后不可修改": "移行後は変更できません",
  "如有疑问请联系不觉客服咨询": "ご不明な点はBujueカスタマーサポートへお問い合わせください",
  "稍后处理": "後で",
  "立即迁移": "今すぐ移行",
  "指定私域归属": "所属プライベートスペースの指定",
  "已指定 {{assigned}}/{{total}}": "指定済み {{assigned}}/{{total}}",
  "请选择私域": "请选择私域",
  "迁移指定项目": "迁移指定项目",
  "请为历史项目指定归属私域，项目信息将对私域可见并可使用对应私域素材；迁移完成后不可修改。": "過去のプロジェクトの所属プライベートスペースを指定してください。プロジェクト情報はプライベートスペースに公開され、該当スペースの素材を利用できます。移行後は変更できません。",
  "快速设计软硬装搭配方案，导出材料及报价清单": "内装プランを素早くデザインし、材料・見積リストをエクスポート",
  "盘八斗": "盤八斗",
  "设计师的项目管理小秘书": "デザイナー向けプロジェクト管理アシスタント",
  "插件": "プラグイン",
  "Revit插件，直接调用私域产品库的贴图和模型": "Revitプラグイン：プライベート製品ライブラリのテクスチャとモデルに直接アクセス。",
  "3DSMax插件，直接调用私域产品库的贴图和模型": "3DSMaxプラグイン：プライベート製品ライブラリのテクスチャとモデルに直接アクセス。",
  "Rhino插件，直接调用私域产品库的贴图和模型": "Rhinoプラグイン：プライベート製品ライブラリのテクスチャとモデルに直接アクセス。",
  "SketchUp插件，直接调用私域产品库的贴图和模型": "SketchUpプラグイン：プライベート製品ライブラリのテクスチャとモデルに直接アクセス。",
  "不觉官方": "Bujue公式",
  "不觉官网": "Bujue公式サイト",
  "了解更多关于不觉": "Bujueについて詳しく知る",
  "不觉APP": "Bujueアプリ",
  "随时随地使用不觉": "いつでもどこでもBujueを使う",
  "操作说明": "操作説明",
  "新手用户操作指引": "初めての方向け操作ガイド",
  "一键导入": "ワンクリックでインポート",
  "轻点鼠标即可从丰富的不觉产品库中选取所需的模型或材质贴图，一键添加到您的项目中。": "クリックするだけでBujue製品ライブラリからモデルやテクスチャを選び、ワンクリックでプロジェクトに追加できます。",
  "简化工作流": "ワークフローを簡略化",
  "插件与Revit软件完美兼容，与不觉产品库深度集成，您可以在Revit中完成所有操作，享受无中断的工作体验。": "RevitソフトウェアとBujueライブラリを深く統合。Revit内ですべての操作を完結し、中断のない作業体験を実現します。",
  "持续更新": "継続的な更新",
  "我们将持续丰富不觉产品库内容，并持续迭代插件，确保您始终能够获得最前沿的设计元素和最专业的技术支持。": "Bujue製品ライブラリのコンテンツを継続的に充実させ、プラグインも継続的にアップデートし、常に最新のデザイン要素と高度な技術サポートを提供します。",
  "不觉 · BIM": "Bujue · BIM",
  "让每一个创意都能迅速转化为精确的数字模型": "あらゆるアイデアを迅速かつ正確なデジタルモデルに変換",
  "立即下载": "今すぐダウンロード",
  "插件与3DSMax软件完美兼容，与不觉产品库深度集成，您可以在3DSMax中完成所有操作，享受无中断的工作体验。": "3DSMaxソフトウェアとBujueライブラリを深く統合。3DSMax内ですべての操作を完結し、中断のない作業体験を実現します。",
  "不觉 · 3DS Max": "Bujue · 3DS Max",
  "插件与Rhino软件完美兼容，与不觉产品库深度集成，您可以在Rhino中完成所有操作，享受无中断的工作体验。": "RhinoソフトウェアとBujueライブラリを深く統合。Rhino内ですべての操作を完結し、中断のない作業体験を実現します。",
  "不觉 · Rhino": "Bujue · Rhino",
  "插件与SketchUp软件完美兼容，与不觉产品库深度集成，您可以在SketchUp中完成所有操作，享受无中断的工作体验。": "SketchUpソフトウェアとBujueライブラリを深く統合。SketchUp内ですべての操作を完結し、中断のない作業体験を実現します。",
  "不觉 · SketchUp": "Bujue · SketchUp",
  "不觉": "Bujue",
  "添加不觉客服微信，咨询开通详情": "BujueカスタマーサポートのWeChatを追加して、利用開始の詳細をお問い合わせください",
  "添加不觉客服微信": "BujueカスタマーサポートのWeChatを追加",
  "填写产品信息": "製品情報を入力",
  "上传产品介绍": "製品紹介をアップロード",
  "上传产品附件": "添付ファイルをアップロード",
  "产品封面": "製品の表紙画像",
  "官方字段": "標準フィールド",
  "产品类别": "製品カテゴリ",
  "物流发货": "配送が必要",
  "无需物流": "配送不要",
  "送样服务": "サンプル提供サービス",
  "提供样品赠送服务，便于用户在正式购买前确认材质、颜色、尺寸等产品细节。": "正式購入前に素材・色・サイズなどの製品詳細を確認できる無料サンプルサービスをご利用いただけます。",
  "每个产品字段可以下拉多选，所选内容展示于产品详情页，可用于产品列表筛选。": "各製品フィールドはプルダウンで複数選択でき、選択内容は製品詳細ページに表示され、製品リストの絞り込みに使用できます。",
  "更多属性": "その他の属性",
  "翻译中...": "翻訳中…",
  "翻译中⋯": "翻訳中⋯",
  "每个产品支持添加最多 5 个属性字段，编辑纯文本内容，字段内容展示于产品详情页，不支持筛选。": "各製品には最大5個の属性フィールドを追加でき、プレーンテキストのみ編集可能です。フィールド内容は製品詳細ページに表示され、絞り込みには使用できません。",
  "添加属性": "属性を追加",
  "最多添加5个属性": "属性は最大5個までです",
  "推荐": "おすすめ",
  "规格信息": "仕様情報",
  "产品规格": "製品仕様",
  "请填写产品规格": "製品仕様を入力してください",
  "添加产品规格": "仕様を追加",
  "系统规格": "システム仕様",
  "管理系统规格": "仕様フィールドを管理",
  "其他成员正在管理系统规格字段，请稍候再试。": "他のメンバーがシステム仕様フィールドを管理しています。しばらくしてからもう一度お試しください。",
  "请前往<manage>管理系统规格</manage>添加": "追加するには、<manage>システム仕様管理</manage>へ移動してください",
  "暂无可用规格，请前往产品信息添加": "利用可能な仕様がありません。製品情報から追加してください",
  "规格名": "仕様名",
  "规格名已存在，请重新输入": "仕様名は既に存在します。再入力してください。",
  "支持手动输入创建新规格名/值，鼠标点击或回车均可添加，规格名称不超过6个字符，规格值不超过50个字符": "仕様名/値を手動で入力して作成できます。クリックまたはEnterで追加。仕様名は6文字まで、仕様値は50文字までです。",
  "规格值": "仕様値",
  "规格值已存在，请重新输入": "仕様値は既に存在します。再入力してください。",
  "规格名翻译不能为空": "仕様名の翻訳を入力してください",
  "规格值翻译不能为空": "仕様値の翻訳を入力してください",
  "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png/webp": "最初の仕様グループで表紙画像をアップロードできます。比率1:1、500KB以下、jpg/png/webp",
  "在第一组规格可上传封面图，比例1:1，≤500KB，jpg/png": "最初の仕様グループで表紙画像をアップロードできます。比率1:1、500KB以下、jpg/png",
  "规格明细表": "仕様明細表",
  "批量设置": "一括設定",
  "选择规格": "仕様を選択",
  "填写内容": "内容を入力",
  "填写": "入力",
  "填写面价": "定価を入力",
  "填写底价": "最低販売価格を入力",
  "填写包装体积（m³）": "梱包体積（m³）を入力",
  "填写重量（kg）": "重量（kg）を入力",
  "填写更多属性": "その他の属性を入力",
  "库存预警": "在庫アラート",
  "体积": "体積",
  "重量": "重量",
  "更多图片": "その他の画像",
  "最多上传3张": "最大3枚まで",
  "产品规格启用：开启后，产品详情页可选择该规格；关闭后将无法选择。": "製品仕様の有効化：有効にすると製品詳細ページでこの仕様を選択できます。無効にすると選択できなくなります。",
  "确认禁用该规格吗？产品详情页将无法选择该规格": "この仕様を無効にしますか？製品詳細ページで選択できなくなります。",
  "库存总和": "在庫合計",
  "每个规格的库存之和": "仕様別在庫合計",
  "*面价": "*定価",
  "底价": "最低販売価格",
  "库存": "在庫",
  "包装体积（m³）": "梱包体積（m³）",
  "重量（kg）": "重量（kg）",
  "面价": "定価",
  "产品提交": "製品情報を送信",
  "请先完善必填信息": "先に必須情報を入力してください",
  "最多添加5个规格！": "仕様は最大5つまで追加できます。",
  "最多添加100个规格值！": "仕様値は最大100件まで追加できます。",
  "请先完成上一个规格或规格值的填写": "先に前の仕様または仕様値の入力を完了してください",
  "单个产品规格组合数量不能超过1000个": "1つの製品の仕様組み合わせ数は1000件を超えることはできません",
  "请至少选择一个规格值": "仕様値を少なくとも1つ選択してください",
  "请至少添加一个规格": "仕様を1つ以上追加してください",
  "底价不能高于面价": "最低販売価格は定価を上回ることはできません",
  "图片不能超过20张": "画像は20枚までです",
  "提示：请为每种语言单独上传介绍内容，避免切换语言后出现内容空缺": "ヒント：言語を切り替えた際に内容が欠けないよう、各言語の紹介内容を個別にアップロードしてください",
  "文件：": "ファイル：",
  "添加文件 支持PDF/PPT/WORD/EXCEL/压缩包等格式": "ファイルを追加（PDF/PPT/WORD/EXCEL/圧縮ファイルなどに対応）",
  "添加文件": "ファイルを追加",
  "支持PDF/PPT/WORD/EXCEL/压缩包等格式": "PDF/PPT/WORD/EXCEL/圧縮ファイルなどの形式に対応",
  "模型：": "モデル：",
  "添加模型 支持CAD/SU/3dsMax/Revit格式": "モデルを追加 CAD/SU/3dsMax/Revit形式に対応",
  "添加模型": "モデルを追加",
  "支持CAD/SU/3dsMax/Revit格式": "CAD/SU/3dsMax/Revit形式に対応",
  "文件格式不支持": "対応していないファイル形式です",
  "贴图：": "テクスチャ：",
  "查看底价": "最低販売価格を表示",
  "暂无文件": "ファイルがありません",
  "暂无案例": "事例がありません",
  "暂无贴图": "テクスチャがありません",
  "收藏": "お気に入り",
  "取消收藏": "お気に入りから削除",
  "已收藏": "お気に入り済み",
  "已添加收藏":"お気に入り登録",
  "已取消收藏":"お気に入り解除",
  "登录已过期，请重新登录":"ログインセッションの有効期限が切れました。再度ログインしてください。",
  "其他文件": "その他のファイル",
  "暂无模型": "モデルがありません",
  "文件": "ファイル",

  // 产品列表 - 查漏补缺
  "规格字段": "仕様フィールド",
  "关联规格字段": "仕様フィールドを関連付け",
  "批量关联": "一括関連付け",
  "添加规格": "仕様を追加",
  "请选择关联规格字段": "関連付ける仕様フィールドを選択",
  "关联规格字段与产品分类后，该分类下的产品筛选条件将自动增加对应规格。": "仕様フィールドと製品分類を関連付けると、その分類の製品の絞り込み条件に対応する仕様が自動的に追加されます。",
  "请先选择分类": "先に分類を選択してください",
  "商家后台": "出店者管理画面",
  "实际销量": "実際の販売数",
  "实物": "実物",
  "虚拟": "デジタル商品",
  "配送方式": "配送方法",
  "快递配送": "宅配便",
  "无需快递": "配送不要",
  "入库状态": "登録ステータス",
  "入库状态的产品，成员可以在APP、Web工作台查看，访客不能查看": "登録済みの製品は、メンバーがアプリやWebワークベンチで閲覧できます。ゲストは閲覧できません。",
  "上架状态的产品，成员和访客在小程序、官网可以查看": "掲載ステータスの製品は、メンバーと訪問者がミニプログラム・公式サイトで閲覧できます。",
  "申请上架": "掲載を申請",
  "其他成员正在编辑该产品，请稍候再试。": "他のメンバーがこの製品を編集中です。しばらくしてからもう一度お試しください。",
  "复制成功!": "コピーしました",
  "删除成功!": "削除しました",
  "上架成功！": "公開しました",
  "上架成功": "公開しました",
  "已提交审核": "審査に提出しました",
  "已下架": "掲載を停止しました",
  "下架成功！": "掲載を停止しました",
  "申请上架成功！": "掲載申請を送信しました",
  "下架理由": "掲載停止の理由",
  "下架时间": "掲載停止日時",
  "申请理由": "申請理由",
  "请填写申请理由": "申請理由を入力してください",
  "提交申请": "申請を送信",
  "批量操作": "選択項目の操作",
  "退出批量操作": "一括操作を終了",
  "批量上架": "一括掲載",
  "批量下架": "一括掲載停止",
  "一键入库": "一括登録",
  "一键删除": "削除",
  "最低价": "最低価格",
  "最高价": "最高価格",
  "模型": "モデル",
  "价格": "価格",

  "有贴图": "テクスチャあり",
  "无贴图": "テクスチャなし",
  "被驳回": "却下済み",
  "条每页": "件/ページ",
  "条/页": "件/ページ",
  "跳至": "移動",
  "第": "",
  "条/共": "件中",

  "请先前往私域设置，开启访客查看产品权限。": "先にプライベートスペース設定で、訪問者の製品閲覧権限を有効にしてください。",
  "跳转": "移動",
  "有": "あり",
  "基本": "基本情報",
  "新增属性": "属性を追加",
  "选择款式": "バリエーションを選択",
  "起": "から",
  "本地上传": "アップロード",
  "关联贴图": "テクスチャ関連付け",
  "请填写": "入力してください",
  "点击添加": "クリックで追加",
  "请先完成上一个规格值的填写": "先に前の仕様値の入力を完了してください",
  "建议图片大小不超过500KB": "画像サイズは500KB以下を推奨します",
  "产品贴图文件夹不存在": "製品テクスチャフォルダが存在しません",
  "云存储空间不足": "クラウドストレージの空き容量が不足しています",
  "产品图片文件夹不存在": "製品画像フォルダが存在しません",
  "请等待当前图片上传完成": "現在の画像アップロードが完了するまでお待ちください",
  "查看更多": "もっと見る",
  "其他规格同步删除": "他の仕様も同期削除",
  "压缩包": "圧縮ファイル",
  "确认删除该附件吗？": "この添付ファイルを削除しますか？",
  "文件最多上传50个": "ファイルは最大50個までです",
  "模型最多上传50个": "モデルは最大50個までです",
  "贴图最多上传1000个": "テクスチャは最大1000個までです",
  "入库时间-正序": "登録日時（昇順）",
  "入库时间-倒序": "登録日時（降順）",
  "上架时间-正序": "掲載日時（昇順）",
  "上架时间-倒序": "掲載日時（降順）",
  "名称 A→Z": "名前 A→Z",
  "名称 Z→A": "名前 Z→A",
  "请至少保留一个生效规格！": "有効な仕様を1つ以上残してください",

  // 批量下载弹窗(cloud_disk/components/batch_download_modal)
  "下载文件":"ファイルをダウンロード",
  "下载任务正在启动中请稍后尝试":"ダウンロードを開始しています。しばらくしてからもう一度お試しください。",
  "正在启动不觉云下载器，请稍候。":"Bujueクラウドダウンローダーを起動しています。しばらくお待ちください。",
  // 这2条拼成一句「未安装…请点击[下载]，…」，中间夹着可点击的「下载」，
  // 所以首尾的空格写在词条里(中文值同理),JSX 里不额外加空格
  "您暂未安装不觉云下载器，请点击":"Bujueクラウドダウンローダーがインストールされていません。",
  "，完成安装后点击重试即可开始下载。":"をクリックしてインストールしてください。インストール完了後、［再試行］をクリックすると、ダウンロードが開始されます。",
  "请使用Windows或苹果电脑进行批量下载":"一括ダウンロードは、WindowsまたはMacでご利用ください。",
  "启用{language}": "{{language}}を有効化します",
  "系统将自动翻译现有数据,翻译期间请勿改动数据": "既存データは自動的に翻訳されます。翻訳完了までデータを変更しないでください。",
  "将为您的私域开启多语言-{language}": "あなたのプライベートスペースに多言語を有効にします-{{language}}",
  "系统将自动翻译现有数据，请勿操作任何私域数据以免引发翻译问题": "システムは既存データを自動翻訳します。翻訳問題を避けるため、プライベートスペースのデータを操作しないでください。",
  "排队中...": "待機中…",
  "排队中⋯": "待機中⋯",
  "简体中文": "中国語（簡体字）",
  "拖动卡片调整顺序；默认使用首个开启的语言。": "カードをドラッグして順序を変更できます。デフォルトでは、最初に有効にした言語が使用されます。",
  "私域容量使用情况": "スペース容量の使用状況",
  "查看权益": "プラン内容を確認",
  "免费": "無料",
  "/年": "/年",
  "当前生效": "ご利用中",
  "核心基础服务": "基本サービス",
  "补差价升级": "差額でアップグレード",
  "暂不支持降级": "ダウングレードはできません",
  "到期日期：": "有効期限：",
  "到期时间：": "有効期限：",
  "确定订单": "ご注文内容の確認",
  "当前套餐剩余时长": "現在のプランの残り期間",
  "升级套餐": "プランをアップグレード",
  "购买时长": "契約期間",
  "有效期至": "有効期限",
  "原价": "通常価格",
  "抵扣": "差引額",
  "优惠码": "クーポンコード",
  "优惠": "割引",
  "支付方式": "支払い方法",
  "支付宝": "Alipay",
  "合计": "合計",
  "立即订阅": "申し込む",
  "优惠金额": "割引額",
  "容量不足，请及时升级套餐": "容量が不足しています。お早めにプランをアップグレードしてください。",
  "容量已满，请及时升级套餐": "容量が上限に達しました。お早めにプランをアップグレードしてください。",
  "原套餐已到期，部分功能不再可用，请及时续费": "以前のプランの有効期限が切れたため、一部の機能がご利用いただけません。お早めに更新してください。",
  "套餐对比": "プランを比較",
  "不觉-套餐订阅": "Bujue - プラン申し込み",
  "不觉·套餐订阅": "Bujue・プラン契約",
  "* 更多权益需求&定制服务请联系客服": "* その他の特典やカスタムサービスについては、サポートまでお問い合わせください",
  "你的私域已使用 {私域已用容量} 容量，请购买更高容量套餐，或进入管理模式清理无用数据后再试。": "プライベートスペースの使用容量は{私域已用容量}に達しています。より大容量のプランを購入するか、管理モードで不要なデータを削除してから再試行してください。",
  "/页": "/ページ",
  "跳至 {页码} 页": "{{pageNum}}ページへ移動",
  "当前私域套餐容量不足": "現在のプライベートスペースの容量プランでは、容量が不足しています。",
  "为不影响使用，请及时处理": "引き続きご利用いただくため、お早めにご対応ください。",
  "为不影响使用，请联系私域管理员处理": "引き続きご利用いただくため、プライベートスペースの管理者に対応を依頼してください。",
  "当前私域套餐容量不足，为不影响使用，请及时处理": "現在のプライベートスペースの容量プランでは、容量が不足しています。引き続きご利用いただくため、お早めにご対応ください。",
  "当前私域套餐容量不足，为不影响使用，请联系私域管理员处理": "現在のプライベートスペースの容量プランでは、容量が不足しています。引き続きご利用いただくため、プライベートスペースの管理者に対応を依頼してください。",
  "立即续费/升级": "更新／アップグレード",
  "暂不支持降级套餐": "プランのダウングレードは現在未対応です",
  "套餐购买或套餐续期时，原价=新套餐单价*购买时长.": "プランの購入または更新時、通常価格 = 新プランの単価 × 契約期間。",
  "套餐升级时，原价=新套餐原单价*（原套餐总时长-赠送时长）/原套餐总时长天数*剩余时长天数.": "プランのアップグレード時、通常価格 = 新プランの通常単価 ×（元プランの合計期間 - 付与期間）/ 元プランの合計日数 × 残り日数。",
  "仅套餐升级时有抵扣金额，抵扣金额=生效订单优惠价/生效订单有效期天数*生效订单剩余天数+所有待生效续期订单实付价总和.": "差引額はプランアップグレード時のみ適用されます。差引額 = 有効注文の割引価格 / 有効注文の有効期間（日）× 有効注文の残り日数 + すべての未適用更新注文の実払い合計。",
  "套餐新购买或续费时：优惠金额 = 原价 * (1 - 折扣)": "新規購入または更新時：割引額 = 通常価格 × (1 - 割引率)",
  "升级套餐时：优惠金额 = (原价 - 抵扣) * (1 - 折扣)": "アップグレード時：割引額 = (通常価格 - 差引額) × (1 - 割引率)",
  "你的私域已使用 {cloudStorage} 容量，请购买更高容量套餐，\n或进入管理模式清理无用数据后再试": "プライベートスペースの使用容量は{{cloudStorage}}に達しています。より大容量のプランを購入するか、\\n管理モードで不要なデータを削除してから再試行してください。",
  "请输入6位优惠码": "6桁のクーポンコードを入力してください",
  "输入优惠码": "クーポンコードを入力",
  "请输入有效优惠码": "有効なクーポンコードを入力してください",
  "优惠码：请联系不觉客服获取优惠码.": "クーポンコード：Bujueカスタマーサポートにお問い合わせください。",
  "请输入优惠码享受优惠:": "クーポンコードを入力して適用：",
  "立即扩容": "容量を拡張",
  "立即购买": "購入する",
  // クラウドディスク
  "文件名": "ファイル名",
  "目标文件夹中的文件": "移動先フォルダー内のファイル",
  "正在上传的文件": "アップロード中のファイル",
  "保留两者": "両方保持",
  "覆盖": "置き換え",
  "已有的文件": "既存のファイル",
  "文件信息": "ファイル情報",
  "文件路径": "ファイルパス",
  "上传文件": "ファイルをアップロード",
  "上传文件夹": "フォルダーをアップロード",
  "未命名文件夹": "名称未設定フォルダー",
  "创建文件夹": "フォルダーを作成",
  "重命名": "名前の変更",
  "产品素材库只能上传图片！": "製品素材ライブラリには画像のみアップロードできます",
  "云盘容量耗尽": "クラウドストレージの容量が上限に達しました",
  "云盘容量不足": "クラウドストレージの空き容量が不足しています",
  "部分文件超出云盘容量": "一部のファイルがクラウドストレージの空き容量を超えています",
  "上传列表": "アップロード一覧",
  "没有上传任务": "アップロードタスクはありません",
  "上传中": "アップロード中",
  "已完成": "完了",
  "暂无上传任务": "アップロードタスクはありません",
  "上传成功": "アップロードしました",
  "文件夹名不能为空": "フォルダー名は必須です",
  "文件名不能为空": "ファイル名は必須です",
  "文件名不能包含以下字符:": "ファイル名に次の文字は使用できません：",
  "当前文件夹名字已存在": "同じ名前のフォルダーが既に存在します",
  "当前文件名已存在": "同じ名前のファイルが既に存在します",
  "重命名成功": "名前を変更しました",
  "重命名失败": "名前の変更に失敗しました",
  "当前文件暂不支持在线预览": "このファイルはオンラインプレビューに対応していません",
  "当前文件暂不支持在线预览,是否下载查看": "このファイルはオンラインプレビューに対応していません。ダウンロードして表示しますか？",
  "贴图库文件夹不能向内外移动！": "テクスチャライブラリフォルダーは内外に移動できません",
  "文件只能移动到产品素材库文件夹里！": "ファイルは製品素材ライブラリフォルダーにのみ移動できます。",
  "贴图库文件夹不能向外移动！": "テクスチャライブラリフォルダーは外側に移動できません",
  "非贴图库文件夹不能向内移动！": "テクスチャライブラリ以外のフォルダーは内側に移動できません",
  "移动失败": "移動に失敗しました",
  "文件重名": "ファイル名重複",
  "文件重复": "重複ファイル",
  "以下文件重名，请选择操作。选择保留两者时，正在上传的文件将被自动重命名；选择覆盖时，目标文件夹中的文件将被正在上传的文件覆盖。": "以下のファイルは名前が重複しています。操作を選択してください。「両方保持」を選ぶとアップロード中のファイルが自動的にリネームされ、「上書き」を選ぶと移動先フォルダーのファイルがアップロード中のファイルで上書きされます。",
  "以下文件和正在上传的文件重复，请确认是否继续上传？确认继续上传，如果存在文件重名，正在上传的文件将会被自动重命名。": "以下のファイルはアップロード中のファイルと重複しています。アップロードを続けますか？続ける場合、名前が重複していればアップロード中のファイルが自動的にリネームされます。",
  "（仅管理员可见）": "（管理者のみ）",
  "（系统）": "（システム）",
  "无法移动至产品素材库外": "製品素材ライブラリの外には移動できません",
  "无法移动至产品素材库文件夹": "製品素材ライブラリフォルダーには移動できません",
  "无法移动至{{name}}文件夹": "{{name}}フォルダーには移動できません",
  "{{name}}库不能重命名、移动和删除，不能添加文件/文件夹": "{{name}}ライブラリは名前の変更・移動・削除ができず、ファイルやフォルダーも追加できません",
  "{{name}}不能重命名、移动和删除": "{{name}}は名前の変更・移動・削除ができません",
  "确认要删除吗？该图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。": "削除してもよろしいですか？この画像は製品に関連付けられています。完全に削除する場合は、関連製品で画像を削除または差し替えてください。",
  "确认要删除吗？已选图片已关联产品。如需彻底删除，请前往关联产品移除或替换图片。": "削除してもよろしいですか？選択した画像は製品に関連付けられています。完全に削除する場合は、関連製品で画像を削除または差し替えてください。",
  "共{{count}}项": "全{{count}}件",
  "管理当前文件夹中的文件，不会影响关联{{name}}的展示图片": "このフォルダー内のファイルを管理します。{{name}}に関連付けられた表示画像には影響しません。",
  "管理当前文件夹中的文件，不会影响关联{{name}}的获奖证书": "このフォルダー内のファイルを管理します。{{name}}に関連付けられた受賞証明書には影響しません。",
  "{{count}}个任务上传完成": "{{count}}件のアップロードが完了しました",
  "{{count}}个任务正在上传": "{{count}}件をアップロード中",
  // マイスペースの各タブ
  "私域列表": "プライベートスペース一覧",
  "私域数据": "プライベートスペースのデータ",
  "内容清单": "コンテンツリスト",
  "数据总览": "データ概要",
  "数据明细": "データ明細",
  "作品分享类型": "作品共有",
  "全部内容": "全コンテンツ：",
  "上新{{count}}个!": "{{count}}件の新着！",
  "上架：": "掲載：",
  "内容": "コンテンツ",
  "内容未开放": "未公開",
  "产品分享": "商品共有",
  "产品已被下架": "この製品は非公開になっています",
  "产品数量": "製品数",
  "仅作品分享、产品分享统计时长，每隔15分钟刷新数据": "滞在時間は作品シェアと製品シェアのみ集計し、データは15分ごとに更新されます。",
  "介绍分享": "紹介のシェア",
  "停留时长统计": "滞在時間の統計",
  "停留时长": "滞在時間",
  "停留时长(累计)": "滞在時間（累計）",
  "每日时长": "1日あたりの滞在時間",
  "升序": "昇順",
  "降序": "降順",
  "分享标题": "シェアタイトル",
  "分享次数": "シェア回数",
  "分享类型": "シェアタイプ",
  "分享记录": "シェア履歴",
  "分享链接": "シェアリンク",
  "区域：": "エリア：",
  "单价": "単価",
  "单价不能小于1": "単価は1以上にしてください",
  "咨询对象": "問い合わせ先",
  "型号": "型番",
  "处理中": "処理中",
  "正在处理...": "処理中…",
  "官方模板": "公式テンプレート",
  "小程序空间分享": "ミニプログラムのスペースシェア",
  "已回复": "返信済み",
  "已处理": "処理済み",
  "已忽略": "無視済み",
  "待处理": "処理待ち",
  "报价单": "見積書",
  "按私域": "スペース別",
  "描述": "説明",
  "搜索关键字": "検索キーワード",
  "数量": "数量",
  "时长": "継続時間",
  "暂无数据！": "データがありません",
  "暂无联系方式！": "連絡先情報がありません",
  "暂无规格": "仕様はまだありません",
  "材料名称": "マテリアル名",
  "查看次数": "閲覧数",
  "查看次数统计": "閲覧回数の統計",
  "标题": "タイトル",
  "正常": "有効",
  "生成报价单": "見積書を作成",
  "生成": "生成",
  "导出成功！": "エクスポートしました",
  "确认要删除这条记录吗？": "このレコードを削除してもよろしいですか？",
  "私域已停用": "スペースは無効です",
  "取消关注": "フォロー解除",
  "置顶成功！": "ピン留めしました",
  "进入": "開く",
  "空间分享": "スペースのシェア",
  "置顶卡片": "ピン留めされたカード",
  "至少选择一个": "1つ以上選択してください",
  "设计风格": "デザインスタイル",
  "设计类型": "デザインタイプ",
  "请填写单价": "単価を入力してください",
  "请填写型号": "型番を入力してください",
  "请填写数量": "数量を入力してください",
  "请填写规格": "仕様を入力してください",
  "请完善材料的合计价格": "マテリアルの合計金額を入力してください",
  "折扣不能超过1": "割引は1以下にしてください",
  "折扣要大于0": "割引は0より大きい値を入力してください",
  "请选择单位": "単位を選択してください",
  "请选择成员！": "メンバーを選択してください",
  "暂无可转单的成员！": "担当者を変更できるメンバーがいません",
  "请选择规格": "仕様を選択してください",
  "转单成功！": "転送しました",
  "选择模板": "テンプレートを選択",
  "阅读次数": "閲覧回数",
  "限制次数": "回数制限",
  "收件箱": "受信トレイ",
  "发件箱": "送信トレイ",
  "下载报价单": "見積書をダウンロード",
  "保存草稿": "下書きを保存",
  "共{{count}}条": "全{{count}}件",
  "已收藏（{{count}}）": "お気に入り（{{count}}）",
  "设置折扣：": "割引を設定：",
  "材料数：": "マテリアルの数：",
  "总价：": "合計価格：",
  "折扣价：": "割引価格：",
  "请联系客服": "サポートにご連絡ください",
  "定制模板": "カスタムテンプレート",
  "定制": "カスタム",
  "分": "分",
  "秒": "秒",
  "小时": "時間",
  "手机：": "携帯番号：",
  "邮箱：": "メールアドレス：",
  "提交人：": "提出者：",
  "提交时间：": "提出日時",
  "其他联系方式：": "その他の連絡先",
  "该": "この",
  "生成报价": "見積書を作成",
  "查看报价": "見積書を見る",
  "转单": "担当者を変更",
  "恢复": "復元",
  "请选择处理的成员": "処理するメンバーを選択してください",
  "小计：": "小計：",
  // WEB+H5 新增文案（2026-09-07）
  "私域会员（{数量}）": "会員（{数量}）",
  "作品类型偏好Top5": "よく見る作品タイプTOP5",
  "内容浏览：{数量}": "コンテンツ閲覧：{数量}",
  "产品收藏：{数量}": "お気に入り商品：{数量}",
  "{数量}条/页": "1ページあたり{数量}件",
  "登录不觉账号并加入  {teamName} 会员，享受会员专属权益与服务。": "Bujueアカウントにログインして {teamName}の会員に登録すると、会員限定の特典とサービスをご利用いただけます。",
  "{次数}次": "{次数}回",
  "{分钟}分{秒}秒": "{分钟}分{秒}秒",
  "{秒}秒": "{秒}秒",
  "开启私域会员管理": "会員管理を有効にする",
  "内容偏好": "コンテンツの好み",
  "会员昵称": "会員名",
  "会员状态": "会員ステータス",
  "用户信息": "会員情報",
  "用户画像": "会員分析",
  "互动记录": "アクティビティ履歴",
  "已离职": "退職済み",
  "产品分享": "商品のシェア",
  "近7天": "過去7日間",
  "近30天": "過去30日間",
  "累计访问次数": "累計アクセス回数",
  "平均停留时长": "平均滞在時間",
  "浏览作品数": "閲覧した作品数",
  "浏览产品数": "閲覧した商品数",
  "分享产品数": "共有した商品数",
  "内容浏览": "コンテンツ閲覧",
  "最近浏览日期": "最終閲覧日時",
  "介绍页": "紹介ページ",
  "选品官": "商品セレクター",
  "主动注册": "直接登録",
  "请输入标签名称": "タグ名を入力してください",
  "该标签已存在，请换一个名称": "このタグはすでに存在します。別の名前を入力してください。",
  "标签存在问题，请修改后再保存": "タグに問題があります。修正してから保存してください。",
  "批量编辑时，修改任一会员信息将同步至其他已选会员": "一括編集中にいずれかの会員情報を変更すると、選択中の他の会員にも反映されます。",
  "登录/注册不觉账号": "Bujueアカウントにログイン／新規登録",
  "请输入手机号或邮箱": "携帯電話番号またはメールアドレスを入力してください。",
  "注册不觉账号并加入 {teamName} 会员，享受会员专属权益与服务": "Bujueアカウントを作成して{teamName}の会員に登録すると、会員限定の特典とサービスをご利用いただけます。",
  "请先开启私域会员，再开启本功能。否则会导致无法获取访客个人数据。": "先に会員管理を有効にしてから、本機能を有効にしてください。会員管理が有効になっていない場合、訪問者の個人データを取得できません。",
  "已选中：{{count}}": "選択済み：{{count}}",
  "已同步更新 {{count}} 位会员的 {{fieldName}}": "{{count}}名の会員の{{fieldName}}を一括更新しました",
  "开启会员管理前，需先确认用户注册 / 登录时需同意的《私域会员协议》与《私域隐私协议》": "会員管理を有効にする前に、ユーザーが登録／ログイン時に同意する必要のある「会員規約」と「プライバシーポリシー」を確認してください。",
  "暂无会员数据": "会員データはまだありません",
  "查看次数": "閲覧数",
  "圈子私域": "サークル連携スペース",
  "我已阅读并同意《私域会员协议》《私域隐私政策》": "「会員規約」と「プライバシーポリシー」を確認し、同意します。",
  "请阅读并勾选同意协议和隐私政策": "会員規約とプライバシーポリシーを確認し、同意してください。",
  "浏览收藏": "閲覧・お気に入り",
  "内容名称": "コンテンツ名",
  "收藏时间": "お気に入り登録日時",
  "收藏产品数": "お気に入り商品数",
  "产品收藏": "お気に入り商品",
  "产品分类偏好Top5": "よく見る商品カテゴリTOP5",
  "登录成功": "ログインしました",
  // 作成スペースガイドの文言
  "私域是指个人或团队通过不觉建立的数据信息库，可广泛应用于品牌展示、销售转化及精准营销等场景。": "プライベートスペースとは、個人やチームがBujue上で構築するデータ情報ライブラリで、ブランド訴求、コンバージョン促進、ターゲティングマーケティングなどの場面で幅広く活用できます。",
  "私域logo": "スペースのロゴ",
  "创建私域空间，可以自动保存您添加的产品数据": "プライベートスペースを作成すると、追加した製品データが自動的に保存されます。",
  "名称不能为纯数字": "名前に数字のみは使用できません",
  "专属产品库": "専用製品ライブラリ",
  "创建私域，即可将产品入库至个人或团队产品库，集中管理更高效": "プライベートスペースを作成し、個人またはチームの製品ライブラリに製品を追加して、より効率的な集中管理を実現します。",
  "创意板工具": "クリエイティブボードツール",
  "直接调用产品及贴图，一键生成产品清单或白皮书，轻松展示方案": "製品やテクスチャを直接呼び出し、ワンクリックで製品リストやホワイトペーパーを生成して、提案を簡単に提示できます。",
  "插件工具库": "プラグインツールライブラリ",
  "联动 Revit、3DMax、Rhino、SketchUp 等设计软件，随时调用产品模型与贴图，提升设计效率": "Revit、3DMax、Rhino、SketchUpなどの設計ソフトと連携し、製品モデルやテクスチャをいつでも呼び出せるため、設計効率が向上します。",
  "支持产品一键上架至公域（紫菜海洋），拓展产品曝光": "ワンクリックで製品をパブリック領域（紫菜海洋）に公開し、露出を拡大できます。",
  "名称不能超过40个字": "名前は40文字以内で入力してください",
  "私域名称包含敏感词汇": "プライベートスペース名に不適切な語句が含まれています",
  "请输入 私域名称": "スペース名を入力",
  "我已阅读并同意协议": "規約を読んで同意します",
  "《不觉私域服务协议》": "『Bujueプライベートスペース利用規約』",
  "查看第{{index}}项": "{{index}}件目を表示",
  // 私域语言开通提示
  "配置说明": "設定手順",
  "语言": "言語",
  "前往设置": "設定に移動",
  "暂不设置": "後で設定",
  "1.介绍在不同语言下，都是同一套配置": "1. 紹介文は言語が異なっても同一の設定です。",
  "2.作品图片、视频、链接上传一次，文本需要按照语言包配置多套": "2. 作品の画像・動画・リンクのアップロードは1回のみで、テキストは言語パックごとに設定する必要があります。",
  "3.产品图片、视频、介绍、附件上传一次，文本需要按照语言包配置多套": "3. 製品の画像・動画・紹介文・添付ファイルのアップロードは1回のみで、テキストは言語パックごとに設定する必要があります。",
  "4、合作的邀请链接只需要分享一次，分组名称需要按照语言包配置": "4. 提携の招待リンクは1回共有するだけで済み、グループ名は言語パックごとに設定する必要があります。",
  "{{teamName}}已成功开通{{langNames}}语言包": "{{teamName}}で{{langNames}}の言語パックが有効になりました。",
  "请前往设置基础信息": "基本情報の設定に移動してください。",
  // —— チームホームのカバー効果設定ダイアログ（2026-09-18）——
  "封面效果": "カバー効果",
  "封面预览": "カバープレビュー",
  "封面模糊背景": "カバーのぼかし背景",
  "图片裁剪：": "トリミング：",
  "长边撑满": "長辺に合わせる",
  "短边撑满": "短辺に合わせる",
  "背景效果：": "背景効果：",
  "白色背景": "白背景",
  "灰色背景": "グレー背景",
  "模糊背景": "ぼかし背景",
  "封面配置查询失败": "カバー設定の取得に失敗しました",
  // —— 製品おすすめ管理ダイアログ（おすすめ設定 / 新製品設定）2026-10-14 ——
  "产品推荐管理": "製品おすすめ管理",
  "推荐设置": "おすすめ設定",
  "新品设置": "新製品設定",
  "新品": "新製品",
  "可选产品": "選択可能な製品",
  "全部删除": "すべて削除",
  "已添加": "追加済み",
  "最多可设置{{maxCount}}个": "最大{{maxCount}}件まで設定できます",
  '在"{分类名称}"中搜索': '「{分类名称}」内で検索',
  "推荐排序": "おすすめ順",
  "浏览量排序": "閲覧数順",
  "上新": "新着",
  "上市时间：": "発売日：",
  "上市时间": "発売日",
  "已下架": "非公開",
  "其他成员正在编辑，请稍候再试。": "他のメンバーが編集中です。しばらくしてからもう一度お試しください。",
  "仅已上架产品可设为推荐，拖动右侧产品可调整展示顺序。": "掲載済みの製品のみおすすめに設定できます。右側の製品をドラッグして表示順を調整できます。",
  "仅已上架产品可设为新品，拖动右侧产品可调整展示顺序。": "掲載済みの製品のみ新製品に設定できます。右側の製品をドラッグして表示順を調整できます。",
  "产品附件": "製品添付ファイル",

  "个人名片：": "個人名刺：",
  "封面图不可取消勾选": "カバー画像は選択解除できません",
  "请输入有效手机号码": "有効な携帯番号を入力してください",
  "请输入正确的手机号或邮箱账号": "有効な携帯番号またはメールアドレスを入力してください",
  "验证码不能为空": "認証コードを入力してください",
  "密码不能为空": "パスワードを入力してください",
  "验证码错误": "認証コードが正しくありません",
  "密码错误": "パスワードが正しくありません",
  "请确认您的密码": "パスワードを確認してください",
  "您输入的两个密码不匹配": "入力した2つのパスワードが一致しません",
  "最低参考价不能大于或等于最高参考价": "最低参考価格は最高参考価格以上にできません",
  "标签不能重名": "タグ名が重複しています",
  "最多可选5个标签": "タグは最大5個まで選択できます",
  "确定要删除吗?已关联产品中的对应标签会一并删除": "削除してもよろしいですか？関連製品の対応するタグも一緒に削除されます",
  "私域类型不能为空": "プライベートドメインタイプは空にできません",
  "请输入优惠码享受优惠，优惠金额=原价*（1-折扣）": "割引コードを入力して割引を受けてください。割引額＝×（1－割引率）",
  "私域Saas工具": "プライベートスペースSaaSツール",
  "件被驳回的产品，确定要重新提交上架吗？": "件が却下された製品です。再度掲載申請を送信しますか？",
  "确定要执行批量上架吗？已选": "一括掲載を実行しますか？選択済み",
  "件产品中包含": "件の製品のうち",

  "select_product_origin": "製品の原産地を選択してください",
  "province_city": "省・市の選択",
  "select_province_city": "省・市を選択してください",
  "supplier_name_is_required": "サプライヤー名は必須です",
  "enter_supplier_name": "サプライヤー名を入力してください",
  "supplier_avatar_is_required": "サプライヤーのアイコンは必須です",
  "select_date": "日付を選択してください",
  "terms_updated": "規約の更新",
  "in_my_space_you_can_view_your_share_history_follows_and_private_space": "マイスペースでは、共有履歴、フォロー、プライベートスペースを確認できます。",
  "the_platform_has_given_you_a_free_three_month_membership": "3か月間の無料メンバーシップをプレゼントしました",
  "free_gift": "無料ギフト",
  "three_month_membership": "3か月メンバーシップ",
  "value_items": "{{value}}件",
  "new_inquiries_need_to_be_processed": "未処理の見積依頼があります",
  "you_can_upload_up_to_value_attachments": "添付ファイルは最大{{value}}個までアップロードできます。",
  "failed_to_upload_value": "{{value}}のアップロードに失敗しました",
  "upload_attachment": "添付ファイルをアップロード",
  "value_is_not_a_pdf_file": "{{value}}はPDFファイルではありません",
  "value_is_not_an_image": "{{value}}は画像ではありません",
  "value_must_not_exceed_4_mb": "{{value}}は4MB以下にしてください",
  "brand_logo": "*ブランドロゴ",
  "brand_logoV2": "ブランドロゴ",
  "china": "中国",
  "logo": "ロゴ",
  "name_is_required": "名前は必須です",
  "brand_already_exists": "ブランドはすでに存在します",
  "enter_brand_name": "ブランド名を入力してください",
  "brand_name": "*ブランド名",
  "upload_a_logo": "ロゴをアップロードしてください",
  "enter_country": "国を入力してください",
  "select_brand_category": "ブランドカテゴリーを選択してください",
  "edit_brand_type": "ブランドタイプを編集",
  "add_brand_type": "ブランドタイプを追加",
  "type_name": "タイプ名",
  "enter_type_name": "タイプ名を入力してください",
  "chinaV2": "中国",
  "brand_nameV2": "ブランド名*",
  "logoV2": "ロゴ",
  "type": "タイプ*",
  "select_brand_type": "ブランドタイプを選択してください",
  "country": "国*",
  "others": "その他",
  "equipment": "設備",
  "name": "名前",
  "free_version": "無料版",
  "free_versionV2": "無料版",
  "buy": "購入",
  "upgrade": "アップグレード",
  "renew": "更新",
  "used_capacity": "使用容量：",
  "original_plan_expiration_date": "元のプランの有効期限：",
  "quantity": "数量",
  "plan_duration_is_up_to_value_3_years_at_a_time": "プランの期間は一度に最大{{value}}3年です",
  "select_at_least_1_year": "1年以上を選択してください",
  "original_price_new_plan_original_unit_price_original_plan_total_term_bonus_duration_original_plan_total_days_remaining_days": "通常価格 = 新プランの通常単価 ×（元プランの合計期間 - 付与期間）/ 元プランの合計日数 × 残り日数",
  "original_price_list_price_subscription_term": "通常価格 = 定価 × 契約期間",
  "the_value_promo_code_has_been_redeemed_for_you_value": "{{value}}割引のクーポンコードを引き換えました：{{value}}",
  "pay_difference": "差額を支払う",
  "select_payment_method": "支払い方法を選択してください",
  "dear_user_your_storage_is_running_out_to_prevent_important_files_from_being_deleted_automatically_upgrade_your_plan_or_manually_delete_unnecessary_files_as_soon_as_possible": "お客様各位、ストレージ容量が不足しています。重要なファイルが自動削除されるのを防ぐため、お早めにプランをアップグレードするか、不要なファイルを手動で削除してください。",
  "failed_to_upload_value_please_try_again": "{{value}}のアップロードに失敗しました。もう一度アップロードしてください。",
  "upload_hd_assets": "高解像度素材をアップロード",
  "name_number": "名前・番号",
  "asset_name_number": "素材名・番号",
  "image_is_required": "画像は必須です",
  "pdf_image": "PDF画像",
  "this_is_the_content_on_the_right": "右の内容です",
  "cad": "CAD",
  "product_texture": "製品テクスチャ",
  "hd_assets": "高解像度素材",
  "pdf_imageV2": "PDF画像",
  "residential": "住宅内装",
  "commercial": "商業内装",
  "attachment_upload_is_not_complete": "添付ファイルのアップロードが完了していません。",
  "publish": "公開",
  "are_you_sure_you_want_to_clear_the_product_introduction": "製品紹介をクリアしてもよろしいですか？",
  "enter_product_name": "製品名を入力してください",
  "enter_product_nameV2": "※製品名を入力してください",
  "enter_model": "型番を入力してください",
  "enter_series_and_model": "※シリーズと型番を入力してください",
  "enter_series_and_modelV2": "シリーズと型番を入力してください",
  "enter_specifications_and_size": "仕様・寸法を入力してください",
  "enter_supplier": "サプライヤーを入力してください",
  "select_product_attributes": "製品属性を選択してください",
  "piece": "点",
  "hd_assets_texture_maps": "高解像度素材（テクスチャマップ）",
  "s_invitation_you_can_enter_product_information_in_the_list_below_and_submit_it_after_the_private_space_administrator_approves_it_the_product_will_be_automatically_added_to": "からの招待です。以下のリストに製品情報を入力して送信してください。プライベートスペース管理者の承認後、製品は自動的に追加されます。",
  "private_space_saas_tools": "プライベートスペースSaaSツール",
  "keep_at_least_one_tab": "少なくとも1つのタブを残してください",
  "hd_assetsV2": "高解像度素材",
  "pdf_imageV3": "PDF画像",
  "residentialV2": "住宅内装",
  "commercialV2": "商業内装",
  "product_textureV2": "製品テクスチャ",
  "chinese_n": "中国語N",
  "english": "英語",
  "japanese": "日本語",
  "test": "テスト",
  "chinese_nV2": "中国語N",
  "validity_period_updated": "有効期限を調整しました",
  "adjust_validity_period": "有効期限の調整",
  "card_expiry": "カードの有効期限",
  "select_dateV2": "日付を選択してください",
  "are_you_sure_you_want_to_value_this_request_card": "このリクエストカードを{{value}}してもよろしいですか？",
  "visible_to_everyone": "全員に公開",
  "block_peers": "同業者をブロック",
  "complete_the_request_and_close_the_card": "リクエストを完了してカードを閉じる",
  "are_you_sure_you_want_to_close_this_request_card": "このリクエストカードを閉じてもよろしいですか？",
  "withdraw_card_to_drafts": "カードを下書きに戻す",
  "are_you_sure_you_want_to_withdraw_this_request_card": "このリクエストカードを取り下げてもよろしいですか？",
  "withdrawn": "取り下げました",
  "withdrawal_failed": "取り下げに失敗しました",
  "adjust_card_expiry": "カードの有効期限を調整",
  "edit_contact_information": "連絡先を変更",
  "are_you_sure_you_want_to_delete_this_request_card": "このリクエストカードを削除してもよろしいですか？",
  "delete_card": "カードの削除",
  "show_less": "折りたたむ",
  "show_more": "もっと見る",
  "request_details": "リクエスト内容",
  "unlimited": "無制限",
  "value_yuan_unit": "{{value}}元/単価",
  "curated": "厳選",
  "about_value_value": "約{{value}}{{value}}",
  "reference_image": "参考イメージ",
  "register_as_a_supplier_to_add_favorites_or_participate": "お気に入り登録や参加にはサプライヤーとして登録してください。",
  "switch_to_the_supplier_role": "サプライヤーの役割に切り替えてください",
  "participate": "参加",
  "are_you_sure_you_want_to_close_this_page": "このページを閉じてもよろしいですか？",
  "anonymous": "匿名",
  "card_expiryV2": "カードの有効期限",
  "to": "まで",
  "curatedV2": "厳選",
  "series": "シリーズ",
  "show_lessV2": "折りたたむ",
  "show_moreV2": "もっと見る",
  "request_detailsV2": "リクエスト内容",
  "unlimitedV2": "無制限",
  "value_yuan_unitV2": "{{value}}元/単価",
  "about_value_valueV2": "約{{value}}{{value}}",
  "you_cannot_participate_in_your_own_cards": "自分で作成したカードには参加できません",
  "delete_all_participation_in_this_item": "このアイテムへの参加をすべて削除しますか？",
  "your_submission_is_not_complete_exit_anyway": "まだ送信が完了していません。終了しますか？",
  "you_cannot_add_your_own_cards_to_favorites": "自分で作成したカードはお気に入りに追加できません",
  "removed_from_favorites": "お気に入りから削除しました",
  "added_to_favorites": "お気に入りに追加しました",
  "anonymousV2": "匿名",
  "card_expiryV3": "カードの有効期限",
  "toV2": "まで",
  "rejection_reason": "却下理由：",
  "rejection_reason_value": "差し戻し理由：{{value}}",
  "public": "公開",
  "block_peersV2": "同業者をブロック",
  "are_you_sure_you_want_to_delete_this_request_cardV2": "このリクエストカードを削除してもよろしいですか？",
  "register_as_a_supplier_to_add_favorites_or_participateV2": "お気に入り登録や参加にはサプライヤーとして登録してください。",
  "switch_to_the_supplier_roleV2": "サプライヤーの役割に切り替えてください",
  "unlimitedV3": "無制限",
  "anonymousV3": "匿名",
  "expired": "失効済み",
  "downloading": "ダウンロード中…",
  "file_not_found": "対応するファイルが見つかりません",
  "this_file_is_too_large_to_preview": "ファイルが大きいためプレビューできません",
  "import_pdf": "PDFをインポート",
  "complete_import": "インポートを完了",
  "invalid_page_number_format": "ページ番号の形式が正しくありません",
  "import_pdfV2": "PDFをインポート",
  "specific_pages": "ページ指定",
  "e_g_1_2_5_7_10": "例：1、2-5、7-10",
  "the_higher_the_resolution_the_longer_the_import_time": "解像度が高くなるほど、インポート時間は長くなります",
  "complete_importV2": "インポートを完了",
  "file_size_exceeds_the_limit_upload_again": "ファイルサイズが制限を超えています。もう一度アップロードしてください",
  "upload_attachmentV2": "添付ファイルをアップロード",
  "supported_formats_pdf_ppt_doc_under_50mb": "対応形式：PDF、PPT、DOC（50MB未満）",
  "duplicate_parameter_name": "パラメータ名が重複しています",
  "enter_feature_name": "特性名を入力してください",
  "enter_feature_nameV2": "特性名を入力してください",
  "date_modified": "更新日時",
  "edit_folder": "フォルダを編集",
  "add_folder": "フォルダを追加",
  "cannot_exceed_30_characters": "30文字以内で入力してください",
  "file_folder_name": "ファイル／フォルダ名",
  "new_file": "新規ファイル",
  "post_request": "リクエストを作成",
  "select_none": "すべて解除",
  "private": "非公開",
  "about_us": "私たちについて",
  "features": "機能紹介",
  "partnerships": "業務提携",
  "contact_us": "お問い合わせ",
  "finished_product": "完成品",
  "all_statuses": "すべてのステータス",
  "draft": "下書き",
  "not_approved": "未承認",
  "privateV2": "非公開",
  "curatedV3": "厳選",
  "this_product_has_already_been_added": "この製品は追加済みです",
  "origin": "産地",
  "crop_the_image": "画像をトリミングしてください",
  "download_failed": "ダウンロードに失敗しました",
  "crop_me": "トリミング範囲を調整",
  "failed_to_load_the_image_please_try_again_later": "画像の読み込みに失敗しました。後でもう一度お試しください。",
  "crop_the_imageV2": "画像をトリミングしてください",
  "download_failedV2": "ダウンロードに失敗しました",
  "crop": "トリミングを確定",
  "unlock_default_ratio": "デフォルト比率の固定を解除",
  "lock_default_ratio": "デフォルト比率をロック",
  "rotate_right": "右回転",
  "rotate_left": "左回転",
  "zoom_in": "ズームイン",
  "zoom_out": "ズームアウト",
  "crop_meV2": "トリミング範囲を調整",
  "click_to_upload": "クリックしてアップロード",
  "image_size_cannot_exceed_value_mb": "画像サイズは{{value}}MB以下にしてください",
  "enter_description": "説明を入力してください",
  "click_to_uploadV2": "クリックしてアップロード",
  "value_is_not_an_imageV2": "{{value}}は画像ではありません",
  "image_size_limit_4mb": "画像サイズ制限4MB",
  "no_more_than_4mb": "4MB以下",
  "added_to_favoritesV2": "お気に入りに追加しました",
  "failed_to_get_verification_code_try_again": "認証コードの取得に失敗しました。再度取得してください",
  "complete_the_puzzle_first": "まずはパズルを完成させてください",
  "enter_your_phone_number": "携帯電話番号を入力してください",
  "enter_verification_code": "認証コードを入力してください",
  "failed_to_get_verification_code_try_againV2": "認証コードの取得に失敗しました。再度取得してください",
  "complete_the_puzzle_firstV2": "まずはパズルを完成させてください",
  "failed_to_get_verification_code_try_againV3": "認証コードの取得に失敗しました。再度取得してください",
  "confirm_that_you_have_read_the_agreement": "規約をお読みのうえ同意してください",
  "user_agreement": "「利用規約」",
  "privacy_policy": "「プライバシーポリシー」",
  "terms_of_service": "「サービス利用規約」",
  "children_s_personal_information_protection_rules_and_instructions_for_guardians": "「児童の個人情報保護規程と保護者への注意事項」",
  "wechat_login": "WeChatログイン",
  "panzi_login": "Panziログイン",
  "wechat_loginV2": "WeChatログイン",
  "panzi_loginV2": "Panziログイン",
  "alipay_login": "Alipayログイン",
  "other_login_methods": "他のログイン方法",
  "hold_and_drag_the_slider_to_complete_the_puzzle": "スライダーを押したままドラッグしてパズルを完成させてください",
  "value_upload_failed": "{{value}}のアップロードに失敗しました",
  "insufficient_storage_capacity": "ストレージ容量が不足しています",
  "video_files_cannot_exceed_200mb": "動画ファイルは200MB以下にしてください",
  "video_upload_failed_due_to_insufficient_storage": "ストレージ容量が不足しているため、動画のアップロードに失敗しました",
  "upload_video": "動画をアップロード",
  "to_ensure_smooth_playback_we_recommend_videos_of_20_30mb_up_to_a_maximum_of_200mb": "動画をスムーズに再生するため、動画サイズは20〜30MB、最大200MB以内でのアップロードをおすすめします。",
  "this_will_take_about_2_minutes_please_wait": "2分ほどかかります。しばらくお待ちください",
  "heiti": "ゴシック体",
  "kaiti": "楷書",
  "fangsong": "倣宋体",
  "songti": "明朝体",
  "gongfan_font": "Gongfanフォント",
  "pangmenzhengdao_bold_calligraphy": "龐門正道粗書体",
  "yanshi_chunfeng_kai": "演示春風楷",
  "youshe_haoshenti": "優設好身体",
  "sanji_xingkai_simplified_chinese": "三極行楷簡体",
  "alignment": "配置",
  "letter_spacing": "文字間隔",
  "biaukai": "標準楷書体",
  "stfangsong": "華文倣宋体",
  "stkaiti": "華文楷体",
  "microsoft_yahei": "Microsoft YaHei",
  "alimama_dongfangdakai": "Alimama東方大楷",
  "alimama_fangyuanti": "Alimama方円体",
  "dingtalk_jinbuti": "DingTalk進歩体",
  "youshe_biaoti_hei": "優設標題黒",
  "mobile": "携帯",
  "web": "ウェブページ",
  "enter_title": "タイトルを入力してください…",
  "upload_videoV2": "動画をアップロード",
  "compression_failed": "圧縮に失敗しました",
  "drag_within_the_image_area": "画像の範囲内でドラッグしてください",
  "link_click_areas_cannot_overlap": "リンクのクリック範囲は重複できません",
  "complete_the_link": "リンクの設定を完了してください",
  "link_must_start_with_http_or_https": "リンクはhttp://またはhttps://で始まる必要があります",
  "layout_effect": "レイアウト効果",
  "exit_tiling_mode": "タイリングモードを終了",
  "amap": "高徳地図",
  "apple_maps": "Appleマップ",
  "duplicate_outline_name": "アウトライン名が重複しています",
  "confirm_deletion": "削除してもよろしいですか？",
  "failed_to_save_the_long_image": "モバイル用ロング画像の保存に失敗しました",
  "value_upload_failedV2": "{{value}}のアップロードに失敗しました",
  "p_style_text_align_center_line_height_2_title_p": "<p style=\"text-align: center; line-height: 2;\">タイトル</p>",
  "enter_titleV2": "タイトルを入力してください…",
  "alignmentV2": "配置",
  "enter_content": "内容を入力してください…",
  "spacing": "間隔",
  "letter_spacingV2": "文字間隔",
  "no_animation": "アニメーションなし",
  "text_animation": "テキストアニメーション",
  "text_shadow": "テキストシャドウ",
  "text_color": "文字の色",
  "value_upload_failedV3": "{{value}}のアップロードに失敗しました",
  "failed_to_generate_the_qr_code_enter_a_valid_link": "QRコードを生成できませんでした。正しいリンクを入力してください。",
  "could_not_detect_an_address": "アドレスを取得できませんでした。",
  "qr_code": "QRコード",
  "enter_the_address_or_upload_a_qr_code": "アドレスを入力するか、QRコードをアップロードしてください",
  "enter_web_address": "ウェブアドレスを入力してください",
  "upload_logo": "ロゴをアップロードしてください",
  "logoV3": "ロゴ",
  "value_upload_failedV4": "{{value}}のアップロードに失敗しました",
  "click_to_view_map": "クリックして地図を表示",
  "enter_contentV2": "内容を入力してください…",
  "enter_titleV3": "タイトルを入力してください…",
  "value_upload_failedV5": "{{value}}のアップロードに失敗しました",
  "upload": "アップロード",
  "enter_titleV4": "タイトルを入力してください…",
  "the_desktop_version_has_not_been_uploaded_the_mobile_version_will_be_shown": "PC版がアップロードされていないため、モバイル版の内容が表示されます。",
  "value_upload_failedV6": "{{value}}のアップロードに失敗しました",
  "click_or_drag_a_single_image": "画像を1枚クリックまたはドラッグ",
  "the_mobile_version_has_not_been_uploaded_the_desktop_version_will_be_shown": "スマホ版がアップロードされていないため、PC版の内容が表示されます。",
  "value_upload_failedV7": "{{value}}のアップロードに失敗しました",
  "error": "エラー",
  "enter_contentV3": "内容を入力してください…",
  "value_upload_failedV8": "{{value}}のアップロードに失敗しました",
  "enter_titleV5": "タイトルを入力してください…",
  "enter_contentV4": "内容を入力してください…",
  "enter_contentV5": "内容を入力してください…",
  "you_can_select_up_to_value_items": "最大{{value}}件まで選択できます",
  "contact_supplier": "サプライヤーに連絡",
  "reference_price": "参考価格",
  "material_origin": "マテリアルの産地",
  "custom": "カスタム",
  "unlike": "いいね解除",
  "like": "いいね",
  "are_you_sure_you_want_to_value": "本当に{{value}}しますか？",
  "request_sample": "サンプルのお申し込み",
  "add_to_comparison": "比較に追加",
  "different_categories_cannot_be_compared": "異なるカテゴリは比較できません",
  "add_to_my_materials": "マイマテリアルに追加",
  "free_1gb_traffic": "1GBのトラフィックをプレゼント",
  "failed_to_upload_valueV2": "{{value}}のアップロードに失敗しました",
  "you_can_upload_up_to_5_files": "最大5ファイルまでアップロードできます",
  "value_is_not_a_pdf_fileV2": "{{value}}はPDFファイルではありません",
  "file_size_limit_100_mb": "ファイルサイズ上限100MB",
  "drag_files_here_or_click_to_add_pdf_format_supported": "ファイルをここにドラッグするか、クリックして追加してください（PDF形式対応）。",
  "pdf_imageV4": "PDF画像",
  "you_can_upload_up_to_value_items": "最大{{value}}件までアップロードできます",
  "pdf_imageV5": "PDF画像",
  "you_can_import_up_to_value_templates_at_a_time": "一度に最大{{value}}件のテンプレートをインポートできます",
  "you_can_upload_up_to_value_pdfs": "最大{{value}}件のPDFをアップロードできます",
  "successfully_followed_the_value_private_space": "{{value}}のプライベートスペースをフォローしました",
  "click_to_create_a_requirement": "クリックして要件を作成",
  "replace_image": "画像を差し替え",
  "edit_image": "画像を編集",
  "yuan_piece": "元/個",
  "the_background_image_has_changed_anchor_points_outside_the_image_must_be_moved_back_into_the_image_area_manually": "背景画像が変更されたため、画像の範囲外にあるアンカーポイントを手動で範囲内に移動してください。",
  "keep_anchor_points_when_replacing_the_image": "画像を差し替えた後もアンカーポイントを保持しますか？",
  "value_is_not_an_imageV3": "{{value}}は画像ではありません",
  "the_background_image_has_changed_anchor_points_outside_the_image_must_be_moved_back_into_the_image_area_manuallyV2": "背景画像が変更されたため、画像の範囲外にあるアンカーポイントを手動で範囲内に移動してください。",
  "deactivated": "停止中",
  "services_information": "サービス・情報",
  "fully_open": "フルオープン",
  "anyone_can_join": "誰でも参加可能",
  "semi_open": "セミオープン",
  "closed": "クローズド",
  "invitation_only": "招待制",
  "access_settings": "公開範囲設定",
  "member_joining": "メンバーの参加",
  "visitor_browsing": "訪問者の閲覧",
  "settings": "設定",
  "submit_results": "結果を送信",
  "closedV2": "クローズド",
  "semi_openV2": "セミオープン",
  "fully_openV2": "フルオープン",
  "submit_resultsV2": "結果を送信",
  "pay": "お支払い",
  "contact_support": "サポートに連絡",
  "following": "フォロー中",
  "my_shares": "共有履歴",
  "mine": "マイページ",
  "my_inquiries": "見積履歴",
  "language": "言語",
  "go_to_settings": "設定に移動",
  "set_up_later": "後で設定",
  "1_the_introduction_uses_the_same_content_across_all_languages": "1. 紹介文は言語が異なっても同一の設定です。",
  "2_portfolio_images_videos_and_links_are_uploaded_once_text_must_be_configured_separately_for_each_language_pack": "2. 作品の画像・動画・リンクのアップロードは1回のみで、テキストは言語パックごとに設定する必要があります。",
  "3_product_images_videos_descriptions_and_attachments_are_uploaded_once_text_must_be_configured_separately_for_each_language_pack": "3. 製品の画像・動画・紹介文・添付ファイルのアップロードは1回のみで、テキストは言語パックごとに設定する必要があります。",
  "4_the_collaboration_invitation_link_only_needs_to_be_shared_once_group_names_must_be_configured_for_each_language_pack": "4. 提携の招待リンクは1回共有するだけで済み、グループ名は言語パックごとに設定する必要があります。",
  "setup_guide": "設定手順",
  "private_space_name": "スペース名*",
  "enter_contact_address": "連絡先住所を入力してください",
  "failed_to_get_the_team_language_list_please_try_again": "チーム言語リストを取得できませんでした。もう一度お試しください。",
  "failed_to_get_private_space_information": "プライベートスペース情報の取得に失敗しました",
  "set_space_information": "スペース情報設定",
  "the_value_plugin_lets_you_use_textures_and_models_from_your_private_space_product_library_directly": "{{value}}プラグインで、プライベートスペースの製品ライブラリのテクスチャとモデルを直接利用できます",
  "stay_tuned": "近日公開",
  "product_publishing_review": "製品公開審査",
  "logoV4": "ロゴ",
  "uploading_image": "画像をアップロード中",
  "scan_to_download_the_app": "スキャンしてアプリをダウンロード",
  "page_settings": "ページ設定",
  "private_space_data_is_being_translated_please_do_not_add_new_data": "プライベートスペースのデータを翻訳中です。新しいデータを追加しないでください",
  "this_private_space_has_not_passed_business_verification_so_visitors_cannot_access_it": "このプライベートスペースは事業者認証が未完了のため、訪問者はアクセスできません。",
  "cadV2": "CAD",
  "total_value_files": "全{{value}}件のファイル",
  "total_value_textures": "全{{value}}件のテクスチャ",
  "total_value_models": "全{{value}}件のモデル",
  "hd_assetsV3": "高解像度素材",
  "total_value_items": "全{{value}}件のデータ",
  "all_attachments": "すべての添付ファイル",
  "customizable": "カスタマイズ可能",
  "parameter_error": "パラメータエラー",
  "published_successfully": "公開しました",
  "empty": "空",
  "emptyV2": "空",
  "select_service_area": "サービスエリアを選択してください",
  "latest": "最新",
  "publish_date": "公開日時",
  "views": "閲覧数",
  "saves": "保存数",
  "date_added": "追加日時",
  "high_tech_only": "ハイテク企業のみ",
  "home_page_display": "トップページ表示",
  "sample_availability": "サンプルの有無",
  "keywords": "キーワード",
  "search": "検索",
  "reference_priceV2": "参考価格",
  "originV2": "産地",
  "texture_library": "テクスチャライブラリ",
  "search_textures": "テクスチャを検索",
  "already_linked": "すでに連携済みです",
  "linked": "連携済み",
  "select_at_least_one_related_image": "関連画像を1枚以上選択してください",
  "you_can_link_up_to_value_images": "画像は最大{{value}}枚まで関連付けできます",
  "external_platform": "外部プラットフォーム",
  "global": "グローバル",
  "ignored": "無視しました",
  "value_records_imported": "{{value}}件をインポートしました",
  "are_you_sure_you_want_to_ignore_it": "無視してもよろしいですか？",
  "privateV3": "非公開",
  "originV3": "産地",
  "crop_meV3": "トリミング範囲を調整",
  "image_size_cannot_exceed_30mb": "画像サイズは30MB以下にしてください",
  "image_dimensions_must_be_between_100_100_and_4096_4096": "画像サイズは4096*4096以下、100*100以上にしてください",
  "network_error_please_try_again_later": "ネットワークエラー。後でもう一度お試しください",
  "paste_image": "画像を貼り付け",
  "supported_formats_jpg_jpeg_png_webp_gif": "jpg、jpeg、png、webp、gif形式に対応",
  "paste_images_with_ctrl_c_ctrl_v": "Ctrl+C／Ctrl+Vで画像を貼り付け可能",
  "image_size_up_to_30mb": "画像サイズは30MBまで",
  "select_image": "画像を選択",
  "drag_to_select_the_area_you_want_to_search_or_click_next_to_skip": "画像内で検索したい範囲を選択できます。「次へ」をクリックしてスキップすることもできます",
  "style_genre": "スタイル/ジャンル",
  "artwork_type": "アートワークの種類",
  "artist_nationality": "作家の国籍",
  "art_origins": "名画の起源",
  "popular": "人気",
  "international": "国際",
  "beijing": "北京",
  "shanghai": "上海",
  "guangzhou": "広州",
  "shenzhen": "深セン",
  "hangzhou": "杭州",
  "chengdu": "成都",
  "chongqing": "重慶",
  "wuhan": "武漢",
  "nanjing": "南京",
  "tianjin": "天津",
  "xi_an": "西安",
  "suzhou": "蘇州",
  "changsha": "長沙",
  "qingdao": "青島",
  "shenyang": "瀋陽",
  "ningbo": "寧波",
  "wuxi": "無錫",
  "dongguan": "東莞",
  "united_states": "米国",
  "russia": "ロシア",
  "united_kingdom": "イギリス",
  "france": "フランス",
  "germany": "ドイツ",
  "italy": "イタリア",
  "canada": "カナダ",
  "japan": "日本",
  "south_korea": "韓国",
  "nationwide": "中国全土",
  "globalV2": "グローバル",
  "reposition": "位置を変更",
  "discover": "発見",
  "all_categories": "すべてのカテゴリ",
  "nationwideV2": "中国全土",
  "zhejiang": "浙江省",
  "hangzhouV2": "杭州",
  "enter_company_name": "会社名を入力してください",
  "you_can_enter_up_to_30_characters": "最大30文字まで入力できます",
  "enter_detailed_address": "詳細住所を入力してください",
  "you_can_enter_up_to_50_characters": "最大50文字まで入力できます",
  "legal_representative": "法定代表者",
  "enter_legal_representative": "法定代表者を入力してください",
  "you_can_enter_up_to_10_characters": "最大10文字まで入力できます",
  "same_as_legal_representative": "法定代表者と同一人物ですか？",
  "different_person": "同一人物ではありません",
  "same_person": "同一人物です",
  "id_document_photos": "身分証明書の写真",
  "upload_the_portrait_side_of_your_id": "身分証明書の顔写真面をアップロードしてください",
  "upload_the_emblem_side_of_your_id": "身分証明書の国章面をアップロードしてください",
  "name_on_id": "身分証明書の氏名",
  "enter_name_on_id": "身分証明書の氏名を入力してください",
  "id_number": "身分証明書番号",
  "enter_id_number": "身分証明書番号を入力してください",
  "enter_a_valid_id_number": "正しい身分証明書番号を入力してください",
  "id_validity_period": "身分証明書の有効期限",
  "valid_for_a_fixed_period": "一定期間有効",
  "no_expiry": "無期限",
  "select_expiry_date": "身分証明書の有効期限を選択してください",
  "power_of_attorney": "委任状",
  "upload_power_of_attorney": "委任状をアップロードしてください",
  "url_email": "URL（メールアドレス）",
  "enter_url_email": "URL（メールアドレス）を入力してください",
  "enter_phone_number": "電話番号を入力してください",
  "telex": "テレックス",
  "enter_telex": "テレックスを入力してください",
  "zip_code": "郵便番号",
  "enter_zip_code": "郵便番号を入力してください",
  "enterprise_type": "企業形態",
  "select_enterprise_type": "企業形態を選択してください",
  "trading_company": "貿易業",
  "manufacturer": "製造業",
  "state_owned_enterprise": "国有企業",
  "wholly_state_owned_company": "完全国有企業",
  "other_limited_liability_company": "その他の有限責任会社",
  "joint_stock_limited_company": "株式会社",
  "collective_enterprise": "集団所有制企業",
  "private_enterprise": "民間企業",
  "foreign_hong_kong_macao_and_taiwan_invested_enterprise": "外資・香港マカオ台湾系企業",
  "main_business_industry": "主な事業の業種",
  "select_your_main_business_industry": "主な事業の業種を選択してください",
  "agriculture_forestry_animal_husbandry_and_fishery": "農林水産業",
  "metallurgical_industry": "冶金産業",
  "machinery_industry": "機械産業",
  "chemical_industry": "化学工業",
  "light_industry": "軽工業",
  "electronics_and_telecommunications": "電子通信業",
  "oil_petrochemical": "石油・石油化学工業",
  "building_materials": "建材産業",
  "pharmaceutical_industry": "製薬産業",
  "textile_industry": "繊維産業",
  "electricity_and_gas_industry": "電気・ガス業",
  "other_industries": "その他の工業",
  "civil_engineering_construction_industry": "土木建設業",
  "construction_installation": "建設・設置業",
  "interior_decoration": "内装業",
  "foreign_trade_industry": "対外貿易業",
  "wholesale": "卸売業",
  "retail_industry": "小売業",
  "transportation_and_warehousing_industry": "運輸・倉庫業",
  "postal_industry": "郵便業",
  "accommodation_and_catering_industry": "宿泊・飲食業",
  "real_estate_industry": "不動産業",
  "information_technology_industry": "情報技術業",
  "information_and_consulting_services_industry": "情報・コンサルティングサービス業",
  "investment": "投資業",
  "other_service_industries": "その他のサービス業",
  "research_institutes": "研究機関",
  "business_site_area_m2": "事業所面積（M2",
  "enter_business_site_area": "事業所面積を入力してください",
  "enter_a_positive_integer": "正の整数を入力してください",
  "registered_capital_10_000_yuan": "登録資本金（10,000元）",
  "enter_registered_capital_10_000_yuan": "登録資本金（10,000元）を入力してください",
  "enter_an_amount_with_up_to_two_decimal_places": "金額を小数点第2位まで入力してください",
  "number_of_employees": "従業員数",
  "enter_number_of_employees": "従業員数を入力してください",
  "technical_staff_count": "専門技術者数",
  "enter_technical_staff_count": "専門技術者数を入力してください",
  "product_standards": "製品規格",
  "standard_products": "標準品",
  "non_standard_products": "非標準品",
  "main_product_name": "主な商品名",
  "enter_main_product_name": "主な商品名を入力してください",
  "applicable_quality_standard": "適用品質規格",
  "enter_applicable_quality_standard": "適用品質規格を入力してください",
  "review": "審査",
  "rejected": "審査差し戻し",
  "review_comments": "審査コメント",
  "enter_rejection_reason": "差し戻し理由を入力してください",
  "enter_rejection_reason_required": "差し戻し理由を入力してください（必須）",
  "supplier_name": "※サプライヤー名",
  "supplier_is_already_in_use": "サプライヤーはすでに使用されています",
  "enter_supplier_nameV2": "サプライヤー名を入力してください",
  "enter_supplier_nameV3": "※サプライヤー名を入力してください",
  "enter_business_contact_name": "業務担当者名を入力してください",
  "enter_business_contact_nameV2": "※業務担当者名を入力してください",
  "business_contact_phone_number": "※業務担当者の電話番号",
  "enter_business_contact_phone_number": "業務担当者の電話番号を入力してください",
  "enter_business_contact_phone_numberV2": "※業務担当者の電話番号を入力してください",
  "enter_contact_addressV2": "連絡先住所を入力してください",
  "enter_business_wechat_id": "業務連絡用のWeChat IDを入力してください",
  "other_social_media_accounts": "その他のSNSアカウント",
  "upload_supplier_logo": "サプライヤーのロゴをアップロードしてください",
  "service_area": "※サービスエリア",
  "select_service_areaV2": "サービスエリアを選択してください",
  "select_service_areaV3": "※サービスエリアを選択してください",
  "select_supplier_type": "サプライヤーのタイプを選択してください",
  "upload_business_license": "営業許可証をアップロード",
  "upload_business_licenseV2": "※営業許可証をアップロード",
  "upload_company_profile": "会社概要をアップロード",
  "upload_award_certificates": "表彰状をアップロード",
  "boosts_credit_score": "（信用スコアが上がります）",
  "brand_authorization_letter": "ブランド使用許諾書",
  "trademark_registration_certificate": "商標登録証",
  "enter_company_nameV2": "会社名を入力してください",
  "enter_company_nameV3": "※会社名を入力してください",
  "company_introduction": "会社紹介",
  "enter_company_introduction": "会社紹介を入力してください",
  "legal_representativeV2": "※法定代表者",
  "enter_legal_representativeV2": "法定代表者を入力してください",
  "enter_legal_representativeV3": "※法定代表者を入力してください",
  "id_photo": "※本人確認書類の写真",
  "upload_photo": "写真をアップロードしてください",
  "upload_photo_side_of_id": "※身分証の顔写真面をアップロード",
  "upload_emblem_side_of_id": "※身分証の国章面をアップロード",
  "select_service_areaV4": "サービスエリアを選択してください",
  "add_planet": "プラネット追加",
  "import_new_brands": "新規ブランドのインポート",
  "ignoredV2": "無視しました",
  "value_records_importedV2": "{{value}}件をインポートしました",
  "you_are_just_one_verification_step_away_from_becoming_a_platform_supplier": "プラットフォームのサプライヤー登録まで、あとは認証のみです。",
  "attribute_name": "特性名",
  "enter_specification_name": "仕様名を入力してください",
  "enter_attribute_name": "特性名を入力してください",
  "this_specification_already_exists": "この仕様はすでに存在します",
  "this_attribute_already_exists": "この特性はすでに存在します",
  "enter_specifications": "仕様を入力してください",
  "attribute_value": "特性値",
  "enter_attribute_value": "特性値を入力してください",
  "enter_attribute": "特性を入力してください",
  "add_attribute": "特性を追加",
  "within_two_weeks": "2週間以内",
  "within_one_year": "1年以内",
  "more_than_one_year": "1年以上",
  "curatedV4": "厳選",
  "seriesV2": "シリーズ",
  "specification_customizable": "仕様・カスタマイズ可否",
  "attributes": "特性",
  "no_attributes_yet": "特性はまだありません",
  "reference_priceV3": "参考価格",
  "originV4": "産地",
  "notes": "補足",
  "delete_this_item": "削除しますか？",
  "unlimitedV4": "無制限",
  "value_yuan_unitV3": "{{value}}元/単価",
  "about_value_valueV3": "約{{value}}{{value}}",
  "reference_imageV2": "参考イメージ",
  "this_product_already_exists": "この商品はすでに存在します",
  "this_area_cannot_be_dragged": "この領域はドラッグできません",
  "drag_curated_products_from_the_left": "厳選した商品を左からドラッグしてください",
  "or_left_click_here_to_upload_a_product": "または、ここを左クリックして商品をアップロードしてください",
  "cancel_your_participation": "参加を取りやめますか？",
  "joined": "参加済み",
  "upload_local_products": "ローカルの商品をアップロード",
  "add_product_images": "商品画像を追加してください",
  "enter_series_name": "シリーズ名を入力してください",
  "enter_product_nameV3": "商品名を入力してください",
  "customizableV2": "カスタマイズ可否",
  "reference_priceV4": "参考価格",
  "price_must_exceed_0": "価格は0より大きい値を入力してください",
  "price_must_be_a_number": "価格は数値で入力してください",
  "approx": "約",
  "yuan_unit_price": "元/単価",
  "select_delivery_period": "納期を選択してください",
  "additional_information": "追加情報",
  "enter_additional_information": "追加情報を入力してください",
  "all_categoriesV2": "すべてのカテゴリ",
  "search_materials": "マテリアルを検索",
  "select_brand": "ブランドを選択",
  "use_cases": "活用シーン",
  "reference_priceV5": "参考価格",
  "my_uploads": "自分のアップロード",
  "one_month": "1ヶ月",
  "three_months": "3ヶ月",
  "six_months": "半年",
  "within_one_yearV2": "1年以内",
  "more_than_one_yearV2": "1年以上",
  "a": "個",
  "confirm_download": "ダウンロードの確認",
  "cancel_download": "ダウンロード中止",
  "please_save_the_qr_code_and_use_a_third_party_application_to_scan_the_code_to_open_it": "QRコードを保存し、サードパーティアプリでスキャンして開いてください。",
  "press_and_hold_to_scan_qr_code": "長押しでQRコードを読み取る",
  "texture_libraryV2": "テクスチャライブラリ",
  "search_texturesV2": "テクスチャを検索",
  "linkedV2": "連携済み",
  "select_at_least_one_related_imageV2": "関連画像を1枚以上選択してください",
  "failed_to_upload_valueV3": "{{value}}のアップロードに失敗しました",
  "by_space": "スペース別",
  "choose_at_least_one": "1つ以上選択してください",
  "disabled": "無効",
  "space_disabled": "スペースは無効です",
  "unlimitedV5": "無制限",
  "substituteInstallation": "設置代行",
  "substituteProcessing": "加工代行",
  "substituteConstruction": "施工代行",
  "detailedDesign": "詳細設計",
  "within_two_weeksV2": "2週間以内",
  "within_one_yearV3": "1年以内",
  "more_than_one_yearV3": "1年以上",
  "show_lessV3": "折りたたむ",
  "show_moreV3": "もっと見る",
  "anonymousV4": "匿名",
  "toV3": "まで",
  "curatedV5": "厳選",
  "seriesV3": "シリーズ",
  "specification_customizableV2": "仕様・カスタマイズ可否",
  "attributesV2": "特性",
  "reference_priceV6": "参考価格",
  "originV5": "産地",
  "unlimitedV6": "無制限",
  "notesV2": "補足",
  "my_choice": "自分の選択",
  "request_detailsV3": "リクエスト内容",
  "value_yuan_unitV4": "{{value}}元/単価",
  "about_value_valueV4": "約{{value}}{{value}}",
  "supplier_ignored": "このサプライヤーを無視しました",
  "supplier": "サプライヤー",
  "this_card_ignores_all_information_about_this_supplier_do_you_want_to_continue": "このカードでは、このサプライヤーに関するすべての情報を無視します。続けますか？",
  "messages": "メッセージ",
  "visible_after_you_submit": "送信後に表示されます",
  "request_detailsV4": "要望内容",
  "request_address": "要望の住所",
  "unlimitedV7": "無制限",
  "approx_value_value": "約{{value}} {{value}}",
  "adopted": "採用済み",
  "shortlisted": "候補",
  "eliminated": "不採用",
  "no": "番号",
  "seriesV4": "シリーズ",
  "originV6": "産地",
  "reference_priceV7": "参考価格",
  "contact": "お問い合わせ",
  "you_cannot_add_your_own_cards_to_favoritesV2": "自分で作成したカードはお気に入りに追加できません",
  "remove_from_favorites": "お気に入りから削除しますか？",
  "removed_from_favoritesV2": "お気に入りから削除しました",
  "add_this_request_card_to_favorites": "このリクエストカードをお気に入りに追加しますか？",
  "added_to_favoritesV3": "お気に入りに追加しました",
  "return_to_preview_page": "プレビューページに戻りますか？",
  "submitted_successfully": "送信しました",
  "enter_contact_name": "ご担当者名を入力してください",
  "enter_a_valid_phone_number": "正しい携帯電話番号を入力してください",
  "invalid_phone_number_format": "携帯電話番号の形式が正しくありません",
  "enter_contact_number": "電話番号を入力してください",
  "enter_a_valid_email_address": "正しいメールアドレスを入力してください",
  "invalid_email_format": "メールアドレスの形式が正しくありません",
  "wechat": "WeChat",
  "enter_wechat_id": "WeChat IDを入力してください",
  "curatedV6": "厳選",
  "seriesV5": "シリーズ",
  "specification_customizableV3": "仕様・カスタマイズ可否",
  "attributesV3": "特性",
  "reference_priceV8": "参考価格",
  "originV7": "産地",
  "unlimitedV8": "無制限",
  "notesV3": "補足",
  "request_detailsV5": "リクエスト内容",
  "value_yuan_unitV5": "{{value}}元/単価",
  "about_value_valueV5": "約{{value}}{{value}}",
  "visible_after_you_submitV2": "送信後に表示されます",
  "request_detailsV6": "要望内容",
  "request_addressV2": "要望の住所",
  "unlimitedV9": "無制限",
  "approx_value_valueV2": "約{{value}} {{value}}",
  "toV4": "まで",
  "enter_keywords_to_search_or_create_works": "キーワードを入力して作品を検索・作成",
  "join": "参加",
  "joinedV2": "参加済み",
  "loading_please_try_again_later": "読み込み中です。後でもう一度お試しください",
  "this_material_color_already_exists_and_cannot_be_added_again": "このマテリアルカラーはすでに存在するため、重複して追加できません。",
  "replace_current_material": "現在のマテリアルを置き換えますか？",
  "you_have_reached_the_material_limit_remove_some_materials_before_adding_more": "マテリアルの追加上限に達しました。整理してから追加してください。",
  "drag_from_the_material_library_on_the_left_to_add": "左側のマテリアルライブラリからドラッグして追加してください",
  "all_categoriesV3": "すべてのカテゴリ",
  "search_materialsV2": "マテリアルを検索",
  "select_brandV2": "ブランドを選択",
  "use_casesV2": "活用シーン",
  "reference_priceV9": "参考価格",
  "my_uploadsV2": "自分のアップロード",
  "private_site": "非公開サイト",
  "designer_edition": "デザイナー版",
  "build_your_own_designer_brand_platform_own_your_data_and_run_it_your_way": "デザイナーブランド独自のプラットフォームを構築。データの権利はあなたのもの、プラットフォームの主導権もあなたに。",
  "i_am_in_charge_of_my_private_space": "私のプライベートスペースは私が決める",
  "i_decide_what_content_to_put_on_it": "どのような内容を載せるかは私が決めます",
  "i_decide_how_confidential_each_file_is": "各ファイルの機密性は私が決めます",
  "i_decide_how_much_access_to_grant": "権限をどこまで公開するかは私が決めます",
  "i_decide_what_to_send_to_clients": "クライアントに何を送信するかは私が決めます",
  "i_decide_who_to_partner_with": "誰と提携するかは私が決めます",
  "i_decide_who_gets_into_my_library": "誰をライブラリに登録するかは私が決めます",
  "i_decide_how_the_portfolio_is_presented": "ポートフォリオの見せ方は私が決めます",
  "i_decide_the_portfolio_s_validity_period_and_number_of_views": "ポートフォリオの有効期間と閲覧回数は私が決めます",
  "submit_proposals_that_self_destruct_after_reading_no_freeloading": "提案書を提出、閲覧後は自動消去、ただ乗りは禁止",
  "brand_edition": "ブランド版",
  "my_private_space_is_my_sales_assistant": "私のプライベートスペースは営業アシスタントです",
  "i_want_to_send_all_the_files_of_the_products_the_designer_needs_anytime_anywhere": "デザイナーが必要とする製品ファイルをすべて、いつでもどこでも送信したい",
  "i_want_to_get_into_designers_private_space_libraries": "デザイナーのプライベートスペースのライブラリに入りたい",
  "i_want_designers_to_use_my_products_directly": "デザイナーに私の製品を直接使ってほしい",
  "i_want_designers_to_follow_me_and_be_notified_of_new_products": "デザイナーに私をフォローしてもらい、新製品の通知を受け取ってほしい",
  "i_want_multi_device_business_presentation_desktop_large_screen_ipad_and_mobile": "パソコン、大画面、iPad、スマートフォンなど、マルチデバイスでビジネスを提案したい",
  "i_want_seamless_links_between_case_studies_and_related_products": "事例と関連製品をシームレスにつなげたい",
  "i_want_viral_sharing_and_growth": "口コミで拡散していきたい",
  "i_want_to_be_able_to_get_customer_information": "顧客情報を取得したい",
  "i_want_to_form_an_industrial_alliance_and_exchange_resources": "業界アライアンスを結成し、リソースを共有したい",
  "organization_edition": "組織版",
  "our_private_space_does_it_all": "私たちのプライベートスペースは万能です",
  "we_need_multi_platform_presence_official_site_app_and_mini_program": "公式サイト、アプリ、ミニプログラムなど、マルチプラットフォームでの展開が必要です",
  "we_need_members_to_sign_up": "メンバー登録が必要です",
  "we_need_event_promotion": "イベントの告知・宣伝が必要です",
  "we_need_members_work_to_be_showcased": "メンバーの作品を紹介する必要があります",
  "we_need_our_own_curated_material_library_for_designers_to_choose_from": "デザイナーが選択できる独自の厳選されたマテリアルライブラリが必要です",
  "we_need_works_linked_to_products": "作品と製品をリンクさせる必要があります",
  "contact_supportV2": "サポートに相談",
  "get_started": "はじめる",
  "30_minutes_to_build": "30分で構築",
  "everything_is_under_your_control": "すべてはあなたの思いのままに",
  "management_work_business_sales": "管理、業務、商談、営業…",
  "enter_bujue": "Bujueへ",
  "multiple_roles_multiple_platforms": "複数の役割、複数のプラットフォーム",
  "learn_more": "さらに詳しく",
  "support": "サポート",
  "help": "ヘルプ",
  "services": "サービス",
  "privacy_policyV2": "プライバシーポリシー",
  "user_agreementV2": "利用規約",
  "contactV2": "お問い合わせ",
  "support_qr_code": "サポートのQRコード",
  "scan_to_download_the_appV2": "スキャンしてアプリをダウンロード",
  "enter_new_phone_number": "新しい携帯電話番号を入力してください",
  "enter_new_email": "新しいメールアドレスを入力してください",
  "the_new_phone_number_is_the_same_as_the_old_phone_number": "新しい携帯電話番号が現在の携帯電話番号と同じです",
  "failed_to_get_verification_code_try_againV4": "認証コードの取得に失敗しました。再度取得してください",
  "linked_successfully": "連携しました",
  "you_are_not_logged_in": "ログインしていません",
  "get_the_verification_code": "認証コードを取得してください",
  "account_management": "アカウント管理",
  "not_set": "未設定",
  "wechatV2": "WeChat",
  "are_you_sure_you_want_to_unlink": "連携を解除してもよろしいですか？",
  "unlinked_successfully": "連携を解除しました",
  "unlink": "連携を解除",
  "not_linked": "未連携",
  "identity_verification": "本人確認",
  "verify": "確認",
  "enter_verification_codeV2": "認証コードを入力してください",
  "link_phone_number": "携帯電話番号を連携",
  "enter_verification_codeV3": "認証コードを入力してください",
  "link_email": "メールアドレスを連携",
  "enter_a_valid_email_addressV2": "正しいメールアドレスを入力してください",
  "enter_verification_codeV4": "認証コードを入力してください",
  "password_setup": "パスワード設定",
  "enter_password": "パスワードを入力してください",
  "confirm_password": "パスワードの確認",
  "confirm_your_password": "パスワードを確認してください",
  "new_password": "新しいパスワード",
  "confirm_new_password": "新しいパスワードの確認",
  "link_wechat": "WeChatを連携",
  "scan_the_qr_code_to_link_wechat": "QRコードをスキャンしてWeChatを連携してください",
  "loading": "読み込み中",
  "switch_interval": "切り替え間隔",
  "enter_an_integer_greater_than_0": "0より大きい整数を入力してください",
  "switch_effect": "切り替え効果",
  "are_you_sure_you_want_to_update_this_agreement_today": "本日中にこの規約を更新してもよろしいですか？",
  "upload_document": "書類をアップロードしてください",
  "agreement_document": "規約ファイル：",
  "upload_agreement": "規約をアップロードしてください",
  "uploaded_successfully": "アップロードしました",
  "upload_a_docx_file": ".docxファイルをアップロードしてください",
  "agreement_number": "規約番号：",
  "enter_agreement_number": "規約番号を入力してください",
  "agreement_version": "規約バージョン：",
  "enter_agreement_version": "規約バージョンを入力してください",
  "effective_date": "発効日：",
  "select_effective_date": "発効日を選択してください",
  "not_uploaded": "規約未アップロード",
  "uploaded_file_agreement": "アップロードファイルの規約",
  "fixed_agreement": "固定規約",
  "membership_agreement": "会員規約",
  "add_new_artwork": "新しいアートワークを追加",
  "parse": "解析",
  "upload_image": "画像をアップロードしてください",
  "color_scheme": "配色",
  "select_color_scheme": "配色を選択してください",
  "enter_artist": "作者を入力してください",
  "artist": "作者",
  "style_genreV2": "スタイル/ジャンル",
  "enter_style_genre": "スタイル/ジャンルを入力してください",
  "enter_art_type": "アートの種類を入力してください",
  "art_type": "アートの種類",
  "creation_date": "制作年",
  "enter_creation_date": "制作年を入力してください",
  "nationality": "国籍",
  "theme": "テーマ",
  "historical_and_cultural_background": "歴史的・文化的背景",
  "emotional_symbolism": "感情の象徴",
  "collection_location": "収蔵場所",
  "prompt": "プロンプト",
  "artistV2": "作者",
  "style_genreV3": "スタイル/ジャンル",
  "art_typeV2": "アートの種類",
  "creation_dateV2": "制作年",
  "nationalityV2": "国籍",
  "themeV2": "テーマ",
  "historical_and_cultural_backgroundV2": "歴史的・文化的背景",
  "emotional_symbolismV2": "感情の象徴",
  "color_schemeV2": "配色",
  "collection_locationV2": "収蔵場所",
  "promptV2": "プロンプト",
  "art_provenance_library": "アート来歴ライブラリ",
  "product_count": "製品数",
  "cannot_delete_a_brand_that_contains_products": "ブランドに製品が含まれている場合は削除できません。",
  "chinaV3": "中国",
  "select_odd_row": "奇数行を選択",
  "select_even_row": "偶数行を選択",
  "creation_failed": "作成に失敗しました",
  "edited_successfully": "編集しました",
  "edit_failed": "編集に失敗しました",
  "enter_brand_nameV2": "ブランド名を入力してください",
  "the_brand_name_already_exists": "ブランド名はすでに存在します。",
  "logoV5": "ロゴ",
  "select_brand_typeV2": "ブランドタイプを選択してください",
  "official": "公式",
  "enter_value": "{{value}}を入力してください",
  "duration_year": "期間/年",
  "bonus_duration_month": "特典期間/月",
  "confirm_cancellation": "キャンセルしてもよろしいですか？",
  "candidate_duration": "候補期間",
  "save_the_current_data_first": "まず現在のデータを保存してください。",
  "my_account_change_password": "マイページ/パスワード変更",
  "current_password": "現在のパスワード",
  "enter_current_password": "現在のパスワードを入力してください",
  "new_passwordV2": "新しいパスワード",
  "confirm_new_passwordV2": "新しいパスワード（確認）",
  "edit_language_plan": "言語プランの編集",
  "add_language_plan": "言語プランの追加",
  "languageV2": "言語",
  "select_language": "言語を選択してください",
  "enter_price": "価格を入力してください",
  "enter_plan_description": "プランの説明を入力してください",
  "default": "デフォルト",
  "enter_valueV2": "{{value}}を入力してください",
  "plan_name": "プラン名",
  "plan_description": "プランの説明",
  "capacity_gb": "容量/GB",
  "original_price": "通常価格",
  "default_plan": "デフォルトプラン",
  "save_the_current_data_firstV2": "まず現在のデータを保存してください。",
  "plan_nameV2": "プラン名",
  "plan_descriptionV2": "プランの説明",
  "select_languageV2": "言語を選択",
  "default_planV2": "デフォルトプラン",
  "complaint_time": "苦情日時",
  "reason_for_complaint": "苦情の理由",
  "complaint_content": "苦情の内容",
  "complaint_user_id": "苦情ユーザーID",
  "complaints_panel": "苦情パネル",
  "total_value_itemsV2": "全{{value}}件",
  "commonly_used": "よく使う",
  "creation_failedV2": "作成に失敗しました",
  "are_you_sure_you_want_to_delete_the_group_value": "グループ「{{value}}」を削除してもよろしいですか？",
  "are_you_sure_you_want_to_delete_the_country_value": "国「{{value}}」を削除してもよろしいですか？",
  "are_you_sure_you_want_to_remove_value_from_commonly_used": "「{{value}}」をよく使う一覧から削除してもよろしいですか？",
  "removed_successfully": "削除しました",
  "removal_failed": "削除に失敗しました",
  "add_failed": "追加に失敗しました",
  "select_an_svg_file": "SVGファイルを選択してください",
  "no_files_to_upload": "アップロードするファイルがありません",
  "upload_completed": "アップロード完了",
  "no_data_to_export": "エクスポートするデータがありません",
  "file_name": "ファイル名",
  "pending_upload": "アップロード待ち",
  "no_data_to_import_all_data_already_exists": "インポートするデータがありません。すべてのデータがすでに存在します。",
  "bulk_import_country_data": "国データの一括インポート",
  "about_to_import_value_groups_and_value_countries_value_existing_skipped_continue": "{{value}}件のグループと{{value}}件の国をインポートします（既存の{{value}}件はスキップ）。続行しますか？",
  "confirm_import": "インポートの確認",
  "create_group": "グループの作成",
  "create_country": "国の作成",
  "bulk_import_completed": "一括インポートが完了しました",
  "bulk_import_error": "一括インポートエラー",
  "country_name": "国名",
  "country_code": "国コード",
  "country_management": "国の管理",
  "bulk_importing": "一括インポート中",
  "chinese_name": "中国語名",
  "enter_chinese_name": "中国語名を入力してください",
  "enter_chinese_group_name": "中国語のグループ名を入力してください",
  "value_name": "{{value}}名",
  "enter_value_group_name": "{{value}}グループ名を入力してください",
  "edit_country": "国の編集",
  "add_country": "国の追加",
  "chinese_country_name": "中国語の国名",
  "enter_chinese_country_name": "中国語の国名を入力してください",
  "value_country_name": "{{value}}国名",
  "enter_value_country_name": "{{value}}国名を入力してください",
  "enter_country_code": "国コードを入力してください",
  "country_code_must_be_2_letters": "国コードは英字2文字で入力してください",
  "only_letters_are_allowed": "英字のみ入力できます",
  "2_english_letters": "英字2文字",
  "add_country_to_commonly_used": "国をよく使う一覧に追加",
  "bulk_upload_svgs": "SVGの一括アップロード",
  "version_number": "バージョン番号",
  "force_update": "強制更新",
  "release_notes": "更新内容",
  "installer": "インストーラー",
  "update_file": "更新ファイル",
  "creation_time": "作成日時",
  "updater": "アップデーター",
  "file_upload_failed": "ファイルのアップロードに失敗しました",
  "uploadV2": "アップロード",
  "app_store_link": "アプリストアのリンク",
  "enter_version_number": "バージョン番号を入力してください",
  "upload_installer": "インストーラーをアップロードしてください",
  "enter_release_notes": "更新内容を入力してください",
  "enter_banner_link": "バナーリンクを入力してください",
  "enter_banner_linkV2": "バナーリンクを入力してください",
  "upload_imageV2": "画像をアップロードしてください",
  "delete_banner": "バナーの削除",
  "are_you_sure_you_want_to_delete_it": "削除してもよろしいですか？",
  "switch_intervalV2": "切り替え間隔",
  "enter_an_integer_greater_than_0V2": "0より大きい整数を入力してください",
  "switch_effectV2": "切り替え効果",
  "select_languageV3": "言語を選択してください",
  "add_new_language_pack": "言語パックの追加",
  "select_languageV4": "言語を選択してください",
  "existing_languages": "既存の言語",
  "translation_progress": "翻訳の進捗状況",
  "are_you_sure_you_want_to_delete": "削除してもよろしいですか？",
  "not_uploadedV2": "未アップロード",
  "uploaded": "アップロード済み",
  "space_language_packs": "スペース言語パック",
  "space_management": "スペース管理",
  "official_settings": "公式設定",
  "select_space": "スペースを選択",
  "select_spaceV2": "スペースを選択してください",
  "select_language_pack": "言語パックを選択してください",
  "plan_nameV3": "プラン名",
  "order_time": "注文日時",
  "order_source": "注文元",
  "wechatV3": "WeChat",
  "order": "注文",
  "version_numberV2": "バージョン番号",
  "operation_time": "操作日時",
  "api": "API",
  "request": "リクエスト",
  "response": "応答",
  "ipv4_address": "IPv4アドレス",
  "ipv6_address": "IPv6アドレス",
  "operator_id": "操作ユーザーID",
  "operation_log": "操作ログ",
  "total_value_itemsV3": "全{{value}}件",
  "value_is_not_an_imageV4": "{{value}}は画像ではありません",
  "image_size_limit_4mbV2": "画像サイズ制限4MB",
  "add_certificate": "証明書を追加",
  "material_image_must_not_exceed_4_mb_800_800_px_or_larger_with_the_same_aspect_ratio_is_recommended": "マテリアル画像は4MB以下にしてください。800×800px以上、同じ縦横比のサイズを推奨します。",
  "image_is_requiredV2": "画像は必須です",
  "are_you_sure_you_want_to_add_this_material_to_the_comparison": "このマテリアルを比較に追加してもよろしいですか？",
  "are_you_sure_you_want_to_clear_it": "クリアしてもよろしいですか？",
  "cleared_successfully": "クリアしました",
  "product_comparison": "製品比較",
  "add_attributeV2": "特性を追加",
  "enter_feature_nameV3": "特性名を入力してください",
  "node_name_is_required": "ノード名は必須です",
  "node_name": "ノード名",
  "schematic_diagram_is_required": "模式図は必須です",
  "schematic_diagram": "模式図",
  "applicable_materials_are_required": "適用マテリアルを選択してください",
  "applicable_materials": "適用マテリアル",
  "drawings": "図面",
  "enter_node_name": "ノード名を入力してください",
  "node": "ノード",
  "upload_schematic_diagram": "模式図をアップロードしてください",
  "applicable_materials_are_requiredV2": "適用マテリアルは必須です",
  "pack_box": "袋/箱",
  "pieces_pack": "枚/袋",
  "kg_piece": "kg/枚",
  "fields_with_existing_data_cannot_be_deleted": "データがある場合はフィールドを削除できません",
  "field_name_is_empty_or_already_exists": "フィールド名が空か、すでに存在しています",
  "field_name_already_exists_or_is_empty": "フィールド名がすでに存在するか、空です",
  "upload_imageV3": "画像をアップロードしてください",
  "new_shipping_address": "配送先住所を追加",
  "application_submitted": "申請しました",
  "shipping_address": "配送先住所",
  "requested_quantity": "申請数量",
  "value_is_not_an_imageV5": "{{value}}は画像ではありません",
  "image_size_limit_4mbV3": "画像サイズ制限4MB",
  "customization_notes": "カスタマイズ内容",
  "specification_name_already_exists": "仕様名がすでに存在します。名前は重複できません",
  "name_is_requiredV2": "名前は必須です",
  "reason_for_terminating_the_partnership": "提携終了の理由",
  "partnership_terminated": "提携を終了しました",
  "note_added_successfully": "メモを追加しました",
  "rejection_reasonV2": "却下理由：",
  "application_rejected": "申請を差し戻しました",
  "supplier_nameV2": "サプライヤー名",
  "onboarding_date": "出店日",
  "products": "製品",
  "end_partnership": "提携終了",
  "reason_for_termination": "終了理由",
  "application_rejectedV2": "申請差し戻し",
  "rejection_reasonV3": "却下理由：",
  "enable_this_partnership": "提携を有効にしてもよろしいですか？",
  "enabled": "有効にしました",
  "approve_this_application": "審査を承認してもよろしいですか？",
  "total_value_itemsV4": "全{{value}}件",
  "rejection_number": "差し戻し番号：",
  "termination_number": "終了番号：",
  "rejection_time": "差し戻し日時：",
  "termination_time": "提携終了日時：",
  "reason_for_terminating_the_partnershipV2": "提携終了の理由：",
  "enter_required": "ご記入ください（必須項目）",
  "rating_submitted": "評価しました",
  "brand_nameV3": "ブランド名",
  "main_product_nameV2": "主な商品名",
  "product_quality": "製品の品質",
  "contract_performance": "契約履行状況",
  "service_level": "サービスレベル",
  "product_price": "製品価格",
  "corporate_reputation": "企業の評判",
  "review_score": "評価スコア",
  "qualified": "合格",
  "unqualified": "不合格",
  "improvement_suggestions": "改善提案",
  "handling_notes": "対応内容",
  "creation_timeV2": "作成日時",
  "display": "表示",
  "are_you_sure_you_want_to_delete_this_category": "このカテゴリを削除してもよろしいですか？",
  "document_category": "ドキュメントカテゴリ",
  "enter_category_name": "カテゴリ名を入力してください",
  "enter_sort_order": "並び順を入力してください",
  "displayV2": "表示",
  "added_successfully": "追加しました",
  "are_you_sure_you_want_to_delete_this_document": "このドキュメントを削除してもよろしいですか？",
  "are_you_sure_you_want_to_disable_this_document": "このドキュメントを無効にしてもよろしいですか？",
  "are_you_sure_you_want_to_enable_this_document": "このドキュメントを有効にしてもよろしいですか？",
  "enabledV2": "有効にしました",
  "disabled_successfully": "無効にしました",
  "title": "タイトル",
  "question_category": "質問カテゴリ",
  "date_addedV2": "追加日時",
  "pin_to_top": "上部に固定",
  "pinned": "固定済み",
  "not_pinned": "未固定",
  "enable": "有効化",
  "disabledV2": "無効",
  "are_you_sure_you_want_to_pin_it": "固定してもよろしいですか？",
  "are_you_sure_you_want_to_unpin_it": "固定を解除してもよろしいですか？",
  "help_documentation": "ヘルプドキュメント",
  "enter_titleV6": "タイトルを入力してください",
  "end_time": "終了時間",
  "start_time": "開始時間",
  "select_status": "ステータスを選択してください",
  "enabledV3": "有効",
  "disabledV3": "無効",
  "edit_document": "ドキュメントの編集",
  "add_document": "ドキュメント追加",
  "document_categoryV2": "ドキュメントカテゴリ",
  "enter_sort_orderV2": "並び順を入力してください",
  "operation_details": "操作内容",
  "enter_document_details": "ドキュメントの詳細を入力してください",
  "import_pdfV3": "PDFをインポート",
  "complete_importV3": "インポートを完了",
  "invalid_page_number_formatV2": "ページ番号の形式が正しくありません",
  "import_pdfV4": "PDFをインポート",
  "specific_pagesV2": "ページ指定",
  "e_g_1_2_5_7_10V2": "例：1、2-5、7-10",
  "the_higher_the_resolution_the_longer_the_import_timeV2": "解像度が高くなるほど、インポート時間は長くなります",
  "complete_importV4": "インポートを完了",
  "subcategory_order_updated": "サブカテゴリの並び順を更新しました",
  "are_you_sure_you_want_to_delete_value": "{{value}}を削除してもよろしいですか？",
  "name_is_requiredV3": "名前は必須です",
  "duplicate_name": "ファイル名重複",
  "edit_primary_category": "大分類を編集",
  "add_primary_category": "大分類を追加",
  "enter_category_nameV2": "カテゴリ名を入力してください",
  "percentage": "割合",
  "enter_product_percentage": "製品の割合を入力してください",
  "global_field_management": "グローバルフィールド管理",
  "code": "コード",
  "creation_timeV3": "作成日時",
  "displayV3": "表示",
  "delete_this_category": "カテゴリを削除してもよろしいですか？",
  "are_you_sure_you_want_to_delete_the_category": "カテゴリを削除してもよろしいですか？",
  "name_is_requiredV4": "名前は必須です",
  "subcategory_added": "サブカテゴリを追加しました",
  "subcategory_updated": "サブカテゴリを変更しました",
  "primary_category_order_updated": "大分類の並び順を更新しました",
  "enter_category_nameV3": "カテゴリ名を入力してください",
  "enter_code": "コードを入力してください",
  "logo_image": "ロゴ画像",
  "reject_application": "申請差し戻し",
  "enter_rejection_reason_requiredV2": "差し戻し理由を入力してください（必須）",
  "rejection_reasonV4": "却下理由：",
  "reason_for_unpublishing": "非公開の理由：",
  "review_center_material_review": "審査センター/マテリアル審査",
  "user_id": "ユーザーID",
  "enter_user_id": "ユーザーIDを入力してください",
  "material": "マテリアル",
  "enter_material_and_color_name": "マテリアル名と色名を入力してください",
  "application_type": "申請種別",
  "material_name": "マテリアル名",
  "regular_user": "一般ユーザー",
  "official_material": "公式マテリアル",
  "username": "ユーザー名",
  "phone_number": "携帯電話番号",
  "publicV2": "公開",
  "privateV4": "非公開",
  "publicV3": "公開",
  "description": "説明",
  "application_time": "申請日時",
  "created": "作成済み",
  "rejection_reasonV5": "却下理由：",
  "approve_this_applicationV2": "審査を承認してもよろしいですか？",
  "enter_valueV3": "{{value}}を入力してください",
  "view_details": "詳細を表示",
  "reviewV2": "審査",
  "enter_rejection_reasonV2": "差し戻し理由を入力してください",
  "rejectedV2": "審査差し戻し",
  "review_commentsV2": "審査コメント",
  "node_nameV2": "ノード名",
  "schematic_diagramV2": "模式図",
  "creation_timeV4": "作成日時",
  "drawingsV2": "図面",
  "click_to_download": "クリックしてダウンロード",
  "last_modified": "更新日時",
  "material_node_management": "マテリアルノードの管理",
  "nodeV2": "ノード",
  "node_name_is_requiredV2": "ノード名は必須です",
  "schematic_diagram_is_requiredV2": "模式図は必須です",
  "applicable_materials_are_requiredV3": "適用マテリアルは必須です",
  "applicable_materialsV2": "適用マテリアル",
  "upload_drawings": "図面をアップロード",
  "add_parameters": "パラメータの追加",
  "parameter_name_is_required": "パラメータ名は必須です",
  "field_name": "フィールド名",
  "input_field": "入力欄",
  "dropdown": "プルダウン",
  "enter_field_name": "フィールド名を入力してください",
  "display_name": "表示名",
  "enter_display_name": "表示名を入力してください",
  "control_type_is_required": "コントロールタイプを選択してください",
  "control_type": "コントロールタイプ",
  "default_value": "デフォルト値",
  "candidate_values_are_required": "候補値は必須です",
  "candidate_value": "候補値",
  "select_material_category": "マテリアル分類を選択してください",
  "material_category": "マテリアル分類",
  "as_filter": "フィルターとして",
  "name_is_requiredV5": "名前は必須です",
  "parameter_name": "パラメータ名",
  "material_categoryV2": "マテリアル分類",
  "control_typeV2": "コントロールタイプ",
  "input_fieldV2": "入力欄",
  "dropdownV2": "プルダウン",
  "default_valueV2": "デフォルト値",
  "candidate_valueV2": "候補値",
  "creation_timeV5": "作成日時",
  "are_you_sure_you_want_to_delete_this_field_under_all_related_categories": "関連するすべてのカテゴリからこのフィールドを削除しますか？",
  "are_you_sure_you_want_to_delete_this_field_under_value": "${{value}}のこのフィールドを削除しますか？",
  "configuration_load_failed": "設定の読み込みに失敗しました：",
  "configuration_load_failedV2": "設定の読み込みに失敗しました：",
  "edit_benefits": "特典を編集",
  "add_benefits": "特典を追加",
  "titleV2": "タイトル",
  "enter_titleV7": "タイトルを入力してください",
  "subtitle": "サブタイトル",
  "enter_subtitle": "サブタイトルを入力してください",
  "icon": "アイコン",
  "benefits": "特典説明",
  "benefit_name": "特典名",
  "benefitsV2": "特典説明",
  "switch": "スイッチ",
  "application_timeV2": "申請日時",
  "delete_this_benefit": "この特典を削除しますか？",
  "membership_benefits": "会員特典",
  "add_agreement": "規約を追加",
  "agreement_name": "規約名",
  "enter_agreement_name": "規約名を入力してください",
  "agreement": "規約",
  "upload_agreementV2": "規約をアップロードしてください",
  "upload_a_pdf_file": ".pdfファイルをアップロードしてください",
  "size_must_not_exceed_2mb": "サイズは2MB以内",
  "click_to_uploadV3": "クリックしてアップロード",
  "titleV3": "タイトル",
  "enter_titleV8": "タイトルを入力してください",
  "agreementV2": "規約",
  "fees_and_benefits": "料金と特典",
  "enter_paid_benefits": "有償特典を入力してください",
  "membership_rules": "会員規約",
  "membership_name": "会員名称",
  "membership_validity_period": "会員有効期間",
  "benefitsV3": "特典",
  "fees_and_benefitsV2": "料金と特典",
  "select_membership_validity_period": "会員有効期間を選択してください",
  "original_priceV2": "通常価格",
  "enter_priceV2": "価格を入力してください",
  "amount_paid": "支払い金額",
  "select_benefits": "特典を選択してください",
  "edit_basic_information": "基本情報を編集",
  "membership_validity_periodV2": "会員有効期間：",
  "member_price": "会員価格：",
  "membership_rulesV2": "会員規約：",
  "membership_rulesV3": "会員規約",
  "user_agreementV3": "利用規約：",
  "membership_settings": "会員設定",
  "enter_valueV4": "{{value}}を入力してください",
  "distributor": "販売代理店",
  "discount": "割引",
  "discountV2": "割引",
  "channel_code": "チャネルコード",
  "5_digit_channel_code": "5桁のチャネルコード",
  "transaction_volume": "成約件数",
  "sales": "売上高",
  "enableV2": "有効化",
  "deactivatedV2": "停止中",
  "referral_code": "紹介コード",
  "purchase_date": "購入日",
  "value_yuan": "{{value}}人民元",
  "amount_paidV2": "支払い金額",
  "customer_contact": "顧客担当者",
  "item": "商品",
  "payment_platform": "決済プラットフォーム",
  "payment_order_number": "決済番号",
  "select_partner_information_first": "先にパートナー情報を選択してください",
  "distributor_management": "販売代理店管理",
  "update_partner_information": "パートナー情報を更新",
  "add_partner_information": "パートナー情報を追加",
  "partner": "パートナー",
  "enter_partner_name": "パートナー名を入力してください",
  "enter_discount": "割引を入力してください",
  "5_digit_discount_code": "5桁の割引コード",
  "sales_data": "販売データ",
  "select_a_supplier": "サプライヤーを選択してください",
  "search_suppliers": "サプライヤーを検索",
  "search_team": "チームを検索",
  "private_space": "スペース",
  "creation_timeV6": "作成日時",
  "review_status": "審査ステータス",
  "rejection_reasonV6": "却下理由：",
  "approve_this_product": "この商品を承認しますか？",
  "enter_reason": "理由を入力してください",
  "search_product_private_space_name": "商品/プライベートスペース名を検索",
  "approve_these_products": "これらの商品を一括承認しますか？",
  "force_unpublish": "強制非公開",
  "total_quantity": "合計数量",
  "curatedV7": "厳選",
  "top_pick": "イチオシ",
  "are_you_sure_you_want_to_publish_these_products": "これらの商品を公開しますか？",
  "are_you_sure_you_want_to_cancel_the_homepage_promotion": "トップページのおすすめ表示を解除しますか？",
  "private_spaceV2": "スペース",
  "creation_timeV7": "作成日時",
  "curatedV8": "厳選",
  "not_curated": "非厳選",
  "completeness_status": "完成度ステータス",
  "review_information": "審査情報",
  "review_statusV2": "審査ステータス",
  "rejection_reasonV7": "却下理由：",
  "approve_this": "承認しますか？",
  "are_you_sure_you_want_to_publish_this_product": "この商品を公開しますか？",
  "promote_this_on_the_homepage": "トップページでおすすめ表示しますか？",
  "ban_publishing": "公開禁止",
  "enter_publishing_ban_reason": "公開禁止の理由を入力してください",
  "enter_rejection_reasonV3": "却下理由を入力してください",
  "add_recommended_supplier": "推奨サプライヤーを追加",
  "search_private_space_name": "スペース名を検索",
  "enter_keywords_to_search_private_space": "キーワードを入力してスペースを検索",
  "no_matching_results": "一致する結果はありません",
  "added": "追加済み",
  "saved": "保存済み",
  "save_failed_restored_to_the_latest_server_state": "保存に失敗したため、サーバーの最新状態に復元しました：",
  "valid": "有効",
  "validV2": "有効",
  "remove_this_recommendation": "この推奨を削除しますか？",
  "saving": "保存中…",
  "supplier_nameV3": "サプライヤー名",
  "officialV2": "公式",
  "materialV2": "マテリアル",
  "usernameV2": "ユーザー名",
  "phone_numberV2": "携帯電話番号",
  "application_timeV3": "申請日時",
  "requested_quantityV2": "申請数量",
  "review_center_swatch_management": "審査センター/サンプル管理",
  "enter_material_name": "マテリアル名を入力してください",
  "consignee": "荷受人",
  "enter_consignee_id": "荷受人IDを入力してください",
  "bundled_service_settings": "付帯サービス設定",
  "edit_service": "サービスを編集",
  "service_name": "サービス名",
  "value_nameV2": "{{value}}名",
  "automatic_trigger": "自動トリガー",
  "manual_trigger": "手動トリガー",
  "processing": "処理中",
  "failed": "失敗",
  "file_path_does_not_exist": "ファイルパスが存在しません",
  "start_timeV2": "開始時間",
  "end_timeV2": "終了時間",
  "statistical_period": "統計期間",
  "statistics_completion_time": "統計完了時間",
  "trigger_mode": "トリガーモード",
  "statistics_file": "統計ファイル",
  "query_failed": "検索に失敗しました",
  "statistics": "統計",
  "time_range_by_end_time": "時間範囲（終了時刻基準）",
  "month": "月",
  "total_value_itemsV5": "全{{value}}件",
  "on_value_grant_the_value_team_value_gb_of_bujue_cloud_storage": "{{value}}に{{value}}チームへBujueクラウドストレージ{{value}}GBを付与しますか？",
  "grant_the_value_team_value_gb_of_bujue_cloud_storage_now": "{{value}}チームへBujueクラウドストレージ{{value}}GBを今すぐ付与しますか？",
  "operation_failed": "操作に失敗しました：",
  "current_granted_capacity": "現在の付与容量：",
  "granted_capacity": "付与容量",
  "granted_capacity_is_required": "付与容量は必須です",
  "enter_granted_capacity": "付与容量を入力してください",
  "issue_date": "付与日",
  "select_issue_date": "付与日を選択してください",
  "if_you_do_not_select_an_issue_date_it_will_take_effect_immediately": "付与日を選択しない場合は、すぐに有効になります。",
  "reminder_is_required": "リマインダーは必須です",
  "team_name": "チーム名",
  "granted_capacityV2": "付与容量",
  "active_plan": "適用中のプラン",
  "total_capacity_gb": "総容量/GB",
  "used_gb": "使用済み/GB",
  "cancel_this_grant": "この付与を取り消しますか？",
  "cancel_grant": "付与の取り消し",
  "team_capacity_management": "チーム容量管理",
  "team_nameV2": "チーム名",
  "select_purchase_duration": "購入期間を選択",
  "enter_amount_paid": "実支払額を入力",
  "adjust_amount_paid_must_be_less_than_amount_due": "実支払額を調整（請求額未満である必要があります）",
  "select_payment_channel": "決済チャネルを選択",
  "enter_payment_order_number": "決済番号を入力",
  "please_value_first": "まず{{value}}してください",
  "free_versionV3": "無料版",
  "set_plan": "プランを設定",
  "plan": "プラン：",
  "planV2": "プラン*",
  "value_year": "（￥{{value}}/年）",
  "free_forever": "（永久無料）",
  "renewV2": "更新する",
  "upgradeV2": "アップグレード",
  "purchase_duration": "購入期間*",
  "the_value_promo_code_has_been_redeemed_for_you_valueV2": "{{value}}割引のクーポンコードを引き換えました：{{value}}",
  "amount_paidV3": "実支払額*",
  "unionpay": "銀聯決済",
  "offline_payment": "オフライン決済",
  "rejection_reasonV8": "却下理由：",
  "rejection_reasonV9": "却下理由",
  "enter_requiredV2": "ご記入ください（必須項目）",
  "team_nameV3": "チーム名",
  "team_type": "チームタイプ",
  "approve_this_applicationV3": "審査を承認してもよろしいですか？",
  "enter_rejection_reasonV4": "却下理由を入力してください",
  "total_value_itemsV6": "全{{value}}件",
  "rejection_id": "却下番号：",
  "rejection_timeV2": "却下日時：",
  "rejection_reasonV10": "却下理由：",
  "view_team_verification": "チーム認証を表示",
  "are_you_sure_you_want_to_restore_this_team": "このチームを復元しますか？",
  "restored": "復元しました",
  "incomplete_form": "未記入の項目があります",
  "configured": "設定完了",
  "attachment_deleted": "添付ファイルを削除しました",
  "uploaded_successfullyV2": "アップロードしました",
  "team_nameV4": "チーム名",
  "registered_at": "登録日時",
  "public_mini_program": "パブリックミニプログラム",
  "custom_mini_program": "カスタムミニプログラム",
  "redirect_official_site_to_mini_program": "公式サイトからミニプログラムへ遷移⬇",
  "deactivatedV3": "停止中",
  "active": "有効",
  "team_management": "チーム管理",
  "total_value_itemsV7": "全{{value}}件",
  "suspend_team": "チームの停止",
  "enter_requiredV3": "ご記入ください（必須項目）",
  "reason_for_deactivation": "停止理由",
  "set_custom_wechat_mini_program_info": "カスタムWeChatミニプログラム情報を設定",
  "team_settings": "チーム設定",
  "bujue_operations_team": "Bujue運営チーム",
  "space_mode": "スペースモード",
  "internationalV2": "国際",
  "domestic": "国内",
  "product_category_wrap": "商品カテゴリーの改行",
  "click_to_uploadV4": "クリックしてアップロード",
  "uploaded_images": "アップロード済み画像",
  "are_you_sure_you_want_to_delete_this_item": "この項目を削除しますか？",
  "3d_plugin_update": "3Dプラグインのアップデート",
  "updaterV2": "アップデーター",
  "plugin_name": "プラグイン名",
  "enter_plugin_name": "プラグイン名を入力してください",
  "enter_software_name": "ソフトウェア名を入力してください",
  "software_name": "ソフトウェア名",
  "select_icon": "アイコンを選択してください",
  "iconV2": "アイコン",
  "updaterV3": "アップデーター",
  "upload_update_package": "更新プログラムをアップロードしてください",
  "file_upload_failedV2": "ファイルのアップロードに失敗しました",
  "uploadV3": "アップロード",
  "version_numberV3": "バージョン番号",
  "enter_version_numberV2": "バージョン番号を入力してください",
  "transaction_number": "取引番号",
  "income_source": "収入区分",
  "application_timeV4": "申請日時",
  "transaction_amount": "取引金額",
  "finance_center_transaction_history": "財務センター/取引履歴",
  "enter_transaction_number": "取引番号を入力してください",
  "transaction_time": "取引日時",
  "searchV2": "検索",
  "associated_suppliers": "関連サプライヤー",
  "mobileV2": "携帯",
  "gender": "性別",
  "id_numberV2": "身分証明書番号",
  "registered_atV2": "登録日時",
  "bio": "自己紹介",
  "disabledV4": "無効",
  "activeV2": "有効",
  "bujue_team": "Bujueチーム",
  "update_failed": "更新に失敗しました：",
  "user_management": "ユーザー管理",
  "enter_name_email_phone_number_or_nickname": "氏名・メールアドレス・携帯電話番号・ニックネームを入力",
  "edit_information": "情報を編集",
  "add_information": "情報を追加",
  "remaining_quantity": "残数",
  "number_of_teams": "チーム数",
  "delete_information": "情報を削除",
  "are_you_sure_you_want_to_delete_itV2": "削除してもよろしいですか？",
  "draftV2": "下書き",
  "rejectedV3": "審査差し戻し",
  "unpublished": "非公開",
  "work_management": "作品管理",
  "user_idV2": "ユーザーID",
  "enter_user_idV2": "ユーザーIDを入力してください",
  "work_title": "作品名",
  "enter_work_title": "作品名を入力してください",
  "unpublished_for_violation": "規約違反により非公開",
  "work_id": "作品ID",
  "user": "ユーザー",
  "phone_numberV3": "携帯電話番号",
  "application_timeV5": "申請日時",
  "reason_for_unpublishingV2": "非公開の理由",
  "display_this_on_the_home_page": "トップページに表示しますか？",
  "remove_from_the_home_page": "トップページへの表示を解除しますか？",
  "view_detailsV2": "詳細を表示",
  "rejection_reasonV11": "却下理由：",
  "reason_for_violation": "違反理由",
  "rejection_timeV3": "差し戻し日時：",
  "violation_application_time": "違反申請日時",
  "reason_for_violationV2": "違反理由：",
  "design_style_management": "デザインスタイル管理",
  "style_name": "スタイル名",
  "style_name_value": "スタイル名-{{value}}",
  "creation_timeV8": "作成日時",
  "displayV4": "表示",
  "delete_this_categoryV2": "カテゴリを削除してもよろしいですか？",
  "primary_category_order_updatedV2": "大分類の並び順を更新しました",
  "design_style": "デザインスタイル",
  "duplicate_style_name": "スタイル名が重複しています",
  "enter_category_nameV4": "カテゴリ名を入力してください",
  "subcategory_order_updatedV2": "サブカテゴリの並び順を更新しました",
  "building_type_management": "建物タイプ管理",
  "category_name_value": "カテゴリ名-{{value}}",
  "creation_timeV9": "作成日時",
  "displayV5": "表示",
  "delete_this_categoryV3": "カテゴリを削除してもよろしいですか？",
  "are_you_sure_you_want_to_delete_the_categoryV2": "カテゴリを削除してもよろしいですか？",
  "subcategory_addedV2": "サブカテゴリを追加しました",
  "subcategory_updatedV2": "サブカテゴリを変更しました",
  "primary_category_order_updatedV3": "大分類の並び順を更新しました",
  "building_type_classification": "建物タイプ分類",
  "enter_category_nameV5": "カテゴリ名を入力してください",
  "category_name_valueV2": "カテゴリ名{{value}}",
  "enter_category_name_value": "カテゴリ名{{value}}を入力してください",
  "platform_management": "プラットフォーム管理",
  "carousel": "カルーセル",
  "app_carousel": "アプリカルーセル",
  "agreement_template": "契約書テンプレート",
  "product_library_management": "製品ライブラリ管理",
  "bundled_service_settingsV2": "付帯サービス設定",
  "material_categoryV3": "マテリアル分類",
  "private_space_product_management": "プライベートスペース製品管理",
  "country_managementV2": "国の管理",
  "work_managementV2": "作品管理",
  "building_type_managementV2": "建物タイプ管理",
  "design_style_managementV2": "デザインスタイル管理",
  "cloud_drive_admin": "クラウドストレージ管理",
  "team_capacity_managementV2": "チーム容量管理",
  "cloud_drive_operations": "クラウドストレージ運営",
  "candidate_durationV2": "候補期間",
  "distributor_managementV2": "販売代理店管理",
  "idea_board_management": "アイデアボード管理",
  "promptV3": "プロンプト",
  "basic_asset_management": "基本素材管理",
  "recommended_supplier_management": "推奨サプライヤー管理",
  "ai_configuration": "AI設定",
  "models_and_keys": "モデルとキー",
  "ai_usage": "AI使用量",
  "tools_admin": "ツール管理",
  "custom_template": "カスタムテンプレート",
  "art_provenance_libraryV2": "アート来歴ライブラリ",
  "3d_plugin_updateV2": "3Dプラグインのアップデート",
  "node_library_management": "ノードライブラリ管理",
  "help_documentationV2": "ヘルプドキュメント",
  "document_categoryV3": "ドキュメントカテゴリ",
  "review_center": "審査センター",
  "material_review": "マテリアル審査",
  "swatch_management": "サンプル管理",
  "user_managementV2": "ユーザー管理",
  "membership_settingsV2": "会員設定",
  "membership_benefitsV2": "会員特典",
  "business_entity_management": "事業者管理",
  "design_team_management": "デザインチーム管理",
  "log_panel": "ログパネル",
  "complaints_panelV2": "苦情パネル",
  "space_language_packsV2": "スペース言語パック",
  "finance_center": "財務センター",
  "transaction_history": "取引履歴",
  "client_version": "クライアントバージョン",
  "downloader_version": "ダウンローダーバージョン",
  "statisticsV2": "統計",
  "change_password": "パスワード変更",
  "please_act_soon": "お早めにご対応ください",
  "this_is_the_last_page": "最後のページです",
  "bujue_space_gallery": "Bujueスペースギャラリー",
  "the_platform_that_empowers_designers": "デザイナーを支えるプラットフォーム",
  "folder_name_is_required": "フォルダー名は必須です",
  "file_name_is_required": "ファイル名は必須です",
  "file_names_cannot_contain_the_following_characters": "ファイル名に次の文字は使用できません：",
  "a_folder_with_this_name_already_exists": "同じ名前のフォルダーが既に存在します",
  "a_file_with_this_name_already_exists": "同じ名前のファイルが既に存在します",
  "renamed": "名前を変更しました",
  "rename_failed": "名前の変更に失敗しました",
  "online_preview_is_not_supported_for_this_file_download_it_instead": "このファイルはオンラインプレビューに対応していません。ダウンロードして表示しますか？",
  "online_preview_is_not_supported_for_this_file": "このファイルはオンラインプレビューに対応していません",
  "rename": "名前の変更",
  "file_nameV2": "ファイル名",
  "folder_name_is_requiredV2": "フォルダー名は必須です",
  "file_name_is_requiredV2": "ファイル名は必須です",
  "file_names_cannot_contain_the_following_charactersV2": "ファイル名に次の文字は使用できません：",
  "a_folder_with_this_name_already_existsV2": "同じ名前のフォルダーが既に存在します",
  "a_file_with_this_name_already_existsV2": "同じ名前のファイルが既に存在します",
  "renamedV2": "名前を変更しました",
  "rename_failedV2": "名前の変更に失敗しました",
  "online_preview_is_not_supported_for_this_file_download_it_insteadV2": "このファイルはオンラインプレビューに対応していません。ダウンロードして表示しますか？",
  "online_preview_is_not_supported_for_this_fileV2": "このファイルはオンラインプレビューに対応していません",
  "file_nameV3": "ファイル名",
  "files_in_destination_folder": "移動先フォルダー内のファイル",
  "file_being_uploaded": "アップロード中のファイル",
  "existing_files": "既存のファイル",
  "file_information": "ファイル情報",
  "file_path": "ファイルパス",
  "only_images_can_be_uploaded_to_the_product_asset_library": "製品素材ライブラリには画像のみアップロードできます。",
  "cloud_drive_is_full": "クラウドストレージの容量が上限に達しました",
  "not_enough_cloud_drive_space": "クラウドストレージの空き容量が不足しているため、",
  "some_files_exceed_the_available_cloud_drive_space": "一部のファイルがクラウドストレージの空き容量を超えています",
  "upload_file": "ファイルをアップロード",
  "upload_folder": "フォルダーをアップロード",
  "unnamed_folder": "名称未設定フォルダー",
  "original_image_for_content_display": "コンテンツ表示用の元画像",
  "texture_library_folders_cannot_be_moved_in_or_out": "テクスチャライブラリフォルダーは内外に移動できません。",
  "files_can_only_be_moved_into_the_product_asset_library_folder": "ファイルは製品素材ライブラリフォルダーにのみ移動できます。",
  "folders_other_than_texture_library_folders_cannot_be_moved_in": "テクスチャライブラリ以外のフォルダーは内側に移動できません。",
  "texture_library_folders_cannot_be_moved_out": "テクスチャライブラリフォルダーは外側に移動できません。",
  "move_failed": "移動に失敗しました",
  "duplicate_nameV2": "ファイル名重複",
  "duplicate_files": "重複ファイル",
  "admin_only": "（管理者のみ）",
  "system": "（システム）",
  "cannot_move_outside_the_product_asset_library": "製品素材ライブラリの外には移動できません",
  "cannot_move_to_the_product_asset_library_folder": "製品素材ライブラリフォルダーには移動できません",
  "cannot_move_to_the_value_folder": "{{value}}フォルダーには移動できません",
  "not_enough_cloud_drive_spaceV2": "クラウドストレージの空き容量が不足しているため、",
  "uploaded_successfullyV3": "アップロードしました",
  "file_names_cannot_contain_the_following_charactersV3": "ファイル名に次の文字は使用できません：",
  "no_upload_tasks": "アップロードタスクはありません",
  "x_files_are_being_uploaded": "X件のファイルをアップロード中",
  "upload_list": "アップロード一覧",
  "uploading": "アップロード中",
  "completed": "完了",
  "no_upload_tasksV2": "アップロードタスクはありません",
  "my_company": "自社",
  "my_companyV2": "自社",
  "company_administrator": "会社管理者",
  "private_deployment_for_enterprises": "企業向けオンプレミス導入",
  "on_premises_data_deployment": "データのオンプレミス保管",
  "iconV3": "アイコン",
  "private_cloud_server": "プライベートクラウドサーバー",
  "custom_homepage": "ホームカスタマイズ",
  "delegated_data_management": "データ管理の委託",
  "number_of_members": "メンバー数",
  "unlimitedV10": "無制限",
  "technical_services": "技術サービス",
  "online_one_on_one_support": "オンライン1対1サポート",
  "class_a": "クラスA",
  "class_b": "クラスB",
  "activeV3": "有効",
  "terminated": "終了",
  "level": "レベル",
  "partnership_status": "提携状況",
  "date_addedV3": "追加日",
  "terminate_this_partnership": "提携を終了しますか？",
  "resume_this_partnership": "提携を再開しますか？",
  "are_you_sure_you_want_to_delete_this_contracted_supplier": "この契約サプライヤーの情報を削除してもよろしいですか？",
  "change_end_date": "終了日を変更",
  "select_dateV3": "日付を選択してください",
  "add_contracted_supplier": "契約サプライヤーの追加",
  "select_a_supplier_to_add": "追加するサプライヤーを選択してください",
  "search_suppliersV2": "サプライヤーを検索",
  "addedV2": "追加済み",
  "contracted_suppliers": "契約サプライヤー",
  "unnamed_folderV2": "名称未設定フォルダー",
  "assets": "資産",
  "value_is_not_an_imageV6": "{{value}}は画像ではありません",
  "value_file_upload_failed": "{{value}}のアップロードに失敗しました。",
  "published_successfullyV2": "公開しました",
  "drag_an_image_of_your_work_here_to_use_as_the_cover": "作品の画像をドラッグしてカバーに設定してください",
  "select_building_type": "建物タイプを選択してください",
  "select_style": "スタイルを選択してください",
  "enter_work_titleV2": "作品名を入力してください",
  "enter_work_titleV3": "作品名を入力してください",
  "unnamed": "名称未設定",
  "enter_body_text": "本文を入力してください",
  "failed_to_upload_valueV4": "{{value}}のアップロードに失敗しました",
  "you_can_upload_up_to_value_attachmentsV2": "添付ファイルは最大{{value}}個までアップロードできます。",
  "added_attachments": "追加済みの添付ファイル",
  "only_images_and_videos_can_be_uploaded": "画像と動画のみアップロードできます",
  "pdf_imageV6": "PDF画像",
  "the_introduction_is_still_uploading_try_saving_again_in_a_moment": "紹介文のアップロードが完了していません。しばらくしてから保存してください。",
  "attachment_upload_is_not_completeV2": "添付ファイルのアップロードが完了していません。",
  "name_is_requiredV6": "名前は必須です",
  "supplier_is_required": "サプライヤーは必須です",
  "select_material_properties": "マテリアル属性を選択してください",
  "minimum_period_cannot_be_greater_than_maximum_period": "最小周期は最大周期を超えられません。",
  "product_style": "製品バリエーション",
  "only_pdf_files_can_be_uploaded": "PDFファイルのみアップロードできます。",
  "failed_to_upload_valueV5": "{{value}}のアップロードに失敗しました",
  "added_attachmentsV2": "追加済みの添付ファイル",
  "chinese_pdf": "中国語PDF",
  "upload_chinese_pdf": "中国語PDFをアップロード",
  "english_pdf": "英語PDF",
  "upload_english_pdf": "英語PDFをアップロード",
  "value_is_not_an_imageV7": "{{value}}は画像ではありません",
  "image_size_limit_4mbV4": "画像サイズ制限4MB",
  "you_can_upload_up_to_value_images": "最大{{value}}枚の画像をアップロードできます",
  "no_more_than_4mbV2": "4MB以下",
  "value_is_not_an_imageV8": "{{value}}は画像ではありません",
  "image_size_limit_4mbV5": "画像サイズ制限4MB",
  "select_styleV2": "スタイルを選択してください",
  "select_styleV3": "*スタイルを選択してください",
  "enter_work_titleV4": "作品名を入力してください",
  "enter_work_titleV5": "*作品名を入力してください",
  "enter_descriptionV2": "説明を入力してください",
  "enter_descriptionV3": "*説明を入力してください",
  "upload_photos": "写真をアップロード",
  "upload_photoV2": "写真をアップロードしてください",
  "material_list": "*マテリアルリスト",
  "exporting": "エクスポート中…",
  "material_listV2": "マテリアルリスト",
  "no_materials_added": "マテリアルが追加されていません",
  "drag_materials_from_the_material_library_on_the_left_to_add_them": "左側のマテリアルライブラリからマテリアルをドラッグして追加してください",
  "nodeV3": "ノード",
  "add_a_node": "ノードを追加してください",
  "project_case": "プロジェクト事例",
  "published_successfullyV3": "公開しました",
  "case_description": "事例の説明",
  "enter_case_description": "事例説明を入力してください",
  "upload_imageV4": "画像をアップロードしてください",
  "company_created_redirecting_to_company_management": "会社を作成しました。会社管理ページに移動します。",
  "create_company": "会社を作成",
  "create_companyV2": "会社を作成",
  "company_logo": "企業ロゴ",
  "company_profile": "会社概要",
  "tell_us_about_your_business": "貴社についてご紹介ください",
  "edit_material": "マテリアルを編集",
  "create_material": "マテリアルを作成",
  "created_and_published": "作成して公開しました",
  "changes_published": "変更を公開しました",
  "publishV2": "公開",
  "at_least_one_image_is_required": "画像を1枚以上追加してください",
  "material_category_name": "※マテリアル分類と名称",
  "select_material_categoryV2": "マテリアル分類を選択してください",
  "select_material_categoryV3": "マテリアル分類を選択してください",
  "enter_material_nameV2": "マテリアル名を入力してください",
  "upload_brand_logo": "ブランドロゴをアップロードしてください",
  "an_incorrect_material_brand_name_may_reduce_search_traffic_enter_it_carefully_and_accurately": "マテリアルブランド名を誤って入力すると検索トラフィックが減少する可能性があります。慎重かつ正確に入力してください。",
  "enter_brand_nameV3": "ブランド名を入力してください",
  "select_unit": "単位を選択してください",
  "enter_series_and_modelV3": "シリーズと型番を入力してください",
  "enter_series": "シリーズを入力してください",
  "enter_origin": "産地を入力してください",
  "select_delivery_periodV2": "納期を選択してください",
  "within_one_yearV4": "1年以内",
  "more_than_one_yearV4": "1年以上",
  "select_supporting_services": "付帯サービスを選択してください",
  "select_use_case": "利用シーンを選択してください",
  "airport": "空港",
  "railway_station": "鉄道駅",
  "shopping_mall_supermarket": "ショッピングモール・スーパーマーケット",
  "plaza": "広場",
  "hotel": "ホテル",
  "museum_exhibition_hall": "博物館・展示ホール",
  "theater_ktv": "劇場・カラオケ",
  "office_building": "オフィスビル",
  "school": "学校",
  "hospital": "病院",
  "restaurant": "レストラン",
  "house_villa": "住宅・別荘",
  "pool": "プール",
  "sports_field": "グラウンド",
  "at_least_one_specification_is_required": "仕様を1つ以上追加してください",
  "upload_node": "ノードをアップロード",
  "upload_parts": "部品をアップロード",
  "enter_experience": "経験を入力してください",
  "more_materials": "マテリアルをもっと見る",
  "published_visible_to_everyone": "公開済み：全員が閲覧できます",
  "privateV5": "非公開",
  "unlimitedV11": "無制限",
  "anonymousV5": "匿名",
  "expiredV2": "失効済み",
  "favorite_requests": "お気に入りのリクエスト",
  "view_all": "すべて見る",
  "clear_invalid_items": "無効な項目をクリア",
  "unlimitedV12": "無制限",
  "request_addressV3": "要望の住所",
  "select_province": "省を選択してください",
  "select_city": "都市を選択してください",
  "select_area": "エリアを選択してください",
  "unlimitedV13": "無制限",
  "materialV3": "マテリアル",
  "finished_productV2": "完成品",
  "equipmentV2": "設備",
  "museum_exhibition_hallV2": "博物館・展示ホール",
  "restaurantV2": "レストラン",
  "sports_fieldV2": "グラウンド",
  "basement": "地下室",
  "shopping_mall_supermarketV2": "ショッピングモール・スーパーマーケット",
  "plazaV2": "広場",
  "semi_outdoor_space": "半屋外空間",
  "railway_stationV2": "鉄道駅",
  "airportV2": "空港",
  "hotelV2": "ホテル",
  "theater_ktvV2": "劇場・カラオケ",
  "indoor": "屋内",
  "outdoor": "屋外",
  "courtyard": "中庭",
  "exterior_wall": "外壁",
  "roof": "屋根",
  "office_buildingV2": "オフィスビル",
  "schoolV2": "学校",
  "hospitalV2": "病院",
  "poolV2": "プール",
  "house_villaV2": "住宅・別荘",
  "within_100_000": "10万以内",
  "within_500_000": "50万以内",
  "within_1_000_000": "100万以内",
  "1_000_000_or_more": "100万以上",
  "failed_to_get_your_location": "位置情報の取得に失敗しました",
  "request_detailsV7": "要望内容",
  "enter_request_details": "リクエストの内容を入力してください",
  "card_expiryV4": "カードの有効期限",
  "select_card_validity_period": "カードの有効期限を選択してください",
  "when_the_validity_period_expires_the_system_automatically_unpublishes_the_card_set_the_card_period_shorter_than_the_time_you_actually_need": "有効期限が切れると、カードは自動的に非公開になります。カードの期間は実際に必要な期間より短く設定することをおすすめします。",
  "request_addressV4": "要望の住所",
  "use_casesV3": "活用シーン",
  "select_use_caseV2": "利用シーンを選択してください",
  "indoorV2": "屋内",
  "outdoorV2": "屋外",
  "semi_outdoor_spaceV2": "半屋外空間",
  "basementV2": "地下室",
  "roofV2": "屋根",
  "exterior_wallV2": "外壁",
  "courtyardV2": "中庭",
  "airportV3": "空港",
  "railway_stationV3": "鉄道駅",
  "shopping_mall_supermarketV3": "ショッピングモール・スーパーマーケット",
  "plazaV3": "広場",
  "hotelV3": "ホテル",
  "museum_exhibition_hallV3": "博物館・展示ホール",
  "theater_ktvV3": "劇場・カラオケ",
  "office_buildingV3": "オフィスビル",
  "schoolV3": "学校",
  "hospitalV3": "病院",
  "restaurantV3": "レストラン",
  "house_villaV3": "住宅・別荘",
  "poolV3": "プール",
  "sports_fieldV3": "グラウンド",
  "budget": "予算",
  "yuan": "元",
  "approxV2": "約",
  "show_lessV4": "折りたたむ",
  "show_moreV4": "もっと見る",
  "enter_a_valid_mobile_or_landline_number": "正しい携帯電話番号または固定電話番号を入力してください",
  "enter_a_valid_email_addressV3": "正しいメールアドレスを入力してください",
  "enter_at_least_one_contact_method": "連絡先を1つ以上入力してください",
  "enter_nickname": "ユーザーのニックネームを入力してください",
  "enter_phone_numberV2": "電話番号を入力してください",
  "enter_email_address": "メールアドレスを入力してください",
  "enter_wechat_idV2": "WeChatアカウントを入力してください",
  "requestV2": "リクエスト",
  "delete_this_anchor_and_all_its_content": "このアンカーとすべての内容を削除しますか？",
  "s_request_card": "のリクエストカード",
  "yuanV2": "元",
  "this_request_has_not_been_published_exit_anyway": "リクエストは未公開です。終了してもよろしいですか？",
  "save_as_draft": "下書きとして保存",
  "upload_an_image_and_create_an_anchor_first": "画像をアップロードし、アンカーを作成したことを確認してください",
  "publishV3": "公開",
  "value_is_not_an_imageV9": "{{value}}は画像ではありません",
  "click_to_uploadV5": "クリックしてアップロード",
  "finished_products_2": "完成品：2",
  "finished_productV3": "完成品",
  "equipment_3": "設備：3",
  "equipmentV3": "設備",
  "materialV4": "マテリアル",
  "request_detailsV8": "リクエスト内容",
  "briefly_describe_your_request": "リクエストの内容を簡単にご記入ください",
  "show_lessV5": "折りたたむ",
  "show_moreV5": "もっと見る",
  "unlimitedV14": "無制限",
  "price_limit": "価格制限",
  "yuan_unit_priceV2": "元/単価",
  "within_two_weeksV3": "2週間以内",
  "reference_imageV3": "参考イメージ",
  "submission_materials": "投稿マテリアル",
  "curatedV9": "厳選",
  "quantityV2": "数量",
  "approxV3": "約",
  "m": "メートル",
  "detailed_design_service": "詳細設計代行",
  "value_succeeded_value_failed": "成功{{value}}件、失敗{{value}}件",
  "brand_category": "ブランド分類",
  "select_data_1_first": "先にデータ1を選択してください",
  "space": "スペース：",
  "you_can_add_more_products": "さらに製品を追加できます",
  "enter_supplier_nameV4": "サプライヤー名を入力してください",
  "supplier_nameV4": "サプライヤー名",
  "failed_to_get_verification_code_try_againV5": "認証コードの取得に失敗しました。再度取得してください",
  "get_the_verification_codeV2": "認証コードを取得してください",
  "identity_verificationV2": "本人確認",
  "verifyV2": "確認",
  "enter_verification_codeV5": "認証コードを入力してください",
  "store_logo": "店舗ロゴ",
  "upload_store_logo": "店舗ロゴをアップロードしてください",
  "platform_name": "プラットフォーム名",
  "enter_platform_name": "プラットフォーム名を入力してください",
  "enter_platform_nameV2": "※プラットフォーム名を入力してください",
  "store_address": "店舗住所",
  "enter_store_address": "店舗住所を入力してください",
  "enter_store_addressV2": "※店舗住所を入力してください",
  "supplier_logo": "※サプライヤーロゴ",
  "upload_supplier_logoV2": "サプライヤーのロゴをアップロードしてください",
  "supplier_is_already_in_useV2": "サプライヤーはすでに使用されています",
  "enter_supplier_nameV5": "サプライヤー名を入力してください",
  "enter_supplier_nameV6": "※サプライヤー名を入力してください",
  "deprecated": "（非推奨）",
  "upload_company_profileV2": "会社概要をアップロード",
  "address_cannot_be_entered": "住所は入力できません",
  "enter_company_introductionV2": "会社紹介を入力してください",
  "honors": "受賞・実績",
  "upload_honors": "受賞・実績をアップロード",
  "verification_information": "認証情報",
  "upload_business_licenseV3": "営業許可証をアップロード",
  "upload_business_licenseV4": "※営業許可証をアップロード",
  "company_name": "※会社名",
  "enter_company_nameV4": "会社名を入力してください",
  "enter_company_nameV5": "※会社名を入力してください",
  "enter_detailed_addressV2": "詳細住所を入力してください",
  "enter_full_address": "※詳細住所を入力してください",
  "legal_representativeV3": "※法定代表者",
  "enter_legal_representativeV4": "法定代表者を入力してください",
  "enter_legal_representativeV5": "※法定代表者を入力してください",
  "legal_representative_format_is_incorrect": "法定代表者の形式が正しくありません",
  "enter_the_legal_representative_s_phone_number": "法定代表者の電話番号を入力してください",
  "enter_the_legal_representative_s_phone_numberV2": "※法定代表者の電話番号を入力してください",
  "supplier_type": "※サプライヤー種別",
  "select_supplier_typeV2": "サプライヤーのタイプを選択してください",
  "manufacturerV2": "メーカー",
  "dealer": "代理店",
  "business_contact_name": "※業務担当者名",
  "enter_business_contact_nameV3": "業務担当者名を入力してください",
  "enter_business_contact_nameV4": "※業務担当者名を入力してください",
  "contact_phone_number_format_is_incorrect": "連絡先電話番号の形式が正しくありません",
  "enter_business_contact_phone_numberV3": "業務担当者の電話番号を入力してください",
  "enter_business_contact_phone_numberV4": "※業務担当者の電話番号を入力してください",
  "enter_contact_addressV3": "連絡先住所を入力してください",
  "enter_business_wechat_idV2": "業務連絡用のWeChat IDを入力してください",
  "service_areaV2": "※サービスエリア",
  "select_service_areaV5": "サービスエリアを選択してください",
  "security_settings": "セキュリティ設定",
  "glass_supplier": "ガラスサプライヤー",
  "transfer": "移管",
  "unfreeze": "凍結解除",
  "delete_supplier": "サプライヤーを削除",
  "third_party_store": "サードパーティストア",
  "verification_informationV2": "認証情報",
  "security_settingsV2": "セキュリティ設定",
  "taobao": "タオバオ",
  "tmall": "Tmall",
  "jd_com": "京東",
  "pinduoduo": "ピンドゥオドゥオ",
  "douyin": "Douyin",
  "kuaishou": "Kuaishou",
  "suning": "蘇寧",
  "add_at_least_one_store": "店舗を1つ以上追加してください",
  "third_party_storeV2": "サードパーティストア",
  "enter_store_url": "店舗のURLを入力してください",
  "supplier_onboarding_under_review": "サプライヤー出店申請を審査中",
  "supplier_onboarding_rejected": "サプライヤー出店申請を差し戻し",
  "our_review_team_will_review_your_application_within_2_business_days": "審査チームが2営業日以内に申請内容を審査いたします。",
  "please_wait_you_will_be_notified_by_sms_once_your_application_is_approved": "審査を通過しましたら、SMSでお知らせします。しばらくお待ちください。",
  "contact_400_189_9196": "お問い合わせ：400-189-9196",
  "preview_information": "プレビュー情報",
  "reapply": "再申請",
  "business_verification": "法人認証",
  "turn_on_the_front_camera": "フロントカメラをオンにしてください",
  "image_uploaded_successfully": "画像をアップロードしました",
  "server_error": "サーバーエラー",
  "face_detected": "顔が検出されました",
  "no_face_detected": "顔が検出されませんでした",
  "face_authentication_passed": "顔認証が完了しました",
  "return_to_your_computer_to_complete_business_verification": "パソコンに戻って事業者認証を完了してください",
  "face_authentication_failed": "顔認証に失敗しました",
  "file_upload_failedV3": "ファイルのアップロードに失敗しました",
  "the_image_is_too_large_please_upload_it_again_maximum_file_size_value_mb": "画像が大きすぎますので、再アップロードしてください（最大ファイルサイズは{{value}}MBです）",
  "image_uploaded_successfullyV2": "画像をアップロードしました",
  "upload_your_id_card_first": "まず身分証をアップロードしてください",
  "id_card_submitted_successfully": "身分証を送信しました",
  "added_to_favoritesV4": "お気に入りに追加しました",
  "team_logo": "チームロゴ",
  "10k": "万",
  "header_background": "ヘッダーの背景",
  "tile_n": "タイルN",
  "delete_all": "すべて削除",
  "about": "紹介",
  "partnership": "提携",
  "productsV2": "製品",
  "shared_product": "商品共有",
  "shared_productV2": "商品共有",
  "assetsV2": "資産",
  "to_value_select_at_least_one_value": "{{value}}する{{value}}を選択してください",
  "invite_value": "{{value}}を招待",
  "no_private_spaces_yet": "スペースなし",
  "please_read_the_following_supplier_onboarding_service_agreement_and_rules_carefully": "以下のサプライヤー出店サービス規約および規定をよくお読みください。",
  "i_have_read_the_above_agreement": "上記の規約を読みました",
  "read_and_accept_the_agreement": "規約をお読みのうえ、チェックを入れてください",
  "you_cannot_invite_yourself": "自分自身は招待できません",
  "recommended_designers": "おすすめのデザイナー",
  "company_nameV2": "会社名",
  "company_name_is_required": "会社名は必須です",
  "enter_company_nameV6": "会社名を入力してください",
  "business_contact": "業務担当者",
  "business_contact_is_required": "業務担当者は必須です",
  "enter_business_contact": "業務担当者を入力してください",
  "contact_number": "連絡先電話番号",
  "contact_phone_number_is_required": "連絡先電話番号は必須です",
  "enter_contact_numberV2": "電話番号を入力してください",
  "create_an_introduction_page": "紹介ページの作成",
  "manage_product_data": "製品データの管理",
  "dear_supplier": "サプライヤー各位",
  "congratulations_a_designer_friend_has_recommended_you_as_a_curated_supplier_on_bujue_bujue_is_a_curated_high_quality_supplier_platform_built_on_designer_recommendations_once_you_complete_the_curated_supplier_onboarding_process_you_can": "おめでとうございます。ご友人のデザイナーの推薦により、Bujueの厳選サプライヤーに選ばれました。Bujueはデザイナーの推薦によって共に築かれた、厳選された高品質のサプライヤープラットフォームです。厳選サプライヤーの出店手続きが完了すると、以下が可能になります。",
  "share_product_library_cards_directly_with_designers_and_on_social_media": "製品ライブラリカードをデザイナーやSNSに直接共有",
  "we_look_forward_to_having_you_on_board_to_make_bujue_even_better_and_to_helping_more_designers_discover_you_contact_you_and_build_win_win_partnerships": "皆様のご参加によりBujueはさらに充実し、より多くのデザイナーの方々があなたを見つけ、ご連絡し、Win-Winの協力関係を築けることを楽しみにしております。",
  "join_company": "企業に参加",
  "confirm_request": "参加を申請",
  "cancel": "キャンセル",
  "apply_to_join_value": "{{value}}への参加を申請",
  "verification": "認証情報",
  "enter_what_you_want_to_know": "知りたいことを入力してください",
  "zhejiang_icp_no_17033477_5": "浙江省ICP番号17033477-5",
  "failed_to_get_verification_code_try_againV6": "認証コードの取得に失敗しました。再度取得してください",
  "complete_the_puzzle_firstV3": "まずはパズルを完成させてください",
  "linked_successfullyV2": "連携しました",
  "enter_verification_codeV6": "認証コードを入力してください",
  "failed_to_get_verification_code_try_againV7": "認証コードの取得に失敗しました。再度取得してください",
  "complete_the_puzzle_firstV4": "まずはパズルを完成させてください",
  "registration_and_login_agreement": "登録・ログイン規約について",
  "wechat_loginV3": "WeChatログイン",
  "wechat_loginV4": "WeChatログイン",
  "panzi_loginV3": "Panziログイン",
  "alipay_loginV2": "Alipayログイン",
  "hold_and_drag_the_slider_to_complete_the_puzzleV2": "スライダーを押したままドラッグしてパズルを完成させてください",
  "choose_ai_layout_style": "AIレイアウト方式を選択",
  "dense_grid": "密なグリッド",
  "seamless_tight_tiling": "シームレスで隙間のないタイル配置",
  "loose_grid": "ゆったりグリッド",
  "spaced_layout_with_optional_rounded_corners": "間隔を空けた配置、角丸に対応",
  "artistic_layout": "アートレイアウト",
  "free_composition_with_ai_color_palette": "自由な構図とAI配色",
  "start_layout": "レイアウト開始",
  "detecting_material_colors": "マテリアルの配色を解析中…",
  "analyzing_texture": "質感を解析中…",
  "deducing_composition": "構図を推定中…",
  "matching_background_swatches": "背景カラーパレットを照合中…",
  "selecting_decorative_elements": "装飾要素を選定中…",
  "balancing_white_space": "余白バランスを調整中…",
  "generating_layout": "レイアウト案を生成中…",
  "ai_processing": "AI処理中…",
  "connector_layout": "接続線レイアウト",
  "model": "型番",
  "material_information": "マテリアル情報",
  "materials_in_the_library_information_comes_from_the_product_library_and_cannot_be_edited": "ライブラリ内のマテリアルです。情報は製品ライブラリから取得されるため、編集できません。",
  "material_nameV2": "マテリアル名",
  "optional": "任意",
  "select_material_propertiesV2": "マテリアル属性を選択してください",
  "value_automatically_selected": "{{value}}が自動的に選択されました",
  "the_original_specification_is_no_longer_valid_select_another_one": "元の仕様は無効です。再度選択してください。",
  "this_specification_combination_is_disabled": "この仕様の組み合わせは無効です",
  "select_value": "{{value}}を選択してください",
  "specification_code": "仕様コード",
  "enter_specification_code": "仕様コードを入力…",
  "this_specification_has_no_image_and_cannot_be_selected_here": "この仕様には画像がないため、ここでは選択できません。",
  "this_specification_has_multiple_images_you_can_replace_the_image_used_in_the_canvas": "この仕様には複数の画像があり、キャンバスで使用中の画像を差し替えできます。",
  "changing_the_specification_will_also_replace_the_image_of_this_element_in_the_canvas": "仕様を変更すると、キャンバス内の該当要素の画像も差し替わります。",
  "this_specification_has_no_current_images_and_cannot_be_selected_here": "この仕様には現在の画像がないため、ここでは選択できません。",
  "select_at_least_one_image_first": "画像を1枚以上選択してください",
  "loading_data_source": "データソースを読み込み中です。しばらくお待ちください…",
  "ai_is_analyzing_this_image_please_wait": "この画像をAIで解析中です。しばらくお待ちください…",
  "ai_recognition_in_progress": "AI認識中…",
  "image_loading_failed": "画像の読み込みに失敗しました",
  "recognition_failed_task_does_not_exist_or_has_expired": "認識に失敗しました：タスクが存在しないか、期限が切れています",
  "recognition_failed": "認識に失敗しました：",
  "unknown_error": "不明なエラー",
  "no_matching_material_was_found_in_the_current_asset_library_drag_one_in_manually_from_the_asset_library_on_the_left_or_try_again_later": "現在の素材ライブラリでマテリアルが見つかりません。左側の素材ライブラリから手動でドラッグするか、後でもう一度お試しください。",
  "no_matching_material_image_was_found_in_the_library_you_can_add_it_manually_from_the_asset_library_on_the_left": "ライブラリ内でマテリアル画像が見つかりません。左側の素材ライブラリから手動で追加できます。",
  "identified_value_materials_fetching_images": "{{value}}件のマテリアルを認識しました。画像を取得中…",
  "placed_value_identified_materials": "認識したマテリアルを{{value}}件配置しました ✓",
  "select_at_least_one_asset_first": "素材を1つ以上選択してください",
  "ai_photorealistic_renderings_cannot_be_used_as_materials_in_layout": "AIリアル化パースはマテリアルとしてレイアウトに使用できません",
  "material_board_is_empty": "マテリアルボードが空です",
  "ai_material_board": "AIマテリアルボード",
  "materialV5": "マテリアル",
  "material_board_generated": "マテリアルボードを生成しました ✓",
  "layout_failed": "レイアウトに失敗しました：",
  "layout_completed": "レイアウト完了 ✓",
  "no_connector_found_in_the_selection": "選択範囲に接続線が見つかりません",
  "base_image_not_found": "ベース画像が見つかりません",
  "child_image_not_found": "子画像が見つかりません",
  "connector_layoutV2": "・接続線レイアウト",
  "base_image": "ベース画像",
  "connector_layout_completed": "接続線レイアウト完了 ✓",
  "select_a_material_board_in_the_workbench_first": "ワークベンチでマテリアルボードを選択してください",
  "material_board_is_empty_add_assets_first": "マテリアルボードが空です。素材を追加してください",
  "material_board": "マテリアルボード",
  "ai_photorealism_in_progress_about_60_120_seconds": "AIリアル化中…（約60〜120秒）",
  "ai_photorealism_in_progress_about_60_120_secondsV2": "AIリアル化中です。約60〜120秒かかります…",
  "ai_photorealism_failed_task_does_not_exist_or_has_expired": "AIリアル化に失敗しました：タスクが存在しないか、期限が切れています",
  "photorealistic": "・リアル化",
  "ai_photorealism_completed": "AIリアル化完了 ✓",
  "ai_photorealism_completed_reused_existing_result": "AIリアル化完了 ✓（既存の結果を再利用）",
  "ai_photorealism_failed": "AIリアル化に失敗しました：",
  "cutting_out": "切り抜き中…",
  "ai_cutout_in_progress_please_wait": "AI切り抜き中です。しばらくお待ちください…",
  "cutout_failed_task_does_not_exist_or_has_expired": "切り抜きに失敗しました：タスクが存在しないか、期限が切れています",
  "cutout_completed": "切り抜き完了 ✓",
  "cutout_failed": "切り抜きに失敗しました：",
  "white_paper": "ホワイトペーパー",
  "quotation_list": "見積リスト",
  "script": "スクリプト",
  "token_placeholder": "トークンプレースホルダー",
  "loading_failed": "読み込みに失敗しました：",
  "export_script_metadata_loading_failed": "エクスポートスクリプトのメタデータの読み込みに失敗しました：",
  "are_you_sure_you_want_to_delete_this_template": "このテンプレートを削除してもよろしいですか？",
  "template_deleted": "テンプレートを削除しました",
  "delete_failed": "削除に失敗しました：",
  "uploadingV2": "アップロード中…",
  "file_uploaded": "ファイルをアップロードしました",
  "upload_failedV2": "アップロードに失敗しました：",
  "enter_template_name": "テンプレート名を入力してください",
  "select_script": "スクリプトを選択してください",
  "upload_template_file": "テンプレートファイルをアップロードしてください",
  "template_updated": "テンプレートを更新しました",
  "template_uploaded": "テンプレートをアップロードしました",
  "create": "作成",
  "save_failed": "保存に失敗しました：",
  "scene": "シーン",
  "enter_private_space_name_to_search": "スペース名を入力して検索",
  "retry_loading_script": "スクリプトの読み込みを再試行",
  "retrying": "再試行中…",
  "upload_template": "テンプレートをアップロード",
  "creation_timeV10": "作成日時",
  "update_time": "更新日時",
  "spaceV2": "所属スペース",
  "engine": "エンジン",
  "globalV3": "グローバル",
  "this_script_is_not_in_the_current_script_metadata_legacy_dirty_data_or_removed": "このスクリプトは現在のスクリプトメタデータに存在しません（レガシーな不正データまたは提供終了）",
  "the_built_in_default_template_is_not_editable": "組み込みのデフォルトテンプレートは編集できません",
  "the_built_in_default_template_cannot_be_deleted": "組み込みのデフォルトテンプレートは削除できません",
  "no_custom_templates": "カスタムテンプレートはありません",
  "edit_template": "テンプレートの編集",
  "template_name": "テンプレート名",
  "example_official_template_quotation_list_2026_edition": "例：公式テンプレート・見積リスト（2026年版）",
  "enter_private_space_name_to_search_none_global": "スペース名を入力して検索（未選択＝グローバル）",
  "token_placeholder_placeholder_filling": "トークンプレースホルダー（プレースホルダー埋め込み）",
  "script_pre_registration_script": "スクリプト（事前登録スクリプト）",
  "no_scripts_available": "（選択できるスクリプトがありません）",
  "no_file": "（ファイルなし）",
  "undo_replacement": "差し替えを元に戻す",
  "uploadedV2": "アップロード済み",
  "idea_board_managementV2": "アイデアボード管理",
  "promptV4": "プロンプト",
  "basic_assets": "基本素材",
  "recommended_suppliers": "推奨サプライヤー",
  "models_and_keysV2": "モデルとキー",
  "ai_configurationV2": "AI設定",
  "ai_usageV2": "AI使用量",
  "export": "エクスポート",
  "export_template": "テンプレートのエクスポート",
  "loading_failedV2": "読み込みに失敗しました：",
  "background": "背景",
  "decoration": "装飾",
  "enter_category_nameV6": "カテゴリ名を入力してください",
  "category_created": "カテゴリを作成しました",
  "category_renamed": "カテゴリ名を変更しました",
  "createV2": "作成",
  "save_failedV2": "保存に失敗しました：",
  "are_you_sure_you_want_to_delete_the_category_value_and_its_official_assets": "カテゴリ「{{value}}」とその公式素材を削除してもよろしいですか？",
  "category_deleted": "カテゴリを削除しました",
  "delete_failedV2": "削除に失敗しました：",
  "image_uploaded": "画像をアップロードしました",
  "upload_failedV3": "アップロードに失敗しました：",
  "are_you_sure_you_want_to_delete_this_official_asset": "この公式素材を削除してもよろしいですか？",
  "new_category": "新規カテゴリ",
  "no_images": "画像なし",
  "create_new_value_category": "{{value}}カテゴリを新規作成",
  "rename_category": "カテゴリの名前を変更",
  "category_name": "カテゴリ名",
  "configuration_load_failedV3": "設定の読み込みに失敗しました：",
  "overwrite_the_existing_super_admin_configuration_with_the_current_runtime_configuration_key_model_prompt": "現在の実行設定（キー／モデル／プロンプト）で既存のスーパー管理者設定を上書きします。よろしいですか？",
  "current_runtime_configuration_imported": "現在の実行設定をインポートしました ✓",
  "import_failed": "インポートに失敗しました：",
  "material_recognition": "マテリアル認識",
  "area_detection": "エリア検出",
  "artistic_layout_asset_selection": "アートレイアウト素材の選択",
  "primary_model": "メインモデル",
  "fallback_model": "予備モデル",
  "capability_name": "能力名",
  "example_deep_thinking": "例：深い思考",
  "label_on_off_high": "ラベル（オン／オフ／high）",
  "request_fragment_json_e_g_thinking_type_enabled": "リクエスト断片JSON（例：{\"thinking\":{\"type\":\"enabled\"}}）",
  "set": "設定済み",
  "format": "フォーマット ✓",
  "should_start_with_sk_or_ark": "sk-またはark-で始める必要があります",
  "testing": "テスト中…",
  "connection_successful": "接続成功",
  "connection_failed": "接続に失敗しました",
  "connection_test_failed": "接続テストに失敗しました：",
  "request_failed": "リクエスト失敗",
  "enter_model_name": "モデル名を入力してください",
  "current_value_leave_blank_to_keep_unchanged": "現在：{{value}}（空欄の場合は変更しません）",
  "enter_api_key": "APIキーを入力してください",
  "edit_model": "モデルの編集",
  "model_name_e_g_doubao_vision": "モデル名（例：Doubao Vision）",
  "api_endpoint": "APIエンドポイント",
  "api_key": "APIキー",
  "example_doubao_seed_1_6_vision_250815": "例：doubao-seed-1-6-vision-250815",
  "test_connection": "接続テスト",
  "disable_value_the_following_prompts_are_using_it_value_after_disabling_they_fall_back_automatically_and_ai_calls_are_not_interrupted_confirm": "⚠「{{value}}」を無効にしますか？以下のプロンプトが使用中です：{{value}} 無効化後は自動的にフォールバックし、AI呼び出しは中断されません。無効にしてよろしいですか？",
  "delete_value_the_following_prompts_are_using_it_value_after_deletion_these_bindings_become_invalid_and_the_runtime_falls_back_to_the_fallback_or_system_default_confirm_deletion": "⚠「{{value}}」を削除しますか？以下のプロンプトが使用中です：{{value}} 削除するとこれらのバインディングは無効になり、実行時は予備／システム既定にフォールバックします。削除してよろしいですか？",
  "delete_model_value": "モデル「{{value}}」を削除しますか？",
  "deleted_click_save_to_write_to_the_server": "削除しました（「保存」をクリックするとサーバーに反映されます）",
  "updated_click_save_to_write_to_the_server": "更新しました（「保存」をクリックするとサーバーに反映されます）",
  "savedV2": "保存済み",
  "model_configuration_saved": "モデル設定を保存しました",
  "save_failedV3": "保存に失敗しました：",
  "no_models_yet_click_add_model_below": "まだモデルがありません。下の「モデルを追加」をクリックしてください",
  "referenced": "参照中",
  "model_id": "モデルID",
  "there_are_new_unsaved_keys": "新しい未保存のキーがあります",
  "material_recognitionV2": "マテリアル認識",
  "area_detectionV2": "エリア検出",
  "artistic_layout_asset_selectionV2": "アートレイアウト素材の選択",
  "missing_required_placeholder": "必須のプレースホルダーがありません：",
  "save_failed_missing_required_placeholder": "保存に失敗しました：必須のプレースホルダーがありません",
  "content_is_required": "内容は必須です",
  "prompt_content_is_required": "プロンプト内容は必須です",
  "savedV3": "保存済み",
  "prompt_saved": "プロンプトを保存しました",
  "save_failedV4": "保存に失敗しました：",
  "failed_to_restore_defaults_no_response_from_the_server": "デフォルトの復元に失敗しました：サーバーからの応答がありません",
  "restored_to_default": "デフォルトに戻しました",
  "default_prompt_restored": "デフォルトのプロンプトに戻しました",
  "failed_to_restore_defaults": "デフォルトの復元に失敗しました：",
  "no_model_selected": "モデルが選択されていません",
  "this_model_has_no_available_capabilities": "このモデルには選択できる機能がありません",
  "do_not_enable": "（有効にしない）",
  "using_the_server_default_click_restore_default_to_view_the_default_content": "（サーバーのデフォルト値を使用中。「デフォルトに戻す」をクリックするとデフォルトの内容を確認できます）",
  "do_not_bind": "（バインドしない）",
  "leave_blank_default": "空欄＝デフォルト",
  "temperature": "温度",
  "recommended_suppliers_legacy_admin": "推奨サプライヤー（旧管理画面）",
  "select_team_none_global": "チームを選択（未選択＝グローバル）",
  "failed_to_load_usage": "使用量の読み込みに失敗しました：",
  "30_days": "30日間",
  "7_days": "7日間",
  "today": "今日",
  "total_calls": "合計呼び出し回数",
  "failure_rate": "失敗率",
  "total_tokens": "総トークン数",
  "loadingV2": "読み込み中…",
  "dimensions": "ディメンション：",
  "metrics": "指標：",
  "no_records_yet": "まだ記録がありません",
  "no_trend_data_yet": "トレンドデータはまだありません",
  "value_files_exceed_25mb": "{{value}}件が25MBを超えています",
  "value_files_have_unsupported_formats": "{{value}}件が未対応の形式です",
  "ignored_value_files": "{{value}}のファイルを無視しました",
  "no_number": "番号なし",
  "modelV2": "型番",
  "no_value": "No.{{value}}",
  "specification_value": "仕様{{value}}",
  "undone": "元に戻しました",
  "redone": "やり直しました",
  "ai_material_boardV2": "AIマテリアルボード",
  "select_the_material_to_delete_first": "削除するマテリアルを先に選択してください",
  "workbench": "ワークベンチ",
  "material_boardV2": "マテリアルボード",
  "select_v": "選択V",
  "pan_h": "パンH",
  "fit_to_artboard_f": "アートボードに合わせるF",
  "undo": "元に戻す",
  "redo": "やり直し",
  "ai_layout": "AIレイアウト",
  "ai_realistic_renderings_do_not_support_material_replacement": "AIリアル化パースではマテリアルを置き換えられません",
  "off": "オフ",
  "number_only": "番号のみ",
  "material_name_only": "マテリアル名のみ",
  "number_material_name": "番号＋マテリアル名",
  "exportV2": "エクスポート",
  "png_images": "PNG画像",
  "callout": "吹き出し",
  "white_paperV2": "ホワイトペーパー",
  "white_paper_template": "ホワイトペーパーテンプレート",
  "defaultV2": "（デフォルト）",
  "savedV4": "保存しました ✓",
  "save_failed_try_again": "保存に失敗しました。もう一度お試しください",
  "paste_imageV2": "画像を貼り付け",
  "ignored_value": "無視しました：{{value}}",
  "ignored_this_format_is_not_supported_yet": "無視しました：この形式には未対応です",
  "ignored_only_image_pasting_is_supported_jpg_png_gif_webp_bmp_heic_tiff": "無視しました：貼り付けできるのは画像のみです（jpg/png/gif/webp/bmp/heic/tiff）",
  "backgroundV2": "背景",
  "your_browser_does_not_support_the_eyedropper": "お使いのブラウザはスポイトに対応していません",
  "custom_color": "+カスタムカラー",
  "custom_colorV2": "▲カスタムカラー",
  "saturation": "彩度",
  "brightness": "明度",
  "hue": "色相",
  "eyedropper": "スポイト",
  "select_or_open_a_material_board_first": "まずマテリアルボードを選択するか開いてください",
  "background_color_applied": "背景色を適用しました ✓",
  "background_replaced": "背景を置き換えました ✓",
  "image_uploadedV2": "画像をアップロードしました ✓",
  "upload_failed_value": "アップロードに失敗しました：{{value}}",
  "deleted": "削除しました ✓",
  "delete_failed_value": "削除に失敗しました：{{value}}",
  "solid_color_background": "単色の背景",
  "custom_colorV3": "カスタムカラー",
  "no_saved_colors_yet": "まだ色が保存されていません",
  "decoration_replaced": "装飾を置き換えました ✓",
  "decoration_added": "装飾を追加しました ✓",
  "new_decoration_category_name": "新しい装飾カテゴリ名",
  "creation_failed_value": "作成に失敗しました：{{value}}",
  "rename_categoryV2": "カテゴリの名前を変更",
  "rename_failed_value": "名前の変更に失敗しました：{{value}}",
  "delete_category_value": "カテゴリ「{{value}}」を削除しますか？",
  "decoration_assets": "装飾素材",
  "category": "+カテゴリ",
  "renameV2": "名前の変更",
  "no_filter_fields_available_yet": "使用可能なフィルターフィールドはまだありません",
  "lowest": "最低",
  "highest": "最高",
  "select_service_areaV6": "サービスエリアを選択してください",
  "unnamedV2": "名称未設定",
  "my_space": "マイスペース",
  "public_space": "パブリックスペース",
  "backgroundV3": "背景",
  "decorationV2": "装飾",
  "search_for_materials": "マテリアルを検索…",
  "clear_search": "検索をクリア",
  "material_replaced": "マテリアルを置き換えました ✓",
  "reference_priceV10": "参考価格",
  "back": "← 戻る",
  "view_product_details": "製品の詳細を見る",
  "this_specification_combination_is_disabledV2": "この仕様の組み合わせは無効です",
  "value_automatically_selectedV2": "{{value}}が自動的に選択されました",
  "select_valueV2": "{{value}}を選択してください",
  "no_imagesV2": "この仕様の画像なし",
  "view_product_detailsV2": "製品の詳細を見る",
  "recommended_suppliersV2": "推奨サプライヤー",
  "loading_data_sourceV2": "データソースを読み込み中…",
  "failed_to_load_data_source": "データソースの読み込みに失敗しました",
  "you_re_not_following_any_private_spaces_yet": "フォロー中のプライベートスペースはありません",
  "you_haven_t_joined_or_created_any_private_spaces_yet": "参加または作成したプライベートスペースはありません",
  "no_data_sources_yet": "まだデータソースがありません",
  "no_categories": "カテゴリなし",
  "loading_subcategories": "サブカテゴリを読み込み中…",
  "loading_products": "製品を読み込み中…",
  "no_matching_products_try_relaxing_the_filters": "一致する製品がありません。フィルター条件を緩めてみてください",
  "no_products": "このカテゴリに製品なし",
  "select_a_subcategory_to_view_products": "製品を表示するにはサブカテゴリを選択してください",
  "loading_more": "さらに読み込み中…",
  "source": "ソース",
  "service_expired": "サービス期限切れ",
  "banned_for_violation": "違反により利用停止",
  "no_permission_to_query": "閲覧権限がありません",
  "select_spaceV3": "スペースを選択",
  "regulations": "規制",
  "clear": "クリア",
  "this_specification_combination_is_disabledV3": "この仕様の組み合わせは無効です",
  "unnamedV3": "名称未設定",
  "public_spaceV2": "パブリックスペース",
  "failed_to_load_data_sourceV2": "データソースの読み込みに失敗しました",
  "numbering_example_st_01_st_01_1_st_01_2_split_skus_of_the_same_material_into_sub_numbers": "採番例：ST-01・ST-01-1・ST-01-2（同一マテリアルの複数SKUを枝番に分割）",
  "numbering_example_st_01_st_02_one_row_per_material_main_number_only": "採番例：ST-01・ST-02（マテリアルごとに1行、主番号のみ）",
  "export_quotation_list": "見積リストのエクスポート",
  "close": "閉じる",
  "defaultV3": "（デフォルト）",
  "material_quotation": "マテリアル見積書",
  "there_is_no_layout_canvas_in_the_workbench": "ワークベンチにレイアウトキャンバスがありません",
  "all_canvases_value": "すべてのキャンバス（{{value}}）",
  "value_canvases_selected": "{{value}}件のキャンバスを選択中",
  "the_material": "このマテリアル",
  "example_open_the_material_details_page_in_the_existing_system": "（例）既存システムのマテリアル詳細ページを開きます：",
  "this_material_has_no_image_id": "このマテリアルには画像IDがありません",
  "the_default_specification_row_cannot_be_deleted": "デフォルトの仕様行は削除できません",
  "renumbered": "再採番しました ✓",
  "material_information_saved": "マテリアル情報を保存しました ✓",
  "no_materials_available_for_export": "エクスポートできるマテリアルがありません",
  "loading_template": "テンプレートを読み込み中…",
  "select_a_quotation_template": "見積テンプレートを選択してください",
  "generating_export_file": "エクスポートファイルを生成中…",
  "the_quotation_export_task_does_not_exist_or_has_expired": "見積エクスポートタスクが存在しないか、期限が切れています",
  "export_completed": "エクスポート完了 ✓",
  "quotation_export_failed": "見積のエクスポートに失敗しました：",
  "unknown_errorV2": "不明なエラー",
  "timeout": "タイムアウト",
  "export_failed": "エクスポートに失敗しました：",
  "remove_gaps_and_renumber_consecutively_in_the_current_order": "欠番を削除し、現在の順序で連続番号に振り直します。",
  "total_price": "合計金額",
  "0_1_e_g_0_850_means_15_off": "0～1（例：0.850は15%オフ）",
  "discounted_price": "割引後価格",
  "by_canvas": "キャンバス別",
  "by_category": "カテゴリ別",
  "by_supplier": "サプライヤー別",
  "no_supplier": "サプライヤー未記入",
  "material_quotationV2": "マテリアル見積書",
  "material_library": "マテリアルライブラリ",
  "material_database": "マテリアルデータベース",
  "uncategorized": "未分類",
  "material_boardV3": "マテリアルボード",
  "product_id_value": "製品ID：{{value}}",
  "image_id_value": "画像ID：{{value}}",
  "name_value": "名称：{{value}}",
  "brand_value": "ブランド：{{value}}",
  "supplier_value": "サプライヤー：{{value}}",
  "primary_category_value": "大分類：{{value}}",
  "secondary_category_value": "中分類：{{value}}",
  "tertiary_category_value": "小分類：{{value}}",
  "custom_field_value": "カスタムフィールド：{{value}}",
  "spec_value": "仕様：{{value}}",
  "no_supplierV2": "サプライヤー未記入",
  "noV2": "番号",
  "noV3": "番号",
  "material_nameV3": "マテリアル名",
  "material_categoryV4": "マテリアル分類",
  "canvas": "キャンバス",
  "spec_attributes": "仕様属性",
  "quantityV3": "数量",
  "unit_price_yuan": "単価（元）",
  "total_yuan": "合計（元）",
  "no_spec_selected": "仕様未選択",
  "drag_to_reorder": "ドラッグして番号順を調整",
  "open_material_details": "マテリアル詳細ページを開く",
  "locate_in_material_library": "マテリアルライブラリ内で位置を表示",
  "click_to_select_material_attributes": "クリックしてマテリアル属性を選択",
  "click_to_select_change_specifications": "クリックして仕様を選択・変更",
  "click_to_change_specifications": "クリックして仕様を変更",
  "edit_quantity_by_canvas": "キャンバスごとに数量を編集",
  "delete_this_spec_row": "この仕様行を削除",
  "this_material_has_only_one_specification_left_and_cannot_be_deleted": "このマテリアルの仕様は1つのみのため、削除できません。",
  "subtotal": "小計",
  "material_replacedV2": "マテリアルを置き換えました ✓",
  "material_replaced_globally_value_occurrences": "マテリアルを一括置換しました ✓（{{value}}箇所）",
  "replace_material": "マテリアルを置換",
  "new_material": "新しいマテリアル",
  "single_replacement": "単一置換",
  "rectangle": "長方形",
  "square": "正方形",
  "circle": "真円",
  "ellipse": "楕円",
  "triangle": "三角形",
  "rhombus": "ひし形",
  "trapezoid": "台形",
  "hexagon": "六角形",
  "locate_material": "マテリアルの位置を表示",
  "noV4": "番号",
  "uncategorizedV2": "未分類",
  "select_product_specifications": "製品仕様を選択してください",
  "select_a_material_first": "先にマテリアルを選択してください",
  "click_any_material_in_the_material_library_to_replace_the_image": "マテリアルライブラリ内の任意のマテリアルをクリックして画像を置き換えてください",
  "select_a_decoration_first": "先に装飾を選択してください",
  "click_any_decoration_in_the_decoration_asset_library_to_replace_it": "装飾素材ライブラリ内の任意の装飾をクリックして置き換えてください",
  "click_asset": "素材をクリック",
  "size_and_position": "サイズと位置",
  "width": "幅",
  "height": "高さ",
  "ratio": "比率",
  "material_callouts_in_the_product_library_cannot_be_edited": "製品ライブラリ内のマテリアルの吹き出しは編集できません。",
  "image_name": "画像名…",
  "replace_materialV2": "マテリアルを置換",
  "cutting_outV2": "切り抜き中…",
  "ai_cutout": "AI切り抜き",
  "replace_decoration": "装飾を置き換え",
  "images": "枚の画像",
  "canvas_list": "キャンバスリスト",
  "search_canvases": "キャンバスを検索…",
  "clear_searchV2": "検索をクリア",
  "no_related_canvas_found_for_value": "「{{value}}」に関連するキャンバスが見つかりませんでした",
  "no_material_boards_yet": "マテリアルボードはまだありません",
  "unnamedV4": "名称未設定",
  "value_double_click_to_locate": "{{value}}・ダブルクリックで位置を表示",
  "material_boardV4": "マテリアルボード",
  "widthV2": "幅",
  "heightV2": "高さ",
  "enter_edit_mode": "編集モードへ",
  "ai_relayout": "AIで再レイアウト",
  "ai_realistic_material_board": "マテリアルボードをAIリアル化",
  "layout": "レイアウト",
  "background_image_adjustment": "背景画像の調整",
  "horizontal": "左右",
  "show_material_callouts": "マテリアル吹き出しを表示",
  "show_material_numbers": "マテリアル番号を表示",
  "grid_layout": "グリッドレイアウト",
  "rows": "行",
  "widthV3": "幅",
  "automatic": "自動",
  "heightV3": "高さ",
  "background_image_effect": "背景画像効果",
  "brightnessV2": "明暗",
  "unnamedV5": "名称未設定",
  "ai_material_boardV3": "AIマテリアルボード",
  "uncategorizedV3": "未分類",
  "material_information_number": "マテリアル情報／番号",
  "locate_this_product_card_in_the_material_library": "マテリアルライブラリでこの製品カードの位置を表示",
  "select_product_specificationsV2": "製品仕様を選択してください",
  "apply_canvas": "キャンバスを適用",
  "unnamedV6": "名称未設定",
  "asset_images": "素材画像",
  "heightV4": "高さ",
  "image_nameV2": "画像名…",
  "material_callouts_in_the_product_library_cannot_be_editedV2": "製品ライブラリ内のマテリアルの吹き出しは編集できません。",
  "loading_data_sourceV3": "データソースを読み込み中…",
  "loadingV3": "読み込み中…",
  "ai_recognition": "AI認識",
  "view_properties_here": "ここで属性を確認",
  "ai_realistic_renderings_do_not_support_material_replacementV2": "AIリアル化パースではマテリアルを置き換えられません",
  "generating_material_board_please_wait": "マテリアルボードを生成中です。しばらくお待ちください…",
  "value_images_value": "{{value}}枚の画像{{value}}",
  "multi_select": "複数選択",
  "loading_data_sourceV4": "データソースを読み込み中…",
  "loadingV4": "読み込み中…",
  "ai_recognitionV2": "AI認識",
  "rectangleV2": "長方形",
  "heightV5": "高さ",
  "line_width": "線幅",
  "text": "テキスト",
  "failed_to_save_project_name_please_try_again": "プロジェクト名の保存に失敗しました。もう一度お試しください",
  "create_new_material_board": "マテリアルボードを新規作成",
  "fit_all_f": "全体に合わせるF",
  "form_mode": "フォームモード",
  "workbench_mode": "ワークベンチモード",
  "exportV3": "エクスポート",
  "select_vV2": "選択V",
  "pan_hV2": "パンH",
  "connector_c": "コネクタC",
  "rectangle_r": "長方形R",
  "text_t": "テキストT",
  "undo_z": "元に戻す⌘Z",
  "redo_z": "やり直し⌘⇧Z",
  "duplicate": "複製",
  "ai_material_boardV4": "AIマテリアルボード",
  "undoneV2": "元に戻しました",
  "redoneV2": "やり直しました",
  "duplicated": "複製しました ✓",
  "connector_deleted": "コネクタを削除しました",
  "ai_realistic_renderings_cannot_be_dragged_into_a_material_board": "AIリアル化パースはマテリアルボードにドラッグできません",
  "copied_to_layout_canvas": "レイアウトキャンバスにコピーしました ✓",
  "decoration_addedV2": "装飾を追加しました ✓",
  "generating_ai_realistic_image": "AIリアル化を実行中…",
  "generating_material_board_please_waitV2": "マテリアルボードを生成中です。しばらくお待ちください…",
  "savedV5": "保存しました ✓",
  "save_failed_try_againV2": "保存に失敗しました。もう一度お試しください",
  "select_a_material_or_material_board_first": "先にマテリアルまたはマテリアルボードを選択してください",
  "rendering_value_items_for_export": "{{value}}件をエクスポート用にレンダリング中…",
  "export_completedV2": "エクスポート完了 ✓",
  "export_timed_out_please_reduce_the_number_and_try_again": "エクスポートがタイムアウトしました。件数を減らしてもう一度お試しください。",
  "png_export_failed": "PNGエクスポートに失敗しました：",
  "select_the_material_board_to_export_first": "先にエクスポートするマテリアルボードを選択してください",
  "the_selected_material_board_contains_no_materials_so_the_list_cannot_be_exported": "選択したマテリアルボードにマテリアルがないため、リストをエクスポートできません。",
  "generating_export_fileV2": "エクスポートファイルを生成中…",
  "material_list_xlsx": "マテリアル一覧.xlsx",
  "export_timed_out_please_try_again": "エクスポートがタイムアウトしました。もう一度お試しください。",
  "material_list_export_failed": "マテリアル一覧のエクスポートに失敗しました：",
  "the_selected_material_board_has_no_materials": "選択したマテリアルボードにマテリアルがありません",
  "material_quotationV3": "マテリアル見積書",
  "the_quotation_export_task_does_not_exist_or_has_expiredV2": "見積エクスポートタスクが存在しないか、期限が切れています",
  "quotation_export_failedV2": "見積のエクスポートに失敗しました：",
  "unknown_errorV3": "不明なエラー",
  "failed_to_generate_the_screenshot_for_material_board_value_skipped": "マテリアルボード「{{value}}」のスクリーンショット生成に失敗したためスキップしました。",
  "no_exportable_material_board_screenshot_or_material_parsing_failed": "エクスポート可能なマテリアルボードがありません（スクリーンショットまたはマテリアルの解析に失敗しました）",
  "the_white_paper_has_skipped_value_material_elements_value_that_are_missing_required_fields": "ホワイトペーパーでは、必須項目が未入力のマテリアル要素{{value}}件{{value}}をスキップしました。",
  "material_white_paper": "マテリアルホワイトペーパー",
  "the_white_paper_export_task_does_not_exist_or_has_expired": "ホワイトペーパーのエクスポートタスクが存在しないか、有効期限が切れています",
  "the_white_paper_has_been_generated_and_will_be_downloaded_soon": "ホワイトペーパーの生成が完了しました。まもなくダウンロードを開始します。",
  "white_paper_generation_failed": "ホワイトペーパーの生成に失敗しました：",
  "white_paper_export_failed": "ホワイトペーパーのエクスポートに失敗しました：",
  "materialname_is_missing": "materialNameがありません",
  "toptypename_is_missing": "topTypeNameがありません",
  "delete_connector": "コネクタを削除",
  "create_new_material_boardV2": "マテリアルボードを新規作成",
  "enter_edit_modeV2": "編集モードへ",
  "ai_relayoutV2": "AIで再レイアウト",
  "value_files_exceed_25mbV2": "{{value}}件が25MBを超えています",
  "value_files_have_unsupported_formatsV2": "{{value}}件が未対応の形式です",
  "ignored_value_filesV2": "{{value}}のファイルを無視しました",
  "drag_onto_the_material_board_to_add_a_decoration": "マテリアルボードにドラッグして装飾を追加してください",
  "drag_assets_from_the_material_library_or_drag_in_image_files_directly": "マテリアルライブラリから素材をドラッグするか、画像ファイルを直接ドラッグしてください",
  "right_click_to_create_a_new_material_board": "右クリックでマテリアルボードを新規作成",
  "selected": "件選択済み",
  "ai_realistic_renderings": "AIリアル化パース",
  "unnamedV7": "名称未設定",
  "name_valueV2": "名前{{value}}",
  "modelV3": "型番",
  "specification_valueV2": "仕様{{value}}",
  "price_value": "価格{{value}}",
  "ai_material_boardV5": "AIマテリアルボード",
  "double_click_to_edit": "ダブルクリックで編集",
  "unnamed_project": "無題のプロジェクト",
  "material_inspiration": "マテリアルインスピレーション",
  "search_projects": "プロジェクトを検索…",
  "clear_searchV3": "検索をクリア",
  "project_name": "プロジェクト名…",
  "drag": "ドラッグ",
  "pin": "位置を固定",
  "unpin": "固定を解除",
  "design_styleV2": "デザインスタイル",
  "originV8": "産地",
  "reference_priceV11": "参考価格",
  "experience": "経験",
  "nodeV4": "ノード",
  "inspection_certificate": "検査証明書",
  "open_this_link_on_a_computer": "パソコンでリンクを開いてください。",
  "add_planetV2": "プラネット追加",
  "onboarding_information": "出店情報",
  "enter_material_name_color_name": "マテリアル名／カラー名を入力してください",
  "draftV3": "下書き",
  "reject_applicationV2": "申請差し戻し",
  "unpublishedV2": "非公開",
  "use_casesV4": "活用シーン",
  "airportV4": "空港",
  "railway_stationV4": "鉄道駅",
  "shopping_mall_supermarketV4": "ショッピングモール・スーパーマーケット",
  "plazaV4": "広場",
  "hotelV4": "ホテル",
  "museum_exhibition_hallV4": "博物館・展示ホール",
  "theater_ktvV4": "劇場・カラオケ",
  "office_buildingV4": "オフィスビル",
  "schoolV4": "学校",
  "hospitalV4": "病院",
  "restaurantV4": "レストラン",
  "house_villaV4": "住宅・別荘",
  "poolV4": "プール",
  "sports_fieldV4": "グラウンド",
  "within_one_yearV5": "1年以内",
  "more_than_one_yearV5": "1年以上",
  "material_originV2": "マテリアルの産地",
  "reference_priceV12": "参考価格",
  "reason_for_unpublishingV3": "非公開の理由：",
  "unlikeV2": "いいね解除",
  "bulk_deletion_completed": "一括削除しました",
  "upgrading_data_to_adapt_to_new_creative_board_features_please_wait": "クリエイティブボードの新機能に対応するためデータを更新しています。しばらくお待ちください…",
  "updating_numbering": "番号を更新中",
  "no_renumbering_needed": "番号の更新は不要です",
  "white_paperV3": "ホワイトペーパー",
  "the_color_swatch_image_is_empty_and_cannot_be_exported": "カラースウォッチ画像が空のためエクスポートできません。",
  "export_failedV2": "エクスポートに失敗しました",
  "export_failed_contact_your_administrator": "エクスポートに失敗しました。管理者にお問い合わせください。",
  "cancel_export": "エクスポート中止",
  "unnamed_projectV2": "無題のプロジェクト",
  "your_work_is_saved_automatically_are_you_sure_you_want_to_exit": "作成内容は自動保存されます。終了してもよろしいですか？",
  "creative": "クリエイティブ",
  "project": "プロジェクト",
  "unnamed_project_value": "無題のプロジェクト_{{value}}",
  "create_project": "プロジェクトを作成",
  "export_white_paper": "ホワイトペーパーをエクスポート",
  "select_spaceV4": "スペースを選択してください",
  "select_a_template_to_export": "エクスポートするテンプレートを選択してください",
  "exporting_please_wait": "エクスポート中です。お待ちください…",
  "customV2": "カスタム",
  "contact_supportV3": "サポートにご連絡ください",
  "are_you_sure_you_want_to_cancel_the_export": "エクスポートをキャンセルしてもよろしいですか？",
  "exporting_please_waitV2": "エクスポート中です。お待ちください…",
  "exported": "エクスポートしました",
  "if_the_download_does_not_start_automatically_please": "ダウンロードが自動的に開始されない場合は、",
  "project_list": "プロジェクト一覧",
  "search_projectsV2": "プロジェクトを検索",
  "delete_this_project_and_its_related_information": "このプロジェクトと関連情報を削除してもよろしいですか？",
  "the_image_has_not_finished_uploading": "画像のアップロードがまだ完了していません",
  "upload_an_image_and_enter_a_category_name_first": "先に画像をアップロードしてカテゴリ名を入力してください",
  "backgroundV4": "背景",
  "accent": "アクセント",
  "enter_category": "カテゴリを入力してください*",
  "category_deletedV2": "カテゴリを削除しました",
  "failed_to_delete_category": "カテゴリの削除に失敗しました",
  "are_you_sure_you_want_to_delete_valueV2": "{{value}}を削除してもよろしいですか？",
  "value_deleted": "{{value}}を削除しました",
  "official_selection": "公式セレクション",
  "user_upload": "ユーザーアップロード",
  "search_assets": "素材を検索",
  "adjust_texture_scale": "テクスチャ比率を調整",
  "spaceV3": "スペース",
  "quantityV4": "数量",
  "nameV6": "名前",
  "finished_productV4": "完成品",
  "noV5": "番号",
  "enter_product_nameV4": "製品名を入力してください",
  "modelV4": "型番",
  "enter_modelV2": "型番を入力してください",
  "unknown_category": "不明なカテゴリ",
  "enter_specificationsV2": "仕様を入力してください",
  "spaceV4": "スペース",
  "quantityV5": "数量",
  "unit_price": "単価",
  "enter_unit_price": "単価を入力してください",
  "enter_brand": "ブランドを入力してください",
  "enter_supplierV2": "サプライヤーを入力してください",
  "select_unitV2": "単位を選択してください",
  "export_product_list": "製品リストをエクスポート",
  "are_you_sure_you_want_to_cancel_the_exportV2": "エクスポートをキャンセルしてもよろしいですか？",
  "exportedV2": "エクスポートしました",
  "export_failedV3": "エクスポートに失敗しました",
  "if_the_download_does_not_start_automatically_pleaseV2": "ダウンロードが自動的に開始されない場合は、",
  "product_list": "製品リスト",
  "save_changes": "変更を保存しますか？",
  "exportedV3": "エクスポートしました",
  "export_failedV4": "エクスポートに失敗しました",
  "product_listV2": "製品リスト",
  "exportV4": "エクスポート",
  "categoryV2": "カテゴリ",
  "spaceV5": "スペース",
  "discountV3": "割引：",
  "tip_when_grouping_by_category_drag_products_within_a_group_to_change_their_order_note_products_are_numbered_in_order_so_reordering_also_changes_the_numbers": "ヒント：カテゴリ別にグループ化した場合、グループ内で製品をドラッグして並べ替えます（注：製品は番号順に並んでおり、並べ替えると番号も変わります）",
  "tip_drag_groups_to_change_their_order": "ヒント：グループをドラッグして順序を並べ替えます",
  "noV6": "番号",
  "subtotalV2": "小計：",
  "quantityV6": "数量",
  "enter_quantity": "数量を入力してください",
  "unknown_supplier": "不明なサプライヤー",
  "noV7": "番号",
  "subtotalV3": "小計：",
  "noV8": "番号",
  "subtotalV4": "小計：",
  "failed_to_get_image": "画像の取得に失敗しました",
  "unknown_supplierV2": "不明なサプライヤー",
  "materialV6": "マテリアル",
  "already_at_the_front": "すでに最前面です",
  "already_at_the_back": "すでに最背面です",
  "materialV7": "マテリアル",
  "adjust_texture_scaleV2": "テクスチャ比率を調整",
  "move_up_one_level": "1つ上に移動",
  "move_down_one_level": "1つ下に移動",
  "move_to_front": "最前面へ移動",
  "move_to_back": "最背面へ移動",
  "enter_a_category_name_first": "先にカテゴリ名を入力してください",
  "save_background_image": "背景画像を保存",
  "enter_categoryV2": "カテゴリを入力してください*",
  "projection_type": "投影の種類",
  "ground": "地面",
  "top_surface": "上面",
  "materialV8": "マテリアル",
  "rectangleV3": "長方形",
  "round": "円形",
  "hexagonV2": "六角形",
  "trapezoidV2": "台形",
  "undoV2": "元に戻す",
  "redoV2": "やり直し",
  "cutout": "切り抜き",
  "shadow": "シャドウ",
  "reflection": "リフレクション",
  "flip_horizontal": "左右反転",
  "flip_vertical": "上下反転",
  "global_projection": "グローバル投影",
  "projection_length": "投影の長さ",
  "global_shadow": "グローバルシャドウ",
  "product_number": "製品番号",
  "canvas_ratio": "キャンバス比率",
  "fit_to_background_image": "背景画像に合わせる",
  "canvasV2": "キャンバス",
  "your_work_is_saved_automatically_are_you_sure_you_want_to_exitV2": "作成内容は自動保存されます。終了してもよろしいですか？",
  "search_teamV2": "チームを検索",
  "productsV3": "製品",
  "followingV2": "フォロー中",
  "main_product_image": "製品メイン画像",
  "materialV9": "マテリアル",
  "all_value": "すべての{{value}}",
  "materialV10": "マテリアル",
  "move_up_one_levelV2": "1つ上に移動",
  "move_down_one_levelV2": "1つ下に移動",
  "move_to_frontV2": "最前面へ移動",
  "move_to_backV2": "最背面へ移動",
  "delete": "削除",
  "i_have_renewed": "更新済み",
  "checking_private_space_plan_status": "プライベートスペースのプラン状態を確認しています",
  "accentV2": "アクセント",
  "backgroundV5": "背景",
  "delete_this_space_and_its_related_information": "このスペースと関連情報を削除してもよろしいですか？",
  "regenerating_value_artboard": "{{value}}アートボードを再生成しています",
  "unknown_product": "不明な製品",
  "unknown_product_value": "不明な製品{{value}}",
  "finished_productV5": "完成品",
  "uploading_background": "背景をアップロード中",
  "failed_to_get_imageV2": "画像の取得に失敗しました",
  "materialV11": "マテリアル",
  "equipmentV4": "設備",
  "are_you_sure_you_want_to_reset": "リセットしてもよろしいですか？",
  "copying_image_addresses_from_third_party_websites_is_not_supported": "サードパーティのWebサイトの画像URLのコピーには対応していません",
  "processing_images_please_wait": "画像を処理しています。お待ちください…",
  "no_extractable_object_was_found": "抽出できるオブジェクトが見つかりませんでした。",
  "materialV12": "マテリアル",
  "add_to_my_materialsV2": "マイマテリアルに追加",
  "you_cannot_add_your_own_material": "自分のマテリアルは追加できません",
  "this_material_has_already_been_added": "このマテリアルは追加済みです",
  "add_to_comparisonV2": "比較に追加",
  "different_categories_cannot_be_comparedV2": "異なるカテゴリは比較できません",
  "all_materials": "すべてのマテリアル",
  "brand_categoryV2": "ブランド分類",
  "use_casesV5": "活用シーン",
  "airportV5": "空港",
  "railway_stationV5": "鉄道駅",
  "shopping_mall_supermarketV5": "ショッピングモール・スーパーマーケット",
  "plazaV5": "広場",
  "hotelV5": "ホテル",
  "museum_exhibition_hallV5": "博物館・展示ホール",
  "theater_ktvV5": "劇場・カラオケ",
  "office_buildingV5": "オフィスビル",
  "schoolV5": "学校",
  "hospitalV5": "病院",
  "restaurantV5": "レストラン",
  "house_villaV5": "住宅・別荘",
  "poolV5": "プール",
  "sports_fieldV5": "グラウンド",
  "within_one_yearV6": "1年以内",
  "more_than_one_yearV6": "1年以上",
  "material_originV3": "マテリアルの産地",
  "reference_priceV13": "参考価格",
  "all_categoriesV4": "すべてのカテゴリ",
  "pull_to_load": "引っ張って読み込み",
  "content": "コンテンツ",
  "pinned_card": "ピン留めされたカード",
  "unfollow": "フォロー解除",
  "no_contact_information_available": "連絡先情報がありません",
  "not_available": "未公開",
  "select_a_member": "メンバーを選択してください",
  "no_members_available_to_reassign_to": "担当者を変更できるメンバーがいません",
  "select_a_member_to_handle_it": "処理するメンバーを選択してください",
  "pending": "処理待ち",
  "processed": "処理済み",
  "ignoredV3": "無視済み",
  "quotation": "見積書",
  "order_reassigned": "担当者を変更しました",
  "generate_quotation": "見積書を作成",
  "select_template": "テンプレートを選択",
  "official_template": "公式テンプレート",
  "customV3": "カスタム",
  "contact_supportV4": "サポートにご連絡ください",
  "material_nameV4": "マテリアル名",
  "quantityV7": "数量",
  "enter_quantityV2": "数量を入力してください",
  "unit_priceV2": "単価",
  "the_unit_price_cannot_be_less_than_1": "単価は1以上にしてください",
  "enter_unit_priceV2": "単価を入力してください",
  "material_nameV5": "マテリアル名",
  "modelV5": "型番",
  "enter_modelV3": "型番を入力してください",
  "enter_specificationsV3": "仕様を入力してください",
  "select_unitV3": "単位を選択してください",
  "quantityV8": "数量",
  "enter_quantityV3": "数量を入力してください",
  "unit_priceV3": "単価",
  "the_unit_price_cannot_be_less_than_1V2": "単価は1以上にしてください",
  "enter_unit_priceV3": "単価を入力してください",
  "no_specifications_yet": "仕様はまだありません",
  "select_specifications": "仕様を選択してください",
  "activeV4": "有効",
  "this": "この",
  "this_product_has_been_unpublished": "この製品は非公開になっています",
  "enter_the_total_price_of_the_materials": "マテリアルの合計金額を入力してください",
  "set_discount": "割引を設定：",
  "discount_cannot_exceed_1": "割引は1以下にしてください",
  "discount_must_exceed_0": "割引は0より大きい値を入力してください",
  "number_of_materials": "マテリアルの数：",
  "total_priceV2": "合計価格：",
  "discounted_priceV2": "割引価格：",
  "quotationV2": "見積書",
  "exportedV4": "エクスポートしました",
  "processingV2": "処理中",
  "replied": "返信済み",
  "inquiry_recipient": "問い合わせ先",
  "product_countV2": "製品数",
  "activeV5": "有効",
  "thisV2": "この",
  "this_product_has_been_unpublishedV2": "この製品は非公開になっています",
  "download_quotation": "見積書をダウンロード",
  "draftV4": "下書き",
  "not_approvedV2": "未承認",
  "expiring_soon": "まもなく期限切れ",
  "closedV3": "クローズド",
  "new_participation": "新規参加",
  "1_month": "1ヶ月",
  "2_months": "2ヶ月",
  "3_months": "3ヶ月",
  "4_months": "4ヶ月",
  "5_months": "5ヶ月",
  "6_months": "6ヶ月",
  "7_months": "7ヶ月",
  "8_months": "8ヶ月",
  "9_months": "9ヶ月",
  "10_months": "10ヶ月",
  "11_months": "11ヶ月",
  "12_months": "12ヶ月",
  "enter_a_valid_mobile_or_landline_numberV2": "正しい携帯電話番号または固定電話番号を入力してください",
  "enter_a_valid_email_addressV4": "正しいメールアドレスを入力してください",
  "edit_contact_informationV2": "連絡先を変更",
  "enter_at_least_one_contact_methodV2": "連絡先を1つ以上入力してください",
  "enter_the_contact": "担当者名を入力してください",
  "enter_phone_numberV3": "電話番号を入力してください",
  "enter_email_addressV2": "メールアドレスを入力してください",
  "enter_wechat_name": "WeChat名を入力してください",
  "adjust_validity_periodV2": "有効期限の調整",
  "card_expiryV5": "カードの有効期限",
  "select_validity_period": "有効期限を選択してください",
  "republish": "再公開",
  "set_card_expiry": "カード有効期限の設定",
  "set_card_expiry_date": "カードの有効期限を設定してください",
  "official_site_builder": "公式サイト構築",
  "generate_portfolio_product_catalog": "ポートフォリオ／製品カタログの生成",
  "business_partner_circle": "ビジネスパートナーサークル",
  "wechat_mini_program": "WeChatミニプログラム",
  "helpV2": "ヘルプ",
  "build_a_brand_personal_enterprise_website_with_zero_code": "ノーコードでブランド（個人／企業）Webサイトを構築",
  "build_a_personalized_brand_official_site_without_a_single_line_of_code": "コードを1行も書かずに、ブランド公式サイトを個性的に構築",
  "stunning_visual_aesthetics_with_multi_language_support_for_global_expansion": "洗練されたビジュアル表現と多言語対応で、海外展開を後押し",
  "responsive_on_desktop_and_mobile_launch_your_brand_s_official_site_fast": "PC・スマートフォンに自動対応し、ブランド公式サイトをすばやく公開",
  "generate_a_bespoke_portfolio_product_catalog": "ハイエンドなポートフォリオ／製品カタログを生成",
  "upload_once_and_get_a_digitized_structured_library_of_your_works_and_products": "アップロードするだけで、データ化・構造化された作品／製品ライブラリが完成します",
  "share_by_link_with_no_tedious_image_production_or_huge_files_taking_up_space": "リンクで共有できるため、煩雑な画像制作や大容量ファイルによる容量圧迫を回避できます。",
  "no_manual_layout_work_aesthetic_layouts_are_generated_automatically_and_can_be_freely_categorized": "手動でのレイアウト作業は不要。美しい版面を自動生成し、自由に分類できます。",
  "set_sharing_content_automatically_and_track_the_entire_sharing_process": "共有コンテンツを自動的に設定し、共有プロセス全体を追跡できます",
  "multi_language_support_with_automatic_adaptation_to_desktop_tablet_mobile_large_screens_and_more": "多言語対応。PC、タブレット、スマートフォン、大画面など各デバイスに自動で最適化します。",
  "business_circle_business_partner_circle": "ビジネスサークル-ビジネスパートナーサークル",
  "traffic_between_private_spaces_gain_mutual_brand_and_product_exposure_with_the_business_partners_you_have_connected_with": "プライベートスペース間の送客：つながったビジネスパートナー同士で、ブランドと製品を相互に露出できます。",
  "quickly_generate_branded_wechat_mini_programs": "ブランドのWeChatミニプログラムをすばやく生成",
  "no_code_required_we_generate_a_wechat_mini_program_with_your_own_branding_and_refined_visuals_in_no_time": "コード不要で、独自ブランドの洗練されたビジュアルを備えたWeChatミニプログラムをすばやく生成できます。",
  "bujue_zero_code_brand_website_builder_private_space_trading_tool": "Bujue — ノーコードでブランドサイト構築・プライベートスペース取引ツール",
  "get_the_app": "アプリを入手",
  "menu": "メニュー",
  "closeV2": "閉じる",
  "enter_private_space": "プライベートスペースへ",
  "let_every_creator_and_every_enterprise": "すべてのクリエイターとすべての企業が",
  "have_a_brand_home_of_their_own": "自分だけのブランド拠点を持てるように",
  "build_a_brand_website_with_zero_code": "ノーコードでブランドWebサイトを構築",
  "portfolio_product_catalog": "ポートフォリオ／製品カタログ",
  "new_business_tools_for_private_space": "プライベートスペース向けの新しいビジネスツール",
  "use_now": "今すぐ利用",
  "contact_usV2": "お問い合わせ",
  "bujue_features": "Bujueの機能",
  "what_bujue_does": "Bujueができること",
  "dedicated_to_the_design_home_furnishings_and_building_materials_and_wider_aesthetics_industries": "デザイン、住宅・建材、および美学関連の業界に特化したサービスを提供します",
  "china_s_first_luxury_home_design_and_construction_consulting_company": "中国初の高級住宅設計・建設コンサルティング会社",
  "consulting_firm_for_the_design_and_construction_of_private_mansions": "個人邸宅の設計・施工コンサルティング会社",
  "service_case": "サービス事例",
  "case_showcase": "事例紹介",
  "case_value": "事例{{value}}",
  "partner_links": "関連リンク",
  "design_dedao": "設計得到",
  "archbase_building_materials_supply_chain": "ARCHBASE建材サプライチェーン",
  "help_support": "ヘルプ・サポート",
  "2026_hangzhou_bujue_technology_co_ltd": "© 2026 杭州Bujueテクノロジー有限公司",
  "zhejiang_icp_no_17033477_5V2": "浙江省ICP番号17033477-5",
  "support_qr_codeV2": "サポートのQRコード",
  "free_to_use": "無料で利用",
  "individual_small_team": "個人／少人数チーム",
  "medium_team": "中規模チーム",
  "large_team": "大規模チーム",
  "try_bujue_for_free": "Bujueを無料で試す",
  "free_plan": "無料プラン",
  "core_services_start_at_zero_cost": "コアとなる基本サービスをゼロコストで開始",
  "free_trial_with_500mb_storage_capacity": "500MBのストレージ容量を無料で体験",
  "create_websites_and_portfolios_for_free": "Webサイトやポートフォリオの制作を無料で体験",
  "basic_business_card": "基本的な名刺",
  "basic": "ベーシック版",
  "personal_plan": "個人プラン",
  "suitable_for_individuals_and_independent_creators_who_need_a_website_without_product_display_or_transaction_features": "個人や独立クリエイターのサイト構築に最適。商品展示・取引機能は含まれません",
  "10gb_storage_capacity": "10GBのストレージ容量",
  "custom_bujue_subdomain": "Bujueサブドメインのカスタマイズ",
  "basic_website_and_portfolio_features": "Webサイトとポートフォリオの基本機能",
  "for_personal_use_only": "個人使用のみ",
  "contact_usV3": "お問い合わせ",
  "standard": "スタンダード版",
  "team_plan": "チームプラン",
  "suitable_for_small_teams_and_studios_with_product_display_features": "少人数のチームやスタジオなどに最適。商品展示機能付き",
  "50gb_storage_capacity": "50GBのストレージ容量",
  "custom_domain_redirection_service": "独自ドメイン名リダイレクトサービス",
  "no_limit_on_team_size": "チーム人数に制限なし",
  "complete_website_portfolio_and_product_library_functions": "Webサイト、ポートフォリオ、製品ライブラリの機能を完備",
  "bilingual_cn_en": "中国語・英語の二言語対応",
  "professional": "プロフェッショナル版",
  "suitable_for_medium_sized_merchants_and_enterprises_with_product_display_and_transaction_features": "中規模の事業者や企業などに最適。商品展示・取引機能付き",
  "200gb_storage_capacity": "200GBのストレージ容量",
  "transactions_supported_in_development": "取引機能に対応（開発中）",
  "export_file_template_customization": "エクスポートファイルテンプレートのカスタマイズ",
  "product_qr_code_customization_service": "製品QRコードのカスタマイズサービス",
  "business_card_customization": "名刺カスタマイズ",
  "website_visual_customization_service": "Webサイトのビジュアルカスタマイズサービス",
  "assisted_upload_service_for_works_and_products": "作品・製品の代行アップロードサービス",
  "online_offline_training": "オンライン／オフライントレーニング",
  "rendering_optimization": "パースの最適化",
  "exclusive_brand_space": "専用ブランドスペース",
  "build_a_brand_website_with_zero_code_individual_enterprise": "ノーコードでブランドWebサイトを構築（個人／企業）",
  "portfolio_product_catalogV2": "ポートフォリオ／製品カタログ",
  "new_business_tools_for_private_spaceV2": "プライベートスペース向けの新しいビジネスツール",
  "get_the_plan_now": "今すぐプランを入手",
  "switch_plan": "プラン切り替え",
  "other_services": "その他のサービス",
  "from_brand_domains_to_export_templates_we_offer_both_standardized_and_deep_customization_and_lower_the_barrier_to_entry_with_assisted_upload_professional_training_and_more": "ブランドのドメイン名からエクスポートテンプレートに至るまで、標準化サービスと高度なカスタマイズサービスを提供します。利用の敷居を下げ、アップロード代行や専門トレーニングなどのサービスを提供します。",
  "bujue_zero_code_brand_website_builder_private_space_trading_toolV2": "Bujue — ノーコードでブランドサイト構築・プライベートスペース取引ツール",
  "website_builder": "Webサイト構築",
  "portfolio_product_catalogV3": "ポートフォリオ／製品カタログ",
  "business_circle": "ビジネスサークル",
  "wechat_mini_programV2": "WeChatミニプログラム",
  "helpV3": "ヘルプ",
  "enter_private_spaceV2": "プライベートスペースへ",
  "free_registration": "無料登録",
  "let_every_creator_and_every_enterpriseV2": "すべてのクリエイターとすべての企業が",
  "no_code": "ノーコード",
  "aesthetic_visuals": "美しいビジュアル",
  "multi_language_support": "多言語対応",
  "responsive_on_desktop_and_mobile": "PC・モバイル両対応",
  "china_s_first_luxury_home_design_and_construction_consulting_companyV2": "中国初の高級住宅設計・建設コンサルティング会社",
  "consulting_firm_for_the_design_and_construction_of_private_mansionsV2": "個人邸宅の設計・施工コンサルティング会社",
  "click_the_highlighted_area_in_the_top_bar": "上部バーのハイライト領域をクリック",
  "click_the_highlighted_products_area": "「製品」のハイライト領域をクリック",
  "portfolio_product_catalogV4": "ポートフォリオ／製品カタログ",
  "generate_a_bespoke_portfolio_product_catalogV2": "ハイエンドなポートフォリオ／製品カタログを生成",
  "upload_once_and_get_a_digitized_structured_library_of_your_works_and_productsV2": "アップロードするだけで、データ化・構造化された作品／製品ライブラリが完成します",
  "share_by_link_with_no_tedious_catalog_production_or_huge_files_taking_up_space": "リンクで共有できるため、図録の煩雑な制作や大容量ファイルによる容量圧迫を回避できます。",
  "no_manual_layout_work_aesthetic_layouts_are_generated_automatically_and_can_be_freely_categorizedV2": "手動でのレイアウト作業は不要。美しい版面を自動生成し、自由に分類できます。",
  "set_sharing_content_yourself_and_track_the_entire_sharing_process": "共有内容は自分で設定でき、共有プロセス全体を追跡できます",
  "multi_language_support_with_automatic_adaptation_to_desktop_tablet_mobile_large_screens_and_moreV2": "多言語対応。PC、タブレット、スマートフォン、大画面など各デバイスに自動で最適化します。",
  "space_traffic": "スペース送客",
  "brand_exposure": "ブランドの露出",
  "click_the_highlighted_business_circle_area": "「ビジネスサークル」のハイライト領域をクリック",
  "click_the_highlighted_partner_network_area": "「パートナーネットワーク」のハイライト領域をクリック",
  "quickly_generate_branded_wechat_mini_programsV2": "ブランドのWeChatミニプログラムをすばやく生成",
  "previous": "前へ",
  "next": "次へ",
  "use_casesV6": "活用シーン",
  "how_to_use_bujue": "Bujueの使い方",
  "3_500_teams_and_businesses_have_made_bujue_part_of_their_daily_work_turning_every_share_and_every_link_into_value": "3,500を超えるチーム・企業がBujueを日常業務に取り入れ、あらゆる共有とリンクが価値を生み出しています。",
  "play_video": "動画を再生",
  "contact_usV4": "お問い合わせ",
  "wechat_official_account_qr_code": "WeChat公式アカウントQRコード",
  "xiaohongshu_qr_code": "小紅書QRコード",
  "partner_linksV2": "関連リンク",
  "design_dedaoV2": "設計得到",
  "project_management_tools": "プロジェクト管理ツール",
  "furniture_materials": "家具・建材プラザ",
  "archbase_building_materials_supply_chainV2": "ARCHBASE建材サプライチェーン",
  "bujue_featuresV2": "Bujueの機能",
  "help_supportV2": "ヘルプ・サポート",
  "zhejiang_icp_no_17033477_5V3": "浙江省ICP番号17033477-5",
  "wechat_support_qr_code": "WeChatサポートQRコード",
  "try_bujue_for_freeV2": "Bujueを無料で試す",
  "free_planV2": "無料プラン",
  "core_services_start_at_zero_costV2": "コアとなる基本サービスをゼロコストで開始",
  "free_trial_with_500mb_storage_capacityV2": "500MBのストレージ容量を無料で体験",
  "create_websites_and_portfolios_for_freeV2": "Webサイトやポートフォリオの制作を無料で体験",
  "basic_business_cardV2": "基本的な名刺",
  "free_to_useV2": "無料で利用",
  "basicV2": "ベーシック版",
  "personal_planV2": "個人プラン",
  "suitable_for_individuals_and_independent_creators_who_need_a_website_without_product_display_or_transaction_featuresV2": "個人や独立クリエイターのサイト構築に最適。商品展示・取引機能は含まれません",
  "10gb_storage_capacityV2": "10GBのストレージ容量",
  "custom_bujue_subdomainV2": "Bujueサブドメインのカスタマイズ",
  "basic_website_and_portfolio_featuresV2": "Webサイトとポートフォリオの基本機能",
  "for_personal_use_onlyV2": "個人使用のみ",
  "standardV2": "スタンダード版",
  "team_planV2": "チームプラン",
  "suitable_for_small_teams_and_studios_with_product_display_featuresV2": "少人数のチームやスタジオなどに最適。商品展示機能付き",
  "50gb_storage_capacityV2": "50GBのストレージ容量",
  "custom_domain_redirection_serviceV2": "独自ドメイン名リダイレクトサービス",
  "no_limit_on_team_sizeV2": "チーム人数に制限なし",
  "complete_website_portfolio_and_product_library_functionsV2": "Webサイト、ポートフォリオ、製品ライブラリの機能を完備",
  "bilingual_cn_enV2": "中国語・英語の二言語対応",
  "professionalV2": "プロフェッショナル版",
  "suitable_for_medium_sized_merchants_and_enterprises_with_product_display_and_transaction_featuresV2": "中規模の事業者や企業などに最適。商品展示・取引機能付き",
  "200gb_storage_capacityV2": "200GBのストレージ容量",
  "transactions_supported_in_developmentV2": "取引機能に対応（開発中）",
  "399_year": "399元/年",
  "299_year": "299元/年",
  "699_year": "699元/年",
  "499_year": "499元/年",
  "999_year": "999元/年",
  "799_year": "799元/年",
  "1899_year": "1899元/年",
  "1499_year": "1499元/年",
  "5499_year": "5499元/年",
  "3899_year": "3899元/年",
  "19999_year": "19999元/年",
  "9999_year": "9999元/年",
  "export_file_template_customizationV2": "エクスポートファイルテンプレートのカスタマイズ",
  "product_qr_code_customization_serviceV2": "製品QRコードのカスタマイズサービス",
  "business_card_customizationV2": "名刺カスタマイズ",
  "website_visual_customization_serviceV2": "Webサイトのビジュアルカスタマイズサービス",
  "assisted_upload_service_for_works_and_productsV2": "作品・製品の代行アップロードサービス",
  "online_offline_trainingV2": "オンライン／オフライントレーニング",
  "rendering_optimizationV2": "パースの最適化",
  "contact_usV5": "お問い合わせ",
  "other_servicesV2": "その他のサービス",
  "from_brand_domains_to_export_templates_we_offer_both_standardized_and_deep_customization_and_lower_the_barrier_to_entry_with_assisted_upload_professional_training_and_moreV2": "ブランドのドメイン名からエクスポートテンプレートに至るまで、標準化サービスと高度なカスタマイズサービスを提供します。利用の敷居を下げ、アップロード代行や専門トレーニングなどのサービスを提供します。",
  "10_000_individuals_and_3_500_team_and_business_users_are_using_bujue": "10,000人以上の個人と3,500を超えるチーム・企業ユーザーがBujueを利用しています。",
  "opening_the_app_please_wait": "アプリを起動しています。しばらくお待ちください。",
  "service_hours_9_00_17_30": "受付時間：9:00～17:30",
  "consultation_analysis_and_answers": "ご質問の相談・分析・回答",
  "pairing_recommendations_and_usage_tips": "コーディネート提案と活用アドバイス",
  "configuration_list": "構成リスト",
  "members_only_privileges": "会員限定の特典",
  "membership_rulesV4": "会員規約",
  "payment_countdown": "支払いカウントダウン：",
  "become_a_member": "会員登録",
  "payment_status": "支払い状況",
  "view_my_membership": "マイ会員情報を表示",
  "modern_style": "モダンなスタイル",
  "villa": "邸宅",
  "works_library": "作品ライブラリ",
  "publish_work": "作品を公開",
  "value_is_not_an_imageV10": "{{value}}は画像ではありません",
  "other_fields": "その他の項目",
  "no_product_information": "製品情報がありません",
  "related_works": "関連作品",
  "shared_productV3": "商品共有",
  "removed_from_favoritesV3": "お気に入りから削除しました",
  "added_to_favoritesV5": "お気に入りに追加しました",
  "product_unavailable": "商品は無効です",
  "other_fieldsV2": "その他の項目",
  "total_value_itemsV8": "全{{value}}件のデータ",
  "emptyV3": "空",
  "reference_priceV14": "参考価格",
  "other_contact_details": "その他の連絡先",
  "other_fieldsV3": "その他の項目",
  "other_fieldsV4": "その他の項目",
  "all_certificates": "すべての証明書",
  "all_accessories": "すべての付属品",
  "all_nodes": "すべてのノード",
  "other_fieldsV5": "その他の項目",
  "add_to_comparisonV3": "比較に追加",
  "add_failedV2": "追加に失敗しました",
  "request_sampleV2": "サンプルのお申し込み",
  "my_product_library": "マイ製品ライブラリ",
  "related_worksV2": "関連作品",
  "customizableV3": "カスタマイズ可能",
  "material_libraryV2": "マテリアルライブラリ",
  "device_library": "機器ライブラリ",
  "finished_product_library": "完成品ライブラリ",
  "device_libraryV2": "機器ライブラリ",
  "curatedV10": "厳選",
  "material_libraryV3": "マテリアルライブラリ",
  "curatedV11": "厳選",
  "finished_productV6": "完成品",
  "globalV4": "グローバル",
  "reference_priceV15": "参考価格",
  "views_ascending": "閲覧数（昇順）",
  "views_descending": "閲覧数（降順）",
  "name_a_z": "名前A→Z",
  "name_z_a": "名前Z→A",
  "this_private_space_has_been_suspended": "このプライベートスペースは停止されています",
  "get_the_discount_code_first": "まずは割引コードを取得してください",
  "discount_code_copied": "割引コードをコピーしました",
  "channel_codeV2": "チャネルコード",
  "congratulations_your_value_has_been_published_successfully": "おめでとうございます！「{{value}}」を公開しました。",
  "or": "または",
  "check_it_out": "チェックしてみてください",
  "edit_shipping_address": "配送先住所を編集",
  "add_shipping_address": "配送先住所を追加",
  "area": "エリア",
  "enter_detailed_addressV3": "詳細住所を入力してください",
  "enter_recipient_name": "受取人の氏名を入力してください",
  "enter_recipient_phone_number": "受取人の電話番号を入力してください",
  "are_you_sure_you_want_to_delete_this_shipping_address": "この配送先住所を削除してもよろしいですか？",
  "material_nameV6": "マテリアル名",
  "application_timeV6": "申請日時",
  "requested_quantityV3": "申請数量",
  "bujue_supplier_onboarding_agreement_and_rules": "Bujueサプライヤー出店規約および規則",
  "introduction": "はじめに",
  "1_conclusion_of_this_agreement": "1. 本規約の締結",
  "2_instructions_for_using_the_onboarding_system": "2. 出店システムのご利用について",
  "3_supplier_onboarding_requirements_and_supporting_documents": "3. サプライヤーの出店条件および証明書類",
  "1_suppliers_must_meet_the_following_conditions_to_register_on_this_website": "(1) サプライヤーが本ウェブサイトに出店するには、以下の条件を満たす必要があります。",
  "2_submission_of_supporting_documents": "(2) 証明書類の提出：",
  "4_supplier_onboarding_process": "4. サプライヤーの出店フロー",
  "suppliers_must_complete_all_of_the_following_steps_before_they_can_use_supplier_related_features_normally_on_the_bujue_platform": "サプライヤーは、Bujueプラットフォームでサプライヤー関連機能を通常どおり利用する前に、以下のすべての手続きを完了する必要があります。",
  "5_fees_charged_by_the_bujue_platform": "5. Bujueプラットフォームが徴収する費用",
  "1_good_faith_deposit": "(1) 誠実保証金",
  "suppliers_that_meet_all_of_the_following_conditions_may_apply_for_a_refund_of_the_good_faith_deposit_on_the_good_faith_deposit_management_page": "以下の条件をすべて満たすサプライヤーは、誠実保証金の専用管理ページから誠実保証金の返還を申請できます。",
  "1_there_are_no_outstanding_reports_and_or_dispute_cases": "1. 未処理の通報および／または紛争案件がない。",
  "2_there_are_no_outstanding_advances_payable_to_the_bujue_platform": "2. Bujueプラットフォームからの立替金の未返済がない。",
  "3_there_are_no_unfinished_shipments": "3. 未完了の出荷がない。",
  "4_the_completion_time_of_the_last_transaction_has_exceeded_90_calendar_days": "4. 最後の取引の完了から90暦日を超えている。",
  "2_technical_service_fees": "(2) 技術サービス料金",
  "1_when_a_user_purchases_materials_from_a_supplier_through_the_bujue_platform_and_the_order_is_completed_including_partially_completed_the_bujue_platform_has_the_right_to_charge_the_supplier_a_technical_service_fee_of_0_20_of_the_order_amount_the_exact_rate_is_determined_by_the_relevant_rules_of_the_bujue_platform": "1. ユーザーがBujueプラットフォームを通じてサプライヤーからマテリアルを購入し、注文が成立した場合（一部成立を含む）、Bujueプラットフォームは注文成立金額の0%〜20%（具体的な料率はBujueプラットフォームの関連規則に基づき決定）の技術サービス料金をサプライヤーから徴収する権利を有します。",
  "6_description_of_the_service_agreement_and_rules": "6. サービス規約および規則の説明",
  "1_supplier_s_rights_and_obligations": "(1) サプライヤーの権利と義務",
  "2_rights_and_obligations_of_this_website": "(2) 本ウェブサイトの権利と義務",
  "3_intellectual_property_rights": "(3) 知的財産権",
  "4_anti_bribery_clause": "(4) 腐敗防止条項",
  "1_in_order_to_build_a_sound_market_order_on_the_bujue_platform_and_a_healthy_platform_environment_suppliers_agree_to_and_voluntarily_comply_with_all_of_the_following_rules": "1. Bujueプラットフォームの良好な市場秩序を構築し、健全なプラットフォーム環境を整えるため、サプライヤーは以下のすべての規則に同意し、自主的に遵守します。",
  "5_termination_of_onboarding_system_services": "(5) 出店システムサービスの終了",
  "6_modifications_to_this_agreement": "(6) 本規約の変更",
  "7_application_of_law_and_dispute_resolution": "(7) 法の適用と紛争の解決",
  "i_have_read_the_above_agreementV2": "上記の規約を読みました",
  "read_and_accept_the_agreementV2": "規約をお読みのうえ、チェックを入れてください",
  "supplier_onboarding": "サプライヤー出店",
  "supplier_onboarding_application": "サプライヤー出店申請",
  "value_sharing": "{{value}}のシェア",
  "space_sharing": "スペースのシェア",
  "value_sharingV2": "-{{value}}のシェア",
  "value_products_in_total": "合計{{value}}件の製品",
  "hd_assetsV4": "高解像度素材",
  "warning": "警告",
  "heitiV2": "ゴシック体",
  "kaitiV2": "楷書",
  "fangsongV2": "倣宋体",
  "biaukaiV2": "標準楷書体",
  "stfangsongV2": "華文倣宋体",
  "stkaitiV2": "華文楷体",
  "songtiV2": "明朝体",
  "microsoft_yaheiV2": "Microsoft YaHei",
  "gongfan_fontV2": "Gongfanフォント",
  "pangmenzhengdao_bold_calligraphyV2": "龐門正道粗書体",
  "yanshi_chunfeng_kaiV2": "演示春風楷",
  "youshe_haoshentiV2": "優設好身体",
  "sanji_xingkai_simplified_chineseV2": "三極行楷簡体",
  "header_backgroundV2": "ヘッダーの背景",
  "header_backgroundV3": "ヘッダーの背景",
  "shared_productV4": "商品共有",
  "globalV5": "グローバル",
  "nationwideV3": "中国全土",
  "space_sharingV2": "スペースのシェア",
  "follow_space": "スペースをフォロー",
  "up_to_500_items_per_inquiry": "1回の見積依頼は500点までです",
  "enter_your_phone_number_or_email": "携帯電話番号またはメールアドレスを入力してください",
  "shared_productV5": "商品共有",
  "overseas_version_product_sharing": "海外版製品のシェア",
  "shares": "シェア履歴",
  "titleV4": "タイトル",
  "descriptionV2": "説明",
  "duration": "継続時間",
  "value_minutes_value_seconds": "{{value}}分{{value}}秒",
  "value_minutes": "{{value}}分",
  "value_minutes_value_secondsV2": "{{value}}分{{value}}秒",
  "value_hours_value_minutes_value_seconds": "{{value}}時間{{value}}分{{value}}秒",
  "value_days_value_hours_value_minutes_value_seconds": "{{value}}日{{value}}時間{{value}}分{{value}}秒",
  "share_title": "シェアタイトル",
  "share_link": "シェアリンク",
  "usage_limit": "回数制限",
  "share_type": "シェアタイプ",
  "shared_productV6": "商品共有",
  "space_sharingV3": "スペースのシェア",
  "mini_program_space_sharing": "ミニプログラムのスペースシェア",
  "introduction_sharing": "紹介のシェア",
  "time_spent": "滞在時間",
  "dwell_time_is_tracked_only_for_work_shares_and_product_shares_data_refreshes_every_15_minutes": "滞在時間は作品シェアと製品シェアのみ集計し、データは15分ごとに更新されます。",
  "reads": "閲覧回数",
  "content_list": "コンテンツリスト",
  "are_you_sure_you_want_to_delete_this_record": "このレコードを削除してもよろしいですか？",
  "search_keywords": "検索キーワード",
  "total_value_itemsV9": "全{{value}}件",
  "number_of_shares": "シェア回数",
  "content_listV2": "コンテンツリスト",
  "view_count_statistics": "閲覧回数の統計",
  "dwell_time_statistics": "滞在時間の統計",
  "finished_productV7": "完成品",
  "update_failedV2": "更新に失敗しました",
  "update_to_this_version": "このバージョンに更新しますか？",
  "already_up_to_date": "すでに最新バージョンです",
  "stack_bond": "通し目地張り",
  "straight_lay": "直張り",
  "herringbone_paving": "ヘリンボーン張り",
  "herringbone": "ヘリンボーン張り",
  "staggered": "馬張り",
  "brick_bond": "レンガ張り",
  "bevel": "ベベル",
  "corner": "コーナー",
  "center": "中央",
  "gap_depth_lower_limit": "ギャップ深さの下限値",
  "value_must_be_an_integer_greater_than_or_equal_to_0": "0以上の整数を入力してください",
  "value_must_be_a_positive_integer": "正の整数を入力してください",
  "gap_depth": "ギャップ深さ",
  "the_left_value_of_brick_thickness_must_be_less_than_or_equal_to_the_right_value": "レンガの厚さの左側の値は右側の値以下でなければなりません",
  "paving_style": "張り方パターン",
  "row_offset": "行オフセット",
  "brick_length": "レンガの長さ",
  "brick_width": "レンガの幅",
  "fixed_thickness": "一定の厚さ",
  "brick_joint_width": "レンガの目地幅",
  "gap_width": "ギャップ幅",
  "add_chamfer": "面取りを追加",
  "chamfer_size": "面取りサイズ",
  "starting_point": "開始点",
  "degree": "度",
  "rotation_angle": "回転角度",
  "starting_point_0_degree_offset": "開始点0度オフセット",
  "starting_point_90_degree_offset": "開始点90度オフセット",
  "processingV3": "処理中…",
  "start_processing": "処理開始",
  "stop_processing": "処理停止",
  "specification_valueV3": "仕様{{value}}",
  "no_textures_match_the_current_filter": "条件に一致するテクスチャがありません。",
  "you_do_not_have_permission_to_access_this_team_s_library_request_permission_from_an_administrator_and_try_again": "このチームの資料ライブラリにアクセスする権限がありません。管理者に権限を申請してから、もう一度お試しください。",
  "the_product_library_is_disabled_for_this_team": "このチームでは製品ライブラリが無効になっています。",
  "the_team_has_been_deactivated": "このチームは停止されています",
  "the_team_has_been_deleted": "チームは削除されました",
  "all_rights_reserved": "無断転載を禁じます",
  "bujue_technology_co_ltd": "Bujue Technology Co., Ltd.",
  "update_to_this_versionV2": "このバージョンに更新しますか？",
  "already_up_to_dateV2": "すでに最新バージョンです",
  "my_participation": "参加中",
  "prepare_documents": "書類を準備",
  "prepare_all_the_required_documents_in_advance_so_you_can_pass_the_review_in_one_go": "事前に必要な書類をすべて準備し、一度で審査を通過することをおすすめします。",
  "business_license_id_card_photo": "営業許可証、身分証明書の写真",
  "apply_to_join": "出店を申請",
  "fill_in_your_onboarding_information_as_prompted_and_upload_the_required_qualifications": "ページの案内に従って出店情報を正しく入力し、関連資格をアップロードしてください。",
  "submit_for_review": "審査に提出",
  "review_takes_up_to_2_business_days_actual_time_may_vary": "審査には2営業日ほどかかります（実際の審査状況によります）。",
  "whether_or_not_your_application_is_approved_we_will_notify_you_of_the_result_by_sms": "審査の合否にかかわらず、審査結果はSMSでお知らせします。",
  "onboarding_complete": "出店完了",
  "you_can_log_in_to_bujue_space_gallery_supplier_platform_to_manage_your_store": "「Bujueスペースギャラリー－サプライヤープラットフォーム」にログインして、店舗を管理できます。",
  "join_now": "今すぐ出店",
  "supplier_onboarding_process": "サプライヤー出店の流れ",
  "loadingV5": "読み込み中",
  "are_you_sure_you_want_to_valueV2": "{{value}}してもよろしいですか？",
  "value_successful": "{{value}}しました",
  "are_you_sure_you_want_to_valueV3": "{{value}}してもよろしいですか？",
  "value_successfulV2": "{{value}}しました",
  "are_you_sure_you_want_to_valueV4": "{{value}}してもよろしいですか？",
  "value_successfulV3": "{{value}}しました",
  "finished_productV8": "完成品",
  "operation_failed_please_try_again_later": "操作に失敗しました。しばらくしてからもう一度お試しください。",
  "brand_categoryV3": "ブランド分類",
  "all_statusesV2": "すべてのステータス",
  "curatedV12": "厳選",
  "unpublish_all_items": "すべて非公開にしますか？",
  "creation_time_status": "作成日時とステータス",
  "ban_publishingV2": "公開禁止",
  "set_recommended_products": "おすすめ商品を設定",
  "confirm_settings": "設定を確定",
  "new_picks": "新着おすすめ",
  "supplier_settings": "サプライヤー設定",
  "qualification_is_deactivated": "資格が停止されました",
  "supplier_closure": "サプライヤーの閉鎖",
  "your_supplier_qualification_has_been_deactivated_due_to_value_and_similar_conduct": "{{value}}などの行為により、サプライヤー資格が停止されました。",
  "this_supplier_has_been_shut_down_for_rule_violations_and_illegal_conduct": "このサプライヤーは規約違反・法令違反により停止されました。",
  "name_cannot_exceed_20_characters": "氏名は20文字以内で入力してください",
  "position_cannot_exceed_20_characters": "役職は20文字以内で入力してください",
  "phone_number_cannot_exceed_50_characters": "電話番号は50文字以内で入力してください",
  "email_cannot_exceed_100_characters": "メールアドレスは100文字以内で入力してください",
  "remarks_cannot_exceed_100_characters": "備考は100文字以内で入力してください",
  "click_to_refresh": "クリックして更新",
  "wechatV4": "WeChat",
  "wechat_pay_has_a_daily_limit_of_cny_10_000": "WeChat Payの1日上限：10,000人民元",
  "chinese_nV3": "中国語N",
  "mini_program_share_image": "ミニプログラム共有画像",
  "recommended_size_40x50_png_image": "推奨サイズ：40×50のPNG画像",
  "private_space_data_is_being_translated_please_do_not_add_new_dataV2": "プライベートスペースのデータを翻訳中です。新しいデータを追加しないでください",
  "open": "開く",
  "offV2": "オフ",
  "value_is_not_an_imageV11": "{{value}}は画像ではありません",
  "value_file_upload_failedV2": "{{value}}のアップロードに失敗しました。",
  "space_logo": "スペースのロゴ",
  "i_have_read_and_agree_to_the_agreement": "規約を読んで同意します",
  "1_exclusive_product_library_create_a_private_space_and_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "1. 専用の製品ライブラリ：プライベートスペースを作成し、個人またはチームの製品ライブラリに製品を追加して、より効率的な集中管理を実現します。",
  "2_creative_board_tool_pull_in_products_and_textures_directly_generate_a_product_list_or_white_paper_with_one_click_and_present_your_proposal_with_ease": "2. クリエイティブボードツール：製品やテクスチャを直接呼び出し、ワンクリックで製品リストやホワイトペーパーを生成して、提案を簡単に提示できます。",
  "3_plug_in_tool_library_works_with_revit_3dmax_rhino_sketchup_and_other_design_software_so_you_can_pull_in_product_models_and_textures_at_any_time_and_improve_design_efficiency": "3. プラグインツールライブラリ：Revit、3DMax、Rhino、SketchUpなどの設計ソフトと連携し、製品モデルやテクスチャをいつでも呼び出せるため、設計効率が向上します。",
  "4_zicai_ocean_publish_products_to_the_public_marketplace_zicai_ocean_with_one_click_to_expand_exposure": "4. 紫菜海洋：ワンクリックで製品をパブリック領域（紫菜海洋）に公開し、露出を拡大できます。",
  "closeV3": "閉じる",
  "create_a_private_space_to_automatically_save_the_product_data_you_add": "プライベートスペースを作成すると、追加した製品データが自動的に保存されます。",
  "design_private_space_service_slogandesign_private_space_service_slogan": "プライベートスペースサービスのスローガンをデザインプライベートスペースサービスのスローガンをデザイン",
  "address_is_required": "住所を入力してください",
  "logoV6": "ロゴ",
  "private_space_product_publish_unpublish_review": "プライベートスペース製品の公開・非公開審査",
  "view_now": "今すぐ見る",
  "you_have_new_review_results_for_your_private_space_products_check_them_now": "プライベートスペース製品の審査結果が届きました。今すぐご確認ください。",
  "enter_your_space_nickname": "スペース内のニックネームを入力してください",
  "application_submittedV2": "申請しました",
  "join_the_private_space": "プライベートスペースに参加",
  "no_signature_yet": "自己紹介文は未設定です",
  "app_not_installed_tap_to_download": "アプリ未インストールです。タップしてダウンロード",
  "a_sharing_platform_that_empowers_designers": "デザイナーを支援する共有プラットフォーム",
  "free_personalized_official_site": "無料でカスタマイズできる公式サイト",
  "efficient_and_fast_customization_platform": "効率的かつ迅速なカスタマイズプラットフォーム",
  "professional_presentation_of_business_negotiations": "プロフェッショナルな商談プレゼンテーション",
  "branding_and_marketing_assistant": "ブランディングおよびマーケティングアシスタント",
  "efficient_professional_portfolio_library": "効率的でプロフェッショナルなポートフォリオライブラリ",
  "photos_videos_and_vr_works_presented_in_multiple_formats": "写真・動画・VR作品をさまざまな形式で表現",
  "share_your_content_with_one_click": "ワンクリックでコンテンツを共有",
  "quickly_share_what_you_need": "必要なコンテンツをすぐに共有",
  "share_your_portfolio_freely": "ポートフォリオを自由に共有",
  "open_bujue": "Bujueを開く",
  "download_bujue": "Bujueをダウンロード",
  "open_this_page_in_a_browser": "ブラウザを使用して開いてください",
  "enter_your_space_nicknameV2": "スペース内のニックネームを入力してください",
  "application_submittedV3": "申請しました",
  "you_are_already_a_member_of_this_private_space": "すでにこのプライベートスペースのメンバーです",
  "the_application_has_been_sent_and_is_waiting_for_review": "申請を送信しました。審査をお待ちください。",
  "no_signature_yetV2": "自己紹介文は未設定です",
  "this_content_is_private_you_can_view_it_after_joining_the_private_space": "内容は非公開です。スペースに参加してからご覧ください。",
  "nickname_in_private_space": "スペース内のニックネーム",
  "application_submittedV4": "申請しました",
  "search_design_spaces": "デザインスペースを検索",
  "joinedV3": "参加済み",
  "applied": "申請済み",
  "join_nowV2": "今すぐ参加",
  "fully_openV3": "フルオープン",
  "anyone_can_joinV2": "誰でも参加可能",
  "semi_openV3": "セミオープン",
  "closedV4": "クローズド",
  "invitation_onlyV2": "招待制",
  "access_settingsV2": "公開範囲設定",
  "member_joiningV2": "メンバーの参加",
  "visitor_browsingV2": "訪問者の閲覧",
  "get_the_verification_codeV3": "認証コードを取得してください",
  "enter_new_phone_numberV2": "新しい携帯電話番号を入力してください",
  "enter_new_emailV2": "新しいメールアドレスを入力してください",
  "the_new_phone_number_is_the_same_as_the_old_phone_numberV2": "新しい携帯電話番号が現在の携帯電話番号と同じです",
  "failed_to_get_verification_code_try_againV8": "認証コードの取得に失敗しました。再度取得してください",
  "delete_this_space": "このスペースを削除しますか？",
  "select_a_recipient": "受信者を選択してください",
  "select_a_member_to_transfer_to": "移管先のメンバーを選択してください",
  "this_user_already_owns_the_maximum_number_of_private_spaces_so_the_transfer_cannot_be_completed": "このユーザーが所有するプライベートスペースの数が上限に達しているため、移管できません",
  "delete_space": "スペースを削除",
  "identity_verificationV3": "本人確認",
  "verifyV3": "確認",
  "enter_verification_codeV7": "認証コードを入力してください",
  "transfer_administrator_rights": "管理者権限を移管",
  "confirm_transfer": "移管を確定",
  "search_people": "メンバーを検索",
  "enter_username_or_password": "ユーザー名またはパスワードを入力してください",
  "enter_confirmation_password": "確認用のパスワードを入力してください",
  "set_login_password": "ログインパスワードを設定",
  "enter_username": "ユーザー名を入力してください",
  "enter_passwordV2": "パスワードを入力してください",
  "enter_password_again": "パスワードをもう一度入力してください",
  "permission_settings": "権限設定",
  "team_store_published_content_statistics": "チームストア公開コンテンツ統計",
  "team_store_unpublished_content_statistics": "チームストア非公開コンテンツ統計",
  "team_store_publish_rejection_statistics": "チームストア公開差し戻し統計",
  "team_store_publish_success_statistics": "チームストア公開成功統計",
  "service_area_value": "サービスエリア：{{value}}",
  "globalV6": "グローバル",
  "private_space_status_is_normal": "ステータス：正常",
  "this_private_space_has_been_deleted": "プライベートスペースは削除済みです",
  "space_deleted": "スペースが削除されました",
  "space_disabledV2": "スペースは無効です",
  "space_disabledV3": "スペースは無効です",
  "all_brands": "すべてのブランド",
  "search_brands": "ブランドを検索",
  "no_brand_data_yet": "ブランドデータはまだありません",
  "brand_supplier_list": "ブランドサプライヤー一覧",
  "sign_contract": "契約締結",
  "contract_expired": "契約期限切れ",
  "you_can_upload_up_to_value_itemsV2": "最大{{value}}件までアップロードできます",
  "device_libraryV3": "機器ライブラリ",
  "material_libraryV4": "マテリアルライブラリ",
  "hd_assetsV5": "高解像度素材",
  "warningV2": "警告",
  "materialV13": "マテリアル",
  "equipmentV5": "設備",
  "finished_productV9": "完成品",
  "info": "情報",
  "member": "会員",
  "security_settingsV3": "セキュリティ設定",
  "billing": "請求",
  "finished_productV10": "完成品",
  "this_product_has_already_been_addedV2": "この製品は追加済みです",
  "product_list_fixed_price": "商品一覧の固定価格",
  "product_list_price_range": "商品一覧の価格帯",
  "unknown_categoryV2": "不明なカテゴリ",
  "titleV5": "タイトル：",
  "link": "リンク：",
  "no_download_link_yet": "ダウンロードリンクはまだありません",
  "the_value_plugin_lets_you_use_textures_and_models_from_your_private_space_product_library_directlyV2": "{{value}}プラグインで、プライベートスペースの製品ライブラリのテクスチャとモデルを直接利用できます",
  "stay_tunedV2": "近日公開",
  "invitee": "被招待者",
  "onboarding_dateV2": "出店日",
  "download_poster": "ポスターをダウンロード",
  "brand_categoryV4": "ブランド分類",
  "personal_information": "個人情報",
  "bioV2": "自己紹介",
  "add_a_personalized_signature": "自己紹介を追加…",
  "brand_categoryV5": "ブランド分類",
  "my_materials": "マイマテリアル",
  "enter_material_name_color_nameV2": "マテリアル名／カラー名を入力してください",
  "use_casesV7": "活用シーン",
  "airportV6": "空港",
  "railway_stationV6": "鉄道駅",
  "shopping_mall_supermarketV6": "ショッピングモール・スーパーマーケット",
  "plazaV6": "広場",
  "hotelV6": "ホテル",
  "museum_exhibition_hallV6": "博物館・展示ホール",
  "theater_ktvV6": "劇場・カラオケ",
  "office_buildingV6": "オフィスビル",
  "schoolV6": "学校",
  "hospitalV6": "病院",
  "restaurantV6": "レストラン",
  "house_villaV6": "住宅・別荘",
  "poolV6": "プール",
  "sports_fieldV6": "グラウンド",
  "within_one_yearV7": "1年以内",
  "more_than_one_yearV7": "1年以上",
  "material_originV4": "マテリアルの産地",
  "reference_priceV16": "参考価格",
  "set_to_public": "公開に設定しました",
  "reason_for_unpublishingV4": "非公開の理由：",
  "privateV6": "非公開",
  "material_added": "マテリアルを追加しました",
  "different_categories_cannot_be_comparedV3": "異なるカテゴリは比較できません",
  "unlikeV3": "いいね解除",
  "brand_categoryV6": "ブランド分類",
  "disabledV5": "無効",
  "view_reason": "理由を確認",
  "enter_private_spaceV3": "プライベートスペースへ",
  "user_agreement_to_be_added": "利用規約（追加予定）",
  "modern_minimalist_style": "モダンミニマルスタイル",
  "classical_style": "クラシックスタイル",
  "art_deco_style_shanghai_style": "アールデコスタイル／上海スタイル",
  "industrial_style_urban_style": "インダストリアルスタイル／アーバンスタイル",
  "country_style_pastoral_style": "カントリースタイル／田園スタイル",
  "chinese_style": "中国風スタイル",
  "mediterranean_style": "地中海スタイル",
  "southeast_asian_style": "東南アジアスタイル",
  "wabi_sabi_style": "侘び寂びスタイル",
  "japanese_style": "和風スタイル",
  "draftV5": "下書き",
  "unpublishedV3": "非公開",
  "privateV7": "非公開",
  "material_listV3": "マテリアルリスト",
  "no_description_yet": "まだ説明がありません",
  "renderings_photos": "パース／実例写真",
  "main_material_list": "主要マテリアル一覧",
  "no_materials_addedV2": "マテリアルが追加されていません",
  "export_material_list": "マテリアルリストをエクスポート",
  "select_export_template": "エクスポートテンプレートを選択",
  "default_template": "既定のテンプレート",
  "export_nodes_simultaneously": "ノードを同時にエクスポート",
  "export_asset_textures_simultaneously": "素材テクスチャを同時にエクスポート",
  "select_export_templateV2": "エクスポートテンプレートを選択してください",
  "exportV5": "エクスポート",
  "exportingV2": "エクスポート中…",
  "envelope_s": "通",
  "surface": "面",
  "video_optimization_pending": "動画の最適化待ち",
  "optimizing_video": "動画を最適化中",
  "annotation_points_overlap": "注釈ポイントが重なっています",
  "save_the_previous_annotation_first": "前の注釈を保存してください",
  "select_valueV3": "{{value}}を選択してください",
  "chinese_nV4": "中国語N",
  "value_m": "{{value}}㎡",
  "value_present": "{{value}}〜現在",
  "summary": "まとめ",
  "this_is_sample_text": "これはサンプルテキストです",
  "drag_to_reorderV2": "ドラッグして並べ替え",
  "merge_into": "」を「",
  "confirm": "「",
  "merge_successful": "マージしました",
  "merge_failed": "マージに失敗しました",
  "drag_here_to_merge_categories": "ここにドラッグしてカテゴリをマージ",
  "value_file_upload_failedV3": "{{value}}のアップロードに失敗しました。",
  "logoV7": "ロゴ",
  "value_file_upload_failedV4": "{{value}}のアップロードに失敗しました。",
  "video": "動画",
  "cover_cannot_be_reordered": "カバーは並べ替えできません",
  "cloud_drive_is_fullV2": "クラウドストレージの容量が上限に達しました",
  "some_files_exceed_the_available_cloud_drive_spaceV2": "一部のファイルがクラウドストレージの空き容量を超えています",
  "duplicate_style_name_merge": "同名のスタイルがあります。マージしますか？",
  "duplicate_type_name_merge": "同名のタイプがあります。マージしますか？",
  "no_url": "URLがありません",
  "enter_node_nameV2": "ノード名を入力してください",
  "nodeV5": "ノード",
  "node_name_is_requiredV3": "ノード名は必須です",
  "node_nameV3": "ノード名",
  "upload_schematic_diagramV2": "模式図をアップロードしてください",
  "schematic_diagramV3": "模式図",
  "applicable_materials_are_requiredV4": "適用マテリアルは必須です",
  "applicable_materialsV3": "適用マテリアル",
  "drawingsV3": "図面",
  "draftV6": "下書き",
  "reject_applicationV3": "申請差し戻し",
  "unpublishedV4": "非公開",
  "all_styles": "すべてのスタイル",
  "modern_minimalist_styleV2": "モダンミニマルスタイル",
  "classical_styleV2": "クラシックスタイル",
  "art_deco_style_shanghai_styleV2": "アールデコスタイル／上海スタイル",
  "industrial_style_urban_styleV2": "インダストリアルスタイル／アーバンスタイル",
  "country_style_pastoral_styleV2": "カントリースタイル／田園スタイル",
  "chinese_styleV2": "中国風スタイル",
  "mediterranean_styleV2": "地中海スタイル",
  "southeast_asian_styleV2": "東南アジアスタイル",
  "wabi_sabi_styleV2": "侘び寂びスタイル",
  "japanese_styleV2": "和風スタイル",
  "value_reason": "{{value}}理由",
  "value_reason_value": "{{value}}理由：{{value}}",
  "delete_this_work": "この作品を削除しますか？",
  "search_my_work": "私の作品を検索",
  "work_style": "作品のスタイル",
  "scan_the_qr_code_with_wechat_to_open": "WeChatでQRコードをスキャンしてください",
  "click_to_learn_more": "クリックして詳細を確認",
  "click_to_learn_moreV2": "クリックして詳細を確認",
  "unpublishedV5": "非公開",
  "overview": "概要",
  "attributesV4": "特性",
  "experienceV2": "経験",
  "inspection_certificateV2": "検査証明書",
  "usage_scenarios": "使用シーン",
  "styling_suggestions": "コーディネート提案",
  "nodeV6": "ノード",
  "packaging_information": "梱包情報",
  "accessories": "付属品",
  "detailed_design_serviceV2": "詳細設計代行",
  "regular_customer": "一般のお客様",
  "officialV3": "公式",
  "indoorV3": "屋内",
  "outdoorV3": "屋外",
  "semi_outdoor_spaceV3": "半屋外空間",
  "basementV3": "地下室",
  "roofV3": "屋根",
  "exterior_wallV3": "外壁",
  "courtyardV3": "中庭",
  "airportV7": "空港",
  "railway_stationV7": "鉄道駅",
  "shopping_mall_supermarketV7": "ショッピングモール・スーパーマーケット",
  "plazaV7": "広場",
  "hotelV7": "ホテル",
  "museum_exhibition_hallV7": "博物館・展示ホール",
  "theater_ktvV7": "劇場・カラオケ",
  "office_buildingV7": "オフィスビル",
  "schoolV7": "学校",
  "hospitalV7": "病院",
  "restaurantV7": "レストラン",
  "house_villaV7": "住宅・別荘",
  "poolV7": "プール",
  "sports_fieldV7": "グラウンド",
  "draftV7": "下書き",
  "publication_under_review": "公開審査中",
  "sensitive_words": "NGワード",
  "completeness": "完全性",
  "reject": "差し戻し",
  "not_curatedV2": "未厳選",
  "sensitive_content_review": "センシティブ審査",
  "not_approvedV3": "未承認",
  "sensitive_content_review_passed": "センシティブ審査に合格しました",
  "completeness_review_passed": "完全性審査に合格しました",
  "completeness_review_failed": "完全性審査に不合格でした",
  "main_image": "メイン画像",
  "related_worksV3": "関連作品",
  "materialV14": "マテリアル",
  "equipmentV6": "設備",
  "finished_productV11": "完成品",
  "material_libraryV5": "マテリアルライブラリ",
  "device_libraryV4": "機器ライブラリ",
  "finished_product_libraryV2": "完成品ライブラリ",
  "activeV6": "有効",
  "terminatedV2": "終了",
  "about_page": "紹介ページ",
  "works_libraryV2": "作品ライブラリ",
  "team_supplier": "チームサプライヤー",
  "not_signed": "未契約",
  "sign_contractV2": "契約締結",
  "partnership_expired": "提携期限切れ",
  "slice": "枚",
  "bottle": "本",
  "case": "箱",
  "box": "箱",
  "bundle": "束",
  "package": "袋",
  "barrel": "樽",
  "pallet": "パレット",
  "roll": "巻",
  "m²": "平方メートル",
  "l": "リットル",
  "kg": "キログラム",
  "t": "トン",
  "upload_up_to": "一度にアップロードできるのは最大",
  "size_exceeds_the_limit_width_height_must_be_15000_pixels_or_less": "サイズが制限を超えています（幅・高さは15000ピクセル以下）",
  "beijingV2": "北京",
  "tianjinV2": "天津",
  "shanghaiV2": "上海",
  "chongqingV2": "重慶",
  "hebei": "河北",
  "shanxi": "山西",
  "liaoning": "遼寧",
  "jilin": "吉林",
  "heilongjiang": "黒竜江",
  "jiangsu": "江蘇",
  "zhejiangV2": "浙江省",
  "anhui": "安徽",
  "fujian": "福建",
  "jiangxi": "江西",
  "shandong": "山東",
  "henan": "河南",
  "hubei": "湖北",
  "hunan": "湖南",
  "guangdong": "広東",
  "guangxi": "広西",
  "hainan": "海南",
  "sichuan": "四川",
  "guizhou": "貴州",
  "yunnan": "雲南",
  "tibet": "チベット",
  "shaanxi": "陝西",
  "gansu": "甘粛",
  "qinghai": "青海",
  "ningxia": "寧夏",
  "inner_mongolia": "内モンゴル",
  "inner_mongoliaV2": "内モンゴル",
  "xinjiang": "新疆",
  "taiwan": "台湾",
  "hong_kong": "香港",
  "macau": "マカオ",
  "aba": "阿壩",
  "aksu": "アクス",
  "altay": "アルタイ",
  "ngari": "アリ",
  "anqing": "安慶",
  "anshan": "鞍山",
  "anshun": "安順",
  "anyang": "安陽",
  "baicheng": "白城",
  "baise": "百色",
  "baishan": "白山",
  "baiyin": "白銀",
  "bengbu": "蚌埠",
  "baoding": "保定",
  "baoji": "宝鶏",
  "baoshan": "保山",
  "baotou": "包頭",
  "bayannur": "バヤンヌール",
  "bayingolin": "バインゴリン",
  "benxi": "本渓",
  "bijie": "畢節",
  "binzhou": "浜州",
  "bortala": "ボルタラ",
  "bozhou": "亳州",
  "cangzhou": "滄州",
  "changchun": "長春",
  "changde": "常徳",
  "changji": "昌吉",
  "changshaV2": "長沙",
  "changzhou": "常州",
  "chaohu": "巣湖",
  "chaoyang": "朝陽",
  "chaozhou": "潮州",
  "chengde": "承徳",
  "chengduV2": "成都",
  "chenzhou": "郴州",
  "chifeng": "赤峰",
  "chizhou": "池州",
  "chongzuo": "崇左",
  "chuzhou": "滁州",
  "dali": "大理",
  "dalian": "大連",
  "dandong": "丹東",
  "daqing": "大慶",
  "datong": "大同",
  "daxing_anling": "大興安嶺",
  "dazhou": "達州",
  "dehong": "徳宏",
  "deyang": "徳陽",
  "dezhou": "徳州",
  "dingxi": "定西",
  "dongguanV2": "東莞",
  "dongying": "東営",
  "ezhou": "鄂州",
  "enshi": "恩施",
  "ordos": "オルドス",
  "foshan": "仏山",
  "fushun": "撫順",
  "fuxin": "阜新",
  "fuyang": "阜陽",
  "fuzhou": "福州",
  "gannan": "甘南",
  "ganzhou": "贛州",
  "guang_an": "広安",
  "guangyuan": "広元",
  "guangzhouV2": "広州",
  "guigang": "貴港",
  "guilin": "桂林",
  "guiyang": "貴陽",
  "guyuan": "固原",
  "harbin": "ハルビン",
  "haibei": "海北",
  "haidong": "海東",
  "haikou": "海口",
  "haixi": "海西",
  "hami": "ハミ",
  "handan": "邯鄲",
  "hangzhouV3": "杭州",
  "hanzhong": "漢中",
  "hebi": "鶴壁",
  "hechi": "河池",
  "hefei": "合肥",
  "hegang": "鶴崗",
  "heihe": "黒河",
  "hengshui": "衡水",
  "hengyang": "衡陽",
  "hotan": "ホータン",
  "heyuan": "河源",
  "heze": "菏沢",
  "hezhou": "賀州",
  "honghe": "紅河",
  "huai_an": "淮安",
  "huaibei": "淮北",
  "huaihua": "懐化",
  "huainan": "淮南",
  "huanggang": "黄岡",
  "huangnan": "黄南",
  "huangshan": "黄山",
  "huangshi": "黄石",
  "hohhot": "フフホト",
  "huizhou": "恵州",
  "hulunbuir": "フルンボイル",
  "huzhou": "湖州",
  "jiamusi": "ジャムス",
  "ji_an": "吉安",
  "jiangmen": "江門",
  "jiaozuo": "焦作",
  "jiaxing": "嘉興",
  "jiayuguan": "嘉峪関",
  "jieyang": "掲陽",
  "jinan": "済南",
  "jinchang": "金昌",
  "jincheng": "晋城",
  "jingdezhen": "景徳鎮",
  "jingmen": "荊門",
  "jingzhou": "荊州",
  "jinhua": "金華",
  "jining": "済寧",
  "jinzhong": "晋中",
  "jinzhou": "錦州",
  "jiujiang": "九江",
  "jiuquan": "酒泉",
  "jixi": "鶏西",
  "kaifeng": "開封",
  "kashgar": "カシュガル",
  "karamay": "カラマイ",
  "kizilsu": "キジルス",
  "kunming": "昆明",
  "laibin": "来賓",
  "laiwu": "莱蕪",
  "langfang": "廊坊",
  "lanzhou": "蘭州",
  "lhasa": "ラサ",
  "leshan": "楽山",
  "liangshan": "涼山",
  "lianyungang": "連雲港",
  "liaocheng": "聊城",
  "liaoyang": "遼陽",
  "liaoyuan": "遼源",
  "lijiang": "麗江",
  "lincang": "臨滄",
  "linfen": "臨汾",
  "linxia": "臨夏",
  "linyi": "臨沂",
  "nyingchi": "林芝",
  "lishui": "麗水",
  "liuzhou": "柳州",
  "longnan": "隴南",
  "longyan": "龍岩",
  "loudi": "婁底",
  "luohe": "漯河",
  "luoyang": "洛陽",
  "luzhou": "瀘州",
  "l_liang": "呂梁",
  "ma_anshan": "馬鞍山",
  "maoming": "茂名",
  "meishan": "眉山",
  "meizhou": "梅州",
  "mianyang": "綿陽",
  "mudanjiang": "牡丹江",
  "nanchang": "南昌",
  "nanchong": "南充",
  "nanjingV2": "南京",
  "nanning": "南寧",
  "nanping": "南平",
  "nanyang": "南陽",
  "nagqu": "ナクチュ",
  "neijiang": "内江",
  "ningboV2": "寧波",
  "ningde": "寧徳",
  "nujiang": "怒江",
  "panjin": "盤錦",
  "panzhihua": "攀枝花",
  "pingdingshan": "平頂山",
  "pingliang": "平涼",
  "pingxiang": "萍郷",
  "putian": "莆田",
  "puyang": "濮陽",
  "qiandongnan": "黔東南",
  "qiannan": "黔南",
  "qianxinan": "黔西南",
  "qingdaoV2": "青島",
  "qingyang": "慶陽",
  "qingyuan": "清遠",
  "qinhuangdao": "秦皇島",
  "qinzhou": "欽州",
  "qiqihar": "チチハル",
  "qitaihe": "七台河",
  "quanzhou": "泉州",
  "qujing": "曲靖",
  "quzhou": "衢州",
  "shigatse": "シガツェ",
  "rizhao": "日照",
  "sanmenxia": "三門峡",
  "sanming": "三明",
  "sanya": "三亜",
  "shangluo": "商洛",
  "shangqiu": "商丘",
  "shangrao": "上饒",
  "shannan": "山南",
  "shantou": "汕頭",
  "shanwei": "汕尾",
  "shaoguan": "韶関",
  "shaoxing": "紹興",
  "shaoyang": "邵陽",
  "shennongjia": "神農架",
  "shenyangV2": "瀋陽",
  "shenzhenV2": "深セン",
  "shijiazhuang": "石家荘",
  "shiyan": "十堰",
  "shizuishan": "石嘴山",
  "shuangyashan": "双鴨山",
  "shuozhou": "朔州",
  "siping": "四平",
  "songyuan": "松原",
  "suihua": "綏化",
  "suining": "遂寧",
  "suizhou": "随州",
  "suqian": "宿遷",
  "suzhouV2": "蘇州",
  "tacheng": "塔城",
  "tai_an": "泰安",
  "taiyuan": "太原",
  "taizhou": "泰州",
  "tangshan": "唐山",
  "tianshui": "天水",
  "tieling": "鉄嶺",
  "tongchuan": "銅川",
  "tonghua": "通化",
  "tongliao": "通遼",
  "tongling": "銅陵",
  "tongren": "銅仁",
  "turpan": "トルファン",
  "weifang": "濰坊",
  "weihai": "威海",
  "weinan": "渭南",
  "wenshan": "文山",
  "wenzhou": "温州",
  "wuhai": "烏海",
  "wuhanV2": "武漢",
  "wuhu": "蕪湖",
  "ulanqab": "ウランチャブ",
  "urumqi": "ウルムチ",
  "wuwei": "武威",
  "wuxiV2": "無錫",
  "wuzhong": "呉忠",
  "wuzhou": "梧州",
  "xiamen": "アモイ",
  "xi_anV2": "西安",
  "xiangtan": "湘潭",
  "xiangxi": "湘西",
  "xianning": "咸寧",
  "xianyang": "咸陽",
  "xiaogan": "孝感",
  "xilingol": "シリンゴル",
  "xing_an": "興安",
  "xingtai": "邢台",
  "xining": "西寧",
  "xinxiang": "新郷",
  "xinyang": "信陽",
  "xinyu": "新余",
  "xinzhou": "忻州",
  "xishuangbanna": "西双版納",
  "xuancheng": "宣城",
  "xuchang": "許昌",
  "xuzhou": "徐州",
  "ya_an": "雅安",
  "yan_an": "延安",
  "yanbian": "延辺",
  "yancheng": "塩城",
  "yangjiang": "陽江",
  "yangquan": "陽泉",
  "yangzhou": "揚州",
  "yantai": "煙台",
  "yibin": "宜賓",
  "yichang": "宜昌",
  "yichun": "宜春",
  "ili_kazakh": "イリ・カザフ",
  "yinchuan": "銀川",
  "yingkou": "営口",
  "yingtan": "鷹潭",
  "yiyang": "益陽",
  "yongzhou": "永州",
  "yueyang": "岳陽",
  "yulin": "玉林",
  "yulinV2": "楡林",
  "yuncheng": "運城",
  "yunfu": "雲浮",
  "yunlin": "雲林",
  "yuxi": "玉渓",
  "zaozhuang": "棗荘",
  "zhangjiajie": "張家界",
  "zhangjiakou": "張家口",
  "zhangye": "張掖",
  "zhangzhou": "漳州",
  "zhanjiang": "湛江",
  "zhaoqing": "肇慶",
  "zhaotong": "昭通",
  "zhengzhou": "鄭州",
  "zhenjiang": "鎮江",
  "zhongshan": "中山",
  "zhongwei": "中衛",
  "zhoukou": "周口",
  "zhoushan": "舟山",
  "zhuhai": "珠海",
  "zhuzhou": "株洲",
  "zibo": "淄博",
  "zigong": "自貢",
  "ziyang": "資陽",
  "zunyi": "遵義",
  "japaneseV2": "日本語",
  "wechatV5": "WeChat",
  "unknown_device": "不明なデバイス",
  "only_image_files_are_allowed": "画像ファイルのみアップロードできます。",
  "product_textureV3": "製品テクスチャ",
  "commissioned_assets": "委託素材",
  "insufficient_capacity": "容量不足",
  "your_cloud_storage_is_running_low_to_avoid_interruptions_we_recommend_upgrading_your_capacity_as_soon_as_possible": "クラウドストレージの容量が不足しています。通常のご利用への影響を避けるため、早めに容量のアップグレードをお勧めします。",
  "expand_capacity": "容量を拡張",
  "for_proper_display_the_long_edge_must_be_at_least_value_we_recommend_uploading_images_of_value_value_or_larger": "表示品質を保つため、画像の長辺は{{value}}以上にしてください。{{value}}*{{value}}以上の画像のアップロードをお勧めします。",
  "for_better_display_quality_upload_images_of_value_value_or_larger": "表示品質を高めるため、{{value}}*{{value}}以上の画像のアップロードをお勧めします。",
  "exit_failed_use_f11_to_exit_full_screen": "終了に失敗しました。F11キーで全画面表示を解除してください。",
  "network_busy_try_again_later": "通信が混雑しています。時間をおいて再試行してください。",
  "the_user_is_currently_in_the_queue": "このユーザーは現在順番待ちです。",
  "the_image_does_not_exist": "画像が存在しません。",
  "the_image_size_or_resolution_does_not_meet_the_requirements": "画像のサイズまたは解像度が要件を満たしていません。",
  "you_have_already_added_this_product_to_favorites_do_not_add_it_again": "この製品はすでにお気に入りに追加されています。重複して追加しないでください。",
  "the_current_product_type_does_not_match_the_products_in_the_pk_list": "現在の製品タイプはPKリスト内の製品タイプと一致しません。",
  "this_brand_name_already_exists": "このブランド名はすでに存在します。",
  "an_error_occurred_while_deleting_the_supplier_associated_with_the_team_brand_brandid_id": "チームブランドに関連付けられたサプライヤーの削除中にエラーが発生しました。brandId:{{id}}",
  "an_error_occurred_while_deleting_the_product_associated_with_the_team_brand_brandid_id": "チームブランドに関連付けられた製品の削除中にエラーが発生しました。brandId:{{id}}",
  "the_token_is_invalid": "トークンが無効です。",
  "alipay_payment_error_error": "Alipay決済エラー：{{error}}",
  "token_expired": "トークンの期限切れ",
  "the_user_is_not_logged_in": "ユーザーはログインしていません。",
  "this_supplier_name_already_exists": "このサプライヤー名はすでに存在します。",
  "the_deadline_cannot_be_earlier_than_today": "期限は本日より前に設定できません。",
  "associated_brands_exist_remove_the_associations_first": "関連付けられたブランドがあります。先に関連付けを解除してください。",
  "id_is_required": "IDは必須です",
  "parameters_are_required": "パラメータは必須です",
  "log_in_to_download": "ログインしてからダウンロードしてください。",
  "the_file_does_not_exist": "ファイルが存在しません。",
  "log_in_to_preview": "ログインしてからプレビューしてください。",
  "missing_parameters": "必要なパラメータが不足しています。",
  "the_token_is_invalidV2": "トークンが無効です。",
  "user_information_is_required": "ユーザー情報は必須です",
  "system_busy_try_again_later": "システムが混雑しています。時間をおいて再試行してください。",
  "complete_security_verification": "セキュリティ認証を完了してください。",
  "general_notice": "お知らせ",
  "general_notice_we_have_launched_the_featurename_feature": "お知らせ：{{featureName}}機能をリリースしました。",
  "in_my_space_you_can_view_your_share_history_following_and_spaces": "マイスペースでは、シェア履歴、フォロー、スペースを確認できます。",
  "the_current_account_does_not_have_a_space_yet": "現在のアカウントにはスペースがありません。",
  "create_a_space_first_to_unlock_a_new_product_management_experience": "まずスペースを作成して、新しい製品管理を始めましょう。",
  "click_create_below_to_finish_creating_your_space_and_access_the_following_resources": "下の「作成」をクリックしてスペースを作成すると、以下のリソースを利用できます。",
  "exclusive_product_library_create_a_space_to_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "専用製品ライブラリ：スペースを作成すると、製品を個人またはチームの製品ライブラリに登録し、効率よく一元管理できます。",
  "space_logoV2": "スペースロゴ",
  "name_is_requiredV7": "名前は必須です",
  "i_have_read_and_agree_to_the_bujue_space_service_agreement": "「Bujueスペースサービス利用規約」を読み、同意します。",
  "thank_you_for_choosing_our_product_you_now_receive_capacity_mb_of_permanently_free_storage_effective_immediately_enjoy": "当社製品をご利用いただきありがとうございます。{{capacity}} MBの永久無料ストレージをプレゼントします。今すぐご利用いただけます！",
  "english_and_japanese_language_packs_have_been_activated_for": "{私域名称}で英語・日本語の言語パックが有効になりました。",
  "go_to_basic_info_settings": "基本情報の設定に移動してください。",
  "the_introduction_uses_the_same_configuration_across_all_languages": "紹介はすべての言語で共通の設定を使用します。",
  "scan_and_share_qr_code": "QRコードをスキャン・シェア",
  "share_language": "シェア時の言語",
  "you_can_also_copy_the_link_and_send_it_to_your_friends": "リンクをコピーして友達に送ることもできます。",
  "one_click_download_batch_download_chinese_source_text_to_be_confirmed": "ワンクリックダウンロード／一括ダウンロード（中国語の原文要確認）",
  "key_vault": "キーボックス",
  "product_asset_library": "製品素材",
  "reviews": "レビュー",
  "space_id": "スペースID",
  "panbagua": "盤八卦",
  "bujue_app": "Bujueアプリ",
  "cny": "￥{价格}CNY",
  "bioV3": "自己紹介：",
  "add_a_bio": "自己紹介を追加…",
  "spaces_i_manage": "管理しているプライベートスペース",
  "spaces_i_ve_joined": "参加しているプライベートスペース",
  "third_party_accounts": "外部アカウント",
  "to_keep_your_account_secure_please_verify_your_identity_you_can_continue_once_verification_succeeds": "アカウントの安全のため、本人確認を行ってください。確認が完了すると次の操作に進めます。",
  "use_phone_number": "携帯電話番号を使用",
  "use_email": "メールアドレスを使用",
  "enter_the_email_address_you_want_to_link": "連携するメールアドレスを入力してください",
  "enter_the_phone_number_you_want_to_link": "連携する携帯電話番号を入力してください",
  "you_are_not_logged_inV2": "ログインしていません",
  "failed_to_get_the_verification_code_please_try_again": "認証コードを取得できませんでした。もう一度お試しください。",
  "waiting_for_administrator_review": "管理者の承認待ち",
  "entering_the_private_space_in_count_s": "{{count}}秒後に自動的にプライベートスペースへ移動します",
  "open_the_app": "アプリを開く",
  "keep_both": "両方保持",
  "replace": "置き換え",
  "create_folder": "フォルダーを作成",
  "only_images_can_be_uploaded_to_the_product_asset_libraryV2": "製品素材ライブラリには画像のみアップロードできます",
  "file_names_cannot_contain_the_following_charactersV4": "ファイル名に次の文字は使用できません：",
  "this_file_cannot_be_previewed_online_download_it_to_view": "このファイルはオンラインプレビューに対応していません。ダウンロードして確認しますか？",
  "texture_library_folders_cannot_be_moved_in_or_outV2": "テクスチャライブラリフォルダーは内外に移動できません",
  "files_can_only_be_moved_into_product_asset_library_folders": "ファイルは製品素材ライブラリフォルダーにのみ移動できます。",
  "texture_library_folders_cannot_be_moved_outV2": "テクスチャライブラリフォルダーは外側に移動できません",
  "folders_other_than_texture_library_folders_cannot_be_moved_inV2": "テクスチャライブラリ以外のフォルダーは内側に移動できません",
  "cannot_move_to_the_name_folder": "{{name}}フォルダーには移動できません",
  "the_name_library_cannot_be_renamed_moved_or_deleted_and_no_files_or_folders_can_be_added_to_it": "{{name}}ライブラリは名前の変更・移動・削除ができず、ファイルやフォルダーも追加できません",
  "name_cannot_be_renamed_moved_or_deleted": "{{name}}は名前の変更・移動・削除ができません",
  "count_items_in_total": "全{{count}}件",
  "manage_files_in_this_folder_display_images_linked_to_name_are_not_affected": "このフォルダー内のファイルを管理します。{{name}}に関連付けられた表示画像には影響しません。",
  "manage_files_in_this_folder_award_certificates_linked_to_name_are_not_affected": "このフォルダー内のファイルを管理します。{{name}}に関連付けられた受賞証明書には影響しません。",
  "count_uploads_completed": "{{count}}件のアップロードが完了しました",
  "count_uploads_in_progress": "{{count}}件をアップロード中",
  "private_space_list": "プライベートスペース一覧",
  "private_space_data": "プライベートスペースのデータ",
  "data_overview": "データ概要",
  "data_details": "データ明細",
  "all_content": "すべてのコンテンツ",
  "count_new": "{{count}}件の新着！",
  "listed": "掲載済み：",
  "time_spent_total": "滞在時間（累計）",
  "daily_time_spent": "1日あたりの滞在時間",
  "ascending": "昇順",
  "descending": "降順",
  "region": "エリア",
  "no_contact_information_availableV2": "連絡先情報がありません",
  "generate": "生成",
  "exportedV5": "エクスポートしました",
  "design_type": "デザインタイプ",
  "select_a_memberV2": "メンバーを選択してください",
  "no_members_available_to_reassign_toV2": "担当者を変更できるメンバーがいません",
  "save_draft": "下書きを保存",
  "total_count_items": "全{{count}}件",
  "favorited_count": "お気に入り（{{count}}）",
  "min": "分",
  "sec": "秒",
  "hr": "時間",
  "phone": "携帯番号：",
  "email": "メールアドレス：",
  "submitted_by": "提出者：",
  "submitted_at": "提出日時",
  "other_contact": "その他の連絡先",
  "generate_quotationV2": "見積書を作成",
  "view_quotation": "見積書を見る",
  "checking_membership_status_please_wait": "会員ステータスを確認中です。しばらくお待ちください",
  "no_agreement_template_configured": "規約テンプレートが未設定です",
  "open_this_link_on_a_computerV2": "パソコンでリンクを開いてください",
  "link_phone_or_email": "携帯電話番号・メールアドレスを連携",
  "linked_successfullyV3": "連携しました",
  "this_private_space": "このプライベートスペース",
  "exclusive_product_library": "専用製品ライブラリ",
  "create_a_private_space_and_add_products_to_your_personal_or_team_product_library_for_more_efficient_centralized_management": "プライベートスペースを作成し、個人またはチームの製品ライブラリに製品を追加して、より効率的な集中管理を実現します。",
  "creative_board_tool": "クリエイティブボードツール",
  "pull_in_products_and_textures_directly_generate_a_product_list_or_white_paper_with_one_click_and_present_your_proposal_with_ease": "製品やテクスチャを直接呼び出し、ワンクリックで製品リストやホワイトペーパーを生成して、提案を簡単に提示できます。",
  "plug_in_tool_library": "プラグインツールライブラリ",
  "works_with_revit_3dmax_rhino_sketchup_and_other_design_software_so_you_can_pull_in_product_models_and_textures_at_any_time_and_improve_design_efficiency": "Revit、3DMax、Rhino、SketchUpなどの設計ソフトと連携し、製品モデルやテクスチャをいつでも呼び出せるため、設計効率が向上します。",
  "publish_products_to_the_public_marketplace_zicai_ocean_with_one_click_to_expand_exposure": "ワンクリックで製品をパブリック領域（紫菜海洋）に公開し、露出を拡大できます。",
  "the_name_cannot_exceed_40_characters": "名前は40文字以内で入力してください",
  "the_private_space_name_contains_sensitive_words": "プライベートスペース名に不適切な語句が含まれています",
  "enter_the_private_space_name": "プライベートスペース名を入力してください",
  "view_item_index": "{{index}}件目を表示",
  "please_confirm_and_check_the_agreement_first": "先に規約を確認し、チェックを入れてください",
  "password_box": "機密フォルダ",
  // —— デザインセンターの「プロジェクト管理ツール」入口（2026-10-26）——
  "项目管理工具": "プロジェクト管理ツール",
}

export const colorList = [
  { color: "#FFFFFF", name: '白色' },
  { color: "#FFD700", name: '黄色' },
  { color: "#F7931E", name: '橙色' },
  { color: "#996633", name: '棕色' },
  { color: "#D62828", name: '红色' },
  { color: "#FFB6C1", name: '粉色' },
  { color: "#A393BF", name: '紫色' },
  { color: "#4CAF50", name: '绿色' },
  { color: "#007BFF", name: '蓝色' },
  { color: "#A1CBE6", name: '浅蓝' },
  { color: "#9E9E9E", name: '灰色' },
  { color: "#1C1C1C", name: '黑色' },
];

export const cloud_out = {
  cloud_admin: "当前私域套餐容量不足，为不影响使用，请及时处理",
  cloud_user: "当前私域套餐容量不足，为不影响使用，请联系私域管理员处理",
}
